/* this file was auto-generated by the package "graphql-codegen". DO NOT edit this file manually */
// @ts-nocheck
import type { Color, ColorCx } from '@xarvio/corporate-styles';
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { GraphqlContext } from './context';
export type TranslationId = string;
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** AppConfigValue */
  AppConfigValue: { input: any; output: any; }
  Color: { input: Color; output: Color; }
  ColorCx: { input: ColorCx; output: ColorCx; }
  /** ISO8601-formatted date with timezone */
  Date: { input: string; output: string; }
  IndexableObject: { input: unknown; output: unknown; }
  /** Keeps the Map returned for a JSON object by the Feign client */
  JSONObject: { input: any; output: any; }
  Node: { input: { uuid: string; etag?: string | null }; output: { uuid: string; etag?: string | null }; }
  NodeWithTypename: { input: { __typename: string; uuid: string; etag?: string | null }; output: { __typename: string; uuid: string; etag?: string | null }; }
  TranslationId: { input: TranslationId; output: TranslationId; }
  /** UUID ids */
  UUID: { input: string; output: string; }
};

export type AbLine = {
  __typename: 'AbLine';
  createdDate?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  fieldV2: FieldV2;
  geometry: Scalars['JSONObject']['output'];
  heading?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum AbstractProductType {
  Fertilizer = 'FERTILIZER',
  Fungicide = 'FUNGICIDE',
  Herbicide = 'HERBICIDE',
  Insecticide = 'INSECTICIDE',
  Other = 'OTHER',
  Pgr = 'PGR'
}

export enum Access {
  ContractorLimitedFarmAccess = 'CONTRACTOR_LIMITED_FARM_ACCESS',
  ContractorLimitedFieldAccess = 'CONTRACTOR_LIMITED_FIELD_ACCESS',
  ContractorReadUpdateDelete = 'CONTRACTOR_READ_UPDATE_DELETE',
  ContractorWrite = 'CONTRACTOR_WRITE',
  DistributorRead = 'DISTRIBUTOR_READ',
  PrimaryCommercialPartnerFarmReadAccess = 'PRIMARY_COMMERCIAL_PARTNER_FARM_READ_ACCESS',
  PrimaryCommercialPartnerFarmShareAccess = 'PRIMARY_COMMERCIAL_PARTNER_FARM_SHARE_ACCESS',
  PrimaryCommercialPartnerFarmWriteAccess = 'PRIMARY_COMMERCIAL_PARTNER_FARM_WRITE_ACCESS',
  Read = 'READ',
  SelfRead = 'SELF_READ',
  ServicePartnerFarmReadAccess = 'SERVICE_PARTNER_FARM_READ_ACCESS',
  ServicePartnerFarmShareAccess = 'SERVICE_PARTNER_FARM_SHARE_ACCESS',
  ServicePartnerFarmWriteAccess = 'SERVICE_PARTNER_FARM_WRITE_ACCESS',
  Share = 'SHARE',
  SustainabilityProgramManagerFieldAccess = 'SUSTAINABILITY_PROGRAM_MANAGER_FIELD_ACCESS',
  Write = 'WRITE'
}

export enum AccessMode {
  Free = 'FREE',
  Guided = 'GUIDED'
}

export type Action = {
  __typename: 'Action';
  code?: Maybe<ActionCode>;
  end?: Maybe<ActionDate>;
  id?: Maybe<Scalars['String']['output']>;
  labelKey?: Maybe<Scalars['String']['output']>;
  start?: Maybe<ActionDate>;
  type?: Maybe<ActionDetailType>;
};

export enum ActionCode {
  AutumnalMgmt_1 = 'AUTUMNAL_MGMT_1',
  AutumnalMgmt_2 = 'AUTUMNAL_MGMT_2',
  Burndown = 'BURNDOWN',
  EarlyIntertillageAndRidgingUp = 'EARLY_INTERTILLAGE_AND_RIDGING_UP',
  EarlyPost = 'EARLY_POST',
  EarlyPost_2 = 'EARLY_POST_2',
  EarlyRidgeMgmt = 'EARLY_RIDGE_MGMT',
  LandPreparation_1 = 'LAND_PREPARATION_1',
  LandPreparation_2 = 'LAND_PREPARATION_2',
  LandPreparation_3 = 'LAND_PREPARATION_3',
  LateIntertillageAndRidgingUp = 'LATE_INTERTILLAGE_AND_RIDGING_UP',
  LatePost = 'LATE_POST',
  LatePost_2 = 'LATE_POST_2',
  LateRidgeMgmt = 'LATE_RIDGE_MGMT',
  MidIntertillageAndRidgingUp = 'MID_INTERTILLAGE_AND_RIDGING_UP',
  MidPost = 'MID_POST',
  MidPost_2 = 'MID_POST_2',
  PreEmerging = 'PRE_EMERGING',
  PreEmerging_2 = 'PRE_EMERGING_2',
  PreHarvestBurndown = 'PRE_HARVEST_BURNDOWN',
  RidgeMgmt = 'RIDGE_MGMT',
  SecondBurndown = 'SECOND_BURNDOWN',
  SpringMgmt_1 = 'SPRING_MGMT_1',
  SpringMgmt_2 = 'SPRING_MGMT_2',
  StubbleTreatment = 'STUBBLE_TREATMENT',
  Tillage = 'TILLAGE',
  VeryEarlyPost = 'VERY_EARLY_POST',
  VeryEarlyPost_2 = 'VERY_EARLY_POST_2',
  VeryLatePost = 'VERY_LATE_POST',
  VeryLatePost_2 = 'VERY_LATE_POST_2'
}

export type ActionDate = {
  __typename: 'ActionDate';
  calendarDate?: Maybe<Scalars['Date']['output']>;
  daysAfterPrevious?: Maybe<Scalars['Int']['output']>;
  daysAfterSeeding?: Maybe<Scalars['Int']['output']>;
  growthStageIndex?: Maybe<Scalars['String']['output']>;
  growthStageScale?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ActionDateType>;
};

export type ActionDateInput = {
  daysAfterSeeding?: InputMaybe<Scalars['Int']['input']>;
  growthStageIndex?: InputMaybe<Scalars['String']['input']>;
  growthStageScale?: InputMaybe<ScaleV2>;
  type?: InputMaybe<ActionDateType>;
};

export enum ActionDateType {
  DaysAfterSeeding = 'DAYS_AFTER_SEEDING',
  GrowthStage = 'GROWTH_STAGE'
}

export type ActionDetail = {
  __typename: 'ActionDetail';
  action?: Maybe<Action>;
  additives?: Maybe<Array<Maybe<ActionDetailAdditive>>>;
  applicationSpots?: Maybe<Array<Maybe<ApplicationSpot>>>;
  applicationTypes?: Maybe<Array<Maybe<TreatmentProgramApplicationType>>>;
  maxTotalLiquidRate?: Maybe<Scalars['Float']['output']>;
  minTotalLiquidRate?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<Maybe<ActionDetailProduct>>>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  totalLiquidRate?: Maybe<Scalars['Float']['output']>;
  /** # actionId */
  type?: Maybe<ActionDetailType>;
  typeIcon?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<ActionDate>;
  validTill?: Maybe<ActionDate>;
};


export type ActionDetailApplicationSpotsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ActionDetailAdditive = {
  __typename: 'ActionDetailAdditive';
  applicationRate?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<ProductV2>;
};

export type ActionDetailProduct = {
  __typename: 'ActionDetailProduct';
  applicationRate?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<ProductV2>;
};

export type ActionDetailTankMix = {
  __typename: 'ActionDetailTankMix';
  additives?: Maybe<Array<Maybe<ActionDetailAdditive>>>;
  applicationSpot?: Maybe<ApplicationSpot>;
  /** @deprecated Since V3 program, Use `applicationSpot` for V3 program only */
  applicationSpots?: Maybe<Array<Maybe<ApplicationSpot>>>;
  applicationTypes?: Maybe<Array<Maybe<TreatmentProgramApplicationType>>>;
  maxTotalLiquidRate?: Maybe<Scalars['Float']['output']>;
  minTotalLiquidRate?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Array<Maybe<ActionDetailProduct>>>;
  tankNumber?: Maybe<Scalars['Int']['output']>;
  /** Use applicationSpots for V2 program */
  taskMethod?: Maybe<TaskMethod>;
  totalLiquidRate?: Maybe<Scalars['Float']['output']>;
  validFrom?: Maybe<ActionDate>;
  validTill?: Maybe<ActionDate>;
};


export type ActionDetailTankMixApplicationSpotArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type ActionDetailTankMixApplicationSpotsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type ActionDetailTankMixTaskMethodArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export enum ActionDetailType {
  LandPreparation = 'LAND_PREPARATION',
  Spraying = 'SPRAYING'
}

export type ActionDetailV2 = {
  __typename: 'ActionDetailV2';
  action?: Maybe<Action>;
  additionalNoticeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tankMixes?: Maybe<Array<Maybe<ActionDetailTankMix>>>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  /** # actionId */
  type?: Maybe<ActionDetailType>;
};

export type ActionInput = {
  code?: InputMaybe<ActionCode>;
  end?: InputMaybe<ActionDateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<ActionDateInput>;
  type?: InputMaybe<ActionDetailType>;
};

export type ActionRecommendation = {
  __typename: 'ActionRecommendation';
  actionType?: Maybe<ActionType>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  confidenceLevel?: Maybe<ConfidenceLevel>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  reasons?: Maybe<Array<Maybe<ActionRecommendationReason>>>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<ActionRecommendationStatus>;
  type?: Maybe<ActionType>;
};

export type ActionRecommendationAggregation = {
  __typename: 'ActionRecommendationAggregation';
  actions?: Maybe<Array<Maybe<ActionRecommendationAggregationAction>>>;
  aggregatedStatus?: Maybe<ActionRecommendationAggregationStatus>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
};

export type ActionRecommendationAggregationAction = {
  __typename: 'ActionRecommendationAggregationAction';
  status?: Maybe<ActionRecommendationAggregationStatus>;
  type?: Maybe<ActionRecommendationType>;
};

export enum ActionRecommendationAggregationStatus {
  Active = 'ACTIVE',
  Snoozed = 'SNOOZED'
}

export enum ActionRecommendationReason {
  BeforeMainEggDeposition = 'BEFORE_MAIN_EGG_DEPOSITION',
  CriticalStageReached = 'CRITICAL_STAGE_REACHED',
  FlagLeafStageReached = 'FLAG_LEAF_STAGE_REACHED',
  FloweringStageReached = 'FLOWERING_STAGE_REACHED',
  GrowthStage = 'GROWTH_STAGE',
  GrowthStageFinalApplicationReached = 'GROWTH_STAGE_FINAL_APPLICATION_REACHED',
  HighDiseaseRisk = 'HIGH_DISEASE_RISK',
  HighPestRisk = 'HIGH_PEST_RISK',
  MainL1Development = 'MAIN_L1_DEVELOPMENT',
  PgrOsrBbch14ToBbch16 = 'PGR_OSR_BBCH14_TO_BBCH16',
  PgrOsrFromBbch18 = 'PGR_OSR_FROM_BBCH18',
  PgrOsrFromBbch31 = 'PGR_OSR_FROM_BBCH31',
  PgrOsrSecondTreatment = 'PGR_OSR_SECOND_TREATMENT',
  R1StageReached = 'R1_STAGE_REACHED',
  RamulariaProtection = 'RAMULARIA_PROTECTION',
  RowClosing = 'ROW_CLOSING',
  StinkBugProtection = 'STINK_BUG_PROTECTION',
  StinkBugProtectionGrainfilling = 'STINK_BUG_PROTECTION_GRAINFILLING',
  StinkBugProtectionHeading = 'STINK_BUG_PROTECTION_HEADING',
  TreatmentPeriodExceeded = 'TREATMENT_PERIOD_EXCEEDED',
  VtStageReached = 'VT_STAGE_REACHED'
}

export enum ActionRecommendationStatus {
  Necessary = 'NECESSARY',
  NotNeeded = 'NOT_NEEDED',
  Recommended = 'RECOMMENDED'
}

export enum ActionRecommendationType {
  FertilizerApplication = 'FERTILIZER_APPLICATION',
  FungicideApplication = 'FUNGICIDE_APPLICATION',
  Harvesting = 'HARVESTING',
  HerbicideApplication = 'HERBICIDE_APPLICATION',
  InsecticideApplication = 'INSECTICIDE_APPLICATION',
  PlantGrowthRegulatorApplication = 'PLANT_GROWTH_REGULATOR_APPLICATION',
  Seeding = 'SEEDING',
  WaterManagement = 'WATER_MANAGEMENT'
}

export enum ActionType {
  FertilizerApplication = 'FERTILIZER_APPLICATION',
  FungicideApplication = 'FUNGICIDE_APPLICATION',
  Harvesting = 'HARVESTING',
  HerbicideApplication = 'HERBICIDE_APPLICATION',
  InhApplication = 'INH_APPLICATION',
  InsecticideApplication = 'INSECTICIDE_APPLICATION',
  PlantGrowthRegulatorApplication = 'PLANT_GROWTH_REGULATOR_APPLICATION',
  Seeding = 'SEEDING'
}

export type ActionWindow = {
  __typename: 'ActionWindow';
  actionType: ActionWindowType;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeasonUuid: Scalars['UUID']['output'];
  cropSeasonV2: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: ActionWindowStatus;
  windowEndDate?: Maybe<Scalars['Date']['output']>;
  windowStartDate?: Maybe<Scalars['Date']['output']>;
};

export enum ActionWindowExecutionStatus {
  Adjusted = 'ADJUSTED',
  Done = 'DONE',
  Missed = 'MISSED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export enum ActionWindowStatus {
  Current = 'CURRENT',
  Future = 'FUTURE',
  Missed = 'MISSED',
  NotPresent = 'NOT_PRESENT',
  NoInformation = 'NO_INFORMATION'
}

export enum ActionWindowType {
  FungicideApplication = 'FUNGICIDE_APPLICATION',
  Harvesting = 'HARVESTING',
  InsecticideApplication = 'INSECTICIDE_APPLICATION',
  PlantGrowthRegulatorApplication = 'PLANT_GROWTH_REGULATOR_APPLICATION',
  Seeding = 'SEEDING'
}

export type ActiveIngredient = {
  __typename: 'ActiveIngredient';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum ActualCulturalPractice {
  Baling = 'BALING',
  CropProtection = 'CROP_PROTECTION',
  Fertilizing = 'FERTILIZING',
  ForageHarvesting = 'FORAGE_HARVESTING',
  Harvesting = 'HARVESTING',
  Mowing = 'MOWING',
  SluryManureApplication = 'SLURY_MANURE_APPLICATION',
  SowingAndPlanting = 'SOWING_AND_PLANTING',
  Swathing = 'SWATHING',
  Tillage = 'TILLAGE',
  Transport = 'TRANSPORT',
  Unknown = 'UNKNOWN',
  Wrapping = 'WRAPPING'
}

export type AdditionalInfectionRiskFactor = {
  __typename: 'AdditionalInfectionRiskFactor';
  additionalInfectionRiskFactor?: Maybe<Scalars['Boolean']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason: CropSeasonV2;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type AdditiveRate = {
  __typename: 'AdditiveRate';
  rates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Address = {
  __typename: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  provinceId?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export enum AdeMode {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Terminal = 'TERMINAL'
}

export type AgBalanceFieldEmissionIndicator = {
  __typename: 'AgBalanceFieldEmissionIndicator';
  calculationDate: Scalars['Date']['output'];
  carbonFarmingSeason?: Maybe<CarbonFarmingSeason>;
  ch4FieldEmission?: Maybe<Scalars['Float']['output']>;
  co2EnergyFieldEmission?: Maybe<Scalars['Float']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  directCO2MineralFieldEmission?: Maybe<Scalars['Float']['output']>;
  directN2OMineralFieldEmission?: Maybe<Scalars['Float']['output']>;
  directN2OOrganicFieldEmission?: Maybe<Scalars['Float']['output']>;
  directN2OResiduesFieldEmission?: Maybe<Scalars['Float']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  indirectN2OMineralFieldEmission?: Maybe<Scalars['Float']['output']>;
  indirectN2OOrganicFieldEmission?: Maybe<Scalars['Float']['output']>;
  indirectN2OResiduesFieldEmission?: Maybe<Scalars['Float']['output']>;
  issues?: Maybe<Array<Maybe<AgBalanceFieldEmissionIndicatorIssue>>>;
  status: AgBalanceFieldEmissionIndicatorStatus;
  totalFieldEmission?: Maybe<Scalars['Float']['output']>;
};

export type AgBalanceFieldEmissionIndicatorIssue = {
  __typename: 'AgBalanceFieldEmissionIndicatorIssue';
  cropSeasonUuid: Scalars['UUID']['output'];
  message: Scalars['String']['output'];
  messageKey: Scalars['String']['output'];
  severity: AgBalanceFieldEmissionIndicatorIssueSeverity;
  taskUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum AgBalanceFieldEmissionIndicatorIssueSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum AgBalanceFieldEmissionIndicatorStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

export type AgBalanceFieldInput = {
  __typename: 'AgBalanceFieldInput';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  field: FieldV2;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  soilDrainageClassCode?: Maybe<SoilDrainageClass>;
  soilDrainageClassUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type AggregatedNotification = {
  __typename: 'AggregatedNotification';
  aggregationFromDate: Scalars['Date']['output'];
  aggregationTillDate: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  newestNotificationTimestamp: Scalars['Date']['output'];
  payload?: Maybe<AggregatedNotificationPayload>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AggregatedNotificationPayload = {
  __typename: 'AggregatedNotificationPayload';
  cropSeasonUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  farm?: Maybe<FarmV2>;
  farms?: Maybe<Array<Maybe<FarmV2>>>;
  fieldDataLayerUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  fieldUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  flightTaskUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  nutritionProgramUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  optimalDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  scoutingTaskUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  scoutingTypeByTaskUuid?: Maybe<Scalars['JSONObject']['output']>;
  seedBoxTreatmentTaskUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  seedTreatmentTaskUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  seedingTaskUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  sprayingUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  stressUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  type?: Maybe<NotificationType>;
  usersUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};

export type AggregatedPestDevelopmentPrediction = {
  __typename: 'AggregatedPestDevelopmentPrediction';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  developmentStage?: Maybe<DevelopmentStage>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  mainGeneration?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  stress?: Maybe<StressV2>;
};


export type AggregatedPestDevelopmentPredictionStressArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type AggregatedRisk = {
  __typename: 'AggregatedRisk';
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum AgronomicIndexType {
  Bp = 'BP',
  BpLai = 'BP_LAI',
  CustomPowerzoneData = 'CUSTOM_POWERZONE_DATA',
  /**
   *  Drone vegetation renders: index (GLI|VARIGREEN|SYNTHETIC_NDVI|NDVI|NDRE) x stored breaks
   *  (EQUAL_INTERVAL|NATURAL_BREAKS). Forwarded unchanged to Remote Sensing
   *  /drone-flight-geometries, which resolves the zoning asset and breaks key.
   */
  DroneGliEqualInterval = 'DRONE_GLI_EQUAL_INTERVAL',
  DroneGliNaturalBreaks = 'DRONE_GLI_NATURAL_BREAKS',
  DroneNdreEqualInterval = 'DRONE_NDRE_EQUAL_INTERVAL',
  DroneNdreNaturalBreaks = 'DRONE_NDRE_NATURAL_BREAKS',
  DroneNdviEqualInterval = 'DRONE_NDVI_EQUAL_INTERVAL',
  DroneNdviNaturalBreaks = 'DRONE_NDVI_NATURAL_BREAKS',
  /**
   *  Drone planting-failure renders per analysis depth (50|100 cm). Forwarded unchanged to Remote
   *  Sensing /drone-flight-geometries; first-call breaks come from the zoning preset.
   */
  DronePlantingFailure_50Cm = 'DRONE_PLANTING_FAILURE_50_CM',
  DronePlantingFailure_100Cm = 'DRONE_PLANTING_FAILURE_100_CM',
  DroneSyntheticNdviEqualInterval = 'DRONE_SYNTHETIC_NDVI_EQUAL_INTERVAL',
  DroneSyntheticNdviNaturalBreaks = 'DRONE_SYNTHETIC_NDVI_NATURAL_BREAKS',
  DroneVarigreenEqualInterval = 'DRONE_VARIGREEN_EQUAL_INTERVAL',
  DroneVarigreenNaturalBreaks = 'DRONE_VARIGREEN_NATURAL_BREAKS',
  DroneWeedPressureAllHighSensitivity = 'DRONE_WEED_PRESSURE_ALL_HIGH_SENSITIVITY',
  /**
   *  Drone weed-pressure rasters zoned for Crop Protection, Nutrition and Seeding task flows: weed type
   *  (ALL|GRASSY|BROADLEAF) x sensitivity (LOW|MEDIUM|HIGH). Same rasters as WZS_WEED_PRESSURE_* above,
   *  different product: these return management zones via Remote Sensing /drone-flight-geometries
   *  (first-call breaks from the zoning preset; customBreaks / numberOfZones apply).
   */
  DroneWeedPressureAllLowSensitivity = 'DRONE_WEED_PRESSURE_ALL_LOW_SENSITIVITY',
  DroneWeedPressureAllMediumSensitivity = 'DRONE_WEED_PRESSURE_ALL_MEDIUM_SENSITIVITY',
  DroneWeedPressureBroadleafHighSensitivity = 'DRONE_WEED_PRESSURE_BROADLEAF_HIGH_SENSITIVITY',
  DroneWeedPressureBroadleafLowSensitivity = 'DRONE_WEED_PRESSURE_BROADLEAF_LOW_SENSITIVITY',
  DroneWeedPressureBroadleafMediumSensitivity = 'DRONE_WEED_PRESSURE_BROADLEAF_MEDIUM_SENSITIVITY',
  DroneWeedPressureGrassyHighSensitivity = 'DRONE_WEED_PRESSURE_GRASSY_HIGH_SENSITIVITY',
  DroneWeedPressureGrassyLowSensitivity = 'DRONE_WEED_PRESSURE_GRASSY_LOW_SENSITIVITY',
  DroneWeedPressureGrassyMediumSensitivity = 'DRONE_WEED_PRESSURE_GRASSY_MEDIUM_SENSITIVITY',
  Lai = 'LAI',
  Ndvi = 'NDVI',
  NematodePowerzoneData = 'NEMATODE_POWERZONE_DATA',
  PowerzoneData = 'POWERZONE_DATA',
  RelativeYieldPowerzoneData = 'RELATIVE_YIELD_POWERZONE_DATA',
  WzsWeedPressureAllHighSensitivity = 'WZS_WEED_PRESSURE_ALL_HIGH_SENSITIVITY',
  /**
   *  Drone weed-pressure indices: weed type (ALL|GRASSY|BROADLEAF) x sensitivity (LOW|MEDIUM|HIGH).
   *  The value equals the STAC asset key/title. stacItemVectorizeGeometries forwards it to Remote Sensing
   *  /stac/vectorize like any non-DRONE_* index. For task-flow zoning use DRONE_WEED_PRESSURE_* below.
   */
  WzsWeedPressureAllLowSensitivity = 'WZS_WEED_PRESSURE_ALL_LOW_SENSITIVITY',
  WzsWeedPressureAllMediumSensitivity = 'WZS_WEED_PRESSURE_ALL_MEDIUM_SENSITIVITY',
  WzsWeedPressureBroadleafHighSensitivity = 'WZS_WEED_PRESSURE_BROADLEAF_HIGH_SENSITIVITY',
  WzsWeedPressureBroadleafLowSensitivity = 'WZS_WEED_PRESSURE_BROADLEAF_LOW_SENSITIVITY',
  WzsWeedPressureBroadleafMediumSensitivity = 'WZS_WEED_PRESSURE_BROADLEAF_MEDIUM_SENSITIVITY',
  WzsWeedPressureGrassyHighSensitivity = 'WZS_WEED_PRESSURE_GRASSY_HIGH_SENSITIVITY',
  WzsWeedPressureGrassyLowSensitivity = 'WZS_WEED_PRESSURE_GRASSY_LOW_SENSITIVITY',
  WzsWeedPressureGrassyMediumSensitivity = 'WZS_WEED_PRESSURE_GRASSY_MEDIUM_SENSITIVITY'
}

export enum Alert {
  DelayedActionT2 = 'DELAYED_ACTION_T2',
  DifferentGrowthStages = 'DIFFERENT_GROWTH_STAGES',
  DifferentTankmixesRecommendedT2 = 'DIFFERENT_TANKMIXES_RECOMMENDED_T2',
  FarmerTreatment = 'FARMER_TREATMENT',
  Fusa_30Mm = 'FUSA_30_MM',
  GroupByVariety = 'GROUP_BY_VARIETY',
  LateT1 = 'LATE_T1',
  LateT2 = 'LATE_T2',
  ProductAlreadyApplied = 'PRODUCT_ALREADY_APPLIED',
  ProductAlreadySprayed = 'PRODUCT_ALREADY_SPRAYED',
  RecommendationMismatchWithinVariety = 'RECOMMENDATION_MISMATCH_WITHIN_VARIETY',
  T1Systiva = 'T1_SYSTIVA',
  T2Group = 'T2_GROUP',
  WrongDate = 'WRONG_DATE'
}

export enum AlgorithmType {
  LatePostEmergence = 'LATE_POST_EMERGENCE',
  PostEmergence = 'POST_EMERGENCE',
  PreEmergence = 'PRE_EMERGENCE'
}

export type AnalyticsCollection = {
  __typename: 'AnalyticsCollection';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  fieldDataLayers?: Maybe<Array<Maybe<AnalyticsCollectionFieldDataLayer>>>;
  fieldNotes?: Maybe<Array<Maybe<FieldNote>>>;
  fieldZones?: Maybe<Array<Maybe<FieldZone>>>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  mapItemMagnitudes?: Maybe<Array<Maybe<AnalyticsCollectionMapItemMagnitude>>>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AnalyticsCollectionType>;
  uuid: Scalars['UUID']['output'];
};

export type AnalyticsCollectionFieldDataLayer = {
  __typename: 'AnalyticsCollectionFieldDataLayer';
  checksum?: Maybe<Scalars['String']['output']>;
  fieldDataLayer?: Maybe<FieldDataLayer>;
  magnitudeType?: Maybe<MagnitudeType>;
  maxElevation?: Maybe<Scalars['Float']['output']>;
  minElevation?: Maybe<Scalars['Float']['output']>;
  processingType?: Maybe<ProcessingType>;
};

export type AnalyticsCollectionMapItemMagnitude = {
  __typename: 'AnalyticsCollectionMapItemMagnitude';
  fieldDataLayerMagnitude?: Maybe<AnalyticsCollectionFieldDataLayer>;
  mapType: MapItemType;
  stacItemMagnitude?: Maybe<AnalyticsCollectionStacItem>;
};

export type AnalyticsCollectionStacItem = {
  __typename: 'AnalyticsCollectionStacItem';
  stacFieldDataLayerType: StacFieldDataLayer;
  stacItemRender?: Maybe<StacItemRender>;
  stacMagnitudeType: StacMagnitudeType;
};

export enum AnalyticsCollectionType {
  Multi = 'MULTI',
  Singular = 'SINGULAR',
  Unknown = 'UNKNOWN'
}

export type AnomalyHistory = {
  __typename: 'AnomalyHistory';
  qcCode?: Maybe<Scalars['Int']['output']>;
  startDatetime?: Maybe<Scalars['Date']['output']>;
  wx3QcCode?: Maybe<Scalars['Int']['output']>;
};

export type AnomalyVariableInfo = {
  __typename: 'AnomalyVariableInfo';
  anomalyHistory?: Maybe<Array<Maybe<AnomalyHistory>>>;
  variableName?: Maybe<Scalars['String']['output']>;
  wasEverAnomaly?: Maybe<Scalars['Boolean']['output']>;
};

export type AppConfig = {
  __typename: 'AppConfig';
  name?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<AppConfigObjectType>;
  requiresFunctionality?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scope?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  value?: Maybe<Scalars['AppConfigValue']['output']>;
};

export enum AppConfigObjectType {
  Country = 'COUNTRY',
  CountryCrop = 'COUNTRY_CROP',
  Crop = 'CROP',
  Global = 'GLOBAL'
}

export type ApplicableColumn = {
  __typename: 'ApplicableColumn';
  bestGuess?: Maybe<Scalars['Int']['output']>;
  indices?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type ApplicableStress = {
  __typename: 'ApplicableStress';
  assessmentObjectUuid?: Maybe<Scalars['UUID']['output']>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
  units?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApplicableUnit = {
  __typename: 'ApplicableUnit';
  bestGuess?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ApplicationCategory {
  AboveAverage = 'ABOVE_AVERAGE',
  Average = 'AVERAGE',
  BelowAverage = 'BELOW_AVERAGE',
  BiodiversityWindow = 'BIODIVERSITY_WINDOW',
  BufferZoneCustom = 'BUFFER_ZONE_CUSTOM',
  BufferZoneTotal = 'BUFFER_ZONE_TOTAL',
  Flat = 'FLAT',
  Generic = 'GENERIC',
  High = 'HIGH',
  Low = 'LOW',
  NoWeeds = 'NO_WEEDS',
  Obstacle = 'OBSTACLE',
  Off = 'OFF',
  On = 'ON',
  OnOff_1 = 'ON_OFF_1',
  OnOff_2 = 'ON_OFF_2',
  OnOff_3 = 'ON_OFF_3',
  OnOff_4 = 'ON_OFF_4',
  OnOff_5 = 'ON_OFF_5',
  OnOff_6 = 'ON_OFF_6',
  OnOff_7 = 'ON_OFF_7',
  OnOffCategoriesFromHighToLowBiomass = 'ON_OFF_CATEGORIES_FROM_HIGH_TO_LOW_BIOMASS',
  Seeding_1 = 'SEEDING_1',
  Seeding_2 = 'SEEDING_2',
  Seeding_3 = 'SEEDING_3',
  Seeding_4 = 'SEEDING_4',
  Seeding_5 = 'SEEDING_5',
  Seeding_6 = 'SEEDING_6',
  Seeding_7 = 'SEEDING_7',
  SmsprStrategyZone = 'SMSPR_STRATEGY_ZONE',
  TrialPlot = 'TRIAL_PLOT',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW',
  Weeds = 'WEEDS'
}

export type ApplicationFieldZone = {
  __typename: 'ApplicationFieldZone';
  area?: Maybe<Scalars['Float']['output']>;
  fieldZoneUuid?: Maybe<Scalars['UUID']['output']>;
  fixedMixtureRate?: Maybe<Scalars['Float']['output']>;
};

export type ApplicationMapZone = {
  __typename: 'ApplicationMapZone';
  area?: Maybe<Scalars['Float']['output']>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export enum ApplicationMode {
  Seeding = 'SEEDING',
  Spraying = 'SPRAYING',
  Spreading = 'SPREADING'
}

export type ApplicationRecommendation = {
  __typename: 'ApplicationRecommendation';
  cropSeason?: Maybe<CropSeason>;
  date?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `date`. */
  recommendedDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<ApplicationRecommendationStatus>;
  type?: Maybe<ApplicationRecommendationType>;
  uuid: Scalars['UUID']['output'];
};

export enum ApplicationRecommendationStatus {
  Necessary = 'NECESSARY',
  NotNeeded = 'NOT_NEEDED',
  NoInformation = 'NO_INFORMATION',
  Recommended = 'RECOMMENDED'
}

export enum ApplicationRecommendationType {
  Current = 'CURRENT',
  Forecast = 'FORECAST'
}

export type ApplicationSpot = {
  __typename: 'ApplicationSpot';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum ApplicationStrategy {
  MoreToHigh = 'MORE_TO_HIGH',
  MoreToLow = 'MORE_TO_LOW',
  MoreToMid = 'MORE_TO_MID'
}

export enum ApplicationType {
  AverageBasedVra = 'AVERAGE_BASED_VRA',
  AverageBasedVraSeeding = 'AVERAGE_BASED_VRA_SEEDING',
  CustomVra = 'CUSTOM_VRA',
  CustomVraHerb = 'CUSTOM_VRA_HERB',
  Flat = 'FLAT',
  FlatSeeding = 'FLAT_SEEDING',
  OnOff = 'ON_OFF',
  OnOffHerb = 'ON_OFF_HERB',
  Spot = 'SPOT',
  VariableRateSeeding = 'VARIABLE_RATE_SEEDING',
  Vra = 'VRA',
  VraHerb = 'VRA_HERB'
}

export type ApplicationWindow = {
  __typename: 'ApplicationWindow';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  executionStatus?: Maybe<ApplicationWindowStatus>;
  startDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<ApplicationWindowType>;
};

export enum ApplicationWindowStatus {
  Done = 'DONE',
  Missed = 'MISSED',
  Pending = 'PENDING'
}

export enum ApplicationWindowType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G'
}

export type ApplicationZone = {
  __typename: 'ApplicationZone';
  active?: Maybe<Scalars['Boolean']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<ApplicationCategory>;
  id?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export enum AppliedWithWater {
  Both = 'both',
  Nd = 'nd',
  No = 'no',
  Yes = 'yes'
}

export type ArableApiKey = {
  __typename: 'ArableApiKey';
  apiKey?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ArableDevice = {
  __typename: 'ArableDevice';
  arableDeviceToLocations?: Maybe<Array<Maybe<ArableDeviceToLocation>>>;
  batteryPercentage?: Maybe<Scalars['Float']['output']>;
  elevation?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  lastPost?: Maybe<Scalars['Date']['output']>;
  lastSeen?: Maybe<Scalars['Date']['output']>;
  latestMeasurement?: Maybe<ArableDeviceLatestMeasurement>;
  latitude?: Maybe<Scalars['Float']['output']>;
  locationType?: Maybe<LocationType>;
  locationUuid?: Maybe<Scalars['UUID']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  signalStrength?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ArableDeviceLatestMeasurement = {
  __typename: 'ArableDeviceLatestMeasurement';
  device: ArableDevice;
  humidity?: Maybe<Scalars['Float']['output']>;
  precipitation?: Maybe<Scalars['Float']['output']>;
  soilMoisture?: Maybe<Scalars['Float']['output']>;
  solarRadiation?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
  windDirection?: Maybe<Scalars['String']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
};

export type ArableDeviceToLocation = {
  __typename: 'ArableDeviceToLocation';
  device: ArableDevice;
  fromDate?: Maybe<Scalars['Date']['output']>;
  locationAccessible?: Maybe<Scalars['Boolean']['output']>;
  locationType: LocationType;
  locationUuid: Scalars['UUID']['output'];
  tillDate?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ArvalisCalculationBasis = {
  __typename: 'ArvalisCalculationBasis';
  cropSeason?: Maybe<CropSeasonV2>;
  isRisksBasedOnDefaultVarietyCharacteristics?: Maybe<Scalars['Boolean']['output']>;
};

export type ArvalisCustomEfficacyInformation = {
  __typename: 'ArvalisCustomEfficacyInformation';
  customProtectionDays?: Maybe<Scalars['Int']['output']>;
  dosedMap?: Maybe<DosedMap>;
};

export enum ArvalisDeviceProviderType {
  Corhize = 'CORHIZE',
  Demeter = 'DEMETER',
  DfiElec = 'DFI_ELEC',
  Meteus = 'METEUS',
  Pameseb = 'PAMESEB',
  Sencrop = 'SENCROP',
  Tcsd = 'TCSD',
  WeatherMeasures = 'WEATHER_MEASURES',
  Weenat = 'WEENAT'
}

export type ArvalisDeviceToCropSeason = {
  __typename: 'ArvalisDeviceToCropSeason';
  code?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  health?: Maybe<DeviceHealthStatus>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ArvalisDeviceProviderType>;
  uuid: Scalars['UUID']['output'];
};

export type ArvalisInformation = {
  __typename: 'ArvalisInformation';
  cropSeason?: Maybe<CropSeasonV2>;
  visioFarmLink?: Maybe<Scalars['String']['output']>;
};

export type Assessment = {
  __typename: 'Assessment';
  assessmentData?: Maybe<Array<Maybe<AssessmentData>>>;
  assessmentTimingUuid: Scalars['UUID']['output'];
  assessmentTypeUuid: Scalars['UUID']['output'];
  creatorId?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  denominatorUnitUuid?: Maybe<Scalars['UUID']['output']>;
  displayUnit?: Maybe<MdUnit>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  numberOfSubSamples?: Maybe<Scalars['Int']['output']>;
  numeratorUnitUuid?: Maybe<Scalars['UUID']['output']>;
  sampleSizeUnitUuid?: Maybe<Scalars['UUID']['output']>;
  sampleSizeValue: Scalars['Float']['output'];
  stressV2?: Maybe<StressV2>;
  trialUuid: Scalars['UUID']['output'];
  uuid: Scalars['UUID']['output'];
};


export type AssessmentDisplayUnitArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type AssessmentStressV2Args = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type AssessmentAttachment = {
  __typename: 'AssessmentAttachment';
  assessmentNote: AssessmentNote;
  contentType?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type AssessmentData = {
  __typename: 'AssessmentData';
  actualCreatedDate?: Maybe<Scalars['Date']['output']>;
  actualModifiedDate?: Maybe<Scalars['Date']['output']>;
  assessmentUuid: Scalars['UUID']['output'];
  creatorId?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  factorLevel: Scalars['Int']['output'];
  fieldZone?: Maybe<FieldZone>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  replicate: Scalars['Int']['output'];
  subsample: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AssessmentNote = {
  __typename: 'AssessmentNote';
  assessment?: Maybe<Assessment>;
  assessmentAttachments?: Maybe<Array<Maybe<AssessmentAttachment>>>;
  assessmentTiming: AssessmentTiming;
  comment?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  factorLevel?: Maybe<Scalars['Int']['output']>;
  fieldZone?: Maybe<FieldZone>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  replicate?: Maybe<Scalars['Int']['output']>;
  subsample?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type AssessmentTiming = {
  __typename: 'AssessmentTiming';
  assessmentEndDate?: Maybe<Scalars['Date']['output']>;
  assessmentNotes?: Maybe<Array<Maybe<AssessmentNote>>>;
  assessmentStartDate: Scalars['Date']['output'];
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  checksum?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropGrowthStageMajorIndex?: Maybe<Scalars['String']['output']>;
  cropGrowthStageMaxIndex?: Maybe<Scalars['String']['output']>;
  cropGrowthStageMinIndex?: Maybe<Scalars['String']['output']>;
  cropGrowthStageScale?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  scoutingTask?: Maybe<ScoutingTask>;
  trialUuid: Scalars['UUID']['output'];
  uuid: Scalars['UUID']['output'];
};

export type AvailableDosedMap = {
  __typename: 'AvailableDosedMap';
  dosedMap: DosedMap;
  equipmentType: DosedMapEquipmentType;
};

export type AvailablePackage = {
  __typename: 'AvailablePackage';
  countryCode: Scalars['String']['output'];
  crop?: Maybe<Crop>;
  /** @deprecated Use farmType instead. */
  farmSpecialisedUsageType?: Maybe<SpecialisedUsageType>;
  farmType?: Maybe<FarmType>;
  features?: Maybe<Array<Maybe<FeatureName>>>;
  package: Package;
  /** @deprecated Use package.uuid */
  packageUuid: Scalars['UUID']['output'];
  tenantUuid?: Maybe<Scalars['UUID']['output']>;
};

export type BbchScale = {
  __typename: 'BBCHScale';
  growthStageIndex?: Maybe<Scalars['Int']['output']>;
  growthStageScale?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BagCount = {
  __typename: 'BagCount';
  mdBagUuid: Scalars['UUID']['output'];
  totalApplication: Scalars['Float']['output'];
  totalBagCount: Scalars['Float']['output'];
  unit?: Maybe<BagUnit>;
};

export enum BagUnit {
  Kg = 'KG',
  Units = 'UNITS'
}

/**  Uses a Map instead of a String. */
export type BaseEntityAuditingType = {
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum BaselineMethod {
  Blended = 'BLENDED',
  Matched = 'MATCHED',
  Rotational = 'ROTATIONAL'
}

export type BeforeSeasonRisk = {
  __typename: 'BeforeSeasonRisk';
  cropSeasonV2?: Maybe<CropSeasonV2>;
  stressRisks?: Maybe<Array<Maybe<StressRisk>>>;
};

export type BillingAddress = {
  __typename: 'BillingAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type BiodiversityIndicator = {
  __typename: 'BiodiversityIndicator';
  benchmarkBiodiversityScore?: Maybe<Scalars['Float']['output']>;
  biodiversityScore?: Maybe<Scalars['Float']['output']>;
  biodiversityScoreMax?: Maybe<Scalars['Float']['output']>;
  biodiversityScoreMin?: Maybe<Scalars['Float']['output']>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  speciesLoss?: Maybe<SpeciesLossType>;
  speciesLossTranslationId?: Maybe<Scalars['TranslationId']['output']>;
};

export type BiomassAnalysisNdvi = {
  __typename: 'BiomassAnalysisNdvi';
  acquisitionDate?: Maybe<Scalars['Date']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  boundaryChecksum?: Maybe<Scalars['String']['output']>;
  cropSeasonUuid: Scalars['UUID']['output'];
  dynamicZones?: Maybe<Scalars['JSONObject']['output']>;
  s3CoverageUrl?: Maybe<Scalars['String']['output']>;
  satImageResolution?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
  zone?: Maybe<Scalars['JSONObject']['output']>;
  zones?: Maybe<Scalars['JSONObject']['output']>;
};

export type BlacklistVariableInfo = {
  __typename: 'BlacklistVariableInfo';
  disabledHistory?: Maybe<Array<Maybe<DisabledHistory>>>;
  variableName?: Maybe<Scalars['String']['output']>;
  wasEverDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum BonusPayoutFactor {
  Full = 'FULL',
  Half = 'HALF',
  None = 'NONE'
}

export type BufferZones = {
  __typename: 'BufferZones';
  applicationDate?: Maybe<Scalars['Date']['output']>;
  driftReductionCode?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type BusinessLineLicense = {
  __typename: 'BusinessLineLicense';
  assignmentDate: Scalars['Date']['output'];
  expirationDate?: Maybe<Scalars['Date']['output']>;
  licenseUuid: Scalars['UUID']['output'];
  quotaPackages?: Maybe<Array<Maybe<BusinessLineLicensePackageQuota>>>;
};

export type BusinessLineLicensePackageQuota = {
  __typename: 'BusinessLineLicensePackageQuota';
  packageUuid: Scalars['UUID']['output'];
  quota: Scalars['Float']['output'];
  usedQuota?: Maybe<Scalars['Float']['output']>;
};

export type BusinessLinePurchaseAggregation = {
  __typename: 'BusinessLinePurchaseAggregation';
  farm?: Maybe<FarmV2>;
  licenses?: Maybe<Array<Maybe<BusinessLineLicense>>>;
  sourceType: BusinessLinePurchaseSourceType;
  sourceUuid: Scalars['UUID']['output'];
  /**  ExistingOrder UUID or LicenseRequest UUID */
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum BusinessLinePurchaseSourceType {
  LicenseRequest = 'LICENSE_REQUEST',
  ShopOrder = 'SHOP_ORDER'
}

export enum CalculationBase {
  Forecast = 'FORECAST',
  Historic = 'HISTORIC'
}

export enum CalculationMode {
  EndOfTreatment = 'END_OF_TREATMENT',
  StartOfDayOfTreatment = 'START_OF_DAY_OF_TREATMENT',
  StartOfTreatment = 'START_OF_TREATMENT'
}

export enum CalculationStatusCode {
  BadIrrigationData = 'BAD_IRRIGATION_DATA',
  BadObservationData = 'BAD_OBSERVATION_DATA',
  BadSprayingTaskData = 'BAD_SPRAYING_TASK_DATA',
  CalculationError = 'CALCULATION_ERROR',
  MissingWeatherData = 'MISSING_WEATHER_DATA',
  Ok = 'OK',
  OutOfDate = 'OUT_OF_DATE',
  OverlappingIrrigationData = 'OVERLAPPING_IRRIGATION_DATA',
  ProblemWeatherData = 'PROBLEM_WEATHER_DATA',
  UnknownVariety = 'UNKNOWN_VARIETY'
}

export type CarbonCredit = {
  __typename: 'CarbonCredit';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  carbonFarmingSeason: CarbonFarmingSeason;
  fieldUuid: Scalars['UUID']['output'];
  nonReversibleCarbonCredits?: Maybe<Scalars['Float']['output']>;
  reportingInformationEndDate?: Maybe<Scalars['Date']['output']>;
  reportingInformationStartDate?: Maybe<Scalars['Date']['output']>;
  reversibleCarbonCredits?: Maybe<Scalars['Float']['output']>;
  totalCarbonCredits?: Maybe<Scalars['Float']['output']>;
};

export type CarbonFarmingRequest = {
  __typename: 'CarbonFarmingRequest';
  carbonFarmingSeasons?: Maybe<Array<Maybe<CarbonFarmingSeason>>>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FieldV2>;
  firstInterventionYear?: Maybe<Scalars['Int']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  signupDate?: Maybe<Scalars['Date']['output']>;
  status: CarbonFarmingRequestStatus;
  sustainabilityProgram?: Maybe<SustainabilityProgram>;
  uuid: Scalars['UUID']['output'];
};

export enum CarbonFarmingRequestStatus {
  ApprovedForProgram = 'APPROVED_FOR_PROGRAM',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type CarbonFarmingSeason = {
  __typename: 'CarbonFarmingSeason';
  bonusPayoutFactor?: Maybe<BonusPayoutFactor>;
  bonusPayoutFactorOverride?: Maybe<BonusPayoutFactor>;
  carbonCredits?: Maybe<Array<Maybe<CarbonCredit>>>;
  carbonFarmingRequestUuid: Scalars['UUID']['output'];
  country?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  creditEligibilities?: Maybe<Array<Maybe<CreditEligibility>>>;
  cropSeasonUuid: Scalars['UUID']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported! Use value from `CarbonFarmingRequest`. */
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  greetCarbonIntensityScore?: Maybe<GreetCarbonIntensityScore>;
  interventions?: Maybe<Array<Maybe<FulfilledIntervention>>>;
  isConflictBetweenUserDataAndValidation?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported! Use value from `CarbonFarmingRequest`. */
  signupDate?: Maybe<Scalars['Date']['output']>;
  status: CarbonFarmingSeasonStatus;
  uuid: Scalars['UUID']['output'];
};

export enum CarbonFarmingSeasonStatus {
  Credited = 'CREDITED',
  NotEligibleForSubmission = 'NOT_ELIGIBLE_FOR_SUBMISSION',
  Ongoing = 'ONGOING',
  ReadyForSubmission = 'READY_FOR_SUBMISSION',
  Submitted = 'SUBMITTED',
  UserFinalized = 'USER_FINALIZED'
}

export type CarbonIntensityIndicator = {
  __typename: 'CarbonIntensityIndicator';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  carbonFarmingSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  cropSeasonUuid: Scalars['UUID']['output'];
  eTag?: Maybe<Scalars['String']['output']>;
  fieldUuid: Scalars['UUID']['output'];
  issues?: Maybe<Array<Maybe<CarbonIntensityIndicatorIssue>>>;
  nationalAverageScore?: Maybe<Scalars['Float']['output']>;
  resolvedTillagePractice?: Maybe<CarbonIntensityIndicatorTillagePractice>;
  score?: Maybe<Scalars['Float']['output']>;
  status: CarbonIntensityIndicatorStatus;
  totalYield?: Maybe<Scalars['Float']['output']>;
};

export type CarbonIntensityIndicatorIssue = {
  __typename: 'CarbonIntensityIndicatorIssue';
  message: Scalars['String']['output'];
  messageKey: Scalars['String']['output'];
  severity: CarbonIntensityIndicatorIssueSeverity;
  taskUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum CarbonIntensityIndicatorIssueSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum CarbonIntensityIndicatorStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

export enum CarbonIntensityIndicatorTillagePractice {
  ConventionalTill = 'CONVENTIONAL_TILL',
  NoTill = 'NO_TILL',
  ReducedTill = 'REDUCED_TILL'
}

export type CarbonPlausibilityComment = {
  __typename: 'CarbonPlausibilityComment';
  comment?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type CarbonRelatedDataTillage = {
  __typename: 'CarbonRelatedDataTillage';
  executionDate?: Maybe<Scalars['Date']['output']>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
};

export type Category = {
  __typename: 'Category';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum CautionLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ClaasConnectStatus = {
  __typename: 'ClaasConnectStatus';
  status?: Maybe<Scalars['String']['output']>;
};

export type ClaasFarm = {
  __typename: 'ClaasFarm';
  claasFarmId?: Maybe<Scalars['UUID']['output']>;
  claasFarmName?: Maybe<Scalars['String']['output']>;
};

export type ClaasField = {
  __typename: 'ClaasField';
  alreadyImported?: Maybe<Scalars['Boolean']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  claasFieldName?: Maybe<Scalars['String']['output']>;
  claasFieldUuid?: Maybe<Scalars['UUID']['output']>;
  hasValidBoundary?: Maybe<Scalars['Boolean']['output']>;
};

export type ClaasOrganization = {
  __typename: 'ClaasOrganization';
  claasOrganizationId?: Maybe<Scalars['String']['output']>;
  claasOrganizationName?: Maybe<Scalars['String']['output']>;
};

export type ClaimAttachment = {
  __typename: 'ClaimAttachment';
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['Date']['output']>;
};

export type ClaimCategory = {
  __typename: 'ClaimCategory';
  category?: Maybe<HfClaimCategory>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ClaimEvaluation = {
  __typename: 'ClaimEvaluation';
  attachments?: Maybe<Array<Maybe<ClaimAttachment>>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type CnhCompany = {
  __typename: 'CnhCompany';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CnhFarm = {
  __typename: 'CnhFarm';
  cnhCompany?: Maybe<CnhCompany>;
  cnhGrower?: Maybe<CnhGrower>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CnhField = {
  __typename: 'CnhField';
  alreadyImported?: Maybe<Scalars['Boolean']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  cnhCompany?: Maybe<CnhCompany>;
  cnhFarm?: Maybe<CnhFarm>;
  cnhGrower?: Maybe<CnhGrower>;
  hasValidBoundary?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CnhGrower = {
  __typename: 'CnhGrower';
  cnhCompany?: Maybe<CnhCompany>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CnhTask = {
  __typename: 'CnhTask';
  cnhCompany?: Maybe<CnhCompany>;
  taskUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<CnhTaskType>;
  unitsPerAreaUnitUuid?: Maybe<Scalars['UUID']['output']>;
  useSinglepartPolygons?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  volumePerAreaUnitUuid?: Maybe<Scalars['UUID']['output']>;
  weightPerAreaUnitUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum CnhTaskType {
  Seeding = 'SEEDING',
  Spraying = 'SPRAYING'
}

export type Collaborator = {
  __typename: 'Collaborator';
  companyName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  farmUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  initials?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  /** @deprecated Use `user`. */
  userId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum CommercialPartnerPreOrderStatus {
  Cancelled = 'CANCELLED',
  Converted = 'CONVERTED',
  Opened = 'OPENED'
}

export enum CommercialPartnerPreOrderType {
  HealthyFields = 'HEALTHY_FIELDS'
}

export enum Comparison {
  Match = 'MATCH',
  Mismatch = 'MISMATCH',
  Uncertain = 'UNCERTAIN'
}

export enum ConfidenceLevel {
  ObserveBeforeTreat = 'OBSERVE_BEFORE_TREAT',
  Treat = 'TREAT'
}

export enum ConnectionSource {
  Dkedevice = 'DKEDEVICE',
  JohnDeere = 'JOHN_DEERE',
  Nevonexdevice = 'NEVONEXDEVICE',
  Osmdldevice = 'OSMDLDEVICE',
  Usb = 'USB'
}

export enum ConnectionStatus {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED'
}

export type ConnectivitySource = {
  __typename: 'ConnectivitySource';
  isInterested?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Array<Maybe<ConnectionSource>>>;
};

export type ContactInformation = {
  __typename: 'ContactInformation';
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Container = {
  __typename: 'Container';
  code?: Maybe<Scalars['String']['output']>;
  containerTypeCode?: Maybe<Scalars['String']['output']>;
  containerTypeName?: Maybe<Scalars['String']['output']>;
  containerTypeUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  supportedTaskTypes?: Maybe<Array<Maybe<SupportedTaskType>>>;
  unitCode?: Maybe<Scalars['String']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
  unitSiCode?: Maybe<Scalars['String']['output']>;
  unitSiConversionFactor?: Maybe<Scalars['Float']['output']>;
  unitSiName?: Maybe<Scalars['String']['output']>;
  unitSiUuid?: Maybe<Scalars['UUID']['output']>;
  unitUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum ContaminationState {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CountryCropGrowthStagePrediction = {
  __typename: 'CountryCropGrowthStagePrediction';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropGrowthStageV2?: Maybe<CropGrowthStageV2>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  displayCode?: Maybe<Scalars['String']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  gsOrder?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<GrowthStageProvider>;
  scale?: Maybe<ScaleV2>;
  startDate?: Maybe<Scalars['Date']['output']>;
};


export type CountryCropGrowthStagePredictionCropGrowthStageV2Args = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type CountryCropStressSetting = {
  __typename: 'CountryCropStressSetting';
  countryCode: Scalars['String']['output'];
  cropUuid: Scalars['UUID']['output'];
  mandatorySettings: Array<Maybe<MandatoryStressSetting>>;
  stress: StressV2;
};


export type CountryCropStressSettingStressArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type CountryWeed = {
  __typename: 'CountryWeed';
  characteristicId?: Maybe<Scalars['String']['output']>;
  characteristicName?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<Array<Maybe<Md2Item>>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum CoverCrop {
  CoverCrop = 'COVER_CROP',
  NoCoverCrop = 'NO_COVER_CROP',
  WinterCommodityCrop = 'WINTER_COMMODITY_CROP'
}

export enum CreationFlowHint {
  CropEstablishment = 'CROP_ESTABLISHMENT',
  CropProtection = 'CROP_PROTECTION',
  NutritionManagement = 'NUTRITION_MANAGEMENT',
  SmartSpraying = 'SMART_SPRAYING',
  WeedManagement = 'WEED_MANAGEMENT'
}

export type CreditEligibility = {
  __typename: 'CreditEligibility';
  criteria?: Maybe<Criteria>;
  deadlineDate?: Maybe<Scalars['Date']['output']>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
};

export enum Criteria {
  BarillaDeadline_1 = 'BARILLA_DEADLINE_1',
  BarillaDeadline_2 = 'BARILLA_DEADLINE_2',
  BarillaDeadline_2LateReporting = 'BARILLA_DEADLINE_2_LATE_REPORTING',
  BarillaDeadline_3 = 'BARILLA_DEADLINE_3',
  BarillaExtendedDeadline_1 = 'BARILLA_EXTENDED_DEADLINE_1',
  BarillaExtendedDeadline_2 = 'BARILLA_EXTENDED_DEADLINE_2',
  BarillaExtendedDeadline_3 = 'BARILLA_EXTENDED_DEADLINE_3',
  PeroniDeadline_1 = 'PERONI_DEADLINE_1',
  PeroniDeadline_2 = 'PERONI_DEADLINE_2',
  PeroniDeadline_2LateReporting = 'PERONI_DEADLINE_2_LATE_REPORTING',
  PeroniDeadline_3 = 'PERONI_DEADLINE_3',
  PeroniExtendedDeadline_1 = 'PERONI_EXTENDED_DEADLINE_1',
  PeroniExtendedDeadline_2 = 'PERONI_EXTENDED_DEADLINE_2',
  PeroniExtendedDeadline_3 = 'PERONI_EXTENDED_DEADLINE_3'
}

export type CriticalCropStageRisk = {
  __typename: 'CriticalCropStageRisk';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  issueType?: Maybe<IssueType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CropSeasonStatusState>;
  statusPrecision?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<CropSeasonStatusType>;
};

export type CriticalCropStageRiskInfo = {
  __typename: 'CriticalCropStageRiskInfo';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  issueType?: Maybe<IssueType>;
  priority?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CropSeasonStatusType>;
};

export type CriticalGrowthStagePeriodRisk = {
  __typename: 'CriticalGrowthStagePeriodRisk';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CropSeasonStatusState>;
  type?: Maybe<CropSeasonStatusType>;
};

export type Crop = {
  __typename: 'Crop';
  eppocode?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  landUse?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  landUseUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  /** @deprecated Not supported anymore by MD2.0 */
  scientificName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  varieties?: Maybe<Array<Maybe<Variety>>>;
};

export type CropDictCode = {
  __typename: 'CropDictCode';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropEstablishment = {
  __typename: 'CropEstablishment';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  dosedMap?: Maybe<DosedMap>;
  etag?: Maybe<Scalars['String']['output']>;
  fieldInputPackagingUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedArea?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type CropEstablishmentDetails = {
  __typename: 'CropEstablishmentDetails';
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  seedBoxPerArea?: Maybe<Scalars['Float']['output']>;
  seedWeightPerSeedBox?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
  yieldExpectation?: Maybe<Scalars['Float']['output']>;
};

export type CropGrowthStage = {
  __typename: 'CropGrowthStage';
  bbch2DigitCode?: Maybe<Scalars['Int']['output']>;
  cdnImagePath?: Maybe<Scalars['String']['output']>;
  cdnLogoPath?: Maybe<Scalars['String']['output']>;
  cropName: Scalars['String']['output'];
  cropUuid: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  growthStageCode?: Maybe<Scalars['String']['output']>;
  mesoStageCode?: Maybe<Scalars['Int']['output']>;
  plantType?: Maybe<Scalars['String']['output']>;
  plantTypeUuid?: Maybe<Scalars['UUID']['output']>;
  primaryGrowthStage?: Maybe<Scalars['String']['output']>;
  secondaryGrowthStage?: Maybe<Scalars['String']['output']>;
  secondaryGrowthStageCode?: Maybe<Scalars['Int']['output']>;
  secondaryGrowthStageName?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type CropGrowthStageImage = {
  __typename: 'CropGrowthStageImage';
  code?: Maybe<Scalars['String']['output']>;
  fullPath?: Maybe<Scalars['String']['output']>;
  imageThumbnailPath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  typeUuid?: Maybe<Scalars['UUID']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropGrowthStageV2 = {
  __typename: 'CropGrowthStageV2';
  code?: Maybe<Scalars['String']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Array<Maybe<CropGrowthStageImage>>>;
  isActiveGSModel?: Maybe<Scalars['Boolean']['output']>;
  isMilestone?: Maybe<Scalars['Boolean']['output']>;
  mainGSCode?: Maybe<Scalars['String']['output']>;
  mainGSName?: Maybe<Scalars['String']['output']>;
  mainGSUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalCode?: Maybe<Scalars['String']['output']>;
  scaleCode?: Maybe<ScaleV2>;
  scaleName?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropMix = {
  __typename: 'CropMix';
  /**  optional, because for single-crop mixes this is not required */
  crops: Array<CropMixDetail>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropMixDetail = {
  __typename: 'CropMixDetail';
  crop?: Maybe<Crop>;
  cropUuid: Scalars['UUID']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  variety?: Maybe<Variety>;
  varietyUuid?: Maybe<Scalars['UUID']['output']>;
};


export type CropMixDetailCropArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type CropNutritionReportConfiguration = {
  __typename: 'CropNutritionReportConfiguration';
  cover: CropNutritionReportCoverConfiguration;
  creatorId: Scalars['String']['output'];
  etag: Scalars['String']['output'];
  farmSummary: CropNutritionReportFarmSummaryConfiguration;
  fieldDetails: CropNutritionReportFieldDetailsConfiguration;
  lastModifierId: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type CropNutritionReportCoverConfiguration = {
  __typename: 'CropNutritionReportCoverConfiguration';
  coverImage?: Maybe<File>;
  includeCoverImage: Scalars['Boolean']['output'];
  includeFarmName: Scalars['Boolean']['output'];
  includeFieldList: Scalars['Boolean']['output'];
  includeGrowerName: Scalars['Boolean']['output'];
  includeTotalArea: Scalars['Boolean']['output'];
};

export type CropNutritionReportFarmSummaryConfiguration = {
  __typename: 'CropNutritionReportFarmSummaryConfiguration';
  includeApplicationPrescriptionMaps: Scalars['Boolean']['output'];
  includePowerzone: Scalars['Boolean']['output'];
  includeSoilSamplingResultParameters: Array<SoilPropertyType>;
  includeSoilSamplingSetLayout: Scalars['Boolean']['output'];
};

export type CropNutritionReportFieldDetailsConfiguration = {
  __typename: 'CropNutritionReportFieldDetailsConfiguration';
  includeApplicationPrescriptionMaps: Scalars['Boolean']['output'];
  includePowerzone: Scalars['Boolean']['output'];
  includeSoilSamplingResultParameters: Array<SoilPropertyType>;
  includeSoilSamplingSetLayout: Scalars['Boolean']['output'];
  included: Scalars['Boolean']['output'];
};

export type CropResidueManagementTask = {
  __typename: 'CropResidueManagementTask';
  area?: Maybe<Scalars['Float']['output']>;
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  residueManagementUuid: Scalars['UUID']['output'];
  state?: Maybe<TaskExecutionState>;
  uuid: Scalars['UUID']['output'];
};

export type CropSeason = {
  __typename: 'CropSeason';
  actionRecommendationAggregations?: Maybe<Array<Maybe<ActionRecommendationAggregation>>>;
  actionRecommendations?: Maybe<Array<Maybe<ActionRecommendation>>>;
  actionWindows?: Maybe<Array<Maybe<ActionWindow>>>;
  activeGrowthStage?: Maybe<GrowthStage>;
  aggregatedRisks?: Maybe<Array<Maybe<AggregatedRisk>>>;
  applicationRecommendations?: Maybe<Array<Maybe<ApplicationRecommendation>>>;
  applicationWindows?: Maybe<Array<Maybe<ApplicationWindow>>>;
  crop?: Maybe<Crop>;
  cropEstablishmentGrowthStageIndex?: Maybe<Scalars['String']['output']>;
  cropEstablishmentMethod?: Maybe<EstablishmentMethod>;
  cropSeasonStatus?: Maybe<Array<Maybe<CropSeasonStatus>>>;
  cropUsage?: Maybe<CropUsage>;
  droneFlights?: Maybe<Array<Maybe<DroneFlight>>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `fieldV2`. */
  field: Field;
  fieldV2: FieldV2;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  growthStages?: Maybe<Array<Maybe<GrowthStage>>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isHealthyField?: Maybe<Scalars['Boolean']['output']>;
  lifecycleState?: Maybe<LifecycleState>;
  nutritionRecommendations?: Maybe<Array<Maybe<NutritionRecommendation>>>;
  nutritionStatus?: Maybe<Array<Maybe<NutritionStatus>>>;
  observations?: Maybe<Array<Maybe<Observation>>>;
  preCropUuid?: Maybe<Scalars['UUID']['output']>;
  protectionTimes?: Maybe<Array<Maybe<ProtectionTime>>>;
  recommendationSnoozes?: Maybe<Array<Maybe<RecommendationSnooze>>>;
  risks?: Maybe<Array<Maybe<Risk>>>;
  seedingTillageSystem?: Maybe<TillageSystem>;
  sourceMaps?: Maybe<Array<Maybe<SourceMap>>>;
  sprayingWindow?: Maybe<SprayingWindow>;
  /** @deprecated Use `sprayingsV2` */
  sprayings?: Maybe<Array<Maybe<Spraying>>>;
  sprayingsV2?: Maybe<Array<Maybe<SprayingV2>>>;
  startDate?: Maybe<Scalars['Date']['output']>;
  tillageSystem?: Maybe<TillageSystem>;
  /** @deprecated Use `tillageSystem`. */
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  timingStressesInfo?: Maybe<Array<Maybe<TimingStressInfo>>>;
  uuid: Scalars['UUID']['output'];
  variety?: Maybe<Variety>;
  weedManagementRecommendations?: Maybe<Array<Maybe<WeedManagementRecommendation>>>;
  weedRisk?: Maybe<WeedRisk>;
  yield?: Maybe<Scalars['Float']['output']>;
  yieldExpectation: Scalars['Float']['output'];
};


export type CropSeasonActionRecommendationAggregationsArgs = {
  actionStatus?: InputMaybe<ActionRecommendationAggregationStatus>;
  actionType?: InputMaybe<Array<InputMaybe<ActionRecommendationType>>>;
};


export type CropSeasonActionRecommendationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonApplicationRecommendationsArgs = {
  fromDate: Scalars['Date']['input'];
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<ApplicationRecommendationType>;
};


export type CropSeasonCropSeasonStatusArgs = {
  type?: InputMaybe<Array<InputMaybe<CropSeasonStatusType>>>;
};


export type CropSeasonNutritionRecommendationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonRisksArgs = {
  fromDate: Scalars['Date']['input'];
  tillDate: Scalars['Date']['input'];
};


export type CropSeasonSourceMapsArgs = {
  filterStrategy?: InputMaybe<FilterStrategy>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonWeedManagementRecommendationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CropSeasonData = {
  __typename: 'CropSeasonData';
  actionDetails?: Maybe<Array<Maybe<CropSystemRecommendationActionDetail>>>;
  cropSeason?: Maybe<CropSeasonV2>;
  nutritionTargetRates?: Maybe<Array<Maybe<NutrientRate>>>;
};

export type CropSeasonNutritionProgram = {
  __typename: 'CropSeasonNutritionProgram';
  actionDetails?: Maybe<Array<Maybe<NutritionActionDetail>>>;
  averageCropYieldFiveYears?: Maybe<Scalars['Float']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  cropSystemRecommendation?: Maybe<CropSystemRecommendation>;
  cropSystemRecommendationV2?: Maybe<CropSystemRecommendationV2>;
  etag?: Maybe<Scalars['String']['output']>;
  isOrganicFertilizerApplicationPlanned?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  nitrogenMin?: Maybe<Scalars['Float']['output']>;
  nitrogenMineralInSoil?: Maybe<Scalars['Float']['output']>;
  nutritionTargetRates?: Maybe<Array<Maybe<NutritionTargetRate>>>;
  provider?: Maybe<NutritionProgramProvider>;
  strategy?: Maybe<NutritionProgramStrategy>;
  uuid: Scalars['UUID']['output'];
};

export type CropSeasonNutritionProgramExecutionStatus = {
  __typename: 'CropSeasonNutritionProgramExecutionStatus';
  cropSeason?: Maybe<CropSeasonV2>;
  sprayingNutrients?: Maybe<Array<Maybe<SprayingNutrient>>>;
  totalNutrients?: Maybe<Array<Maybe<TotalNutrients>>>;
  totalNutrientsDelta?: Maybe<Array<Maybe<TotalNutrientsDelta>>>;
  totalProducts?: Maybe<Array<Maybe<TotalProducts>>>;
};

export type CropSeasonNutritionRecommendation = {
  __typename: 'CropSeasonNutritionRecommendation';
  actionDetails?: Maybe<Array<Maybe<NutritionActionDetail>>>;
  cropSeason?: Maybe<CropSeasonV2>;
  isOrganicFertilizerApplicationPlanned?: Maybe<Scalars['Boolean']['output']>;
  nitrogenMin?: Maybe<Scalars['Float']['output']>;
  nutritionTargetRates?: Maybe<Array<Maybe<NutritionTargetRate>>>;
  provider?: Maybe<NutritionProgramProvider>;
};

export type CropSeasonStatus = {
  __typename: 'CropSeasonStatus';
  basedOn?: Maybe<CalculationBase>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CropSeasonStatusState>;
  type?: Maybe<CropSeasonStatusType>;
};

export type CropSeasonStatusReportEmailSubscription = {
  __typename: 'CropSeasonStatusReportEmailSubscription';
  creatorId?: Maybe<Scalars['String']['output']>;
  deliveryDays?: Maybe<Array<Maybe<DeliveryDay>>>;
  etag?: Maybe<Scalars['String']['output']>;
  farmV2: FarmV2;
  lastExecutionTime?: Maybe<Scalars['Date']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Section>;
  subscriptionStatus?: Maybe<EmailSubscriptionStatus>;
  theme?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum CropSeasonStatusState {
  Disabled = 'DISABLED',
  High = 'HIGH',
  Inactive = 'INACTIVE',
  Low = 'LOW',
  Medium = 'MEDIUM',
  MediumHigh = 'MEDIUM_HIGH',
  MediumLow = 'MEDIUM_LOW',
  NotRelevant = 'NOT_RELEVANT',
  NotSupported = 'NOT_SUPPORTED',
  NoInformation = 'NO_INFORMATION',
  Protected = 'PROTECTED'
}

export enum CropSeasonStatusType {
  Abiotic = 'ABIOTIC',
  Disease = 'DISEASE',
  Insect = 'INSECT',
  Lodging = 'LODGING',
  Weed = 'WEED'
}

export type CropSeasonTreatmentProgram = {
  __typename: 'CropSeasonTreatmentProgram';
  actionDetails?: Maybe<Array<Maybe<ActionDetail>>>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  recommendationStatus?: Maybe<RecommendationStatusType>;
  treatmentScenario?: Maybe<TreatmentScenario>;
  uuid: Scalars['UUID']['output'];
  weedManagementProgramRecommendationUuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropSeasonTreatmentProgramExecutionStatus = {
  __typename: 'CropSeasonTreatmentProgramExecutionStatus';
  actionWindows?: Maybe<Array<Maybe<TreatmentProgramActionWindow>>>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  executionStatus?: Maybe<ExecutionStatus>;
  outOfWindowsTasks?: Maybe<Array<Maybe<TreatmentProgramActionWindowTask>>>;
  plannedExecutionStatus?: Maybe<PlannedExecutionStatus>;
  treatmentScenarioUuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropSeasonTreatmentProgramV2 = {
  __typename: 'CropSeasonTreatmentProgramV2';
  actionDetails?: Maybe<Array<Maybe<ActionDetailV2>>>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  recommendationStatus?: Maybe<RecommendationStatusType>;
  scenarioDescriptionKey?: Maybe<Scalars['String']['output']>;
  treatmentScenario?: Maybe<TreatmentScenario>;
  uuid: Scalars['UUID']['output'];
  weedManagementProgramRecommendationUuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropSeasonTreatmentProgramV3 = {
  __typename: 'CropSeasonTreatmentProgramV3';
  actions?: Maybe<Array<Maybe<TreatmentProgramAction>>>;
  checksum?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  cropEstablishmentGrowthStageIndex?: Maybe<Scalars['String']['output']>;
  cropEstablishmentGrowthStageScaleCode?: Maybe<ScaleV2>;
  cropEstablishmentMethodUuid?: Maybe<Scalars['UUID']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  equipmentType?: Maybe<TreatmentEquipmentType>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recommendationStatus?: Maybe<RecommendationStatusType>;
  scenarioDescriptionKey?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TreatmentProgramType>;
  uuid: Scalars['UUID']['output'];
  weedManagementProgramRecommendationUuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropSeasonV2 = {
  __typename: 'CropSeasonV2';
  actionRecommendationAggregations?: Maybe<Array<Maybe<ActionRecommendationAggregation>>>;
  actionRecommendations?: Maybe<Array<Maybe<ActionRecommendation>>>;
  actionWindows?: Maybe<Array<Maybe<ActionWindow>>>;
  activeCountryCropGrowthStage?: Maybe<CountryCropGrowthStagePrediction>;
  activeGrowthStage?: Maybe<GrowthStage>;
  additionalInfectionRiskFactor?: Maybe<AdditionalInfectionRiskFactor>;
  agBalanceFieldEmissionIndicator?: Maybe<AgBalanceFieldEmissionIndicator>;
  aggregatedPestDevelopmentPredictions?: Maybe<Array<Maybe<AggregatedPestDevelopmentPrediction>>>;
  applicationWindows?: Maybe<Array<Maybe<ApplicationWindow>>>;
  arvalisCalculationBasis?: Maybe<ArvalisCalculationBasis>;
  arvalisDeviceToCropSeason?: Maybe<ArvalisDeviceToCropSeason>;
  arvalisInformation?: Maybe<ArvalisInformation>;
  averageHeightOfCanopy?: Maybe<Scalars['Float']['output']>;
  averageThicknessOfCanopy?: Maybe<Scalars['Float']['output']>;
  beforeSeasonRisks?: Maybe<Array<BeforeSeasonRisk>>;
  biodiversityIndicator?: Maybe<BiodiversityIndicator>;
  biomassPerAreaAtTermination?: Maybe<Scalars['Float']['output']>;
  boundary?: Maybe<Scalars['JSONObject']['output']>;
  boundaryChecksum?: Maybe<Scalars['String']['output']>;
  campaignYear?: Maybe<Scalars['Int']['output']>;
  carbonPlausibilityComment?: Maybe<CarbonPlausibilityComment>;
  countryCropGrowthStagePredictions?: Maybe<Array<Maybe<CountryCropGrowthStagePrediction>>>;
  creator?: Maybe<User>;
  criticalCropStageRiskInfos?: Maybe<Array<Maybe<CriticalCropStageRiskInfo>>>;
  criticalCropStageRisks?: Maybe<Array<Maybe<CriticalCropStageRisk>>>;
  criticalGrowthStagePeriodRisks?: Maybe<Array<Maybe<CriticalGrowthStagePeriodRisk>>>;
  crop?: Maybe<Crop>;
  cropEstablishmentDetails?: Maybe<CropEstablishmentDetails>;
  cropEstablishmentGrowthStageIndex?: Maybe<Scalars['String']['output']>;
  cropEstablishmentGrowthStageScaleCode?: Maybe<ScaleV2>;
  cropEstablishmentMethodCode?: Maybe<EstablishmentMethod>;
  cropEstablishments?: Maybe<Array<CropEstablishment>>;
  cropMix: CropMix;
  cropResidueManagementTasks?: Maybe<Array<CropResidueManagementTask>>;
  cropSeasonNutritionProgram?: Maybe<CropSeasonNutritionProgram>;
  cropSeasonNutritionProgramExecutionStatus?: Maybe<CropSeasonNutritionProgramExecutionStatus>;
  cropSeasonStatus?: Maybe<Array<Maybe<CropSeasonStatus>>>;
  cropSeasonTreatmentProgram?: Maybe<CropSeasonTreatmentProgram>;
  cropSeasonTreatmentProgramExecutionStatus?: Maybe<CropSeasonTreatmentProgramExecutionStatus>;
  cropSeasonTreatmentProgramV2?: Maybe<CropSeasonTreatmentProgramV2>;
  cropSeasonTreatmentProgramV3?: Maybe<CropSeasonTreatmentProgramV3>;
  cropSeasonWaterManagementProgram?: Maybe<CropSeasonWaterManagementProgram>;
  cropUsage?: Maybe<CropUsage>;
  cropWaterAvailabilities?: Maybe<Array<Maybe<CropWaterAvailability>>>;
  croppingSystem?: Maybe<Dictionary>;
  customPowerzoneOrders?: Maybe<Array<Maybe<CustomPowerzoneOrder>>>;
  dailyFungusDetails?: Maybe<Array<Maybe<DailyFungusDetails>>>;
  dailyStressCharacteristics?: Maybe<Array<Maybe<DailyStressCharacteristics>>>;
  dailyStressEventProbabilities?: Maybe<Array<Maybe<DailyStressEventProbability>>>;
  dailyWeedRiskDetails?: Maybe<Array<Maybe<DailyWeedRiskDetails>>>;
  depthOfRoots?: Maybe<Scalars['Float']['output']>;
  droneFlights?: Maybe<Array<DroneFlight>>;
  dryMatterAnalysis?: Maybe<Array<Maybe<DryMatterAnalysis>>>;
  endDate?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  fieldDataLayers?: Maybe<Array<Maybe<FieldDataLayer>>>;
  fieldV2: FieldV2;
  fieldVariabilityIndexes?: Maybe<Array<Maybe<FieldVariabilityIndex>>>;
  fieldVariabilityInput?: Maybe<FieldVariabilityInput>;
  foreignCatchCropUuid?: Maybe<Scalars['UUID']['output']>;
  foreignCropUuid?: Maybe<Scalars['UUID']['output']>;
  foreignPreCropUuid?: Maybe<Scalars['UUID']['output']>;
  frostRisks?: Maybe<Array<Maybe<FrostRisk>>>;
  greenhouseWhiteningTasks?: Maybe<Array<GreenhouseWhiteningTask>>;
  groundWaterDepth?: Maybe<Scalars['Float']['output']>;
  growthStagePredictionDaily?: Maybe<Array<Maybe<GrowthStagePredictionDaily>>>;
  growthStages?: Maybe<Array<Maybe<GrowthStage>>>;
  harvests?: Maybe<Array<Harvest>>;
  hfClaims?: Maybe<Array<Maybe<HfClaim>>>;
  hfOfferCondition?: Maybe<HfOfferCondition>;
  hfPrice?: Maybe<HfPrice>;
  hfServiceRequests?: Maybe<Array<Maybe<HfServiceRequest>>>;
  hortaCropSeason?: Maybe<HortaCropSeason>;
  hortaSustainabilityIndicator?: Maybe<HortaSustainabilityIndicator>;
  initialWaterContentInSoil?: Maybe<Scalars['Float']['output']>;
  isAutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  isHealthyField?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `croppingSystem` instead. */
  isOrganicFarming?: Maybe<Scalars['Boolean']['output']>;
  landPreparations?: Maybe<Array<LandPreparation>>;
  leafPruningTasks?: Maybe<Array<LeafPruningTask>>;
  lifecycleState?: Maybe<LifecycleState>;
  modifier?: Maybe<User>;
  monitorPractices?: Maybe<Array<Maybe<MonitorPractice>>>;
  nextCountryCropGrowthStage?: Maybe<CountryCropGrowthStagePrediction>;
  nextGrowthStage?: Maybe<GrowthStage>;
  nutritionRecommendations?: Maybe<Array<Maybe<NutritionRecommendation>>>;
  nutritionStatus?: Maybe<Array<Maybe<NutritionStatus>>>;
  observations?: Maybe<Array<Observation>>;
  operationalInstructions?: Maybe<Array<Maybe<HfOperationalInstruction>>>;
  pestDevelopmentPredictions?: Maybe<Array<Maybe<PestDevelopmentPrediction>>>;
  preCrop?: Maybe<Crop>;
  /** @deprecated Use `preCrop`. */
  preCropUuid?: Maybe<Scalars['UUID']['output']>;
  produceDeliveryTasks?: Maybe<Array<Maybe<ProduceDeliveryTask>>>;
  projectedIncidences?: Maybe<Array<Maybe<ProjectedIncidences>>>;
  protectionTimes?: Maybe<Array<Maybe<ProtectionTime>>>;
  recommendationSnoozes?: Maybe<Array<Maybe<RecommendationSnooze>>>;
  residueLeft?: Maybe<Scalars['Boolean']['output']>;
  risks?: Maybe<Array<Maybe<Risk>>>;
  risksV2?: Maybe<Array<Maybe<RiskV2>>>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  scoutingTasks?: Maybe<Array<ScoutingTask>>;
  seedBoxTreatments?: Maybe<Array<SeedBoxTreatment>>;
  /** @deprecated Use `seedTreatmentType`. */
  seedTreatment?: Maybe<SeedTreatmentType>;
  seedTreatmentTasks?: Maybe<Array<SeedTreatment>>;
  seedTreatmentType?: Maybe<SeedTreatmentType>;
  seedWeight?: Maybe<Scalars['Float']['output']>;
  seedbedQualityUuid?: Maybe<Scalars['UUID']['output']>;
  seedingTillageSystem?: Maybe<TillageSystem>;
  shootsPerPlantCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `smartSprayingTasksV2` */
  smartSprayingTasks?: Maybe<Array<SmartSprayingTask>>;
  smartSprayingTasksV2?: Maybe<Array<SmartSprayingTaskV2>>;
  soilSamplingTasks?: Maybe<Array<Maybe<SoilSamplingTask>>>;
  soilSolarizationMaterialUuid?: Maybe<Scalars['UUID']['output']>;
  sourceMaps?: Maybe<Array<Maybe<SourceMap>>>;
  sowingDepthClassUuid?: Maybe<Scalars['UUID']['output']>;
  sprayingsV2?: Maybe<Array<SprayingV2>>;
  startDate: Scalars['Date']['output'];
  stressEfficacyCharacteristics?: Maybe<Array<Maybe<StressEfficacyCharacteristics>>>;
  stressSettings?: Maybe<StressSettings>;
  sustainabilityIndicator?: Maybe<SustainabilityIndicator>;
  sustainabilityInput?: Maybe<SustainabilityInput>;
  taskAggregations?: Maybe<Array<Maybe<TaskAggregation>>>;
  tillageSystem?: Maybe<TillageSystem>;
  timingCalculationStatus?: Maybe<TimingCalculationStatus>;
  timingProductRecommendations?: Maybe<Array<TimingProductRecommendation>>;
  timingStressesInfo?: Maybe<Array<Maybe<TimingStressInfo>>>;
  toppingTasks?: Maybe<Array<ToppingTask>>;
  trainingSystemUuid?: Maybe<Scalars['UUID']['output']>;
  trials?: Maybe<Array<Maybe<Trial>>>;
  underSeedManagementUuid?: Maybe<Scalars['UUID']['output']>;
  useOrganicFertilizer?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
  variety?: Maybe<Variety>;
  waterBalances?: Maybe<Array<Maybe<WaterBalance>>>;
  waterManagementTasks?: Maybe<Array<WaterManagementTask>>;
  waterRecommendations?: Maybe<Array<Maybe<WaterRecommendation>>>;
  waterStatus?: Maybe<Array<Maybe<WaterStatus>>>;
  waterloggingRiskUuid?: Maybe<Scalars['UUID']['output']>;
  weedManagementRecommendations?: Maybe<Array<Maybe<WeedManagementRecommendation>>>;
  weedRisk?: Maybe<WeedRisk>;
  weedStatus?: Maybe<Array<Maybe<WeedStatus>>>;
  weeklySeedingRecommendations?: Maybe<Array<Maybe<WeeklySeedingRecommendation>>>;
  yield?: Maybe<Scalars['Float']['output']>;
  yieldExpectation: Scalars['Float']['output'];
  yieldPrediction?: Maybe<YieldPrediction>;
};


export type CropSeasonV2ActionRecommendationAggregationsArgs = {
  actionStatus?: InputMaybe<ActionRecommendationAggregationStatus>;
  actionType?: InputMaybe<Array<InputMaybe<ActionRecommendationType>>>;
};


export type CropSeasonV2ActionRecommendationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2ActionWindowsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2AggregatedPestDevelopmentPredictionsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2CountryCropGrowthStagePredictionsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2CriticalCropStageRisksArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<CropSeasonStatusType>>>;
};


export type CropSeasonV2CriticalGrowthStagePeriodRisksArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<CropSeasonStatusType>>>;
};


export type CropSeasonV2CropArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2CropSeasonStatusArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<InputMaybe<CropSeasonStatusType>>>;
};


export type CropSeasonV2CropUsageArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2CropWaterAvailabilitiesArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2CroppingSystemArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2DailyFungusDetailsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2DailyStressCharacteristicsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  stressRiskTypes?: InputMaybe<Array<InputMaybe<RiskType>>>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<DailyStressCharacteristicsType>>>;
};


export type CropSeasonV2DailyStressEventProbabilitiesArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  stressUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2DailyWeedRiskDetailsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2DryMatterAnalysisArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2FieldDataLayersArgs = {
  includedMagnitudeTypeFilter?: InputMaybe<Array<InputMaybe<MagnitudeType>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maxCountByType?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<FieldDataLayerType>>>;
};


export type CropSeasonV2FrostRisksArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2GrowthStagesArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2NutritionRecommendationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2NutritionStatusArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2OperationalInstructionsArgs = {
  roleFeatureName: Scalars['String']['input'];
};


export type CropSeasonV2PestDevelopmentPredictionsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2PreCropArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2RisksArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<CropSeasonStatusState>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<InputMaybe<RiskType>>>;
};


export type CropSeasonV2RisksV2Args = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<CropSeasonStatusState>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<RiskType>>>;
};


export type CropSeasonV2ScoutingTasksArgs = {
  excludeStressQuestions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CropSeasonV2SeedingTillageSystemArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2SourceMapsArgs = {
  filterStrategy?: InputMaybe<FilterStrategy>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2SprayingsV2Args = {
  sprayingTaskUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type CropSeasonV2StressEfficacyCharacteristicsArgs = {
  format?: InputMaybe<Array<InputMaybe<TimeFormat>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2TillageSystemArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2VarietyArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type CropSeasonV2WaterRecommendationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2WaterStatusArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2WeedManagementRecommendationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CropSeasonV2WeedStatusArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CropSeasonWaterManagementProgram = {
  __typename: 'CropSeasonWaterManagementProgram';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  waterManagementScenario?: Maybe<WaterManagementScenario>;
};

export type CropSystemRecommendation = {
  __typename: 'CropSystemRecommendation';
  cropSeasons?: Maybe<Array<Maybe<CropSeasonData>>>;
  nutrientRateUnitCode?: Maybe<NutrientRateUnitCode>;
  provider: NutritionProgramProvider;
  soilSamplingResult?: Maybe<SoilSamplingResult>;
  totalNutritionTargetRates?: Maybe<Array<Maybe<NutrientRate>>>;
  uuid: Scalars['UUID']['output'];
};

export type CropSystemRecommendationActionDetail = {
  __typename: 'CropSystemRecommendationActionDetail';
  appliedNutrients?: Maybe<Array<Maybe<NutrientRate>>>;
  nutrients?: Maybe<Array<Maybe<NutritionActionNutrient>>>;
  nutrientsDemandDelta?: Maybe<Array<Maybe<NutrientRate>>>;
  totalNutrients?: Maybe<Array<Maybe<NutrientRate>>>;
  type?: Maybe<NutritionRecommendationActionType>;
  validFrom?: Maybe<RecommendationActionValidity>;
  validTill?: Maybe<RecommendationActionValidity>;
};

export type CropSystemRecommendationRequest = {
  __typename: 'CropSystemRecommendationRequest';
  averageCropYieldFiveYears?: Maybe<Scalars['Float']['output']>;
  cropSeasonUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /** @deprecated Use `croppingSystem` attribute from `CropSeasonV2` schema. */
  croppingSystemUuid?: Maybe<Scalars['UUID']['output']>;
  customNutrientRates?: Maybe<Array<Maybe<NutrientRate>>>;
  isQualitativeCalcium?: Maybe<Scalars['Boolean']['output']>;
  isQualitativeMagnesium?: Maybe<Scalars['Boolean']['output']>;
  isQualitativeNitrogen?: Maybe<Scalars['Boolean']['output']>;
  isQualitativePhosphorus?: Maybe<Scalars['Boolean']['output']>;
  isQualitativePotassium?: Maybe<Scalars['Boolean']['output']>;
  nitrogenMineralInSoil?: Maybe<Scalars['Float']['output']>;
  previousYearOrganicNitrogen?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<NutritionProgramProvider>;
  relativePowerOfTotalNeutralisation?: Maybe<Scalars['Float']['output']>;
  soilSamplingResultUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type CropSystemRecommendationV2 = {
  __typename: 'CropSystemRecommendationV2';
  cropSeasons?: Maybe<Array<Maybe<CropSeasonData>>>;
  cropSystemRecommendationRequest?: Maybe<CropSystemRecommendationRequest>;
  /** @deprecated Use `croppingSystem` attribute from `CropSeasonV2` schema. */
  croppingSystem?: Maybe<Dictionary>;
  isInRedZone?: Maybe<Scalars['Boolean']['output']>;
  isQualitativeCalcium?: Maybe<Scalars['Boolean']['output']>;
  isQualitativeMagnesium?: Maybe<Scalars['Boolean']['output']>;
  isQualitativeNitrogen?: Maybe<Scalars['Boolean']['output']>;
  isQualitativePhosphorus?: Maybe<Scalars['Boolean']['output']>;
  isQualitativePotassium?: Maybe<Scalars['Boolean']['output']>;
  previousYearOrganicNitrogen?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<NutritionProgramProvider>;
  recommendationRequestUuid?: Maybe<Scalars['UUID']['output']>;
  relativePowerOfTotalNeutralisation?: Maybe<Scalars['Float']['output']>;
  soilSamplingResult?: Maybe<SoilSamplingResult>;
  strategy?: Maybe<NutritionProgramStrategy>;
  totalNutritionTargetRates?: Maybe<Array<Maybe<NutrientRate>>>;
  uuid: Scalars['UUID']['output'];
};

export type CropTankMixSummary = {
  __typename: 'CropTankMixSummary';
  cropSeasonsHavingAtLeastOneTankMix?: Maybe<Scalars['Int']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  numberOfTankMixes?: Maybe<Scalars['Int']['output']>;
};

export type CropUsage = {
  __typename: 'CropUsage';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type CropWaterAvailability = {
  __typename: 'CropWaterAvailability';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  evapotranspiration?: Maybe<Scalars['Float']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  optimalEvapotranspiration?: Maybe<Scalars['Float']['output']>;
  optimalWaterAvailableQuantity?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  waterAvailablePercentage?: Maybe<Scalars['Float']['output']>;
  waterAvailableQuantity?: Maybe<Scalars['Float']['output']>;
  waterAvailableStatus?: Maybe<WaterAvailableStatus>;
  waterSensitivity?: Maybe<WaterSensitivity>;
};

export type CurrentWeedPrediction = {
  __typename: 'CurrentWeedPrediction';
  fieldV2?: Maybe<FieldV2>;
  relevant?: Maybe<Scalars['Boolean']['output']>;
  resistanceUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  resistances?: Maybe<Array<Maybe<TargetWeedResistance>>>;
  targetWeedUuid?: Maybe<Scalars['UUID']['output']>;
  taxonomicRank?: Maybe<TaxonomicRank>;
  weedRecord?: Maybe<WeedRecord>;
  weedRecordCreationDate?: Maybe<Scalars['Date']['output']>;
  weedRecordSourceType?: Maybe<WeedRecordSourceType>;
  weight?: Maybe<TargetWeedWeight>;
};

export type CustomPowerzoneOrder = {
  __typename: 'CustomPowerzoneOrder';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  minGeometryArea?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CustomPowerzoneStatus>;
  timeWindows?: Maybe<Array<Maybe<CustomPowerzoneTimeWindow>>>;
  type?: Maybe<CustomPowerzoneType>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  zoneNr?: Maybe<Scalars['Int']['output']>;
};

export enum CustomPowerzoneStatus {
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type CustomPowerzoneTimeWindow = {
  __typename: 'CustomPowerzoneTimeWindow';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum CustomPowerzoneType {
  Evi = 'EVI',
  Lai = 'LAI',
  Ndvi = 'NDVI'
}

export type DailyFungusDetails = {
  __typename: 'DailyFungusDetails';
  basedOn?: Maybe<CalculationBase>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  contaminationIndex?: Maybe<Scalars['Float']['output']>;
  contaminationIndexStatus?: Maybe<ContaminationState>;
  contaminationWeight?: Maybe<Scalars['Float']['output']>;
  contaminationWeightStatus?: Maybe<ContaminationState>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  rain?: Maybe<Scalars['Float']['output']>;
  remainingLeachingResistance?: Maybe<Scalars['Float']['output']>;
  sporeReserve?: Maybe<Scalars['Float']['output']>;
  sporulationPotential?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  stress?: Maybe<StressV2>;
  treatmentDateAdviced?: Maybe<Scalars['Date']['output']>;
  varietyThreshold?: Maybe<Scalars['Float']['output']>;
};


export type DailyFungusDetailsStressArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type DailyStressCharacteristics = {
  __typename: 'DailyStressCharacteristics';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  groupingDate?: Maybe<Scalars['Date']['output']>;
  isActionRelevant?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isPotential?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<DailyStressCharacteristicsStatus>;
  stressRiskType?: Maybe<RiskType>;
  stresses?: Maybe<Array<Maybe<StressV2>>>;
  subType?: Maybe<DailyStressCharacteristicsSubType>;
  type?: Maybe<DailyStressCharacteristicsType>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type DailyStressCharacteristicsStressesArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum DailyStressCharacteristicsStatus {
  High = 'HIGH',
  Intermediate = 'INTERMEDIATE',
  Low = 'LOW',
  Medium = 'MEDIUM',
  MediumHigh = 'MEDIUM_HIGH',
  MediumLow = 'MEDIUM_LOW',
  Mild = 'MILD',
  NotJustifiedTreatment = 'NOT_JUSTIFIED_TREATMENT',
  NotPresent = 'NOT_PRESENT',
  Severe = 'SEVERE'
}

export enum DailyStressCharacteristicsSubType {
  Ascospores = 'ASCOSPORES',
  AscosporesOnBerryMummies = 'ASCOSPORES_ON_BERRY_MUMMIES',
  BerryToBerry = 'BERRY_TO_BERRY',
  Conidia = 'CONIDIA',
  ConidiaOnBerries = 'CONIDIA_ON_BERRIES',
  ConidiaOnBerryMummies = 'CONIDIA_ON_BERRY_MUMMIES',
  ConidiaOnCanes = 'CONIDIA_ON_CANES',
  ConidiaOnFlowers = 'CONIDIA_ON_FLOWERS',
  CumulativeInfection = 'CUMULATIVE_INFECTION',
  DiseaseOnset = 'DISEASE_ONSET',
  DiseasePressureClusters = 'DISEASE_PRESSURE_CLUSTERS',
  DiseasePressureLeaves = 'DISEASE_PRESSURE_LEAVES',
  Disperal = 'DISPERAL',
  FryIndex = 'FRY_INDEX',
  Germination = 'GERMINATION',
  Incubation = 'INCUBATION',
  IncubationClusters = 'INCUBATION_CLUSTERS',
  IncubationEndClusters = 'INCUBATION_END_CLUSTERS',
  IncubationEndLeaves = 'INCUBATION_END_LEAVES',
  IncubationLeaves = 'INCUBATION_LEAVES',
  IncubationLow = 'INCUBATION_LOW',
  IncubationOfLowProbableInfections = 'INCUBATION_OF_LOW_PROBABLE_INFECTIONS',
  IncubationOfProbableInfections = 'INCUBATION_OF_PROBABLE_INFECTIONS',
  Infection = 'INFECTION',
  InfectionPotentialIndex_7Days = 'INFECTION_POTENTIAL_INDEX_7_DAYS',
  Level_0_25 = 'LEVEL_0_25',
  Level_25_50 = 'LEVEL_25_50',
  Level_50_75 = 'LEVEL_50_75',
  Level_75_90 = 'LEVEL_75_90',
  Level_90_100 = 'LEVEL_90_100',
  MainInfectionSporulationPeriod = 'MAIN_INFECTION_SPORULATION_PERIOD',
  PrimaryConidia = 'PRIMARY_CONIDIA',
  ProjectionAtHarvest = 'PROJECTION_AT_HARVEST',
  PycnidiaOnset = 'PYCNIDIA_ONSET',
  Release = 'RELEASE',
  Risk = 'RISK',
  RiskStatus = 'RISK_STATUS',
  SecondaryConidia = 'SECONDARY_CONIDIA',
  Sporulation = 'SPORULATION',
  SporulationEnd = 'SPORULATION_END',
  SusceptibilityClusters = 'SUSCEPTIBILITY_CLUSTERS',
  Symptoms = 'SYMPTOMS',
  ViableSporongia = 'VIABLE_SPORONGIA'
}

export enum DailyStressCharacteristicsType {
  Aggregated = 'AGGREGATED',
  ColonyGrowth = 'COLONY_GROWTH',
  CumulativeInfection = 'CUMULATIVE_INFECTION',
  CumulativeInfectionPressure = 'CUMULATIVE_INFECTION_PRESSURE',
  CumulativeRisk = 'CUMULATIVE_RISK',
  DiseasePressureClusters = 'DISEASE_PRESSURE_CLUSTERS',
  DiseasePressureLeaves = 'DISEASE_PRESSURE_LEAVES',
  Dispersal = 'DISPERSAL',
  IncubationDiseaseOnset = 'INCUBATION_DISEASE_ONSET',
  IncubationOnClusters = 'INCUBATION_ON_CLUSTERS',
  IncubationOnLeaves = 'INCUBATION_ON_LEAVES',
  Infection = 'INFECTION',
  InfectionAndIncubation = 'INFECTION_AND_INCUBATION',
  InfectionDynamic = 'INFECTION_DYNAMIC',
  InfectionPotentialIndex = 'INFECTION_POTENTIAL_INDEX',
  InfectionPressure = 'INFECTION_PRESSURE',
  InfectionPressureSpring = 'INFECTION_PRESSURE_SPRING',
  Inoculum = 'INOCULUM',
  InoculumAvailability = 'INOCULUM_AVAILABILITY',
  InoculumDose = 'INOCULUM_DOSE',
  InoculumPotential = 'INOCULUM_POTENTIAL',
  MainInfectionSporulationPeriod = 'MAIN_INFECTION_SPORULATION_PERIOD',
  MicotoxinContaminationIndex = 'MICOTOXIN_CONTAMINATION_INDEX',
  NumberOfGeneration = 'NUMBER_OF_GENERATION',
  OosporeGermination = 'OOSPORE_GERMINATION',
  PressureIndex = 'PRESSURE_INDEX',
  SeasonalInfectionPressure = 'SEASONAL_INFECTION_PRESSURE',
  Sporulation = 'SPORULATION',
  SummaryOfEvents = 'SUMMARY_OF_EVENTS',
  TreatedMicotoxinContaminationIndex = 'TREATED_MICOTOXIN_CONTAMINATION_INDEX'
}

export type DailyStressEventProbability = {
  __typename: 'DailyStressEventProbability';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeasonV2: CropSeasonV2;
  endDate?: Maybe<Scalars['Date']['output']>;
  incubationLevels?: Maybe<Array<Maybe<IncubationLevel>>>;
  infectionType?: Maybe<InfectionType>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isPotential?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<DailyStressEventProbabilityStatus>;
  stressV2?: Maybe<StressV2>;
  type?: Maybe<DailyStressEventProbabilityType>;
};


export type DailyStressEventProbabilityStressV2Args = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum DailyStressEventProbabilityStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  None = 'NONE',
  NotSpecified = 'NOT_SPECIFIED'
}

export enum DailyStressEventProbabilityType {
  Dispersal = 'DISPERSAL',
  EggDeposit = 'EGG_DEPOSIT',
  EndIncubationClusters = 'END_INCUBATION_CLUSTERS',
  EndIncubationLeaves = 'END_INCUBATION_LEAVES',
  Germination = 'GERMINATION',
  Infection = 'INFECTION',
  Infestation = 'INFESTATION',
  Migration = 'MIGRATION',
  Release = 'RELEASE',
  Sporulation = 'SPORULATION',
  ViableSporangia = 'VIABLE_SPORANGIA'
}

export type DailyWeedRiskDetails = {
  __typename: 'DailyWeedRiskDetails';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isEmerging?: Maybe<Scalars['Boolean']['output']>;
  isLast?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  leafIndexCount?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  stress?: Maybe<StressV2>;
  weedGrowthStageIndex?: Maybe<Scalars['String']['output']>;
  weedGrowthStageScale?: Maybe<Scalars['String']['output']>;
};


export type DailyWeedRiskDetailsStressArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum DataReliability {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum DeliveryDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DemandEquationProduct = {
  __typename: 'DemandEquationProduct';
  averageRate?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<ProductV2>;
  unit?: Maybe<Scalars['String']['output']>;
  zones?: Maybe<Array<Maybe<DemandEquationZone>>>;
};

export type DemandEquationRecommendation = {
  __typename: 'DemandEquationRecommendation';
  calciumOxideInLime?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  desiredBaseSaturation?: Maybe<Scalars['Float']['output']>;
  desiredCalciumSaturation?: Maybe<Scalars['Float']['output']>;
  desiredCationExchangeCapacityPercentage?: Maybe<Scalars['Float']['output']>;
  desiredGypsumPercentage?: Maybe<Scalars['Float']['output']>;
  desiredNutrientLevel?: Maybe<Scalars['Float']['output']>;
  nutritionMethodUuid?: Maybe<Scalars['UUID']['output']>;
  products?: Maybe<Array<Maybe<DemandEquationProduct>>>;
  relativePowerOfTotalNeutralisation?: Maybe<Scalars['Float']['output']>;
  soilSamplingResult?: Maybe<SoilSamplingResult>;
  uuid: Scalars['UUID']['output'];
};

export type DemandEquationRecommendationV2 = {
  __typename: 'DemandEquationRecommendationV2';
  calciumOxideInLime?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  desiredBaseSaturation?: Maybe<Scalars['Float']['output']>;
  desiredCalciumSaturation?: Maybe<Scalars['Float']['output']>;
  desiredCationExchangeCapacityPercentage?: Maybe<Scalars['Float']['output']>;
  desiredGypsumPercentage?: Maybe<Scalars['Float']['output']>;
  desiredNutrientLevel?: Maybe<Scalars['Float']['output']>;
  nutritionMethodUuid?: Maybe<Scalars['UUID']['output']>;
  relativePowerOfTotalNeutralisation?: Maybe<Scalars['Float']['output']>;
  samplingAreas?: Maybe<Array<Maybe<DemandEquationSamplingArea>>>;
  soilSamplingResult?: Maybe<SoilSamplingResult>;
  uuid: Scalars['UUID']['output'];
};

export type DemandEquationSamplingArea = {
  __typename: 'DemandEquationSamplingArea';
  products?: Maybe<Array<Maybe<DemandEquationSamplingAreaProduct>>>;
  samplingAreaId?: Maybe<Scalars['String']['output']>;
};

export type DemandEquationSamplingAreaProduct = {
  __typename: 'DemandEquationSamplingAreaProduct';
  product?: Maybe<ProductV2>;
  rate?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type DemandEquationZone = {
  __typename: 'DemandEquationZone';
  id?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type DescriptionAndSymptom = {
  __typename: 'DescriptionAndSymptom';
  crop?: Maybe<Crop>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionCode?: Maybe<Scalars['String']['output']>;
  descriptionName?: Maybe<Scalars['String']['output']>;
  descriptionUuid?: Maybe<Scalars['UUID']['output']>;
  stressCode?: Maybe<Scalars['String']['output']>;
  stressName?: Maybe<Scalars['String']['output']>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
  symptom?: Maybe<Scalars['String']['output']>;
  symptomCode?: Maybe<Scalars['String']['output']>;
  symptomName?: Maybe<Scalars['String']['output']>;
  symptomUuid?: Maybe<Scalars['UUID']['output']>;
};

export type DetectedDisease = {
  __typename: 'DetectedDisease';
  eppoCode?: Maybe<Scalars['String']['output']>;
  latinName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  referenceImageUrl?: Maybe<Scalars['String']['output']>;
  userSelected?: Maybe<Scalars['Boolean']['output']>;
};

export type DetectedNitrogenStatus = {
  __typename: 'DetectedNitrogenStatus';
  freshMatter?: Maybe<Scalars['Float']['output']>;
  nitrogenUptake?: Maybe<Scalars['Float']['output']>;
};

export type DetectedPest = {
  __typename: 'DetectedPest';
  colorCode?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  eppoCode?: Maybe<Scalars['String']['output']>;
  latinName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  referenceImageUrl?: Maybe<Scalars['String']['output']>;
};

export type DetectedWeed = {
  __typename: 'DetectedWeed';
  colorCode?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  eppoCode?: Maybe<Scalars['String']['output']>;
  latinName?: Maybe<Scalars['String']['output']>;
  localName?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  referenceImageUrl?: Maybe<Scalars['String']['output']>;
  taxonomicRank?: Maybe<TaxonomicRank>;
};

export enum DevelopmentStage {
  Adult = 'ADULT',
  Egg = 'EGG',
  FlyingAdult = 'FLYING_ADULT',
  Juvenile = 'JUVENILE',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  Larva = 'LARVA',
  NeanidI = 'NEANID_I',
  NeanidIi = 'NEANID_II',
  NeanidIii = 'NEANID_III',
  NymphIii = 'NYMPH_III',
  NymphIv = 'NYMPH_IV',
  NymphV = 'NYMPH_V',
  ProtoAdult = 'PROTO_ADULT',
  ProtoAndAdult = 'PROTO_AND_ADULT',
  Pupa = 'PUPA',
  Young = 'YOUNG'
}

export type DeviceFeature = {
  __typename: 'DeviceFeature';
  crop?: Maybe<Crop>;
  deviceUuid: Scalars['UUID']['output'];
  name?: Maybe<FeatureName>;
  packageType?: Maybe<PackageType>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export enum DeviceHealthStatus {
  Bad = 'BAD',
  Good = 'GOOD',
  Reasonable = 'REASONABLE',
  Unknown = 'UNKNOWN'
}

export type DevicePackage = {
  __typename: 'DevicePackage';
  creatorId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityType?: Maybe<FarmPackageQuantityType>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<FarmPackageType>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export enum DeviceScope {
  All = 'ALL',
  Consolidated = 'CONSOLIDATED',
  PhysicalOnly = 'PHYSICAL_ONLY',
  VirtualOnly = 'VIRTUAL_ONLY'
}

export type DictcodeFeature = {
  __typename: 'DictcodeFeature';
  characteristicId?: Maybe<Scalars['String']['output']>;
  characteristicName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropStageGroupCode?: Maybe<Scalars['String']['output']>;
  cropStageGroupName?: Maybe<Scalars['String']['output']>;
  cropStageGroupUuid?: Maybe<Scalars['UUID']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pestCode?: Maybe<Scalars['String']['output']>;
  pestName?: Maybe<Scalars['String']['output']>;
  pestUuid?: Maybe<Scalars['UUID']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionUuid?: Maybe<Scalars['UUID']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueCodes?: Maybe<Array<Maybe<ValueCode>>>;
  valueUnitCode?: Maybe<Scalars['String']['output']>;
  valueUnitName?: Maybe<Scalars['String']['output']>;
  valueUnitSiCode?: Maybe<Scalars['String']['output']>;
  valueUnitSiName?: Maybe<Scalars['String']['output']>;
  valueUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  valueUnitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type DictcodeHierarchy = {
  __typename: 'DictcodeHierarchy';
  childDict?: Maybe<Scalars['String']['output']>;
  childDictCode?: Maybe<Scalars['String']['output']>;
  childDictName?: Maybe<Scalars['String']['output']>;
  childDictcodeName?: Maybe<Scalars['String']['output']>;
  childDictcodeUuid?: Maybe<Scalars['UUID']['output']>;
  parentDict?: Maybe<Scalars['String']['output']>;
  parentDictCode?: Maybe<Scalars['String']['output']>;
  parentDictName?: Maybe<Scalars['String']['output']>;
  parentDictcodeName?: Maybe<Scalars['String']['output']>;
  parentDictcodeUuid?: Maybe<Scalars['UUID']['output']>;
};

export type Dictionary = {
  __typename: 'Dictionary';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type DisabledHistory = {
  __typename: 'DisabledHistory';
  endDatetime?: Maybe<Scalars['Date']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  startDatetime?: Maybe<Scalars['Date']['output']>;
};

export type DiseaseIdentificationResult = ScoutingPoiResult & {
  __typename: 'DiseaseIdentificationResult';
  detectedDiseases?: Maybe<Array<Maybe<DetectedDisease>>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  recognizedCropEppoCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ScoutingPoiResultStatus>;
};

export enum DistributorPartner {
  Greenleaf = 'GREENLEAF',
  Xarvio = 'XARVIO'
}

export enum DoseKey {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type DosedMap = {
  __typename: 'DosedMap';
  actionTypes?: Maybe<Array<Maybe<ActionType>>>;
  additives?: Maybe<Array<Maybe<AdditiveRate>>>;
  applicationDepth?: Maybe<Scalars['Float']['output']>;
  applicationMode?: Maybe<ApplicationMode>;
  applicationSpotUuid?: Maybe<Scalars['UUID']['output']>;
  applicationStrategy?: Maybe<ApplicationStrategy>;
  applicationType?: Maybe<ApplicationType>;
  applicationZones?: Maybe<Array<Maybe<ApplicationZone>>>;
  arvalisCustomEfficacyInformation?: Maybe<ArvalisCustomEfficacyInformation>;
  averageTargetRate?: Maybe<Scalars['Float']['output']>;
  averageWaterRate?: Maybe<Scalars['Float']['output']>;
  bufferZones?: Maybe<BufferZones>;
  checksum?: Maybe<Scalars['String']['output']>;
  creationFlowHint?: Maybe<CreationFlowHint>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  doseKey?: Maybe<DoseKey>;
  fieldZones?: Maybe<Array<Maybe<MappingFieldZone>>>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  inhibitorUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  isHighFlow?: Maybe<Scalars['Boolean']['output']>;
  legend?: Maybe<DosedMapLegend>;
  limitationReasons?: Maybe<Array<Maybe<LimitationReason>>>;
  limitedVra?: Maybe<Scalars['Boolean']['output']>;
  lowestZoneExcluded?: Maybe<Scalars['Boolean']['output']>;
  masterVraRates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  nitrificationInhibitorUsed?: Maybe<Scalars['Boolean']['output']>;
  overrideVraRestriction?: Maybe<Scalars['Boolean']['output']>;
  percentageSpread?: Maybe<Scalars['Float']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  productPackUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  rates?: Maybe<Array<Maybe<ProductRate>>>;
  ratesCalculationRequest?: Maybe<RatesCalculationRequest>;
  ratesV2?: Maybe<Array<Maybe<ZoneRateV2>>>;
  recipe?: Maybe<Array<Maybe<ProductApplicationRate>>>;
  recipeV2?: Maybe<Array<Maybe<SubstanceApplicationRate>>>;
  recommendationDate?: Maybe<Scalars['Date']['output']>;
  recommendedNumberOfZones?: Maybe<Scalars['Int']['output']>;
  referenceZoneId?: Maybe<Scalars['String']['output']>;
  restrictFallbackToFlat?: Maybe<Scalars['Boolean']['output']>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  sourceMap?: Maybe<SourceMap>;
  /** @deprecated Use `sourceMap`. */
  sourceMapUuid?: Maybe<Scalars['String']['output']>;
  sprayZones?: Maybe<Array<Maybe<ApplicationCategory>>>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  targetNutrientUuid?: Maybe<Scalars['UUID']['output']>;
  taskMethodUuid?: Maybe<Scalars['UUID']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  totalTargetAmount?: Maybe<Scalars['Float']['output']>;
  treatmentReasons?: Maybe<Array<Maybe<TreatmentReason>>>;
  ureaseInhibitorUsed?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
  waterAverageApplicationRate?: Maybe<Scalars['Float']['output']>;
  waterRates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  waterTotalApplication?: Maybe<Scalars['Float']['output']>;
  weedPressureThreshold?: Maybe<Scalars['Float']['output']>;
  zonePercentageDifferences?: Maybe<Array<Maybe<ZonePercentageDifference>>>;
};


export type DosedMapPreviewArgs = {
  format?: DosedMapPreviewFormat;
};


export type DosedMapSourceMapArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export enum DosedMapEquipmentType {
  Drone = 'DRONE',
  DroneOptimizedBoundary = 'DRONE_OPTIMIZED_BOUNDARY',
  Standard = 'STANDARD'
}

export type DosedMapInput = {
  applicationType: ApplicationType;
  doseKeyOverride?: InputMaybe<DoseKey>;
  isHighFlow?: InputMaybe<Scalars['Boolean']['input']>;
  rates: Array<InputMaybe<ProductRateInput>>;
  sourceMapUuid?: InputMaybe<Scalars['UUID']['input']>;
  waterRates: Array<InputMaybe<Scalars['Float']['input']>>;
};

export type DosedMapLegend = {
  __typename: 'DosedMapLegend';
  applicationType?: Maybe<ApplicationType>;
  dosedMapUuid?: Maybe<Scalars['UUID']['output']>;
  entries?: Maybe<Array<Maybe<DosedMapLegendEntry>>>;
};

export type DosedMapLegendEntry = {
  __typename: 'DosedMapLegendEntry';
  category?: Maybe<ApplicationCategory>;
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export enum DosedMapPreviewFormat {
  Svg = 'SVG'
}

export type DosedMapProductSummary = {
  __typename: 'DosedMapProductSummary';
  formulation?: Maybe<Formulation>;
  totalAreaApplied?: Maybe<Scalars['Float']['output']>;
  totalProductAmount?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<SubstanceType>;
  unit?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type DroneFlight = {
  __typename: 'DroneFlight';
  abLine?: Maybe<AbLine>;
  acceptableStatusChanges?: Maybe<Array<Maybe<DroneFlightStatus>>>;
  algorithmType?: Maybe<AlgorithmType>;
  algorithmTypeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  cancelledDate?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  /** @deprecated Use status related date, e.g. for status PLANNED, the value is plannedDate */
  date?: Maybe<Scalars['Date']['output']>;
  droneFlightOrthomosaics?: Maybe<Array<Maybe<DroneFlightOrthomosaic>>>;
  equipmentType?: Maybe<EquipmentType>;
  equipmentTypeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  errorCode?: Maybe<DroneFlightErrorCode>;
  errors?: Maybe<Array<Maybe<DroneFlightError>>>;
  etag?: Maybe<Scalars['String']['output']>;
  executedDate?: Maybe<Scalars['Date']['output']>;
  flightCode?: Maybe<Scalars['String']['output']>;
  gridSizeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  gridSizes?: Maybe<Array<Maybe<DroneFlightGridSize>>>;
  groundSampleDistance?: Maybe<Scalars['Float']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  mapTypes?: Maybe<Array<Maybe<DroneFlightMapType>>>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  processedDate?: Maybe<Scalars['Date']['output']>;
  processedDeniedQuotaExhaustedDate?: Maybe<Scalars['Date']['output']>;
  processedFailedDate?: Maybe<Scalars['Date']['output']>;
  processingTime?: Maybe<Scalars['Int']['output']>;
  referenceDroneFlightTask?: Maybe<DroneFlight>;
  resubmittedDate?: Maybe<Scalars['Date']['output']>;
  scheduledDate?: Maybe<Scalars['Date']['output']>;
  serviceType?: Maybe<ServiceType>;
  serviceTypeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  status?: Maybe<DroneFlightStatus>;
  statusDescriptionTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  statusTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  uploadPendingDate?: Maybe<Scalars['Date']['output']>;
  uploadedDate?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['UUID']['output'];
  warningCode?: Maybe<WarningCode>;
};

export type DroneFlightError = {
  __typename: 'DroneFlightError';
  errorCode?: Maybe<DroneFlightErrorCode>;
  fileNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum DroneFlightErrorCode {
  CorruptImage = 'CORRUPT_IMAGE',
  CorruptZipFile = 'CORRUPT_ZIP_FILE',
  DuplicatedImage = 'DUPLICATED_IMAGE',
  InvalidFolderStructure = 'INVALID_FOLDER_STRUCTURE',
  InvalidGsd = 'INVALID_GSD',
  InvalidImageFormat = 'INVALID_IMAGE_FORMAT',
  WrongDistanceToField = 'WRONG_DISTANCE_TO_FIELD'
}

export enum DroneFlightGridSize {
  Grid_1X1 = 'GRID_1X1',
  Grid_3X3 = 'GRID_3X3',
  Grid_5X5 = 'GRID_5X5'
}

export enum DroneFlightMapType {
  DronePlantingFailureMap = 'DRONE_PLANTING_FAILURE_MAP',
  VegetationindexMaps = 'VEGETATIONINDEX_MAPS',
  WeedpressureMap = 'WEEDPRESSURE_MAP'
}

export type DroneFlightOrthomosaic = {
  __typename: 'DroneFlightOrthomosaic';
  fileLocation?: Maybe<Scalars['String']['output']>;
  fileLocationOfPreview?: Maybe<Scalars['String']['output']>;
  flightUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type DroneFlightQuota = {
  __typename: 'DroneFlightQuota';
  availableArea?: Maybe<Scalars['Float']['output']>;
  consumedArea?: Maybe<Scalars['Float']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  droneFlightQuotaTransfers?: Maybe<Array<Maybe<DroneFlightQuotaTransfer>>>;
  etag?: Maybe<Scalars['String']['output']>;
  farmV2?: Maybe<FarmV2>;
  lastModified?: Maybe<Scalars['Date']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<ServiceType>;
  uuid: Scalars['UUID']['output'];
};

export type DroneFlightQuotaTransfer = {
  __typename: 'DroneFlightQuotaTransfer';
  area?: Maybe<Scalars['Float']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  sourceDroneFlightQuotaUuid: Scalars['UUID']['output'];
  targetDroneFlightQuotaUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum DroneFlightStatus {
  Cancelled = 'CANCELLED',
  Executed = 'EXECUTED',
  Planned = 'PLANNED',
  Processed = 'PROCESSED',
  ProcessingDeniedQuotaExhausted = 'PROCESSING_DENIED_QUOTA_EXHAUSTED',
  ProcessingFailed = 'PROCESSING_FAILED',
  ReSubmitted = 'RE_SUBMITTED',
  Scheduled = 'SCHEDULED',
  Uploaded = 'UPLOADED',
  UploadPending = 'UPLOAD_PENDING'
}

export type DroneFlightSummary = {
  __typename: 'DroneFlightSummary';
  farmUuid: Scalars['UUID']['output'];
  serviceType: ServiceType;
  status: DroneFlightStatus;
  taskCount: Scalars['Int']['output'];
};

export type DronePlantingFailureMap = {
  __typename: 'DronePlantingFailureMap';
  classBreaks?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  consumedAreaDelta?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  droneFlight?: Maybe<DroneFlight>;
  droneFlightQuota?: Maybe<DroneFlightQuota>;
  etag?: Maybe<Scalars['String']['output']>;
  failureMaps?: Maybe<Array<Maybe<FailureMap>>>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type DroneSprayerWeedMap = {
  __typename: 'DroneSprayerWeedMap';
  consumedAreaDelta?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  droneFlight?: Maybe<DroneFlight>;
  droneFlightQuota?: Maybe<DroneFlightQuota>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  weeds?: Maybe<Array<Maybe<Weed>>>;
};

export type DryMatterAnalysis = {
  __typename: 'DryMatterAnalysis';
  average?: Maybe<Scalars['Float']['output']>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  harvestCondition?: Maybe<HarvestCondition>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<DryMatterAnalysisType>;
};

export enum DryMatterAnalysisType {
  Forecast = 'FORECAST',
  Measured = 'MEASURED'
}

export enum DtnVendor {
  Alsia = 'ALSIA',
  Assam = 'ASSAM',
  Barilla = 'BARILLA',
  Cesens = 'CESENS',
  Davis = 'DAVIS',
  Ikos = 'IKOS',
  Ikostech = 'IKOSTECH',
  Nesa = 'NESA',
  Netsens = 'NETSENS',
  Pessl = 'PESSL',
  Sencrop = 'SENCROP',
  Virtualdevice = 'VIRTUALDEVICE',
  Weenat = 'WEENAT'
}

export type DtnVendorDevice = {
  __typename: 'DtnVendorDevice';
  distanceFromSearchCenter?: Maybe<Scalars['Float']['output']>;
  dtnVendorDeviceToLocations?: Maybe<Array<Maybe<DtnVendorDeviceToLocation>>>;
  dtnVendorDeviceToLocationsV2?: Maybe<Array<Maybe<DtnVendorDeviceToLocationV2>>>;
  dtnVendorLatestMeasurement?: Maybe<DtnVendorDeviceLatestMeasurement>;
  elevation?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** Not supported by the API but hardcoded to UNKNOWN for DTN vendors */
  latitude?: Maybe<Scalars['Float']['output']>;
  locationType?: Maybe<LocationType>;
  locationUuid?: Maybe<Scalars['UUID']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<DtnVendor>;
};

export type DtnVendorDeviceActivation = {
  __typename: 'DtnVendorDeviceActivation';
  creator?: Maybe<User>;
  device: DtnVendorDevice;
  dfFarmPackageUuid: Scalars['UUID']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid: Scalars['UUID']['output'];
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  validFrom: Scalars['Date']['output'];
  validTill: Scalars['Date']['output'];
  vendor?: Maybe<DtnVendor>;
};

export type DtnVendorDeviceLatestMeasurement = {
  __typename: 'DtnVendorDeviceLatestMeasurement';
  device: DtnVendorDevice;
  humidity?: Maybe<Scalars['Float']['output']>;
  locationType?: Maybe<LocationType>;
  locationUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  precipitation?: Maybe<Scalars['Float']['output']>;
  soilMoisture?: Maybe<Scalars['Float']['output']>;
  solarRadiation?: Maybe<Scalars['Float']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<DtnVendor>;
  windDirection?: Maybe<Scalars['String']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
};

export type DtnVendorDeviceToLocation = {
  __typename: 'DtnVendorDeviceToLocation';
  creator?: Maybe<User>;
  device: DtnVendorDevice;
  etag?: Maybe<Scalars['String']['output']>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  locationAccessible?: Maybe<Scalars['Boolean']['output']>;
  locationType: LocationType;
  locationUuid: Scalars['UUID']['output'];
  tillDate?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['UUID']['output'];
  vendor?: Maybe<DtnVendor>;
};

export type DtnVendorDeviceToLocationV2 = {
  __typename: 'DtnVendorDeviceToLocationV2';
  creator?: Maybe<User>;
  device: DtnVendorDevice;
  etag?: Maybe<Scalars['String']['output']>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  locationAccessible?: Maybe<Scalars['Boolean']['output']>;
  locationType: LocationType;
  locationUuid: Scalars['UUID']['output'];
  tillDate?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['UUID']['output'];
  vendor: DtnVendor;
};

export type DtnVendorKey = {
  __typename: 'DtnVendorKey';
  apiKey?: Maybe<Scalars['String']['output']>;
  apiSecret?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  devices?: Maybe<Array<Maybe<DtnVendorKeyDevice>>>;
  etag?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
  vendor?: Maybe<DtnVendor>;
};

export type DtnVendorKeyDevice = {
  __typename: 'DtnVendorKeyDevice';
  deviceId: Scalars['String']['output'];
};

export enum EmailSubscriptionStatus {
  EmailNotVerified = 'EMAIL_NOT_VERIFIED',
  InvalidNoEmail = 'INVALID_NO_EMAIL',
  Ok = 'OK',
  Pending = 'PENDING'
}

export type EmergenceAnalysisImageResult = {
  __typename: 'EmergenceAnalysisImageResult';
  areaMeasured?: Maybe<Scalars['Float']['output']>;
  imageUuid?: Maybe<Scalars['UUID']['output']>;
  numberOfPlants?: Maybe<Scalars['Float']['output']>;
  svgUrl?: Maybe<Scalars['String']['output']>;
};

export type EmergenceAnalysisResult = ScoutingPoiResult & {
  __typename: 'EmergenceAnalysisResult';
  averageNumberOfPlantsPerArea?: Maybe<Scalars['Float']['output']>;
  averageNumberOfPlantsPerImage?: Maybe<Scalars['Float']['output']>;
  imageResults?: Maybe<Array<Maybe<EmergenceAnalysisImageResult>>>;
  status?: Maybe<ScoutingPoiResultStatus>;
};

export type EntityHistory = {
  __typename: 'EntityHistory';
  entityName?: Maybe<Scalars['String']['output']>;
  entityUuid?: Maybe<Scalars['UUID']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  modifications?: Maybe<Array<Maybe<EntityModification>>>;
  modifiedAt?: Maybe<Scalars['Date']['output']>;
  modifiedBy?: Maybe<User>;
};

export type EntityModification = {
  __typename: 'EntityModification';
  fieldName?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
};

export enum EquipmentType {
  DjiAir_2S = 'DJI_AIR_2S',
  DjiMatrice_30 = 'DJI_MATRICE_30',
  DjiMavic_3MEnterprise = 'DJI_MAVIC_3M_ENTERPRISE',
  DjiMavic_3Enterprise = 'DJI_MAVIC_3_ENTERPRISE',
  DjiPhantom_3 = 'DJI_PHANTOM_3',
  DjiPhantom_4 = 'DJI_PHANTOM_4',
  EbeeMicasense = 'EBEE_MICASENSE',
  EbeeSoda = 'EBEE_SODA',
  Others = 'OTHERS'
}

export enum ErrorCode {
  InvalidRegion = 'INVALID_REGION'
}

export type EscalationContact = {
  __typename: 'EscalationContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum EstablishmentMethod {
  DirectSeeding = 'DIRECT_SEEDING',
  DirectSeedingDry = 'DIRECT_SEEDING_DRY',
  DirectSeedingWet = 'DIRECT_SEEDING_WET',
  DirectSeedingWetOxygen = 'DIRECT_SEEDING_WET_OXYGEN',
  MykosDryDirectSeeding = 'MYKOS_DRY_DIRECT_SEEDING',
  Plantcane = 'PLANTCANE',
  Plantmpb = 'PLANTMPB',
  Ratooning = 'RATOONING',
  Sowing = 'SOWING',
  Spreading = 'SPREADING',
  Spreadingrotary = 'SPREADINGROTARY',
  Stripe = 'STRIPE',
  Transplanting = 'TRANSPLANTING'
}

export enum EvidenceExpectedYieldProofType {
  ArcCounty = 'ARC_COUNTY',
  InsurancePolicy = 'INSURANCE_POLICY',
  RmaTransitional = 'RMA_TRANSITIONAL'
}

export type EvidenceFile = {
  __typename: 'EvidenceFile';
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum EvidenceFileSource {
  ClaasConnect = 'CLAAS_CONNECT',
  CnhDevice = 'CNH_DEVICE',
  DkeDevice = 'DKE_DEVICE',
  ExatrekDevice = 'EXATREK_DEVICE',
  JohnDeere = 'JOHN_DEERE',
  Leaf = 'LEAF',
  NevonexDevice = 'NEVONEX_DEVICE',
  OsMdlDevice = 'OS_MDL_DEVICE',
  Panorama = 'PANORAMA',
  SoilSamplingResult = 'SOIL_SAMPLING_RESULT',
  UserUploaded = 'USER_UPLOADED'
}

export type EvidenceFiles = {
  __typename: 'EvidenceFiles';
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
};

export enum EvidenceLivestockType {
  Cattle = 'CATTLE',
  Goat = 'GOAT',
  Other = 'OTHER',
  Pig = 'PIG',
  Poultry = 'POULTRY',
  Sheep = 'SHEEP'
}

export enum EvidenceManagementSystem {
  AnaerobicDigestion = 'ANAEROBIC_DIGESTION',
  Composting = 'COMPOSTING',
  DailySpread = 'DAILY_SPREAD',
  Other = 'OTHER',
  Storage = 'STORAGE'
}

export enum EvidenceManureType {
  DeepBedding = 'DEEP_BEDDING',
  Liquid = 'LIQUID',
  Other = 'OTHER',
  Slurry = 'SLURRY',
  Solid = 'SOLID'
}

export type EvidenceReceipt = {
  __typename: 'EvidenceReceipt';
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ExatrekApplicationMapDispatchOrder = {
  __typename: 'ExatrekApplicationMapDispatchOrder';
  abLineUuid?: Maybe<Scalars['UUID']['output']>;
  dispatchDate?: Maybe<Scalars['Date']['output']>;
  etag: Scalars['String']['output'];
  exportForm?: Maybe<Scalars['String']['output']>;
  format?: Maybe<ExatrekApplicationMapDispatchOrderFormat>;
  includeBoundary?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ExatrekApplicationMapDispatchOrderStatus>;
  taskType?: Maybe<ExatrekApplicationMapDispatchOrderTaskType>;
  taskUuids: Array<Scalars['UUID']['output']>;
  terminalUuid: Scalars['UUID']['output'];
  userDeviceUuid: Scalars['UUID']['output'];
  uuid: Scalars['UUID']['output'];
};

export enum ExatrekApplicationMapDispatchOrderFormat {
  Cn1 = 'CN1',
  Geotiff = 'GEOTIFF',
  Isoxml = 'ISOXML',
  Json = 'JSON',
  Kml = 'KML',
  Shp = 'SHP'
}

export enum ExatrekApplicationMapDispatchOrderStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Uploaded = 'UPLOADED'
}

export enum ExatrekApplicationMapDispatchOrderTaskType {
  Seeding = 'SEEDING',
  Spraying = 'SPRAYING'
}

export type ExatrekDeviceState = {
  __typename: 'ExatrekDeviceState';
  dateCreated?: Maybe<Scalars['Date']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  etag: Scalars['String']['output'];
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['Date']['output']>;
  lastUpdateTime?: Maybe<Scalars['Date']['output']>;
  mac?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<ExatrekDeviceStatePosition>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
  workstate?: Maybe<Scalars['String']['output']>;
};

export type ExatrekDeviceStatePosition = {
  __typename: 'ExatrekDeviceStatePosition';
  altitude?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export enum ExatrekUsbMode {
  Type_1 = 'TYPE_1',
  Type_2 = 'TYPE_2'
}

export type ExatrekUserDevice = {
  __typename: 'ExatrekUserDevice';
  dateCreated?: Maybe<Scalars['Date']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceState?: Maybe<ExatrekDeviceState>;
  etag: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
};

export type ExatrekUserMachine = {
  __typename: 'ExatrekUserMachine';
  etag: Scalars['String']['output'];
  manufacturerUuid: Scalars['UUID']['output'];
  modelUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tcActive?: Maybe<Scalars['Boolean']['output']>;
  tcCompatModeActive?: Maybe<Scalars['Boolean']['output']>;
  typeUuid: Scalars['UUID']['output'];
  usbMode: ExatrekUsbMode;
  userDevice: ExatrekUserDevice;
  uuid: Scalars['UUID']['output'];
};

export enum ExecutionStatus {
  Completed = 'COMPLETED',
  CompletedAdjusted = 'COMPLETED_ADJUSTED',
  NotStarted = 'NOT_STARTED',
  Ongoing = 'ONGOING',
  OngoingAdjusted = 'ONGOING_ADJUSTED',
  Unknown = 'UNKNOWN'
}

export type ExecutionZoneStrategy = {
  __typename: 'ExecutionZoneStrategy';
  adeSavings?: Maybe<Scalars['Float']['output']>;
  adeSprayedArea?: Maybe<Scalars['Float']['output']>;
  adeTotalArea?: Maybe<Scalars['Float']['output']>;
  /**  ZoneStrategy would have been better name but we have already exposed zoneStrategies as child */
  checksum?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  smartSprayerRegistration?: Maybe<SmartSprayerRegistration>;
  startDate?: Maybe<Scalars['Date']['output']>;
  strategy?: Maybe<ZoneSpecificStrategy>;
};

export type ExistingOrder = {
  __typename: 'ExistingOrder';
  affiliateCodeUuid?: Maybe<Scalars['UUID']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<PurchasedLicense>>>;
  magentoOrderId?: Maybe<Scalars['String']['output']>;
  magentoOrderObjectId?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['Date']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  parentExistingOrderUuid?: Maybe<Scalars['UUID']['output']>;
  shopDevicePackages?: Maybe<Array<Maybe<ShopDevicePackage>>>;
  shopFarmPackages?: Maybe<Array<Maybe<ShopFarmPackage>>>;
  shopUserPackages?: Maybe<Array<Maybe<ShopUserPackage>>>;
  state?: Maybe<OrderState>;
  status?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ExportOrder = {
  __typename: 'ExportOrder';
  status?: Maybe<ExportOrderStatus>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum ExportOrderStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type FdlSourceUnion = DosedMap | DroneFlight | FieldDataLayer | SourceMap;

export type FactorLevelFieldZoneMapping = {
  __typename: 'FactorLevelFieldZoneMapping';
  factorLevel: Scalars['Int']['output'];
  fieldZone?: Maybe<FieldZone>;
};

export type FailureMap = {
  __typename: 'FailureMap';
  failureLengthThresholdInCm?: Maybe<Scalars['Int']['output']>;
  statistics?: Maybe<Statistic>;
};

export type Farm = {
  __typename: 'Farm';
  access?: Maybe<Access>;
  billingAddress?: Maybe<Address>;
  creatorUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `features`. */
  farmFeatures?: Maybe<FarmFeatures>;
  features?: Maybe<Array<Maybe<FarmFeature>>>;
  fieldInputPackaging?: Maybe<FieldInputPackaging>;
  /** @deprecated Use `fieldsV2`. */
  fields: Array<Maybe<Field>>;
  fieldsV2: Array<Maybe<FieldV2>>;
  latitude?: Maybe<Scalars['Float']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  shippingAddress?: Maybe<Address>;
  timezone?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type FarmCarbonIntensityIndicator = {
  __typename: 'FarmCarbonIntensityIndicator';
  cropUuid: Scalars['UUID']['output'];
  currentFieldsAverageScore?: Maybe<Scalars['Float']['output']>;
  currentFieldsCropSeasonUuids?: Maybe<Array<Scalars['UUID']['output']>>;
  currentFieldsTotalYield?: Maybe<Scalars['Float']['output']>;
  farmUuid: Scalars['UUID']['output'];
  submittedFieldsAverageScore?: Maybe<Scalars['Float']['output']>;
  submittedFieldsCropSeasonUuids?: Maybe<Array<Scalars['UUID']['output']>>;
  submittedFieldsTotalYield?: Maybe<Scalars['Float']['output']>;
  sustainabilityProgramUuid: Scalars['UUID']['output'];
  year: Scalars['Int']['output'];
};

export type FarmCountryCropGrowthStagePredictions = {
  __typename: 'FarmCountryCropGrowthStagePredictions';
  farm?: Maybe<FarmV2>;
  growthStages?: Maybe<Array<Maybe<CountryCropGrowthStagePrediction>>>;
};

export type FarmCropMetrics = {
  __typename: 'FarmCropMetrics';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  crop?: Maybe<Crop>;
  farm?: Maybe<FarmV2>;
  totalActiveCropSeasonArea?: Maybe<Scalars['Float']['output']>;
};

export type FarmDataLayer = {
  __typename: 'FarmDataLayer';
  legend?: Maybe<FarmDataLayerLegend>;
  magnitude?: Maybe<MagnitudeType>;
  parameters?: Maybe<WmsParameters>;
  type?: Maybe<FieldDataLayerType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FarmDataLayerLegend = {
  __typename: 'FarmDataLayerLegend';
  entries?: Maybe<Array<Maybe<LegendEntry>>>;
  legendType?: Maybe<LegendType>;
  unit?: Maybe<MagnitudeUnit>;
  unitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type FarmEvidence = {
  __typename: 'FarmEvidence';
  averageCiScore?: Maybe<FarmEvidenceAverageCiScore>;
  links?: Maybe<FarmEvidenceLinks>;
  program?: Maybe<FarmEvidenceProgram>;
  records?: Maybe<FarmEvidenceRecords>;
};

export type FarmEvidenceAcceptedTerm = {
  __typename: 'FarmEvidenceAcceptedTerm';
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  termsUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FarmEvidenceAcceptedTerms = {
  __typename: 'FarmEvidenceAcceptedTerms';
  items?: Maybe<Array<Maybe<FarmEvidenceAcceptedTerm>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FarmEvidenceAgExpertStatement = {
  __typename: 'FarmEvidenceAgExpertStatement';
  certificationName?: Maybe<Scalars['String']['output']>;
  certificationNumber?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  termsUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FarmEvidenceAgExpertStatements = {
  __typename: 'FarmEvidenceAgExpertStatements';
  items?: Maybe<Array<Maybe<FarmEvidenceAgExpertStatement>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FarmEvidenceAudit = {
  __typename: 'FarmEvidenceAudit';
  auditDate?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FarmEvidenceAudits = {
  __typename: 'FarmEvidenceAudits';
  items?: Maybe<Array<Maybe<FarmEvidenceAudit>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FarmEvidenceAverageCiScore = {
  __typename: 'FarmEvidenceAverageCiScore';
  crops?: Maybe<Array<Maybe<FarmEvidenceCropScore>>>;
};

export type FarmEvidenceCertification = {
  __typename: 'FarmEvidenceCertification';
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FarmEvidenceCertifications = {
  __typename: 'FarmEvidenceCertifications';
  items?: Maybe<Array<Maybe<FarmEvidenceCertification>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FarmEvidenceCropScore = {
  __typename: 'FarmEvidenceCropScore';
  averageCiScore?: Maybe<Scalars['Float']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  scoreUnit?: Maybe<Scalars['String']['output']>;
};

export type FarmEvidenceFieldBuckets = {
  __typename: 'FarmEvidenceFieldBuckets';
  complete?: Maybe<Array<Maybe<FarmEvidenceFieldCount>>>;
  open?: Maybe<Array<Maybe<FarmEvidenceFieldCount>>>;
  total?: Maybe<Array<Maybe<FarmEvidenceFieldCount>>>;
  withVerifier?: Maybe<Array<Maybe<FarmEvidenceFieldCount>>>;
};

export type FarmEvidenceFieldCount = {
  __typename: 'FarmEvidenceFieldCount';
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  missing?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Int']['output']>;
};

export type FarmEvidenceLink = BaseEntityAuditingType & {
  __typename: 'FarmEvidenceLink';
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<FarmEvidenceLinkRecordType>;
  recordUuid?: Maybe<Scalars['UUID']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  removedAt?: Maybe<Scalars['String']['output']>;
  removedBy?: Maybe<Scalars['String']['output']>;
  sustainabilityProgramUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum FarmEvidenceLinkRecordType {
  AcceptedTerms = 'ACCEPTED_TERMS',
  AgExpertStatement = 'AG_EXPERT_STATEMENT',
  Certification = 'CERTIFICATION',
  ManureSource = 'MANURE_SOURCE',
  PriorAudit = 'PRIOR_AUDIT'
}

export type FarmEvidenceLinkSort = {
  column: FarmEvidenceLinkSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum FarmEvidenceLinkSortColumn {
  DateCreated = 'DATE_CREATED',
  LastUpdated = 'LAST_UPDATED',
  RecordType = 'RECORD_TYPE',
  RecordUuid = 'RECORD_UUID',
  RemovedAt = 'REMOVED_AT'
}

export type FarmEvidenceLinks = {
  __typename: 'FarmEvidenceLinks';
  agExpertStatements?: Maybe<FarmEvidenceAgExpertStatements>;
  audits?: Maybe<FarmEvidenceAudits>;
  certifications?: Maybe<FarmEvidenceCertifications>;
  manureSources?: Maybe<FarmEvidenceManureSources>;
};

export type FarmEvidenceManureSource = {
  __typename: 'FarmEvidenceManureSource';
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  livestockType?: Maybe<EvidenceLivestockType>;
  managementSystem?: Maybe<EvidenceManagementSystem>;
  manureType?: Maybe<EvidenceManureType>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FarmEvidenceManureSources = {
  __typename: 'FarmEvidenceManureSources';
  items?: Maybe<Array<Maybe<FarmEvidenceManureSource>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FarmEvidenceProgram = {
  __typename: 'FarmEvidenceProgram';
  name?: Maybe<Scalars['String']['output']>;
  reportDue?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FarmEvidenceRecords = {
  __typename: 'FarmEvidenceRecords';
  acceptedTerms?: Maybe<FarmEvidenceAcceptedTerms>;
  fields?: Maybe<FarmEvidenceFieldBuckets>;
  state?: Maybe<FarmEvidenceRecordsState>;
};

export enum FarmEvidenceRecordsState {
  Complete = 'COMPLETE',
  Open = 'OPEN'
}

export type FarmFeature = {
  __typename: 'FarmFeature';
  crop?: Maybe<Crop>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<FeatureName>;
  needsActivation?: Maybe<Scalars['Boolean']['output']>;
  packageType?: Maybe<PackageType>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type FarmFeatures = {
  __typename: 'FarmFeatures';
  farmUuid: Scalars['UUID']['output'];
  freeOfCharge?: Maybe<Scalars['Boolean']['output']>;
  mapping?: Maybe<FarmFeaturesStatus>;
  mappingUuid?: Maybe<Scalars['UUID']['output']>;
  mappingValidTill?: Maybe<Scalars['Date']['output']>;
  timing?: Maybe<FarmFeaturesStatus>;
  timingUuid?: Maybe<Scalars['UUID']['output']>;
  timingValidTill?: Maybe<Scalars['Date']['output']>;
};

export enum FarmFeaturesStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type FarmFeaturesSummary = {
  __typename: 'FarmFeaturesSummary';
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  farm: FarmV2;
  featureName: FeatureName;
  fieldCount: Scalars['Int']['output'];
};

export type FarmGreetCarbonIntensityScore = {
  __typename: 'FarmGreetCarbonIntensityScore';
  /**  Identifiers */
  cropUuid: Scalars['UUID']['output'];
  /**  Carbon intensity scores */
  currentFieldsAverageScore?: Maybe<Scalars['Float']['output']>;
  /**  Crop season UUIDs */
  currentFieldsCropSeasonUuids?: Maybe<Array<Scalars['UUID']['output']>>;
  /**  Yield metrics */
  currentFieldsTotalYield?: Maybe<Scalars['Float']['output']>;
  farmUuid: Scalars['UUID']['output'];
  /**  Metadata */
  scoreUnit?: Maybe<Scalars['String']['output']>;
  submittedFieldsAverageScore?: Maybe<Scalars['Float']['output']>;
  submittedFieldsCropSeasonUuids?: Maybe<Array<Scalars['UUID']['output']>>;
  submittedFieldsTotalYield?: Maybe<Scalars['Float']['output']>;
  sustainabilityProgramUuid: Scalars['UUID']['output'];
  year: Scalars['Int']['output'];
};

export type FarmLayerSummaryCount = {
  __typename: 'FarmLayerSummaryCount';
  count?: Maybe<Scalars['Int']['output']>;
  sourceType?: Maybe<FieldDataLayerSourceType>;
  type?: Maybe<FieldDataLayerType>;
};

export type FarmPackage = {
  __typename: 'FarmPackage';
  creatorId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid: Scalars['UUID']['output'];
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsActivation?: Maybe<Scalars['Boolean']['output']>;
  packageUuid: Scalars['UUID']['output'];
  purchaseDate?: Maybe<Scalars['Date']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityLeft?: Maybe<Scalars['Float']['output']>;
  quantityType?: Maybe<FarmPackageQuantityType>;
  sourceType: FarmPackageSourceType;
  sourceUuid: Scalars['UUID']['output'];
  subscription?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<FarmPackageType>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type FarmPackageConsumption = {
  __typename: 'FarmPackageConsumption';
  consumptionDate?: Maybe<Scalars['Date']['output']>;
  farmPackage: FarmPackage;
  quantityConsumed?: Maybe<Scalars['Float']['output']>;
  totalQuantityRequired?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum FarmPackageQuantityType {
  Area = 'AREA',
  FieldCount = 'FIELD_COUNT',
  WeatherStationCount = 'WEATHER_STATION_COUNT'
}

export enum FarmPackageSourceType {
  CpLicenseRequest = 'CP_LICENSE_REQUEST',
  DroneFlightQuota = 'DRONE_FLIGHT_QUOTA',
  FarmDefaultPackage = 'FARM_DEFAULT_PACKAGE',
  FarmPackage = 'FARM_PACKAGE',
  HfRequest = 'HF_REQUEST',
  HfRequestAddOn = 'HF_REQUEST_ADD_ON',
  Legacy = 'LEGACY',
  TrialSubscription = 'TRIAL_SUBSCRIPTION',
  UserFarmPackage = 'USER_FARM_PACKAGE'
}

export enum FarmPackageType {
  Activation = 'ACTIVATION',
  Foc = 'FOC',
  Regular = 'REGULAR',
  Tech = 'TECH',
  Test = 'TEST'
}

/** A purchase or work document stored on a farm, linked from activities through farm receipt references. */
export type FarmReceipt = {
  __typename: 'FarmReceipt';
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid: Scalars['UUID']['output'];
  farmV2: FarmV2;
  fileBatchUuid: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  receiptKind: Array<FarmReceiptKind>;
  uuid: Scalars['UUID']['output'];
};

export enum FarmReceiptKind {
  ContractWork = 'CONTRACT_WORK',
  CropProtection = 'CROP_PROTECTION',
  Nutrition = 'NUTRITION',
  Other = 'OTHER',
  Seed = 'SEED',
  SoilAnalysis = 'SOIL_ANALYSIS',
  WellPurchase = 'WELL_PURCHASE'
}

/** A link between a farm receipt and a domain object such as a seeding or spraying task. */
export type FarmReceiptReference = {
  __typename: 'FarmReceiptReference';
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  objectType: FarmReceiptReferenceObjectType;
  objectUuid: Scalars['UUID']['output'];
  receiptUuid: Scalars['UUID']['output'];
  uuid: Scalars['UUID']['output'];
};

export enum FarmReceiptReferenceObjectType {
  CoverCropActivity = 'COVER_CROP_ACTIVITY',
  CropProtectionTask = 'CROP_PROTECTION_TASK',
  NutritionTask = 'NUTRITION_TASK',
  SeedingTask = 'SEEDING_TASK'
}

export enum FarmType {
  Farm = 'FARM',
  GreenhouseCluster = 'GREENHOUSE_CLUSTER',
  Orchard = 'ORCHARD',
  Vineyard = 'VINEYARD'
}

export type FarmUuid = {
  __typename: 'FarmUuid';
  uuid: Scalars['UUID']['output'];
};

export type FarmV2 = {
  __typename: 'FarmV2';
  billingAddress?: Maybe<Address>;
  collaborators?: Maybe<Array<Maybe<Collaborator>>>;
  countrySecondLevelSubDivision?: Maybe<Scalars['String']['output']>;
  countrySubDivision?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `owner` instead. */
  creator?: Maybe<User>;
  /** @deprecated Use `creator`. */
  creatorId?: Maybe<Scalars['String']['output']>;
  cropNutritionReportConfiguration?: Maybe<CropNutritionReportConfiguration>;
  cropSeasonStatusReportEmailSubscriptions?: Maybe<Array<Maybe<CropSeasonStatusReportEmailSubscription>>>;
  currentUserPermission?: Maybe<Permission>;
  droneFlightQuotas?: Maybe<Array<Maybe<DroneFlightQuota>>>;
  energyConsumptionRateDiesel?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateElectricity?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateGasoline?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateLiquefiedPetroleumGas?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateNaturalGas?: Maybe<Scalars['Float']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  existingOrders?: Maybe<Array<Maybe<ExistingOrder>>>;
  farmActiveGrowthStages?: Maybe<FarmCountryCropGrowthStagePredictions>;
  farmType?: Maybe<FarmType>;
  features?: Maybe<Array<Maybe<FarmFeature>>>;
  fieldInputPackaging?: Maybe<FieldInputPackaging>;
  fieldSummary?: Maybe<FieldSummary>;
  fieldsV2?: Maybe<Array<FieldV2>>;
  grower?: Maybe<Collaborator>;
  hfAlerts?: Maybe<Array<Maybe<HfAlert>>>;
  hfDiscounts?: Maybe<Array<Maybe<HfDiscount>>>;
  hfServiceRequests?: Maybe<Array<Maybe<HfServiceRequest>>>;
  importOrders?: Maybe<Array<Maybe<ImportOrder>>>;
  /** @deprecated Combined usage is not possible for farm. */
  isCombinedUsageType?: Maybe<Scalars['Boolean']['output']>;
  isMyFarm: Scalars['Boolean']['output'];
  jdNotificationSubscriptions?: Maybe<Array<Maybe<JdNotificationSubscription>>>;
  kwsConsent?: Maybe<KwsConsent>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  latestScoutingTask?: Maybe<ScoutingTask>;
  latitude?: Maybe<Scalars['Float']['output']>;
  legalCode?: Maybe<Scalars['String']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<User>;
  packages?: Maybe<Array<FarmPackage>>;
  recentlyUsedProducts?: Maybe<Array<Maybe<RecentlyUsedProduct>>>;
  shippingAddress?: Maybe<Address>;
  /** @deprecated Use farmType instead. */
  specialisedUsageType?: Maybe<SpecialisedUsageType>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantUuid?: Maybe<Scalars['UUID']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  treatmentScenarios?: Maybe<Array<Maybe<TreatmentScenario>>>;
  uuid: Scalars['UUID']['output'];
  /** @deprecated Use `WeatherV2`. */
  weather?: Maybe<Array<Maybe<Weather>>>;
  weatherV2?: Maybe<Array<Maybe<WeatherV2>>>;
};


export type FarmV2FarmActiveGrowthStagesArgs = {
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type FarmV2FieldsV2Args = {
  lastUpdatedFrom?: InputMaybe<Scalars['Date']['input']>;
};


export type FarmV2LatestScoutingTaskArgs = {
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type FarmV2PackagesArgs = {
  historicalItems?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FarmV2RecentlyUsedProductsArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  productCategoryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskTypes?: InputMaybe<Array<InputMaybe<TaskType>>>;
};


export type FarmV2WeatherArgs = {
  format?: InputMaybe<WeatherFormat>;
  fromDate: Scalars['Date']['input'];
  provider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<Array<InputMaybe<WeatherType>>>;
};


export type FarmV2WeatherV2Args = {
  excludeProvider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  format?: InputMaybe<WeatherFormat>;
  fromDate: Scalars['Date']['input'];
  provider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<Array<InputMaybe<WeatherType>>>;
};

export enum FeatureName {
  AdvisorExpertView = 'ADVISOR_EXPERT_VIEW',
  AgBalance = 'AG_BALANCE',
  AgDashboard = 'AG_DASHBOARD',
  ApplicationMapCustomization = 'APPLICATION_MAP_CUSTOMIZATION',
  BufferZone = 'BUFFER_ZONE',
  CarbonFarming = 'CARBON_FARMING',
  CropEstablishmentVra = 'CROP_ESTABLISHMENT_VRA',
  CropProtectionVra = 'CROP_PROTECTION_VRA',
  CropSeason = 'CROP_SEASON',
  CrossFarmDashboard = 'CROSS_FARM_DASHBOARD',
  CustomHerbicideVra = 'CUSTOM_HERBICIDE_VRA',
  DeviceLicense = 'DEVICE_LICENSE',
  DroneFlight = 'DRONE_FLIGHT',
  DroneFlightGob = 'DRONE_FLIGHT_GOB',
  ExpertScoutingTrip = 'EXPERT_SCOUTING_TRIP',
  ExpertView = 'EXPERT_VIEW',
  ExpertWeather = 'EXPERT_WEATHER',
  FarmFarm = 'FARM_FARM',
  FdlAnalyticsCollection = 'FDL_ANALYTICS_COLLECTION',
  FdlAnalyticsPro = 'FDL_ANALYTICS_PRO',
  FdlMachineDataUpload = 'FDL_MACHINE_DATA_UPLOAD',
  FieldManagement = 'FIELD_MANAGEMENT',
  FieldNotes = 'FIELD_NOTES',
  FieldVariability = 'FIELD_VARIABILITY',
  FieldVariabilityInSeason = 'FIELD_VARIABILITY_IN_SEASON',
  GreenhouseClusterFarm = 'GREENHOUSE_CLUSTER_FARM',
  GrowthStage = 'GROWTH_STAGE',
  HerbicideRecommendation = 'HERBICIDE_RECOMMENDATION',
  HerbicideTiming = 'HERBICIDE_TIMING',
  Imagery = 'IMAGERY',
  ImageryCustomPowerzone = 'IMAGERY_CUSTOM_POWERZONE',
  ImageryFieldStatus = 'IMAGERY_FIELD_STATUS',
  ImageryFreshBiomass = 'IMAGERY_FRESH_BIOMASS',
  ImageryMonitoring = 'IMAGERY_MONITORING',
  ImageryNematodePowerzone = 'IMAGERY_NEMATODE_POWERZONE',
  ImageryPlanetScopeBiomassLai = 'IMAGERY_PLANET_SCOPE_BIOMASS_LAI',
  ImageryPowerzone = 'IMAGERY_POWERZONE',
  ImageryPowerzoneSeedingRecommendation = 'IMAGERY_POWERZONE_SEEDING_RECOMMENDATION',
  ImageryTrueColor = 'IMAGERY_TRUE_COLOR',
  ImageryWeedPressure = 'IMAGERY_WEED_PRESSURE',
  ImageryWeedZoneSprayFieldIdentifier = 'IMAGERY_WEED_ZONE_SPRAY_FIELD_IDENTIFIER',
  InsectTiming = 'INSECT_TIMING',
  Mapping = 'MAPPING',
  MapDownload = 'MAP_DOWNLOAD',
  MapFusion = 'MAP_FUSION',
  NavigateToPoi = 'NAVIGATE_TO_POI',
  Nutrition = 'NUTRITION',
  NutritionProgram = 'NUTRITION_PROGRAM',
  NutritionVra = 'NUTRITION_VRA',
  OrchardFarm = 'ORCHARD_FARM',
  PersonalOrganisation = 'PERSONAL_ORGANISATION',
  PowerzoneVra = 'POWERZONE_VRA',
  PrecifieldMap = 'PRECIFIELD_MAP',
  ProductRecommendation = 'PRODUCT_RECOMMENDATION',
  PzVraAdvisorSeeding = 'PZ_VRA_ADVISOR_SEEDING',
  Reports = 'REPORTS',
  ResidualActivation = 'RESIDUAL_ACTIVATION',
  SeedingRecommendation = 'SEEDING_RECOMMENDATION',
  SmartSpraying = 'SMART_SPRAYING',
  SmartSprayingAde = 'SMART_SPRAYING_ADE',
  SoilSampling = 'SOIL_SAMPLING',
  Task = 'TASK',
  TaskCropEstablishment = 'TASK_CROP_ESTABLISHMENT',
  TaskCropProtection = 'TASK_CROP_PROTECTION',
  TaskGreenhouseWhitening = 'TASK_GREENHOUSE_WHITENING',
  TaskHarvest = 'TASK_HARVEST',
  TaskLandPreparation = 'TASK_LAND_PREPARATION',
  TaskLeafPruning = 'TASK_LEAF_PRUNING',
  TaskNutrition = 'TASK_NUTRITION',
  TaskObservation = 'TASK_OBSERVATION',
  TaskScouting = 'TASK_SCOUTING',
  TaskSeedboxTreatment = 'TASK_SEEDBOX_TREATMENT',
  TaskSeedTreatment = 'TASK_SEED_TREATMENT',
  TaskTopping = 'TASK_TOPPING',
  TaskWaterManagement = 'TASK_WATER_MANAGEMENT',
  TaskWeedManagement = 'TASK_WEED_MANAGEMENT',
  Timing = 'TIMING',
  TimingWaterContent = 'TIMING_WATER_CONTENT',
  UnlimitedDroneFlight = 'UNLIMITED_DRONE_FLIGHT',
  VarietyRecommendation = 'VARIETY_RECOMMENDATION',
  VarietyRecommendationManagement = 'VARIETY_RECOMMENDATION_MANAGEMENT',
  VineyardFarm = 'VINEYARD_FARM',
  VraAdvisorCropProtection = 'VRA_ADVISOR_CROP_PROTECTION',
  VraAdvisorNutrition = 'VRA_ADVISOR_NUTRITION',
  VraAdvisorSeeding = 'VRA_ADVISOR_SEEDING',
  WaterBalance = 'WATER_BALANCE',
  WaterManagementTiming = 'WATER_MANAGEMENT_TIMING',
  WeedRisk = 'WEED_RISK',
  YieldPrediction = 'YIELD_PREDICTION'
}

export type Field = {
  __typename: 'Field';
  area: Scalars['Float']['output'];
  boundarySvg?: Maybe<Scalars['String']['output']>;
  cropSeasons?: Maybe<Array<Maybe<CropSeason>>>;
  /** @deprecated Use `farmV2`. */
  farm?: Maybe<Farm>;
  fieldDataLayers?: Maybe<Array<Maybe<FieldDataLayer>>>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  soilTaxonomy?: Maybe<SoilTaxonomy>;
  soilTexture?: Maybe<SoilTexture>;
  /**  The type and provider parameters can be provided as a list instead of just a string */
  sprayWeather?: Maybe<Array<Maybe<SprayWeather>>>;
  uuid: Scalars['UUID']['output'];
  weather?: Maybe<Array<Maybe<Weather>>>;
};


export type FieldCropSeasonsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lifecycleState?: InputMaybe<Array<InputMaybe<LifecycleState>>>;
};


export type FieldSprayWeatherArgs = {
  fromDate: Scalars['Date']['input'];
  modelUuid?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['Date']['input'];
};


export type FieldWeatherArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FieldActivation = {
  __typename: 'FieldActivation';
  createdAt?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmPackageConsumptions?: Maybe<Array<Maybe<FarmPackageConsumption>>>;
  fieldUuid: Scalars['UUID']['output'];
  package: Package;
  quantityConsumed?: Maybe<Scalars['Float']['output']>;
  quantityPending?: Maybe<Scalars['Float']['output']>;
  status: FieldActivationStatus;
  uuid: Scalars['UUID']['output'];
  validTill?: Maybe<Scalars['Date']['output']>;
};

export enum FieldActivationStatus {
  Activated = 'ACTIVATED',
  Expired = 'EXPIRED',
  FieldDeleted = 'FIELD_DELETED',
  Pending = 'PENDING',
  UnpaidModified = 'UNPAID_MODIFIED'
}

export type FieldBoundaryLookupScore = {
  __typename: 'FieldBoundaryLookupScore';
  farm?: Maybe<FarmV2>;
  field?: Maybe<FieldV2>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type FieldDataDataMapping = {
  __typename: 'FieldDataDataMapping';
  columnIndex?: Maybe<Scalars['Int']['output']>;
  columnName?: Maybe<Scalars['String']['output']>;
  measurement?: Maybe<FieldDataMeasurement>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type FieldDataLayer = {
  __typename: 'FieldDataLayer';
  applicationTypes?: Maybe<Array<Maybe<FieldDataUploadApplicationType>>>;
  /**  acquisition or creation date */
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `source` */
  droneFlight?: Maybe<DroneFlight>;
  /** @deprecated Use `fieldV2`. */
  field?: Maybe<Field>;
  fieldDataLayerLegends?: Maybe<Array<Maybe<FieldDataLayerLegend>>>;
  fieldDataLayerStatistics?: Maybe<Array<Maybe<FieldDataLayerStatistics>>>;
  fieldV2?: Maybe<FieldV2>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  magnitudeStrategy?: Maybe<MagnitudeStrategy>;
  magnitudes?: Maybe<Array<Maybe<Magnitude>>>;
  mbTilesUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<FdlSourceUnion>;
  sourceDescription?: Maybe<FieldDataLayerSourceProperty>;
  sourceType?: Maybe<FieldDataLayerSourceType>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  taskType?: Maybe<TaskType>;
  taskUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<FieldDataLayerType>;
  typeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  uuid: Scalars['UUID']['output'];
  vectorTilesStyleUrl?: Maybe<Scalars['String']['output']>;
  vectorTilesUrl?: Maybe<Scalars['String']['output']>;
  wmsParameters?: Maybe<WmsParameters>;
  wmsUrl?: Maybe<Scalars['String']['output']>;
};


export type FieldDataLayerFieldDataLayerLegendsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  magnitudes?: InputMaybe<Array<InputMaybe<MagnitudeType>>>;
};


export type FieldDataLayerFieldDataLayerStatisticsArgs = {
  magnitudes?: InputMaybe<Array<InputMaybe<MagnitudeType>>>;
};

export type FieldDataLayerClassification = {
  __typename: 'FieldDataLayerClassification';
  checksum?: Maybe<Scalars['String']['output']>;
  classificationEntries?: Maybe<Array<Maybe<FieldDataLayerClassificationEntry>>>;
  classificationType?: Maybe<LegendType>;
  elevation?: Maybe<Scalars['String']['output']>;
  fieldDataLayerUuid: Scalars['UUID']['output'];
  magnitudeType?: Maybe<MagnitudeType>;
  maxElevation?: Maybe<Scalars['Float']['output']>;
  minElevation?: Maybe<Scalars['Float']['output']>;
  processingType?: Maybe<ProcessingType>;
  unit?: Maybe<MagnitudeUnit>;
  unitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldDataLayerClassificationEntry = {
  __typename: 'FieldDataLayerClassificationEntry';
  area?: Maybe<Scalars['Float']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  featureId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type FieldDataLayerLegend = {
  __typename: 'FieldDataLayerLegend';
  checksum?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<Maybe<LegendEntry>>>;
  fieldDataLayer?: Maybe<FieldDataLayer>;
  fieldDataLayerUuid: Scalars['UUID']['output'];
  legendType?: Maybe<LegendType>;
  /** @deprecated Use `magnitudeType` */
  magnitude?: Maybe<MagnitudeType>;
  magnitudeType?: Maybe<MagnitudeType>;
  maxElevation?: Maybe<Scalars['Float']['output']>;
  minElevation?: Maybe<Scalars['Float']['output']>;
  processingType?: Maybe<ProcessingType>;
  unit?: Maybe<MagnitudeUnit>;
  unitUuid?: Maybe<Scalars['UUID']['output']>;
};


export type FieldDataLayerLegendFieldDataLayerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FieldDataLayerSort = {
  column: FieldDataLayerSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum FieldDataLayerSortColumn {
  CreatedAt = 'CREATED_AT',
  CropName = 'CROP_NAME',
  Date = 'DATE',
  FarmName = 'FARM_NAME',
  FieldName = 'FIELD_NAME',
  SourceType = 'SOURCE_TYPE',
  TaskType = 'TASK_TYPE',
  Type = 'TYPE'
}

export type FieldDataLayerSourceProperty = {
  __typename: 'FieldDataLayerSourceProperty';
  cloudCover?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<FieldDataLayerSourceProvider>;
  weeds?: Maybe<Array<Maybe<Weed>>>;
};

export enum FieldDataLayerSourceProvider {
  Airbus = 'AIRBUS',
  Esa = 'ESA',
  Planet = 'PLANET'
}

export enum FieldDataLayerSourceType {
  Analysis = 'ANALYSIS',
  BiomassAnalysis = 'BIOMASS_ANALYSIS',
  BiomassMonitoringAnalysis = 'BIOMASS_MONITORING_ANALYSIS',
  BiomassMonitoringVectorAnalysis = 'BIOMASS_MONITORING_VECTOR_ANALYSIS',
  BiomassProxyV4 = 'BIOMASS_PROXY_V4',
  CustomPowerzone = 'CUSTOM_POWERZONE',
  DosedMap = 'DOSED_MAP',
  DroneFlight = 'DRONE_FLIGHT',
  FieldDataLayer = 'FIELD_DATA_LAYER',
  FieldVariability = 'FIELD_VARIABILITY',
  FreshBiomassAnalysis = 'FRESH_BIOMASS_ANALYSIS',
  GlobalSoilGrid = 'GLOBAL_SOIL_GRID',
  KwsDryMatterAnalysis = 'KWS_DRY_MATTER_ANALYSIS',
  MultiImageBiomassAnalysis = 'MULTI_IMAGE_BIOMASS_ANALYSIS',
  NdviAnalysis = 'NDVI_ANALYSIS',
  NematodePowerzone = 'NEMATODE_POWERZONE',
  PlanetScope = 'PLANET_SCOPE',
  PrecifieldBiomass = 'PRECIFIELD_BIOMASS',
  PrecifieldNitrogenPrescription = 'PRECIFIELD_NITROGEN_PRESCRIPTION',
  SatImage = 'SAT_IMAGE',
  SeedSelectVrsMap = 'SEED_SELECT_VRS_MAP',
  SmartSprayingExecution = 'SMART_SPRAYING_EXECUTION',
  SmartSprayingTask = 'SMART_SPRAYING_TASK',
  SoilNaro = 'SOIL_NARO',
  SoilSamplingPowerzoneAnalysis = 'SOIL_SAMPLING_POWERZONE_ANALYSIS',
  SoilSsurgo = 'SOIL_SSURGO',
  SourceMap = 'SOURCE_MAP',
  StacBiomassSentinel_2 = 'STAC_BIOMASS_SENTINEL_2',
  StacCustomPowerzone = 'STAC_CUSTOM_POWERZONE',
  StacItemBiomassSentinel_2 = 'STAC_ITEM_BIOMASS_SENTINEL_2',
  StacItemBp = 'STAC_ITEM_BP',
  StacItemBpLai = 'STAC_ITEM_BP_LAI',
  StacItemCustomPowerzone = 'STAC_ITEM_CUSTOM_POWERZONE',
  StacItemLai = 'STAC_ITEM_LAI',
  StacItemNdvi = 'STAC_ITEM_NDVI',
  /** @deprecated Use STAC_ITEM_WEED_PRESSURE instead. */
  StacItemNdviWeedPressure = 'STAC_ITEM_NDVI_WEED_PRESSURE',
  StacItemNematodePowerzone = 'STAC_ITEM_NEMATODE_POWERZONE',
  StacItemPowerzoneData = 'STAC_ITEM_POWERZONE_DATA',
  StacItemSoilSamplingPowerzone = 'STAC_ITEM_SOIL_SAMPLING_POWERZONE',
  StacItemWeedPressure = 'STAC_ITEM_WEED_PRESSURE',
  StacPowerzone = 'STAC_POWERZONE',
  StacSoilSamplingPowerzone = 'STAC_SOIL_SAMPLING_POWERZONE',
  Topography = 'TOPOGRAPHY',
  TrueColorAnalysis = 'TRUE_COLOR_ANALYSIS',
  Upload = 'UPLOAD',
  UploadDatasetGroup = 'UPLOAD_DATASET_GROUP'
}

export type FieldDataLayerStatistics = {
  __typename: 'FieldDataLayerStatistics';
  average?: Maybe<Scalars['Float']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  fieldDataLayerUuid?: Maybe<Scalars['UUID']['output']>;
  magnitudeType?: Maybe<MagnitudeType>;
  max?: Maybe<Scalars['Float']['output']>;
  maxElevation?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  minElevation?: Maybe<Scalars['Float']['output']>;
  processingType?: Maybe<ProcessingType>;
  regionId?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<MagnitudeUnit>;
  unitUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum FieldDataLayerTaskType {
  CropEstablishment = 'CROP_ESTABLISHMENT',
  SmartSprayingTask = 'SMART_SPRAYING_TASK',
  Spraying = 'SPRAYING'
}

export enum FieldDataLayerType {
  Application = 'APPLICATION',
  ApplicationEfficacy = 'APPLICATION_EFFICACY',
  BiomassMonitoringAnalysis = 'BIOMASS_MONITORING_ANALYSIS',
  BiomassMonitoringVectorAnalysis = 'BIOMASS_MONITORING_VECTOR_ANALYSIS',
  BiomassMultiImage = 'BIOMASS_MULTI_IMAGE',
  BiomassMultiImageLai = 'BIOMASS_MULTI_IMAGE_LAI',
  BiomassNdvi = 'BIOMASS_NDVI',
  BiomassProxyMonitoringVectorAnalysis = 'BIOMASS_PROXY_MONITORING_VECTOR_ANALYSIS',
  BiomassSingleImage = 'BIOMASS_SINGLE_IMAGE',
  BiomassSingleImageLai = 'BIOMASS_SINGLE_IMAGE_LAI',
  BiomassSingleImageNdviFieldAverage = 'BIOMASS_SINGLE_IMAGE_NDVI_FIELD_AVERAGE',
  CropCoverage = 'CROP_COVERAGE',
  CustomNematodeSourceMap = 'CUSTOM_NEMATODE_SOURCE_MAP',
  CustomNutrientDerivedThresholdBoron = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_BORON',
  CustomNutrientDerivedThresholdGypsum = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_GYPSUM',
  CustomNutrientDerivedThresholdLime = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_LIME',
  CustomNutrientDerivedThresholdPhosphorus = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_PHOSPHORUS',
  CustomNutrientDerivedThresholdPotassium = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_POTASSIUM',
  CustomPowerzone = 'CUSTOM_POWERZONE',
  CustomSourceMap = 'CUSTOM_SOURCE_MAP',
  DosedMap = 'DOSED_MAP',
  /** @deprecated Legacy drone vegetation index layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  DroneGli = 'DRONE_GLI',
  /** @deprecated Use DRONE_IMAGERY_COG instead. */
  DroneImagery = 'DRONE_IMAGERY',
  DroneImageryCog = 'DRONE_IMAGERY_COG',
  /** @deprecated Legacy drone vegetation index layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  DroneNdre = 'DRONE_NDRE',
  /** @deprecated Legacy drone vegetation index layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  DroneNdvi = 'DRONE_NDVI',
  /** @deprecated Legacy drone planting failure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  DronePlantingFailureMap = 'DRONE_PLANTING_FAILURE_MAP',
  /** @deprecated Legacy drone vegetation index layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  DroneSyntheticNdvi = 'DRONE_SYNTHETIC_NDVI',
  /** @deprecated Legacy drone vegetation index layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  DroneVarigreen = 'DRONE_VARIGREEN',
  Elevation = 'ELEVATION',
  ElevationSlope = 'ELEVATION_SLOPE',
  FieldVariability = 'FIELD_VARIABILITY',
  FreshBiomass = 'FRESH_BIOMASS',
  GlobalSoilGrid = 'GLOBAL_SOIL_GRID',
  Herbicide = 'HERBICIDE',
  KwsDryMatter = 'KWS_DRY_MATTER',
  MachinePerformance = 'MACHINE_PERFORMANCE',
  NematodePowerzone = 'NEMATODE_POWERZONE',
  Other = 'OTHER',
  PlanetLai = 'PLANET_LAI',
  PlanetScopeNdvi = 'PLANET_SCOPE_NDVI',
  PlanetScopeNdviAvg = 'PLANET_SCOPE_NDVI_AVG',
  /** @deprecated Use PLANET_SCOPE_WEED_PRESSURE instead. */
  PlanetScopeNdviWeedPressure = 'PLANET_SCOPE_NDVI_WEED_PRESSURE',
  PlanetScopeWeedPressure = 'PLANET_SCOPE_WEED_PRESSURE',
  PrecifieldBiomass = 'PRECIFIELD_BIOMASS',
  PrecifieldNitrogenPrescription = 'PRECIFIELD_NITROGEN_PRESCRIPTION',
  Seeding = 'SEEDING',
  SeedSelectVrsMap = 'SEED_SELECT_VRS_MAP',
  /** @deprecated Use SENTINEL_2_WEED_PRESSURE instead. */
  Sentinel_2NdviWeedPressure = 'SENTINEL_2_NDVI_WEED_PRESSURE',
  Sentinel_2WeedPressure = 'SENTINEL_2_WEED_PRESSURE',
  Slope = 'SLOPE',
  Soil = 'SOIL',
  SoilNaro = 'SOIL_NARO',
  SoilSamplingPowerzone = 'SOIL_SAMPLING_POWERZONE',
  SoilSsurgo = 'SOIL_SSURGO',
  StacCustomPowerzone = 'STAC_CUSTOM_POWERZONE',
  StacPowerzone = 'STAC_POWERZONE',
  StacSentinelBiomass = 'STAC_SENTINEL_BIOMASS',
  StacSoilSamplingPowerzone = 'STAC_SOIL_SAMPLING_POWERZONE',
  Tillage = 'TILLAGE',
  TrueColorAnalysis = 'TRUE_COLOR_ANALYSIS',
  VraAdvisorSourceMap = 'VRA_ADVISOR_SOURCE_MAP',
  WeedClassification = 'WEED_CLASSIFICATION',
  WeedClassificationNdvi = 'WEED_CLASSIFICATION_NDVI',
  /** @deprecated Legacy drone weed pressure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  WeedPressure = 'WEED_PRESSURE',
  WeedSizeClass = 'WEED_SIZE_CLASS',
  Yield = 'YIELD'
}

export enum FieldDataMeasurement {
  ActualSwathWidth = 'actual_swath_width',
  /**  soil */
  Aluminium = 'aluminium',
  AluminiumSaturationInCec = 'aluminium_saturation_in_cec',
  AnaerobicNitrogen = 'anaerobic_nitrogen',
  AppliedAmmonium = 'applied_ammonium',
  AppliedDepth = 'applied_depth',
  AppliedDistanceSpacing = 'applied_distance_spacing',
  AppliedDryMatter = 'applied_dry_matter',
  AppliedNitrogen = 'applied_nitrogen',
  AppliedPhosphorus = 'applied_phosphorus',
  AppliedPotassium = 'applied_potassium',
  AppliedPressure = 'applied_pressure',
  AppliedRateAmmonium = 'applied_rate_ammonium',
  AppliedRateCount = 'applied_rate_count',
  AppliedRateDryMatter = 'applied_rate_dry_matter',
  AppliedRateMass = 'applied_rate_mass',
  AppliedRateNitrogen = 'applied_rate_nitrogen',
  AppliedRatePhosphorus = 'applied_rate_phosphorus',
  AppliedRatePotassium = 'applied_rate_potassium',
  AppliedRateSpacing = 'applied_rate_spacing',
  /**  as-applied */
  AppliedRateVolume = 'applied_rate_volume',
  AppliedTillageDepth = 'applied_tillage_depth',
  AvailableNitrogen = 'available_nitrogen',
  AvailableSilicon = 'available_silicon',
  AvailableWater = 'available_water',
  BaseSaturation = 'base_saturation',
  Boron = 'boron',
  BulkDensity = 'bulk_density',
  Calcium = 'calcium',
  CalciumCarbonate = 'calcium_carbonate',
  CalciumSaturationInCec = 'calcium_saturation_in_cec',
  CarbonNitrogenRatio = 'carbon_nitrogen_ratio',
  CationExchangeCapacity = 'cation_exchange_capacity',
  ClayContent = 'clay_content',
  Cobalt = 'cobalt',
  Copper = 'copper',
  CopperDtpa = 'copper_dtpa',
  CopperMehlich = 'copper_mehlich',
  CountContent = 'count_content',
  /**  Only used internally, not part of the API yet */
  Date = 'date',
  DensityMass = 'density_mass',
  DensityMassPerVolume = 'density_mass_per_volume',
  DensityVolume = 'density_volume',
  DieselExhaustFluidConsumptionVehicle = 'diesel_exhaust_fluid_consumption_vehicle',
  DistanceTravelled = 'distance_travelled',
  DropletSize = 'droplet_size',
  EasilyReducingManganese = 'easily_reducing_manganese',
  ElectricalConductivity = 'electrical_conductivity',
  EngineSpeedVehicle = 'engine_speed_vehicle',
  ExchangeableCalcium = 'exchangeable_calcium',
  ExchangeableMagnesium = 'exchangeable_magnesium',
  ExchangeableManganese = 'exchangeable_manganese',
  ExchangeablePotassium = 'exchangeable_potassium',
  ExchangeableSodium = 'exchangeable_sodium',
  FieldName = 'field_name',
  FineEarthDensity = 'fine_earth_density',
  FreeIronOxides = 'free_iron_oxides',
  FuelConsumptionPerArea = 'fuel_consumption_per_area',
  FuelConsumptionPerTime = 'fuel_consumption_per_time',
  FuelLevelVehicle = 'fuel_level_vehicle',
  GnssQuality = 'gnss_quality',
  HeadingVehicle = 'heading_vehicle',
  Humus = 'humus',
  Iron = 'iron',
  IronDtpa = 'iron_dtpa',
  IronMehlich = 'iron_mehlich',
  Magnesium = 'magnesium',
  MagnesiumSaturationInCec = 'magnesium_saturation_in_cec',
  Manganese = 'manganese',
  ManganeseDtpa = 'manganese_dtpa',
  ManganeseMehlich = 'manganese_mehlich',
  MassContent = 'mass_content',
  Moisture = 'moisture',
  Molybdenum = 'molybdenum',
  NitrogenContentNh4 = 'nitrogen_content_nh4',
  NitrogenContentNo3 = 'nitrogen_content_no3',
  OrganicCarbonContent = 'organic_carbon_content',
  OrganicMatter = 'organic_matter',
  PenetrationResistance = 'penetration_resistance',
  PhCacl = 'ph_cacl',
  PhH2o = 'ph_h2o',
  PhKcl = 'ph_kcl',
  Phosphorus = 'phosphorus',
  PhosphorusAbsortionCoefficient = 'phosphorus_absortion_coefficient',
  PhosphorusBray = 'phosphorus_bray',
  PhosphorusMehlich = 'phosphorus_mehlich',
  PhosphorusOlsen = 'phosphorus_olsen',
  PhosphorusResina = 'phosphorus_resina',
  PhosphorusTruog = 'phosphorus_truog',
  Potassium = 'potassium',
  PotassiumMehlich_3 = 'potassium_mehlich_3',
  PotassiumSaturationInCec = 'potassium_saturation_in_cec',
  RelativeHumidity = 'relative_humidity',
  RockFragments = 'rock_fragments',
  SandContent = 'sand_content',
  SiltContent = 'silt_content',
  Sodium = 'sodium',
  SodiumAbsorptionRatio = 'sodium_absorption_ratio',
  /**  machinery & environmental info */
  SpeedVehicle = 'speed_vehicle',
  StripId = 'strip_id',
  Sulfur = 'sulfur',
  SwathWidth = 'swath_width',
  TargetDepth = 'target_depth',
  TargetDistanceSpacing = 'target_distance_spacing',
  TargetRateAmmonium = 'target_rate_ammonium',
  TargetRateCount = 'target_rate_count',
  TargetRateDryMatter = 'target_rate_dry_matter',
  TargetRateMass = 'target_rate_mass',
  TargetRateNitrogen = 'target_rate_nitrogen',
  TargetRatePhosphorus = 'target_rate_phosphorus',
  TargetRatePotassium = 'target_rate_potassium',
  TargetRateSpacing = 'target_rate_spacing',
  TargetRateVolume = 'target_rate_volume',
  TargetTillageDepth = 'target_tillage_depth',
  TargetWorkingHeight = 'target_working_height',
  Temperature = 'temperature',
  TotalArea = 'total_area',
  TotalKjeldahlNitrogen = 'total_kjeldahl_nitrogen',
  TotalTime = 'total_time',
  TotalVolume = 'total_volume',
  Variety = 'variety',
  VolumeContent = 'volume_content',
  WorkingHeight = 'working_height',
  YieldCount = 'yield_count',
  YieldCropDryMatter = 'yield_crop_dry_matter',
  YieldLengthOfCut = 'yield_length_of_cut',
  YieldMassDry = 'yield_mass_dry',
  YieldMassPerTimeDry = 'yield_mass_per_time_dry',
  YieldMassPerTimeWet = 'yield_mass_per_time_wet',
  YieldMassSeedCotton = 'yield_mass_seed_cotton',
  YieldMassWet = 'yield_mass_wet',
  YieldProteinContent = 'yield_protein_content',
  YieldVolumeDry = 'yield_volume_dry',
  YieldVolumePerTimeWet = 'yield_volume_per_time_wet',
  /**  yield */
  YieldVolumeWet = 'yield_volume_wet',
  Zinc = 'zinc',
  ZincDtpa = 'zinc_dtpa',
  ZincMehlich = 'zinc_mehlich',
  /**  custom source map */
  Zones = 'zones'
}

export enum FieldDataUploadApplicationType {
  Fertilizer = 'FERTILIZER',
  Fungicide = 'FUNGICIDE',
  Herbicide = 'HERBICIDE',
  Inh = 'INH',
  Insecticide = 'INSECTICIDE',
  PlantGrowthRegulator = 'PLANT_GROWTH_REGULATOR'
}

export type FieldDataUploadDataset = {
  __typename: 'FieldDataUploadDataset';
  applicationTypes?: Maybe<Array<Maybe<FieldDataUploadApplicationType>>>;
  boundary?: Maybe<Scalars['JSONObject']['output']>;
  boundaryName?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  dataMapping?: Maybe<Array<Maybe<FieldDataDataMapping>>>;
  date?: Maybe<Scalars['String']['output']>;
  dateCreated: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmV2?: Maybe<FarmV2>;
  fieldV2?: Maybe<FieldV2>;
  format?: Maybe<UploadDatasetFormat>;
  /** @deprecated No longer supported */
  geometryType?: Maybe<UploadDatasetGeometryType>;
  hasDeletedFieldDataLayers?: Maybe<Scalars['Boolean']['output']>;
  includedFileUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  includedFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  missingInfo?: Maybe<FieldDataUploadDatasetMissingInfo>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<FileSource>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<UploadDatasetStatus>;
  taskType?: Maybe<TaskType>;
  taskUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<UploadDatasetType>;
  uploadDatasetGroupUuid?: Maybe<Scalars['UUID']['output']>;
  uploadDatasetTotals?: Maybe<Array<Maybe<UploadDatasetTotal>>>;
  uuid: Scalars['UUID']['output'];
  workingWidth?: Maybe<Scalars['Float']['output']>;
};

export type FieldDataUploadDatasetMissingInfo = {
  __typename: 'FieldDataUploadDatasetMissingInfo';
  cropSeason?: Maybe<FieldDataUploadDatasetMissingInfoCropSeason>;
  dataMapping?: Maybe<Array<Maybe<MissingInfoDataMapping>>>;
  date?: Maybe<MissingInfoDate>;
  exampleData?: Maybe<Array<Maybe<MissingInfoExampleData>>>;
  field?: Maybe<FieldDataUploadDatasetMissingInfoField>;
  type?: Maybe<MissingInfoUploadDatasetType>;
};

export type FieldDataUploadDatasetMissingInfoCropSeason = {
  __typename: 'FieldDataUploadDatasetMissingInfoCropSeason';
  bestGuess?: Maybe<CropSeasonV2>;
  possibleValues?: Maybe<Array<Maybe<CropSeasonV2>>>;
};

export type FieldDataUploadDatasetMissingInfoField = {
  __typename: 'FieldDataUploadDatasetMissingInfoField';
  bestGuess?: Maybe<FieldV2>;
  possibleValues?: Maybe<Array<Maybe<FieldV2>>>;
};

export type FieldDataUploadDatasetSort = {
  column: FieldDataUploadDatasetsSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum FieldDataUploadDatasetsSortColumn {
  Crop = 'CROP',
  Date = 'DATE',
  DateCreated = 'DATE_CREATED',
  Farm = 'FARM',
  Field = 'FIELD',
  Name = 'NAME',
  Status = 'STATUS'
}

export type FieldEntry = {
  __typename: 'FieldEntry';
  etag?: Maybe<Scalars['String']['output']>;
  fieldV2: FieldV2;
  location: Scalars['JSONObject']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type FieldEvidence = {
  __typename: 'FieldEvidence';
  carbonFarmingSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  cropSeason?: Maybe<FieldEvidenceCropSeason>;
  field?: Maybe<FieldEvidenceField>;
  links?: Maybe<FieldEvidenceLinks>;
  program?: Maybe<FieldEvidenceProgram>;
  records?: Maybe<FieldEvidenceRecords>;
};

export type FieldEvidenceAph = {
  __typename: 'FieldEvidenceAph';
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceCiScore = {
  __typename: 'FieldEvidenceCiScore';
  score?: Maybe<Scalars['Float']['output']>;
  scoreUnit?: Maybe<Scalars['String']['output']>;
};

export type FieldEvidenceCoverCrop = {
  __typename: 'FieldEvidenceCoverCrop';
  seasons?: Maybe<Array<Maybe<FieldEvidenceCoverCropSeason>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceCoverCropSeason = {
  __typename: 'FieldEvidenceCoverCropSeason';
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  photos?: Maybe<EvidenceFiles>;
  receipts?: Maybe<Array<Maybe<EvidenceReceipt>>>;
  seedingDate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceCropSeason = {
  __typename: 'FieldEvidenceCropSeason';
  ciScore?: Maybe<FieldEvidenceCiScore>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceExpectedYieldProof = {
  __typename: 'FieldEvidenceExpectedYieldProof';
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  insurer?: Maybe<Scalars['String']['output']>;
  proofType?: Maybe<EvidenceExpectedYieldProofType>;
  publishedValueKgSqm?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceField = {
  __typename: 'FieldEvidenceField';
  area?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceHarvest = {
  __typename: 'FieldEvidenceHarvest';
  aph?: Maybe<FieldEvidenceAph>;
  averageExpectedYieldDry?: Maybe<Scalars['Float']['output']>;
  averageMoisture?: Maybe<Scalars['Float']['output']>;
  averageYieldDry?: Maybe<Scalars['Float']['output']>;
  averageYieldWet?: Maybe<Scalars['Float']['output']>;
  expectedYieldProof?: Maybe<FieldEvidenceExpectedYieldProof>;
  tasks?: Maybe<Array<Maybe<FieldEvidenceHarvestTask>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  yieldSales?: Maybe<FieldEvidenceYieldSales>;
};

export type FieldEvidenceHarvestTask = {
  __typename: 'FieldEvidenceHarvestTask';
  averageMoisture?: Maybe<Scalars['Float']['output']>;
  averageYieldDry?: Maybe<Scalars['Float']['output']>;
  averageYieldWet?: Maybe<Scalars['Float']['output']>;
  executionDate?: Maybe<Scalars['String']['output']>;
  harvestMethod?: Maybe<Scalars['String']['output']>;
  processedArea?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceLandLease = {
  __typename: 'FieldEvidenceLandLease';
  endDate?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTill?: Maybe<Scalars['String']['output']>;
};

export type FieldEvidenceLandLeases = {
  __typename: 'FieldEvidenceLandLeases';
  items?: Maybe<Array<Maybe<FieldEvidenceLandLease>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceLandUse = {
  __typename: 'FieldEvidenceLandUse';
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceLandUses = {
  __typename: 'FieldEvidenceLandUses';
  items?: Maybe<Array<Maybe<FieldEvidenceLandUse>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceLandownerRelease = {
  __typename: 'FieldEvidenceLandownerRelease';
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceLandownerReleases = {
  __typename: 'FieldEvidenceLandownerReleases';
  items?: Maybe<Array<Maybe<FieldEvidenceLandownerRelease>>>;
};

export type FieldEvidenceLink = BaseEntityAuditingType & {
  __typename: 'FieldEvidenceLink';
  carbonFarmingSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<FieldEvidenceLinkRecordType>;
  recordUuid?: Maybe<Scalars['UUID']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  removedAt?: Maybe<Scalars['String']['output']>;
  removedBy?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum FieldEvidenceLinkRecordType {
  LandownerRelease = 'LANDOWNER_RELEASE',
  LandUse = 'LAND_USE',
  LeaseAgreement = 'LEASE_AGREEMENT',
  ManureTest = 'MANURE_TEST',
  SoilTest = 'SOIL_TEST'
}

export type FieldEvidenceLinkSort = {
  column: FieldEvidenceLinkSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum FieldEvidenceLinkSortColumn {
  CarbonFarmingSeasonUuid = 'CARBON_FARMING_SEASON_UUID',
  DateCreated = 'DATE_CREATED',
  LastUpdated = 'LAST_UPDATED',
  RecordType = 'RECORD_TYPE',
  RecordUuid = 'RECORD_UUID',
  RemovedAt = 'REMOVED_AT'
}

export type FieldEvidenceLinks = {
  __typename: 'FieldEvidenceLinks';
  landLease?: Maybe<FieldEvidenceLandLeases>;
  landUse?: Maybe<FieldEvidenceLandUses>;
  landownerRelease?: Maybe<FieldEvidenceLandownerReleases>;
  manureTest?: Maybe<FieldEvidenceManureTests>;
  soilTest?: Maybe<FieldEvidenceSoilTests>;
};

export type FieldEvidenceManureTest = {
  __typename: 'FieldEvidenceManureTest';
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  labReport?: Maybe<EvidenceFiles>;
  nitrogenContent?: Maybe<Scalars['Float']['output']>;
  sampleDate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTill?: Maybe<Scalars['String']['output']>;
};

export type FieldEvidenceManureTests = {
  __typename: 'FieldEvidenceManureTests';
  items?: Maybe<Array<Maybe<FieldEvidenceManureTest>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceNutrition = {
  __typename: 'FieldEvidenceNutrition';
  nutritionPlan?: Maybe<FieldEvidenceNutritionPlan>;
  tasks?: Maybe<Array<Maybe<FieldEvidenceNutritionTask>>>;
  totalNitrogenApplied?: Maybe<Scalars['Float']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceNutritionPlan = {
  __typename: 'FieldEvidenceNutritionPlan';
  basis?: Maybe<Scalars['String']['output']>;
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  expertCredentials?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<EvidenceFile>>>;
  planDate?: Maybe<Scalars['String']['output']>;
  soilTestUuid?: Maybe<Scalars['UUID']['output']>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceNutritionTask = {
  __typename: 'FieldEvidenceNutritionTask';
  applicationDate?: Maybe<Scalars['String']['output']>;
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  nitrogenApplied?: Maybe<Scalars['Float']['output']>;
  receipts?: Maybe<Array<Maybe<EvidenceReceipt>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceProgram = {
  __typename: 'FieldEvidenceProgram';
  name?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceRecords = {
  __typename: 'FieldEvidenceRecords';
  coverCrop?: Maybe<FieldEvidenceCoverCrop>;
  harvest?: Maybe<FieldEvidenceHarvest>;
  nutrition?: Maybe<FieldEvidenceNutrition>;
  seeding?: Maybe<FieldEvidenceSeeding>;
  tillage?: Maybe<FieldEvidenceTillage>;
};

export type FieldEvidenceSale = {
  __typename: 'FieldEvidenceSale';
  averageMoisture?: Maybe<Scalars['Float']['output']>;
  buyer?: Maybe<Scalars['String']['output']>;
  ci?: Maybe<Scalars['Float']['output']>;
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  receipts?: Maybe<Array<Maybe<EvidenceReceipt>>>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  yieldDry?: Maybe<Scalars['Float']['output']>;
  yieldWet?: Maybe<Scalars['Float']['output']>;
};

export type FieldEvidenceSampleResults = {
  __typename: 'FieldEvidenceSampleResults';
  pH?: Maybe<Scalars['Float']['output']>;
};

export type FieldEvidenceSeeding = {
  __typename: 'FieldEvidenceSeeding';
  tasks?: Maybe<Array<Maybe<FieldEvidenceSeedingTask>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceSeedingTask = {
  __typename: 'FieldEvidenceSeedingTask';
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  receipts?: Maybe<Array<Maybe<EvidenceReceipt>>>;
  seedingDate?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceSoilTest = {
  __typename: 'FieldEvidenceSoilTest';
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  labReport?: Maybe<EvidenceFiles>;
  sampleDate?: Maybe<Scalars['String']['output']>;
  sampleResults?: Maybe<FieldEvidenceSampleResults>;
  source?: Maybe<EvidenceFileSource>;
  sourceId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTill?: Maybe<Scalars['String']['output']>;
};

export type FieldEvidenceSoilTests = {
  __typename: 'FieldEvidenceSoilTests';
  items?: Maybe<Array<Maybe<FieldEvidenceSoilTest>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceSort = {
  column: FieldEvidenceSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum FieldEvidenceSortColumn {
  DateCreated = 'DATE_CREATED',
  LastUpdated = 'LAST_UPDATED',
  Status = 'STATUS'
}

export type FieldEvidenceTDisc = {
  __typename: 'FieldEvidenceTDisc';
  mixingEfficiency?: Maybe<Scalars['Float']['output']>;
  tillageDepth?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldEvidenceTillage = {
  __typename: 'FieldEvidenceTillage';
  tasks?: Maybe<Array<Maybe<FieldEvidenceTillageTask>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceTillageTask = {
  __typename: 'FieldEvidenceTillageTask';
  passes?: Maybe<Scalars['Int']['output']>;
  tDisc?: Maybe<FieldEvidenceTDisc>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldEvidenceYieldSales = {
  __typename: 'FieldEvidenceYieldSales';
  sales?: Maybe<Array<Maybe<FieldEvidenceSale>>>;
  totalYield?: Maybe<Scalars['Float']['output']>;
};

export type FieldFeature = {
  __typename: 'FieldFeature';
  crop?: Maybe<Crop>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  features?: Maybe<Array<Maybe<FeatureName>>>;
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  isActivatedField?: Maybe<Scalars['Boolean']['output']>;
  isSponsoredField?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldIdentifierScore = {
  __typename: 'FieldIdentifierScore';
  cropSeasonUuid: Scalars['UUID']['output'];
  farmUuid: Scalars['UUID']['output'];
  fieldIdentifierSavingScorePercentage: Scalars['Float']['output'];
  fieldUuid: Scalars['UUID']['output'];
};

export type FieldInputPackaging = {
  __typename: 'FieldInputPackaging';
  containerUuid?: Maybe<Scalars['UUID']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmV2?: Maybe<FarmV2>;
  fieldInputType?: Maybe<FieldInputType>;
  fieldInputUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  retracted?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum FieldInputType {
  Product = 'PRODUCT',
  Variety = 'VARIETY'
}

export type FieldNote = {
  __typename: 'FieldNote';
  attachments?: Maybe<Array<Maybe<FieldNoteAttachment>>>;
  audioAttachments?: Maybe<Array<Maybe<FieldNoteAudioAttachment>>>;
  categories?: Maybe<Array<Maybe<FieldNoteCategory>>>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FieldV2>;
  isAutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  isDeletionAllowed?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['JSONObject']['output']>;
  locationType?: Maybe<FieldNoteLocationType>;
  note?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<FieldNoteObservation>;
  priority?: Maybe<FieldNotePriority>;
  region?: Maybe<Scalars['JSONObject']['output']>;
  scoutingPoi?: Maybe<ScoutingPoiV2>;
  scoutingTask?: Maybe<ScoutingTask>;
  uuid: Scalars['UUID']['output'];
};

export type FieldNoteAggregation = {
  __typename: 'FieldNoteAggregation';
  creators?: Maybe<Array<Maybe<User>>>;
  cropAggregations?: Maybe<Array<Maybe<FieldNoteCropAggregation>>>;
  farm?: Maybe<FarmV2>;
  fieldNotes?: Maybe<Array<Maybe<FieldNote>>>;
  fields?: Maybe<Array<Maybe<FieldV2>>>;
};

export type FieldNoteAnswer = {
  __typename: 'FieldNoteAnswer';
  assessmentTypeAnswerUuid?: Maybe<Scalars['UUID']['output']>;
  importantGrowthStageUuid?: Maybe<Scalars['UUID']['output']>;
  numberOfFields?: Maybe<Scalars['Int']['output']>;
  numericalValue?: Maybe<Scalars['Int']['output']>;
};

export type FieldNoteAssessmentAggregation = {
  __typename: 'FieldNoteAssessmentAggregation';
  answers?: Maybe<Array<Maybe<FieldNoteAnswer>>>;
  assessmentTypeUuid?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Use `images` from stress level */
  images?: Maybe<Array<Maybe<FieldNoteImage>>>;
};

export type FieldNoteAttachment = {
  __typename: 'FieldNoteAttachment';
  assessmentTypeUuid?: Maybe<Scalars['UUID']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  isDeletionAllowed?: Maybe<Scalars['Boolean']['output']>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type FieldNoteAudioAttachment = {
  __typename: 'FieldNoteAudioAttachment';
  contentLength?: Maybe<Scalars['Int']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  isDeletionAllowed?: Maybe<Scalars['Boolean']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum FieldNoteCategory {
  Biodiversity = 'BIODIVERSITY',
  CarbonProofOfAction = 'CARBON_PROOF_OF_ACTION',
  Claim = 'CLAIM',
  CropDamage = 'CROP_DAMAGE',
  Disease = 'DISEASE',
  Emergence = 'EMERGENCE',
  General = 'GENERAL',
  Lodging = 'LODGING',
  Nutrient = 'NUTRIENT',
  Obstacle = 'OBSTACLE',
  Pest = 'PEST',
  Soil = 'SOIL',
  Waterlogging = 'WATERLOGGING',
  WaterLevelEvidence = 'WATER_LEVEL_EVIDENCE',
  Weed = 'WEED'
}

export type FieldNoteCropAggregation = {
  __typename: 'FieldNoteCropAggregation';
  country?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  maxImportantGrowthStage?: Maybe<ImportantGrowthStage>;
  minImportantGrowthStage?: Maybe<ImportantGrowthStage>;
  stressAggregations?: Maybe<Array<Maybe<FieldNoteStressAggregation>>>;
};

export type FieldNoteImage = {
  __typename: 'FieldNoteImage';
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  imagePath?: Maybe<Scalars['String']['output']>;
  thumbnailPath?: Maybe<Scalars['String']['output']>;
};

export enum FieldNoteLocationType {
  Field = 'FIELD',
  Geometry = 'GEOMETRY'
}

export type FieldNoteObservation = {
  __typename: 'FieldNoteObservation';
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  expert?: Maybe<Scalars['Boolean']['output']>;
  importantStage?: Maybe<ImportantGrowthStage>;
  leafCount?: Maybe<Scalars['Int']['output']>;
  overriddenImportantGrowthStage?: Maybe<ImportantGrowthStage>;
  plantDensity?: Maybe<Scalars['Float']['output']>;
  stressAnswers?: Maybe<Array<Maybe<StressAnswer>>>;
  stressV2Answers?: Maybe<Array<Maybe<ScoutingStressQuestion>>>;
  uuid: Scalars['UUID']['output'];
  weather?: Maybe<ObservationWeather>;
};


export type FieldNoteObservationStressAnswersArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type FieldNoteObservationStressV2AnswersArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export enum FieldNotePriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type FieldNoteSort = {
  column: FieldNoteSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum FieldNoteSortColumn {
  DateCreated = 'DATE_CREATED',
  LastUpdated = 'LAST_UPDATED'
}

export type FieldNoteStressAggregation = {
  __typename: 'FieldNoteStressAggregation';
  assessmentAggregations?: Maybe<Array<Maybe<FieldNoteAssessmentAggregation>>>;
  images?: Maybe<Array<Maybe<FieldNoteImage>>>;
  stress?: Maybe<StressV2>;
};


export type FieldNoteStressAggregationStressArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type FieldPointLookup = {
  __typename: 'FieldPointLookup';
  farm?: Maybe<FarmV2>;
  field?: Maybe<FieldV2>;
};

export type FieldSummary = {
  __typename: 'FieldSummary';
  activeCropSeasonCount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  totalActiveCropSeasonArea?: Maybe<Scalars['Float']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
};

export type FieldV2 = {
  __typename: 'FieldV2';
  abLines?: Maybe<Array<Maybe<AbLine>>>;
  activations?: Maybe<Array<Maybe<FieldActivation>>>;
  agBalanceFieldInput?: Maybe<AgBalanceFieldInput>;
  area: Scalars['Float']['output'];
  boundary?: Maybe<Scalars['JSONObject']['output']>;
  boundaryChecksum?: Maybe<Scalars['String']['output']>;
  boundarySvg?: Maybe<Scalars['String']['output']>;
  carbonCredits?: Maybe<Array<Maybe<CarbonCredit>>>;
  carbonFarmingRequests?: Maybe<Array<Maybe<CarbonFarmingRequest>>>;
  centreLatitude?: Maybe<Scalars['Float']['output']>;
  centreLongitude?: Maybe<Scalars['Float']['output']>;
  clayPercentage?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<User>;
  /** @deprecated Use `cropSeasonsV2`. */
  cropSeasons?: Maybe<Array<Maybe<CropSeason>>>;
  cropSeasonsV2?: Maybe<Array<CropSeasonV2>>;
  currentWeedPredictions?: Maybe<Array<Maybe<CurrentWeedPrediction>>>;
  etag?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `farmV2`. */
  farm?: Maybe<Farm>;
  farmV2?: Maybe<FarmV2>;
  features?: Maybe<Array<Maybe<FieldFeature>>>;
  fieldDataLayers?: Maybe<Array<Maybe<FieldDataLayer>>>;
  fieldEntries?: Maybe<Array<Maybe<FieldEntry>>>;
  fieldNotes?: Maybe<Array<Maybe<FieldNote>>>;
  fieldZones?: Maybe<Array<Maybe<FieldZone>>>;
  flik?: Maybe<Scalars['String']['output']>;
  gravelPercentage?: Maybe<Scalars['Float']['output']>;
  greenhouse?: Maybe<Greenhouse>;
  heading?: Maybe<Scalars['Float']['output']>;
  /** @deprecated This attribute is now available in `CropSystemRecommendationV2.isInRedZone`. */
  isInRedZone?: Maybe<Scalars['Boolean']['output']>;
  landUseTypeUuid?: Maybe<Scalars['UUID']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  localSoilScale?: Maybe<Scalars['String']['output']>;
  localSoilTexture?: Maybe<SoilTexture>;
  modifier?: Maybe<User>;
  monitorPractices?: Maybe<Array<Maybe<MonitorPractice>>>;
  name: Scalars['String']['output'];
  porosityLevel?: Maybe<Dictionary>;
  schlagnummer?: Maybe<Scalars['String']['output']>;
  scoutingTasks?: Maybe<Array<ScoutingTask>>;
  seedSelectorInputs?: Maybe<Array<Maybe<SeedSelectorInput>>>;
  slopePercentage?: Maybe<Scalars['Float']['output']>;
  soilErosion?: Maybe<Array<Maybe<SoilErosion>>>;
  soilOrganicMatterPercentage?: Maybe<Scalars['Float']['output']>;
  soilSalinity?: Maybe<Scalars['Float']['output']>;
  soilSamplingResults?: Maybe<Array<Maybe<SoilSamplingResult>>>;
  soilSamplings?: Maybe<Array<Maybe<SoilSampling>>>;
  soilTaxonomy?: Maybe<SoilTaxonomy>;
  soilTexture?: Maybe<SoilTexture>;
  sourceMaps?: Maybe<Array<Maybe<SourceMap>>>;
  sprayWeather?: Maybe<Array<Maybe<SprayWeather>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tramlines?: Maybe<Array<Maybe<Tramline>>>;
  userDataVsValidationComparisons?: Maybe<UserDataVsValidationComparison>;
  uuid: Scalars['UUID']['output'];
  validityScore?: Maybe<Scalars['Float']['output']>;
  varietyRecommendations?: Maybe<Array<Maybe<VarietyRecommendation>>>;
  /** @deprecated Use `WeatherV2`. */
  weather?: Maybe<Array<Maybe<Weather>>>;
  weatherV2?: Maybe<Array<Maybe<WeatherV2>>>;
  weedRecords?: Maybe<Array<Maybe<WeedRecord>>>;
};


export type FieldV2CropSeasonsArgs = {
  lifecycleState?: InputMaybe<Array<InputMaybe<LifecycleState>>>;
};


export type FieldV2CropSeasonsV2Args = {
  lifecycleState?: InputMaybe<Array<InputMaybe<LifecycleState>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type FieldV2FieldDataLayersArgs = {
  includedMagnitudeTypeFilter?: InputMaybe<Array<InputMaybe<MagnitudeType>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maxCountByType?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<FieldDataLayerType>>>;
};


export type FieldV2FieldNotesArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type FieldV2SourceMapsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type FieldV2SprayWeatherArgs = {
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
};


export type FieldV2WeatherArgs = {
  format?: InputMaybe<WeatherFormat>;
  fromDate: Scalars['Date']['input'];
  provider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<Array<InputMaybe<WeatherType>>>;
};


export type FieldV2WeatherV2Args = {
  excludeProvider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  format?: InputMaybe<WeatherFormat>;
  fromDate: Scalars['Date']['input'];
  provider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<Array<InputMaybe<WeatherType>>>;
};

export type FieldVariabilityInSeason = {
  __typename: 'FieldVariabilityInSeason';
  cropSeasonUuid: Scalars['UUID']['output'];
  cropUuid: Scalars['UUID']['output'];
  farmUuid: Scalars['UUID']['output'];
  fieldUuid: Scalars['UUID']['output'];
  fieldVariabilityIndexes: Array<FieldVariabilityInSeasonIndex>;
  seasonResolutionStatus: SeasonResolutionStatus;
  seasonUuid?: Maybe<Scalars['UUID']['output']>;
};

export type FieldVariabilityInSeasonIndex = {
  __typename: 'FieldVariabilityInSeasonIndex';
  coefficientOfVariation: Scalars['Float']['output'];
  index: AgronomicIndexType;
  quantileRange: Scalars['Float']['output'];
};

export type FieldVariabilityIndex = {
  __typename: 'FieldVariabilityIndex';
  boundaryChecksum?: Maybe<Scalars['String']['output']>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  indexStatus?: Maybe<FieldVariabilityIndexStatus>;
  indexStatusDescriptionTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  indexStatusTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  recommendedNumberOfZones?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
  zones?: Maybe<Scalars['JSONObject']['output']>;
};

export enum FieldVariabilityIndexStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export type FieldVariabilityInput = {
  __typename: 'FieldVariabilityInput';
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  selectedYears?: Maybe<Array<Maybe<SelectedYear>>>;
  uuid: Scalars['UUID']['output'];
};

export type FieldVariabilityTimeSeries = {
  __typename: 'FieldVariabilityTimeSeries';
  collection?: Maybe<Scalars['String']['output']>;
  cropSeasonUuid: Scalars['UUID']['output'];
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  farmUuid: Scalars['UUID']['output'];
  fieldUuid: Scalars['UUID']['output'];
  fieldVariabilityIndexes: Array<FieldVariabilityTimeSeriesIndex>;
  observedAt: Scalars['Date']['output'];
  seasonResolutionStatus: SeasonResolutionStatus;
  seasonUuid?: Maybe<Scalars['UUID']['output']>;
  stacItemUuid: Scalars['UUID']['output'];
};

export type FieldVariabilityTimeSeriesIndex = {
  __typename: 'FieldVariabilityTimeSeriesIndex';
  coefficientOfVariation?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<AgronomicIndexType>;
  quantileRange?: Maybe<Scalars['Float']['output']>;
};

export enum FieldVpiClassification {
  High = 'HIGH',
  Low = 'LOW',
  Mid = 'MID'
}

export type FieldZone = {
  __typename: 'FieldZone';
  checksum?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  fieldV2: FieldV2;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfPolygons?: Maybe<Scalars['Int']['output']>;
  trials?: Maybe<Array<Maybe<Trial>>>;
  type?: Maybe<FieldZoneType>;
  typeColor?: Maybe<Scalars['Color']['output']>;
  typeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum FieldZoneType {
  BiodiversityWindow = 'BIODIVERSITY_WINDOW',
  BufferZone = 'BUFFER_ZONE',
  Generic = 'GENERIC',
  Obstacle = 'OBSTACLE',
  SmsprStrategyZone = 'SMSPR_STRATEGY_ZONE',
  TrialPlot = 'TRIAL_PLOT'
}

export type File = {
  __typename: 'File';
  /**  a batch is not an entity itself, it only has a uuid, so use the UUID directly */
  batchUuid?: Maybe<Scalars['UUID']['output']>;
  creator?: Maybe<User>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  fieldUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  sizeInBytes?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<FileSource>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  uploadDate?: Maybe<Scalars['Date']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type FileSort = {
  column: FileSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum FileSortColumn {
  FileExtension = 'FILE_EXTENSION',
  FileName = 'FILE_NAME',
  Source = 'SOURCE',
  UploadDate = 'UPLOAD_DATE'
}

export enum FileSource {
  ClaasConnect = 'CLAAS_CONNECT',
  Dkedevice = 'DKEDEVICE',
  Exatrekdevice = 'EXATREKDEVICE',
  JohnDeere = 'JOHN_DEERE',
  Leaf = 'LEAF',
  Nevonexdevice = 'NEVONEXDEVICE',
  Osmdldevice = 'OSMDLDEVICE',
  Panorama = 'PANORAMA',
  SoilSamplingResult = 'SOIL_SAMPLING_RESULT',
  UserUploaded = 'USER_UPLOADED'
}

export enum FileUploadOrderStatus {
  Incomplete = 'INCOMPLETE',
  MultipartMergingTriggered = 'MULTIPART_MERGING_TRIGGERED',
  PreProcessingTriggered = 'PRE_PROCESSING_TRIGGERED',
  ProcessingTriggered = 'PROCESSING_TRIGGERED'
}

export enum FileUploadStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Missing = 'MISSING'
}

export enum FilterStrategy {
  All = 'ALL',
  BestResolutionPerDay = 'BEST_RESOLUTION_PER_DAY',
  MostRecentPerTypeAndCardinality = 'MOST_RECENT_PER_TYPE_AND_CARDINALITY',
  TaskCreation = 'TASK_CREATION'
}

export enum FlowHint {
  NemaFree = 'NEMA_FREE'
}

export type FmCarbonRelatedData = {
  __typename: 'FmCarbonRelatedData';
  coverCropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  coverCropUuid?: Maybe<Scalars['UUID']['output']>;
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  fieldBoundary?: Maybe<Scalars['JSONObject']['output']>;
  fieldUuid: Scalars['UUID']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  tillages?: Maybe<Array<Maybe<CarbonRelatedDataTillage>>>;
};

export type Footprint = {
  __typename: 'Footprint';
  benchmarkTotal?: Maybe<Scalars['Float']['output']>;
  factorCropProtection?: Maybe<Scalars['Float']['output']>;
  factorFertilizerProvision?: Maybe<Scalars['Float']['output']>;
  factorFieldEmissions?: Maybe<Scalars['Float']['output']>;
  factorSeeds?: Maybe<Scalars['Float']['output']>;
  factorTractorUse?: Maybe<Scalars['Float']['output']>;
  factorWater?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalMax?: Maybe<Scalars['Float']['output']>;
  totalMin?: Maybe<Scalars['Float']['output']>;
};

export type ForeignCatchCrop = {
  __typename: 'ForeignCatchCrop';
  carryOverNitrogenPreviousYearCoverCrop?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  deDuevCropName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ForeignCrop = {
  __typename: 'ForeignCrop';
  allocationCoefficientCropResiduesFactor?: Maybe<Scalars['Float']['output']>;
  allocationCoefficientHarvestProductFactor?: Maybe<Scalars['Float']['output']>;
  allocationCoefficientRootsFactor?: Maybe<Scalars['Float']['output']>;
  allocationCoefficientStubbleFactor?: Maybe<Scalars['Float']['output']>;
  annualHumusCropResidue?: Maybe<Scalars['Float']['output']>;
  annualHumusDecayPerCrop?: Maybe<Scalars['Float']['output']>;
  annualHumusRoots?: Maybe<Scalars['Float']['output']>;
  carbonConcentrationCropResidueFactor?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  crops?: Maybe<Array<Maybe<CropDictCode>>>;
  deDuevCropName?: Maybe<Scalars['String']['output']>;
  defaultFreshMatterStateYield?: Maybe<Scalars['Float']['output']>;
  defaultStateCropNitrogenDemandRate?: Maybe<Scalars['Float']['output']>;
  defaultStateFreshMatterYieldDifference?: Maybe<Scalars['Float']['output']>;
  defaultStateMaximumNitrogenRate?: Maybe<Scalars['Float']['output']>;
  defaultStateNitrogenAdditionalValueMinus?: Maybe<Scalars['Float']['output']>;
  defaultStateNitrogenAdditionalValuePlus?: Maybe<Scalars['Float']['output']>;
  dryMatterConcentrationCropResidues?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nitrogenAllocationFactor?: Maybe<Scalars['Float']['output']>;
  nitrogenConcentrationCropResidues?: Maybe<Scalars['Float']['output']>;
  nitrogenConcentrationHarvestProduct?: Maybe<Scalars['Float']['output']>;
  nitrogenDemandCalculation?: Maybe<Scalars['Boolean']['output']>;
  recommendedNumberOfApplications?: Maybe<Scalars['Float']['output']>;
  recommendedTimingForApplications?: Maybe<Array<Maybe<RecommendedTimingForApplication>>>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
  yieldMultiplierFactor?: Maybe<Scalars['Float']['output']>;
};

export type ForeignPreCrop = {
  __typename: 'ForeignPreCrop';
  carryOverNitrogenPreviousYearMainCrop?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  deDuevCropName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum Formulation {
  Liquid = 'LIQUID',
  Solid = 'SOLID'
}

export type FreshBiomassOrder = {
  __typename: 'FreshBiomassOrder';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FreshBiomassOrderStatus>;
  tillDate?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum FreshBiomassOrderStatus {
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type FrostRisk = {
  __typename: 'FrostRisk';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeasonV2: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isFrostRiskPresent?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type FulfilledIntervention = {
  __typename: 'FulfilledIntervention';
  fulfilmentStatus?: Maybe<FulfilmentStatus>;
  interventionType?: Maybe<Intervention>;
};

export enum FulfilmentStatus {
  Fulfilled = 'FULFILLED',
  Incomplete = 'INCOMPLETE',
  NotFulfilled = 'NOT_FULFILLED'
}

export type GeneralTask = {
  __typename: 'GeneralTask';
  assigneeUuid?: Maybe<Scalars['UUID']['output']>;
  assignmentState?: Maybe<TaskAssignmentState>;
  creationFlowHint?: Maybe<CreationFlowHint>;
  cropSeason: CropSeasonV2;
  cropUuid: Scalars['UUID']['output'];
  generalStatus: GeneralTaskStatus;
  generalStatusDate: Scalars['Date']['output'];
  productCategoryCodes?: Maybe<Array<Maybe<ProductCategoryType>>>;
  taskDetails: GeneralTasksUnion;
  taskType: GeneralTaskType;
  taskUuid: Scalars['UUID']['output'];
};

export enum GeneralTaskStatus {
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE',
  Planned = 'PLANNED'
}

export enum GeneralTaskType {
  CropEstablishment = 'CROP_ESTABLISHMENT',
  CropResidueManagementTask = 'CROP_RESIDUE_MANAGEMENT_TASK',
  DroneFlight = 'DRONE_FLIGHT',
  GreenhouseWhiteningTask = 'GREENHOUSE_WHITENING_TASK',
  Harvest = 'HARVEST',
  LandPreparation = 'LAND_PREPARATION',
  LeafPruningTask = 'LEAF_PRUNING_TASK',
  ProduceDeliveryTask = 'PRODUCE_DELIVERY_TASK',
  ScoutingTask = 'SCOUTING_TASK',
  SeedBoxTreatment = 'SEED_BOX_TREATMENT',
  SeedTreatment = 'SEED_TREATMENT',
  SmartSprayingTaskV2 = 'SMART_SPRAYING_TASK_V2',
  SoilSamplingTask = 'SOIL_SAMPLING_TASK',
  SprayingV2 = 'SPRAYING_V2',
  ToppingTask = 'TOPPING_TASK',
  WaterManagementTask = 'WATER_MANAGEMENT_TASK'
}

export type GeneralTasksUnion = CropEstablishment | CropResidueManagementTask | DroneFlight | GreenhouseWhiteningTask | Harvest | LandPreparation | LeafPruningTask | ProduceDeliveryTask | ScoutingTask | SeedBoxTreatment | SeedTreatment | SmartSprayingTaskV2 | SoilSamplingTask | SprayingV2 | ToppingTask | WaterManagementTask;

export type GeoMapDetail = {
  __typename: 'GeoMapDetail';
  attribute?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  mapCode?: Maybe<Scalars['String']['output']>;
  mapUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pestDiseaseRegionCode?: Maybe<Scalars['String']['output']>;
  pestDiseaseRegionName?: Maybe<Scalars['String']['output']>;
  pestDiseaseRegionUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueOrig?: Maybe<Scalars['Int']['output']>;
  valueUnitCode?: Maybe<Scalars['String']['output']>;
  valueUnitSiCode?: Maybe<Scalars['String']['output']>;
  valueUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  valueUnitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type Greenhouse = {
  __typename: 'Greenhouse';
  averageHeight?: Maybe<Scalars['Float']['output']>;
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  fieldV2: FieldV2;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  roofMaterialUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
  weatherV2?: Maybe<Array<Maybe<WeatherV2>>>;
};


export type GreenhouseWeatherV2Args = {
  excludeProvider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  format?: InputMaybe<WeatherFormat>;
  fromDate: Scalars['Date']['input'];
  provider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<Array<InputMaybe<WeatherType>>>;
};

export type GreenhouseWhiteningTask = {
  __typename: 'GreenhouseWhiteningTask';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<TaskExecutionState>;
  uuid: Scalars['UUID']['output'];
};

export type GreetApplication = {
  __typename: 'GreetApplication';
  applicationType?: Maybe<GreetApplicationType>;
  avgRate?: Maybe<Scalars['Float']['output']>;
  productUuid?: Maybe<Scalars['UUID']['output']>;
  sprayingUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum GreetApplicationType {
  Flat = 'FLAT',
  Vla = 'VLA',
  WithInhibitor = 'WITH_INHIBITOR'
}

export type GreetCarbonIntensityScore = {
  __typename: 'GreetCarbonIntensityScore';
  appliedCropProtection?: Maybe<Array<Maybe<GreetCropProtection>>>;
  appliedFertilizers?: Maybe<Array<Maybe<GreetApplication>>>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  carbonFarmingSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  coverCropUuid?: Maybe<Scalars['UUID']['output']>;
  cropSeasonUuid: Scalars['UUID']['output'];
  energyConsumptionRateDiesel?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateElectricity?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateGasoline?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateLiquefiedPetroleumGas?: Maybe<Scalars['Float']['output']>;
  energyConsumptionRateNaturalGas?: Maybe<Scalars['Float']['output']>;
  fieldUuid: Scalars['UUID']['output'];
  harvestMethodUuid?: Maybe<Scalars['UUID']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  totalYield?: Maybe<Scalars['Float']['output']>;
  yieldExpectation?: Maybe<Scalars['Float']['output']>;
};

export type GreetCropProtection = {
  __typename: 'GreetCropProtection';
  avgRate?: Maybe<Scalars['Float']['output']>;
  productUuid?: Maybe<Scalars['UUID']['output']>;
  sprayingUuid?: Maybe<Scalars['UUID']['output']>;
};

export type Group = {
  __typename: 'Group';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type GrowthStage = {
  __typename: 'GrowthStage';
  /** @deprecated Not used in `GrowthStage` anymore, moved to `GrowthStagePredictionDaily` */
  continuousIndex?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Not used in `GrowthStage` anymore, moved to `GrowthStagePredictionDaily` */
  continuousLeafIndex?: Maybe<Scalars['Float']['output']>;
  cropGrowthStageV2?: Maybe<CropGrowthStageV2>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  endDate?: Maybe<Scalars['Date']['output']>;
  gsOrder?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Not used in `GrowthStage` anymore, moved to `GrowthStagePredictionDaily` */
  leafCount?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<GrowthStageProvider>;
  /** @deprecated Use `scaleV2`. */
  scale?: Maybe<Scale>;
  scaleV2?: Maybe<ScaleV2>;
  simulationDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Not supported in GrowthStage V2 endpoints */
  uuid?: Maybe<Scalars['UUID']['output']>;
};


export type GrowthStageCropGrowthStageV2Args = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
};

/** Minimal notify payload — not a hydrated GrowthStage series. */
export type GrowthStagePredictionCalculatedPayload = {
  __typename: 'GrowthStagePredictionCalculatedPayload';
  cropSeasonUuid: Scalars['UUID']['output'];
};

export type GrowthStagePredictionDaily = {
  __typename: 'GrowthStagePredictionDaily';
  accumulatedGrowingDegreeDays?: Maybe<Scalars['Float']['output']>;
  berryDevelopmentPercentage?: Maybe<Scalars['Float']['output']>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  continuousIndex?: Maybe<Scalars['Float']['output']>;
  continuousLeafIndex?: Maybe<Scalars['Float']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  dailyGrowingDegreeDays?: Maybe<Scalars['Float']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  floweringPercentage?: Maybe<Scalars['Float']['output']>;
  gsOrder?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  inflorescenceEmissionPercentage?: Maybe<Scalars['Float']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  leafCount?: Maybe<Scalars['Int']['output']>;
  leafEmissionPercentage?: Maybe<Scalars['Float']['output']>;
  provider?: Maybe<GrowthStageProvider>;
  ripeningPercentage?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<ScaleV2>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum GrowthStageProvider {
  Atlas = 'ATLAS',
  Horta = 'HORTA',
  Xarvio = 'XARVIO'
}

export type HfContractorEquipment = {
  __typename: 'HFContractorEquipment';
  hasSectionControl?: Maybe<Scalars['Boolean']['output']>;
  hasVRA?: Maybe<Scalars['Boolean']['output']>;
  machineryLocation?: Maybe<Scalars['JSONObject']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  tankSize?: Maybe<Scalars['Float']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  workingWidth?: Maybe<Scalars['Float']['output']>;
  workingWidth2?: Maybe<Scalars['Float']['output']>;
};

export type HfContractorRequest = {
  __typename: 'HFContractorRequest';
  address?: Maybe<Scalars['String']['output']>;
  agreedPrice?: Maybe<Scalars['Float']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  /** @deprecated Use `creator`. */
  creatorId?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  equipments?: Maybe<Array<Maybe<HfContractorEquipment>>>;
  etag?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maxCapacity?: Maybe<Scalars['Float']['output']>;
  onboardingAssigneeUserId?: Maybe<Scalars['String']['output']>;
  onboardingComment?: Maybe<Scalars['String']['output']>;
  onboardingDate?: Maybe<Scalars['Date']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  quotePrice?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<HfContractorRequestStatus>;
  supportedConnectivityTypes?: Maybe<Array<Maybe<ConnectionSource>>>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
};

export enum HfContractorRequestStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type HfServiceRequest = {
  __typename: 'HFServiceRequest';
  accessMode?: Maybe<AccessMode>;
  appliedPriceCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignedAgScoutId?: Maybe<Scalars['String']['output']>;
  assignedAgronomicConsultantId?: Maybe<Scalars['String']['output']>;
  assignedContractorId?: Maybe<Scalars['String']['output']>;
  assignedCoordinatorId?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<BillingAddress>;
  businessName?: Maybe<Scalars['String']['output']>;
  collaborator?: Maybe<Collaborator>;
  connectivitySource?: Maybe<ConnectivitySource>;
  contractorAgreementId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  dateApproved?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  guidancePatternDistance?: Maybe<Scalars['Float']['output']>;
  hfDiscounts?: Maybe<Array<Maybe<HfDiscount>>>;
  hfReferenceCode?: Maybe<HfReferenceCode>;
  hfRiskClass?: Maybe<Array<Maybe<HfRiskClass>>>;
  historicalExtremeHeatDays?: Maybe<Scalars['Float']['output']>;
  isEyeSpotTreatmentRequired?: Maybe<Scalars['Boolean']['output']>;
  isFafRequired?: Maybe<Scalars['Boolean']['output']>;
  isPGRrequired?: Maybe<Scalars['Boolean']['output']>;
  isRamulariaRequired?: Maybe<Scalars['Boolean']['output']>;
  magentoOrderId?: Maybe<Scalars['String']['output']>;
  operationalReferenceCode?: Maybe<HfReferenceCode>;
  options?: Maybe<Array<Maybe<RateCategory>>>;
  orderReferenceId?: Maybe<Scalars['String']['output']>;
  preferredContractorComment?: Maybe<Scalars['String']['output']>;
  pricePerArea?: Maybe<Scalars['Float']['output']>;
  pricePerAreaUnitUuid?: Maybe<Scalars['UUID']['output']>;
  pricing?: Maybe<Pricing>;
  programType?: Maybe<ProgramType>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  requesteeUser?: Maybe<User>;
  secondaryApplicatorEmailAddress?: Maybe<Scalars['String']['output']>;
  serviceTerm?: Maybe<HfServiceTerm>;
  serviceType?: Maybe<ServiceType>;
  shadowApplicatorEmailAddress?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Status>;
  totalBasePrice?: Maybe<Scalars['Float']['output']>;
  totalPgrPrice?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Harvest = {
  __typename: 'Harvest';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  clustersPerPlant?: Maybe<Scalars['Float']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  harvestMethodCode?: Maybe<HarvestMethodCode>;
  harvestedProduceCode?: Maybe<HarvestedProduceCode>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  processedArea?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<TaskExecutionState>;
  uuid: Scalars['UUID']['output'];
  yield?: Maybe<Scalars['Float']['output']>;
  yieldProperties?: Maybe<Scalars['JSONObject']['output']>;
};

export enum HarvestCondition {
  Early = 'EARLY',
  Late = 'LATE',
  NotReady = 'NOT_READY',
  Optimal = 'OPTIMAL'
}

export enum HarvestMethodCode {
  Carrotharvester = 'CARROTHARVESTER',
  ChemicalDestruction = 'CHEMICAL_DESTRUCTION',
  CombineHarvesterGrain = 'COMBINE_HARVESTER_GRAIN',
  CombineStrawAndChaffRemoval = 'COMBINE_STRAW_AND_CHAFF_REMOVAL',
  CombineStrawIncorporation = 'COMBINE_STRAW_INCORPORATION',
  CombineStrawRemoval = 'COMBINE_STRAW_REMOVAL',
  CombineWithoutStrawAndChaffRemoval = 'COMBINE_WITHOUT_STRAW_AND_CHAFF_REMOVAL',
  Cut = 'CUT',
  Forageharvester = 'FORAGEHARVESTER',
  Foragersdirectcutting = 'FORAGERSDIRECTCUTTING',
  Grazing = 'GRAZING',
  Handcut = 'HANDCUT',
  Handharvest = 'HANDHARVEST',
  Handpick = 'HANDPICK',
  Handpluck = 'HANDPLUCK',
  Harvester = 'HARVESTER',
  Harvester2Stage = 'HARVESTER2STAGE',
  Harvesterbeet = 'HARVESTERBEET',
  Harvesterccm = 'HARVESTERCCM',
  Harvestercob = 'HARVESTERCOB',
  Harvestergrain = 'HARVESTERGRAIN',
  HarvestergrainRemoval = 'HARVESTERGRAIN_REMOVAL',
  Harvesterpotatoes = 'HARVESTERPOTATOES',
  Harvestersugarbeet = 'HARVESTERSUGARBEET',
  Herbicide = 'HERBICIDE',
  IncorporationWithoutharvesting = 'INCORPORATION_WITHOUTHARVESTING',
  Machine = 'MACHINE',
  MachineHarvesting = 'MACHINE_HARVESTING',
  Maizechopper = 'MAIZECHOPPER',
  Mowercombination = 'MOWERCOMBINATION',
  MulchingWithoutremovalofcuttings = 'MULCHING_WITHOUTREMOVALOFCUTTINGS',
  Notapplicable = 'NOTAPPLICABLE',
  Pick = 'PICK',
  Pluck = 'PLUCK',
  RollerMechanicalDestruction = 'ROLLER_MECHANICAL_DESTRUCTION'
}

export enum HarvestedProduceCode {
  Ccm = 'CCM',
  Crop = 'CROP',
  Fruit = 'FRUIT',
  Fruitfall = 'FRUITFALL',
  Grain = 'GRAIN',
  Hay = 'HAY',
  Plant = 'PLANT',
  Straw = 'STRAW'
}

export type HfAddress = {
  __typename: 'HfAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type HfAgRegion = {
  __typename: 'HfAgRegion';
  countryCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type HfAlert = {
  __typename: 'HfAlert';
  alert?: Maybe<Alert>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  farm?: Maybe<FarmV2>;
  field?: Maybe<FieldV2>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
};

export type HfClaim = {
  __typename: 'HfClaim';
  active?: Maybe<Scalars['Boolean']['output']>;
  assigneeUser?: Maybe<User>;
  categories?: Maybe<Array<Maybe<ClaimCategory>>>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason: CropSeasonV2;
  etag?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<ClaimEvaluation>;
  fieldNotes?: Maybe<Array<Maybe<FieldNote>>>;
  hfServiceRequest?: Maybe<HfServiceRequest>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  status: HfClaimStatus;
  uuid: Scalars['UUID']['output'];
};

export enum HfClaimCategory {
  LeafHealthy = 'LEAF_HEALTHY'
}

export enum HfClaimStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Declined = 'DECLINED',
  InReview = 'IN_REVIEW',
  Pending = 'PENDING'
}

export type HfDiscount = {
  __typename: 'HfDiscount';
  category: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  hfServiceRequest?: Maybe<HfServiceRequest>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  unit: HfDiscountUnit;
  uuid: Scalars['UUID']['output'];
};

export enum HfDiscountUnit {
  Flat = 'FLAT',
  PerArea = 'PER_AREA'
}

export type HfDistributor = {
  __typename: 'HfDistributor';
  address: HfAddress;
  distributorManagerId?: Maybe<User>;
  distributorName: Scalars['String']['output'];
  distributorPartner: DistributorPartner;
  etag?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type HfFarm = {
  __typename: 'HfFarm';
  creatorId?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farm: FarmV2;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  sapCreditor?: Maybe<Scalars['String']['output']>;
  sapDebtor?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type HfInvoice = {
  __typename: 'HfInvoice';
  creatorId?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  hfServiceRequests: Array<HfServiceRequest>;
  invoiceReferenceCode?: Maybe<Scalars['String']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum HfLevel {
  CheckField = 'CHECK_FIELD',
  Claim = 'CLAIM',
  Closing = 'CLOSING',
  Info = 'INFO',
  None = 'NONE',
  Ok = 'OK',
  Urgent = 'URGENT',
  Warning = 'WARNING'
}

export type HfMachinery = {
  __typename: 'HfMachinery';
  creatorId?: Maybe<Scalars['String']['output']>;
  depotLocation?: Maybe<Scalars['JSONObject']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  hasSectionControl?: Maybe<Scalars['Boolean']['output']>;
  hasVRA?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Dictionary>;
  model?: Maybe<Sprayer>;
  name?: Maybe<Scalars['String']['output']>;
  tankSize?: Maybe<Scalars['Float']['output']>;
  terminal?: Maybe<Dictionary>;
  type?: Maybe<Dictionary>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  workingWidths?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type HfOffer = {
  __typename: 'HfOffer';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  hfServiceRequests?: Maybe<Array<Maybe<HfServiceRequest>>>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  recipientUser?: Maybe<User>;
  status?: Maybe<Status>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type HfOfferCondition = {
  __typename: 'HfOfferCondition';
  cropSeasonV2?: Maybe<CropSeasonV2>;
  riskClass?: Maybe<RiskClass>;
};

export type HfOperationalInstruction = {
  __typename: 'HfOperationalInstruction';
  cropSeason?: Maybe<CropSeasonV2>;
  instruction?: Maybe<Scalars['String']['output']>;
  level?: Maybe<HfLevel>;
  roleFeatureName?: Maybe<RoleFeatureName>;
};

export type HfPreOrder = {
  __typename: 'HfPreOrder';
  cropQuotas?: Maybe<Array<Maybe<PreOrderCropQuota>>>;
  farm?: Maybe<FarmV2>;
  status?: Maybe<CommercialPartnerPreOrderStatus>;
  uuid: Scalars['UUID']['output'];
};

export type HfPrice = {
  __typename: 'HfPrice';
  cropSeason?: Maybe<CropSeasonV2>;
  loyaltyDiscountAmount: Scalars['Float']['output'];
  loyaltyDiscountEligible: Scalars['Boolean']['output'];
  loyaltyDiscountPerArea: Scalars['Float']['output'];
  loyaltyDiscountPerAreaUnitUuid?: Maybe<Scalars['UUID']['output']>;
  pricePerArea: Scalars['Float']['output'];
  pricePerAreaUnitUuid: Scalars['UUID']['output'];
  totalBasePrice: Scalars['Float']['output'];
  totalPgrPrice?: Maybe<Scalars['Float']['output']>;
};

export type HfRate = {
  __typename: 'HfRate';
  countryCode: Scalars['String']['output'];
  rates?: Maybe<Array<Maybe<RegionRate>>>;
};

export type HfReferenceCode = {
  __typename: 'HfReferenceCode';
  accessMode?: Maybe<AccessMode>;
  assignedAgronomicConsultantId?: Maybe<Scalars['String']['output']>;
  assignedCoordinatorId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  digitalServiceManager?: Maybe<User>;
  distributorUuid?: Maybe<Scalars['UUID']['output']>;
  enabledCrops?: Maybe<Array<Crop>>;
  etag?: Maybe<Scalars['String']['output']>;
  hfDistributor?: Maybe<HfDistributor>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  margins?: Maybe<Array<Maybe<HfReferenceCodeMargin>>>;
  offerModel?: Maybe<OfferModel>;
  operationalReferenceCode?: Maybe<HfReferenceCode>;
  organisation?: Maybe<PublicOrganisation>;
  target?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type HfReferenceCodeCategoryRate = {
  __typename: 'HfReferenceCodeCategoryRate';
  category?: Maybe<RateCategory>;
  rateInEuroPerHectare?: Maybe<Scalars['Float']['output']>;
};

export type HfReferenceCodeMargin = {
  __typename: 'HfReferenceCodeMargin';
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  marginAbs?: Maybe<Scalars['Float']['output']>;
};

export type HfReferenceCodePublic = {
  __typename: 'HfReferenceCodePublic';
  code: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  enabledCrops?: Maybe<Array<Crop>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  offerModel?: Maybe<OfferModel>;
  organisation?: Maybe<PublicOrganisation>;
  uuid: Scalars['UUID']['output'];
};

export type HfReferenceCodeRate = {
  __typename: 'HfReferenceCodeRate';
  categories?: Maybe<Array<Maybe<HfReferenceCodeCategoryRate>>>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  hfReferenceCodeUuid?: Maybe<Scalars['UUID']['output']>;
  season?: Maybe<PricingSeason>;
};

export type HfRequestFarmPackageAddOn = {
  __typename: 'HfRequestFarmPackageAddOn';
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  lastModifier?: Maybe<User>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  packageUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type HfRiskClass = {
  __typename: 'HfRiskClass';
  riskClass?: Maybe<HfServiceRequestAreaClassType>;
  varietyUuid?: Maybe<Scalars['UUID']['output']>;
};

export type HfSeason = {
  __typename: 'HfSeason';
  country?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  seasonEndDate?: Maybe<Scalars['Date']['output']>;
  seasonStartDate?: Maybe<Scalars['Date']['output']>;
};

export enum HfServiceRequestAreaClassType {
  ClassA = 'CLASS_A',
  ClassAPlus = 'CLASS_A_PLUS',
  ClassB = 'CLASS_B',
  ClassC = 'CLASS_C',
  Eyespot = 'EYESPOT',
  Faf = 'FAF',
  Fusarium = 'FUSARIUM',
  Pgr = 'PGR',
  PowderyMildew = 'POWDERY_MILDEW',
  Ramularia = 'RAMULARIA'
}

export enum HfServiceTerm {
  Bbch_22 = 'BBCH_22',
  Bbch_32 = 'BBCH_32',
  Bbch_75 = 'BBCH_75',
  Rita = 'RITA'
}

export type HfWeatherData = {
  __typename: 'HfWeatherData';
  actualExtremeHeatDays?: Maybe<Scalars['Int']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  currentGDD?: Maybe<Scalars['Float']['output']>;
  farm?: Maybe<FarmV2>;
  floweringPeriodEndDate?: Maybe<Scalars['Date']['output']>;
  floweringPeriodStartDate?: Maybe<Scalars['Date']['output']>;
};

export type HortaCropSeason = {
  __typename: 'HortaCropSeason';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  fmCropSeason?: Maybe<CropSeasonV2>;
  hortaPreCropUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type HortaSpraying = {
  __typename: 'HortaSpraying';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  fmSpraying?: Maybe<SprayingV2>;
  hortaCropProtectionDistributionModeUuid?: Maybe<Scalars['UUID']['output']>;
  hortaFertilizerDistributionModeUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type HortaStress = {
  __typename: 'HortaStress';
  code?: Maybe<Scalars['String']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  treatmentTypeCode?: Maybe<Scalars['String']['output']>;
  treatmentTypeName?: Maybe<Scalars['String']['output']>;
  treatmentTypeUuid: Scalars['UUID']['output'];
  uuid: Scalars['UUID']['output'];
};

export type HortaSustainabilityIndicator = {
  __typename: 'HortaSustainabilityIndicator';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  sustainabilityIndicators?: Maybe<Scalars['JSONObject']['output']>;
};

export type Image = {
  __typename: 'Image';
  code?: Maybe<Scalars['String']['output']>;
  fullPath?: Maybe<Scalars['String']['output']>;
  imageThumbnailPath?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  typeUuid?: Maybe<Scalars['UUID']['output']>;
  usage?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ImportOrder = {
  __typename: 'ImportOrder';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  importedNumberOfFields?: Maybe<Scalars['Int']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ImportOrderStatus>;
  subjectId: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export enum ImportOrderFilterStrategy {
  LatestImportPerFarm = 'LATEST_IMPORT_PER_FARM'
}

export enum ImportOrderStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Ongoing = 'ONGOING',
  Pending = 'PENDING'
}

export type ImportantGrowthStage = {
  __typename: 'ImportantGrowthStage';
  countryCode?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  cropGrowthStageV2?: Maybe<CropGrowthStageV2>;
  /** @deprecated Use `cropGrowthStageV2` */
  cropGrowthStages?: Maybe<Array<Maybe<CropGrowthStage>>>;
  gsOrder?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  isMilestone?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `scaleV2`. */
  scale?: Maybe<Scale>;
  scaleV2?: Maybe<ScaleV2>;
  shortName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};


export type ImportantGrowthStageCropGrowthStageV2Args = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
};


export type ImportantGrowthStageCropGrowthStagesArgs = {
  languageCode: Scalars['String']['input'];
};

export type IncubationLevel = {
  __typename: 'IncubationLevel';
  date: Scalars['Date']['output'];
  incubationLevel: Scalars['Float']['output'];
};

export enum InfectionType {
  Ascoporix = 'ASCOPORIX',
  Conidia = 'CONIDIA',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type Ingredient = {
  __typename: 'Ingredient';
  averageApplicationRate?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  productFormulationTypeGroup?: Maybe<Scalars['UUID']['output']>;
  productFormulationTypeGroupName?: Maybe<Scalars['String']['output']>;
  totalApplication?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum Intervention {
  Biofuel = 'BIOFUEL',
  ChangeToOrganic = 'CHANGE_TO_ORGANIC',
  CoverCrop = 'COVER_CROP',
  LowCFertilizer = 'LOW_C_FERTILIZER',
  NoTillage = 'NO_TILLAGE',
  ReducedTillage = 'REDUCED_TILLAGE',
  StrawIncorporation = 'STRAW_INCORPORATION',
  UiNi = 'UI_NI',
  UiNiOrganic = 'UI_NI_ORGANIC',
  Vra = 'VRA'
}

export type InviteCode = {
  __typename: 'InviteCode';
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  languageCode?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum IrrigationEnergySource {
  Diesel = 'DIESEL',
  Electricity = 'ELECTRICITY'
}

export enum IsActiveGsModelFilter {
  Both = 'BOTH',
  False = 'FALSE',
  True = 'TRUE'
}

export enum IssueType {
  BlossomEndRot = 'BLOSSOM_END_ROT',
  CriticalStageReached = 'CRITICAL_STAGE_REACHED',
  FlagLeafStageReached = 'FLAG_LEAF_STAGE_REACHED',
  FloweringStageReached = 'FLOWERING_STAGE_REACHED',
  GrowthStage = 'GROWTH_STAGE',
  GrowthStageFinalApplicationReached = 'GROWTH_STAGE_FINAL_APPLICATION_REACHED',
  R1StageReached = 'R1_STAGE_REACHED',
  RamulariaProtection = 'RAMULARIA_PROTECTION',
  RowClosing = 'ROW_CLOSING',
  StinkBugProtection = 'STINK_BUG_PROTECTION',
  StinkBugProtectionGrainfilling = 'STINK_BUG_PROTECTION_GRAINFILLING',
  StinkBugProtectionHeading = 'STINK_BUG_PROTECTION_HEADING',
  TreatmentPeriodExceeded = 'TREATMENT_PERIOD_EXCEEDED',
  VtStageReached = 'VT_STAGE_REACHED'
}

export type JdFieldSynchronizationOrder = {
  __typename: 'JdFieldSynchronizationOrder';
  farmUuids?: Maybe<Array<Maybe<FarmUuid>>>;
  jdFieldSyncId?: Maybe<Scalars['UUID']['output']>;
  jdOrganizationId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<JdFieldSynchronizationOrderStatus>;
  uuid: Scalars['UUID']['output'];
};

export enum JdFieldSynchronizationOrderStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Processed = 'PROCESSED',
  Started = 'STARTED'
}

export type JdNotificationSubscription = {
  __typename: 'JdNotificationSubscription';
  categories?: Maybe<Array<JdNotificationSubscriptionCategory>>;
  farmV2?: Maybe<FarmV2>;
  jdOrganizationId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum JdNotificationSubscriptionCategory {
  ApplicationRecommendation = 'APPLICATION_RECOMMENDATION',
  ResidualHerbicide = 'RESIDUAL_HERBICIDE'
}

export type KubotaApplicationMapDispatchOrder = {
  __typename: 'KubotaApplicationMapDispatchOrder';
  dateCreated?: Maybe<Scalars['Date']['output']>;
  errorReason?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<KubotaApplicationMapDispatchOrderStatus>;
  taskType?: Maybe<KubotaApplicationMapDispatchOrderTaskType>;
  taskUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum KubotaApplicationMapDispatchOrderStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum KubotaApplicationMapDispatchOrderTaskType {
  Spraying = 'SPRAYING'
}

export type KubotaField = {
  __typename: 'KubotaField';
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type KwsConsent = {
  __typename: 'KwsConsent';
  eTag?: Maybe<Scalars['String']['output']>;
  farmV2?: Maybe<FarmV2>;
  proofOfPurchaseStatus?: Maybe<ProofOfPurchaseStatus>;
  status?: Maybe<KwsConsentStatus>;
  uuid: Scalars['UUID']['output'];
};

export enum KwsConsentStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type KwsSupportedVariety = {
  __typename: 'KwsSupportedVariety';
  variety?: Maybe<Variety>;
};


export type KwsSupportedVarietyVarietyArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type LandPreparation = {
  __typename: 'LandPreparation';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  drainagePreparationUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  processedArea?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<TaskExecutionState>;
  tillageDepth?: Maybe<Scalars['Float']['output']>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type LeafDamageResult = ScoutingPoiResult & {
  __typename: 'LeafDamageResult';
  highDamageAreaPercentage?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  mediumDamageAreaPercentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ScoutingPoiResultStatus>;
};

export type LeafPruningTask = {
  __typename: 'LeafPruningTask';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<TaskExecutionState>;
  uuid: Scalars['UUID']['output'];
};

export type LegendEntry = {
  __typename: 'LegendEntry';
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum LegendType {
  Continuous = 'CONTINUOUS',
  Discrete = 'DISCRETE',
  Ranged = 'RANGED'
}

export type License = {
  __typename: 'License';
  activeSince?: Maybe<Scalars['Date']['output']>;
  activeTill?: Maybe<Scalars['Date']['output']>;
  associatedDevicePackages?: Maybe<Array<Scalars['UUID']['output']>>;
  associatedPackages?: Maybe<Array<Scalars['UUID']['output']>>;
  associatedUserPackages?: Maybe<Array<Scalars['UUID']['output']>>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isAvailableInAppStore?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<PaymentType>;
  price?: Maybe<Scalars['Float']['output']>;
  requiredPackages?: Maybe<Array<Scalars['UUID']['output']>>;
  seller?: Maybe<LicenseSellerType>;
  stockQty?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type LicenseRequest = {
  __typename: 'LicenseRequest';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorUser?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  farm: FarmV2;
  lastModifierUser?: Maybe<User>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  licenseUuid: Scalars['UUID']['output'];
  organisation?: Maybe<Organisation>;
  organisationMemberUser?: Maybe<User>;
  quantity: Scalars['Float']['output'];
  seasonEndDate?: Maybe<Scalars['Date']['output']>;
  seasonStartDate?: Maybe<Scalars['Date']['output']>;
  shopFarmPackages?: Maybe<Array<Maybe<ShopFarmPackage>>>;
  status: LicenseRequestStatusType;
  statusColor?: Maybe<Scalars['ColorCx']['output']>;
  statusOrder?: Maybe<Scalars['Int']['output']>;
  statusTranslationId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
};

export type LicenseRequestSeason = {
  __typename: 'LicenseRequestSeason';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum LicenseRequestStatusType {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  RenewalScheduled = 'RENEWAL_SCHEDULED',
  Revoked = 'REVOKED'
}

export enum LicenseSellerType {
  BasfDigitalFarming = 'BASF_DIGITAL_FARMING',
  BoschBasfSmartFarming = 'BOSCH_BASF_SMART_FARMING'
}

export enum LifecycleState {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Planned = 'PLANNED'
}

export enum LimitationReason {
  HighRiskEyespot = 'HIGH_RISK_EYESPOT',
  HighRiskFg = 'HIGH_RISK_FG',
  HighRiskYellowrust = 'HIGH_RISK_YELLOWRUST'
}

export type LinkedDevice = {
  __typename: 'LinkedDevice';
  creatorId?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Array<Maybe<VendorDeviceInfo>>>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Location = {
  __typename: 'Location';
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export enum LocationType {
  Farm = 'FARM',
  Field = 'FIELD',
  Greenhouse = 'GREENHOUSE'
}

export type Magnitude = {
  __typename: 'Magnitude';
  checksum?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<FieldDataLayerClassification>;
  dataReliability?: Maybe<DataReliability>;
  elevation?: Maybe<Scalars['String']['output']>;
  fieldDataLayer?: Maybe<FieldDataLayer>;
  geodataZipUrl?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  legend?: Maybe<FieldDataLayerLegend>;
  magnitudeType?: Maybe<MagnitudeType>;
  maxElevation?: Maybe<Scalars['Float']['output']>;
  mbTilesUrl?: Maybe<Scalars['String']['output']>;
  minElevation?: Maybe<Scalars['Float']['output']>;
  processingType?: Maybe<ProcessingType>;
  sourceInvalidReasons?: Maybe<Array<Maybe<MagnitudeSourceInvalidReasonType>>>;
  statistics?: Maybe<FieldDataLayerStatistics>;
  type?: Maybe<MagnitudeType>;
  typeDescriptionTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  typeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  unit?: Maybe<MagnitudeUnit>;
  unitUuid?: Maybe<Scalars['UUID']['output']>;
  vectorTilesStyleUrl?: Maybe<Scalars['String']['output']>;
  vectorTilesUrl?: Maybe<Scalars['String']['output']>;
  wmsParameters?: Maybe<WmsParameters>;
  wmsUrl?: Maybe<Scalars['String']['output']>;
};


export type MagnitudeClassificationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MagnitudeLegendArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export enum MagnitudeSourceInvalidReasonType {
  Other = 'OTHER',
  OverlappingGeometries = 'OVERLAPPING_GEOMETRIES',
  TooManyClasses = 'TOO_MANY_CLASSES'
}

export enum MagnitudeStrategy {
  Grouped = 'GROUPED',
  Separate = 'SEPARATE'
}

export enum MagnitudeType {
  ActualWorkingWidth = 'ACTUAL_WORKING_WIDTH',
  /**  Soil maps (both uploaded and global grids) */
  Aluminium = 'ALUMINIUM',
  AluminiumSaturationInCec = 'ALUMINIUM_SATURATION_IN_CEC',
  AnaerobicNitrogen = 'ANAEROBIC_NITROGEN',
  /**  Smart Sprayer */
  ApplicationCoverage = 'APPLICATION_COVERAGE',
  AppliedAmmonium = 'APPLIED_AMMONIUM',
  AppliedAmmoniumRate = 'APPLIED_AMMONIUM_RATE',
  AppliedDryMatter = 'APPLIED_DRY_MATTER',
  AppliedDryMatterRate = 'APPLIED_DRY_MATTER_RATE',
  AppliedNitrogen = 'APPLIED_NITROGEN',
  AppliedNitrogenRate = 'APPLIED_NITROGEN_RATE',
  AppliedPhosphorus = 'APPLIED_PHOSPHORUS',
  AppliedPhosphorusRate = 'APPLIED_PHOSPHORUS_RATE',
  AppliedPotassium = 'APPLIED_POTASSIUM',
  AppliedPotassiumRate = 'APPLIED_POTASSIUM_RATE',
  AvailableMoisture = 'AVAILABLE_MOISTURE',
  AvailableNitrogen = 'AVAILABLE_NITROGEN',
  AvailableSilicon = 'AVAILABLE_SILICON',
  AvailableWater = 'AVAILABLE_WATER',
  AvailableWaterStorage = 'AVAILABLE_WATER_STORAGE',
  AverageNdvi = 'AVERAGE_NDVI',
  BaseSaturation = 'BASE_SATURATION',
  Boron = 'BORON',
  BulkDensity = 'BULK_DENSITY',
  Calcium = 'CALCIUM',
  CalciumCarbonate = 'CALCIUM_CARBONATE',
  CalciumSaturationInCec = 'CALCIUM_SATURATION_IN_CEC',
  CarbonNitrogenRatio = 'CARBON_NITROGEN_RATIO',
  CationExchangeCapacity = 'CATION_EXCHANGE_CAPACITY',
  ClayContent = 'CLAY_CONTENT',
  CoarseFragments = 'COARSE_FRAGMENTS',
  Cobalt = 'COBALT',
  Copper = 'COPPER',
  CopperDtpa = 'COPPER_DTPA',
  CopperMehlich = 'COPPER_MEHLICH',
  CountContent = 'COUNT_CONTENT',
  CountRate = 'COUNT_RATE',
  Cpi1 = 'CPI1',
  CropCount = 'CROP_COUNT',
  CropDryMatter = 'CROP_DRY_MATTER',
  DensityClass = 'DENSITY_CLASS',
  DensityMass = 'DENSITY_MASS',
  DensityMassPerVolume = 'DENSITY_MASS_PER_VOLUME',
  DensityVolume = 'DENSITY_VOLUME',
  Depth = 'DEPTH',
  DieselExhaustFluidConsumption = 'DIESEL_EXHAUST_FLUID_CONSUMPTION',
  Drainage = 'DRAINAGE',
  /** @deprecated Legacy drone vegetation index layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  DroneFlightZonesEqualInterval = 'DRONE_FLIGHT_ZONES_EQUAL_INTERVAL',
  /**
   *  Drone flights
   * @deprecated Legacy drone vegetation index layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable.
   */
  DroneFlightZonesNaturalBreaks = 'DRONE_FLIGHT_ZONES_NATURAL_BREAKS',
  DropletSize = 'DROPLET_SIZE',
  DryMass = 'DRY_MASS',
  DryMassPerTime = 'DRY_MASS_PER_TIME',
  /**  KWS dry matter */
  DryMatterContent = 'DRY_MATTER_CONTENT',
  DryVolume = 'DRY_VOLUME',
  EasilyReducingManganese = 'EASILY_REDUCING_MANGANESE',
  /**  Application efficacy maps */
  EfficacyCoverage = 'EFFICACY_COVERAGE',
  ElectricalConductivity = 'ELECTRICAL_CONDUCTIVITY',
  EngineSpeed = 'ENGINE_SPEED',
  Evi = 'EVI',
  ExchangeableCalcium = 'EXCHANGEABLE_CALCIUM',
  ExchangeableMagnesium = 'EXCHANGEABLE_MAGNESIUM',
  ExchangeableManganese = 'EXCHANGEABLE_MANGANESE',
  ExchangeablePotassium = 'EXCHANGEABLE_POTASSIUM',
  ExchangeableSodium = 'EXCHANGEABLE_SODIUM',
  /**  Others */
  FieldVariability = 'FIELD_VARIABILITY',
  FieldWaterContent = 'FIELD_WATER_CONTENT',
  FineEarthDensity = 'FINE_EARTH_DENSITY',
  FirstWiltingPoint = 'FIRST_WILTING_POINT',
  FreeIronOxides = 'FREE_IRON_OXIDES',
  FreshBiomass = 'FRESH_BIOMASS',
  FuelConsumptionPerArea = 'FUEL_CONSUMPTION_PER_AREA',
  FuelConsumptionPerTime = 'FUEL_CONSUMPTION_PER_TIME',
  FuelLevel = 'FUEL_LEVEL',
  GnssQuality = 'GNSS_QUALITY',
  /**  Topography */
  Height = 'HEIGHT',
  Humus = 'HUMUS',
  Inclination = 'INCLINATION',
  Iron = 'IRON',
  IronDtpa = 'IRON_DTPA',
  IronMehlich = 'IRON_MEHLICH',
  Lai = 'LAI',
  LaiContrast = 'LAI_CONTRAST',
  LengthOfCut = 'LENGTH_OF_CUT',
  LiquidRate = 'LIQUID_RATE',
  Magnesium = 'MAGNESIUM',
  MagnesiumSaturationInCec = 'MAGNESIUM_SATURATION_IN_CEC',
  Manganese = 'MANGANESE',
  ManganeseDtpa = 'MANGANESE_DTPA',
  ManganeseMehlich = 'MANGANESE_MEHLICH',
  MassContent = 'MASS_CONTENT',
  MaxWaterCapacity = 'MAX_WATER_CAPACITY',
  Moisture = 'MOISTURE',
  Molybdenum = 'MOLYBDENUM',
  /**  Biomass maps */
  Ndvi = 'NDVI',
  NdviContrast = 'NDVI_CONTRAST',
  NitrogenContentNh4 = 'NITROGEN_CONTENT_NH4',
  NitrogenContentNo3 = 'NITROGEN_CONTENT_NO3',
  OrganicCarbonContent = 'ORGANIC_CARBON_CONTENT',
  OrganicMatter = 'ORGANIC_MATTER',
  Orthomosaic = 'ORTHOMOSAIC',
  PenetrationResistance = 'PENETRATION_RESISTANCE',
  /** @deprecated Legacy drone planting failure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  PercentageFailureAbove_50Cm = 'PERCENTAGE_FAILURE_ABOVE_50_CM',
  /** @deprecated Legacy drone planting failure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  PercentageFailureAbove_100Cm = 'PERCENTAGE_FAILURE_ABOVE_100_CM',
  PermanentWiltingPoint = 'PERMANENT_WILTING_POINT',
  Phosphorus = 'PHOSPHORUS',
  PhosphorusAbsortionCoefficient = 'PHOSPHORUS_ABSORTION_COEFFICIENT',
  PhosphorusBray = 'PHOSPHORUS_BRAY',
  PhosphorusMehlich = 'PHOSPHORUS_MEHLICH',
  PhosphorusMehlichBasedOnClay = 'PHOSPHORUS_MEHLICH_BASED_ON_CLAY',
  PhosphorusOlsen = 'PHOSPHORUS_OLSEN',
  PhosphorusResina = 'PHOSPHORUS_RESINA',
  PhosphorusTruog = 'PHOSPHORUS_TRUOG',
  PhCacl = 'PH_CACL',
  PhH2O = 'PH_H2O',
  PhKcl = 'PH_KCL',
  Potassium = 'POTASSIUM',
  PotassiumMehlich_3 = 'POTASSIUM_MEHLICH_3',
  PotassiumSaturationInCec = 'POTASSIUM_SATURATION_IN_CEC',
  Pressure = 'PRESSURE',
  ProteinContent = 'PROTEIN_CONTENT',
  RateDifference = 'RATE_DIFFERENCE',
  RelativeHumidity = 'RELATIVE_HUMIDITY',
  RockFragments = 'ROCK_FRAGMENTS',
  RootCauseClass = 'ROOT_CAUSE_CLASS',
  SandContent = 'SAND_CONTENT',
  SaturatedHydraulicConductivity = 'SATURATED_HYDRAULIC_CONDUCTIVITY',
  SeedCottonMass = 'SEED_COTTON_MASS',
  SiltContent = 'SILT_CONTENT',
  Sodium = 'SODIUM',
  SodiumAbsorptionRatio = 'SODIUM_ABSORPTION_RATIO',
  SoilType = 'SOIL_TYPE',
  /**  Uploaded as-applied & yield maps */
  SolidRate = 'SOLID_RATE',
  SpacingDistance = 'SPACING_DISTANCE',
  SpacingRate = 'SPACING_RATE',
  Speed = 'SPEED',
  Sulfur = 'SULFUR',
  /**
   *  Weed pressure maps
   * @deprecated Legacy drone weed pressure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable.
   */
  SurfaceFraction = 'SURFACE_FRACTION',
  /** @deprecated Legacy drone weed pressure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  SurfaceFractionHighSensitivity = 'SURFACE_FRACTION_HIGH_SENSITIVITY',
  /** @deprecated Legacy drone weed pressure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  SurfaceFractionLowSensitivity = 'SURFACE_FRACTION_LOW_SENSITIVITY',
  /** @deprecated Legacy drone weed pressure layers are no longer produced. Use the drone STAC collections instead. Existing layers remain readable. */
  SurfaceFractionMediumSensitivity = 'SURFACE_FRACTION_MEDIUM_SENSITIVITY',
  TargetAmmoniumRate = 'TARGET_AMMONIUM_RATE',
  TargetCountRate = 'TARGET_COUNT_RATE',
  TargetDepth = 'TARGET_DEPTH',
  TargetDryMatterRate = 'TARGET_DRY_MATTER_RATE',
  TargetLiquidRate = 'TARGET_LIQUID_RATE',
  TargetNitrogenRate = 'TARGET_NITROGEN_RATE',
  TargetPhosphorusRate = 'TARGET_PHOSPHORUS_RATE',
  TargetPotassiumRate = 'TARGET_POTASSIUM_RATE',
  TargetSolidRate = 'TARGET_SOLID_RATE',
  TargetSpacingDistance = 'TARGET_SPACING_DISTANCE',
  TargetSpacingRate = 'TARGET_SPACING_RATE',
  TargetTillageDepth = 'TARGET_TILLAGE_DEPTH',
  TargetWorkingHeight = 'TARGET_WORKING_HEIGHT',
  Temperature = 'TEMPERATURE',
  Texture = 'TEXTURE',
  TillageDepth = 'TILLAGE_DEPTH',
  TotalKjeldahlNitrogen = 'TOTAL_KJELDAHL_NITROGEN',
  TrueColor = 'TRUE_COLOR',
  UsdaSoilTaxonomy = 'USDA_SOIL_TAXONOMY',
  UsdaTexture = 'USDA_TEXTURE',
  Variety = 'VARIETY',
  VolumeContent = 'VOLUME_CONTENT',
  WeedClass = 'WEED_CLASS',
  WeedCoverage = 'WEED_COVERAGE',
  WeedSizeClassCombined = 'WEED_SIZE_CLASS_COMBINED',
  WeedSizeClassLarge = 'WEED_SIZE_CLASS_LARGE',
  WeedSizeClassMedium = 'WEED_SIZE_CLASS_MEDIUM',
  WeedSizeClassSmall = 'WEED_SIZE_CLASS_SMALL',
  WetMass = 'WET_MASS',
  WetMassPerTime = 'WET_MASS_PER_TIME',
  WetVolume = 'WET_VOLUME',
  WetVolumePerTime = 'WET_VOLUME_PER_TIME',
  WorkingHeight = 'WORKING_HEIGHT',
  WorkingWidth = 'WORKING_WIDTH',
  WorldReferenceBaseSoilTaxonomy = 'WORLD_REFERENCE_BASE_SOIL_TAXONOMY',
  Zinc = 'ZINC',
  ZincDtpa = 'ZINC_DTPA',
  ZincMehlich = 'ZINC_MEHLICH',
  /**  Custom source maps */
  Zones = 'ZONES'
}

export enum MagnitudeUnit {
  Degree = 'DEGREE',
  DegreeK = 'DEGREE_K',
  ItemSec = 'ITEM_SEC',
  Kg = 'KG',
  Kgpm2 = 'KGPM2',
  Kgpm3 = 'KGPM3',
  KgKg = 'KG_KG',
  KgSec = 'KG_SEC',
  M = 'M',
  M3 = 'M3',
  M3Pm2 = 'M3PM2',
  M3Sec = 'M3_SEC',
  Molpkg = 'MOLPKG',
  MolM3 = 'MOL_M3',
  Mps = 'MPS',
  None = 'NONE',
  Pa = 'PA',
  Percent = 'PERCENT',
  PercentUnitless = 'PERCENT_UNITLESS',
  Ppm = 'PPM',
  SeedMrow = 'SEED_MROW',
  SM = 'S_M',
  Upm2 = 'UPM2',
  UsCanolaBushelsPerAcre = 'US_CANOLA_BUSHELS_PER_ACRE',
  UsCornBushelsPerAcre = 'US_CORN_BUSHELS_PER_ACRE',
  UsSoyBushelsPerAcre = 'US_SOY_BUSHELS_PER_ACRE',
  VolPercent = 'VOL_PERCENT'
}

export enum MandatoryStressSetting {
  CautionLevel = 'CAUTION_LEVEL',
  Presence = 'PRESENCE'
}

export type MapItem = {
  __typename: 'MapItem';
  cropSeason?: Maybe<CropSeasonV2>;
  date?: Maybe<Scalars['Date']['output']>;
  farm?: Maybe<FarmV2>;
  field?: Maybe<FieldV2>;
  fieldDataLayer?: Maybe<FieldDataLayer>;
  fieldDataLayerType?: Maybe<FieldDataLayerType>;
  /**  FDL uuid or StacItemIndex uuid */
  mapType?: Maybe<MapItemType>;
  sourceType?: Maybe<FieldDataLayerSourceType>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  stacFieldDataLayerType?: Maybe<StacFieldDataLayer>;
  stacItemUuid?: Maybe<Scalars['UUID']['output']>;
  taskType?: Maybe<TaskType>;
  taskUuid?: Maybe<Scalars['UUID']['output']>;
  /**  acquisition date or computation date for Powerzone */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type MapItemSort = {
  column: MapItemSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum MapItemSortColumn {
  CreatedAt = 'CREATED_AT',
  CropName = 'CROP_NAME',
  Date = 'DATE',
  FarmName = 'FARM_NAME',
  FieldName = 'FIELD_NAME',
  SourceType = 'SOURCE_TYPE',
  TaskType = 'TASK_TYPE',
  Type = 'TYPE'
}

export enum MapItemType {
  Fdl = 'FDL',
  Stac = 'STAC'
}

export type MappingFieldZone = {
  __typename: 'MappingFieldZone';
  checksum?: Maybe<Scalars['String']['output']>;
  fieldZone?: Maybe<FieldZone>;
  fixedRate?: Maybe<Scalars['Float']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<FieldZoneType>;
};

export type Md2AggregatedProductusesByCrop = {
  __typename: 'Md2AggregatedProductusesByCrop';
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stresses?: Maybe<Array<Maybe<Md2Item>>>;
  uuid: Scalars['UUID']['output'];
};

export type Md2Configuration = {
  __typename: 'Md2Configuration';
  characteristicId?: Maybe<Scalars['String']['output']>;
  characteristicName?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<Array<Maybe<Md2Item>>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionUuid?: Maybe<Scalars['UUID']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  stressCode?: Maybe<Scalars['String']['output']>;
  stressName?: Maybe<Scalars['String']['output']>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueMax?: Maybe<Scalars['String']['output']>;
  valueMin?: Maybe<Scalars['String']['output']>;
  valueUnitSiCode?: Maybe<Scalars['String']['output']>;
  valueUnitSiName?: Maybe<Scalars['String']['output']>;
  valueUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
};

export type Md2CountryCropConfiguration = {
  __typename: 'Md2CountryCropConfiguration';
  characteristicId?: Maybe<Scalars['String']['output']>;
  characteristicName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Md2DictionaryMapping = {
  __typename: 'Md2DictionaryMapping';
  sourceCode?: Maybe<Scalars['String']['output']>;
  sourceDictName?: Maybe<Scalars['String']['output']>;
  sourceDictShort?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  targetCode?: Maybe<Scalars['String']['output']>;
  targetDictName?: Maybe<Scalars['String']['output']>;
  targetDictShort?: Maybe<Scalars['String']['output']>;
  targetName?: Maybe<Scalars['String']['output']>;
  targetUuid?: Maybe<Scalars['UUID']['output']>;
};

export type Md2Item = {
  __typename: 'Md2Item';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dictId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Md2ProductFeature = {
  __typename: 'Md2ProductFeature';
  characteristicId?: Maybe<Scalars['String']['output']>;
  characteristicName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  productCategories?: Maybe<Array<Maybe<Md2Item>>>;
  productCode?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productUuid?: Maybe<Scalars['UUID']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  valueCodes?: Maybe<Array<Maybe<Md2Item>>>;
};

export type Md2TillageDepth = {
  __typename: 'Md2TillageDepth';
  checksum?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  tillageDepths?: Maybe<Array<Maybe<Tillages>>>;
};

export type Md2VraAdvisorConfiguration = {
  __typename: 'Md2VraAdvisorConfiguration';
  applicationStrategyOptions?: Maybe<Array<Maybe<Md2Item>>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  dosageDistributionOptions?: Maybe<Array<Maybe<Md2Item>>>;
  doseRateStepPercent?: Maybe<Scalars['Float']['output']>;
  fieldDataLayerConfigurations?: Maybe<Array<Maybe<Md2VraAdvisorFieldDataLayerConfiguration>>>;
  growthStageModelScale?: Maybe<Scalars['String']['output']>;
  minPolygonWidthInPixel?: Maybe<Scalars['Float']['output']>;
  minZoneSizeInM2?: Maybe<Scalars['Float']['output']>;
  productCategoryCode?: Maybe<Scalars['String']['output']>;
  productCategoryUuid?: Maybe<Scalars['UUID']['output']>;
  taskTypeCode?: Maybe<Scalars['String']['output']>;
  taskTypeUuid?: Maybe<Scalars['UUID']['output']>;
};

export type Md2VraAdvisorFieldDataLayerConfiguration = {
  __typename: 'Md2VraAdvisorFieldDataLayerConfiguration';
  applicationStrategyDefaultCode?: Maybe<Scalars['String']['output']>;
  applicationStrategyDefaultName?: Maybe<Scalars['String']['output']>;
  applicationStrategyDefaultUuid?: Maybe<Scalars['UUID']['output']>;
  dosageDistributionDefaultCode?: Maybe<Scalars['String']['output']>;
  dosageDistributionDefaultName?: Maybe<Scalars['String']['output']>;
  dosageDistributionDefaultUuid?: Maybe<Scalars['UUID']['output']>;
  fdlTypeCode?: Maybe<Scalars['String']['output']>;
  fdlTypeName?: Maybe<Scalars['String']['output']>;
  fdlTypeUuid?: Maybe<Scalars['UUID']['output']>;
  growthStageIntervalCodeFrom?: Maybe<Scalars['String']['output']>;
  growthStageIntervalCodeTill?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['Float']['output']>;
  maxMapPrimaryFdlAgeInDays?: Maybe<Scalars['Int']['output']>;
  maxNumberOfZone?: Maybe<Scalars['Int']['output']>;
  numberOfDaySeedingFdlFrom?: Maybe<Scalars['Int']['output']>;
  numberOfDaySeedingFdlTill?: Maybe<Scalars['Int']['output']>;
  offConcept?: Maybe<Scalars['Boolean']['output']>;
  offLogic?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type MdCoefficientOfVariationDetail = {
  __typename: 'MdCoefficientOfVariationDetail';
  colourValue?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  fieldVariabilityCategoryCode?: Maybe<Scalars['String']['output']>;
  fieldVariabilityCategoryName?: Maybe<Scalars['String']['output']>;
  fieldVariabilityCategoryUuid?: Maybe<Scalars['UUID']['output']>;
  recommendedNumberOfZones?: Maybe<Scalars['String']['output']>;
  seasonCode?: Maybe<Scalars['String']['output']>;
  seasonName?: Maybe<Scalars['String']['output']>;
  seasonUuid?: Maybe<Scalars['UUID']['output']>;
  valueMax?: Maybe<Scalars['String']['output']>;
  valueMin?: Maybe<Scalars['String']['output']>;
};

export type MdSoilNematodeRisk = {
  __typename: 'MdSoilNematodeRisk';
  assessmentObjectCode?: Maybe<Scalars['String']['output']>;
  assessmentObjectName?: Maybe<Scalars['String']['output']>;
  assessmentObjectUuid?: Maybe<Scalars['UUID']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  numeratorUnitCode?: Maybe<Scalars['String']['output']>;
  numeratorUnitName?: Maybe<Scalars['String']['output']>;
  numeratorUnitUuid?: Maybe<Scalars['UUID']['output']>;
  pestCode?: Maybe<Scalars['String']['output']>;
  pestName?: Maybe<Scalars['String']['output']>;
  pestUuid?: Maybe<Scalars['UUID']['output']>;
  riskCode?: Maybe<Scalars['String']['output']>;
  riskName?: Maybe<Scalars['String']['output']>;
  riskUuid?: Maybe<Scalars['UUID']['output']>;
  sampleSize?: Maybe<Scalars['String']['output']>;
  sampleUnitCode?: Maybe<Scalars['String']['output']>;
  sampleUnitName?: Maybe<Scalars['String']['output']>;
  sampleUnitUuid?: Maybe<Scalars['UUID']['output']>;
  valueMax?: Maybe<Scalars['Float']['output']>;
  valueMin?: Maybe<Scalars['Float']['output']>;
};

export enum MdTaskType {
  Fieldtreatment = 'FIELDTREATMENT',
  Irrigation = 'IRRIGATION',
  Seedboxtreatment = 'SEEDBOXTREATMENT',
  Seeding = 'SEEDING',
  Seedtreatment = 'SEEDTREATMENT',
  Soilprep = 'SOILPREP',
  Tillage = 'TILLAGE'
}

export type MdUnit = {
  __typename: 'MdUnit';
  baseUnitCode?: Maybe<Scalars['String']['output']>;
  baseUnitName?: Maybe<Scalars['String']['output']>;
  baseUnitUuid?: Maybe<Scalars['UUID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayUnitCode?: Maybe<Scalars['String']['output']>;
  displayUnitConversionFactor?: Maybe<Scalars['Float']['output']>;
  displayUnitName?: Maybe<Scalars['String']['output']>;
  displayUnitUuid?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  unitDenominatorCode?: Maybe<Scalars['String']['output']>;
  unitDenominatorName?: Maybe<Scalars['String']['output']>;
  unitDenominatorUuid?: Maybe<Scalars['UUID']['output']>;
  unitGroupCode?: Maybe<Scalars['String']['output']>;
  unitGroupName?: Maybe<Scalars['String']['output']>;
  unitGroupUuid?: Maybe<Scalars['UUID']['output']>;
  unitNumeratorCode?: Maybe<Scalars['String']['output']>;
  unitNumeratorName?: Maybe<Scalars['String']['output']>;
  unitNumeratorUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
  validUnit?: Maybe<Scalars['Boolean']['output']>;
};

export enum MeasureSubmissionErrorCode {
  MeasureSubmissionError = 'MEASURE_SUBMISSION_ERROR'
}

export type MeasureSubmissionFieldOrder = {
  __typename: 'MeasureSubmissionFieldOrder';
  carbonFarmingSeason?: Maybe<CarbonFarmingSeason>;
  errors?: Maybe<Array<Maybe<MeasureSubmissionFieldOrderError>>>;
  field?: Maybe<FieldV2>;
  status: MeasureSubmissionStatus;
  uuid: Scalars['UUID']['output'];
};

export type MeasureSubmissionFieldOrderError = {
  __typename: 'MeasureSubmissionFieldOrderError';
  code: MeasureSubmissionErrorCode;
  message: Scalars['String']['output'];
};

export type MeasureSubmissionFieldResult = {
  __typename: 'MeasureSubmissionFieldResult';
  area?: Maybe<Scalars['Float']['output']>;
  ch4SoilPreliminaryCredit?: Maybe<Scalars['Float']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  directN2OPreliminaryCredit?: Maybe<Scalars['Float']['output']>;
  dsocPreliminaryCredit?: Maybe<Scalars['Float']['output']>;
  field?: Maybe<FieldV2>;
  indirectN2OPreliminaryCredit?: Maybe<Scalars['Float']['output']>;
  postUncertaintyNonReversibleCredit?: Maybe<Scalars['Float']['output']>;
  postUncertaintyReversibleCredit?: Maybe<Scalars['Float']['output']>;
  totalNonReversiblePreliminaryCredit?: Maybe<Scalars['Float']['output']>;
  totalPreliminaryCredit?: Maybe<Scalars['Float']['output']>;
  totalReversiblePreliminaryCredit?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  weightedCreditShare?: Maybe<Scalars['Float']['output']>;
  yield?: Maybe<Scalars['Float']['output']>;
};

export enum MeasureSubmissionMode {
  Production = 'PRODUCTION',
  Test = 'TEST'
}

export type MeasureSubmissionOrder = {
  __typename: 'MeasureSubmissionOrder';
  baselineMethod?: Maybe<BaselineMethod>;
  country: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  fields?: Maybe<Array<Maybe<MeasureSubmissionFieldOrder>>>;
  /**  RFC3339 timestamp */
  finalizedAt?: Maybe<Scalars['String']['output']>;
  harvestYear: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  statistics: MeasureSubmissionOrderStatistics;
  /**  RFC3339 timestamp */
  status: MeasureSubmissionStatus;
  submissionMode?: Maybe<MeasureSubmissionMode>;
  sustainabilityProgram?: Maybe<SustainabilityProgram>;
  uuid: Scalars['UUID']['output'];
};

export type MeasureSubmissionOrderStatistics = {
  __typename: 'MeasureSubmissionOrderStatistics';
  numberOfFailedFields?: Maybe<Scalars['Int']['output']>;
  numberOfFieldsToSubmit: Scalars['Int']['output'];
  numberOfSubmittedFields?: Maybe<Scalars['Int']['output']>;
};

export type MeasureSubmissionProjectLevelCropResult = {
  __typename: 'MeasureSubmissionProjectLevelCropResult';
  cropName: Scalars['String']['output'];
  numberOfFields?: Maybe<Scalars['Int']['output']>;
  totalCredits?: Maybe<Scalars['Float']['output']>;
  totalNonReversibleEmissionReductions?: Maybe<Scalars['Float']['output']>;
  totalReversibleEmissionReductions?: Maybe<Scalars['Float']['output']>;
  totalYield?: Maybe<Scalars['Float']['output']>;
};

export type MeasureSubmissionProjectLevelResult = {
  __typename: 'MeasureSubmissionProjectLevelResult';
  numberOfFields?: Maybe<Scalars['Int']['output']>;
  totalCredits?: Maybe<Scalars['Float']['output']>;
  totalNonReversibleEmissionReductions?: Maybe<Scalars['Float']['output']>;
  totalReversibleEmissionReductions?: Maybe<Scalars['Float']['output']>;
  totalYield?: Maybe<Scalars['Float']['output']>;
};

export type MeasureSubmissionResult = {
  __typename: 'MeasureSubmissionResult';
  country: Scalars['String']['output'];
  fields?: Maybe<Array<Maybe<MeasureSubmissionFieldResult>>>;
  measureSubmissionOrder: MeasureSubmissionOrder;
  /** # deprecated */
  projectLevelCropResults?: Maybe<Array<Maybe<MeasureSubmissionProjectLevelCropResult>>>;
  projectLevelResult?: Maybe<MeasureSubmissionProjectLevelResult>;
  projectLevelResultByCrop?: Maybe<Array<Maybe<MeasureSubmissionProjectLevelCropResult>>>;
  uuid: Scalars['UUID']['output'];
};

export enum MeasureSubmissionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type Measurement = {
  __typename: 'Measurement';
  assessmentObjectUuid?: Maybe<Scalars['UUID']['output']>;
  displayUnit?: Maybe<Scalars['String']['output']>;
  measurement?: Maybe<SoilPropertyType>;
  siValue?: Maybe<Scalars['Float']['output']>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum MergeOrigin {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export enum MergedExecutionStatus {
  Active = 'ACTIVE',
  Unmerged = 'UNMERGED'
}

export type MergedSmartSprayerExecution = {
  __typename: 'MergedSmartSprayerExecution';
  /** Always false for merged executions; archive/restore is not supported for multi-machine merges. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  count: Scalars['Int']['output'];
  executionDates?: Maybe<Array<Scalars['Date']['output']>>;
  externalTaskUuids?: Maybe<Array<Scalars['String']['output']>>;
  mergeOrigin?: Maybe<MergeOrigin>;
  /** List of registrations associated with this merged execution. Always contains at least one registration. */
  smartSprayerRegistrations: Array<SmartSprayerRegistration>;
  status?: Maybe<MergedExecutionStatus>;
  uuid: Scalars['UUID']['output'];
};

export type MissingInfoDataMapping = {
  __typename: 'MissingInfoDataMapping';
  applicableColumns?: Maybe<ApplicableColumn>;
  applicableUnits?: Maybe<ApplicableUnit>;
  measurement?: Maybe<FieldDataMeasurement>;
};

export type MissingInfoDate = {
  __typename: 'MissingInfoDate';
  bestGuess?: Maybe<Scalars['String']['output']>;
};

export type MissingInfoExampleData = {
  __typename: 'MissingInfoExampleData';
  columnIndex?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type MissingInfoUploadDatasetType = {
  __typename: 'MissingInfoUploadDatasetType';
  bestGuess?: Maybe<UploadDatasetType>;
  possibleValues?: Maybe<Array<Maybe<UploadDatasetType>>>;
};

export type MonitorCoverCrop = {
  __typename: 'MonitorCoverCrop';
  coverCropConfidenceIndex?: Maybe<Scalars['Float']['output']>;
  coverCropDetected?: Maybe<CoverCrop>;
};

export type MonitorPractice = {
  __typename: 'MonitorPractice';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  coverCrops?: Maybe<Array<Maybe<MonitorCoverCrop>>>;
  cropUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  field?: Maybe<FieldV2>;
  tillages?: Maybe<Array<Maybe<MonitorTillage>>>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type MonitorTillage = {
  __typename: 'MonitorTillage';
  confidenceIndex?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  tillageIntensity?: Maybe<Scalars['String']['output']>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
};

export type MultiFile = {
  __typename: 'MultiFile';
  fileName?: Maybe<Scalars['String']['output']>;
  offsetInBytes?: Maybe<Scalars['Float']['output']>;
  partNumber?: Maybe<Scalars['Int']['output']>;
  s3UploadUrl?: Maybe<Scalars['String']['output']>;
  sizeInBytes?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<FileUploadStatus>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum MultiFileSource {
  DroneFlight = 'DRONE_FLIGHT'
}

export type MultiFileUploadOrder = {
  __typename: 'MultiFileUploadOrder';
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<MultiFile>>>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<MultiFileSource>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<FileUploadOrderStatus>;
  totalUploadSizeInBytes?: Maybe<Scalars['Float']['output']>;
  uploadType?: Maybe<MultiFileUploadType>;
  uploadedSizeInBytes?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum MultiFileUploadType {
  MultiFile = 'MULTI_FILE',
  MultiPart = 'MULTI_PART'
}

export type MultiWeedResult = ScoutingPoiResult & {
  __typename: 'MultiWeedResult';
  detectedWeeds?: Maybe<Array<Maybe<DetectedWeed>>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  numberOfWeeds?: Maybe<Scalars['Int']['output']>;
  numberOfWeedsPerSquareMeter?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<ScoutingPoiResultStatus>;
  weedCoverage?: Maybe<Scalars['Float']['output']>;
};

/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type Mutation = {
  __typename: 'Mutation';
  createCropSeasonStatusReportEmailSubscription?: Maybe<CropSeasonStatusReportEmailSubscription>;
  createFarmReceipt?: Maybe<FarmReceipt>;
  createFarmReceiptReference?: Maybe<FarmReceiptReference>;
  /** please do not use these mutations directly, use the custom hooks in @xarvio/frontend-core-graphql/hooks */
  createNodes: Array<MutationResponse>;
  createPrecifieldCerealsMapSubscription?: Maybe<PrecifieldCerealsMapSubscription>;
  createRecommendationSnooze?: Maybe<RecommendationSnooze>;
  createSpraying?: Maybe<Spraying>;
  createSprayingV2?: Maybe<SprayingV2>;
  deleteFarmReceipt?: Maybe<Scalars['UUID']['output']>;
  deleteFarmReceiptReference?: Maybe<Scalars['UUID']['output']>;
  /**
   * payload for delete can be used to place information about the parent into the mutation result
   * (since the payload is just returned from the mutation)
   */
  deleteNodes: Array<MutationResponse>;
  replaceSmartSprayerWeedPressureExclusions?: Maybe<SmartSprayerWeedPressureExclusionSet>;
  requestSmartSprayerWeedPressureRecalculation?: Maybe<SmartSprayerWeedPressureRecalculation>;
  updateFarmReceipt?: Maybe<FarmReceipt>;
  updateNodes: Array<MutationResponse>;
  updatePrecifieldCerealsMapSubscription?: Maybe<PrecifieldCerealsMapSubscription>;
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreateCropSeasonStatusReportEmailSubscriptionArgs = {
  deliveryDays: Array<InputMaybe<DeliveryDay>>;
  farmUuid: Scalars['UUID']['input'];
  locale: Scalars['String']['input'];
  sections?: InputMaybe<SectionInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreateFarmReceiptArgs = {
  farmUuid: Scalars['UUID']['input'];
  fileBatchUuid: Scalars['UUID']['input'];
  receiptKind: Array<FarmReceiptKind>;
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreateFarmReceiptReferenceArgs = {
  objectType: FarmReceiptReferenceObjectType;
  objectUuid: Scalars['UUID']['input'];
  receiptUuid: Scalars['UUID']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreateNodesArgs = {
  errorsDic?: InputMaybe<Scalars['IndexableObject']['input']>;
  keepOrder?: InputMaybe<Scalars['Boolean']['input']>;
  payloads: Array<Scalars['IndexableObject']['input']>;
  typename: Scalars['String']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreatePrecifieldCerealsMapSubscriptionArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
  nitrogenTargetRate: Scalars['Float']['input'];
  productUuid: Scalars['UUID']['input'];
  yieldFiveYearOlympicAverage: Scalars['Float']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreateRecommendationSnoozeArgs = {
  actionType: RecommendationSnoozeType;
  cropSeasonUuid: Scalars['UUID']['input'];
  validTill?: InputMaybe<Scalars['Date']['input']>;
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreateSprayingArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<DosedMapInput>;
  plannedDate: Scalars['Date']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationCreateSprayingV2Args = {
  cropSeasonUuid: Scalars['UUID']['input'];
  executionDate?: InputMaybe<Scalars['Date']['input']>;
  input?: InputMaybe<DosedMapInput>;
  plannedDate: Scalars['Date']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationDeleteFarmReceiptArgs = {
  uuid: Scalars['UUID']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationDeleteFarmReceiptReferenceArgs = {
  uuid: Scalars['UUID']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationDeleteNodesArgs = {
  errorsDic?: InputMaybe<Scalars['IndexableObject']['input']>;
  keepOrder?: InputMaybe<Scalars['Boolean']['input']>;
  nodes: Array<Scalars['NodeWithTypename']['input']>;
  payloads?: InputMaybe<Array<Scalars['IndexableObject']['input']>>;
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationReplaceSmartSprayerWeedPressureExclusionsArgs = {
  exclusions: Array<Scalars['UUID']['input']>;
  fieldUuid: Scalars['UUID']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationRequestSmartSprayerWeedPressureRecalculationArgs = {
  farmUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fieldUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  reason: SmartSprayerWeedPressureRecalculationReason;
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationUpdateFarmReceiptArgs = {
  etag: Scalars['String']['input'];
  fileBatchUuid: Scalars['UUID']['input'];
  uuid: Scalars['UUID']['input'];
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationUpdateNodesArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  errorsDic?: InputMaybe<Scalars['IndexableObject']['input']>;
  ignoreUuid?: InputMaybe<Scalars['Boolean']['input']>;
  keepOrder?: InputMaybe<Scalars['Boolean']['input']>;
  nodes: Array<Scalars['NodeWithTypename']['input']>;
  payloads: Array<Scalars['IndexableObject']['input']>;
  updateType?: InputMaybe<UpdateType>;
};


/**
 *  Define Scalar and common enum/type in the common.graphqls
 *  Add type definition in the service.graphqls
 */
export type MutationUpdatePrecifieldCerealsMapSubscriptionArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
  nitrogenTargetRate: Scalars['Float']['input'];
  productUuid: Scalars['UUID']['input'];
  uuid: Scalars['UUID']['input'];
  yieldFiveYearOlympicAverage: Scalars['Float']['input'];
};

export type MutationResponse = {
  __typename: 'MutationResponse';
  context?: Maybe<Scalars['IndexableObject']['output']>;
  errors?: Maybe<Array<ResponseStatus>>;
  node: Scalars['NodeWithTypename']['output'];
  payload?: Maybe<Scalars['IndexableObject']['output']>;
  restResponse?: Maybe<Scalars['IndexableObject']['output']>;
};

export type NamedCropMix = {
  __typename: 'NamedCropMix';
  crops: Array<CropMixDetail>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  /**  this is mandatory because a MD2 or custom mix entity must exist for it */
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  isRetracted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type NitrogenProduct = {
  __typename: 'NitrogenProduct';
  nutrients?: Maybe<Array<Maybe<NutrientProduct>>>;
  rate?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type NitrogenStatusResult = ScoutingPoiResult & {
  __typename: 'NitrogenStatusResult';
  detectedNitrogenStatus?: Maybe<DetectedNitrogenStatus>;
  status?: Maybe<ScoutingPoiResultStatus>;
};

export type NitrogenType = {
  __typename: 'NitrogenType';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Notification = {
  __typename: 'Notification';
  /** @deprecated Use `farmV2`. */
  farm?: Maybe<Farm>;
  farmV2?: Maybe<FarmV2>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  object?: Maybe<NotificationObject>;
  payload?: Maybe<NotificationPayload>;
  scheduledDate: Scalars['Date']['output'];
  type: NotificationType;
  uuid: Scalars['UUID']['output'];
};

export type NotificationConfiguration = {
  __typename: 'NotificationConfiguration';
  notificationEnd?: Maybe<Scalars['Date']['output']>;
  notificationStart?: Maybe<Scalars['Date']['output']>;
  notificationType?: Maybe<NotificationType>;
};

export type NotificationObject = CropSeason | DroneFlight | FieldV2 | Permission | Spraying;

export type NotificationPayload = {
  __typename: 'NotificationPayload';
  index?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scale>;
  stress?: Maybe<Stress>;
  stressV2?: Maybe<StressV2>;
  upcomingInDays?: Maybe<Scalars['Int']['output']>;
};

export type NotificationPreference = {
  __typename: 'NotificationPreference';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasons?: Maybe<Array<Maybe<NotificationPreferenceCropSeason>>>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type NotificationPreferenceCropSeason = {
  __typename: 'NotificationPreferenceCropSeason';
  cropSeason?: Maybe<CropSeasonV2>;
  notifications?: Maybe<Array<Maybe<NotificationConfiguration>>>;
};

export enum NotificationType {
  BlackrotRiskCharacteristicReachedHigh = 'BLACKROT_RISK_CHARACTERISTIC_REACHED_HIGH',
  BlackrotRiskCharacteristicReachedMediumHigh = 'BLACKROT_RISK_CHARACTERISTIC_REACHED_MEDIUM_HIGH',
  BlackrotRiskCharacteristicReachedMediumLow = 'BLACKROT_RISK_CHARACTERISTIC_REACHED_MEDIUM_LOW',
  BotrytisRiskCharacteristicReachedHigh = 'BOTRYTIS_RISK_CHARACTERISTIC_REACHED_HIGH',
  CropSeasonAutoClosure = 'CROP_SEASON_AUTO_CLOSURE',
  CropSeasonNutritionProgramTaskUpcoming = 'CROP_SEASON_NUTRITION_PROGRAM_TASK_UPCOMING',
  CryptobladesDevelopmentStageReachedCumEggG3 = 'CRYPTOBLADES_DEVELOPMENT_STAGE_REACHED_CUM_EGG_G3',
  DownyMildewRiskCharacteristicReachedHigh = 'DOWNY_MILDEW_RISK_CHARACTERISTIC_REACHED_HIGH',
  DownyMildewRiskCharacteristicReachedMediumHigh = 'DOWNY_MILDEW_RISK_CHARACTERISTIC_REACHED_MEDIUM_HIGH',
  DownyMildewRiskCharacteristicReachedMediumLow = 'DOWNY_MILDEW_RISK_CHARACTERISTIC_REACHED_MEDIUM_LOW',
  DroneFlightCreated = 'DRONE_FLIGHT_CREATED',
  DroneFlightErrorReceived = 'DRONE_FLIGHT_ERROR_RECEIVED',
  DroneFlightExecuted = 'DRONE_FLIGHT_EXECUTED',
  DroneFlightScheduleDateUpdated = 'DRONE_FLIGHT_SCHEDULE_DATE_UPDATED',
  DroneFlightWarningReceived = 'DRONE_FLIGHT_WARNING_RECEIVED',
  FarmAccessRequest = 'FARM_ACCESS_REQUEST',
  FertilizerRecommendation = 'FERTILIZER_RECOMMENDATION',
  FrostRiskHigh = 'FROST_RISK_HIGH',
  FungicideRecommendation = 'FUNGICIDE_RECOMMENDATION',
  GrowthStageReached = 'GROWTH_STAGE_REACHED',
  GrowthStageUpcoming = 'GROWTH_STAGE_UPCOMING',
  HarvestOverdue = 'HARVEST_OVERDUE',
  HarvestUpcoming = 'HARVEST_UPCOMING',
  HeatWaveHigh = 'HEAT_WAVE_HIGH',
  HeatWaveLow = 'HEAT_WAVE_LOW',
  HeatWaveMedium = 'HEAT_WAVE_MEDIUM',
  HighDiseaseRiskReached = 'HIGH_DISEASE_RISK_REACHED',
  ImportantGrowthStageEnding = 'IMPORTANT_GROWTH_STAGE_ENDING',
  ImportantGrowthStageUpcoming = 'IMPORTANT_GROWTH_STAGE_UPCOMING',
  Information = 'INFORMATION',
  InsecticideRecommendation = 'INSECTICIDE_RECOMMENDATION',
  InsectRisk = 'INSECT_RISK',
  InvitedUserSignsup = 'INVITED_USER_SIGNSUP',
  LeafhopperDevelopmentStageReachedCumNeanidiISc = 'LEAFHOPPER_DEVELOPMENT_STAGE_REACHED_CUM_NEANIDI_I_SC',
  LeafhopperDevelopmentStageReachedCumNinfeIiiSc = 'LEAFHOPPER_DEVELOPMENT_STAGE_REACHED_CUM_NINFE_III_SC',
  LobesiaDevelopmentStageReachedCumEggG2 = 'LOBESIA_DEVELOPMENT_STAGE_REACHED_CUM_EGG_G2',
  LobesiaDevelopmentStageReachedCumEggG3 = 'LOBESIA_DEVELOPMENT_STAGE_REACHED_CUM_EGG_G3',
  LobesiaDevelopmentStageReachedCumLarvaG2 = 'LOBESIA_DEVELOPMENT_STAGE_REACHED_CUM_LARVA_G2',
  LobesiaDevelopmentStageReachedCumLarvaG3 = 'LOBESIA_DEVELOPMENT_STAGE_REACHED_CUM_LARVA_G3',
  MediumDiseaseRiskReached = 'MEDIUM_DISEASE_RISK_REACHED',
  NewBiomassMapAvailable = 'NEW_BIOMASS_MAP_AVAILABLE',
  NewFarmShared = 'NEW_FARM_SHARED',
  NewFdlAvailable = 'NEW_FDL_AVAILABLE',
  NewPowerZoneMapAvailable = 'NEW_POWER_ZONE_MAP_AVAILABLE',
  NewWeedMapAvailable = 'NEW_WEED_MAP_AVAILABLE',
  ObservationRequest = 'OBSERVATION_REQUEST',
  OptimalDmcAchieved = 'OPTIMAL_DMC_ACHIEVED',
  OptimalDmcEntered = 'OPTIMAL_DMC_ENTERED',
  PlanococcusDevelopmentStageReachedCumNeanidiIG1 = 'PLANOCOCCUS_DEVELOPMENT_STAGE_REACHED_CUM_NEANIDI_I_G1',
  PlanococcusDevelopmentStageReachedCumNeanidiIG2 = 'PLANOCOCCUS_DEVELOPMENT_STAGE_REACHED_CUM_NEANIDI_I_G2',
  PlanococcusDevelopmentStageReachedCumNeanidiIG3 = 'PLANOCOCCUS_DEVELOPMENT_STAGE_REACHED_CUM_NEANIDI_I_G3',
  PlantGrowthRegulatorRecommendation = 'PLANT_GROWTH_REGULATOR_RECOMMENDATION',
  PowderyMildewRiskCharacteristicReachedHigh = 'POWDERY_MILDEW_RISK_CHARACTERISTIC_REACHED_HIGH',
  PowderyMildewRiskCharacteristicReachedMediumHigh = 'POWDERY_MILDEW_RISK_CHARACTERISTIC_REACHED_MEDIUM_HIGH',
  PowderyMildewRiskCharacteristicReachedMediumLow = 'POWDERY_MILDEW_RISK_CHARACTERISTIC_REACHED_MEDIUM_LOW',
  ProcessingDeniedQuotaExhausted = 'PROCESSING_DENIED_QUOTA_EXHAUSTED',
  ProcessingFailed = 'PROCESSING_FAILED',
  ResidualActivationFailure = 'RESIDUAL_ACTIVATION_FAILURE',
  ResidualActivationPending = 'RESIDUAL_ACTIVATION_PENDING',
  ResidualActivationRecommendationOutlook = 'RESIDUAL_ACTIVATION_RECOMMENDATION_OUTLOOK',
  ResidualActivationRecommendationZidua = 'RESIDUAL_ACTIVATION_RECOMMENDATION_ZIDUA',
  ResidualActivationScouting = 'RESIDUAL_ACTIVATION_SCOUTING',
  ResidualActivationSuccess = 'RESIDUAL_ACTIVATION_SUCCESS',
  ScoutingTaskAssigned = 'SCOUTING_TASK_ASSIGNED',
  ScoutingTripAssigned = 'SCOUTING_TRIP_ASSIGNED',
  SeedboxTreatmentTaskAssigned = 'SEEDBOX_TREATMENT_TASK_ASSIGNED',
  SeedboxTreatmentTaskCreated = 'SEEDBOX_TREATMENT_TASK_CREATED',
  SeedboxTreatmentTaskScheduledToday = 'SEEDBOX_TREATMENT_TASK_SCHEDULED_TODAY',
  SeedingTaskAssigned = 'SEEDING_TASK_ASSIGNED',
  SeedingTaskCreated = 'SEEDING_TASK_CREATED',
  SeedTreatmentTaskAssigned = 'SEED_TREATMENT_TASK_ASSIGNED',
  SeedTreatmentTaskCreated = 'SEED_TREATMENT_TASK_CREATED',
  SeedTreatmentTaskScheduledToday = 'SEED_TREATMENT_TASK_SCHEDULED_TODAY',
  SprayRecommendation = 'SPRAY_RECOMMENDATION',
  StartMigration = 'START_MIGRATION',
  SuboptimalDmcAchieved = 'SUBOPTIMAL_DMC_ACHIEVED',
  SuboptimalDmcEntered = 'SUBOPTIMAL_DMC_ENTERED',
  TaskAssigned = 'TASK_ASSIGNED',
  TaskCreated = 'TASK_CREATED',
  TaskOverdue = 'TASK_OVERDUE',
  TaskPlannedDateUpdated = 'TASK_PLANNED_DATE_UPDATED',
  TaskScheduledToday = 'TASK_SCHEDULED_TODAY',
  Unknown = 'UNKNOWN',
  WaterAvailabilityRiskHigh = 'WATER_AVAILABILITY_RISK_HIGH',
  WaterAvailabilityRiskMedium = 'WATER_AVAILABILITY_RISK_MEDIUM',
  WaterRecommendation = 'WATER_RECOMMENDATION',
  YellowTrapNotification = 'YELLOW_TRAP_NOTIFICATION'
}

export type Nutrient = {
  __typename: 'Nutrient';
  code?: Maybe<Scalars['String']['output']>;
  concentrationPercentage?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type NutrientMethodMapping = {
  __typename: 'NutrientMethodMapping';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  distributorCode?: Maybe<Scalars['String']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  distributorUuid?: Maybe<Scalars['UUID']['output']>;
  nutrientCode?: Maybe<Scalars['String']['output']>;
  nutrientMethodCode?: Maybe<Scalars['String']['output']>;
  nutrientMethodName?: Maybe<Scalars['String']['output']>;
  nutrientMethodUuid?: Maybe<Scalars['UUID']['output']>;
  nutrientName?: Maybe<Scalars['String']['output']>;
  nutrientUuid?: Maybe<Scalars['UUID']['output']>;
};

export type NutrientProduct = {
  __typename: 'NutrientProduct';
  rate?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type NutrientRate = {
  __typename: 'NutrientRate';
  nutrientUuid?: Maybe<Scalars['UUID']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export enum NutrientRateUnitCode {
  KgHa = 'KG_HA',
  KgM2 = 'KG_M2'
}

export type NutritionActionDetail = {
  __typename: 'NutritionActionDetail';
  applicationTypes?: Maybe<Array<Maybe<NutritionApplicationType>>>;
  appliedNutrients?: Maybe<Array<Maybe<NutrientRate>>>;
  nutrients?: Maybe<Array<Maybe<NutritionActionNutrient>>>;
  nutrientsDemandDelta?: Maybe<Array<Maybe<NutrientRate>>>;
  products?: Maybe<Array<Maybe<NutritionActionProduct>>>;
  totalNutrients?: Maybe<Array<Maybe<NutrientRate>>>;
  type?: Maybe<NutritionRecommendationActionType>;
  validFrom?: Maybe<NutritionActionValidity>;
  validTill?: Maybe<NutritionActionValidity>;
};

export type NutritionActionNutrient = {
  __typename: 'NutritionActionNutrient';
  nutrientUuid?: Maybe<Scalars['UUID']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  relativePowerOfTotalNeutralisation?: Maybe<Scalars['Float']['output']>;
  samplingAreaId?: Maybe<Scalars['String']['output']>;
};

export type NutritionActionProduct = {
  __typename: 'NutritionActionProduct';
  nutrients?: Maybe<Array<Maybe<NutrientRate>>>;
  product?: Maybe<ProductV2>;
  rate?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type NutritionActionValidity = {
  __typename: 'NutritionActionValidity';
  calendarDate?: Maybe<Scalars['Date']['output']>;
  daysAfterSeeding?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `growthStageIndexAsString`. */
  growthStageIndex?: Maybe<Scalars['Int']['output']>;
  growthStageIndexAsString?: Maybe<Scalars['String']['output']>;
  growthStageScale?: Maybe<ScaleV2>;
  type?: Maybe<NutritionActionValidityType>;
};

export enum NutritionActionValidityType {
  DaysAfterSeeding = 'DAYS_AFTER_SEEDING',
  GrowthStage = 'GROWTH_STAGE'
}

export enum NutritionApplicationType {
  Flat = 'FLAT',
  OnOff = 'ON_OFF',
  Vra = 'VRA',
  VraHerb = 'VRA_HERB'
}

export enum NutritionProgramProvider {
  Custom = 'CUSTOM',
  Horta = 'HORTA',
  Precifield = 'PRECIFIELD',
  Xarvio = 'XARVIO',
  Yara = 'YARA'
}

export enum NutritionProgramStrategy {
  Agronomic = 'AGRONOMIC',
  Custom = 'CUSTOM',
  Legal = 'LEGAL',
  Recommended = 'RECOMMENDED'
}

export type NutritionRecommendation = {
  __typename: 'NutritionRecommendation';
  actionType?: Maybe<NutritionRecommendationActionType>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  confidenceLevel?: Maybe<ConfidenceLevel>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
  description?: Maybe<Scalars['String']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<NutritionRecommendationStatus>;
};

export enum NutritionRecommendationActionType {
  FertilizerApplication = 'FERTILIZER_APPLICATION'
}

export enum NutritionRecommendationStatus {
  NotNeeded = 'NOT_NEEDED',
  Recommended = 'RECOMMENDED'
}

export type NutritionStacItemVectorization = {
  __typename: 'NutritionStacItemVectorization';
  centerZoneId?: Maybe<Scalars['Int']['output']>;
  geometry: Scalars['JSONObject']['output'];
  index: AgronomicIndexType;
  numberOfZones: Scalars['Int']['output'];
  stacItemUuid: Scalars['UUID']['output'];
  zonePercentageDifferences: Array<ZonePercentageDifference>;
  zoneStatistics: Array<ZoneStatisticsItem>;
};

export type NutritionStatus = {
  __typename: 'NutritionStatus';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<NutritionStatusState>;
  type: NutritionStatusType;
};

export enum NutritionStatusState {
  High = 'HIGH',
  Low = 'LOW',
  Protected = 'PROTECTED'
}

export enum NutritionStatusType {
  Nutrition = 'NUTRITION'
}

export type NutritionTargetRate = {
  __typename: 'NutritionTargetRate';
  cropRate?: Maybe<Scalars['Float']['output']>;
  nutrientUuid?: Maybe<Scalars['UUID']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  soilRate?: Maybe<Scalars['Float']['output']>;
};

export type Observation = {
  __typename: 'Observation';
  creatorId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `cropSeasonV2` */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
  executionDate?: Maybe<Scalars['Date']['output']>;
  /**  need to keep in order to avoid breaking existing clients */
  importantStage?: Maybe<ImportantGrowthStage>;
  importantStageUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  leafCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `stressAnswers`. */
  stressAnswerUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  stressAnswers?: Maybe<Array<Maybe<StressAnswer>>>;
  uuid: Scalars['UUID']['output'];
  yieldExpectation?: Maybe<Scalars['Float']['output']>;
};


export type ObservationStressAnswersArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationWeather = {
  __typename: 'ObservationWeather';
  endDate?: Maybe<Scalars['Date']['output']>;
  precipitationMmAcc?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export enum OfferModel {
  Access = 'ACCESS',
  Daxur = 'DAXUR',
  Essential = 'ESSENTIAL',
  Flexbio = 'FLEXBIO',
  Flexhigh = 'FLEXHIGH',
  Flexlow = 'FLEXLOW',
  Premium = 'PREMIUM',
  Premiumhigh = 'PREMIUMHIGH',
  Premiumlow = 'PREMIUMLOW',
  Standard = 'STANDARD',
  Ultra = 'ULTRA'
}

/** just on local schema to be able to use REST endpoint */
export type OfflineBasedSmartSprayingTask = {
  __typename: 'OfflineBasedSmartSprayingTask';
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type OnOffStatistics = {
  __typename: 'OnOffStatistics';
  areaOff?: Maybe<Scalars['Float']['output']>;
  areaOn?: Maybe<Scalars['Float']['output']>;
  fieldDataLayer?: Maybe<FieldDataLayer>;
  regionId?: Maybe<Scalars['String']['output']>;
};

export type OneSoilApplicationMapDispatchOrder = {
  __typename: 'OneSoilApplicationMapDispatchOrder';
  deviceManufacturerUuid?: Maybe<Scalars['UUID']['output']>;
  dispatchDate?: Maybe<Scalars['Date']['output']>;
  format?: Maybe<OneSoilApplicationMapDispatchOrderFormat>;
  status?: Maybe<OneSoilApplicationMapDispatchOrderStatus>;
  taskType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `taskUuids`. */
  taskUuid?: Maybe<Scalars['UUID']['output']>;
  taskUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  terminalCode?: Maybe<Scalars['String']['output']>;
  userDeviceUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum OneSoilApplicationMapDispatchOrderFormat {
  Isoxml = 'ISOXML',
  Shp = 'SHP'
}

export enum OneSoilApplicationMapDispatchOrderStatus {
  DeliveryFailed = 'DELIVERY_FAILED',
  DeliverySuccessful = 'DELIVERY_SUCCESSFUL',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Uploaded = 'UPLOADED'
}

export enum OneSoilApplicationMapDispatchOrderTaskType {
  Seeding = 'SEEDING',
  Spraying = 'SPRAYING'
}

export type OneSoilDevice = {
  __typename: 'OneSoilDevice';
  batteryLevel?: Maybe<Scalars['Float']['output']>;
  batteryLevelPercent?: Maybe<Scalars['Int']['output']>;
  deviceId: Scalars['String']['output'];
  /** @deprecated Use `UserDevice.features` */
  deviceLicense?: Maybe<OneSoilDeviceLicense>;
  deviceVersion?: Maybe<Scalars['String']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  lastCellularProvider?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['String']['output']>;
  locationLat?: Maybe<Scalars['Float']['output']>;
  locationLon?: Maybe<Scalars['Float']['output']>;
  networkType?: Maybe<Scalars['String']['output']>;
  rssi?: Maybe<Scalars['Float']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  storageSizeTotal?: Maybe<Scalars['Float']['output']>;
  storageSizeUsed?: Maybe<Scalars['Float']['output']>;
  syncIntervalBatterySeconds?: Maybe<Scalars['Float']['output']>;
  syncIntervalPowerSeconds?: Maybe<Scalars['Float']['output']>;
};

export type OneSoilDeviceLicense = {
  __typename: 'OneSoilDeviceLicense';
  creatorId?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  licenseValidTill?: Maybe<Scalars['Date']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type OneSoilFarmReceivedFile = {
  __typename: 'OneSoilFarmReceivedFile';
  farm?: Maybe<FarmV2>;
  receivedFile?: Maybe<OneSoilReceivedFile>;
  uploadDatasetUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type OneSoilReceivedFile = {
  __typename: 'OneSoilReceivedFile';
  acquisitionDate?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  farmReceivedFiles?: Maybe<Array<Maybe<OneSoilFarmReceivedFile>>>;
  fileName?: Maybe<Scalars['String']['output']>;
  sourceEvent?: Maybe<OneSoilReceivedFileSourceEvent>;
  uuid: Scalars['UUID']['output'];
};

export enum OneSoilReceivedFileSourceEvent {
  AsAppliedCreated = 'AS_APPLIED_CREATED',
  FileUploaded = 'FILE_UPLOADED',
  IsoxmlCreated = 'ISOXML_CREATED'
}

export type OneSoilUploadDatasetOrder = {
  __typename: 'OneSoilUploadDatasetOrder';
  farm?: Maybe<FarmV2>;
  receivedFiles?: Maybe<Array<Maybe<OneSoilReceivedFile>>>;
  status?: Maybe<OnesoilUploadDatasetOrderStatus>;
  uploadDatasetResults?: Maybe<Array<Maybe<OneSoilUploadDatasetResult>>>;
  uuid: Scalars['UUID']['output'];
};

export type OneSoilUploadDatasetResult = {
  __typename: 'OneSoilUploadDatasetResult';
  receivedFile?: Maybe<OneSoilReceivedFile>;
  uploadDatasetUuid: Scalars['UUID']['output'];
};

export enum OnesoilUploadDatasetOrderStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum OperationMode {
  Burndown = 'BURNDOWN',
  Smartsprayer = 'SMARTSPRAYER'
}

export type OrderAffiliate = {
  __typename: 'OrderAffiliate';
  affiliateCodeUuid?: Maybe<Scalars['UUID']['output']>;
  farm?: Maybe<Farm>;
  orderId?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum OrderState {
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Complete = 'COMPLETE',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  PaymentReview = 'PAYMENT_REVIEW',
  PendingPayment = 'PENDING_PAYMENT',
  Processing = 'PROCESSING'
}

export type Organisation = {
  __typename: 'Organisation';
  active?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<Address>;
  code?: Maybe<Scalars['String']['output']>;
  contactInformation?: Maybe<ContactInformation>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Group>>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationTags?: Maybe<Array<Maybe<OrganisationTagType>>>;
  organisationType?: Maybe<OrganisationType>;
  owner?: Maybe<User>;
  quotas?: Maybe<Array<Maybe<OrganisationQuota>>>;
  taxId?: Maybe<Scalars['String']['output']>;
  tenantUuid?: Maybe<Scalars['UUID']['output']>;
  trustedDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid: Scalars['UUID']['output'];
};

export type OrganisationBranch = {
  __typename: 'OrganisationBranch';
  address?: Maybe<Address>;
  etag?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  uuid: Scalars['UUID']['output'];
};

export type OrganisationFarmAssignment = {
  __typename: 'OrganisationFarmAssignment';
  etag?: Maybe<Scalars['String']['output']>;
  farm: FarmV2;
  organisation?: Maybe<Organisation>;
  role?: Maybe<OrganisationFarmAssignmentRole>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum OrganisationFarmAssignmentRole {
  PrimaryCommercialPartner = 'PRIMARY_COMMERCIAL_PARTNER',
  ServicePartner = 'SERVICE_PARTNER'
}

export type OrganisationFeature = {
  __typename: 'OrganisationFeature';
  dateCreated?: Maybe<Scalars['Date']['output']>;
  enable: Scalars['Boolean']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  feature: OrganisationFeatureType;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  organisation: Organisation;
  uuid: Scalars['UUID']['output'];
};

export enum OrganisationFeatureType {
  BusinessDashboard = 'BUSINESS_DASHBOARD',
  BusinessLine = 'BUSINESS_LINE',
  BusinessOverview = 'BUSINESS_OVERVIEW',
  EasyLicenseManagement = 'EASY_LICENSE_MANAGEMENT',
  ExpertScoutingTrip = 'EXPERT_SCOUTING_TRIP'
}

export type OrganisationMember = {
  __typename: 'OrganisationMember';
  branch?: Maybe<OrganisationBranch>;
  coOwner?: Maybe<Scalars['Boolean']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  groupUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  manager?: Maybe<OrganisationMember>;
  organisation?: Maybe<Organisation>;
  privileges?: Maybe<Array<OrganisationMemberPrivilege>>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
};

export enum OrganisationMemberPrivilege {
  OperateBioenergy = 'OPERATE_BIOENERGY',
  ReadBioenergy = 'READ_BIOENERGY',
  ReadCommercial = 'READ_COMMERCIAL',
  SignBioenergy = 'SIGN_BIOENERGY',
  WriteCommercial = 'WRITE_COMMERCIAL'
}

export type OrganisationMembershipRequest = {
  __typename: 'OrganisationMembershipRequest';
  branch?: Maybe<OrganisationBranch>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<OrganisationMember>;
  organisation?: Maybe<PublicOrganisation>;
  requestee?: Maybe<User>;
  requesteeEmail?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<User>;
  status?: Maybe<OrganisationMembershipRequestStatus>;
  uuid: Scalars['UUID']['output'];
};

export enum OrganisationMembershipRequestStatus {
  Accepted = 'ACCEPTED',
  AutoAccepted = 'AUTO_ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export type OrganisationMethod = {
  __typename: 'OrganisationMethod';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  methodUuid: Scalars['UUID']['output'];
  organisation: Organisation;
  uuid: Scalars['UUID']['output'];
};

export type OrganisationQuota = {
  __typename: 'OrganisationQuota';
  consumedQuota?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  isRetracted?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<License>;
  maxQuota?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<LicenseRequestSeason>;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type OrganisationQuotaLedger = {
  __typename: 'OrganisationQuotaLedger';
  correlationUuid?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  destinationQuotaCreditUuid?: Maybe<Scalars['UUID']['output']>;
  destinationType: OrganisationQuotaPartyType;
  destinationUuid: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  license?: Maybe<License>;
  operationType: OrganisationQuotaOperationType;
  quantity: Scalars['Float']['output'];
  quotaCreditUuid?: Maybe<Scalars['UUID']['output']>;
  sourceType: OrganisationQuotaPartyType;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type OrganisationQuotaLedgerSort = {
  column: OrganisationQuotaLedgerSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum OrganisationQuotaLedgerSortColumn {
  DateCreated = 'DATE_CREATED',
  Quantity = 'QUANTITY'
}

export enum OrganisationQuotaOperationType {
  Assignment = 'ASSIGNMENT',
  LicenseRequestApproval = 'LICENSE_REQUEST_APPROVAL',
  LicenseRequestRevocation = 'LICENSE_REQUEST_REVOCATION',
  QuotaTransfer = 'QUOTA_TRANSFER',
  QuotaTransferReject = 'QUOTA_TRANSFER_REJECT'
}

export enum OrganisationQuotaPartyType {
  LicenseRequest = 'LICENSE_REQUEST',
  Organisation = 'ORGANISATION',
  Xarvio = 'XARVIO'
}

export type OrganisationTag = {
  __typename: 'OrganisationTag';
  code?: Maybe<OrganisationTagType>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum OrganisationTagType {
  BioenergyFirstPointOfAggregation = 'BIOENERGY_FIRST_POINT_OF_AGGREGATION',
  BioenergyIntermediary = 'BIOENERGY_INTERMEDIARY',
  BioenergyPlant = 'BIOENERGY_PLANT',
  BioenergyProgramOwner = 'BIOENERGY_PROGRAM_OWNER',
  BioenergyVerifier = 'BIOENERGY_VERIFIER',
  Distributor = 'DISTRIBUTOR'
}

export enum OrganisationType {
  Commercial = 'COMMERCIAL',
  Internal = 'INTERNAL',
  Personal = 'PERSONAL',
  Trial = 'TRIAL'
}

export type Organization = {
  __typename: 'Organization';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Package = {
  __typename: 'Package';
  activatesPackages?: Maybe<Array<Maybe<Package>>>;
  countryCode: Scalars['String']['output'];
  crop?: Maybe<Crop>;
  dependsOnFeatures?: Maybe<Array<Maybe<FeatureName>>>;
  farmAssignable?: Maybe<Scalars['Boolean']['output']>;
  features?: Maybe<Array<FeatureName>>;
  type?: Maybe<PackageType>;
  userAssignable?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
  validTill?: Maybe<Scalars['Date']['output']>;
  validityInDays?: Maybe<Scalars['Int']['output']>;
};

export enum PackageType {
  Activation = 'ACTIVATION',
  Foc = 'FOC',
  Regular = 'REGULAR',
  Tech = 'TECH',
  Test = 'TEST'
}

export type PaginatedFarmEvidenceLink = {
  __typename: 'PaginatedFarmEvidenceLink';
  items?: Maybe<Array<Maybe<FarmEvidenceLink>>>;
  pagination: Pagination;
};

export type PaginatedFarmReceipt = {
  __typename: 'PaginatedFarmReceipt';
  items?: Maybe<Array<Maybe<FarmReceipt>>>;
  pagination: Pagination;
};

export type PaginatedFieldDataLayer = {
  __typename: 'PaginatedFieldDataLayer';
  items?: Maybe<Array<Maybe<FieldDataLayer>>>;
  pagination: Pagination;
};

export type PaginatedFieldEvidence = {
  __typename: 'PaginatedFieldEvidence';
  items?: Maybe<Array<Maybe<FieldEvidence>>>;
  pagination: Pagination;
};

export type PaginatedFieldEvidenceLink = {
  __typename: 'PaginatedFieldEvidenceLink';
  items?: Maybe<Array<Maybe<FieldEvidenceLink>>>;
  pagination: Pagination;
};

export type PaginatedFieldNote = {
  __typename: 'PaginatedFieldNote';
  items?: Maybe<Array<Maybe<FieldNote>>>;
  pagination: Pagination;
};

export type PaginatedFile = {
  __typename: 'PaginatedFile';
  items?: Maybe<Array<Maybe<File>>>;
  pagination: Pagination;
};

export type PaginatedHfClaim = {
  __typename: 'PaginatedHfClaim';
  items?: Maybe<Array<Maybe<HfClaim>>>;
  pagination: Pagination;
};

export type PaginatedHfContractorRequest = {
  __typename: 'PaginatedHfContractorRequest';
  items?: Maybe<Array<Maybe<HfContractorRequest>>>;
  pagination: Pagination;
};

export type PaginatedHfOperationalInstruction = {
  __typename: 'PaginatedHfOperationalInstruction';
  items?: Maybe<Array<Maybe<HfOperationalInstruction>>>;
  pagination: Pagination;
};

export type PaginatedMapItem = {
  __typename: 'PaginatedMapItem';
  items?: Maybe<Array<Maybe<MapItem>>>;
  pagination: Pagination;
};

export type PaginatedMd2DictionaryMapping = {
  __typename: 'PaginatedMd2DictionaryMapping';
  content?: Maybe<Array<Maybe<Md2DictionaryMapping>>>;
  number?: Maybe<Scalars['Int']['output']>;
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  totalElements?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedOrganisation = {
  __typename: 'PaginatedOrganisation';
  items?: Maybe<Array<Maybe<Organisation>>>;
  pagination: Pagination;
};

export type PaginatedOrganisationQuotaLedger = {
  __typename: 'PaginatedOrganisationQuotaLedger';
  items?: Maybe<Array<Maybe<OrganisationQuotaLedger>>>;
  pagination: Pagination;
};

export type PaginatedPreOrder = {
  __typename: 'PaginatedPreOrder';
  items?: Maybe<Array<Maybe<PreOrder>>>;
  pagination: Pagination;
};

export type PaginatedScaleTicket = {
  __typename: 'PaginatedScaleTicket';
  items?: Maybe<Array<Maybe<ScaleTicket>>>;
  pagination: Pagination;
};

export type PaginatedScaleTicketBooking = {
  __typename: 'PaginatedScaleTicketBooking';
  items?: Maybe<Array<Maybe<ScaleTicketBooking>>>;
  pagination: Pagination;
};

export type PaginatedScaleTicketBookingDispute = {
  __typename: 'PaginatedScaleTicketBookingDispute';
  items?: Maybe<Array<Maybe<ScaleTicketBookingDispute>>>;
  pagination: Pagination;
};

export type PaginatedScaleTicketDataMapping = {
  __typename: 'PaginatedScaleTicketDataMapping';
  items?: Maybe<Array<Maybe<ScaleTicketDataMapping>>>;
  pagination: Pagination;
};

export type PaginatedScaleTicketHistory = {
  __typename: 'PaginatedScaleTicketHistory';
  items?: Maybe<Array<Maybe<ScaleTicketHistory>>>;
  pagination: Pagination;
};

export type PaginatedScaleTicketSellerMapping = {
  __typename: 'PaginatedScaleTicketSellerMapping';
  items?: Maybe<Array<Maybe<ScaleTicketSellerMapping>>>;
  pagination: Pagination;
};

export type PaginatedScaleTicketUpload = {
  __typename: 'PaginatedScaleTicketUpload';
  items?: Maybe<Array<Maybe<ScaleTicketUpload>>>;
  pagination: Pagination;
};

export type PaginatedScoutingTask = {
  __typename: 'PaginatedScoutingTask';
  items?: Maybe<Array<Maybe<ScoutingTask>>>;
  pagination: Pagination;
};

export type PaginatedSmartSprayerExecution = {
  __typename: 'PaginatedSmartSprayerExecution';
  items?: Maybe<Array<Maybe<SmartSprayerExecution>>>;
  pagination: Pagination;
};

export type PaginatedSmartSprayerRegistration = {
  __typename: 'PaginatedSmartSprayerRegistration';
  items?: Maybe<Array<Maybe<SmartSprayerRegistration>>>;
  pagination: Pagination;
};

export type PaginatedSmartSprayerWeedPressureFields = {
  __typename: 'PaginatedSmartSprayerWeedPressureFields';
  items?: Maybe<Array<Maybe<SmartSprayerWeedPressureFieldListItem>>>;
  pagination: Pagination;
  /** Fields on the page (all pages) whose calculation is still PENDING. */
  pendingFieldCount: Scalars['Int']['output'];
};

export type PaginatedSustainabilityOrganisationCapability = {
  __typename: 'PaginatedSustainabilityOrganisationCapability';
  items?: Maybe<Array<Maybe<SustainabilityOrganisationCapability>>>;
  pagination: Pagination;
};

export type PaginatedSustainabilityProgram = {
  __typename: 'PaginatedSustainabilityProgram';
  items?: Maybe<Array<Maybe<SustainabilityProgram>>>;
  pagination: Pagination;
};

export type PaginatedSustainabilityProgramBranchAssignment = {
  __typename: 'PaginatedSustainabilityProgramBranchAssignment';
  items?: Maybe<Array<Maybe<SustainabilityProgramBranchAssignment>>>;
  pagination: Pagination;
};

export type PaginatedSustainabilityProgramEnrolledField = {
  __typename: 'PaginatedSustainabilityProgramEnrolledField';
  items?: Maybe<Array<Maybe<SustainabilityProgramEnrolledField>>>;
  pagination: Pagination;
};

export type PaginatedSustainabilityProgramInvitation = {
  __typename: 'PaginatedSustainabilityProgramInvitation';
  items?: Maybe<Array<Maybe<SustainabilityProgramInvitation>>>;
  pagination: Pagination;
};

export type PaginatedSustainabilityProgramOrganisationParticipation = {
  __typename: 'PaginatedSustainabilityProgramOrganisationParticipation';
  items?: Maybe<Array<Maybe<SustainabilityProgramOrganisationParticipation>>>;
  pagination: Pagination;
};

export type PaginatedTask = {
  __typename: 'PaginatedTask';
  items?: Maybe<Array<Maybe<GeneralTask>>>;
  pagination: Pagination;
};

export type PaginatedTrialsV2 = {
  __typename: 'PaginatedTrialsV2';
  items?: Maybe<Array<Maybe<TrialV2>>>;
  pagination: Pagination;
};

export type PaginatedUploadDataset = {
  __typename: 'PaginatedUploadDataset';
  items?: Maybe<Array<Maybe<FieldDataUploadDataset>>>;
  pagination: Pagination;
};

export type PaginatedVariety = {
  __typename: 'PaginatedVariety';
  items?: Maybe<Array<Maybe<Variety>>>;
  pagination: Pagination;
};

export type Pagination = {
  __typename: 'Pagination';
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type PanoramaClient = {
  __typename: 'PanoramaClient';
  panoramaClientName?: Maybe<Scalars['String']['output']>;
  panoramaOrganization?: Maybe<PanoramaOrganization>;
};

export type PanoramaConnectionStatus = {
  __typename: 'PanoramaConnectionStatus';
  connectedOrganizations?: Maybe<Array<Maybe<PanoramaOrganization>>>;
  status?: Maybe<ConnectionStatus>;
};

export type PanoramaFarm = {
  __typename: 'PanoramaFarm';
  panoramaClientName?: Maybe<Scalars['String']['output']>;
  panoramaFarmName?: Maybe<Scalars['String']['output']>;
  panoramaOrganization?: Maybe<PanoramaOrganization>;
};

export type PanoramaField = {
  __typename: 'PanoramaField';
  alreadyImported?: Maybe<Scalars['Boolean']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  hasValidBoundary?: Maybe<Scalars['Boolean']['output']>;
  panoramaAsAppliedUuid?: Maybe<Scalars['UUID']['output']>;
  panoramaClientName?: Maybe<Scalars['String']['output']>;
  panoramaFarmName?: Maybe<Scalars['String']['output']>;
  panoramaFieldName?: Maybe<Scalars['String']['output']>;
  panoramaOrganization?: Maybe<PanoramaOrganization>;
  panoramaPlanningUuid?: Maybe<Scalars['UUID']['output']>;
};

export type PanoramaOrganization = {
  __typename: 'PanoramaOrganization';
  panoramaOrgCode?: Maybe<Scalars['String']['output']>;
  panoramaOrgName?: Maybe<Scalars['String']['output']>;
};

export type PayloadData = {
  __typename: 'PayloadData';
  description?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<AggregatedNotificationPayload>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum PaymentType {
  PostPaid = 'POST_PAID',
  PrePaid = 'PRE_PAID'
}

export type Permission = {
  __typename: 'Permission';
  access?: Maybe<Access>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  grantee?: Maybe<User>;
  granter?: Maybe<User>;
  isGranteeOwner?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  objectUuid?: Maybe<Scalars['UUID']['output']>;
  tags?: Maybe<Array<Maybe<PermissionTag>>>;
  uuid: Scalars['UUID']['output'];
};

export type PermissionRequest = {
  __typename: 'PermissionRequest';
  requestee?: Maybe<User>;
  requester?: Maybe<User>;
  status?: Maybe<PermissionRequestStatus>;
  uuid: Scalars['UUID']['output'];
};

export enum PermissionRequestStatus {
  Accepted = 'ACCEPTED',
  InvalidCountry = 'INVALID_COUNTRY',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum PermissionTag {
  Distributor = 'DISTRIBUTOR',
  SustainabilityProgramManager = 'SUSTAINABILITY_PROGRAM_MANAGER',
  XarvioSupport = 'XARVIO_SUPPORT'
}

export type PestDevelopmentPrediction = {
  __typename: 'PestDevelopmentPrediction';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  cumulativePercentage?: Maybe<Scalars['Float']['output']>;
  cumulativeWeightedPercentage?: Maybe<Scalars['Float']['output']>;
  currentPercentage?: Maybe<Scalars['Float']['output']>;
  currentWeightedPercentage?: Maybe<Scalars['Float']['output']>;
  developmentStage?: Maybe<DevelopmentStage>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  generation?: Maybe<Scalars['Int']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<PestDevelopmentStatus>;
  stress?: Maybe<StressV2>;
};


export type PestDevelopmentPredictionStressArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum PestDevelopmentStatus {
  Reached = 'REACHED'
}

export enum PlannedExecutionStatus {
  NotStarted = 'NOT_STARTED',
  Ongoing = 'ONGOING',
  OngoingAdjusted = 'ONGOING_ADJUSTED'
}

export type Plausibility = {
  __typename: 'Plausibility';
  amber1Max?: Maybe<Scalars['Float']['output']>;
  amber1MaxSi?: Maybe<Scalars['Float']['output']>;
  amber1Min?: Maybe<Scalars['Float']['output']>;
  amber1MinSi?: Maybe<Scalars['Float']['output']>;
  amber2Max?: Maybe<Scalars['Float']['output']>;
  amber2MaxSi?: Maybe<Scalars['Float']['output']>;
  amber2Min?: Maybe<Scalars['Float']['output']>;
  amber2MinSi?: Maybe<Scalars['Float']['output']>;
  characteristicId?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  green1Max?: Maybe<Scalars['Float']['output']>;
  green1MaxSi?: Maybe<Scalars['Float']['output']>;
  green1Min?: Maybe<Scalars['Float']['output']>;
  green1MinSi?: Maybe<Scalars['Float']['output']>;
  rateUnitCode?: Maybe<Scalars['String']['output']>;
  rateUnitName?: Maybe<Scalars['String']['output']>;
  rateUnitSiCode?: Maybe<Scalars['String']['output']>;
  rateUnitSiName?: Maybe<Scalars['String']['output']>;
  rateUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  rateUnitUuid?: Maybe<Scalars['UUID']['output']>;
  red1Max?: Maybe<Scalars['Float']['output']>;
  red1MaxSi?: Maybe<Scalars['Float']['output']>;
  red1Min?: Maybe<Scalars['Float']['output']>;
  red1MinSi?: Maybe<Scalars['Float']['output']>;
  red2Max?: Maybe<Scalars['Float']['output']>;
  red2MaxSi?: Maybe<Scalars['Float']['output']>;
  red2Min?: Maybe<Scalars['Float']['output']>;
  red2MinSi?: Maybe<Scalars['Float']['output']>;
  sourceCode?: Maybe<Scalars['String']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
};

export type PreOrder = {
  __typename: 'PreOrder';
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  etag?: Maybe<Scalars['String']['output']>;
  farm: FarmV2;
  hfServiceDetails?: Maybe<PreOrderHfServiceDetails>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  orderType: CommercialPartnerPreOrderType;
  shadowApplicatorEmailAddress?: Maybe<Scalars['String']['output']>;
  status: CommercialPartnerPreOrderStatus;
  uuid: Scalars['UUID']['output'];
};

export type PreOrderCropQuota = {
  __typename: 'PreOrderCropQuota';
  consumed?: Maybe<Scalars['Float']['output']>;
  crop?: Maybe<Crop>;
  effectiveQuantity?: Maybe<Scalars['Float']['output']>;
  pricePerArea?: Maybe<Scalars['Float']['output']>;
  pricePerAreaUnit?: Maybe<MdUnit>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type PreOrderHfServiceDetails = {
  __typename: 'PreOrderHfServiceDetails';
  areaClasses?: Maybe<Array<PreOrderHfServiceRequestAreaClass>>;
  assignedAgronomicConsultant?: Maybe<User>;
  assignedContractor?: Maybe<User>;
  assignedContractorIdOnLogisticPlatform?: Maybe<Scalars['String']['output']>;
  assignedContractorShippingAddress?: Maybe<PreOrderHfServiceRequestShippingAddress>;
  businessName?: Maybe<Scalars['String']['output']>;
  farmerId?: Maybe<Scalars['String']['output']>;
  hfReferenceCode?: Maybe<HfReferenceCode>;
  hfReferenceCodePublic?: Maybe<HfReferenceCodePublic>;
  logisticPlatformCode?: Maybe<Scalars['String']['output']>;
  logisticPlatformName?: Maybe<Scalars['String']['output']>;
  quotas?: Maybe<Array<Maybe<PreOrderQuota>>>;
  secondaryLogisticPlatformCode?: Maybe<Scalars['String']['output']>;
  serviceType: ServiceType;
  soldAt?: Maybe<Scalars['Date']['output']>;
  suggestedAgronomicConsultantEmail?: Maybe<Scalars['String']['output']>;
  suggestedAgronomicConsultantFullName?: Maybe<Scalars['String']['output']>;
  suggestedContractorEmail?: Maybe<Scalars['String']['output']>;
  suggestedContractorFullName?: Maybe<Scalars['String']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  totalFafArea?: Maybe<Scalars['Float']['output']>;
};

export type PreOrderHfServiceRequestAreaClass = {
  __typename: 'PreOrderHfServiceRequestAreaClass';
  area: Scalars['Float']['output'];
  classType: HfServiceRequestAreaClassType;
  crop: Crop;
};


export type PreOrderHfServiceRequestAreaClassCropArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type PreOrderHfServiceRequestShippingAddress = {
  __typename: 'PreOrderHfServiceRequestShippingAddress';
  city: Scalars['String']['output'];
  countryId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  provinceId: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type PreOrderQuota = {
  __typename: 'PreOrderQuota';
  crop: Crop;
  pricePerArea: Scalars['Float']['output'];
  pricePerAreaUnit: MdUnit;
  quantity: Scalars['Float']['output'];
};


export type PreOrderQuotaCropArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type PrecifieldBiomassMap = {
  __typename: 'PrecifieldBiomassMap';
  acquisitionDate?: Maybe<Scalars['Date']['output']>;
  averageBiomass?: Maybe<Scalars['Float']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type PrecifieldCerealsMapSubscription = {
  __typename: 'PrecifieldCerealsMapSubscription';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  nitrogenTargetRate?: Maybe<Scalars['Float']['output']>;
  productV2?: Maybe<ProductV2>;
  status?: Maybe<PrecifieldSubscriptionStatus>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  yieldFiveYearOlympicAverage?: Maybe<Scalars['Float']['output']>;
};

export type PrecifieldNitrogenPrescriptionMap = {
  __typename: 'PrecifieldNitrogenPrescriptionMap';
  acquisitionDate?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['Int']['output']>;
  mapModel?: Maybe<Scalars['String']['output']>;
  precifieldFieldId?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<NitrogenProduct>>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type PrecifieldOsrMapSubscription = {
  __typename: 'PrecifieldOsrMapSubscription';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  endWinterPrecifieldBiomassMapUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  historicOrganicProductUuid?: Maybe<Scalars['UUID']['output']>;
  isCropAssociatedWithLegumesCover?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  organicProductFrequencyUuid?: Maybe<Scalars['UUID']['output']>;
  precifieldSoilTypeUuid?: Maybe<Scalars['UUID']['output']>;
  productV2?: Maybe<ProductV2>;
  startWinterPrecifieldBiomassMapUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<PrecifieldSubscriptionStatus>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum PrecifieldSubscriptionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Ongoing = 'ONGOING',
  Pending = 'PENDING'
}

export type PrecifieldYieldPotentialMap = {
  __typename: 'PrecifieldYieldPotentialMap';
  acquisitionDate?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['Int']['output']>;
  mapModel?: Maybe<Scalars['String']['output']>;
  precifieldFieldId?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Prediction = {
  __typename: 'Prediction';
  harvestDate?: Maybe<Scalars['Date']['output']>;
  yieldScenario?: Maybe<Array<Maybe<YieldScenario>>>;
};

export type PremiumBand = {
  __typename: 'PremiumBand';
  maxCi?: Maybe<Scalars['Float']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
};

export enum Pricing {
  Basic = 'BASIC',
  Premium = 'PREMIUM'
}

export enum PricingSeason {
  Season_2026 = 'SEASON_2026'
}

export enum ProcessingType {
  None = 'NONE',
  Zoned = 'ZONED',
  ZonedByAffectedArea = 'ZONED_BY_AFFECTED_AREA',
  ZonedFillGaps = 'ZONED_FILL_GAPS'
}

export type ProduceDeliveryTask = {
  __typename: 'ProduceDeliveryTask';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  distanceToStorage?: Maybe<Scalars['Float']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  produceProperties?: Maybe<ProduceDeliveryTaskProduceProperties>;
  quantity?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<TaskExecutionState>;
  transportSystemUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ProduceDeliveryTaskProduceProperties = {
  __typename: 'ProduceDeliveryTaskProduceProperties';
  brix?: Maybe<Scalars['Float']['output']>;
  moisturePercent?: Maybe<Scalars['Float']['output']>;
};

export type Product = {
  __typename: 'Product';
  abstractProductType?: Maybe<Array<Maybe<AbstractProductType>>>;
  actualFormulationCode?: Maybe<Scalars['String']['output']>;
  cdnImagePath?: Maybe<Scalars['String']['output']>;
  cdnLogoPath?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  distributionType?: Maybe<Scalars['String']['output']>;
  distributionTypeUuid?: Maybe<Scalars['UUID']['output']>;
  doseRateUnit?: Maybe<Scalars['String']['output']>;
  doseRateUnitUuid?: Maybe<Scalars['UUID']['output']>;
  formulation?: Maybe<Scalars['String']['output']>;
  formulationCode?: Maybe<Scalars['String']['output']>;
  formulationFormUuid?: Maybe<Scalars['UUID']['output']>;
  formulationTypeUuid?: Maybe<Scalars['UUID']['output']>;
  highFlowRates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  importCountry?: Maybe<Scalars['String']['output']>;
  isProductSynonym?: Maybe<Scalars['Boolean']['output']>;
  lastCommercialDate?: Maybe<Scalars['Date']['output']>;
  lastUseDate?: Maybe<Scalars['Date']['output']>;
  lowFlowRates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  maxDoseRate?: Maybe<Scalars['Float']['output']>;
  minDoseRate?: Maybe<Scalars['Float']['output']>;
  minRate?: Maybe<Scalars['Float']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationUuid?: Maybe<Scalars['UUID']['output']>;
  productExpiryDate?: Maybe<Scalars['Date']['output']>;
  productFeatures?: Maybe<Array<Maybe<ProductFeatureType>>>;
  productName?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  productTypeUuid?: Maybe<Scalars['UUID']['output']>;
  productUseStatus?: Maybe<Scalars['String']['output']>;
  referenceProductUuid?: Maybe<Scalars['UUID']['output']>;
  referenceRegistration?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['Date']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ProductApplicationRate = {
  __typename: 'ProductApplicationRate';
  averageApplicationRate?: Maybe<Scalars['Float']['output']>;
  liquid?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  ratesPerZone?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  totalApplication?: Maybe<Scalars['Float']['output']>;
};

export enum ProductCategoryType {
  F = 'F',
  Ferti = 'FERTI',
  H = 'H',
  I = 'I',
  Pgr = 'PGR'
}

export type ProductFeature = {
  __typename: 'ProductFeature';
  crop?: Maybe<Crop>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vraMinMixRateSi?: Maybe<Scalars['Float']['output']>;
  vraMinRateSi?: Maybe<Scalars['Float']['output']>;
};

export enum ProductFeatureType {
  Abiotic = 'ABIOTIC',
  OnOff = 'ON_OFF',
  TreatmentTimes = 'TREATMENT_TIMES',
  Unknown = 'UNKNOWN',
  VraMap = 'VRA_MAP'
}

export enum ProductFormulationTypeGroup {
  G = 'G',
  L = 'L',
  S = 'S',
  X = 'X'
}

export type ProductPack = {
  __typename: 'ProductPack';
  categories?: Maybe<Array<Maybe<Category>>>;
  code?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  crop?: Maybe<Crop>;
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<ProductV2>>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ProductPermissibleRate = {
  __typename: 'ProductPermissibleRate';
  amountWaterMax?: Maybe<Scalars['Float']['output']>;
  amountWaterMaxSi?: Maybe<Scalars['Float']['output']>;
  amountWaterMin?: Maybe<Scalars['Float']['output']>;
  amountWaterMinSi?: Maybe<Scalars['Float']['output']>;
  appliedWithWater?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  dilutionRatioMax?: Maybe<Scalars['Float']['output']>;
  dilutionRatioMin?: Maybe<Scalars['Float']['output']>;
  doseUnitCode?: Maybe<Scalars['String']['output']>;
  doseUnitName?: Maybe<Scalars['String']['output']>;
  doseUnitUuid?: Maybe<Scalars['UUID']['output']>;
  maxRate?: Maybe<Scalars['Float']['output']>;
  minRate?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rateMaxSi?: Maybe<Scalars['Float']['output']>;
  rateMinSi?: Maybe<Scalars['Float']['output']>;
  rateUnitSiCode?: Maybe<Scalars['String']['output']>;
  rateUnitSiName?: Maybe<Scalars['String']['output']>;
  rateUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  taskMethodCode?: Maybe<Scalars['String']['output']>;
  taskMethodName?: Maybe<Scalars['String']['output']>;
  taskMethodUuid?: Maybe<Scalars['UUID']['output']>;
  taskTypeCode?: Maybe<Scalars['String']['output']>;
  taskTypeName?: Maybe<Scalars['String']['output']>;
  taskTypeUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
  waterUnitCode?: Maybe<Scalars['String']['output']>;
  waterUnitName?: Maybe<Scalars['String']['output']>;
  waterUnitSiCode?: Maybe<Scalars['String']['output']>;
  waterUnitSiName?: Maybe<Scalars['String']['output']>;
  waterUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  waterUnitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type ProductPermissibleRateV2 = {
  __typename: 'ProductPermissibleRateV2';
  amountWaterMax?: Maybe<Scalars['Float']['output']>;
  amountWaterMaxSi?: Maybe<Scalars['Float']['output']>;
  amountWaterMin?: Maybe<Scalars['Float']['output']>;
  amountWaterMinSi?: Maybe<Scalars['Float']['output']>;
  appliedWithWater?: Maybe<AppliedWithWater>;
  code?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  dilutionRatioMax?: Maybe<Scalars['Float']['output']>;
  dilutionRatioMin?: Maybe<Scalars['Float']['output']>;
  doseUnitCode?: Maybe<Scalars['String']['output']>;
  doseUnitName?: Maybe<Scalars['String']['output']>;
  doseUnitUuid?: Maybe<Scalars['UUID']['output']>;
  maxRate?: Maybe<Scalars['Float']['output']>;
  minRate?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rateMaxSi?: Maybe<Scalars['Float']['output']>;
  rateMinSi?: Maybe<Scalars['Float']['output']>;
  rateUnitSiCode?: Maybe<Scalars['String']['output']>;
  rateUnitSiName?: Maybe<Scalars['String']['output']>;
  rateUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  taskMethodCode?: Maybe<Scalars['String']['output']>;
  taskMethodName?: Maybe<Scalars['String']['output']>;
  taskMethodUuid?: Maybe<Scalars['UUID']['output']>;
  taskTypeCode?: Maybe<Scalars['String']['output']>;
  taskTypeName?: Maybe<Scalars['String']['output']>;
  taskTypeUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  waterUnitCode?: Maybe<Scalars['String']['output']>;
  waterUnitName?: Maybe<Scalars['String']['output']>;
  waterUnitSiCode?: Maybe<Scalars['String']['output']>;
  waterUnitSiName?: Maybe<Scalars['String']['output']>;
  waterUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  waterUnitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type ProductRate = {
  __typename: 'ProductRate';
  isMaster?: Maybe<Scalars['Boolean']['output']>;
  productUuid?: Maybe<Scalars['UUID']['output']>;
  rates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type ProductRateInput = {
  isMaster?: InputMaybe<Scalars['Boolean']['input']>;
  productUuid?: InputMaybe<Scalars['UUID']['input']>;
  rates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type ProductRecommendationTankMix = {
  __typename: 'ProductRecommendationTankMix';
  crops?: Maybe<Array<Maybe<CropTankMixSummary>>>;
  farmUuid: Scalars['UUID']['output'];
};

export enum ProductRecommendationsGroupSort {
  EfficacyScore = 'EFFICACY_SCORE',
  Frequency = 'FREQUENCY'
}

export type ProductV2 = {
  __typename: 'ProductV2';
  accountableNitrogenPercentage?: Maybe<Scalars['Float']['output']>;
  activeDescription?: Maybe<Scalars['String']['output']>;
  activeIngredients?: Maybe<Array<Maybe<ActiveIngredient>>>;
  actualFormulationCode?: Maybe<Scalars['String']['output']>;
  ammoniumStabilizer?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<Category>>>;
  code?: Maybe<Scalars['String']['output']>;
  conversionFactorToRateUnitSi?: Maybe<Scalars['Float']['output']>;
  conversionFactorToWaterUnitSi?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  dateOfAnalysis?: Maybe<Scalars['Date']['output']>;
  density?: Maybe<Scalars['Float']['output']>;
  displayRateUnitCode?: Maybe<Scalars['String']['output']>;
  displayRateUnitName?: Maybe<Scalars['String']['output']>;
  displayRateUnitUuid?: Maybe<Scalars['UUID']['output']>;
  displayWaterUnitCode?: Maybe<Scalars['String']['output']>;
  displayWaterUnitName?: Maybe<Scalars['String']['output']>;
  displayWaterUnitUuid?: Maybe<Scalars['UUID']['output']>;
  distributionTypeCode?: Maybe<Scalars['String']['output']>;
  distributionTypeName?: Maybe<Scalars['String']['output']>;
  distributionTypeUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `farmV2`. */
  farm?: Maybe<Farm>;
  farmV2?: Maybe<FarmV2>;
  features?: Maybe<Array<Maybe<ProductFeature>>>;
  fertilizerTypeUuid?: Maybe<Scalars['UUID']['output']>;
  formulationBasedMixSequence?: Maybe<Scalars['Int']['output']>;
  formulationCode?: Maybe<Scalars['String']['output']>;
  formulationName?: Maybe<Scalars['String']['output']>;
  formulationTypeGroupCode?: Maybe<Scalars['String']['output']>;
  formulationTypeGroupName?: Maybe<Scalars['String']['output']>;
  formulationTypeGroupUuid?: Maybe<Scalars['UUID']['output']>;
  formulationUuid?: Maybe<Scalars['UUID']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  isRetracted?: Maybe<Scalars['Boolean']['output']>;
  isUseRestricted?: Maybe<Scalars['Boolean']['output']>;
  labelLink?: Maybe<Scalars['String']['output']>;
  lastUseDate?: Maybe<Scalars['Date']['output']>;
  maxRateSi?: Maybe<Scalars['Float']['output']>;
  maxWaterSi?: Maybe<Scalars['Float']['output']>;
  minRateSi?: Maybe<Scalars['Float']['output']>;
  minWaterSi?: Maybe<Scalars['Float']['output']>;
  minimumAccountableNitrogenPercentage?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nitrificationInhibitor?: Maybe<Scalars['Boolean']['output']>;
  nitrogenTypes?: Maybe<Array<Maybe<NitrogenType>>>;
  nutrients?: Maybe<Array<Maybe<Nutrient>>>;
  organicFertilizerSubTypeCode?: Maybe<Scalars['String']['output']>;
  organicFertilizerSubTypeUuid?: Maybe<Scalars['UUID']['output']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  productFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productUseStatus?: Maybe<Scalars['String']['output']>;
  rateUnitSiCode?: Maybe<Scalars['String']['output']>;
  rateUnitSiName?: Maybe<Scalars['String']['output']>;
  rateUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  referenceProductCode?: Maybe<Scalars['String']['output']>;
  referenceProductName?: Maybe<Scalars['String']['output']>;
  referenceProductUuid?: Maybe<Scalars['UUID']['output']>;
  registrationDate?: Maybe<Scalars['Date']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  sanitizedDensity?: Maybe<Scalars['Float']['output']>;
  sites?: Maybe<Array<Maybe<Site>>>;
  taskMethods?: Maybe<Array<Maybe<TaskMethod>>>;
  ureaseInhibitor?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
  waterUnitSiCode?: Maybe<Scalars['String']['output']>;
  waterUnitSiName?: Maybe<Scalars['String']['output']>;
  waterUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum ProgramType {
  Cap = 'CAP',
  CoDaxur = 'CO_DAXUR',
  CoPlantedHectare = 'CO_PLANTED_HECTARE',
  Regular = 'REGULAR'
}

export type ProjectedDailyIncidence = {
  __typename: 'ProjectedDailyIncidence';
  endDate?: Maybe<Scalars['Date']['output']>;
  projectedIncidence?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type ProjectedIncidences = {
  __typename: 'ProjectedIncidences';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  criticalPeriodEndDate?: Maybe<Scalars['Date']['output']>;
  criticalPeriodIncidenceThresholdHigh?: Maybe<Scalars['Float']['output']>;
  criticalPeriodStartDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  inoculumPeriodStartDate?: Maybe<Scalars['Date']['output']>;
  isLocked: Scalars['Boolean']['output'];
  isStale?: Maybe<Scalars['Boolean']['output']>;
  projectedDailyIncidences?: Maybe<Array<Maybe<ProjectedDailyIncidence>>>;
  projectingGrowthStageIndex?: Maybe<Scalars['String']['output']>;
  projectingGrowthStageScale?: Maybe<Scalars['String']['output']>;
  stress?: Maybe<StressV2>;
};


export type ProjectedIncidencesStressArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum ProofOfPurchaseStatus {
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN',
  Valid = 'VALID'
}

export enum ProtectionLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  MediumHigh = 'MEDIUM_HIGH',
  MediumLow = 'MEDIUM_LOW'
}

export type ProtectionTime = {
  __typename: 'ProtectionTime';
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonV2: CropSeasonV2;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `stressV2` */
  stress: Stress;
  stressV2: StressV2;
  uuid: Scalars['UUID']['output'];
};

export enum ProtectionType {
  High = 'HIGH',
  Medium = 'MEDIUM'
}

export type Protocol = {
  __typename: 'Protocol';
  creationDate?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  factorLevels?: Maybe<Scalars['Int']['output']>;
  factorUuid?: Maybe<Scalars['UUID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  maxPlotArea?: Maybe<Scalars['Float']['output']>;
  minPlotArea?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  plannedNoOfTrials?: Maybe<Scalars['Int']['output']>;
  plotLength?: Maybe<Scalars['Float']['output']>;
  plotWidth?: Maybe<Scalars['Float']['output']>;
  protocolAttachments?: Maybe<Array<Maybe<ProtocolAttachment>>>;
  protocolName?: Maybe<Scalars['String']['output']>;
  protocolNumber: Scalars['Int']['output'];
  replicates?: Maybe<Scalars['Int']['output']>;
  targetCountry?: Maybe<Scalars['String']['output']>;
  targetYear?: Maybe<Scalars['Int']['output']>;
  typeUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ProtocolAttachment = {
  __typename: 'ProtocolAttachment';
  contentType?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  protocolUuid?: Maybe<Scalars['UUID']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type PublicOrganisation = {
  __typename: 'PublicOrganisation';
  billingAddress?: Maybe<Address>;
  code?: Maybe<Scalars['String']['output']>;
  contactInformation?: Maybe<ContactInformation>;
  etag?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type PurchasedLicense = {
  __typename: 'PurchasedLicense';
  paymentType?: Maybe<PaymentType>;
  quantity?: Maybe<Scalars['Float']['output']>;
  subscriptionActive?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Query = {
  __typename: 'Query';
  abLines?: Maybe<Array<Maybe<AbLine>>>;
  activeIngredients?: Maybe<Array<ActiveIngredient>>;
  additionalInfectionRiskFactor?: Maybe<AdditionalInfectionRiskFactor>;
  additionalInfectionRiskFactors?: Maybe<Array<Maybe<AdditionalInfectionRiskFactor>>>;
  agBalanceFieldEmissionIndicators?: Maybe<Array<Maybe<AgBalanceFieldEmissionIndicator>>>;
  agBalanceFieldInputs?: Maybe<Array<Maybe<AgBalanceFieldInput>>>;
  aggregatedPestDevelopmentPredictions?: Maybe<Array<Maybe<AggregatedPestDevelopmentPrediction>>>;
  aggregatedUserNotifications?: Maybe<Array<Maybe<AggregatedNotification>>>;
  analyticsCollection?: Maybe<AnalyticsCollection>;
  analyticsCollections?: Maybe<Array<Maybe<AnalyticsCollection>>>;
  appConfigs?: Maybe<Array<Maybe<AppConfig>>>;
  arableApiKey?: Maybe<ArableApiKey>;
  arableApiKeys?: Maybe<Array<Maybe<ArableApiKey>>>;
  arableDeviceToLocations?: Maybe<Array<Maybe<ArableDeviceToLocation>>>;
  arableDevices?: Maybe<Array<Maybe<ArableDevice>>>;
  arvalisCustomEfficacyInformations?: Maybe<Array<Maybe<ArvalisCustomEfficacyInformation>>>;
  arvalisDeviceToCropSeasons?: Maybe<Array<ArvalisDeviceToCropSeason>>;
  arvalisInformations?: Maybe<Array<Maybe<ArvalisInformation>>>;
  assessment?: Maybe<Assessment>;
  assessmentAttachment?: Maybe<AssessmentAttachment>;
  assessmentAttachments?: Maybe<Array<Maybe<AssessmentAttachment>>>;
  assessmentData?: Maybe<AssessmentData>;
  assessmentNote?: Maybe<AssessmentNote>;
  assessmentNotes?: Maybe<Array<Maybe<AssessmentNote>>>;
  assessmentTiming?: Maybe<AssessmentTiming>;
  availablePackages?: Maybe<Array<Maybe<AvailablePackage>>>;
  bagCounts?: Maybe<Array<BagCount>>;
  beforeSeasonRisks?: Maybe<Array<BeforeSeasonRisk>>;
  biomassAnalysisNdvi?: Maybe<Array<Maybe<BiomassAnalysisNdvi>>>;
  businessLinePurchaseAggregations?: Maybe<Array<Maybe<BusinessLinePurchaseAggregation>>>;
  carbonCredits?: Maybe<Array<Maybe<CarbonCredit>>>;
  carbonFarmingPlausibilities?: Maybe<Array<Maybe<Plausibility>>>;
  carbonFarmingRequests?: Maybe<Array<Maybe<CarbonFarmingRequest>>>;
  carbonFarmingSeason?: Maybe<CarbonFarmingSeason>;
  carbonFarmingSeasons?: Maybe<Array<Maybe<CarbonFarmingSeason>>>;
  carbonIntensityIndicators?: Maybe<Array<Maybe<CarbonIntensityIndicator>>>;
  carbonPlausibilityComments?: Maybe<Array<Maybe<CarbonPlausibilityComment>>>;
  claasConnectStatus?: Maybe<ClaasConnectStatus>;
  claasFarms?: Maybe<Array<Maybe<ClaasFarm>>>;
  claasFields?: Maybe<Array<Maybe<ClaasField>>>;
  claasOrganizations?: Maybe<Array<Maybe<ClaasOrganization>>>;
  cnhCompanies?: Maybe<Array<Maybe<CnhCompany>>>;
  cnhFarms?: Maybe<Array<Maybe<CnhFarm>>>;
  cnhFields?: Maybe<Array<Maybe<CnhField>>>;
  cnhGrowers?: Maybe<Array<Maybe<CnhGrower>>>;
  cnhTasks?: Maybe<Array<Maybe<CnhTask>>>;
  coefficientOfVariationDetails?: Maybe<Array<Maybe<MdCoefficientOfVariationDetail>>>;
  collaborators?: Maybe<Array<Maybe<Collaborator>>>;
  containers?: Maybe<Array<Maybe<Container>>>;
  countryCropGrowthStagePredictions?: Maybe<Array<Maybe<CountryCropGrowthStagePrediction>>>;
  countryCropStressSettings?: Maybe<Array<Maybe<CountryCropStressSetting>>>;
  countryWeeds?: Maybe<Array<Maybe<CountryWeed>>>;
  criticalCropStageRiskInfos?: Maybe<Array<Maybe<CriticalCropStageRiskInfo>>>;
  criticalCropStageRisks?: Maybe<Array<Maybe<CriticalCropStageRisk>>>;
  criticalGrowthStagePeriodRisks?: Maybe<Array<Maybe<CriticalGrowthStagePeriodRisk>>>;
  cropEstablishment?: Maybe<CropEstablishment>;
  cropEstablishmentDetails?: Maybe<Array<Maybe<CropEstablishmentDetails>>>;
  cropEstablishments?: Maybe<Array<CropEstablishment>>;
  cropResidueManagementTask?: Maybe<CropResidueManagementTask>;
  cropResidueManagementTasks?: Maybe<Array<CropResidueManagementTask>>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonNutritionProgramExecutionStatuses?: Maybe<Array<Maybe<CropSeasonNutritionProgramExecutionStatus>>>;
  cropSeasonNutritionPrograms?: Maybe<Array<Maybe<CropSeasonNutritionProgram>>>;
  cropSeasonNutritionRecommendations?: Maybe<Array<Maybe<CropSeasonNutritionRecommendation>>>;
  cropSeasonTreatmentProgramV3?: Maybe<CropSeasonTreatmentProgramV3>;
  cropSeasonTreatmentPrograms?: Maybe<Array<Maybe<CropSeasonTreatmentProgram>>>;
  cropSeasonTreatmentProgramsV2?: Maybe<Array<Maybe<CropSeasonTreatmentProgramV2>>>;
  cropSeasonTreatmentProgramsV3?: Maybe<Array<Maybe<CropSeasonTreatmentProgramV3>>>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  cropSeasonsV2?: Maybe<Array<CropSeasonV2>>;
  cropSystemRecommendation?: Maybe<CropSystemRecommendation>;
  cropSystemRecommendationV2?: Maybe<CropSystemRecommendationV2>;
  cropSystemRecommendationsV2?: Maybe<Array<Maybe<CropSystemRecommendationV2>>>;
  cropUsages?: Maybe<Array<Maybe<CropUsage>>>;
  cropWaterAvailabilities?: Maybe<Array<Maybe<CropWaterAvailability>>>;
  crops?: Maybe<Array<Maybe<Crop>>>;
  currentWeedPredictions?: Maybe<Array<Maybe<CurrentWeedPrediction>>>;
  customPowerzoneOrder?: Maybe<CustomPowerzoneOrder>;
  customPowerzoneOrders?: Maybe<Array<Maybe<CustomPowerzoneOrder>>>;
  dailyFungusDetails?: Maybe<Array<Maybe<DailyFungusDetails>>>;
  dailyStressCharacteristics?: Maybe<Array<Maybe<DailyStressCharacteristics>>>;
  dailyStressEventProbabilities?: Maybe<Array<Maybe<DailyStressEventProbability>>>;
  dailyWeedRiskDetails?: Maybe<Array<Maybe<DailyWeedRiskDetails>>>;
  demandEquationRecommendation?: Maybe<DemandEquationRecommendation>;
  demandEquationRecommendationV2?: Maybe<DemandEquationRecommendationV2>;
  demandEquationRecommendations?: Maybe<Array<Maybe<DemandEquationRecommendation>>>;
  demandEquationRecommendationsV2?: Maybe<Array<Maybe<DemandEquationRecommendationV2>>>;
  devicePackage?: Maybe<DevicePackage>;
  devicePackages?: Maybe<Array<Maybe<DevicePackage>>>;
  dictcodeFeatures?: Maybe<Array<Maybe<DictcodeFeature>>>;
  dictcodeHierarchies?: Maybe<Array<Maybe<DictcodeHierarchy>>>;
  dictionaries?: Maybe<Array<Maybe<Dictionary>>>;
  dosedMapLegends?: Maybe<Array<Maybe<DosedMapLegend>>>;
  dosedMapProductSummaries?: Maybe<Array<Maybe<DosedMapProductSummary>>>;
  dosedMaps?: Maybe<Array<Maybe<DosedMap>>>;
  droneFlightQuotaTransfers?: Maybe<Array<Maybe<DroneFlightQuotaTransfer>>>;
  droneFlightQuotas?: Maybe<Array<Maybe<DroneFlightQuota>>>;
  droneFlightSummary?: Maybe<Array<DroneFlightSummary>>;
  droneFlights?: Maybe<Array<DroneFlight>>;
  dronePlantingFailureMaps?: Maybe<Array<Maybe<DronePlantingFailureMap>>>;
  droneSprayerWeedMaps?: Maybe<Array<Maybe<DroneSprayerWeedMap>>>;
  dtnVendorDeviceActivation?: Maybe<DtnVendorDeviceActivation>;
  dtnVendorDeviceActivations?: Maybe<Array<Maybe<DtnVendorDeviceActivation>>>;
  dtnVendorDeviceToLocations?: Maybe<Array<Maybe<DtnVendorDeviceToLocation>>>;
  dtnVendorDeviceToLocationsV2?: Maybe<Array<Maybe<DtnVendorDeviceToLocationV2>>>;
  dtnVendorDevices?: Maybe<Array<Maybe<DtnVendorDevice>>>;
  dtnVendorKey?: Maybe<DtnVendorKey>;
  dtnVendorKeys?: Maybe<Array<Maybe<DtnVendorKey>>>;
  exatrekApplicationMapDispatchOrders?: Maybe<Array<ExatrekApplicationMapDispatchOrder>>;
  exatrekDeviceStates?: Maybe<Array<ExatrekDeviceState>>;
  exatrekUserDevices?: Maybe<Array<ExatrekUserDevice>>;
  exatrekUserMachines?: Maybe<Array<ExatrekUserMachine>>;
  existingOrders?: Maybe<Array<Maybe<ExistingOrder>>>;
  exportOrder?: Maybe<ExportOrder>;
  exportOrders?: Maybe<Array<Maybe<ExportOrder>>>;
  farm?: Maybe<Farm>;
  farmCarbonIntensityIndicators?: Maybe<Array<Maybe<FarmCarbonIntensityIndicator>>>;
  farmCropMetrics?: Maybe<Array<Maybe<FarmCropMetrics>>>;
  farmDataLayers?: Maybe<Array<Maybe<FarmDataLayer>>>;
  farmEvidence?: Maybe<FarmEvidence>;
  farmFeaturesSummary?: Maybe<Array<Maybe<FarmFeaturesSummary>>>;
  farmGreetCarbonIntensityScores?: Maybe<Array<Maybe<FarmGreetCarbonIntensityScore>>>;
  farmLayerSummaryCount?: Maybe<Array<Maybe<FarmLayerSummaryCount>>>;
  farmPackages?: Maybe<Array<FarmPackage>>;
  farmV2?: Maybe<FarmV2>;
  farmsV2?: Maybe<Array<FarmV2>>;
  /** @deprecated `boundary` and `etag` is not supported in type Field. Use `fieldV2`. */
  field?: Maybe<Field>;
  fieldActivations?: Maybe<Array<Maybe<FieldActivation>>>;
  fieldBoundaryLookupScore?: Maybe<Array<Maybe<FieldBoundaryLookupScore>>>;
  fieldDataLayerClassifications?: Maybe<Array<Maybe<FieldDataLayerClassification>>>;
  fieldDataLayerLegends?: Maybe<Array<Maybe<FieldDataLayerLegend>>>;
  fieldDataLayerStatistics?: Maybe<Array<Maybe<FieldDataLayerStatistics>>>;
  fieldDataLayers?: Maybe<Array<Maybe<FieldDataLayer>>>;
  /** #regionsOfInterest: [Stringified{geometry: Geometry;id: string;}] */
  fieldDataLayersStatistics?: Maybe<Array<Maybe<FieldDataLayerStatistics>>>;
  fieldDataUploadDatasets?: Maybe<Array<Maybe<FieldDataUploadDataset>>>;
  fieldEntries?: Maybe<Array<Maybe<FieldEntry>>>;
  fieldFeatures?: Maybe<Array<Maybe<FieldFeature>>>;
  fieldInputPackagings?: Maybe<Array<Maybe<FieldInputPackaging>>>;
  fieldNotesAggregation?: Maybe<Array<Maybe<FieldNoteAggregation>>>;
  fieldPointLookup?: Maybe<Array<Maybe<FieldPointLookup>>>;
  fieldV2?: Maybe<FieldV2>;
  fieldVariabilityIndexes?: Maybe<Array<Maybe<FieldVariabilityIndex>>>;
  fieldVariabilityInputs?: Maybe<Array<Maybe<FieldVariabilityInput>>>;
  fieldZones?: Maybe<Array<Maybe<FieldZone>>>;
  fieldsV2?: Maybe<Array<FieldV2>>;
  fmCarbonRelatedData: Array<FmCarbonRelatedData>;
  foreignCatchCrops?: Maybe<Array<Maybe<ForeignCatchCrop>>>;
  foreignCrops?: Maybe<Array<Maybe<ForeignCrop>>>;
  foreignPreCrops?: Maybe<Array<Maybe<ForeignPreCrop>>>;
  freshBiomassOrder?: Maybe<FreshBiomassOrder>;
  frostRisks?: Maybe<Array<Maybe<FrostRisk>>>;
  geoMapDetails?: Maybe<Array<Maybe<GeoMapDetail>>>;
  getAllSupportedGreenOnGreenCrops?: Maybe<Array<Scalars['UUID']['output']>>;
  greenhouseWhiteningTask?: Maybe<GreenhouseWhiteningTask>;
  greenhouseWhiteningTasks?: Maybe<Array<GreenhouseWhiteningTask>>;
  greenhouses?: Maybe<Array<Greenhouse>>;
  greetCarbonIntensityScores?: Maybe<Array<Maybe<GreetCarbonIntensityScore>>>;
  groups?: Maybe<Array<Group>>;
  growthStagePredictionDaily?: Maybe<Array<Maybe<GrowthStagePredictionDaily>>>;
  growthStages?: Maybe<Array<Maybe<GrowthStage>>>;
  harvest?: Maybe<Harvest>;
  harvests?: Maybe<Array<Harvest>>;
  hfAgRegions?: Maybe<Array<Maybe<HfAgRegion>>>;
  hfAlerts?: Maybe<Array<Maybe<HfAlert>>>;
  hfClaims?: Maybe<Array<Maybe<HfClaim>>>;
  hfContractorRequests?: Maybe<Array<Maybe<HfContractorRequest>>>;
  hfDiscounts?: Maybe<Array<Maybe<HfDiscount>>>;
  hfDistributors?: Maybe<Array<Maybe<HfDistributor>>>;
  hfFarms?: Maybe<Array<Maybe<HfFarm>>>;
  hfInvoices?: Maybe<Array<Maybe<HfInvoice>>>;
  hfMachineries?: Maybe<Array<Maybe<HfMachinery>>>;
  hfOfferConditions?: Maybe<Array<Maybe<HfOfferCondition>>>;
  hfOffers?: Maybe<Array<HfOffer>>;
  hfPreOrders?: Maybe<Array<Maybe<HfPreOrder>>>;
  hfPrices?: Maybe<Array<Maybe<HfPrice>>>;
  hfRates?: Maybe<Array<Maybe<HfRate>>>;
  hfReferenceCodeRates?: Maybe<Array<Maybe<HfReferenceCodeRate>>>;
  /** Filter reference codes by countries; omitted, empty, or blank country values apply no country restriction. */
  hfReferenceCodes?: Maybe<Array<Maybe<HfReferenceCode>>>;
  /** Filter public reference codes by countries; omitted, empty, or blank country values apply no country restriction. */
  hfReferenceCodesPublic?: Maybe<Array<Maybe<HfReferenceCodePublic>>>;
  hfRequestFarmPackageAddOns?: Maybe<Array<Maybe<HfRequestFarmPackageAddOn>>>;
  hfRiskClasses?: Maybe<Array<Maybe<HfRiskClass>>>;
  hfSeason?: Maybe<HfSeason>;
  hfServiceRequests?: Maybe<Array<Maybe<HfServiceRequest>>>;
  hfServiceRequestsHistory?: Maybe<Array<Maybe<EntityHistory>>>;
  hfWeatherData?: Maybe<Array<Maybe<HfWeatherData>>>;
  hortaCropSeasons?: Maybe<Array<Maybe<HortaCropSeason>>>;
  hortaSprayings?: Maybe<Array<Maybe<HortaSpraying>>>;
  hortaStresses?: Maybe<Array<Maybe<HortaStress>>>;
  hortaSustainabilityIndicators?: Maybe<Array<Maybe<HortaSustainabilityIndicator>>>;
  importOrders?: Maybe<Array<Maybe<ImportOrder>>>;
  importantGrowthStages?: Maybe<Array<Maybe<ImportantGrowthStage>>>;
  inviteCodes?: Maybe<Array<Maybe<InviteCode>>>;
  jdFieldSynchronizationOrder?: Maybe<JdFieldSynchronizationOrder>;
  jdFieldSynchronizationOrders?: Maybe<Array<Maybe<JdFieldSynchronizationOrder>>>;
  jdNotificationSubscriptions?: Maybe<Array<Maybe<JdNotificationSubscription>>>;
  kubotaApplicationMapDispatchOrders?: Maybe<Array<Maybe<KubotaApplicationMapDispatchOrder>>>;
  kwsConsent?: Maybe<KwsConsent>;
  kwsSupportedVarieties?: Maybe<Array<Maybe<KwsSupportedVariety>>>;
  landPreparation?: Maybe<Array<Maybe<LandPreparation>>>;
  landPreparations?: Maybe<Array<LandPreparation>>;
  leafPruningTask?: Maybe<LeafPruningTask>;
  leafPruningTasks?: Maybe<Array<LeafPruningTask>>;
  licenseRequests?: Maybe<Array<Maybe<LicenseRequest>>>;
  licenses?: Maybe<Array<License>>;
  linkedDevices?: Maybe<Array<Maybe<LinkedDevice>>>;
  md2AggregatedProductusesByCrops?: Maybe<Array<Maybe<Md2AggregatedProductusesByCrop>>>;
  md2Configurations?: Maybe<Array<Maybe<Md2Configuration>>>;
  md2CountryCropConfigurations?: Maybe<Array<Maybe<Md2CountryCropConfiguration>>>;
  md2CropGrowthStageV2?: Maybe<Array<Maybe<CropGrowthStageV2>>>;
  md2ProductFeatures?: Maybe<Array<Md2ProductFeature>>;
  md2TillageDepths?: Maybe<Array<Maybe<Md2TillageDepth>>>;
  md2VraAdvisorConfigurations?: Maybe<Array<Maybe<Md2VraAdvisorConfiguration>>>;
  mdUnits?: Maybe<Array<Maybe<MdUnit>>>;
  measureSubmissionOrders?: Maybe<Array<Maybe<MeasureSubmissionOrder>>>;
  measureSubmissionResults?: Maybe<Array<Maybe<MeasureSubmissionResult>>>;
  mergedSmartSprayerExecution?: Maybe<MergedSmartSprayerExecution>;
  minObservationDate?: Maybe<Scalars['Date']['output']>;
  monitorPractices?: Maybe<Array<Maybe<MonitorPractice>>>;
  multiFileUploadOrders?: Maybe<Array<Maybe<MultiFileUploadOrder>>>;
  namedCropMixes?: Maybe<Array<Maybe<NamedCropMix>>>;
  notificationPreferences?: Maybe<Array<Maybe<NotificationPreference>>>;
  nutrientMethodMappings?: Maybe<Array<Maybe<NutrientMethodMapping>>>;
  nutritionVraAdvisorGeometries?: Maybe<NutritionStacItemVectorization>;
  observation?: Maybe<Observation>;
  observations?: Maybe<Array<Observation>>;
  onOffStatistics?: Maybe<Array<Maybe<OnOffStatistics>>>;
  onesoilApplicationMapDispatchOrders?: Maybe<Array<Maybe<OneSoilApplicationMapDispatchOrder>>>;
  onesoilDevices?: Maybe<Array<Maybe<OneSoilDevice>>>;
  /** @deprecated Deprecated because of change farm to be optional for upload datasets */
  onesoilFarmReceivedFiles?: Maybe<Array<Maybe<OneSoilFarmReceivedFile>>>;
  onesoilReceivedFiles?: Maybe<Array<Maybe<OneSoilReceivedFile>>>;
  onesoilUploadDatasetOrders?: Maybe<Array<Maybe<OneSoilUploadDatasetOrder>>>;
  operationalInstructions?: Maybe<Array<Maybe<HfOperationalInstruction>>>;
  orderAffiliates?: Maybe<Array<Maybe<OrderAffiliate>>>;
  organisationBranches?: Maybe<Array<Maybe<OrganisationBranch>>>;
  organisationFarmAssignments?: Maybe<Array<Maybe<OrganisationFarmAssignment>>>;
  organisationFeatures?: Maybe<Array<Maybe<OrganisationFeature>>>;
  organisationMembers?: Maybe<Array<Maybe<OrganisationMember>>>;
  organisationMembershipRequests?: Maybe<Array<Maybe<OrganisationMembershipRequest>>>;
  organisationMethods?: Maybe<Array<Maybe<OrganisationMethod>>>;
  organisationTags?: Maybe<Array<Maybe<OrganisationTag>>>;
  organisations?: Maybe<Array<Maybe<Organisation>>>;
  packages?: Maybe<Array<Package>>;
  paginatedFarmEvidenceLinks?: Maybe<PaginatedFarmEvidenceLink>;
  paginatedFarmReceipts?: Maybe<PaginatedFarmReceipt>;
  paginatedFieldDataLayers?: Maybe<PaginatedFieldDataLayer>;
  paginatedFieldDataUploadDatasets?: Maybe<PaginatedUploadDataset>;
  paginatedFieldEvidence?: Maybe<PaginatedFieldEvidence>;
  paginatedFieldEvidenceLinks?: Maybe<PaginatedFieldEvidenceLink>;
  paginatedFieldNotes?: Maybe<PaginatedFieldNote>;
  paginatedFiles?: Maybe<PaginatedFile>;
  paginatedHfClaims?: Maybe<PaginatedHfClaim>;
  paginatedHfContractorRequests?: Maybe<PaginatedHfContractorRequest>;
  paginatedHfOperationalInstructions?: Maybe<PaginatedHfOperationalInstruction>;
  paginatedMapItems?: Maybe<PaginatedMapItem>;
  paginatedMd2DictionaryMappings?: Maybe<PaginatedMd2DictionaryMapping>;
  paginatedOrganisationQuotaLedgers?: Maybe<PaginatedOrganisationQuotaLedger>;
  paginatedOrganisations?: Maybe<PaginatedOrganisation>;
  paginatedPreOrders?: Maybe<PaginatedPreOrder>;
  paginatedScaleTicketBookingDisputes?: Maybe<PaginatedScaleTicketBookingDispute>;
  paginatedScaleTicketBookings?: Maybe<PaginatedScaleTicketBooking>;
  paginatedScaleTicketDataMappings?: Maybe<PaginatedScaleTicketDataMapping>;
  paginatedScaleTicketHistory?: Maybe<PaginatedScaleTicketHistory>;
  paginatedScaleTicketSellerMappings?: Maybe<PaginatedScaleTicketSellerMapping>;
  paginatedScaleTicketUploads?: Maybe<PaginatedScaleTicketUpload>;
  paginatedScaleTickets?: Maybe<PaginatedScaleTicket>;
  paginatedScoutingTasks?: Maybe<PaginatedScoutingTask>;
  paginatedSmartSprayerExecutions?: Maybe<PaginatedSmartSprayerExecution>;
  paginatedSmartSprayerRegistrations?: Maybe<PaginatedSmartSprayerRegistration>;
  paginatedSustainabilityOrganisationCapabilities?: Maybe<PaginatedSustainabilityOrganisationCapability>;
  paginatedSustainabilityProgramBranchAssignments?: Maybe<PaginatedSustainabilityProgramBranchAssignment>;
  paginatedSustainabilityProgramEnrolledFields?: Maybe<PaginatedSustainabilityProgramEnrolledField>;
  paginatedSustainabilityProgramInvitations?: Maybe<PaginatedSustainabilityProgramInvitation>;
  paginatedSustainabilityProgramOrganisationParticipations?: Maybe<PaginatedSustainabilityProgramOrganisationParticipation>;
  paginatedSustainabilityPrograms?: Maybe<PaginatedSustainabilityProgram>;
  paginatedTasks?: Maybe<PaginatedTask>;
  paginatedTrialsV2?: Maybe<PaginatedTrialsV2>;
  paginatedVarieties?: Maybe<PaginatedVariety>;
  panoramaClients?: Maybe<Array<Maybe<PanoramaClient>>>;
  panoramaConnectionStatus?: Maybe<PanoramaConnectionStatus>;
  panoramaFarms?: Maybe<Array<Maybe<PanoramaFarm>>>;
  panoramaFields?: Maybe<Array<Maybe<PanoramaField>>>;
  panoramaOrganizations?: Maybe<Array<Maybe<PanoramaOrganization>>>;
  permissionRequests?: Maybe<Array<Maybe<PermissionRequest>>>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  pestDevelopmentPredictions?: Maybe<Array<Maybe<PestDevelopmentPrediction>>>;
  preOrder?: Maybe<PreOrder>;
  preOrders?: Maybe<Array<Maybe<PreOrder>>>;
  precifieldBiomassMaps?: Maybe<Array<Maybe<PrecifieldBiomassMap>>>;
  precifieldCerealsMapSubscription?: Maybe<Array<Maybe<PrecifieldCerealsMapSubscription>>>;
  precifieldNitrogenPrescriptionMaps?: Maybe<Array<Maybe<PrecifieldNitrogenPrescriptionMap>>>;
  precifieldOsrMapSubscriptions?: Maybe<Array<Maybe<PrecifieldOsrMapSubscription>>>;
  precifieldYieldPotentialMaps?: Maybe<Array<Maybe<PrecifieldYieldPotentialMap>>>;
  produceDeliveryTask?: Maybe<ProduceDeliveryTask>;
  produceDeliveryTasks?: Maybe<Array<ProduceDeliveryTask>>;
  productPacks?: Maybe<Array<Maybe<ProductPack>>>;
  productPermissibleRates?: Maybe<Array<Maybe<ProductPermissibleRate>>>;
  productPermissibleRatesV2?: Maybe<Array<Maybe<ProductPermissibleRateV2>>>;
  productRecommendationTankMixes?: Maybe<Array<Maybe<ProductRecommendationTankMix>>>;
  /** @deprecated Use `productsV2` */
  products?: Maybe<Array<Maybe<Product>>>;
  productsV2?: Maybe<Array<ProductV2>>;
  projectedIncidences?: Maybe<Array<Maybe<ProjectedIncidences>>>;
  protocol?: Maybe<Protocol>;
  protocolAttachments: Array<Maybe<ProtocolAttachment>>;
  protocols?: Maybe<Array<Maybe<Protocol>>>;
  publicOrganisations?: Maybe<Array<Maybe<PublicOrganisation>>>;
  quotaLimits?: Maybe<Array<Maybe<QuotaLimit>>>;
  quotaTransfers?: Maybe<Array<Maybe<QuotaTransfer>>>;
  recentlyUsedProducts?: Maybe<Array<Maybe<RecentlyUsedProduct>>>;
  risks?: Maybe<Array<Maybe<Risk>>>;
  risksV2?: Maybe<Array<Maybe<RiskV2>>>;
  scaleTicket?: Maybe<ScaleTicket>;
  scaleTicketBooking?: Maybe<ScaleTicketBooking>;
  scaleTicketBookingDispute?: Maybe<ScaleTicketBookingDispute>;
  scaleTicketSummary?: Maybe<ScaleTicketSummary>;
  scaleTicketUpload?: Maybe<ScaleTicketUpload>;
  /** @deprecated Use `scoutingPoisV2` */
  scoutingPois?: Maybe<Array<Maybe<ScoutingPoi>>>;
  scoutingPoisV2?: Maybe<Array<Maybe<ScoutingPoiV2>>>;
  scoutingProtocols?: Maybe<Array<Maybe<ScoutingProtocol>>>;
  scoutingReportDispatchOrders?: Maybe<Array<Maybe<ScoutingReportDispatchOrder>>>;
  scoutingReports?: Maybe<Array<Maybe<ScoutingReport>>>;
  scoutingStressQuestions?: Maybe<Array<Maybe<ScoutingStressQuestion>>>;
  scoutingStressQuestionsByWeedAssessmentType?: Maybe<Array<Maybe<ScoutingStressQuestion>>>;
  /** @deprecated Use `paginatedScoutedTasks` */
  scoutingTasks?: Maybe<Array<ScoutingTask>>;
  searchFieldIdentifierScores?: Maybe<Array<Maybe<FieldIdentifierScore>>>;
  searchFieldVariabilityInSeason?: Maybe<Array<Maybe<FieldVariabilityInSeason>>>;
  searchFieldVariabilityTimeSeries?: Maybe<Array<FieldVariabilityTimeSeries>>;
  searchTreatmentPrograms?: Maybe<Array<Maybe<CropSeasonTreatmentProgramV3>>>;
  searchTreatmentScenarios?: Maybe<Array<Maybe<TreatmentScenario>>>;
  seasonTimelines?: Maybe<Array<Maybe<SeasonTimeline>>>;
  seedBoxTreatments?: Maybe<Array<SeedBoxTreatment>>;
  seedSelectorInput?: Maybe<SeedSelectorInput>;
  seedSelectorInputs?: Maybe<Array<Maybe<SeedSelectorInput>>>;
  seedTreatments?: Maybe<Array<SeedTreatment>>;
  sharingMandates?: Maybe<Array<Maybe<SharingMandate>>>;
  shopDevicePackages?: Maybe<Array<Maybe<ShopDevicePackage>>>;
  shopFarmPackages?: Maybe<Array<Maybe<ShopFarmPackage>>>;
  shopGiftCard?: Maybe<ShopGiftCard>;
  shopSubscriptionItems?: Maybe<Array<Maybe<ShopSubscriptionItem>>>;
  shopSubscriptionPeriod?: Maybe<ShopSubscriptionPeriod>;
  shopSubscriptionPeriods?: Maybe<Array<Maybe<ShopSubscriptionPeriod>>>;
  shopSubscriptions?: Maybe<Array<Maybe<ShopSubscription>>>;
  shopUserPackages?: Maybe<Array<Maybe<ShopUserPackage>>>;
  smagConnectionStatus?: Maybe<SmagConnectionStatus>;
  smartSprayerExecution?: Maybe<SmartSprayerExecution>;
  smartSprayerExecutionStatistics?: Maybe<SmartSprayerExecutionStatistics>;
  smartSprayerExecutions?: Maybe<Array<Maybe<SmartSprayerExecution>>>;
  smartSprayerLicenses?: Maybe<Array<Maybe<SmartSprayerLicense>>>;
  smartSprayerRegistration?: Maybe<SmartSprayerRegistration>;
  smartSprayerRegistrationStatus?: Maybe<SmartSprayerRegistrationStatus>;
  smartSprayerRegistrations?: Maybe<Array<Maybe<SmartSprayerRegistration>>>;
  smartSprayerWeedPressureExclusions?: Maybe<SmartSprayerWeedPressureExclusionSet>;
  smartSprayerWeedPressureField?: Maybe<SmartSprayerWeedPressureField>;
  smartSprayerWeedPressureFields?: Maybe<PaginatedSmartSprayerWeedPressureFields>;
  smartSprayerWeedPressureStatistics?: Maybe<SmartSprayerWeedPressureStatistics>;
  smartSprayingOfflineTask?: Maybe<SmartSprayingOfflineTask>;
  /** @deprecated Use `smartSprayingOfflineTasksV2` */
  smartSprayingOfflineTasks?: Maybe<Array<SmartSprayingOfflineTask>>;
  smartSprayingOfflineTasksV2?: Maybe<Array<SmartSprayingOfflineTask>>;
  /** @deprecated Use `smartSprayingTaskV2`. */
  smartSprayingTask: SmartSprayingTask;
  smartSprayingTaskDevicePayloads?: Maybe<Array<SmartSprayingTaskDevicePayload>>;
  smartSprayingTaskV2: SmartSprayingTaskV2;
  /** @deprecated Use `smartSprayingTasksV2`. */
  smartSprayingTasks?: Maybe<Array<SmartSprayingTask>>;
  smartSprayingTasksV2?: Maybe<Array<SmartSprayingTaskV2>>;
  smartSprayingTerminalStrategyMappings?: Maybe<SmartSprayingTerminalStrategyMappings>;
  smartSprayingTerminalTask?: Maybe<SmartSprayingTerminalTask>;
  smartSprayingTerminalTasks?: Maybe<Array<SmartSprayingTerminalTask>>;
  soilNematodeRisks?: Maybe<Array<Maybe<MdSoilNematodeRisk>>>;
  soilSampling?: Maybe<SoilSampling>;
  soilSamplingMeasurements?: Maybe<Array<Maybe<SoilSamplingMeasurement>>>;
  soilSamplingResult?: Maybe<SoilSamplingResult>;
  soilSamplingResults?: Maybe<Array<Maybe<SoilSamplingResult>>>;
  soilSamplingStressAnalyses?: Maybe<Array<Maybe<SoilSamplingStressAnalysis>>>;
  soilSamplingStressAnalysis?: Maybe<SoilSamplingStressAnalysis>;
  soilSamplingTasks?: Maybe<Array<Maybe<SoilSamplingTask>>>;
  soilSamplings?: Maybe<Array<Maybe<SoilSampling>>>;
  soilTaxonomies?: Maybe<Array<Maybe<SoilTaxonomy>>>;
  soilTextures?: Maybe<Array<Maybe<SoilTexture>>>;
  sourceMapStyle?: Maybe<SourceMapStyle>;
  sourceMaps?: Maybe<Array<Maybe<SourceMap>>>;
  sprayers?: Maybe<Array<Maybe<Sprayer>>>;
  /** @deprecated Use `sprayingV2` */
  spraying?: Maybe<Array<Maybe<Spraying>>>;
  sprayingV2?: Maybe<Array<Maybe<SprayingV2>>>;
  sprayingsV2?: Maybe<Array<SprayingV2>>;
  stacFarmStatistics?: Maybe<Array<Maybe<StacFarmStatistics>>>;
  stacItemRenders?: Maybe<Array<Maybe<StacItemRender>>>;
  /**
   *  Every index is vectorized by Remote Sensing. DRONE_* values (including DRONE_WEED_PRESSURE_*) go to
   *  /drone-flight-geometries, all others to /stac/vectorize. For customBreaks, omit/null/[] means automated
   *  breaks; a non-empty list is forwarded and Remote Sensing validates it.
   *  Drone sprayer maps are created through the drone service REST API, not through this query.
   */
  stacItemVectorizeGeometries?: Maybe<StacItemVectorizeGeometry>;
  stacMosaicRender?: Maybe<StacMosaicRender>;
  /** @deprecated Use `tDiskAssignments`. */
  stirObjects: Array<StirObject>;
  /** @deprecated Use `tDiskOperations`. */
  stirOperations: Array<StirOperation>;
  stressEfficacyCharacteristics?: Maybe<Array<Maybe<StressEfficacyCharacteristics>>>;
  stressQuestions?: Maybe<Array<Maybe<StressQuestion>>>;
  stressSettings?: Maybe<Array<Maybe<StressSettings>>>;
  stressSettingsByUuid?: Maybe<StressSettings>;
  /** @deprecated Use `stressesV2` */
  stresses?: Maybe<Array<Maybe<Stress>>>;
  stressesV2?: Maybe<Array<Maybe<StressV2>>>;
  subscriptionPreference?: Maybe<SubscriptionPreference>;
  sustainabilityInput?: Maybe<SustainabilityInput>;
  sustainabilityInputs?: Maybe<Array<Maybe<SustainabilityInput>>>;
  sustainabilityProgram?: Maybe<SustainabilityProgram>;
  sustainabilityProgramInvitation?: Maybe<SustainabilityProgramInvitation>;
  sustainabilityProgramStaffMembers?: Maybe<Array<Maybe<SustainabilityProgramStaffMember>>>;
  sustainabilityPrograms?: Maybe<Array<Maybe<SustainabilityProgram>>>;
  tDiskAssignments: Array<TDiskAssignment>;
  tDiskOperations: Array<TDiskOperation>;
  taskAggregations?: Maybe<Array<Maybe<TaskAggregation>>>;
  tasksHistory?: Maybe<Array<Maybe<EntityHistory>>>;
  tasksSummary?: Maybe<Array<Maybe<TaskSummary>>>;
  tenants?: Maybe<Array<Maybe<Tenant>>>;
  tillageSystems?: Maybe<Array<Maybe<TillageSystem>>>;
  timingCalculationStatuses?: Maybe<Array<Maybe<TimingCalculationStatus>>>;
  timingLimitationsV2?: Maybe<Array<Maybe<TimingLimitationV2>>>;
  timingLimitationsV2List?: Maybe<Array<Maybe<TimingLimitationV2>>>;
  timingProductRecommendations?: Maybe<Array<TimingProductRecommendation>>;
  timingProductRecommendationsGroups?: Maybe<Array<TimingProductRecommendationsGroup>>;
  toppingTask?: Maybe<ToppingTask>;
  toppingTasks?: Maybe<Array<ToppingTask>>;
  tramlines?: Maybe<Array<Maybe<Tramline>>>;
  treatmentScenario?: Maybe<TreatmentScenario>;
  treatmentScenarios?: Maybe<Array<Maybe<TreatmentScenario>>>;
  trials: Array<Maybe<Trial>>;
  uploadDatasetSourceValueMappings?: Maybe<Array<Maybe<SourceValueMapping>>>;
  uploadDatasetSummaries: Array<UploadDatasetSummary>;
  userDataVsValidationComparisons: Array<UserDataVsValidationComparison>;
  userDevices?: Maybe<Array<Maybe<UserDevice>>>;
  userFarmPackages?: Maybe<Array<Maybe<UserFarmPackage>>>;
  userFeatures?: Maybe<Array<Maybe<UserFeature>>>;
  userGroups?: Maybe<Array<UserGroup>>;
  userLicenseRequests?: Maybe<Array<Maybe<UserLicenseRequest>>>;
  userNotifications?: Maybe<Array<Maybe<Notification>>>;
  userNotificationsV2?: Maybe<Array<Maybe<UserNotification>>>;
  userPackages?: Maybe<Array<Maybe<UserPackage>>>;
  userSettings?: Maybe<Array<Maybe<UserSetting>>>;
  users?: Maybe<Array<Maybe<User>>>;
  /** @deprecated `registrationStatusUuid` not supported anymore. */
  varieties?: Maybe<Array<Maybe<Variety>>>;
  varietyCharacteristics?: Maybe<Array<Maybe<VarietyCharacteristic>>>;
  varietyRecommendations?: Maybe<Array<Maybe<VarietyRecommendation>>>;
  vendorDeviceBlacklistEntries?: Maybe<Array<Maybe<VendorDeviceBlacklistEntry>>>;
  vendorDeviceDataAnomalies?: Maybe<Array<Maybe<VendorDeviceDataAnomaly>>>;
  vendorDeviceDataMissing?: Maybe<Array<Maybe<VendorDeviceDataMissing>>>;
  vendorDeviceSensorStatuses?: Maybe<Array<Maybe<VendorDeviceSensorStatus>>>;
  vendorDeviceStatus?: Maybe<Array<Maybe<VendorDeviceStatus>>>;
  waterBalances?: Maybe<Array<Maybe<WaterBalance>>>;
  waterManagementScenarios?: Maybe<Array<Maybe<WaterManagementScenario>>>;
  waterManagementTask?: Maybe<WaterManagementTask>;
  waterManagementTasks?: Maybe<Array<WaterManagementTask>>;
  weather?: Maybe<Array<Maybe<Weather>>>;
  weatherUserData?: Maybe<WeatherUserData>;
  weatherUserDataList?: Maybe<Array<Maybe<WeatherUserData>>>;
  weedRecord: WeedRecord;
  weedRecords?: Maybe<Array<Maybe<WeedRecord>>>;
  weeklySeedingRecommendations?: Maybe<Array<Maybe<WeeklySeedingRecommendation>>>;
  wiuzConnectionStatus?: Maybe<WiuzConnectionStatus>;
  wiuzUserFarms?: Maybe<Array<Maybe<WiuzUserFarm>>>;
  wiuzUserfarmImportOrders?: Maybe<Array<Maybe<WiuzUserfarmImportOrder>>>;
};


export type QueryAbLinesArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryActiveIngredientsArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryAdditionalInfectionRiskFactorArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryAdditionalInfectionRiskFactorsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryAgBalanceFieldEmissionIndicatorsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryAgBalanceFieldInputsArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryAggregatedPestDevelopmentPredictionsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAggregatedUserNotificationsArgs = {
  aggregationDuration?: InputMaybe<Scalars['Int']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['Date']['input'];
  languageCode: Scalars['String']['input'];
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<InputMaybe<NotificationType>>>;
};


export type QueryAnalyticsCollectionArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryAnalyticsCollectionsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryAppConfigsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectTypes?: InputMaybe<Array<InputMaybe<AppConfigObjectType>>>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryArableApiKeyArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryArableDeviceToLocationsArgs = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationType?: InputMaybe<LocationType>;
  locationUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryArableDevicesArgs = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryArvalisCustomEfficacyInformationsArgs = {
  dosedMapUuids: Array<Scalars['UUID']['input']>;
};


export type QueryArvalisDeviceToCropSeasonsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryArvalisInformationsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
};


export type QueryAssessmentArgs = {
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAssessmentAttachmentArgs = {
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAssessmentAttachmentsArgs = {
  assessmentAttachmentUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  assessmentNoteUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryAssessmentDataArgs = {
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAssessmentNoteArgs = {
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAssessmentNotesArgs = {
  assessmentNoteUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  assessmentTimingUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  assessmentUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryAssessmentTimingArgs = {
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryAvailablePackagesArgs = {
  countryCode: Scalars['String']['input'];
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryBagCountsArgs = {
  mdBagUuids: Array<Scalars['UUID']['input']>;
  totalApplication: Scalars['Float']['input'];
  unit: BagUnit;
};


export type QueryBeforeSeasonRisksArgs = {
  cropSeasonUuid: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryBiomassAnalysisNdviArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate: Scalars['Date']['input'];
  returnGeometry?: InputMaybe<Scalars['Boolean']['input']>;
  tillDate: Scalars['Date']['input'];
};


export type QueryBusinessLinePurchaseAggregationsArgs = {
  farmUuids: Array<Scalars['UUID']['input']>;
};


export type QueryCarbonCreditsArgs = {
  carbonFarmingSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCarbonFarmingPlausibilitiesArgs = {
  characteristicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCarbonFarmingRequestsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sustainabilityProgramUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCarbonFarmingSeasonArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCarbonFarmingSeasonsArgs = {
  requestUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCarbonIntensityIndicatorsArgs = {
  carbonFarmingSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCarbonPlausibilityCommentsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryClaasFarmsArgs = {
  claasOrganizationId: Scalars['String']['input'];
};


export type QueryClaasFieldsArgs = {
  claasFarmId: Scalars['UUID']['input'];
  claasOrganizationId: Scalars['String']['input'];
};


export type QueryCnhFarmsArgs = {
  cnhCompanyId: Scalars['String']['input'];
  cnhGrowerUuid: Scalars['UUID']['input'];
};


export type QueryCnhFieldsArgs = {
  cnhCompanyId: Scalars['String']['input'];
  cnhFarmUuid: Scalars['UUID']['input'];
};


export type QueryCnhGrowersArgs = {
  cnhCompanyId: Scalars['String']['input'];
};


export type QueryCnhTasksArgs = {
  taskUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCoefficientOfVariationDetailsArgs = {
  coefficientOfVariation?: InputMaybe<Scalars['Float']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  seasonCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCollaboratorsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryContainersArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCountryCropGrowthStagePredictionsArgs = {
  cropSeasonUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryCountryCropStressSettingsArgs = {
  countryCode: Scalars['String']['input'];
  cropUuids: Array<Scalars['UUID']['input']>;
};


export type QueryCountryWeedsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCriticalCropStageRiskInfosArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
};


export type QueryCriticalCropStageRisksArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<CropSeasonStatusType>>>;
};


export type QueryCriticalGrowthStagePeriodRisksArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<CropSeasonStatusType>>>;
};


export type QueryCropEstablishmentArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCropEstablishmentDetailsArgs = {
  cropSeasonUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropEstablishmentsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropResidueManagementTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCropResidueManagementTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropSeasonArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCropSeasonNutritionProgramExecutionStatusesArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropSeasonNutritionProgramsArgs = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropSeasonNutritionRecommendationsArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
  nitrogenMin: Scalars['Float']['input'];
  provider: NutritionProgramProvider;
};


export type QueryCropSeasonTreatmentProgramV3Args = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCropSeasonTreatmentProgramsArgs = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropSeasonTreatmentProgramsV2Args = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropSeasonTreatmentProgramsV3Args = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropSeasonV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCropSeasonsV2Args = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  lifecycleState?: InputMaybe<Array<InputMaybe<LifecycleState>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropSystemRecommendationArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCropSystemRecommendationV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCropSystemRecommendationsV2Args = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCropUsagesArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCropWaterAvailabilitiesArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCropsArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCurrentWeedPredictionsArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCustomPowerzoneOrderArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryCustomPowerzoneOrdersArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
};


export type QueryDailyFungusDetailsArgs = {
  cropSeasonUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryDailyStressCharacteristicsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  stressRiskTypes?: InputMaybe<Array<InputMaybe<RiskType>>>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<DailyStressCharacteristicsType>>>;
};


export type QueryDailyStressEventProbabilitiesArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  stressUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryDailyWeedRiskDetailsArgs = {
  cropSeasonUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryDemandEquationRecommendationArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryDemandEquationRecommendationV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type QueryDemandEquationRecommendationsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDemandEquationRecommendationsV2Args = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDevicePackageArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryDevicePackagesArgs = {
  deviceUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  historicalItems?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDictcodeFeaturesArgs = {
  characteristicIds: Array<Scalars['String']['input']>;
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['String']['input']>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropStageGroupCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropStageGroupUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropStageGrowthScaleCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  dictShort?: InputMaybe<Scalars['String']['input']>;
  pestCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pestUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDictcodeHierarchiesArgs = {
  childDict?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentDict?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentDictCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentDictcodeUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDictionariesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dict: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDosedMapLegendsArgs = {
  dosedMapUuid: Scalars['UUID']['input'];
};


export type QueryDosedMapProductSummariesArgs = {
  applicationTypes?: InputMaybe<Array<ApplicationType>>;
  creationFlowHints?: InputMaybe<Array<CreationFlowHint>>;
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  productCategories?: InputMaybe<Array<ProductCategoryType>>;
};


export type QueryDosedMapsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDroneFlightQuotaTransfersArgs = {
  sourceDroneFlightQuotaUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  targetDroneFlightQuotaUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDroneFlightQuotasArgs = {
  farmUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDroneFlightSummaryArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryDroneFlightsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  flightCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  referenceDroneFlightTaskUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDronePlantingFailureMapsArgs = {
  flightUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDroneSprayerWeedMapsArgs = {
  flightUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDtnVendorDeviceActivationArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryDtnVendorDeviceActivationsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryDtnVendorDeviceToLocationsArgs = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationType?: InputMaybe<LocationType>;
  locationUuid?: InputMaybe<Scalars['UUID']['input']>;
  vendor: DtnVendor;
};


export type QueryDtnVendorDeviceToLocationsV2Args = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  locationType?: InputMaybe<LocationType>;
  locationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<DtnVendor>;
};


export type QueryDtnVendorDevicesArgs = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deviceScope?: InputMaybe<DeviceScope>;
  locationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  searchCenterLocationUuid?: InputMaybe<Scalars['UUID']['input']>;
  searchRadius?: InputMaybe<Scalars['Float']['input']>;
  vendor?: InputMaybe<DtnVendor>;
};


export type QueryDtnVendorKeyArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryExatrekApplicationMapDispatchOrdersArgs = {
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryExatrekDeviceStatesArgs = {
  uuids: Array<Scalars['UUID']['input']>;
};


export type QueryExatrekUserDevicesArgs = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryExatrekUserMachinesArgs = {
  userDeviceUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryExistingOrdersArgs = {
  farmUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryExportOrderArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryExportOrdersArgs = {
  taskUuids: Array<Scalars['UUID']['input']>;
};


export type QueryFarmArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryFarmCarbonIntensityIndicatorsArgs = {
  cropUuid: Scalars['UUID']['input'];
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sustainabilityProgramUuid: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryFarmCropMetricsArgs = {
  farmUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryFarmDataLayersArgs = {
  farmUuid?: InputMaybe<Scalars['UUID']['input']>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  magnitude: MagnitudeType;
  type: FieldDataLayerType;
};


export type QueryFarmEvidenceArgs = {
  farmUuid: Scalars['UUID']['input'];
  sustainabilityProgramUuid: Scalars['UUID']['input'];
};


export type QueryFarmFeaturesSummaryArgs = {
  farmUuids: Array<Scalars['UUID']['input']>;
};


export type QueryFarmGreetCarbonIntensityScoresArgs = {
  cropUuid: Scalars['UUID']['input'];
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sustainabilityProgramUuid: Scalars['UUID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryFarmLayerSummaryCountArgs = {
  farmUuid: Scalars['UUID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryFarmPackagesArgs = {
  farmUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  historicalItems?: InputMaybe<Scalars['Boolean']['input']>;
  sourceType?: InputMaybe<FarmPackageSourceType>;
  sourceUuid?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<FarmPackageType>;
};


export type QueryFarmV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type QueryFarmsV2Args = {
  lastUpdatedFrom?: InputMaybe<Scalars['Date']['input']>;
  uuids: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryFieldArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryFieldActivationsArgs = {
  farmUuid?: InputMaybe<Scalars['UUID']['input']>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  packageUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldBoundaryLookupScoreArgs = {
  farmUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  regionOfInterest?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFieldDataLayerClassificationsArgs = {
  elevation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldDataLayerUuid: Scalars['UUID']['input'];
  locale: Scalars['String']['input'];
  magnitudes: Array<InputMaybe<MagnitudeType>>;
};


export type QueryFieldDataLayerLegendsArgs = {
  elevation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldDataLayerUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  magnitudes?: InputMaybe<Array<InputMaybe<MagnitudeType>>>;
};


export type QueryFieldDataLayerStatisticsArgs = {
  elevation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  magnitudeType: Array<InputMaybe<MagnitudeType>>;
  regionOfInterest?: InputMaybe<Scalars['String']['input']>;
  regionsOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid: Scalars['UUID']['input'];
};


export type QueryFieldDataLayersArgs = {
  applicationTypes?: InputMaybe<Array<InputMaybe<FieldDataUploadApplicationType>>>;
  cropEstablishmentUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  fromDateCreated?: InputMaybe<Scalars['Date']['input']>;
  includedMagnitudeTypeFilter?: InputMaybe<Array<InputMaybe<MagnitudeType>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maxCountByType?: InputMaybe<Scalars['Int']['input']>;
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sprayingUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskType?: InputMaybe<Array<InputMaybe<FieldDataLayerTaskType>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  tillDateCreated?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<FieldDataLayerType>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldDataLayersStatisticsArgs = {
  elevation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  magnitudeTypes: Array<MagnitudeType>;
  uuids: Array<Scalars['UUID']['input']>;
};


export type QueryFieldDataUploadDatasetsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  fromDateCreated?: InputMaybe<Scalars['Date']['input']>;
  hasDeletedFieldDataLayers?: InputMaybe<Scalars['Boolean']['input']>;
  sourceTypes?: InputMaybe<Array<InputMaybe<FileSource>>>;
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskType?: InputMaybe<Array<InputMaybe<TaskType>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  tillDateCreated?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<InputMaybe<UploadDatasetType>>>;
  uploadDatasetGroupUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldEntriesArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldFeaturesArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldInputPackagingsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldNotesAggregationArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldNoteUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  observationDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryFieldPointLookupArgs = {
  farmUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pointOfInterest?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFieldV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type QueryFieldVariabilityIndexesArgs = {
  cropSeasonUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldVariabilityInputsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldZonesArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFieldsV2Args = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lastUpdatedFrom?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFmCarbonRelatedDataArgs = {
  fieldUuids: Array<Scalars['UUID']['input']>;
};


export type QueryForeignCatchCropsArgs = {
  catchCropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  catchCropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  regionUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryForeignCropsArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  regionUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryForeignPreCropsArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preCropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preCropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryFreshBiomassOrderArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryFrostRisksArgs = {
  cropSeasonUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGeoMapDetailsArgs = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mapCode?: InputMaybe<Scalars['String']['input']>;
  mapTypeCode?: InputMaybe<Scalars['String']['input']>;
  mapTypeUuid?: InputMaybe<Scalars['UUID']['input']>;
  mapUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGreenhouseWhiteningTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryGreenhouseWhiteningTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryGreenhousesArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryGreetCarbonIntensityScoresArgs = {
  carbonFarmingSeasonUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  cropSeasonUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryGrowthStagePredictionDailyArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
};


export type QueryGrowthStagesArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
};


export type QueryHarvestArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryHarvestsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfAgRegionsArgs = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryHfAlertsArgs = {
  farmUuids: Array<Scalars['UUID']['input']>;
};


export type QueryHfClaimsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfContractorRequestsArgs = {
  creatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<HfContractorRequestStatus>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfDiscountsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  hfServiceRequestUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfDistributorsArgs = {
  mdDistributorUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfFarmsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfInvoicesArgs = {
  hfServiceRequestUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  invoiceReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfMachineriesArgs = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfOfferConditionsArgs = {
  cropSeasonUuid: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryHfOffersArgs = {
  uuids: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryHfPreOrdersArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfPricesArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  hfReferenceCodeUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryHfRatesArgs = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryHfReferenceCodeRatesArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  hfReferenceCodeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  season?: InputMaybe<PricingSeason>;
};


export type QueryHfReferenceCodesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdFromDate?: InputMaybe<Scalars['Date']['input']>;
  createdTillDate?: InputMaybe<Scalars['Date']['input']>;
  distributorUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfReferenceCodesPublicArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfRequestFarmPackageAddOnsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfRiskClassesArgs = {
  hfReferenceCodeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  varietyUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryHfSeasonArgs = {
  countryCode: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHfServiceRequestsArgs = {
  assignedContractorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHfServiceRequestsHistoryArgs = {
  uuids: Array<Scalars['UUID']['input']>;
};


export type QueryHfWeatherDataArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHortaCropSeasonsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHortaSprayingsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sprayingUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHortaStressesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  treatmentTypeCode?: InputMaybe<Scalars['String']['input']>;
  treatmentTypeUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryHortaSustainabilityIndicatorsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryImportOrdersArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryImportantGrowthStagesArgs = {
  countryCode: Scalars['String']['input'];
  cropUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryJdFieldSynchronizationOrderArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryJdFieldSynchronizationOrdersArgs = {
  jdOrganizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryJdNotificationSubscriptionsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryKubotaApplicationMapDispatchOrdersArgs = {
  taskUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryKwsConsentArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryLandPreparationArgs = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryLandPreparationsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryLeafPruningTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryLeafPruningTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryLicenseRequestsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryLicensesArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  seller?: InputMaybe<LicenseSellerType>;
};


export type QueryLinkedDevicesArgs = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryMd2AggregatedProductusesByCropsArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryMd2ConfigurationsArgs = {
  characteristicId?: InputMaybe<Scalars['String']['input']>;
  characteristicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sourceCode?: InputMaybe<Scalars['String']['input']>;
  sourceUuid?: InputMaybe<Scalars['UUID']['input']>;
  stressCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryMd2CountryCropConfigurationsArgs = {
  characteristicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryMd2CropGrowthStageV2Args = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCode?: InputMaybe<Array<Scalars['String']['input']>>;
  cropUuid?: InputMaybe<Array<Scalars['UUID']['input']>>;
  isActiveGSModel?: InputMaybe<IsActiveGsModelFilter>;
  locale?: InputMaybe<Scalars['String']['input']>;
  scaleCode?: InputMaybe<ScaleV2>;
  uuid?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryMd2ProductFeaturesArgs = {
  characteristicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sourceCode?: InputMaybe<Scalars['String']['input']>;
  sourceUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMd2TillageDepthsArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryMd2VraAdvisorConfigurationsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  productCategoryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productCategoryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskTypeCode?: InputMaybe<MdTaskType>;
  taskTypeUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryMdUnitsArgs = {
  baseUnitCode?: InputMaybe<Scalars['String']['input']>;
  baseUnitUuid?: InputMaybe<Scalars['UUID']['input']>;
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  unitGroupCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unitGroupUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  validUnit?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMeasureSubmissionOrdersArgs = {
  programUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryMeasureSubmissionResultsArgs = {
  measureSubmissionUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryMergedSmartSprayerExecutionArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryMinObservationDateArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
};


export type QueryMonitorPracticesArgs = {
  fieldUuids: Array<Scalars['UUID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMultiFileUploadOrdersArgs = {
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryNamedCropMixesArgs = {
  countryCode: Scalars['String']['input'];
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryNotificationPreferencesArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryNutrientMethodMappingsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  distributorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  distributorUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  nutrientMethodCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nutrientMethodUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryNutritionVraAdvisorGeometriesArgs = {
  index: AgronomicIndexType;
  numberOfZones?: InputMaybe<Scalars['Int']['input']>;
  stacItemUuid: Scalars['UUID']['input'];
};


export type QueryObservationArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryObservationsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOnOffStatisticsArgs = {
  fieldDataLayerUuid?: InputMaybe<Scalars['UUID']['input']>;
  regionsOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOnesoilApplicationMapDispatchOrdersArgs = {
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userDeviceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOnesoilDevicesArgs = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOnesoilFarmReceivedFilesArgs = {
  farmUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
};


export type QueryOnesoilReceivedFilesArgs = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOnesoilUploadDatasetOrdersArgs = {
  osMdlReceivedFileUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOperationalInstructionsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  roleFeatureName: Scalars['String']['input'];
};


export type QueryOrderAffiliatesArgs = {
  affiliateCodeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOrganisationBranchesArgs = {
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOrganisationFarmAssignmentsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOrganisationFeaturesArgs = {
  features?: InputMaybe<Array<InputMaybe<OrganisationFeatureType>>>;
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOrganisationMembersArgs = {
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganisationMembershipRequestsArgs = {
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  requesteeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOrganisationMethodsArgs = {
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryOrganisationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  organisationTags?: InputMaybe<Array<InputMaybe<OrganisationTagType>>>;
  quotasRequired?: InputMaybe<Scalars['Boolean']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPackagesArgs = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<PackageType>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedFarmEvidenceLinksArgs = {
  farmUuid: Scalars['UUID']['input'];
  includeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  recordType?: InputMaybe<Array<FarmEvidenceLinkRecordType>>;
  recordUuid?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sort?: InputMaybe<Array<FarmEvidenceLinkSort>>;
  sustainabilityProgramUuid: Scalars['UUID']['input'];
};


export type QueryPaginatedFarmReceiptsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  receiptKinds?: InputMaybe<Array<InputMaybe<FarmReceiptKind>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedFieldDataLayersArgs = {
  cropEstablishmentUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  fromDateCreated?: InputMaybe<Scalars['Date']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<FieldDataLayerSort>>>;
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sprayingUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskType?: InputMaybe<Array<InputMaybe<FieldDataLayerTaskType>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  tillDateCreated?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<FieldDataLayerType>>>;
};


export type QueryPaginatedFieldDataUploadDatasetsArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  fromDateCreated?: InputMaybe<Scalars['Date']['input']>;
  hasDeletedFieldDataLayers?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FieldDataUploadDatasetSort>>>;
  sourceTypes?: InputMaybe<Array<InputMaybe<FileSource>>>;
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskType?: InputMaybe<Array<InputMaybe<TaskType>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  tillDateCreated?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<InputMaybe<UploadDatasetType>>>;
  uploadDatasetGroupUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedFieldEvidenceArgs = {
  farmUuid: Scalars['UUID']['input'];
  fieldUuid?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FieldEvidenceSort>>;
  sustainabilityProgramUuid: Scalars['UUID']['input'];
};


export type QueryPaginatedFieldEvidenceLinksArgs = {
  farmUuid: Scalars['UUID']['input'];
  fieldUuid?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includeRemoved?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  recordType?: InputMaybe<Array<FieldEvidenceLinkRecordType>>;
  recordUuid?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sort?: InputMaybe<Array<FieldEvidenceLinkSort>>;
  sustainabilityProgramUuid: Scalars['UUID']['input'];
};


export type QueryPaginatedFieldNotesArgs = {
  attachmentType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creatorId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropSeasonUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  hasAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  hasGrowthStageObservation?: InputMaybe<Scalars['Boolean']['input']>;
  hasStressObservation?: InputMaybe<Scalars['Boolean']['input']>;
  locationType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scoutingPoiUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  scoutingTaskUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<FieldNoteSort>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  uuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedFilesArgs = {
  batchUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fileExtensions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FileSort>>>;
  sources?: InputMaybe<Array<InputMaybe<FileSource>>>;
  uploadFromDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedHfClaimsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  season?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedHfContractorRequestsArgs = {
  creatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  status?: InputMaybe<HfContractorRequestStatus>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedHfOperationalInstructionsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  roleFeatureName: Scalars['String']['input'];
};


export type QueryPaginatedMapItemsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldDataLayerTypes?: InputMaybe<Array<InputMaybe<FieldDataLayerType>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  locale: Scalars['String']['input'];
  maxCountByType?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<MapItemSort>>>;
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  stacFieldDataLayerTypes?: InputMaybe<Array<InputMaybe<StacFieldDataLayer>>>;
  taskTypes?: InputMaybe<Array<InputMaybe<FieldDataLayerTaskType>>>;
  taskUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryPaginatedMd2DictionaryMappingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  sameTarget?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sourceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceDictShort: Scalars['String']['input'];
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  targetCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetDictShort: Scalars['String']['input'];
  targetUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedOrganisationQuotaLedgersArgs = {
  fromDate: Scalars['Date']['input'];
  licenseUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  operationType?: InputMaybe<OrganisationQuotaOperationType>;
  organisationUuids: Array<Scalars['UUID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<InputMaybe<OrganisationQuotaLedgerSort>>>;
  tillDate: Scalars['Date']['input'];
};


export type QueryPaginatedOrganisationsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organisationTags?: InputMaybe<Array<InputMaybe<OrganisationTagType>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedPreOrdersArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  hfReferenceCodeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  includeObsolete?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCurrentSeason?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  season?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedScaleTicketBookingDisputesArgs = {
  farmName?: InputMaybe<Scalars['String']['input']>;
  organisationUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Array<InputMaybe<ScaleTicketBookingDisputeReason>>>;
  sort?: InputMaybe<Array<ScaleTicketBookingDisputeSort>>;
  state?: InputMaybe<Array<InputMaybe<ScaleTicketBookingDisputeState>>>;
  ticketUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedScaleTicketBookingsArgs = {
  carbonFarmingSeasonUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScaleTicketBookingSort>>;
  sustainabilityProgramUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  ticketUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedScaleTicketDataMappingsArgs = {
  columnNames?: InputMaybe<Array<Scalars['String']['input']>>;
  organisationUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScaleTicketDataMappingSort>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryPaginatedScaleTicketHistoryArgs = {
  branchUuid: Scalars['UUID']['input'];
  organisationUuid: Scalars['UUID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScaleTicketHistorySort>>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  ticketUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryPaginatedScaleTicketSellerMappingsArgs = {
  farmUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organisationUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ScaleTicketSellerMappingSort>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryPaginatedScaleTicketUploadsArgs = {
  branchUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  organisationUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScaleTicketUploadSort>>;
  state?: InputMaybe<ScaleTicketUploadState>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryPaginatedScaleTicketsArgs = {
  branchUuid?: InputMaybe<Scalars['UUID']['input']>;
  farmUuid?: InputMaybe<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  includeBookings?: InputMaybe<Scalars['Boolean']['input']>;
  organisationUuid?: InputMaybe<Scalars['UUID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sellerName?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ScaleTicketSort>>;
  state?: InputMaybe<Array<InputMaybe<ScaleTicketState>>>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryPaginatedScoutingTasksArgs = {
  assigneeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  assignmentStates?: InputMaybe<Array<InputMaybe<TaskAssignmentState>>>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  excludeStressQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  protocolUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<ScoutingTaskSort>>>;
  states?: InputMaybe<Array<InputMaybe<TaskExecutionState>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  trialUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedSmartSprayerExecutionsArgs = {
  adeModes?: InputMaybe<Array<AdeMode>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cropUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  farmUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fieldUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  operationModes?: InputMaybe<Array<OperationMode>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  smartSprayerRegistrationUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sort?: InputMaybe<Array<SmartSprayerExecutionSort>>;
  strategies?: InputMaybe<Array<Strategy>>;
  taskUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryPaginatedSmartSprayerRegistrationsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  licenseStatus?: InputMaybe<Scalars['String']['input']>;
  machineIdentifier?: InputMaybe<Scalars['String']['input']>;
  oem?: InputMaybe<SmartSprayerRegistrationOem>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  smartSprayerLicenseUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sort?: InputMaybe<Array<SmartSprayerRegistrationSort>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedSustainabilityOrganisationCapabilitiesArgs = {
  capabilities?: InputMaybe<Array<InputMaybe<SustainabilityOrganisationCapabilityType>>>;
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SustainabilityOrganisationCapabilitySort>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedSustainabilityProgramBranchAssignmentsArgs = {
  isFPA?: InputMaybe<Scalars['Boolean']['input']>;
  isPlant?: InputMaybe<Scalars['Boolean']['input']>;
  organisationBranchUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SustainabilityProgramBranchAssignmentSort>>;
  sustainabilityProgramUuids: Array<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedSustainabilityProgramEnrolledFieldsArgs = {
  farmName?: InputMaybe<Scalars['String']['input']>;
  farmUuid?: InputMaybe<Scalars['UUID']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldUuid?: InputMaybe<Scalars['UUID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SustainabilityProgramEnrolledSort>>;
  sustainabilityProgramUuid: Scalars['UUID']['input'];
};


export type QueryPaginatedSustainabilityProgramInvitationsArgs = {
  inviteeEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SustainabilityProgramInvitationSort>>;
  sustainabilityProgramUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedSustainabilityProgramOrganisationParticipationsArgs = {
  capabilities?: InputMaybe<Array<SustainabilityOrganisationCapabilityType>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  partnerOrganisationUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  programOrganisationUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sort?: InputMaybe<Array<SustainabilityProgramOrganisationParticipationSort>>;
  statuses?: InputMaybe<Array<SustainabilityProgramOrganisationParticipationStatus>>;
  sustainabilityProgramUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryPaginatedSustainabilityProgramsArgs = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  joinCode?: InputMaybe<Scalars['String']['input']>;
  organisationUuid?: InputMaybe<Scalars['UUID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SustainabilityProgramSort>>;
  types?: InputMaybe<Array<InputMaybe<SustainabilityProgramType>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedTasksArgs = {
  assigneeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  assignmentStates?: InputMaybe<Array<InputMaybe<TaskAssignmentState>>>;
  creationFlowHints?: InputMaybe<Array<InputMaybe<CreationFlowHint>>>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  generalStatuses?: InputMaybe<Array<InputMaybe<GeneralTaskStatus>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  productCategoryCodes?: InputMaybe<Array<InputMaybe<ProductCategoryType>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TaskSort>>>;
  taskTypes?: InputMaybe<Array<InputMaybe<GeneralTaskType>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryPaginatedTrialsV2Args = {
  creatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lockedAt?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  protocolUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sort?: InputMaybe<Array<InputMaybe<TrialV2Sort>>>;
  trialUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPaginatedVarietiesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  registeredRegionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registeredRegionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registrationNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPanoramaClientsArgs = {
  panoramaOrgCode: Scalars['String']['input'];
};


export type QueryPanoramaFarmsArgs = {
  panoramaClientName: Scalars['String']['input'];
  panoramaOrgCode: Scalars['String']['input'];
};


export type QueryPanoramaFieldsArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  panoramaClientName?: InputMaybe<Scalars['String']['input']>;
  panoramaFarmName?: InputMaybe<Scalars['String']['input']>;
  panoramaOrgCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPermissionsArgs = {
  granteeUuid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granteeUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granterUuid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  granterUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  objectUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPestDevelopmentPredictionsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryPreOrderArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryPreOrdersArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  hfReferenceCodeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  includeObsolete?: InputMaybe<Scalars['Boolean']['input']>;
  onlyCurrentSeason?: InputMaybe<Scalars['Boolean']['input']>;
  season?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPrecifieldBiomassMapsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPrecifieldCerealsMapSubscriptionArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPrecifieldNitrogenPrescriptionMapsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPrecifieldOsrMapSubscriptionsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPrecifieldYieldPotentialMapsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryProduceDeliveryTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryProduceDeliveryTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryProductPacksArgs = {
  categoryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProductPermissibleRatesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  taskMethodCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskMethodUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskTypeCode?: InputMaybe<Scalars['String']['input']>;
  taskTypeUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryProductPermissibleRatesV2Args = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  taskMethodCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskMethodUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskTypeCode?: InputMaybe<Scalars['String']['input']>;
  taskTypeUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryProductRecommendationTankMixesArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  includeDoseRateCompatibility?: InputMaybe<Scalars['Boolean']['input']>;
  includeHealthyFields?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductsArgs = {
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropUuid: Scalars['UUID']['input'];
  type?: InputMaybe<Array<InputMaybe<AbstractProductType>>>;
};


export type QueryProductsV2Args = {
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nutrientCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nutrientUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  productCategoryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productCategoryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskTypeCode?: InputMaybe<Scalars['String']['input']>;
  taskTypeUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryProjectedIncidencesArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
};


export type QueryProtocolArgs = {
  uuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProtocolAttachmentsArgs = {
  protocolUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryProtocolsArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  factorUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  targetCountries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetYears?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  typeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryPublicOrganisationsArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orgMemberUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ownerUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryQuotaLimitsArgs = {
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryQuotaTransfersArgs = {
  sourceOrganisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  targetOrganisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryRecentlyUsedProductsArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  productCategoryUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskTypes?: InputMaybe<Array<InputMaybe<TaskType>>>;
};


export type QueryRisksArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<CropSeasonStatusState>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<InputMaybe<RiskType>>>;
};


export type QueryRisksV2Args = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<InputMaybe<CropSeasonStatusState>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<InputMaybe<RiskType>>>;
};


export type QueryScaleTicketArgs = {
  includeBookings?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['UUID']['input'];
};


export type QueryScaleTicketBookingArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryScaleTicketBookingDisputeArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryScaleTicketSummaryArgs = {
  branchUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fileUuid?: InputMaybe<Scalars['UUID']['input']>;
  organisationUuid: Scalars['UUID']['input'];
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
  sellerName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ticketNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScaleTicketUploadArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryScoutingPoisArgs = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryScoutingPoisV2Args = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryScoutingProtocolsArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryScoutingReportDispatchOrdersArgs = {
  scoutingReportUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryScoutingReportsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  reportDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryScoutingStressQuestionsArgs = {
  assessmentTypeCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assessmentTypeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  scoutingProblemCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scoutingProblemUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  stressCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryScoutingStressQuestionsByWeedAssessmentTypeArgs = {
  assessmentTypeCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assessmentTypeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  stressCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryScoutingTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  excludeStressQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  trialUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySearchFieldIdentifierScoresArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySearchFieldVariabilityInSeasonArgs = {
  farmUuids: Array<Scalars['UUID']['input']>;
};


export type QuerySearchFieldVariabilityTimeSeriesArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate: Scalars['Date']['input'];
  tillDate: Scalars['Date']['input'];
};


export type QuerySearchTreatmentProgramsArgs = {
  actions?: InputMaybe<Array<SearchTreatmentProgramActionInput>>;
  cropEstablishmentGrowthStageIndex?: InputMaybe<Scalars['String']['input']>;
  cropEstablishmentGrowthStageScaleCode?: InputMaybe<ScaleV2>;
  cropEstablishmentMethodUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  equipmentType?: InputMaybe<TreatmentEquipmentType>;
  farmUuid: Scalars['UUID']['input'];
  season?: InputMaybe<Scalars['String']['input']>;
  type: TreatmentProgramType;
  uniqueOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySearchTreatmentScenariosArgs = {
  actions?: InputMaybe<Array<ActionInput>>;
  cropUuid: Scalars['UUID']['input'];
  equipmentType: TreatmentEquipmentType;
  farmUuid: Scalars['UUID']['input'];
  season?: InputMaybe<Scalars['String']['input']>;
  type: TreatmentScenarioType;
};


export type QuerySeasonTimelinesArgs = {
  characteristicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySeedBoxTreatmentsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySeedSelectorInputArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySeedSelectorInputsArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySeedTreatmentsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySharingMandatesArgs = {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryShopDevicePackagesArgs = {
  deviceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryShopFarmPackagesArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryShopGiftCardArgs = {
  giftCardCode: Scalars['String']['input'];
};


export type QueryShopSubscriptionItemsArgs = {
  subscriptionUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryShopSubscriptionPeriodArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryShopSubscriptionPeriodsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  subscriptionUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryShopSubscriptionsArgs = {
  deviceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  ownerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  renewalDateFrom?: InputMaybe<Scalars['Date']['input']>;
  renewalDateTill?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ShopSubscriptionStatus>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryShopUserPackagesArgs = {
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySmartSprayerExecutionArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayerExecutionStatisticsArgs = {
  adeModes?: InputMaybe<Array<AdeMode>>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  cropUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  farmUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fieldUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  operationModes?: InputMaybe<Array<OperationMode>>;
  smartSprayerRegistrationUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  strategies?: InputMaybe<Array<Strategy>>;
  taskUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QuerySmartSprayerExecutionsArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  smartSprayerRegistrationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayerLicensesArgs = {
  oems?: InputMaybe<Array<InputMaybe<SmartSprayerRegistrationOem>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayerRegistrationArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayerRegistrationStatusArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayerRegistrationsArgs = {
  smartSprayerLicenseUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayerWeedPressureExclusionsArgs = {
  fieldUuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayerWeedPressureFieldArgs = {
  fieldUuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayerWeedPressureFieldsArgs = {
  farmUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fieldUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SmartSprayerWeedPressureFieldSort>>;
};


export type QuerySmartSprayerWeedPressureStatisticsArgs = {
  farmUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fieldUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QuerySmartSprayingOfflineTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayingOfflineTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayingOfflineTasksV2Args = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  smartSprayingExecutionUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayingTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayingTaskDevicePayloadsArgs = {
  smartSprayingTaskUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayingTaskV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayingTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayingTasksV2Args = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lastUpdatedFrom?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySmartSprayingTerminalTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySmartSprayingTerminalTasksArgs = {
  smartSprayerRegistrationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  smartSprayingExecutionUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySoilNematodeRisksArgs = {
  assessmentObjectCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assessmentObjectUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  pestCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pestUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySoilSamplingArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySoilSamplingResultArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySoilSamplingResultsArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySoilSamplingStressAnalysesArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  soilSamplingResultUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySoilSamplingStressAnalysisArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySoilSamplingTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  soilSamplingSetUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySoilSamplingsArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySoilTaxonomiesArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySoilTexturesArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dict?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySourceMapStyleArgs = {
  applicationType?: InputMaybe<ApplicationType>;
  country?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  type: SourceMapType;
};


export type QuerySourceMapsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  filterStrategy?: InputMaybe<FilterStrategy>;
  sourceCardinality?: InputMaybe<Array<InputMaybe<SourceCardinality>>>;
  sourceUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<SourceMapType>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySprayersArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manufacturerCode?: InputMaybe<Scalars['String']['input']>;
  manufacturerUuid?: InputMaybe<Scalars['UUID']['input']>;
  typeCode?: InputMaybe<Scalars['String']['input']>;
  typeUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySprayingArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySprayingV2Args = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySprayingsV2Args = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryStacFarmStatisticsArgs = {
  farmUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryStacItemRendersArgs = {
  creationFlowHint?: InputMaybe<CreationFlowHint>;
  cropSeasonResultLimit?: InputMaybe<Scalars['Int']['input']>;
  cropSeasonUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fieldUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  magnitudeTypes?: InputMaybe<Array<StacMagnitudeType>>;
  productCategoryTypes?: InputMaybe<Array<InputMaybe<ProductCategoryType>>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  varietyUuid?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryStacItemVectorizeGeometriesArgs = {
  creationFlowHint: CreationFlowHint;
  customBreaks?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  germinationRatePercentage?: InputMaybe<Scalars['Float']['input']>;
  index: AgronomicIndexType;
  numberOfZones?: InputMaybe<Scalars['Int']['input']>;
  productCategoryTypes?: InputMaybe<Array<InputMaybe<ProductCategoryType>>>;
  stacItemUuid: Scalars['UUID']['input'];
  varietyUuid?: InputMaybe<Scalars['UUID']['input']>;
  yieldExpectation?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryStacMosaicRenderArgs = {
  boundingBox?: InputMaybe<Array<Scalars['Float']['input']>>;
  fieldUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  magnitudeType: StacMagnitudeType;
  renderingType?: InputMaybe<RenderingType>;
  tillDate?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryStirObjectsArgs = {
  fmObjectType?: InputMaybe<Scalars['String']['input']>;
  fmObjectUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryStirOperationsArgs = {
  taskType: StirTaskType;
};


export type QueryStressEfficacyCharacteristicsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  format?: InputMaybe<Array<InputMaybe<TimeFormat>>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  taskUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryStressQuestionsArgs = {
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryStressSettingsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryStressSettingsByUuidArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryStressesArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStressesV2Args = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySustainabilityInputArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySustainabilityInputsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySustainabilityProgramArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySustainabilityProgramInvitationArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QuerySustainabilityProgramStaffMembersArgs = {
  sustainabilityProgramUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QuerySustainabilityProgramsArgs = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  organisationUuid?: InputMaybe<Scalars['UUID']['input']>;
  types?: InputMaybe<Array<InputMaybe<SustainabilityProgramType>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryTDiskAssignmentsArgs = {
  taskType?: InputMaybe<TDiskTaskType>;
  taskUuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryTDiskOperationsArgs = {
  taskType?: InputMaybe<TDiskTaskType>;
  uuids?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type QueryTaskAggregationsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryTasksHistoryArgs = {
  taskTypes: Array<GeneralTaskType>;
  uuids: Array<Scalars['UUID']['input']>;
};


export type QueryTasksSummaryArgs = {
  creationFlowHint: CreationFlowHint;
  cropUuids: Array<Scalars['UUID']['input']>;
  farmUuids: Array<Scalars['UUID']['input']>;
  isHealthyField?: InputMaybe<Scalars['Boolean']['input']>;
  productCategoryCode?: InputMaybe<Array<InputMaybe<ProductCategoryType>>>;
  taskType: GeneralTaskType;
};


export type QueryTillageSystemsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTimingCalculationStatusesArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
};


export type QueryTimingLimitationsV2Args = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryTimingLimitationsV2ListArgs = {
  inputs: Array<TimingLimitationsV2Input>;
};


export type QueryTimingProductRecommendationsArgs = {
  cropSeasonUuids: Array<InputMaybe<Scalars['UUID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryTimingProductRecommendationsGroupsArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  includeDoseRateCompatibility: Scalars['Boolean']['input'];
  sort?: InputMaybe<ProductRecommendationsGroupSort>;
  type?: InputMaybe<Array<InputMaybe<TimingProductRecommendationsGroupType>>>;
};


export type QueryToppingTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryToppingTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryTramlinesArgs = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryTreatmentScenarioArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryTreatmentScenariosArgs = {
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryTrialsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  protocolUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  trialUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryUploadDatasetSourceValueMappingsArgs = {
  columnIndex?: InputMaybe<Scalars['Int']['input']>;
  columnName?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  measurement: Scalars['String']['input'];
  uploadDatasetUuid: Scalars['UUID']['input'];
};


export type QueryUploadDatasetSummariesArgs = {
  status?: InputMaybe<Array<InputMaybe<UploadDatasetStatus>>>;
};


export type QueryUserDataVsValidationComparisonsArgs = {
  fieldUuids: Array<Scalars['UUID']['input']>;
};


export type QueryUserDevicesArgs = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryUserFarmPackagesArgs = {
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryUserGroupsArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUserLicenseRequestsArgs = {
  organisationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryUserNotificationsArgs = {
  farmUuid?: InputMaybe<Scalars['UUID']['input']>;
  fromDate: Scalars['Date']['input'];
  tillDate: Scalars['Date']['input'];
};


export type QueryUserNotificationsV2Args = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fromDate: Scalars['Date']['input'];
  languageCode: Scalars['String']['input'];
  objectUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<InputMaybe<NotificationType>>>;
};


export type QueryUserPackagesArgs = {
  historicalItems?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryUsersArgs = {
  emailIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inviteCodeUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryVarietiesArgs = {
  countryUuid?: InputMaybe<Scalars['UUID']['input']>;
  cropUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registrationNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registrationStatusUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryVarietyCharacteristicsArgs = {
  altitude?: InputMaybe<Scalars['Int']['input']>;
  characteristicIds: Array<Scalars['String']['input']>;
  characteristicsStrategy?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  irrigated?: InputMaybe<Scalars['Boolean']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  regionUuid?: InputMaybe<Scalars['UUID']['input']>;
  seasonCode?: InputMaybe<Scalars['String']['input']>;
  seasonUuid?: InputMaybe<Scalars['UUID']['input']>;
  sowingDate?: InputMaybe<Scalars['Date']['input']>;
  stressCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stressUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  varietyCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  varietyUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryVarietyRecommendationsArgs = {
  fieldUuids: Array<Scalars['UUID']['input']>;
};


export type QueryVendorDeviceBlacklistEntriesArgs = {
  deviceUuid?: InputMaybe<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryVendorDeviceDataAnomaliesArgs = {
  deviceUuid?: InputMaybe<Scalars['UUID']['input']>;
  fromDate: Scalars['Date']['input'];
  tillDate: Scalars['Date']['input'];
  timeFormat: WeatherFormat;
};


export type QueryVendorDeviceDataMissingArgs = {
  deviceUuid?: InputMaybe<Scalars['UUID']['input']>;
  fromDate: Scalars['Date']['input'];
  tillDate: Scalars['Date']['input'];
  timeFormat: WeatherFormat;
};


export type QueryVendorDeviceSensorStatusesArgs = {
  deviceUuid?: InputMaybe<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryVendorDeviceStatusArgs = {
  vendor?: InputMaybe<DtnVendor>;
};


export type QueryWaterBalancesArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryWaterManagementScenariosArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryWaterManagementTaskArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryWaterManagementTasksArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryWeatherArgs = {
  foreignUuid: Scalars['UUID']['input'];
  format?: InputMaybe<WeatherFormat>;
  fromDate: Scalars['Date']['input'];
  provider?: InputMaybe<Array<InputMaybe<WeatherProvider>>>;
  tillDate: Scalars['Date']['input'];
  type?: InputMaybe<Array<InputMaybe<WeatherType>>>;
};


export type QueryWeatherUserDataArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryWeatherUserDataListArgs = {
  locationUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryWeedRecordArgs = {
  uuid: Scalars['UUID']['input'];
};


export type QueryWeedRecordsArgs = {
  cropSeasonUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sourceType?: InputMaybe<WeedRecordSourceType>;
  uuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryWeeklySeedingRecommendationsArgs = {
  cropSeasonUuid: Scalars['UUID']['input'];
};


export type QueryWiuzUserfarmImportOrdersArgs = {
  filterStrategy?: InputMaybe<ImportOrderFilterStrategy>;
};

export type QuotaLimit = {
  __typename: 'QuotaLimit';
  createdAt?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  license: License;
  maxQuota?: Maybe<Scalars['Float']['output']>;
  organisation: Organisation;
  retracted?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['UUID']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
};

export type QuotaTransfer = {
  __typename: 'QuotaTransfer';
  createdDate?: Maybe<Scalars['Date']['output']>;
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  license: License;
  quantity?: Maybe<Scalars['Float']['output']>;
  sourceOrganisation: PublicOrganisation;
  targetOrganisation: PublicOrganisation;
  targetOrganisationCode?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
};

export type RateByZone = {
  __typename: 'RateByZone';
  id?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export enum RateCategory {
  ClassA = 'CLASS_A',
  ClassAPlus = 'CLASS_A_PLUS',
  ClassB = 'CLASS_B',
  Eyespot = 'EYESPOT',
  Faf = 'FAF',
  Fusarium = 'FUSARIUM',
  Pgr = 'PGR',
  PowderyMildew = 'POWDERY_MILDEW',
  Ramularia = 'RAMULARIA'
}

export enum RateUnit {
  Kgpm2 = 'KGPM2',
  M3Pm2 = 'M3PM2',
  SeedMrow = 'SEED_MROW',
  Upm2 = 'UPM2'
}

export type RatesCalculationRequest = {
  __typename: 'RatesCalculationRequest';
  allowLimitationViolations?: Maybe<Scalars['Boolean']['output']>;
  applicationFieldZones?: Maybe<Array<Maybe<ApplicationFieldZone>>>;
  applicationMapZones?: Maybe<Array<Maybe<ApplicationMapZone>>>;
  applicationStrategy?: Maybe<ApplicationStrategy>;
  applicationType?: Maybe<ApplicationType>;
  baseFactor?: Maybe<Scalars['Float']['output']>;
  lowestZoneExcluded?: Maybe<Scalars['Boolean']['output']>;
  referenceProductRates?: Maybe<Array<Maybe<ReferenceProductRate>>>;
  referenceTotalMixtureRate?: Maybe<ReferenceTotalMixtureRate>;
  referenceZoneId?: Maybe<Scalars['String']['output']>;
  zoneFactors?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  zoneIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zonePercentageDifferences?: Maybe<Array<Maybe<ZonePercentageDifference>>>;
};

export type RecentlyUsedProduct = {
  __typename: 'RecentlyUsedProduct';
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  farmV2?: Maybe<FarmV2>;
  product?: Maybe<ProductV2>;
  productCategories?: Maybe<Array<Maybe<Md2Item>>>;
  /** @deprecated Use `productCategories`. */
  productCategoryUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /** @deprecated Use `product`. */
  productUuid?: Maybe<Scalars['UUID']['output']>;
  taskType?: Maybe<TaskType>;
  usedAt?: Maybe<Scalars['Date']['output']>;
};

export type RecommendationActionValidity = {
  __typename: 'RecommendationActionValidity';
  calendarDate?: Maybe<Scalars['Date']['output']>;
  daysAfterSeeding?: Maybe<Scalars['Int']['output']>;
  growthStageIndex?: Maybe<Scalars['String']['output']>;
  growthStageScale?: Maybe<ScaleV2>;
  type?: Maybe<NutritionActionValidityType>;
};

export type RecommendationSnooze = {
  __typename: 'RecommendationSnooze';
  actionType?: Maybe<RecommendationSnoozeType>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export enum RecommendationSnoozeType {
  FertilizerApplication = 'FERTILIZER_APPLICATION',
  FungicideApplication = 'FUNGICIDE_APPLICATION',
  Harvesting = 'HARVESTING',
  HerbicideApplication = 'HERBICIDE_APPLICATION',
  InsecticideApplication = 'INSECTICIDE_APPLICATION',
  LandPreparation = 'LAND_PREPARATION',
  PlantGrowthRegulatorApplication = 'PLANT_GROWTH_REGULATOR_APPLICATION',
  Seeding = 'SEEDING',
  WaterManagement = 'WATER_MANAGEMENT'
}

export enum RecommendationStatusType {
  Custom = 'CUSTOM',
  Recommended = 'RECOMMENDED'
}

export type RecommendedRate = {
  __typename: 'RecommendedRate';
  rate: Scalars['Float']['output'];
  rateUnit: RateUnit;
  zoneId: Scalars['Int']['output'];
};

export type RecommendedTimingForApplication = {
  __typename: 'RecommendedTimingForApplication';
  applicationOrder?: Maybe<Scalars['Int']['output']>;
  validFrom?: Maybe<BbchScale>;
  validTill?: Maybe<BbchScale>;
};

export type ReferenceProductRate = {
  __typename: 'ReferenceProductRate';
  formulationType?: Maybe<ProductFormulationTypeGroup>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  productUuid?: Maybe<Scalars['UUID']['output']>;
  referenceRate?: Maybe<Scalars['Float']['output']>;
};

export type ReferenceTotalMixtureRate = {
  __typename: 'ReferenceTotalMixtureRate';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  referenceRate?: Maybe<Scalars['Float']['output']>;
};

export type RegionRate = {
  __typename: 'RegionRate';
  basePrice?: Maybe<Scalars['Float']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
};

export type RelativeMaturity = {
  __typename: 'RelativeMaturity';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export enum RenderingType {
  /** @deprecated Use DYNAMIC instead. This will be removed in future releases. */
  Absolute = 'ABSOLUTE',
  Dynamic = 'DYNAMIC',
  /** @deprecated Use STATIC instead. This will be removed in future releases. */
  Relative = 'RELATIVE',
  Static = 'STATIC'
}

export type ResidualActivation = {
  __typename: 'ResidualActivation';
  activationDate?: Maybe<Scalars['Date']['output']>;
  activationDeadline?: Maybe<Scalars['Date']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  scoutingReminderDate?: Maybe<Scalars['Date']['output']>;
  sprayingUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<ResidualActivationStatus>;
};

export enum ResidualActivationStatus {
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Successful = 'SUCCESSFUL',
  Unsuccessful = 'UNSUCCESSFUL'
}

export type ResponseStatus = {
  __typename: 'ResponseStatus';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorCodeTranslation?: Maybe<Scalars['String']['output']>;
  errorCodeTranslationId?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Scalars['String']['output']>>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type Risk = {
  __typename: 'Risk';
  basedOn?: Maybe<CalculationBase>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  cropSeasonUuid: Scalars['UUID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CropSeasonStatusState>;
  statusPrecision?: Maybe<Scalars['Float']['output']>;
  stressV2?: Maybe<StressV2>;
  type?: Maybe<RiskType>;
  uuid: Scalars['UUID']['output'];
};


export type RiskStressV2Args = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum RiskClass {
  A = 'A',
  APlus = 'A_PLUS',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type RiskClassification = {
  __typename: 'RiskClassification';
  maxValue?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  riskLevel?: Maybe<RiskLevel>;
  thresholdUnit?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export enum RiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type RiskMap = {
  __typename: 'RiskMap';
  aggregatedRiskLevel?: Maybe<RiskLevel>;
  assessmentObjectUuid?: Maybe<Scalars['UUID']['output']>;
  classification?: Maybe<Array<Maybe<RiskClassification>>>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum RiskType {
  StressAscosporesRisk = 'STRESS_ASCOSPORES_RISK',
  StressCombinedConidiaAscosporesRisk = 'STRESS_COMBINED_CONIDIA_ASCOSPORES_RISK',
  StressCombinedPrimarySecondaryRisk = 'STRESS_COMBINED_PRIMARY_SECONDARY_RISK',
  StressConidiaRisk = 'STRESS_CONIDIA_RISK',
  StressInfectionRisk = 'STRESS_INFECTION_RISK',
  StressMicotoxinRisk = 'STRESS_MICOTOXIN_RISK',
  StressMultiplicationRate = 'STRESS_MULTIPLICATION_RATE',
  StressPrimaryRisk = 'STRESS_PRIMARY_RISK',
  StressRisk = 'STRESS_RISK',
  StressSecondaryRisk = 'STRESS_SECONDARY_RISK',
  StressStartingPressure = 'STRESS_STARTING_PRESSURE'
}

export type RiskV2 = {
  __typename: 'RiskV2';
  basedOn?: Maybe<CalculationBase>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<CropSeasonStatusState>;
  statusPrecision?: Maybe<Scalars['Float']['output']>;
  stresses?: Maybe<Array<Maybe<StressV2>>>;
  type?: Maybe<RiskType>;
};


export type RiskV2StressesArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum RoleFeatureName {
  HfAgronomicConsultant = 'HF_AGRONOMIC_CONSULTANT',
  HfContractor = 'HF_CONTRACTOR',
  HfCoordinator = 'HF_COORDINATOR'
}

export type SampledPoint = {
  __typename: 'SampledPoint';
  geometry?: Maybe<Scalars['JSONObject']['output']>;
};

export type SamplingArea = {
  __typename: 'SamplingArea';
  area?: Maybe<Scalars['Float']['output']>;
  classId?: Maybe<Scalars['Int']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  totalCores?: Maybe<Scalars['Float']['output']>;
};

export type SamplingDepth = {
  __typename: 'SamplingDepth';
  id?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type SamplingId = {
  __typename: 'SamplingId';
  id?: Maybe<Scalars['String']['output']>;
  samplingAreaId?: Maybe<Scalars['String']['output']>;
  samplingDepthId?: Maybe<Scalars['String']['output']>;
};

export type SamplingPoint = {
  __typename: 'SamplingPoint';
  geometry?: Maybe<Scalars['JSONObject']['output']>;
};

export enum Scale {
  Bbch = 'BBCH',
  IsuGrowthStages = 'isuGrowthStages',
  Zadoks = 'zadoks'
}

export type ScaleTicket = BaseEntityAuditingType & {
  __typename: 'ScaleTicket';
  /** The ticket's BOOKED shares, oldest first. Only returned when the query sends includeBookings: true. */
  bookings?: Maybe<Array<Maybe<ScaleTicketBooking>>>;
  branchUuid?: Maybe<Scalars['UUID']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  dataMappingUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmName?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUuid?: Maybe<Scalars['UUID']['output']>;
  grossWeight?: Maybe<Scalars['Float']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  netWeight?: Maybe<Scalars['Float']['output']>;
  /** Kilograms at the crop's standard moisture. Null when the sample or the standard moisture is missing. */
  netWeightAtStandardMoisture?: Maybe<Scalars['Float']['output']>;
  organisationUuid?: Maybe<Scalars['UUID']['output']>;
  sampleMoisture?: Maybe<Scalars['Float']['output']>;
  sellerId?: Maybe<Scalars['String']['output']>;
  sellerIsAnElevator?: Maybe<Scalars['Boolean']['output']>;
  sellerName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ScaleTicketState>;
  tareWeight?: Maybe<Scalars['Float']['output']>;
  ticketNumber?: Maybe<Scalars['String']['output']>;
  uploadUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  weighedInAt?: Maybe<Scalars['String']['output']>;
  weighedOutAt?: Maybe<Scalars['String']['output']>;
};

export type ScaleTicketBooking = BaseEntityAuditingType & {
  __typename: 'ScaleTicketBooking';
  booking?: Maybe<Scalars['Float']['output']>;
  bookingNote?: Maybe<Scalars['String']['output']>;
  carbonFarmingSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  fieldCiScore?: Maybe<Scalars['Float']['output']>;
  fieldCiScoreUnit?: Maybe<Scalars['String']['output']>;
  /** Kilograms. Crop season yield times field area. Null when the yield or the area is missing. */
  fieldHarvestCap?: Maybe<Scalars['Float']['output']>;
  fieldHarvestDate?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  organisationUuid?: Maybe<Scalars['UUID']['output']>;
  state?: Maybe<ScaleTicketBookingState>;
  sustainabilityProgramAllocationOrder?: Maybe<SustainabilityProgramAllocationOrder>;
  sustainabilityProgramName?: Maybe<Scalars['String']['output']>;
  sustainabilityProgramUuid?: Maybe<Scalars['UUID']['output']>;
  ticketUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ScaleTicketBookingDispute = BaseEntityAuditingType & {
  __typename: 'ScaleTicketBookingDispute';
  bookingUuid?: Maybe<Scalars['UUID']['output']>;
  correctedAt?: Maybe<Scalars['String']['output']>;
  correctedBy?: Maybe<Scalars['String']['output']>;
  correctionReason?: Maybe<ScaleTicketBookingDisputeCorrectionReason>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disputeNumber?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmName?: Maybe<Scalars['String']['output']>;
  fieldNotEnrolled?: Maybe<Scalars['Boolean']['output']>;
  heldNetWeight?: Maybe<Scalars['Float']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  netWeight?: Maybe<Scalars['Float']['output']>;
  reasons?: Maybe<Array<Maybe<ScaleTicketBookingDisputeReason>>>;
  rejectedAt?: Maybe<Scalars['String']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  rejectedReasons?: Maybe<Array<Maybe<ScaleTicketBookingDisputeReason>>>;
  resolution?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  sampleMoisture?: Maybe<Scalars['Float']['output']>;
  splits?: Maybe<Array<Maybe<ScaleTicketBookingDisputeSplit>>>;
  state?: Maybe<ScaleTicketBookingDisputeState>;
  suggestedCarbonFarmingSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  ticketNumber?: Maybe<Scalars['String']['output']>;
  ticketUuid?: Maybe<Scalars['UUID']['output']>;
  totalLoad?: Maybe<Scalars['Boolean']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  weighedInAt?: Maybe<Scalars['String']['output']>;
  withdrawnAt?: Maybe<Scalars['String']['output']>;
  withdrawnBy?: Maybe<Scalars['String']['output']>;
};

export enum ScaleTicketBookingDisputeCorrectionReason {
  EntryError = 'ENTRY_ERROR',
  GapConflictFix = 'GAP_CONFLICT_FIX',
  GrowerNamedField = 'GROWER_NAMED_FIELD',
  Other = 'OTHER'
}

export enum ScaleTicketBookingDisputeReason {
  Moisture = 'MOISTURE',
  NotMyLoad = 'NOT_MY_LOAD',
  Other = 'OTHER',
  Weight = 'WEIGHT',
  WrongField = 'WRONG_FIELD'
}

export type ScaleTicketBookingDisputeSort = {
  column: ScaleTicketBookingDisputeSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum ScaleTicketBookingDisputeSortColumn {
  CreatedAt = 'CREATED_AT',
  DisputeNumber = 'DISPUTE_NUMBER',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  State = 'STATE',
  Uuid = 'UUID'
}

export type ScaleTicketBookingDisputeSplit = {
  __typename: 'ScaleTicketBookingDisputeSplit';
  booking?: Maybe<Scalars['Float']['output']>;
  bookingUuid?: Maybe<Scalars['UUID']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  netWeight?: Maybe<Scalars['Float']['output']>;
};

export enum ScaleTicketBookingDisputeState {
  Corrected = 'CORRECTED',
  Open = 'OPEN',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

export type ScaleTicketBookingSort = {
  column: ScaleTicketBookingSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum ScaleTicketBookingSortColumn {
  Booking = 'BOOKING',
  CreatedAt = 'CREATED_AT',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  State = 'STATE',
  Uuid = 'UUID'
}

export enum ScaleTicketBookingState {
  Booked = 'BOOKED',
  Disputed = 'DISPUTED',
  Replaced = 'REPLACED'
}

export type ScaleTicketDataMapping = BaseEntityAuditingType & {
  __typename: 'ScaleTicketDataMapping';
  branchColumn?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropColumn?: Maybe<Scalars['String']['output']>;
  cropMappings?: Maybe<Scalars['JSONObject']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  grossColumn?: Maybe<Scalars['String']['output']>;
  grossUnit?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUsed?: Maybe<Scalars['Date']['output']>;
  moistureColumn?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  netColumn?: Maybe<Scalars['String']['output']>;
  netUnit?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  organisationUuid?: Maybe<Scalars['UUID']['output']>;
  sellerColumn?: Maybe<Scalars['String']['output']>;
  tareColumn?: Maybe<Scalars['String']['output']>;
  tareUnit?: Maybe<Scalars['String']['output']>;
  ticketNumberColumn?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  weighInDateColumn?: Maybe<Scalars['String']['output']>;
  weighInDateTimeColumn?: Maybe<Scalars['String']['output']>;
  weighInTimeColumn?: Maybe<Scalars['String']['output']>;
  weighOutDateColumn?: Maybe<Scalars['String']['output']>;
  weighOutDateTimeColumn?: Maybe<Scalars['String']['output']>;
  weighOutTimeColumn?: Maybe<Scalars['String']['output']>;
};

export type ScaleTicketDataMappingSort = {
  column: ScaleTicketDataMappingSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum ScaleTicketDataMappingSortColumn {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  LastUsed = 'LAST_USED',
  Name = 'NAME',
  OrganisationUuid = 'ORGANISATION_UUID'
}

export type ScaleTicketDuplicateNumberSummary = {
  __typename: 'ScaleTicketDuplicateNumberSummary';
  netWeight: Scalars['Float']['output'];
  netWeightAtStandardMoisture?: Maybe<Scalars['Float']['output']>;
  seller: ScaleTicketSellerRef;
  ticketNumber: Scalars['String']['output'];
  tickets?: Maybe<Array<ScaleTicketDuplicateTicket>>;
};

export type ScaleTicketDuplicateTicket = {
  __typename: 'ScaleTicketDuplicateTicket';
  netWeight: Scalars['Float']['output'];
  netWeightAtStandardMoisture: Scalars['Float']['output'];
  sampleMoisture: Scalars['Float']['output'];
  weighedInAt: Scalars['Date']['output'];
};

export type ScaleTicketHarvestCapSummary = {
  __typename: 'ScaleTicketHarvestCapSummary';
  booked: Scalars['Float']['output'];
  field: ScaleTicketNamedRef;
  harvestCap: Scalars['Float']['output'];
  harvestChangedAt: Scalars['Date']['output'];
  harvestSales: Scalars['Float']['output'];
  harvestUsed: Scalars['Float']['output'];
  harvested: Scalars['Float']['output'];
  netWeight: Scalars['Float']['output'];
  netWeightAtStandardMoisture?: Maybe<Scalars['Float']['output']>;
  totalTickets: Scalars['Int']['output'];
};

export type ScaleTicketHistory = BaseEntityAuditingType & {
  __typename: 'ScaleTicketHistory';
  bookingUuid?: Maybe<Scalars['UUID']['output']>;
  /** When the change happened. */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Who acted. Null for a reader who reads the ticket only through farm access. */
  creatorId?: Maybe<Scalars['String']['output']>;
  disputeUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  /** Null on TICKET_CREATED. */
  field?: Maybe<ScaleTicketHistoryField>;
  kind?: Maybe<ScaleTicketHistoryKind>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  ticketNumber?: Maybe<Scalars['String']['output']>;
  ticketUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  valueAfter?: Maybe<Scalars['String']['output']>;
  valueAfterName?: Maybe<Scalars['String']['output']>;
  valueBefore?: Maybe<Scalars['String']['output']>;
  /** Farm name of a FARM value, or field name of a CARBON_FARMING_SEASON value. */
  valueBeforeName?: Maybe<Scalars['String']['output']>;
};

export enum ScaleTicketHistoryField {
  Booking = 'BOOKING',
  BookingState = 'BOOKING_STATE',
  CarbonFarmingSeason = 'CARBON_FARMING_SEASON',
  ContractId = 'CONTRACT_ID',
  Farm = 'FARM',
  GrossWeight = 'GROSS_WEIGHT',
  NetWeight = 'NET_WEIGHT',
  SampleMoisture = 'SAMPLE_MOISTURE',
  SellerId = 'SELLER_ID',
  SellerIsAnElevator = 'SELLER_IS_AN_ELEVATOR',
  SellerName = 'SELLER_NAME',
  State = 'STATE',
  TareWeight = 'TARE_WEIGHT',
  WeighedInAt = 'WEIGHED_IN_AT',
  WeighedOutAt = 'WEIGHED_OUT_AT'
}

export enum ScaleTicketHistoryKind {
  SplitBooked = 'SPLIT_BOOKED',
  SplitChanged = 'SPLIT_CHANGED',
  SplitDisputed = 'SPLIT_DISPUTED',
  SplitReleased = 'SPLIT_RELEASED',
  SplitReplaced = 'SPLIT_REPLACED',
  TicketCorrected = 'TICKET_CORRECTED',
  TicketCreated = 'TICKET_CREATED',
  TicketRecomputed = 'TICKET_RECOMPUTED',
  TicketUpdated = 'TICKET_UPDATED'
}

export type ScaleTicketHistorySort = {
  column: ScaleTicketHistorySortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum ScaleTicketHistorySortColumn {
  DateCreated = 'DATE_CREATED',
  Field = 'FIELD',
  Kind = 'KIND',
  LastUpdated = 'LAST_UPDATED',
  TicketUuid = 'TICKET_UUID'
}

export type ScaleTicketMissingHarvestSummary = {
  __typename: 'ScaleTicketMissingHarvestSummary';
  allHarvestedFieldsFull: Scalars['Boolean']['output'];
  farm: ScaleTicketNamedRef;
  fields?: Maybe<Array<ScaleTicketNamedRef>>;
  netWeight: Scalars['Float']['output'];
  netWeightAtStandardMoisture?: Maybe<Scalars['Float']['output']>;
  programs?: Maybe<Array<SustainabilityProgramNamedRef>>;
};

export type ScaleTicketMissingMoistureSummary = {
  __typename: 'ScaleTicketMissingMoistureSummary';
  netWeight: Scalars['Float']['output'];
  netWeightAtStandardMoisture?: Maybe<Scalars['Float']['output']>;
  seller?: Maybe<ScaleTicketSellerRef>;
  ticketNumber: Scalars['String']['output'];
};

export type ScaleTicketNamedRef = {
  __typename: 'ScaleTicketNamedRef';
  name: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type ScaleTicketSellerMapping = BaseEntityAuditingType & {
  __typename: 'ScaleTicketSellerMapping';
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  organisationUuid?: Maybe<Scalars['UUID']['output']>;
  sellerName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ScaleTicketSellerMappingSort = {
  column: ScaleTicketSellerMappingSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum ScaleTicketSellerMappingSortColumn {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  OrganisationUuid = 'ORGANISATION_UUID',
  SellerName = 'SELLER_NAME'
}

export type ScaleTicketSellerNotMatched = {
  __typename: 'ScaleTicketSellerNotMatched';
  firstSeen?: Maybe<Scalars['Date']['output']>;
  netWeight: Scalars['Float']['output'];
  netWeightAtStandardMoisture?: Maybe<Scalars['Float']['output']>;
  seller?: Maybe<ScaleTicketSellerRef>;
  suggestedFarm?: Maybe<ScaleTicketNamedRef>;
  tickets?: Maybe<Scalars['Int']['output']>;
};

export type ScaleTicketSellerRef = {
  __typename: 'ScaleTicketSellerRef';
  sellerId?: Maybe<Scalars['String']['output']>;
  sellerName?: Maybe<Scalars['String']['output']>;
};

export type ScaleTicketSort = {
  column: ScaleTicketSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum ScaleTicketSortColumn {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  GrossWeight = 'GROSS_WEIGHT',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  NetWeight = 'NET_WEIGHT',
  SampleMoisture = 'SAMPLE_MOISTURE',
  Source = 'SOURCE',
  TareWeight = 'TARE_WEIGHT',
  TicketNumber = 'TICKET_NUMBER',
  Uuid = 'UUID',
  WeighedInAt = 'WEIGHED_IN_AT'
}

export enum ScaleTicketState {
  Booked = 'BOOKED',
  Disputed = 'DISPUTED',
  DuplicateTicketNumber = 'DUPLICATE_TICKET_NUMBER',
  HarvestCapReached = 'HARVEST_CAP_REACHED',
  MissingHarvest = 'MISSING_HARVEST',
  MissingMoisture = 'MISSING_MOISTURE',
  SellerNotMatched = 'SELLER_NOT_MATCHED',
  Unbooked = 'UNBOOKED'
}

export type ScaleTicketStateSummary = {
  __typename: 'ScaleTicketStateSummary';
  netWeight: Scalars['Float']['output'];
  netWeightAtStandardMoisture: Scalars['Float']['output'];
  tickets: Scalars['Int']['output'];
};

export type ScaleTicketStates = {
  __typename: 'ScaleTicketStates';
  BOOKED: ScaleTicketStateSummary;
  DISPUTED: ScaleTicketStateSummary;
  DUPLICATE_TICKET_NUMBER: ScaleTicketStateSummary;
  HARVEST_CAP_REACHED: ScaleTicketStateSummary;
  MISSING_HARVEST: ScaleTicketStateSummary;
  MISSING_MOISTURE: ScaleTicketStateSummary;
  SELLER_NOT_MATCHED: ScaleTicketStateSummary;
  UNBOOKED: ScaleTicketStateSummary;
};

export type ScaleTicketSummary = {
  __typename: 'ScaleTicketSummary';
  duplicateTicketNumbers?: Maybe<Array<ScaleTicketDuplicateNumberSummary>>;
  harvestCapExceeded?: Maybe<Array<ScaleTicketHarvestCapSummary>>;
  missingHarvest?: Maybe<Array<ScaleTicketMissingHarvestSummary>>;
  missingMoisture?: Maybe<Array<ScaleTicketMissingMoistureSummary>>;
  sellerNotMatched?: Maybe<Array<ScaleTicketSellerNotMatched>>;
  ticketStates: ScaleTicketStates;
  totalTickets: Scalars['Int']['output'];
  totalUploads: Scalars['Int']['output'];
};

export type ScaleTicketUpload = BaseEntityAuditingType & {
  __typename: 'ScaleTicketUpload';
  branchUuid?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  dataMappingName?: Maybe<Scalars['String']['output']>;
  dataMappingUuid?: Maybe<Scalars['UUID']['output']>;
  /** Why a FAILED upload failed. */
  errorCode?: Maybe<ScaleTicketUploadError>;
  etag?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  organisationUuid?: Maybe<Scalars['UUID']['output']>;
  state?: Maybe<ScaleTicketUploadState>;
  /** Written once the upload is DONE. */
  summary?: Maybe<ScaleTicketUploadSummary>;
  /** Tickets stored by this upload, counted by state. A state with no ticket is null. */
  ticketStates?: Maybe<ScaleTicketUploadTicketStates>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum ScaleTicketUploadError {
  OrganisationNotFound = 'ORGANISATION_NOT_FOUND',
  ScaleTicketDataMappingQuantityUnit = 'SCALE_TICKET_DATA_MAPPING_QUANTITY_UNIT',
  ScaleTicketFileMalformed = 'SCALE_TICKET_FILE_MALFORMED',
  ScaleTicketFileMissing = 'SCALE_TICKET_FILE_MISSING',
  ScaleTicketProviderAmbiguous = 'SCALE_TICKET_PROVIDER_AMBIGUOUS',
  ScaleTicketProviderNotDetected = 'SCALE_TICKET_PROVIDER_NOT_DETECTED'
}

export type ScaleTicketUploadSort = {
  column: ScaleTicketUploadSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum ScaleTicketUploadSortColumn {
  BranchUuid = 'BRANCH_UUID',
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  DataMappingUuid = 'DATA_MAPPING_UUID',
  FileName = 'FILE_NAME',
  FileUuid = 'FILE_UUID',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  OrganisationUuid = 'ORGANISATION_UUID',
  State = 'STATE',
  Uuid = 'UUID'
}

export enum ScaleTicketUploadState {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ScaleTicketUploadSummary = BaseEntityAuditingType & {
  __typename: 'ScaleTicketUploadSummary';
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  scaleTicketUploadUuid?: Maybe<Scalars['UUID']['output']>;
  totalDuplicate?: Maybe<Scalars['Int']['output']>;
  totalImported?: Maybe<Scalars['Int']['output']>;
  totalOtherCrop?: Maybe<Scalars['Int']['output']>;
  totalRows?: Maybe<Scalars['Int']['output']>;
  totalVoid?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ScaleTicketUploadTicketStates = {
  __typename: 'ScaleTicketUploadTicketStates';
  BOOKED?: Maybe<Scalars['Int']['output']>;
  DISPUTED?: Maybe<Scalars['Int']['output']>;
  DUPLICATE_TICKET_NUMBER?: Maybe<Scalars['Int']['output']>;
  HARVEST_CAP_REACHED?: Maybe<Scalars['Int']['output']>;
  MISSING_HARVEST?: Maybe<Scalars['Int']['output']>;
  MISSING_MOISTURE?: Maybe<Scalars['Int']['output']>;
  SELLER_NOT_MATCHED?: Maybe<Scalars['Int']['output']>;
  UNBOOKED?: Maybe<Scalars['Int']['output']>;
};

export enum ScaleV2 {
  Bbch = 'BBCH',
  HortaGrapeNutrition = 'HORTA_GRAPE_NUTRITION',
  /**  used for crop DURUM_WHEAT */
  HortaGsHorvs = 'HORTA_GS_HORVS',
  /**  used for crop PROCESSED_TOMATO */
  HortaGsHorvsNutrition = 'HORTA_GS_HORVS_NUTRITION',
  /**  used for crop SPRING_BARLEY */
  HortaGsLype1 = 'HORTA_GS_LYPE1',
  HortaGsLype1Nutrition = 'HORTA_GS_LYPE1_NUTRITION',
  /**  used for crop PROCESSED_TOMATO */
  HortaGsLype2 = 'HORTA_GS_LYPE2',
  HortaGsTablegrapeNutrition = 'HORTA_GS_TABLEGRAPE_NUTRITION',
  /**  @deprecated(reason: "Use `HORTA_GS_WHEAT_NUTRITION`") */
  HortaGsVinegrapeNutrition = 'HORTA_GS_VINEGRAPE_NUTRITION',
  HortaGsWheatNutrition = 'HORTA_GS_WHEAT_NUTRITION',
  HortaTrzdwGs = 'HORTA_TRZDW_GS',
  /**  @deprecated(reason: "Use `HORTA_GS_VINEGRAPE_NUTRITION`") */
  HortaWheatNutrition = 'HORTA_WHEAT_NUTRITION',
  Isu = 'ISU',
  /**  @deprecated(reason: "Use `ISU_PEA`") */
  IsuLentil = 'ISU_LENTIL',
  IsuPea = 'ISU_PEA',
  /**  used for crop FRESH_TOMATO */
  PulseLentil = 'PULSE_LENTIL',
  /**  @deprecated(reason: "Use `ISU_LENTIL`") */
  PulsePea = 'PULSE_PEA',
  Vbfc = 'VBFC',
  Zadoks = 'ZADOKS'
}

export type ScoutingGrowthStage = {
  __typename: 'ScoutingGrowthStage';
  endIndex?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<ScaleV2>;
  startIndex?: Maybe<Scalars['String']['output']>;
};

export type ScoutingPoi = {
  __typename: 'ScoutingPoi';
  algorithmType?: Maybe<ScoutingPoiAlgorithmType>;
  creator?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<ScoutingPoiImage>>>;
  note?: Maybe<Scalars['String']['output']>;
  result?: Maybe<LeafDamageResult>;
  tripName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum ScoutingPoiAlgorithmType {
  DiseaseIdentification = 'DISEASE_IDENTIFICATION',
  EmergenceAnalysis = 'EMERGENCE_ANALYSIS',
  LeafDamage = 'LEAF_DAMAGE',
  MultiWeedIdentification = 'MULTI_WEED_IDENTIFICATION',
  NitrogenStatus = 'NITROGEN_STATUS',
  WeedIdentification = 'WEED_IDENTIFICATION',
  YellowTrap = 'YELLOW_TRAP'
}

export type ScoutingPoiImage = {
  __typename: 'ScoutingPoiImage';
  appVersion?: Maybe<Scalars['String']['output']>;
  captureDate?: Maybe<Scalars['Date']['output']>;
  imageUuid?: Maybe<Scalars['UUID']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ScoutingPoiResult = {
  status?: Maybe<ScoutingPoiResultStatus>;
};

export enum ScoutingPoiResultStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type ScoutingPoiV2 = {
  __typename: 'ScoutingPoiV2';
  algorithmType?: Maybe<ScoutingPoiAlgorithmType>;
  algorithmTypeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  creator?: Maybe<User>;
  cropEppoCode?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<ScoutingPoiImage>>>;
  note?: Maybe<Scalars['String']['output']>;
  result?: Maybe<ScoutingPoiResult>;
  tripName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ScoutingProtocol = {
  __typename: 'ScoutingProtocol';
  countryCode?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  growthStage?: Maybe<ScoutingGrowthStage>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  stressQuestions?: Maybe<Array<Maybe<ScoutingStressQuestion>>>;
  uuid: Scalars['UUID']['output'];
};


export type ScoutingProtocolStressQuestionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ScoutingReport = {
  __typename: 'ScoutingReport';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  fieldNotes?: Maybe<Array<Maybe<FieldNote>>>;
  isIncludeImages?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  pdfPath?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ScoutingReportDispatchOrder = {
  __typename: 'ScoutingReportDispatchOrder';
  copyToSelf: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<User>>>;
  scoutingReport?: Maybe<ScoutingReport>;
  shareType: ScoutingReportShareType;
  sharedAt?: Maybe<Scalars['Date']['output']>;
  status: ScoutingReportDispatchOrderStatus;
  uuid: Scalars['UUID']['output'];
};

export enum ScoutingReportDispatchOrderStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum ScoutingReportShareType {
  App = 'APP',
  Email = 'EMAIL'
}

export type ScoutingStressAnswer = {
  __typename: 'ScoutingStressAnswer';
  code?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Image>>>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type ScoutingStressQuestion = {
  __typename: 'ScoutingStressQuestion';
  answerValue?: Maybe<Scalars['Int']['output']>;
  assessmentTypeAnswerDictName?: Maybe<Scalars['String']['output']>;
  assessmentTypeAnswerDictShort?: Maybe<Scalars['String']['output']>;
  assessmentTypeAnswers?: Maybe<Array<Maybe<ScoutingStressAnswer>>>;
  assessmentTypeCode?: Maybe<Scalars['String']['output']>;
  assessmentTypeDescription?: Maybe<Scalars['String']['output']>;
  assessmentTypeName?: Maybe<Scalars['String']['output']>;
  assessmentTypeUuid: Scalars['UUID']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  crop: Crop;
  dataType?: Maybe<Scalars['String']['output']>;
  expertQuestion?: Maybe<Scalars['Boolean']['output']>;
  expertScoutingTripQuestion?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isPhotoRequired?: Maybe<Scalars['Boolean']['output']>;
  mdUnit?: Maybe<MdUnit>;
  regularQuestion?: Maybe<Scalars['Boolean']['output']>;
  sampleUnitCode?: Maybe<Scalars['String']['output']>;
  sampleUnitName?: Maybe<Scalars['String']['output']>;
  sampleUnitUuid?: Maybe<Scalars['UUID']['output']>;
  scoutingProblemCode?: Maybe<Scalars['String']['output']>;
  scoutingProblemName?: Maybe<Scalars['String']['output']>;
  scoutingProblemUuid?: Maybe<Scalars['UUID']['output']>;
  stressV2?: Maybe<StressV2>;
};

export type ScoutingTask = {
  __typename: 'ScoutingTask';
  assessmentTiming?: Maybe<AssessmentTiming>;
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  farm?: Maybe<FarmV2>;
  fieldV2: FieldV2;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `scoutingPoisV2` */
  scoutingPois?: Maybe<Array<Maybe<ScoutingPoi>>>;
  scoutingPoisV2?: Maybe<Array<Maybe<ScoutingPoiV2>>>;
  state?: Maybe<TaskExecutionState>;
  stressQuestions?: Maybe<Array<Maybe<ScoutingStressQuestion>>>;
  trial?: Maybe<Trial>;
  uuid: Scalars['UUID']['output'];
};


export type ScoutingTaskStressQuestionsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export enum ScoutingTaskAssignmentState {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Unacknowledged = 'UNACKNOWLEDGED',
  Unassigned = 'UNASSIGNED'
}

export type ScoutingTaskSort = {
  column?: InputMaybe<ScoutingTaskSortColumn>;
  direction?: InputMaybe<SortDirection>;
};

export enum ScoutingTaskSortColumn {
  AssigneeName = 'ASSIGNEE_NAME',
  FarmName = 'FARM_NAME',
  FieldName = 'FIELD_NAME',
  ObservationDate = 'OBSERVATION_DATE',
  ProtocolName = 'PROTOCOL_NAME',
  Status = 'STATUS',
  TrialName = 'TRIAL_NAME'
}

export enum ScoutingTaskState {
  Executed = 'EXECUTED',
  Overdue = 'OVERDUE',
  Planned = 'PLANNED'
}

export type SearchTreatmentProgramActionDateInput = {
  calendarDate?: InputMaybe<Scalars['Date']['input']>;
  daysAfterPrevious?: InputMaybe<Scalars['Int']['input']>;
  daysAfterSeeding?: InputMaybe<Scalars['Int']['input']>;
  growthStageIndex?: InputMaybe<Scalars['String']['input']>;
  growthStageScale?: InputMaybe<ScaleV2>;
};

export type SearchTreatmentProgramActionInput = {
  code: ActionCode;
  end?: InputMaybe<SearchTreatmentProgramActionDateInput>;
  start: SearchTreatmentProgramActionDateInput;
  type: ActionDetailType;
};

export enum SeasonResolutionStatus {
  ErrorSeasonNotResolved = 'ERROR_SEASON_NOT_RESOLVED',
  Resolved = 'RESOLVED',
  SeasonNotRequired = 'SEASON_NOT_REQUIRED'
}

export type SeasonTimeline = {
  __typename: 'SeasonTimeline';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countryUuid?: Maybe<Scalars['UUID']['output']>;
  cropCode?: Maybe<Scalars['String']['output']>;
  cropName?: Maybe<Scalars['String']['output']>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  features?: Maybe<Array<Maybe<SeasonTimelineFeatures>>>;
};

export type SeasonTimelineFeatures = {
  __typename: 'SeasonTimelineFeatures';
  characteristicId?: Maybe<Scalars['String']['output']>;
  characteristicName?: Maybe<Scalars['String']['output']>;
  endCode?: Maybe<Scalars['Int']['output']>;
  endMonth?: Maybe<Scalars['Int']['output']>;
  endWeekOfMonth?: Maybe<Scalars['Int']['output']>;
  endYear?: Maybe<Scalars['Int']['output']>;
  startCode?: Maybe<Scalars['Int']['output']>;
  startMonth?: Maybe<Scalars['Int']['output']>;
  startWeekOfMonth?: Maybe<Scalars['Int']['output']>;
  startYear?: Maybe<Scalars['Int']['output']>;
};

export type Section = {
  __typename: 'Section';
  abiotics?: Maybe<SectionSummary>;
  diseases?: Maybe<SectionSummary>;
  growthstages?: Maybe<SectionSummary>;
  insects?: Maybe<SectionSummary>;
  lodgings?: Maybe<SectionSummary>;
};

export type SectionInput = {
  abiotics?: InputMaybe<SectionSummaryInput>;
  diseases?: InputMaybe<SectionSummaryInput>;
  growthstages?: InputMaybe<SectionSummaryInput>;
  insects?: InputMaybe<SectionSummaryInput>;
  lodgings?: InputMaybe<SectionSummaryInput>;
};

export type SectionSummary = {
  __typename: 'SectionSummary';
  details?: Maybe<Scalars['Boolean']['output']>;
  summary?: Maybe<Scalars['Boolean']['output']>;
};

export type SectionSummaryInput = {
  details?: InputMaybe<Scalars['Boolean']['input']>;
  summary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SeedBoxTreatment = {
  __typename: 'SeedBoxTreatment';
  applicationSpotUuid?: Maybe<Scalars['UUID']['output']>;
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  products?: Maybe<Array<Maybe<TreatmentProduct>>>;
  recipe?: Maybe<Array<Maybe<Ingredient>>>;
  state?: Maybe<TaskExecutionState>;
  taskMethodUuid?: Maybe<Scalars['UUID']['output']>;
  totalLiquidLocalUnitUuid?: Maybe<Scalars['UUID']['output']>;
  totalLiquidRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
  waterLocalUnitUuid?: Maybe<Scalars['UUID']['output']>;
};

export type SeedSelectorInput = {
  __typename: 'SeedSelectorInput';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FieldV2>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  relativeMaturity?: Maybe<RelativeMaturity>;
  uuid: Scalars['UUID']['output'];
  variety?: Maybe<Variety>;
};

export type SeedTreatment = {
  __typename: 'SeedTreatment';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  products?: Maybe<Array<Maybe<TreatmentProduct>>>;
  recipe?: Maybe<Array<Maybe<Ingredient>>>;
  state?: Maybe<TaskExecutionState>;
  taskMethodUuid?: Maybe<Scalars['UUID']['output']>;
  totalLiquidRate?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SeedTreatmentType = {
  __typename: 'SeedTreatmentType';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SelectedYear = {
  __typename: 'SelectedYear';
  included: Scalars['Boolean']['output'];
  year: Scalars['Int']['output'];
};

export enum Sensitivity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SensorStatusVariableDetail = {
  __typename: 'SensorStatusVariableDetail';
  disabledHistory?: Maybe<Array<Maybe<DisabledHistory>>>;
  name?: Maybe<Scalars['String']['output']>;
  wasEverDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum ServiceType {
  FullService = 'FULL_SERVICE',
  SelfService = 'SELF_SERVICE'
}

export type SharingMandate = {
  __typename: 'SharingMandate';
  accessCode?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<SharingMandatePermission>>>;
  uuid: Scalars['UUID']['output'];
};

export type SharingMandatePermission = {
  __typename: 'SharingMandatePermission';
  access?: Maybe<Access>;
  isGranteeOwner?: Maybe<Scalars['Boolean']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  objectUuid?: Maybe<Scalars['UUID']['output']>;
};

export type ShopDevicePackage = {
  __typename: 'ShopDevicePackage';
  creatorId?: Maybe<Scalars['String']['output']>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validityInDays?: Maybe<Scalars['Int']['output']>;
};

export type ShopFarmPackage = {
  __typename: 'ShopFarmPackage';
  accumulatedOrderIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validityInDays?: Maybe<Scalars['Int']['output']>;
};

export type ShopGiftCard = {
  __typename: 'ShopGiftCard';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  giftCardCode: Scalars['String']['output'];
};

export enum ShopPaymentVendor {
  Amex = 'AMEX',
  BankTransfer = 'BANK_TRANSFER',
  EcontextAtm = 'ECONTEXT_ATM',
  EcontextSevenEleven = 'ECONTEXT_SEVEN_ELEVEN',
  EcontextStores = 'ECONTEXT_STORES',
  Jcb = 'JCB',
  Klarna = 'KLARNA',
  KlarnaPaynow = 'KLARNA_PAYNOW',
  Mastercard = 'MASTERCARD',
  Paypal = 'PAYPAL',
  Visa = 'VISA'
}

export type ShopSubscription = {
  __typename: 'ShopSubscription';
  addressInformation?: Maybe<ShopSubscriptionAddressInformation>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  paymentDetails?: Maybe<ShopSubscriptionPaymentDetails>;
  renewalDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<ShopSubscriptionStatus>;
  subscriptionItems?: Maybe<Array<Maybe<ShopSubscriptionItem>>>;
  subscriptionPeriods?: Maybe<Array<Maybe<ShopSubscriptionPeriod>>>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ShopSubscriptionAddressInformation = {
  __typename: 'ShopSubscriptionAddressInformation';
  billingAddress?: Maybe<ShopSubscriptionBillingAddress>;
  shippingAddress?: Maybe<ShopSubscriptionShippingAddress>;
};

export type ShopSubscriptionBillingAddress = {
  __typename: 'ShopSubscriptionBillingAddress';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  countryId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  regionCode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telephone: Scalars['String']['output'];
};

export type ShopSubscriptionItem = {
  __typename: 'ShopSubscriptionItem';
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  deviceUuid?: Maybe<Scalars['UUID']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<ShopSubscription>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type ShopSubscriptionPaymentDetails = {
  __typename: 'ShopSubscriptionPaymentDetails';
  cardExpiration?: Maybe<Scalars['String']['output']>;
  customerFirstname?: Maybe<Scalars['String']['output']>;
  customerLastname?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  maskedDetails?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tokenExpirationDate?: Maybe<Scalars['Date']['output']>;
  vendor: ShopPaymentVendor;
};

export type ShopSubscriptionPeriod = {
  __typename: 'ShopSubscriptionPeriod';
  creatorId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  startDate?: Maybe<Scalars['Date']['output']>;
  subscription?: Maybe<ShopSubscription>;
  uuid: Scalars['UUID']['output'];
};

export type ShopSubscriptionShippingAddress = {
  __typename: 'ShopSubscriptionShippingAddress';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  countryId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  regionCode?: Maybe<Scalars['String']['output']>;
  sameAsBilling?: Maybe<Scalars['Boolean']['output']>;
  street?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  telephone: Scalars['String']['output'];
  vatId?: Maybe<Scalars['String']['output']>;
};

export enum ShopSubscriptionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ShopUserPackage = {
  __typename: 'ShopUserPackage';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validityInDays?: Maybe<Scalars['Int']['output']>;
};

export type Site = {
  __typename: 'Site';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type SmagConnectionStatus = {
  __typename: 'SmagConnectionStatus';
  status?: Maybe<ConnectionStatus>;
};

export enum SmartSprayerDeviceFeature {
  MinRateApplication = 'MIN_RATE_APPLICATION'
}

export type SmartSprayerExecution = {
  __typename: 'SmartSprayerExecution';
  adeMode?: Maybe<AdeMode>;
  adeSavings?: Maybe<Scalars['Float']['output']>;
  adeSprayedArea?: Maybe<Scalars['Float']['output']>;
  adeTotalArea?: Maybe<Scalars['Float']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  crop?: Maybe<Crop>;
  endDate?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  field?: Maybe<FieldV2>;
  fieldAssignmentUuid?: Maybe<Scalars['UUID']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  isMinRateApplicationEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  machineName?: Maybe<Scalars['String']['output']>;
  mergedSmartSprayingExecution?: Maybe<MergedSmartSprayerExecution>;
  /** @deprecated Use mergedSmartSprayingExecution instead */
  mergedSmartSprayingExecutionUuid?: Maybe<Scalars['UUID']['output']>;
  missingInfo?: Maybe<SmartSprayerExecutionMissingInfo>;
  offlineTask?: Maybe<SmartSprayingOfflineTask>;
  operationMode?: Maybe<OperationMode>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  smartSprayerRegistration?: Maybe<SmartSprayerRegistration>;
  smartSprayingTaskV2?: Maybe<SmartSprayingTaskV2>;
  strategy?: Maybe<Strategy>;
  terminalTask?: Maybe<SmartSprayingTerminalTask>;
  uuid: Scalars['UUID']['output'];
  zoneStrategies?: Maybe<Array<Maybe<ExecutionZoneStrategy>>>;
};

export type SmartSprayerExecutionFieldInfo = {
  __typename: 'SmartSprayerExecutionFieldInfo';
  bestGuess?: Maybe<Scalars['UUID']['output']>;
  possibleValues?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};

export type SmartSprayerExecutionMissingInfo = {
  __typename: 'SmartSprayerExecutionMissingInfo';
  fieldUuid?: Maybe<SmartSprayerExecutionFieldInfo>;
};

export type SmartSprayerExecutionSort = {
  column: SmartSprayerExecutionSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SmartSprayerExecutionSortColumn {
  AdeMode = 'ADE_MODE',
  AdeTotalArea = 'ADE_TOTAL_AREA',
  ExecutionDate = 'EXECUTION_DATE',
  FieldName = 'FIELD_NAME',
  MachineName = 'MACHINE_NAME',
  OperationMode = 'OPERATION_MODE'
}

export type SmartSprayerExecutionStatistics = {
  __typename: 'SmartSprayerExecutionStatistics';
  executionCropUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  executionFieldUuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  executionStrategies?: Maybe<Array<Maybe<Strategy>>>;
  summary: SmartSprayerExecutionSummary;
};

export type SmartSprayerExecutionSummary = {
  __typename: 'SmartSprayerExecutionSummary';
  adeSavings?: Maybe<Scalars['Float']['output']>;
  adeSprayedArea?: Maybe<Scalars['Float']['output']>;
  adeTotalArea?: Maybe<Scalars['Float']['output']>;
};

export type SmartSprayerLicense = {
  __typename: 'SmartSprayerLicense';
  licenseCode?: Maybe<Scalars['String']['output']>;
  oem?: Maybe<SmartSprayerRegistrationOem>;
  smartSprayerRegistrations?: Maybe<Array<Maybe<SmartSprayerRegistration>>>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SmartSprayerRegistration = {
  __typename: 'SmartSprayerRegistration';
  comments?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['Date']['output']>;
  deviceFeatures?: Maybe<Array<Maybe<SmartSprayerDeviceFeature>>>;
  etag?: Maybe<Scalars['String']['output']>;
  isTwoTankSupported?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  licenseStatus?: Maybe<Scalars['String']['output']>;
  machineIdentifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oem?: Maybe<SmartSprayerRegistrationOem>;
  registeredAt?: Maybe<Scalars['Date']['output']>;
  registrationType?: Maybe<SmartSprayerRegistrationType>;
  smartSprayerExecutions?: Maybe<Array<Maybe<SmartSprayerExecution>>>;
  smartSprayerLicense?: Maybe<SmartSprayerLicense>;
  smartSprayerStatus?: Maybe<SmartSprayerRegistrationStatus>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
};

export enum SmartSprayerRegistrationOem {
  Agco = 'AGCO',
  Amazone = 'AMAZONE',
  Caiman = 'CAIMAN',
  Croplands = 'CROPLANDS',
  Dammann = 'DAMMANN',
  Raven = 'RAVEN',
  Stara = 'STARA',
  Unknown = 'UNKNOWN'
}

export type SmartSprayerRegistrationSort = {
  column: SmartSprayerRegistrationSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SmartSprayerRegistrationSortColumn {
  MachineIdentifier = 'MACHINE_IDENTIFIER',
  Name = 'NAME',
  Oem = 'OEM',
  RegisteredAt = 'REGISTERED_AT'
}

export type SmartSprayerRegistrationStatus = {
  __typename: 'SmartSprayerRegistrationStatus';
  lastSeen?: Maybe<Scalars['Date']['output']>;
  location?: Maybe<Location>;
  packages?: Maybe<Array<Maybe<SmartSprayerStatusPackage>>>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export enum SmartSprayerRegistrationType {
  AdeTrial = 'ADE_TRIAL',
  Commercial = 'COMMERCIAL',
  Internal = 'INTERNAL',
  OneDemo = 'ONE_DEMO'
}

export type SmartSprayerStatusPackage = {
  __typename: 'SmartSprayerStatusPackage';
  description?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SmartSprayerWeedPressureApplication = {
  __typename: 'SmartSprayerWeedPressureApplication';
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  fieldCoveragePercent?: Maybe<Scalars['Int']['output']>;
  included: Scalars['Boolean']['output'];
  seasonKind: SmartSprayerWeedPressureSeasonKind;
  seasonLabel?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SmartSprayerWeedPressureApplicationSelection = {
  __typename: 'SmartSprayerWeedPressureApplicationSelection';
  applicationsAnalyzed: Scalars['Int']['output'];
  currentExclusionUuid?: Maybe<Scalars['UUID']['output']>;
  eligibleApplicationsCount: Scalars['Int']['output'];
  filtered: Scalars['Boolean']['output'];
};

export enum SmartSprayerWeedPressureCalculationState {
  Pending = 'PENDING',
  Ready = 'READY'
}

export type SmartSprayerWeedPressureExclusionSet = {
  __typename: 'SmartSprayerWeedPressureExclusionSet';
  dateCreated?: Maybe<Scalars['Date']['output']>;
  exclusionRevision: Scalars['Int']['output'];
  exclusions: Array<Scalars['UUID']['output']>;
  fieldUuid: Scalars['UUID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
};

/**
 *  OSS-20 Weed Pressure Map (smartsprayer-agronomic-service). Thin BFF mirror.
 *  hotSpotHistory items are prefix FieldKpiPayload (DFITE-60752 / ADR 0041), not per-application mean WPI.
 */
export type SmartSprayerWeedPressureField = {
  __typename: 'SmartSprayerWeedPressureField';
  applicationSelection?: Maybe<SmartSprayerWeedPressureApplicationSelection>;
  applications?: Maybe<Array<SmartSprayerWeedPressureApplication>>;
  averageCoveragePercent?: Maybe<Scalars['Int']['output']>;
  averageDensity?: Maybe<Scalars['Float']['output']>;
  boundaryAreaHa?: Maybe<Scalars['Float']['output']>;
  /** READY: KPIs are populated. PENDING: calculation is still running (HTTP 202), KPI fields are null. */
  calculationState: SmartSprayerWeedPressureCalculationState;
  dominantWeedSize?: Maybe<SmartSprayerWeedPressureWeedSize>;
  emergingZones?: Maybe<Scalars['Int']['output']>;
  farm?: Maybe<FarmV2>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  field?: Maybe<FieldV2>;
  fieldCoverageWarning?: Maybe<Scalars['Boolean']['output']>;
  fieldDataState?: Maybe<SmartSprayerWeedPressureFieldDataState>;
  fieldUuid: Scalars['UUID']['output'];
  fieldVariability?: Maybe<Scalars['Int']['output']>;
  highPressureAreaPercent?: Maybe<Scalars['Int']['output']>;
  hotSpotHistory?: Maybe<Array<SmartSprayerWeedPressureHotSpotHistoryPoint>>;
  hotSpotStabilityPercent?: Maybe<Scalars['Int']['output']>;
  pressureTrendDirection?: Maybe<SmartSprayerWeedPressureTrendDirection>;
  pressureTrendSlope?: Maybe<Scalars['Float']['output']>;
  /** Suggested wait before polling again. Only set while PENDING, when the REST API provides it. */
  retryAfterSeconds?: Maybe<Scalars['Int']['output']>;
  settingsApplied?: Maybe<SmartSprayerWeedPressureSettingsApplied>;
  /** Weed Pressure COG for this Aggregation snapshot. Null until the snapshot is published. */
  stacItemId?: Maybe<Scalars['UUID']['output']>;
  weedPressureScore?: Maybe<Scalars['Int']['output']>;
};

export enum SmartSprayerWeedPressureFieldDataState {
  Available = 'AVAILABLE',
  Empty = 'EMPTY',
  LimitedHistory = 'LIMITED_HISTORY'
}

export type SmartSprayerWeedPressureFieldListItem = {
  __typename: 'SmartSprayerWeedPressureFieldListItem';
  applicationsAnalyzed?: Maybe<Scalars['Int']['output']>;
  averageCoveragePercent?: Maybe<Scalars['Int']['output']>;
  averageDensity?: Maybe<Scalars['Float']['output']>;
  boundaryAreaHa?: Maybe<Scalars['Float']['output']>;
  calculationState: SmartSprayerWeedPressureCalculationState;
  dominantWeedSize?: Maybe<SmartSprayerWeedPressureWeedSize>;
  eligibleApplicationsCount?: Maybe<Scalars['Int']['output']>;
  emergingZones?: Maybe<Scalars['Int']['output']>;
  farm?: Maybe<FarmV2>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  field?: Maybe<FieldV2>;
  fieldCoverageWarning?: Maybe<Scalars['Boolean']['output']>;
  fieldDataState?: Maybe<SmartSprayerWeedPressureFieldDataState>;
  fieldUuid: Scalars['UUID']['output'];
  fieldVariability?: Maybe<Scalars['Int']['output']>;
  highPressureAreaPercent?: Maybe<Scalars['Int']['output']>;
  hotSpotStabilityPercent?: Maybe<Scalars['Int']['output']>;
  pressureTrendDirection?: Maybe<SmartSprayerWeedPressureTrendDirection>;
  pressureTrendSlope?: Maybe<Scalars['Float']['output']>;
  weedPressureScore?: Maybe<Scalars['Int']['output']>;
};

export type SmartSprayerWeedPressureFieldSort = {
  column: SmartSprayerWeedPressureFieldSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SmartSprayerWeedPressureFieldSortColumn {
  ApplicationsAnalyzed = 'APPLICATIONS_ANALYZED',
  FieldUuid = 'FIELD_UUID',
  HighPressureAreaPercent = 'HIGH_PRESSURE_AREA_PERCENT',
  HotSpotStabilityPercent = 'HOT_SPOT_STABILITY_PERCENT',
  PressureTrendSlope = 'PRESSURE_TREND_SLOPE',
  WeedPressureScore = 'WEED_PRESSURE_SCORE'
}

export enum SmartSprayerWeedPressureHistoryKind {
  Application = 'APPLICATION',
  CropSeason = 'CROP_SEASON',
  Uncategorized = 'UNCATEGORIZED'
}

export type SmartSprayerWeedPressureHotSpotHistoryPoint = {
  __typename: 'SmartSprayerWeedPressureHotSpotHistoryPoint';
  applicationUuid?: Maybe<Scalars['UUID']['output']>;
  applicationsAnalyzed: Scalars['Int']['output'];
  averageCoveragePercent?: Maybe<Scalars['Int']['output']>;
  averageDensity?: Maybe<Scalars['Float']['output']>;
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  date: Scalars['Date']['output'];
  dominantWeedSize?: Maybe<SmartSprayerWeedPressureWeedSize>;
  emergingZones?: Maybe<Scalars['Int']['output']>;
  fieldDataState: SmartSprayerWeedPressureFieldDataState;
  fieldVariability?: Maybe<Scalars['Int']['output']>;
  highPressureAreaPercent?: Maybe<Scalars['Int']['output']>;
  hotSpotStabilityPercent?: Maybe<Scalars['Int']['output']>;
  kind: SmartSprayerWeedPressureHistoryKind;
  pressureTrendDirection?: Maybe<SmartSprayerWeedPressureTrendDirection>;
  pressureTrendSlope?: Maybe<Scalars['Float']['output']>;
  /** Spot Spray application whose prefix this stop copies. Set on application, crop-season, and year stops when REST sends it. */
  sourceApplicationUuid?: Maybe<Scalars['UUID']['output']>;
  /** STAC item for that application prefix. Null until the prefix is registered and the publication generation matches the snapshot. */
  stacItemId?: Maybe<Scalars['UUID']['output']>;
  weedPressureScore?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type SmartSprayerWeedPressureRecalculation = {
  __typename: 'SmartSprayerWeedPressureRecalculation';
  reason: SmartSprayerWeedPressureRecalculationReason;
  status: SmartSprayerWeedPressureRecalculationStatus;
};

export enum SmartSprayerWeedPressureRecalculationReason {
  Manual = 'MANUAL',
  SettingsChanged = 'SETTINGS_CHANGED'
}

export enum SmartSprayerWeedPressureRecalculationStatus {
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED'
}

export enum SmartSprayerWeedPressureSeasonKind {
  CropSeason = 'CROP_SEASON',
  Estimated = 'ESTIMATED',
  Uncategorized = 'UNCATEGORIZED'
}

export type SmartSprayerWeedPressureSettingsApplied = {
  __typename: 'SmartSprayerWeedPressureSettingsApplied';
  gridSizeM: Scalars['Int']['output'];
  timeWeighting: SmartSprayerWeedPressureTimeWeighting;
  weightingMode: SmartSprayerWeedPressureWeightingMode;
};

export type SmartSprayerWeedPressureStatistics = {
  __typename: 'SmartSprayerWeedPressureStatistics';
  /** False while any selected field is still PENDING, so the summary is partial. */
  calculationComplete?: Maybe<Scalars['Boolean']['output']>;
  pendingFieldCount?: Maybe<Scalars['Int']['output']>;
  summary: SmartSprayerWeedPressureStatisticsSummary;
  weedPressureFieldUuids: Array<Scalars['UUID']['output']>;
};

export type SmartSprayerWeedPressureStatisticsSummary = {
  __typename: 'SmartSprayerWeedPressureStatisticsSummary';
  summaryPressureTrendDirection?: Maybe<SmartSprayerWeedPressureTrendDirection>;
  summaryPressureTrendSlope?: Maybe<Scalars['Float']['output']>;
  summaryWeedPressureScore?: Maybe<Scalars['Int']['output']>;
};

export enum SmartSprayerWeedPressureTimeWeighting {
  Historical = 'HISTORICAL',
  RecentFocus = 'RECENT_FOCUS'
}

export enum SmartSprayerWeedPressureTrendDirection {
  Decreasing = 'DECREASING',
  Flat = 'FLAT',
  Increasing = 'INCREASING'
}

export enum SmartSprayerWeedPressureWeedSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export enum SmartSprayerWeedPressureWeightingMode {
  Balanced = 'BALANCED',
  CoverageFocused = 'COVERAGE_FOCUSED',
  DensityFocused = 'DENSITY_FOCUSED'
}

export type SmartSprayingOfflineTask = {
  __typename: 'SmartSprayingOfflineTask';
  crop?: Maybe<Crop>;
  /** @deprecated Use `field` */
  cropSeason?: Maybe<CropSeasonV2>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  field?: Maybe<FieldV2>;
  fieldName?: Maybe<Scalars['String']['output']>;
  machineIdentifier?: Maybe<Scalars['String']['output']>;
  operationMode?: Maybe<OperationMode>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  smartSprayingExecution?: Maybe<SmartSprayerExecution>;
  /** @deprecated Use `smartSprayingTaskV2` */
  smartSprayingTask?: Maybe<SmartSprayingTask>;
  smartSprayingTaskV2?: Maybe<SmartSprayingTaskV2>;
  strategy?: Maybe<Strategy>;
  /** @deprecated No longer used */
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SmartSprayingTask = {
  __typename: 'SmartSprayingTask';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  dosedMap?: Maybe<DosedMap>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  operationMode?: Maybe<OperationMode>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  recommendationUuid?: Maybe<Scalars['UUID']['output']>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  smartSprayingExecution?: Maybe<SmartSprayerExecution>;
  smartSprayingTaskDevicePayloads?: Maybe<Array<Maybe<SmartSprayingTaskDevicePayload>>>;
  soilTextureUuid?: Maybe<Scalars['UUID']['output']>;
  state?: Maybe<TaskExecutionState>;
  strategy?: Maybe<Strategy>;
  uuid: Scalars['UUID']['output'];
  weedRecord?: Maybe<WeedRecord>;
  zoneStrategies?: Maybe<Array<Maybe<ZoneStrategy>>>;
};

export type SmartSprayingTaskDevicePayload = {
  __typename: 'SmartSprayingTaskDevicePayload';
  calculatedDate?: Maybe<Scalars['Date']['output']>;
  devicePayload?: Maybe<Scalars['String']['output']>;
  error?: Maybe<SmartSprayingTaskDevicePayloadError>;
  /** @deprecated Use `SmartSprayingTaskV2`. */
  smartSprayingTask?: Maybe<SmartSprayingTask>;
  smartSprayingTaskV2?: Maybe<SmartSprayingTaskV2>;
  status?: Maybe<SmartSprayingTaskDevicePayloadStatus>;
  warning?: Maybe<SmartSprayingTaskDevicePayloadWarning>;
};

export enum SmartSprayingTaskDevicePayloadError {
  AdeBadRequest = 'ADE_BAD_REQUEST',
  AdeCalculationError = 'ADE_CALCULATION_ERROR',
  DosedMapWithoutProducts = 'DOSED_MAP_WITHOUT_PRODUCTS',
  GeneralAdeError = 'GENERAL_ADE_ERROR',
  MissingDosedMap = 'MISSING_DOSED_MAP',
  NoGrowthStage = 'NO_GROWTH_STAGE',
  PermissionMissing = 'PERMISSION_MISSING',
  TaskPlannedTooFarInFuture = 'TASK_PLANNED_TOO_FAR_IN_FUTURE',
  TaskPlannedTooFarInPast = 'TASK_PLANNED_TOO_FAR_IN_PAST',
  TooManyMgmtZones = 'TOO_MANY_MGMT_ZONES'
}

export enum SmartSprayingTaskDevicePayloadStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export enum SmartSprayingTaskDevicePayloadWarning {
  AdaptMgmtZone = 'ADAPT_MGMT_ZONE',
  ThresholdAccuracyGs = 'THRESHOLD_ACCURACY_GS',
  ThresholdAccuracyPrevAppl = 'THRESHOLD_ACCURACY_PREV_APPL',
  ThresholdAccuracyQuestion = 'THRESHOLD_ACCURACY_QUESTION',
  ThresholdAccuracySoilMoisture = 'THRESHOLD_ACCURACY_SOIL_MOISTURE',
  ThresholdAccuracyUnsupportedCrop = 'THRESHOLD_ACCURACY_UNSUPPORTED_CROP',
  ThresholdAccuracyUnsupportedInput = 'THRESHOLD_ACCURACY_UNSUPPORTED_INPUT',
  ThresholdAccuracyUnsupportedStrategy = 'THRESHOLD_ACCURACY_UNSUPPORTED_STRATEGY'
}

export type SmartSprayingTaskDosedMap = {
  __typename: 'SmartSprayingTaskDosedMap';
  dosedMap?: Maybe<DosedMap>;
  tankNumber?: Maybe<Scalars['Int']['output']>;
};

export type SmartSprayingTaskV2 = {
  __typename: 'SmartSprayingTaskV2';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  customAdjacentThreshold?: Maybe<Scalars['Int']['output']>;
  customThreshold?: Maybe<Scalars['Int']['output']>;
  dosedMaps?: Maybe<Array<Maybe<SmartSprayingTaskDosedMap>>>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isCropRowAngleDetectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMinRateApplicationEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  operationMode?: Maybe<OperationMode>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  recommendationUuid?: Maybe<Scalars['UUID']['output']>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  smartSprayingExecution?: Maybe<SmartSprayerExecution>;
  smartSprayingTaskDevicePayloads?: Maybe<Array<Maybe<SmartSprayingTaskDevicePayload>>>;
  soilTextureUuid?: Maybe<Scalars['UUID']['output']>;
  state?: Maybe<TaskExecutionState>;
  strategy?: Maybe<Strategy>;
  thresholdAnswerUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  uuid: Scalars['UUID']['output'];
  weedRecord?: Maybe<WeedRecord>;
  zoneStrategies?: Maybe<Array<Maybe<ZoneStrategy>>>;
};

export type SmartSprayingTerminalStrategyMappings = {
  __typename: 'SmartSprayingTerminalStrategyMappings';
  burndown: Scalars['JSONObject']['output'];
  smartsprayer: Scalars['JSONObject']['output'];
};

export type SmartSprayingTerminalTask = {
  __typename: 'SmartSprayingTerminalTask';
  country?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  externalTaskUuid: Scalars['UUID']['output'];
  operationMode?: Maybe<OperationMode>;
  rowWidth?: Maybe<Scalars['Float']['output']>;
  smartSprayerRegistration?: Maybe<SmartSprayerRegistration>;
  smartSprayingExecution?: Maybe<SmartSprayerExecution>;
  /** @deprecated Use `smartSprayingTaskV2` */
  smartSprayingTask?: Maybe<SmartSprayingTask>;
  smartSprayingTaskV2?: Maybe<SmartSprayingTaskV2>;
  uuid: Scalars['UUID']['output'];
};

export enum SoilDrainageClass {
  Fast = 'FAST',
  Moderate = 'MODERATE',
  Slow = 'SLOW'
}

export type SoilErosion = {
  __typename: 'SoilErosion';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  fieldV2?: Maybe<FieldV2>;
  totalErosion?: Maybe<Scalars['Float']['output']>;
};

export enum SoilPropertyType {
  Aluminium = 'ALUMINIUM',
  AluminiumSaturationInCec = 'ALUMINIUM_SATURATION_IN_CEC',
  AnaerobicNitrogen = 'ANAEROBIC_NITROGEN',
  AvailableMoisture = 'AVAILABLE_MOISTURE',
  AvailableMoistureHorizonA = 'AVAILABLE_MOISTURE_HORIZON_A',
  AvailableMoistureHorizonB = 'AVAILABLE_MOISTURE_HORIZON_B',
  AvailableNitrogen = 'AVAILABLE_NITROGEN',
  AvailableSilicon = 'AVAILABLE_SILICON',
  AvailableWater = 'AVAILABLE_WATER',
  AvailableWaterStorage = 'AVAILABLE_WATER_STORAGE',
  AvailableWaterStorageTo_25Cm = 'AVAILABLE_WATER_STORAGE_TO_25CM',
  AvailableWaterStorageTo_50Cm = 'AVAILABLE_WATER_STORAGE_TO_50CM',
  AvailableWaterStorageTo_100Cm = 'AVAILABLE_WATER_STORAGE_TO_100CM',
  AvailableWaterStorageTo_150Cm = 'AVAILABLE_WATER_STORAGE_TO_150CM',
  BaseSaturation = 'BASE_SATURATION',
  Boron = 'BORON',
  BulkDensity = 'BULK_DENSITY',
  Calcium = 'CALCIUM',
  CalciumCarbonate = 'CALCIUM_CARBONATE',
  CalciumSaturationInCec = 'CALCIUM_SATURATION_IN_CEC',
  CarbonNitrogenRatio = 'CARBON_NITROGEN_RATIO',
  CationExchangeCapacity = 'CATION_EXCHANGE_CAPACITY',
  Clay = 'CLAY',
  CoarseFragments = 'COARSE_FRAGMENTS',
  Cobalt = 'COBALT',
  Copper = 'COPPER',
  CopperDtpa = 'COPPER_DTPA',
  CopperMehlich = 'COPPER_MEHLICH',
  Drainage = 'DRAINAGE',
  EasilyReducingManganese = 'EASILY_REDUCING_MANGANESE',
  ElectricalConductivity = 'ELECTRICAL_CONDUCTIVITY',
  ExchangeableCalcium = 'EXCHANGEABLE_CALCIUM',
  ExchangeableMagnesium = 'EXCHANGEABLE_MAGNESIUM',
  ExchangeableManganese = 'EXCHANGEABLE_MANGANESE',
  ExchangeablePotassium = 'EXCHANGEABLE_POTASSIUM',
  ExchangeableSodium = 'EXCHANGEABLE_SODIUM',
  FieldWaterContent = 'FIELD_WATER_CONTENT',
  FieldWaterContentHorizonA = 'FIELD_WATER_CONTENT_HORIZON_A',
  FieldWaterContentHorizonB = 'FIELD_WATER_CONTENT_HORIZON_B',
  FineEarthDensity = 'FINE_EARTH_DENSITY',
  FirstWiltingPoint = 'FIRST_WILTING_POINT',
  FirstWiltingPointHorizonA = 'FIRST_WILTING_POINT_HORIZON_A',
  FirstWiltingPointHorizonB = 'FIRST_WILTING_POINT_HORIZON_B',
  FreeIronOxides = 'FREE_IRON_OXIDES',
  Humus = 'HUMUS',
  Iron = 'IRON',
  IronDtpa = 'IRON_DTPA',
  IronMehlich = 'IRON_MEHLICH',
  Magnesium = 'MAGNESIUM',
  MagnesiumOxide = 'MAGNESIUM_OXIDE',
  MagnesiumSaturationInCec = 'MAGNESIUM_SATURATION_IN_CEC',
  Manganese = 'MANGANESE',
  ManganeseDtpa = 'MANGANESE_DTPA',
  ManganeseMehlich = 'MANGANESE_MEHLICH',
  MaxWaterCapacity = 'MAX_WATER_CAPACITY',
  MaxWaterCapacityHorizonA = 'MAX_WATER_CAPACITY_HORIZON_A',
  MaxWaterCapacityHorizonB = 'MAX_WATER_CAPACITY_HORIZON_B',
  Molybdenum = 'MOLYBDENUM',
  NitrogenContentNh4 = 'NITROGEN_CONTENT_NH4',
  NitrogenContentNo3 = 'NITROGEN_CONTENT_NO3',
  OrganicCarbonContent = 'ORGANIC_CARBON_CONTENT',
  OrganicMatter = 'ORGANIC_MATTER',
  PenetrationResistance = 'PENETRATION_RESISTANCE',
  PermanentWiltingPoint = 'PERMANENT_WILTING_POINT',
  PermanentWiltingPointHorizonA = 'PERMANENT_WILTING_POINT_HORIZON_A',
  PermanentWiltingPointHorizonB = 'PERMANENT_WILTING_POINT_HORIZON_B',
  Phosphorus = 'PHOSPHORUS',
  PhosphorusAbsortionCoefficient = 'PHOSPHORUS_ABSORTION_COEFFICIENT',
  PhosphorusBray = 'PHOSPHORUS_BRAY',
  PhosphorusMassVolume = 'PHOSPHORUS_MASS_VOLUME',
  PhosphorusMehlich = 'PHOSPHORUS_MEHLICH',
  PhosphorusOlsen = 'PHOSPHORUS_OLSEN',
  PhosphorusResina = 'PHOSPHORUS_RESINA',
  PhosphorusTruog = 'PHOSPHORUS_TRUOG',
  PhCacl = 'PH_CACL',
  PhH2O = 'PH_H2O',
  PhKcl = 'PH_KCL',
  Potassium = 'POTASSIUM',
  PotassiumMehlich_3 = 'POTASSIUM_MEHLICH_3',
  PotassiumSaturationInCec = 'POTASSIUM_SATURATION_IN_CEC',
  RockFragments = 'ROCK_FRAGMENTS',
  Sand = 'SAND',
  SaturatedHydraulicConductivity = 'SATURATED_HYDRAULIC_CONDUCTIVITY',
  SaturatedHydraulicConductivityHorizonA = 'SATURATED_HYDRAULIC_CONDUCTIVITY_HORIZON_A',
  SaturatedHydraulicConductivityHorizonB = 'SATURATED_HYDRAULIC_CONDUCTIVITY_HORIZON_B',
  Silt = 'SILT',
  Sodium = 'SODIUM',
  SodiumAbsorptionRatio = 'SODIUM_ABSORPTION_RATIO',
  SoilType = 'SOIL_TYPE',
  StressAnalysisResult = 'STRESS_ANALYSIS_RESULT',
  Sulfur = 'SULFUR',
  Texture = 'TEXTURE',
  TotalKjeldahlNitrogen = 'TOTAL_KJELDAHL_NITROGEN',
  UsdaTexture = 'USDA_TEXTURE',
  Zinc = 'ZINC',
  ZincDtpa = 'ZINC_DTPA',
  ZincMehlich = 'ZINC_MEHLICH'
}

export type SoilSample = {
  __typename: 'SoilSample';
  id?: Maybe<Scalars['String']['output']>;
  measurements?: Maybe<Array<Maybe<Measurement>>>;
  samplingArea?: Maybe<Scalars['String']['output']>;
  samplingDepth?: Maybe<Scalars['String']['output']>;
};

export type SoilSampling = {
  __typename: 'SoilSampling';
  comment?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FieldV2>;
  flowHint?: Maybe<FlowHint>;
  gridAngle?: Maybe<Scalars['Float']['output']>;
  gridCellSize?: Maybe<Scalars['Float']['output']>;
  headlandWidth?: Maybe<Scalars['Float']['output']>;
  internalBuffer?: Maybe<Scalars['Float']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numCores?: Maybe<Scalars['Float']['output']>;
  numberOfPointsPerReferenceArea?: Maybe<Scalars['Float']['output']>;
  pattern?: Maybe<SoilSamplingPattern>;
  radius?: Maybe<Scalars['Float']['output']>;
  referenceArea?: Maybe<Scalars['Float']['output']>;
  samplingAreas?: Maybe<Array<Maybe<SamplingArea>>>;
  samplingDepths?: Maybe<Array<Maybe<SamplingDepth>>>;
  samplingIds?: Maybe<Array<Maybe<SamplingId>>>;
  samplingPoints?: Maybe<Array<Maybe<SamplingPoint>>>;
  soilSamplingTasks?: Maybe<Array<Maybe<SoilSamplingTask>>>;
  sourceMapUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<SoilSamplingType>;
  unit?: Maybe<SoilSamplingUnit>;
  uuid: Scalars['UUID']['output'];
};

export type SoilSamplingMeasurement = {
  __typename: 'SoilSamplingMeasurement';
  applicableStresses?: Maybe<Array<Maybe<ApplicableStress>>>;
  applicableUnits: Array<Scalars['String']['output']>;
  measurement: SoilPropertyType;
};

export enum SoilSamplingPattern {
  Grid = 'GRID',
  MShape = 'M_SHAPE',
  Zigzag = 'ZIGZAG',
  ZoneBorder = 'ZONE_BORDER',
  ZShape = 'Z_SHAPE'
}

export type SoilSamplingResult = {
  __typename: 'SoilSamplingResult';
  creatorId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FieldV2>;
  fileBatchUuid?: Maybe<Scalars['UUID']['output']>;
  files?: Maybe<Array<Maybe<File>>>;
  laboratory?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  samples?: Maybe<Array<Maybe<SoilSample>>>;
  samplingAreas?: Maybe<Array<Maybe<SoilSamplingResultArea>>>;
  samplingDepths?: Maybe<Array<Maybe<SamplingDepth>>>;
  soilSampling?: Maybe<SoilSampling>;
  sourceMap?: Maybe<SoilSamplingResultSourceMap>;
  sourceSoilSamplingResult?: Maybe<SoilSamplingResult>;
  status?: Maybe<SoilSamplingResultStatus>;
  uuid: Scalars['UUID']['output'];
};

export type SoilSamplingResultArea = {
  __typename: 'SoilSamplingResultArea';
  id?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type SoilSamplingResultSourceMap = {
  __typename: 'SoilSamplingResultSourceMap';
  uuid?: Maybe<Scalars['UUID']['output']>;
  zonesToSamplingAreaMappings?: Maybe<Array<Maybe<ZonesToSamplingAreaMapping>>>;
};

export enum SoilSamplingResultStatus {
  Draft = 'DRAFT',
  ReadyToProcess = 'READY_TO_PROCESS'
}

export type SoilSamplingStressAnalysis = {
  __typename: 'SoilSamplingStressAnalysis';
  aggregatedRiskLevel?: Maybe<RiskLevel>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  field?: Maybe<FieldV2>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  riskMaps?: Maybe<Array<Maybe<RiskMap>>>;
  soilSamplingResult?: Maybe<SoilSamplingResult>;
  uuid: Scalars['UUID']['output'];
};

export type SoilSamplingTask = {
  __typename: 'SoilSamplingTask';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  sampledPoints?: Maybe<Array<Maybe<SampledPoint>>>;
  soilSamplingSet?: Maybe<SoilSampling>;
  state?: Maybe<TaskExecutionState>;
  uuid: Scalars['UUID']['output'];
};

export enum SoilSamplingType {
  Circular = 'CIRCULAR',
  Grid = 'GRID',
  MapZones = 'MAP_ZONES'
}

export enum SoilSamplingUnit {
  ItemsPerArea = 'ITEMS_PER_AREA',
  ItemsPerHectare = 'ITEMS_PER_HECTARE'
}

export type SoilTaxonomy = {
  __typename: 'SoilTaxonomy';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SoilTexture = {
  __typename: 'SoilTexture';
  clayAvg?: Maybe<Scalars['Float']['output']>;
  clayMax?: Maybe<Scalars['Float']['output']>;
  clayMin?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dict?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sandAvg?: Maybe<Scalars['Float']['output']>;
  sandMax?: Maybe<Scalars['Float']['output']>;
  sandMin?: Maybe<Scalars['Float']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  siltAvg?: Maybe<Scalars['Float']['output']>;
  siltMax?: Maybe<Scalars['Float']['output']>;
  siltMin?: Maybe<Scalars['Float']['output']>;
  soilTaxonomyCode?: Maybe<Scalars['String']['output']>;
  soilTaxonomyName?: Maybe<Scalars['String']['output']>;
  soilTaxonomyUuid?: Maybe<Scalars['UUID']['output']>;
  soilTextureUSDACode?: Maybe<Scalars['String']['output']>;
  soilTextureUSDADescription?: Maybe<Scalars['String']['output']>;
  soilTextureUSDAName?: Maybe<Scalars['String']['output']>;
  soilTextureUSDAShortName?: Maybe<Scalars['String']['output']>;
  soilTextureUSDAUuid?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceCardinality {
  MultiImage = 'MULTI_IMAGE',
  None = 'NONE',
  SingleImage = 'SINGLE_IMAGE'
}

export type SourceMap = {
  __typename: 'SourceMap';
  acceptableThresholds?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  boundaryOutdatedSince?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  /** @deprecated Use `vectorizationParameters`. */
  droneCustomMapParameters?: Maybe<Scalars['JSONObject']['output']>;
  field?: Maybe<FieldV2>;
  fieldDataLayerMagnitude?: Maybe<Magnitude>;
  /** @deprecated Use `fieldDataLayerMagnitude` */
  fieldDataLayerMagnitudeType?: Maybe<MagnitudeType>;
  fieldDataLayerProcessingType?: Maybe<ProcessingType>;
  fieldDataLayerUuid?: Maybe<Scalars['UUID']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  groupTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  labelTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  maxElevation?: Maybe<Scalars['Float']['output']>;
  minElevation?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recommendedThreshold?: Maybe<Scalars['Float']['output']>;
  sourceCardinality?: Maybe<SourceCardinality>;
  sourceDate?: Maybe<Scalars['Date']['output']>;
  sourceType?: Maybe<SourceType>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  stacFieldDataLayer?: Maybe<StacFieldDataLayer>;
  stacIndex?: Maybe<AgronomicIndexType>;
  stacMagnitude?: Maybe<StacMagnitudeType>;
  thresholdIndex?: Maybe<Scalars['Int']['output']>;
  totalArea?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<SourceMapType>;
  uuid: Scalars['UUID']['output'];
  /**
   *  Parameters this map was vectorized with (stacItemUuid, index, creationFlowHint,
   *  numberOfZones, customBreaks), so a saved customization can be reopened and edited.
   *  Does not replace `type`, which keeps the source-map semantics.
   */
  vectorizationParameters?: Maybe<Scalars['JSONObject']['output']>;
  weeds?: Maybe<Array<Maybe<Weed>>>;
  /** @deprecated Use `zoneIds`. */
  zoneCount?: Maybe<Scalars['Int']['output']>;
  zoneIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};


export type SourceMapFieldDataLayerMagnitudeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type SourceMapFieldDataLayerProcessingTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SourceMapStyle = {
  __typename: 'SourceMapStyle';
  applicationType?: Maybe<ApplicationType>;
  entries?: Maybe<Array<SourceMapStyleEntry>>;
  sourceMapType?: Maybe<SourceMapType>;
};

export type SourceMapStyleEntry = {
  __typename: 'SourceMapStyleEntry';
  category?: Maybe<ApplicationCategory>;
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export enum SourceMapType {
  Biomass = 'BIOMASS',
  BiomassLai = 'BIOMASS_LAI',
  BiomassMonitoringVectorAnalysis = 'BIOMASS_MONITORING_VECTOR_ANALYSIS',
  BiomassNdvi = 'BIOMASS_NDVI',
  BiomassProxyMonitoringVectorAnalysis = 'BIOMASS_PROXY_MONITORING_VECTOR_ANALYSIS',
  Boundary = 'BOUNDARY',
  Custom = 'CUSTOM',
  CustomNematode = 'CUSTOM_NEMATODE',
  CustomNutrientDerivedThresholdBoron = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_BORON',
  CustomNutrientDerivedThresholdGypsum = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_GYPSUM',
  CustomNutrientDerivedThresholdLime = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_LIME',
  CustomNutrientDerivedThresholdPhosphorus = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_PHOSPHORUS',
  CustomNutrientDerivedThresholdPotassium = 'CUSTOM_NUTRIENT_DERIVED_THRESHOLD_POTASSIUM',
  CustomPowerzoneEvi = 'CUSTOM_POWERZONE_EVI',
  CustomPowerzoneLai = 'CUSTOM_POWERZONE_LAI',
  CustomPowerzoneNdvi = 'CUSTOM_POWERZONE_NDVI',
  CustomUploadFdl = 'CUSTOM_UPLOAD_FDL',
  DroneGli = 'DRONE_GLI',
  DroneNdre = 'DRONE_NDRE',
  DroneNdvi = 'DRONE_NDVI',
  DroneSprayerWeedHighSensitivity = 'DRONE_SPRAYER_WEED_HIGH_SENSITIVITY',
  DroneSprayerWeedLowSensitivity = 'DRONE_SPRAYER_WEED_LOW_SENSITIVITY',
  DroneSprayerWeedMediumSensitivity = 'DRONE_SPRAYER_WEED_MEDIUM_SENSITIVITY',
  DroneSyntheticNdvi = 'DRONE_SYNTHETIC_NDVI',
  DroneVarigreen = 'DRONE_VARIGREEN',
  NematodePowerzone = 'NEMATODE_POWERZONE',
  OneSoilBiomass = 'ONE_SOIL_BIOMASS',
  PlanetLai = 'PLANET_LAI',
  PlanetScopeNdvi = 'PLANET_SCOPE_NDVI',
  /** @deprecated Use PLANET_SCOPE_WEED_PRESSURE instead. */
  PlanetScopeNdviWeedPressure = 'PLANET_SCOPE_NDVI_WEED_PRESSURE',
  PlanetScopeWeedPressure = 'PLANET_SCOPE_WEED_PRESSURE',
  PrecifieldNitrogenPrescription = 'PRECIFIELD_NITROGEN_PRESCRIPTION',
  SeedSelectVrsMap = 'SEED_SELECT_VRS_MAP',
  /** @deprecated Use SENTINEL_2_WEED_PRESSURE instead. */
  Sentinel_2NdviWeedPressure = 'SENTINEL_2_NDVI_WEED_PRESSURE',
  Sentinel_2WeedPressure = 'SENTINEL_2_WEED_PRESSURE',
  Soil = 'SOIL',
  SoilSamplingNutrientThresholdBoron = 'SOIL_SAMPLING_NUTRIENT_THRESHOLD_BORON',
  SoilSamplingNutrientThresholdGypsum = 'SOIL_SAMPLING_NUTRIENT_THRESHOLD_GYPSUM',
  SoilSamplingNutrientThresholdLime = 'SOIL_SAMPLING_NUTRIENT_THRESHOLD_LIME',
  SoilSamplingNutrientThresholdPhosphorous = 'SOIL_SAMPLING_NUTRIENT_THRESHOLD_PHOSPHOROUS',
  SoilSamplingNutrientThresholdPotassium = 'SOIL_SAMPLING_NUTRIENT_THRESHOLD_POTASSIUM',
  SoilSamplingPowerzone = 'SOIL_SAMPLING_POWERZONE',
  StacCustomPowerzoneLai = 'STAC_CUSTOM_POWERZONE_LAI',
  StacPowerzone = 'STAC_POWERZONE',
  StacSentinelBiomass = 'STAC_SENTINEL_BIOMASS',
  StacSoilSamplingPowerzone = 'STAC_SOIL_SAMPLING_POWERZONE',
  VraAdvisor = 'VRA_ADVISOR',
  WeedClassification = 'WEED_CLASSIFICATION',
  WeedClassificationNdvi = 'WEED_CLASSIFICATION_NDVI',
  WeedPressure = 'WEED_PRESSURE',
  WeedPressureHighSensitivity = 'WEED_PRESSURE_HIGH_SENSITIVITY',
  WeedPressureLowSensitivity = 'WEED_PRESSURE_LOW_SENSITIVITY',
  WeedPressureMediumSensitivity = 'WEED_PRESSURE_MEDIUM_SENSITIVITY',
  Yield = 'YIELD'
}

export enum SourceType {
  Analysis = 'ANALYSIS',
  AnalysisDynamicFiveZones = 'ANALYSIS_DYNAMIC_FIVE_ZONES',
  AnalysisDynamicSevenZones = 'ANALYSIS_DYNAMIC_SEVEN_ZONES',
  AnalysisFixedThreeZones = 'ANALYSIS_FIXED_THREE_ZONES',
  DroneFlight = 'DRONE_FLIGHT',
  FieldDataLayer = 'FIELD_DATA_LAYER',
  PrecifieldNitrogenPrescription = 'PRECIFIELD_NITROGEN_PRESCRIPTION',
  SatImage = 'SAT_IMAGE',
  SeedSelectVrsMap = 'SEED_SELECT_VRS_MAP',
  StacItemBiomassSentinel_2 = 'STAC_ITEM_BIOMASS_SENTINEL_2',
  StacItemBp = 'STAC_ITEM_BP',
  StacItemBpLai = 'STAC_ITEM_BP_LAI',
  StacItemCustomPowerzoneLai = 'STAC_ITEM_CUSTOM_POWERZONE_LAI',
  StacItemLai = 'STAC_ITEM_LAI',
  StacItemNdvi = 'STAC_ITEM_NDVI',
  StacItemNdviWeedPressure = 'STAC_ITEM_NDVI_WEED_PRESSURE',
  StacItemNematodePowerzone = 'STAC_ITEM_NEMATODE_POWERZONE',
  StacItemPowerzoneData = 'STAC_ITEM_POWERZONE_DATA',
  StacItemSoilSamplingPowerzone = 'STAC_ITEM_SOIL_SAMPLING_POWERZONE',
  StacItemWeedPressure = 'STAC_ITEM_WEED_PRESSURE',
  UserProvided = 'USER_PROVIDED'
}

export type SourceValueMapping = {
  __typename: 'SourceValueMapping';
  foreignValue: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export enum SpecialisedUsageType {
  Farm = 'FARM',
  GreenhouseCluster = 'GREENHOUSE_CLUSTER',
  Orchard = 'ORCHARD',
  Vineyard = 'VINEYARD'
}

export enum SpeciesLossType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export type SprayWeather = {
  __typename: 'SprayWeather';
  /** @deprecated Use `toDate`. */
  endDate?: Maybe<Scalars['Date']['output']>;
  factors?: Maybe<Array<Maybe<SprayWeatherFactor>>>;
  /** @deprecated Use `fieldV2`. */
  field?: Maybe<Field>;
  fieldV2?: Maybe<FieldV2>;
  fromDate?: Maybe<Scalars['Date']['output']>;
  modelUuid?: Maybe<Scalars['UUID']['output']>;
  result?: Maybe<SprayWeatherResult>;
  /** @deprecated Use `fromDate`. */
  startDate?: Maybe<Scalars['Date']['output']>;
  toDate?: Maybe<Scalars['Date']['output']>;
};

export type SprayWeatherFactor = {
  __typename: 'SprayWeatherFactor';
  factor?: Maybe<SprayWeatherFactorFactor>;
  result?: Maybe<SprayWeatherResult>;
};

export enum SprayWeatherFactorFactor {
  AirTemperature = 'AIR_TEMPERATURE',
  DeltaT = 'DELTA_T',
  Precipitation = 'PRECIPITATION',
  RelativeHumidity = 'RELATIVE_HUMIDITY',
  Wind = 'WIND'
}

export enum SprayWeatherResult {
  Bad = 'bad',
  Good = 'good',
  Moderate = 'moderate',
  Unknown = 'unknown'
}

export type Sprayer = {
  __typename: 'Sprayer';
  code?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<SprayerManufacturer>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SprayerType>;
  uuid: Scalars['UUID']['output'];
};

export type SprayerManufacturer = {
  __typename: 'SprayerManufacturer';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type SprayerType = {
  __typename: 'SprayerType';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Spraying = {
  __typename: 'Spraying';
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeason>;
  dosedMap?: Maybe<DosedMap>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `fieldInputPackagingUuids`. */
  fieldInputPackagingUuid?: Maybe<Scalars['UUID']['output']>;
  fieldInputPackagingUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  processedArea?: Maybe<Scalars['Float']['output']>;
  recommendationUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SprayingNutrient = {
  __typename: 'SprayingNutrient';
  accountableAmount?: Maybe<Scalars['Float']['output']>;
  accountableRate?: Maybe<Scalars['Float']['output']>;
  amount: Scalars['Float']['output'];
  fertilizerTypeUuid: Scalars['UUID']['output'];
  nutrientUuid: Scalars['UUID']['output'];
  rate: Scalars['Float']['output'];
  sprayingUuid: Scalars['UUID']['output'];
};

export type SprayingV2 = {
  __typename: 'SprayingV2';
  assignee?: Maybe<Collaborator>;
  /** @deprecated Use `assignee` for more information related to it. */
  assigneeUuid?: Maybe<Scalars['UUID']['output']>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  availableDosedMaps?: Maybe<Array<AvailableDosedMap>>;
  creatorId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  dosedMap?: Maybe<DosedMap>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  executionStartDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `fieldInputPackagingUuids`. */
  fieldInputPackagingUuid?: Maybe<Scalars['UUID']['output']>;
  fieldInputPackagingUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  hortaSpraying?: Maybe<HortaSpraying>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  isAutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  processedArea?: Maybe<Scalars['Float']['output']>;
  recommendationUuid?: Maybe<Scalars['UUID']['output']>;
  residualActivation?: Maybe<ResidualActivation>;
  state?: Maybe<TaskExecutionState>;
  uuid: Scalars['UUID']['output'];
  weedRecordUuid?: Maybe<Scalars['UUID']['output']>;
};

export type SprayingWindow = {
  __typename: 'SprayingWindow';
  cropSeasonUuid: Scalars['UUID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: SprayingWindowStatus;
  uuid: Scalars['UUID']['output'];
};

export enum SprayingWindowStatus {
  Current = 'CURRENT',
  Future = 'FUTURE',
  Missed = 'MISSED',
  NotPresent = 'NOT_PRESENT',
  NoInformation = 'NO_INFORMATION'
}

export type StacFarmStatistics = {
  __typename: 'StacFarmStatistics';
  count?: Maybe<Scalars['Int']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  stacFieldDataLayerType?: Maybe<StacFieldDataLayer>;
};

export enum StacFieldDataLayer {
  /**  Refers to AgronomicIndexType.LAI */
  BiomassPlanetScope = 'BIOMASS_PLANET_SCOPE',
  /**  Refers to AgronomicIndexType.BP */
  BiomassProxy = 'BIOMASS_PROXY',
  /**  Refers to AgronomicIndexType.BP_LAI */
  BiomassProxyLai = 'BIOMASS_PROXY_LAI',
  /**  Refers to AgronomicIndexType.LAI (Sentinel-2 biomass, analogous to BIOMASS_PLANET_SCOPE) */
  BiomassSentinel_2 = 'BIOMASS_SENTINEL_2',
  /**  Refers to AgronomicIndexType.CUSTOM_POWERZONE_DATA */
  CustomPowerzone = 'CUSTOM_POWERZONE',
  /**  Refers to AgronomicIndexType.NEMATODE_POWERZONE_DATA */
  NematodePowerzone = 'NEMATODE_POWERZONE',
  OssCropCoverage = 'OSS_CROP_COVERAGE',
  /**  One Smart Spray layers */
  OssWeedCoverage = 'OSS_WEED_COVERAGE',
  OssWeedMaps = 'OSS_WEED_MAPS',
  OssWeedPressureMaps = 'OSS_WEED_PRESSURE_MAPS',
  OssWeedSizeClassCombined = 'OSS_WEED_SIZE_CLASS_COMBINED',
  OssWeedSizeClassCompare = 'OSS_WEED_SIZE_CLASS_COMPARE',
  OssWeedSizeClassLarge = 'OSS_WEED_SIZE_CLASS_LARGE',
  OssWeedSizeClassMedium = 'OSS_WEED_SIZE_CLASS_MEDIUM',
  OssWeedSizeClassSmall = 'OSS_WEED_SIZE_CLASS_SMALL',
  PlanetScopeNdvi = 'PLANET_SCOPE_NDVI',
  PlanetScopeNdviAvg = 'PLANET_SCOPE_NDVI_AVG',
  /** @deprecated Use PLANET_SCOPE_WEED_PRESSURE instead. */
  PlanetScopeNdviWeedPressure = 'PLANET_SCOPE_NDVI_WEED_PRESSURE',
  PlanetScopeVisual = 'PLANET_SCOPE_VISUAL',
  PlanetScopeWeedPressure = 'PLANET_SCOPE_WEED_PRESSURE',
  /**  Refers to AgronomicIndexType.POWERZONE_DATA */
  Powerzone = 'POWERZONE',
  /**  Refers to AgronomicIndexType.RELATIVE_YIELD_POWERZONE_DATA */
  RelativeYieldPowerzone = 'RELATIVE_YIELD_POWERZONE',
  /** @deprecated Use SENTINEL_2_WEED_PRESSURE instead. */
  Sentinel_2NdviWeedPressure = 'SENTINEL_2_NDVI_WEED_PRESSURE',
  Sentinel_2Visual = 'SENTINEL_2_VISUAL',
  Sentinel_2WeedPressure = 'SENTINEL_2_WEED_PRESSURE',
  WzsGli = 'WZS_GLI',
  WzsNdre = 'WZS_NDRE',
  WzsNdvi = 'WZS_NDVI',
  WzsOrthomosaic = 'WZS_ORTHOMOSAIC',
  WzsPlantingFailure = 'WZS_PLANTING_FAILURE',
  /**  Drone vegetation-index rasters: one analytics family per index. */
  WzsSyntheticNdvi = 'WZS_SYNTHETIC_NDVI',
  WzsVarigreen = 'WZS_VARIGREEN',
  WzsWeedpressureAll = 'WZS_WEEDPRESSURE_ALL',
  WzsWeedpressureBroadleaf = 'WZS_WEEDPRESSURE_BROADLEAF',
  WzsWeedpressureGrassy = 'WZS_WEEDPRESSURE_GRASSY',
  WzsWeedpressureHigh = 'WZS_WEEDPRESSURE_HIGH',
  /**
   *  Weed Zone Spray layers
   *  Naming caveat: despite the name, WZS_WEEDPRESSURE_* layers are weed DETECTION masks
   *  (DRONE_WEED_DETECTION_SENSITIVITY_* assets), not weed pressure. Actual weed-pressure
   *  rasters are WZS_WEED_PRESSURE_* below. Rename to WZS_WEED_DETECTION_* is tracked in
   *  https://jira.digital-farming.com/browse/DFITE-57889 (depends on DFITE-57888).
   */
  WzsWeedpressureLow = 'WZS_WEEDPRESSURE_LOW',
  WzsWeedpressureMedium = 'WZS_WEEDPRESSURE_MEDIUM',
  /**  Drone weed-pressure raster families grouped by weed type. */
  WzsWeedPressureAll = 'WZS_WEED_PRESSURE_ALL',
  WzsWeedPressureBroadleaf = 'WZS_WEED_PRESSURE_BROADLEAF',
  WzsWeedPressureGrassy = 'WZS_WEED_PRESSURE_GRASSY'
}

export type StacHistogram = {
  __typename: 'StacHistogram';
  buckets: Array<Scalars['Int']['output']>;
  classBoundaries: Array<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type StacItemRender = {
  __typename: 'StacItemRender';
  cropSeason?: Maybe<CropSeasonV2>;
  datetime: Scalars['Date']['output'];
  field: FieldV2;
  fieldDataLayerType: StacFieldDataLayer;
  fullUuid?: Maybe<Scalars['String']['output']>;
  groupTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  index?: Maybe<AgronomicIndexType>;
  labelTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  legends: Array<StacLegend>;
  magnitudeType: StacMagnitudeType;
  md2Configuration?: Maybe<Md2VraAdvisorConfiguration>;
  selectionReasons?: Maybe<Array<Maybe<StacItemSelectionReason>>>;
  source?: Maybe<StacItemRenderSource>;
  sourceType?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  statistics?: Maybe<StacStatistics>;
  thumbnailUrl: Scalars['String']['output'];
  unitUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
  visUrl: Scalars['String']['output'];
};

/**  Resolved from sourceType/sourceUuid. Extend with other teams' source types as they adopt it. */
export type StacItemRenderSource = DroneFlight;

export enum StacItemSelectionReason {
  ChmAllDataRetrieved = 'CHM_ALL_DATA_RETRIEVED',
  /**  Fallback using a LAI map calculated on BPv4 when primary LAI data is not valid */
  ChmFallbackBiomassProxy = 'CHM_FALLBACK_BIOMASS_PROXY',
  /**  LAI data exists for CHM but exceeds the maximum age threshold */
  ChmFallbackBiomassProxyLai = 'CHM_FALLBACK_BIOMASS_PROXY_LAI',
  ChmFinalFallbackPowerzone = 'CHM_FINAL_FALLBACK_POWERZONE',
  /**  Valid recent LAI map is available (from Sentinel/Planet with age <=10 days) for CHM */
  ChmLaiOutdated = 'CHM_LAI_OUTDATED',
  /**  Fallback using the 3-zone Biomass Proxy map for CHM when neither primary nor BPv4 LAI is suitable */
  ChmNoSuitableData = 'CHM_NO_SUITABLE_DATA',
  /**  No valid image or LAI data could be found for CHM */
  ChmPowerzoneAvailable = 'CHM_POWERZONE_AVAILABLE',
  /**  Indicates the crop season is too early (e.g., up until 7 days post seeding) for CHM image selection */
  ChmPrimaryLaiAvailable = 'CHM_PRIMARY_LAI_AVAILABLE',
  /**
   *  All requested imagery data has been successfully retrieved
   *  -------------------------
   *  Crop Health Management (CHM) Status Codes
   *  -------------------------
   */
  ChmSeasonTooEarly = 'CHM_SEASON_TOO_EARLY',
  /**  All requested imagery data has been successfully retrieved */
  NmAllDataRetrieved = 'NM_ALL_DATA_RETRIEVED',
  /**  Fallback to a LAI map calculated on BPv4 using Nutrition Standard logic (applies during 7 days after seeding to BBCH 49 in NM) */
  NmFallbackBiomassProxy = 'NM_FALLBACK_BIOMASS_PROXY',
  /**  NM LAI data exists but is outdated based on the defined age thresholds */
  NmFallbackBiomassProxyLai = 'NM_FALLBACK_BIOMASS_PROXY_LAI',
  /**  Fallback using the Biomass Proxy map with Nutrition Standard logic (e.g., after BBCH 49 in NM) */
  NmFinalFallbackPowerzone = 'NM_FINAL_FALLBACK_POWERZONE',
  /**
   *  Valid LAI map with enhanced Nutrition Advisor logic is available for NM
   *  (e.g., within 10 days after seeding or within 20 days after BBCH 49 as applicable)
   */
  NmLaiOutdated = 'NM_LAI_OUTDATED',
  NmNoSuitableData = 'NM_NO_SUITABLE_DATA',
  /**  For early growth stages (up until 7 days post seeding), a Powerzone map is available for NM */
  NmPrimaryLaiAvailable = 'NM_PRIMARY_LAI_AVAILABLE',
  /**
   *  -------------------------
   *  Nutrition Management (NM) Status Codes
   *  -------------------------
   */
  NmStarterFertilizerPowerzoneAvailable = 'NM_STARTER_FERTILIZER_POWERZONE_AVAILABLE',
  SmAllDataRetrieved = 'SM_ALL_DATA_RETRIEVED',
  /**
   *  No valid data was found for Nutrition Management
   *  -------------------------
   *  Seeding Management (SM) Status Codes
   *  -------------------------
   */
  SmNoSuitableData = 'SM_NO_SUITABLE_DATA',
  /**  No valid data was found for Seeding Management */
  SmPowerzoneAvailable = 'SM_POWERZONE_AVAILABLE',
  /**
   *  All requested imagery data has been successfully retrieved
   *  -------------------------
   *  Weed Management (WM) Status Codes
   *  -------------------------
   */
  WmAllDataRetrieved = 'WM_ALL_DATA_RETRIEVED',
  /**  Weed-pressure candidate maps were found; the most recent flight is marked as default */
  WmNoSuitableData = 'WM_NO_SUITABLE_DATA'
}

export type StacItemVectorizeGeometry = {
  __typename: 'StacItemVectorizeGeometry';
  acquisitionDate?: Maybe<Scalars['Date']['output']>;
  centerZoneId?: Maybe<Scalars['Int']['output']>;
  /**  Finite class breaks applied during vectorization; internal open-tail padding is never exposed. */
  customBreaks?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  geometry: Scalars['JSONObject']['output'];
  index: AgronomicIndexType;
  medianZoneId?: Maybe<Scalars['Int']['output']>;
  numberOfZones?: Maybe<Scalars['Int']['output']>;
  /**
   *  Recommended application rates per zone.
   *  Provided for the powerzone seeding recommendation flow (index RELATIVE_YIELD_POWERZONE_DATA).
   */
  recommendedRates?: Maybe<Array<Maybe<RecommendedRate>>>;
  stacItemUuid: Scalars['UUID']['output'];
  zonePercentageDifferences?: Maybe<Array<Maybe<ZonePercentageDifference>>>;
  zoneStatistics?: Maybe<Array<Maybe<ZoneStatisticsItem>>>;
};

export type StacLegend = {
  __typename: 'StacLegend';
  color: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  translationId: Scalars['String']['output'];
};

export enum StacMagnitudeType {
  BiomassCompare = 'BIOMASS_COMPARE',
  BiomassContrast = 'BIOMASS_CONTRAST',
  BiomassProxyCompare = 'BIOMASS_PROXY_COMPARE',
  BiomassProxyContrast = 'BIOMASS_PROXY_CONTRAST',
  BiomassProxyLaiCompare = 'BIOMASS_PROXY_LAI_COMPARE',
  BiomassProxyLaiContrast = 'BIOMASS_PROXY_LAI_CONTRAST',
  /** @deprecated Use OSS_CROP_COVERAGE_COMPARE instead. This will be removed in future releases. */
  CropCoverage = 'CROP_COVERAGE',
  CustomPowerzoneCompare = 'CUSTOM_POWERZONE_COMPARE',
  NematodePowerzoneCompare = 'NEMATODE_POWERZONE_COMPARE',
  NematodePowerzoneContrast = 'NEMATODE_POWERZONE_CONTRAST',
  OssCropCoverageCompare = 'OSS_CROP_COVERAGE_COMPARE',
  OssCropCoverageContrast = 'OSS_CROP_COVERAGE_CONTRAST',
  OssWeedCoverageCompare = 'OSS_WEED_COVERAGE_COMPARE',
  OssWeedCoverageContrast = 'OSS_WEED_COVERAGE_CONTRAST',
  OssWeedPressureIndex = 'OSS_WEED_PRESSURE_INDEX',
  OssWeedSizeClassCombinedCompare = 'OSS_WEED_SIZE_CLASS_COMBINED_COMPARE',
  OssWeedSizeClassCombinedContrast = 'OSS_WEED_SIZE_CLASS_COMBINED_CONTRAST',
  OssWeedSizeClassLargeCompare = 'OSS_WEED_SIZE_CLASS_LARGE_COMPARE',
  OssWeedSizeClassLargeContrast = 'OSS_WEED_SIZE_CLASS_LARGE_CONTRAST',
  OssWeedSizeClassMediumCompare = 'OSS_WEED_SIZE_CLASS_MEDIUM_COMPARE',
  OssWeedSizeClassMediumContrast = 'OSS_WEED_SIZE_CLASS_MEDIUM_CONTRAST',
  OssWeedSizeClassSmallCompare = 'OSS_WEED_SIZE_CLASS_SMALL_COMPARE',
  OssWeedSizeClassSmallContrast = 'OSS_WEED_SIZE_CLASS_SMALL_CONTRAST',
  PlanetScopeNdvi = 'PLANET_SCOPE_NDVI',
  PlanetScopeNdviCompare = 'PLANET_SCOPE_NDVI_COMPARE',
  PlanetScopeNdviContrast = 'PLANET_SCOPE_NDVI_CONTRAST',
  /** @deprecated Use PLANET_SCOPE_WEED_PRESSURE instead. */
  PlanetScopeNdviWeedPressure = 'PLANET_SCOPE_NDVI_WEED_PRESSURE',
  PlanetScopeVisual = 'PLANET_SCOPE_VISUAL',
  PlanetScopeWeedPressure = 'PLANET_SCOPE_WEED_PRESSURE',
  PowerzoneCompare = 'POWERZONE_COMPARE',
  PowerzoneContrast = 'POWERZONE_CONTRAST',
  RelativeYieldPowerzoneCompare = 'RELATIVE_YIELD_POWERZONE_COMPARE',
  RelativeYieldPowerzoneContrast = 'RELATIVE_YIELD_POWERZONE_CONTRAST',
  Sentinel_2BiomassCompare = 'SENTINEL_2_BIOMASS_COMPARE',
  Sentinel_2BiomassContrast = 'SENTINEL_2_BIOMASS_CONTRAST',
  /** @deprecated Use SENTINEL_2_WEED_PRESSURE instead. */
  Sentinel_2NdviWeedPressure = 'SENTINEL_2_NDVI_WEED_PRESSURE',
  Sentinel_2Visual = 'SENTINEL_2_VISUAL',
  Sentinel_2WeedPressure = 'SENTINEL_2_WEED_PRESSURE',
  /**
   *  ONE_SMART_SPRAY magnitudes
   * @deprecated Use OSS_WEED_COVERAGE_COMPARE instead. This will be removed in future releases.
   */
  WeedCoverage = 'WEED_COVERAGE',
  /** @deprecated Use OSS_WEED_SIZE_CLASS_COMBINED_COMPARE instead. This will be removed in future releases. */
  WeedSizeClassCombined = 'WEED_SIZE_CLASS_COMBINED',
  /** @deprecated Use OSS_WEED_SIZE_CLASS_LARGE_COMPARE instead. This will be removed in future releases. */
  WeedSizeClassLarge = 'WEED_SIZE_CLASS_LARGE',
  /** @deprecated Use OSS_WEED_SIZE_CLASS_MEDIUM_COMPARE instead. This will be removed in future releases. */
  WeedSizeClassMedium = 'WEED_SIZE_CLASS_MEDIUM',
  /** @deprecated Use OSS_WEED_SIZE_CLASS_SMALL_COMPARE instead. This will be removed in future releases. */
  WeedSizeClassSmall = 'WEED_SIZE_CLASS_SMALL',
  WzsGliEqualInterval = 'WZS_GLI_EQUAL_INTERVAL',
  WzsGliNaturalBreaks = 'WZS_GLI_NATURAL_BREAKS',
  WzsNdreEqualInterval = 'WZS_NDRE_EQUAL_INTERVAL',
  WzsNdreNaturalBreaks = 'WZS_NDRE_NATURAL_BREAKS',
  WzsNdviEqualInterval = 'WZS_NDVI_EQUAL_INTERVAL',
  WzsNdviNaturalBreaks = 'WZS_NDVI_NATURAL_BREAKS',
  WzsOrthomosaicRaw = 'WZS_ORTHOMOSAIC_RAW',
  WzsPlantingFailure_50Cm = 'WZS_PLANTING_FAILURE_50_CM',
  WzsPlantingFailure_100Cm = 'WZS_PLANTING_FAILURE_100_CM',
  /**  Drone vegetation-index rasters: equal-interval and natural-breaks renders per index. */
  WzsSyntheticNdviEqualInterval = 'WZS_SYNTHETIC_NDVI_EQUAL_INTERVAL',
  WzsSyntheticNdviNaturalBreaks = 'WZS_SYNTHETIC_NDVI_NATURAL_BREAKS',
  WzsVarigreenEqualInterval = 'WZS_VARIGREEN_EQUAL_INTERVAL',
  WzsVarigreenNaturalBreaks = 'WZS_VARIGREEN_NATURAL_BREAKS',
  WzsWeedpressureHighAll = 'WZS_WEEDPRESSURE_HIGH_ALL',
  WzsWeedpressureHighBroadleaf = 'WZS_WEEDPRESSURE_HIGH_BROADLEAF',
  WzsWeedpressureHighGrassy = 'WZS_WEEDPRESSURE_HIGH_GRASSY',
  /**
   *  Naming caveat: despite the name, WZS_WEEDPRESSURE_<SENSITIVITY>_<WEED_TYPE> values render
   *  weed DETECTION masks (DRONE_WEED_DETECTION_SENSITIVITY_* assets), not weed pressure. Actual
   *  weed-pressure renders are WZS_WEED_PRESSURE_* below. Rename to WZS_WEED_DETECTION_* is tracked in
   *  https://jira.digital-farming.com/browse/DFITE-57889 (depends on DFITE-57888).
   */
  WzsWeedpressureLowAll = 'WZS_WEEDPRESSURE_LOW_ALL',
  WzsWeedpressureLowBroadleaf = 'WZS_WEEDPRESSURE_LOW_BROADLEAF',
  WzsWeedpressureLowGrassy = 'WZS_WEEDPRESSURE_LOW_GRASSY',
  WzsWeedpressureMediumAll = 'WZS_WEEDPRESSURE_MEDIUM_ALL',
  WzsWeedpressureMediumBroadleaf = 'WZS_WEEDPRESSURE_MEDIUM_BROADLEAF',
  WzsWeedpressureMediumGrassy = 'WZS_WEEDPRESSURE_MEDIUM_GRASSY',
  WzsWeedPressureAllHighSensitivity = 'WZS_WEED_PRESSURE_ALL_HIGH_SENSITIVITY',
  /**  Drone weed-pressure raster magnitudes: weed type (ALL|GRASSY|BROADLEAF) x sensitivity (LOW|MEDIUM|HIGH). */
  WzsWeedPressureAllLowSensitivity = 'WZS_WEED_PRESSURE_ALL_LOW_SENSITIVITY',
  WzsWeedPressureAllMediumSensitivity = 'WZS_WEED_PRESSURE_ALL_MEDIUM_SENSITIVITY',
  WzsWeedPressureBroadleafHighSensitivity = 'WZS_WEED_PRESSURE_BROADLEAF_HIGH_SENSITIVITY',
  WzsWeedPressureBroadleafLowSensitivity = 'WZS_WEED_PRESSURE_BROADLEAF_LOW_SENSITIVITY',
  WzsWeedPressureBroadleafMediumSensitivity = 'WZS_WEED_PRESSURE_BROADLEAF_MEDIUM_SENSITIVITY',
  WzsWeedPressureGrassyHighSensitivity = 'WZS_WEED_PRESSURE_GRASSY_HIGH_SENSITIVITY',
  WzsWeedPressureGrassyLowSensitivity = 'WZS_WEED_PRESSURE_GRASSY_LOW_SENSITIVITY',
  WzsWeedPressureGrassyMediumSensitivity = 'WZS_WEED_PRESSURE_GRASSY_MEDIUM_SENSITIVITY'
}

export type StacMosaicRender = {
  __typename: 'StacMosaicRender';
  availableRenderingTypes: Array<Maybe<RenderingType>>;
  fieldDataLayerType: StacFieldDataLayer;
  fromDate: Scalars['Date']['output'];
  legends: Array<StacLegend>;
  magnitudeType: StacMagnitudeType;
  renderingType: RenderingType;
  thumbnailUrl: Scalars['String']['output'];
  tillDate: Scalars['Date']['output'];
  unitUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['String']['output'];
  visUrl: Scalars['String']['output'];
};

export type StacStatistics = {
  __typename: 'StacStatistics';
  histogram?: Maybe<StacHistogram>;
  max: Scalars['Float']['output'];
  mean: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  stddev: Scalars['Float']['output'];
};

export type Statistic = {
  __typename: 'Statistic';
  totalFailureLength?: Maybe<Scalars['Float']['output']>;
  totalFailureRatio?: Maybe<Scalars['Float']['output']>;
  totalRowLength?: Maybe<Scalars['Float']['output']>;
};

export enum Status {
  Accepted = 'ACCEPTED',
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  TechnicalFailure = 'TECHNICAL_FAILURE'
}

export type StirObject = {
  __typename: 'StirObject';
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  fmObjectType: Scalars['String']['output'];
  fmObjectUuid: Scalars['UUID']['output'];
  lastModifierId?: Maybe<Scalars['String']['output']>;
  stirOperation?: Maybe<StirOperation>;
  uuid: Scalars['UUID']['output'];
};

export type StirOperation = {
  __typename: 'StirOperation';
  name: Scalars['String']['output'];
  stirValue?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum StirTaskType {
  CropEstablishment = 'CROP_ESTABLISHMENT',
  CropProtection = 'CROP_PROTECTION',
  Harvest = 'HARVEST',
  LandPreparation = 'LAND_PREPARATION',
  NutritionManagement = 'NUTRITION_MANAGEMENT',
  WaterManagement = 'WATER_MANAGEMENT'
}

export enum Strategy {
  Always = 'ALWAYS',
  Balanced = 'BALANCED',
  CustomThreshold = 'CUSTOM_THRESHOLD',
  Efficacy = 'EFFICACY',
  LargeWeeds = 'LARGE_WEEDS',
  Never = 'NEVER',
  Savings = 'SAVINGS',
  Terminal1 = 'TERMINAL1',
  Terminal2 = 'TERMINAL2',
  Terminal3 = 'TERMINAL3',
  Terminal4 = 'TERMINAL4',
  Terminal5 = 'TERMINAL5',
  Terminal6 = 'TERMINAL6',
  Terminal7 = 'TERMINAL7',
  Terminal8 = 'TERMINAL8',
  Terminal9 = 'TERMINAL9',
  Terminal10 = 'TERMINAL10',
  Terminal11 = 'TERMINAL11',
  Terminal12 = 'TERMINAL12',
  Terminal13 = 'TERMINAL13',
  Terminal14 = 'TERMINAL14',
  Terminal15 = 'TERMINAL15'
}

export type Stress = {
  __typename: 'Stress';
  eppocode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scientificName?: Maybe<Scalars['String']['output']>;
  stressType?: Maybe<Scalars['String']['output']>;
  stressTypeUuid?: Maybe<Scalars['UUID']['output']>;
  taxonomyUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type StressAnswer = {
  __typename: 'StressAnswer';
  imageUrl?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  stressQuestion: StressQuestion;
  uuid: Scalars['UUID']['output'];
};


export type StressAnswerStressQuestionArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};

export type StressEfficacyCharacteristics = {
  __typename: 'StressEfficacyCharacteristics';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  calculationMode?: Maybe<CalculationMode>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  endDateTransplant?: Maybe<Scalars['Date']['output']>;
  format?: Maybe<TimeFormat>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  isStressDeclared?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProductV2>;
  protectionEndDate?: Maybe<Scalars['Date']['output']>;
  protectionLevel?: Maybe<ProtectionLevel>;
  protectionPercentage?: Maybe<Scalars['Float']['output']>;
  protectionStartDate?: Maybe<Scalars['Date']['output']>;
  protectionType?: Maybe<ProtectionType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startDateTransplant?: Maybe<Scalars['Date']['output']>;
  stresses?: Maybe<Array<Maybe<StressV2>>>;
  /** @deprecated Use `taskUuids` */
  taskUuid?: Maybe<Scalars['UUID']['output']>;
  taskUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
};


export type StressEfficacyCharacteristicsStressesArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type StressQuestion = {
  __typename: 'StressQuestion';
  crop?: Maybe<Crop>;
  expertQuestion?: Maybe<Scalars['Boolean']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `stressV2` */
  stress: Stress;
  stressAnswers?: Maybe<Array<Maybe<StressAnswer>>>;
  stressV2: StressV2;
  uuid: Scalars['UUID']['output'];
};


export type StressQuestionStressArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type StressQuestionStressAnswersArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type StressQuestionStressV2Args = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type StressRisk = {
  __typename: 'StressRisk';
  beforeSeasonRisk?: Maybe<StressRiskValue>;
  date?: Maybe<Scalars['Date']['output']>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum StressRiskValue {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type StressSetting = {
  __typename: 'StressSetting';
  cautionLevel?: Maybe<CautionLevel>;
  isPresent?: Maybe<Scalars['Boolean']['output']>;
  stressUuid: Scalars['String']['output'];
};

export type StressSettings = {
  __typename: 'StressSettings';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason: CropSeasonV2;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  settings: Array<Maybe<StressSetting>>;
  uuid: Scalars['UUID']['output'];
};

export type StressV2 = {
  __typename: 'StressV2';
  code?: Maybe<Scalars['String']['output']>;
  cotyledonCode?: Maybe<Scalars['String']['output']>;
  cotyledonName?: Maybe<Scalars['String']['output']>;
  cotyledonUuid?: Maybe<Scalars['UUID']['output']>;
  descriptionAndSymptoms?: Maybe<Array<Maybe<DescriptionAndSymptom>>>;
  name?: Maybe<Scalars['String']['output']>;
  parentStressCode?: Maybe<Scalars['String']['output']>;
  parentStressName?: Maybe<Scalars['String']['output']>;
  parentStressUuid?: Maybe<Scalars['UUID']['output']>;
  scientificName?: Maybe<Scalars['String']['output']>;
  stressTypeCode?: Maybe<Scalars['String']['output']>;
  stressTypeCodeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  stressTypeName?: Maybe<Scalars['String']['output']>;
  stressTypeUuid?: Maybe<Scalars['UUID']['output']>;
  taxonomyCode?: Maybe<Scalars['String']['output']>;
  taxonomyCodeTranslationId?: Maybe<Scalars['TranslationId']['output']>;
  taxonomyName?: Maybe<Scalars['String']['output']>;
  taxonomyUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};


export type StressV2DescriptionAndSymptomsArgs = {
  cropUuid?: InputMaybe<Scalars['UUID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

/**  DFITE-58283 — GraphQL subscription notify (minimal payload; client refetches queries) */
export type Subscription = {
  __typename: 'Subscription';
  /**
   * Emits when growth-stage-service publishes a calculation event for a crop season
   * in the given set. Max 300 UUIDs; list must be non-empty. Subscribe-time visibility
   * is enforced via farm-service (per UUID; not limited to one farm).
   * Working transport: POST /data/sse with JSON variables.cropSeasonUuids
   * (the query document is not executed). Do not use graphql-ws / WebSocket on /data.
   * Native GraphQL SSE requires a Boot / spring-graphql upgrade (DFITE-59442).
   */
  growthStagePredictionCalculated: GrowthStagePredictionCalculatedPayload;
};


/**  DFITE-58283 — GraphQL subscription notify (minimal payload; client refetches queries) */
export type SubscriptionGrowthStagePredictionCalculatedArgs = {
  cropSeasonUuids: Array<Scalars['UUID']['input']>;
};

export type SubscriptionPreference = {
  __typename: 'SubscriptionPreference';
  etag?: Maybe<Scalars['String']['output']>;
  farms?: Maybe<Array<Maybe<SubscriptionPreferenceFarm>>>;
  globalCategories?: Maybe<Array<Maybe<SubscriptionPreferenceCategory>>>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum SubscriptionPreferenceCategory {
  ApplicationRecommendation = 'APPLICATION_RECOMMENDATION',
  BiomassAndPowerzone = 'BIOMASS_AND_POWERZONE',
  DroneFlight = 'DRONE_FLIGHT',
  Farm = 'FARM',
  GrowthStageAdvanced = 'GROWTH_STAGE_ADVANCED',
  GrowthStageReached = 'GROWTH_STAGE_REACHED',
  HarvestTimer = 'HARVEST_TIMER',
  Information = 'INFORMATION',
  Stress = 'STRESS',
  Task = 'TASK'
}

export type SubscriptionPreferenceFarm = {
  __typename: 'SubscriptionPreferenceFarm';
  categories?: Maybe<Array<Maybe<SubscriptionPreferenceCategory>>>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
};

export enum SubscriptionStatus {
  NotSubscribed = 'NOT_SUBSCRIBED',
  OutOfSeason = 'OUT_OF_SEASON',
  Subscribed = 'SUBSCRIBED',
  TooSmall = 'TOO_SMALL',
  Unsupported = 'UNSUPPORTED'
}

export type SubstanceApplicationRate = {
  __typename: 'SubstanceApplicationRate';
  averageApplicationRate?: Maybe<Scalars['Float']['output']>;
  dilutionFactor?: Maybe<Scalars['Float']['output']>;
  formulation?: Maybe<Formulation>;
  liquid?: Maybe<Scalars['Boolean']['output']>;
  localUnitUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  ratesByZone?: Maybe<Array<Maybe<RateByZone>>>;
  ratesPerZone?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  totalApplication?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<SubstanceType>;
  typeIconName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<RateUnit>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  volumeBasisLocalUnitUuid?: Maybe<Scalars['UUID']['output']>;
  volumeBasisRate?: Maybe<Scalars['Float']['output']>;
};

export type SubstanceRateV2 = {
  __typename: 'SubstanceRateV2';
  dilutionFactor?: Maybe<Scalars['Float']['output']>;
  localUnitUuid?: Maybe<Scalars['UUID']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  substanceUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<SubstanceType>;
  unit?: Maybe<RateUnit>;
  volumeBasisLocalUnitUuid?: Maybe<Scalars['UUID']['output']>;
  volumeBasisRate?: Maybe<Scalars['Float']['output']>;
};

export enum SubstanceType {
  Additive = 'ADDITIVE',
  Product = 'PRODUCT',
  Variety = 'VARIETY',
  Water = 'WATER'
}

export type SupportedTaskType = {
  __typename: 'SupportedTaskType';
  code?: Maybe<TaskTypeCode>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum SustainabilityAdjudicator {
  Automatic = 'AUTOMATIC',
  CarbonAdmin = 'CARBON_ADMIN',
  Organisation = 'ORGANISATION'
}

export type SustainabilityIndicator = {
  __typename: 'SustainabilityIndicator';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  co2EquivalentFootprint?: Maybe<Footprint>;
  cropSeason?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  nitrogenFootprint?: Maybe<Footprint>;
  waterFootprint?: Maybe<Footprint>;
};

export type SustainabilityInput = {
  __typename: 'SustainabilityInput';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  /** @deprecated not needed, to be removed */
  fuelConsumptionPerArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated not needed, to be removed */
  harvestPriceMain?: Maybe<Scalars['Float']['output']>;
  /** @deprecated not needed, to be removed */
  harvestPriceOther?: Maybe<Scalars['Float']['output']>;
  /** @deprecated not needed, to be removed */
  hasCoverCrops?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasFlowerStrips?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasGrassBufferStrips?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasOrganicFertilizers?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasReducedCropInputs?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasReducedTillage?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasStrawBeenRemoved?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasStubblesLeft?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasUncultivatedMargins?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasUndersownCereals?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasUndrilledMargins?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasUndrilledPatches?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  hasUnsprayedHeadlands?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  irrigationEnergySource?: Maybe<IrrigationEnergySource>;
  irrigationEnergySourceTranslationId?: Maybe<Scalars['String']['output']>;
  isBiofuelUsageAboveCutoff?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  isDrainageSystemUsed?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  isNitrificationInhibitorUsed?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not needed, to be removed */
  isUreaseInhibitorUsed?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  /** @deprecated not needed, to be removed */
  mineralNitrogenPerArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated not needed, to be removed */
  organicFertilizersTotalNitrogenPerArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated not needed, to be removed */
  organicFertilizersTotalPhosphorPerArea?: Maybe<Scalars['Float']['output']>;
  /** @deprecated not needed, to be removed */
  soilPH?: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SustainabilityOrganisationCapability = BaseEntityAuditingType & {
  __typename: 'SustainabilityOrganisationCapability';
  adjudicator?: Maybe<SustainabilityAdjudicator>;
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  capability?: Maybe<SustainabilityOrganisationCapabilityType>;
  createdAt: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['Date']['output']>;
  declinedBy?: Maybe<Scalars['String']['output']>;
  declinedReason?: Maybe<Scalars['String']['output']>;
  etag: Scalars['String']['output'];
  lastModifiedAt: Scalars['String']['output'];
  lastModifierId?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  organisationUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type SustainabilityOrganisationCapabilitySort = {
  column: SustainabilityOrganisationCapabilitySortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SustainabilityOrganisationCapabilitySortColumn {
  ApprovedAt = 'APPROVED_AT',
  Capability = 'CAPABILITY',
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  DeclinedAt = 'DECLINED_AT',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  OrganisationUuid = 'ORGANISATION_UUID'
}

export enum SustainabilityOrganisationCapabilityType {
  Agronomist = 'AGRONOMIST',
  Custody = 'CUSTODY',
  FirstPointOfAggregation = 'FIRST_POINT_OF_AGGREGATION',
  Processing = 'PROCESSING',
  ProgramOwner = 'PROGRAM_OWNER',
  Section_45ZClaimant = 'SECTION_45Z_CLAIMANT',
  Verifier = 'VERIFIER'
}

export type SustainabilityProgram = BaseEntityAuditingType & {
  __typename: 'SustainabilityProgram';
  allocationOrder?: Maybe<SustainabilityProgramAllocationOrder>;
  annualDataEntryClosesAt?: Maybe<Scalars['String']['output']>;
  applicableFirstInterventionYears?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  certificationScheme?: Maybe<SustainabilityProgramCertificationScheme>;
  ciLimit?: Maybe<Scalars['Float']['output']>;
  claimTarget45z?: Maybe<Scalars['Boolean']['output']>;
  claimTargetLcfs?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  crops?: Maybe<Array<Maybe<Crop>>>;
  deliveryWindowEnd?: Maybe<Scalars['Date']['output']>;
  deliveryWindowStart?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentationDueDate?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `endDate`. */
  endYear?: Maybe<Scalars['Int']['output']>;
  enrolmentEndDate?: Maybe<Scalars['Date']['output']>;
  enrolmentStartDate?: Maybe<Scalars['Date']['output']>;
  escalationContact?: Maybe<EscalationContact>;
  etag?: Maybe<Scalars['String']['output']>;
  harvestYear?: Maybe<Scalars['Int']['output']>;
  joinCode?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  measureSubmissionOrders?: Maybe<Array<Maybe<MeasureSubmissionOrder>>>;
  name?: Maybe<Scalars['String']['output']>;
  organisationUuid?: Maybe<Scalars['UUID']['output']>;
  premiumBands?: Maybe<Array<Maybe<PremiumBand>>>;
  protocol?: Maybe<SustainabilityProgramProtocol>;
  startDate: Scalars['Date']['output'];
  /** @deprecated Use `startDate`. */
  startYear: Scalars['Int']['output'];
  status?: Maybe<SustainabilityProgramStatus>;
  strategy?: Maybe<SustainabilityProgramStrategy>;
  supplyChainPartnerUuid?: Maybe<Scalars['UUID']['output']>;
  targetWeightedCi?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<SustainabilityProgramType>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  visibilityMode?: Maybe<SustainabilityProgramVisibilityMode>;
  volumeCap?: Maybe<Scalars['Float']['output']>;
  volumeTarget?: Maybe<Scalars['Float']['output']>;
};

export enum SustainabilityProgramAllocationOrder {
  HighestCiClearingLimit = 'HIGHEST_CI_CLEARING_LIMIT',
  LowestCiFirst = 'LOWEST_CI_FIRST'
}

export type SustainabilityProgramBranchAssignment = BaseEntityAuditingType & {
  __typename: 'SustainabilityProgramBranchAssignment';
  branchAddress?: Maybe<Address>;
  branchName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  isFPA: Scalars['Boolean']['output'];
  isPlant: Scalars['Boolean']['output'];
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  organisationAddress?: Maybe<Address>;
  organisationBranch?: Maybe<OrganisationBranch>;
  organisationName?: Maybe<Scalars['String']['output']>;
  sustainabilityProgram?: Maybe<SustainabilityProgram>;
  uuid: Scalars['UUID']['output'];
};

export type SustainabilityProgramBranchAssignmentSort = {
  column: SustainabilityProgramBranchAssignmentSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SustainabilityProgramBranchAssignmentSortColumn {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  IsFpa = 'IS_FPA',
  IsPlant = 'IS_PLANT',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  OrganizationBranchUuid = 'ORGANIZATION_BRANCH_UUID',
  SustainabilityProgramUuid = 'SUSTAINABILITY_PROGRAM_UUID'
}

export enum SustainabilityProgramCertificationScheme {
  IsccEu = 'ISCC_EU',
  IsccPlus = 'ISCC_PLUS',
  RedcertEu = 'REDCERT_EU',
  Uncertified = 'UNCERTIFIED'
}

export type SustainabilityProgramEnrolledField = {
  __typename: 'SustainabilityProgramEnrolledField';
  carbonFarmingSeasonUuid: Scalars['UUID']['output'];
  farmName?: Maybe<Scalars['String']['output']>;
  farmUuid: Scalars['UUID']['output'];
  fieldName?: Maybe<Scalars['String']['output']>;
  fieldUuid: Scalars['UUID']['output'];
};

export type SustainabilityProgramEnrolledSort = {
  column: SustainabilityProgramEnrolledSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SustainabilityProgramEnrolledSortColumn {
  CarbonFarmingSeasonUuid = 'CARBON_FARMING_SEASON_UUID',
  FarmName = 'FARM_NAME',
  FarmUuid = 'FARM_UUID',
  FieldName = 'FIELD_NAME',
  FieldUuid = 'FIELD_UUID'
}

export type SustainabilityProgramInvitation = BaseEntityAuditingType & {
  __typename: 'SustainabilityProgramInvitation';
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  inviteeEmail?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['Date']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  sustainabilityProgram?: Maybe<SustainabilityProgram>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type SustainabilityProgramInvitationSort = {
  column: SustainabilityProgramInvitationSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SustainabilityProgramInvitationSortColumn {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  InviteeEmail = 'INVITEE_EMAIL',
  JoinedAt = 'JOINED_AT',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  SustainabilityProgramUuid = 'SUSTAINABILITY_PROGRAM_UUID',
  Uuid = 'UUID'
}

export type SustainabilityProgramNamedRef = {
  __typename: 'SustainabilityProgramNamedRef';
  claimTarget45z?: Maybe<Scalars['Boolean']['output']>;
  claimTargetLcfs?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organisationName: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type SustainabilityProgramOrganisationParticipation = BaseEntityAuditingType & {
  __typename: 'SustainabilityProgramOrganisationParticipation';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  branchAddress?: Maybe<Address>;
  branchName?: Maybe<Scalars['String']['output']>;
  branchUuid?: Maybe<Scalars['UUID']['output']>;
  capability?: Maybe<SustainabilityOrganisationCapabilityType>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['Date']['output']>;
  declinedBy?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  organisationAddress?: Maybe<Address>;
  organisationName?: Maybe<Scalars['String']['output']>;
  partnerOrganisationUuid?: Maybe<Scalars['UUID']['output']>;
  programOrganisationUuid?: Maybe<Scalars['UUID']['output']>;
  status?: Maybe<SustainabilityProgramOrganisationParticipationStatus>;
  sustainabilityProgramUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  withdrawnAt?: Maybe<Scalars['Date']['output']>;
  withdrawnBy?: Maybe<Scalars['String']['output']>;
};

export type SustainabilityProgramOrganisationParticipationSort = {
  column: SustainabilityProgramOrganisationParticipationSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SustainabilityProgramOrganisationParticipationSortColumn {
  ApprovedAt = 'APPROVED_AT',
  Capability = 'CAPABILITY',
  DeclinedAt = 'DECLINED_AT',
  PartnerOrganisationUuid = 'PARTNER_ORGANISATION_UUID',
  ProgramOrganisationUuid = 'PROGRAM_ORGANISATION_UUID',
  Status = 'STATUS',
  SustainabilityProgramUuid = 'SUSTAINABILITY_PROGRAM_UUID',
  WithdrawnAt = 'WITHDRAWN_AT'
}

export enum SustainabilityProgramOrganisationParticipationStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Withdrawn = 'WITHDRAWN'
}

export enum SustainabilityProgramProtocol {
  GeneralScope_3 = 'GENERAL_SCOPE_3',
  Sep = 'SEP',
  Vm0042 = 'VM0042',
  Vm0051 = 'VM0051'
}

export type SustainabilityProgramSort = {
  column: SustainabilityProgramSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum SustainabilityProgramSortColumn {
  CreatedAt = 'CREATED_AT',
  CreatorId = 'CREATOR_ID',
  DocumentationDueDate = 'DOCUMENTATION_DUE_DATE',
  EnrolmentEndDate = 'ENROLMENT_END_DATE',
  EnrolmentStartDate = 'ENROLMENT_START_DATE',
  HarvestYear = 'HARVEST_YEAR',
  LastModifiedAt = 'LAST_MODIFIED_AT',
  LastModifierId = 'LAST_MODIFIER_ID',
  Name = 'NAME',
  Status = 'STATUS'
}

export type SustainabilityProgramStaffMember = BaseEntityAuditingType & {
  __typename: 'SustainabilityProgramStaffMember';
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  role: SustainabilityProgramStaffMemberRole;
  sustainabilityProgram?: Maybe<SustainabilityProgram>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
};

export enum SustainabilityProgramStaffMemberRole {
  ProgramManager = 'PROGRAM_MANAGER'
}

export enum SustainabilityProgramStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum SustainabilityProgramStrategy {
  Insetting = 'INSETTING',
  Offsetting = 'OFFSETTING'
}

export enum SustainabilityProgramType {
  BarillaSustainabilityDurum = 'BARILLA_SUSTAINABILITY_DURUM',
  CarbonFarming = 'CARBON_FARMING',
  CarbonIntensity = 'CARBON_INTENSITY',
  PeroniSustainabilitySpringBarley = 'PERONI_SUSTAINABILITY_SPRING_BARLEY'
}

export enum SustainabilityProgramVisibilityMode {
  Anyone = 'ANYONE',
  InviteOnly = 'INVITE_ONLY'
}

export type TDiskAssignment = {
  __typename: 'TDiskAssignment';
  creatorId?: Maybe<Scalars['String']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  tDiskOperation?: Maybe<TDiskOperation>;
  taskType: TDiskTaskType;
  taskUuid: Scalars['UUID']['output'];
  uuid: Scalars['UUID']['output'];
};

export type TDiskOperation = {
  __typename: 'TDiskOperation';
  name: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export enum TDiskTaskType {
  CropEstablishment = 'CROP_ESTABLISHMENT',
  Harvest = 'HARVEST',
  LandPreparation = 'LAND_PREPARATION',
  Spraying = 'SPRAYING'
}

export type TargetWeed = {
  __typename: 'TargetWeed';
  resistanceUuids?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  resistances?: Maybe<Array<Maybe<TargetWeedResistance>>>;
  taxonomicRank?: Maybe<TaxonomicRank>;
  uuid: Scalars['UUID']['output'];
  weight?: Maybe<TargetWeedWeight>;
};

export enum TargetWeedResistance {
  Accase = 'ACCASE',
  Als = 'ALS',
  Auxin = 'AUXIN',
  Carotene = 'CAROTENE',
  CellDivisionAboveGround = 'CELL_DIVISION_ABOVE_GROUND',
  CellDivisionRoot = 'CELL_DIVISION_ROOT',
  Epsps = 'EPSPS',
  Glutamine = 'GLUTAMINE',
  InhibitionOfDoxpSynthase = 'INHIBITION_OF_DOXP_SYNTHASE',
  Protox = 'PROTOX',
  Psi = 'PSI',
  Psii = 'PSII',
  SynthesisOfCarotenoids = 'SYNTHESIS_OF_CAROTENOIDS'
}

export enum TargetWeedWeight {
  High = 'HIGH',
  Medium = 'MEDIUM'
}

export type Task = {
  __typename: 'Task';
  type?: Maybe<TaskAggregationType>;
  uuid: Scalars['UUID']['output'];
};

export type TaskAggregation = {
  __typename: 'TaskAggregation';
  cropSeason?: Maybe<CropSeasonV2>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  uuid: Scalars['UUID']['output'];
};

export enum TaskAggregationType {
  CropEstablishment = 'CROP_ESTABLISHMENT',
  CropResidueManagementTask = 'CROP_RESIDUE_MANAGEMENT_TASK',
  Harvest = 'HARVEST',
  LandPreparation = 'LAND_PREPARATION',
  SeedTreatment = 'SEED_TREATMENT',
  Spraying = 'SPRAYING',
  WaterManagement = 'WATER_MANAGEMENT'
}

export enum TaskAssignmentState {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Unacknowledged = 'UNACKNOWLEDGED',
  Unassigned = 'UNASSIGNED'
}

export enum TaskExecutionState {
  AutoExecuted = 'AUTO_EXECUTED',
  Executed = 'EXECUTED',
  Overdue = 'OVERDUE',
  Planned = 'PLANNED'
}

export type TaskMethod = {
  __typename: 'TaskMethod';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  taskTypeCode?: Maybe<Scalars['String']['output']>;
  taskTypeName?: Maybe<Scalars['String']['output']>;
  taskTypeUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type TaskSort = {
  column: TaskSortColumn;
  direction?: InputMaybe<SortDirection>;
};

export enum TaskSortColumn {
  GeneralStatus = 'GENERAL_STATUS',
  GeneralStatusDate = 'GENERAL_STATUS_DATE'
}

export type TaskSummary = {
  __typename: 'TaskSummary';
  farm?: Maybe<FarmV2>;
  tasks?: Maybe<Array<Maybe<TaskSummaryDetail>>>;
};

export type TaskSummaryDetail = {
  __typename: 'TaskSummaryDetail';
  count?: Maybe<Scalars['Int']['output']>;
  creationFlowHint?: Maybe<CreationFlowHint>;
  cropUuid?: Maybe<Scalars['UUID']['output']>;
  generalTaskStatus?: Maybe<GeneralTaskStatus>;
  taskType?: Maybe<GeneralTaskType>;
};

export enum TaskType {
  CropEstablishment = 'CROP_ESTABLISHMENT',
  Seedboxtreatment = 'SEEDBOXTREATMENT',
  Seedtreatment = 'SEEDTREATMENT',
  SmartSprayingTask = 'SMART_SPRAYING_TASK',
  Spraying = 'SPRAYING'
}

export enum TaskTypeCode {
  Fieldtreatment = 'FIELDTREATMENT',
  Nutrition = 'NUTRITION',
  Seeding = 'SEEDING'
}

export enum TaxonomicRank {
  Category = 'CATEGORY',
  Family = 'FAMILY',
  Genus = 'GENUS',
  Species = 'SPECIES'
}

export type Tenant = {
  __typename: 'Tenant';
  code: Scalars['String']['output'];
  uuid: Scalars['UUID']['output'];
};

export type TillageSystem = {
  __typename: 'TillageSystem';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type Tillages = {
  __typename: 'Tillages';
  code?: Maybe<Scalars['String']['output']>;
  defaultTillageDepth?: Maybe<Scalars['Float']['output']>;
  defaultTillageDepthSi?: Maybe<Scalars['Float']['output']>;
  defaultTillageDepthSiUnitCode?: Maybe<Scalars['String']['output']>;
  defaultTillageDepthSiUnitName?: Maybe<Scalars['String']['output']>;
  defaultTillageDepthSiUnitUuid?: Maybe<Scalars['UUID']['output']>;
  defaultTillageDepthUnitCode?: Maybe<Scalars['String']['output']>;
  defaultTillageDepthUnitName?: Maybe<Scalars['String']['output']>;
  defaultTillageDepthUnitUuid?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  maxTillageDepth?: Maybe<Scalars['Float']['output']>;
  maxTillageDepthSi?: Maybe<Scalars['Float']['output']>;
  maxTillageDepthSiUnitCode?: Maybe<Scalars['String']['output']>;
  maxTillageDepthSiUnitName?: Maybe<Scalars['String']['output']>;
  maxTillageDepthSiUnitUuid?: Maybe<Scalars['UUID']['output']>;
  maxTillageDepthUnitCode?: Maybe<Scalars['String']['output']>;
  maxTillageDepthUnitName?: Maybe<Scalars['String']['output']>;
  maxTillageDepthUnitUuid?: Maybe<Scalars['UUID']['output']>;
  minTillageDepth?: Maybe<Scalars['Float']['output']>;
  minTillageDepthSi?: Maybe<Scalars['Float']['output']>;
  minTillageDepthSiUnitCode?: Maybe<Scalars['String']['output']>;
  minTillageDepthSiUnitName?: Maybe<Scalars['String']['output']>;
  minTillageDepthSiUnitUuid?: Maybe<Scalars['UUID']['output']>;
  minTillageDepthUnitCode?: Maybe<Scalars['String']['output']>;
  minTillageDepthUnitName?: Maybe<Scalars['String']['output']>;
  minTillageDepthUnitUuid?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum TimeFormat {
  Daily = 'DAILY',
  Hourly = 'HOURLY'
}

export type TimingCalculationStatus = {
  __typename: 'TimingCalculationStatus';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  status?: Maybe<CalculationStatusCode>;
};

export type TimingLimitationV2 = {
  __typename: 'TimingLimitationV2';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  isVraUnrestricted?: Maybe<Scalars['Boolean']['output']>;
  limitationReasons?: Maybe<Array<Maybe<LimitationReason>>>;
  productCategoryType?: Maybe<ProductCategoryType>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type TimingLimitationsV2Input = {
  cropSeasonUuid: Scalars['UUID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  tillDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TimingProductRecommendation = {
  __typename: 'TimingProductRecommendation';
  basfChoiceRank?: Maybe<Scalars['Int']['output']>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  characteristics?: Maybe<Array<Maybe<TimingProductRecommendationCharacteristic>>>;
  checksum?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  efficacyRank?: Maybe<Scalars['Int']['output']>;
  efficacyScore?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  pricePerformanceRatioRank?: Maybe<Scalars['Int']['output']>;
  protectionPeriod?: Maybe<Scalars['Int']['output']>;
  recipe?: Maybe<Array<Maybe<TimingProductRecommendationRecipe>>>;
  recommendationEndDate?: Maybe<Scalars['Date']['output']>;
  sortValueRank?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  stressEfficacy?: Maybe<Array<Maybe<TimingProductRecommendationStressEfficacy>>>;
  subType?: Maybe<Dictionary>;
  sustainabilityRank?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<TimingProductRecommendationType>;
  vraCapability?: Maybe<TimingProductRecommendationVraCapability>;
};

export enum TimingProductRecommendationCharacteristic {
  BasfChoice = 'BASF_CHOICE',
  BestPricePerformance = 'BEST_PRICE_PERFORMANCE',
  BestProtection = 'BEST_PROTECTION',
  SortValue = 'SORT_VALUE',
  Sustainable = 'SUSTAINABLE'
}

export type TimingProductRecommendationGroupDoseRate = {
  __typename: 'TimingProductRecommendationGroupDoseRate';
  cropSeasonV2?: Maybe<CropSeasonV2>;
  doseRate?: Maybe<Scalars['Float']['output']>;
  recommendationReferenceDate?: Maybe<Scalars['Date']['output']>;
};

export type TimingProductRecommendationGroupRecipe = {
  __typename: 'TimingProductRecommendationGroupRecipe';
  doseRates?: Maybe<Array<Maybe<TimingProductRecommendationGroupDoseRate>>>;
  productV2?: Maybe<ProductV2>;
};

export type TimingProductRecommendationRecipe = {
  __typename: 'TimingProductRecommendationRecipe';
  doseRate?: Maybe<Scalars['Float']['output']>;
  productV2?: Maybe<ProductV2>;
};

export type TimingProductRecommendationStressEfficacy = {
  __typename: 'TimingProductRecommendationStressEfficacy';
  efficacyScore?: Maybe<Scalars['Int']['output']>;
  stressV2?: Maybe<StressV2>;
};


export type TimingProductRecommendationStressEfficacyStressV2Args = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export enum TimingProductRecommendationType {
  Fungicide = 'FUNGICIDE',
  Insecticide = 'INSECTICIDE',
  PlantGrowthRegulator = 'PLANT_GROWTH_REGULATOR'
}

export enum TimingProductRecommendationVraCapability {
  Full = 'FULL',
  None = 'NONE',
  Partial = 'PARTIAL'
}

export type TimingProductRecommendationsGroup = {
  __typename: 'TimingProductRecommendationsGroup';
  characteristics?: Maybe<Array<Maybe<TimingProductRecommendationCharacteristic>>>;
  cropSeasons?: Maybe<Array<Maybe<CropSeasonV2>>>;
  recipe?: Maybe<Array<Maybe<TimingProductRecommendationGroupRecipe>>>;
  type?: Maybe<TimingProductRecommendationsGroupType>;
  vraCapability?: Maybe<TimingProductRecommendationVraCapability>;
};

export enum TimingProductRecommendationsGroupType {
  Fungicide = 'FUNGICIDE',
  FungicidePgr = 'FUNGICIDE_PGR',
  Insecticide = 'INSECTICIDE',
  PlantGrowthRegulator = 'PLANT_GROWTH_REGULATOR'
}

export type TimingStressInfo = {
  __typename: 'TimingStressInfo';
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `stressV2` */
  stress?: Maybe<Stress>;
  stressV2?: Maybe<StressV2>;
  uuid: Scalars['UUID']['output'];
};


export type TimingStressInfoStressV2Args = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type ToppingTask = {
  __typename: 'ToppingTask';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  state?: Maybe<TaskExecutionState>;
  uuid: Scalars['UUID']['output'];
};

export type TotalNutrients = {
  __typename: 'TotalNutrients';
  accountableAmount?: Maybe<Scalars['Float']['output']>;
  accountableRate?: Maybe<Scalars['Float']['output']>;
  amount: Scalars['Float']['output'];
  fertilizerTypeUuid: Scalars['UUID']['output'];
  nutrientUuid: Scalars['UUID']['output'];
  rate: Scalars['Float']['output'];
  /** @deprecated No longer supported */
  targetAmountDelta?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No longer supported */
  targetContributionAmount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No longer supported */
  targetContributionRate?: Maybe<Scalars['Float']['output']>;
  /** @deprecated No longer supported */
  targetRateDelta?: Maybe<Scalars['Float']['output']>;
};

export type TotalNutrientsDelta = {
  __typename: 'TotalNutrientsDelta';
  nutrientUuid?: Maybe<Scalars['UUID']['output']>;
  targetAmountDelta?: Maybe<Scalars['Float']['output']>;
  targetRateDelta?: Maybe<Scalars['Float']['output']>;
};

export type TotalProducts = {
  __typename: 'TotalProducts';
  amount: Scalars['Float']['output'];
  product?: Maybe<ProductV2>;
  rate: Scalars['Float']['output'];
  targetAmountDelta: Scalars['Float']['output'];
  targetRateDelta: Scalars['Float']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type Tramline = {
  __typename: 'Tramline';
  abLine?: Maybe<AbLine>;
  etag?: Maybe<Scalars['String']['output']>;
  fieldV2: FieldV2;
  geometry: Scalars['JSONObject']['output'];
  headlandWidth: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  workingWidth: Scalars['Float']['output'];
};

export enum TreatmentEquipmentType {
  Drone = 'DRONE',
  FlatSpotSmartSprayer = 'FLAT_SPOT_SMART_SPRAYER',
  SmartSprayer = 'SMART_SPRAYER',
  Standard = 'STANDARD'
}

export type TreatmentProduct = {
  __typename: 'TreatmentProduct';
  applicationRate?: Maybe<Scalars['Float']['output']>;
  dilutionFactor?: Maybe<Scalars['Float']['output']>;
  localUnitUuid?: Maybe<Scalars['UUID']['output']>;
  unit?: Maybe<TreatmentProductUnit>;
  uuid: Scalars['UUID']['output'];
};

export enum TreatmentProductUnit {
  KgBox = 'KG_BOX',
  KgKg = 'KG_KG',
  M3Box = 'M3_BOX',
  M3Kg = 'M3_KG'
}

export type TreatmentProgramAction = {
  __typename: 'TreatmentProgramAction';
  additionalNoticeKeys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<ActionCode>;
  end?: Maybe<ActionDate>;
  index?: Maybe<Scalars['Int']['output']>;
  labelKey?: Maybe<Scalars['String']['output']>;
  recommendedApplicationTypes?: Maybe<Array<Maybe<TreatmentProgramApplicationType>>>;
  start?: Maybe<ActionDate>;
  tankMixes?: Maybe<Array<Maybe<ActionDetailTankMix>>>;
  tillageUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<ActionDetailType>;
};

export type TreatmentProgramActionWindow = {
  __typename: 'TreatmentProgramActionWindow';
  action?: Maybe<Action>;
  /** # actionId */
  actionV3?: Maybe<TreatmentProgramAction>;
  code?: Maybe<ActionCode>;
  endDate?: Maybe<Scalars['Date']['output']>;
  executionStatus?: Maybe<ActionWindowExecutionStatus>;
  startDate?: Maybe<Scalars['Date']['output']>;
  tasks?: Maybe<Array<Maybe<TreatmentProgramActionWindowTask>>>;
};

export type TreatmentProgramActionWindowTask = {
  __typename: 'TreatmentProgramActionWindowTask';
  executionDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<ActionDetailType>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export enum TreatmentProgramApplicationType {
  Flat = 'FLAT',
  OnOff = 'ON_OFF',
  Spot = 'SPOT',
  SpotAndFlat = 'SPOT_AND_FLAT',
  Vra = 'VRA'
}

export enum TreatmentProgramType {
  WeedManagement = 'WEED_MANAGEMENT'
}

export type TreatmentReason = {
  __typename: 'TreatmentReason';
  reasonUuid: Scalars['UUID']['output'];
  stressUuid: Scalars['UUID']['output'];
};

export type TreatmentScenario = {
  __typename: 'TreatmentScenario';
  actions?: Maybe<Array<Maybe<Action>>>;
  checksum?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  equipmentType?: Maybe<TreatmentEquipmentType>;
  etag?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<FarmV2>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameTranslationId?: Maybe<Scalars['String']['output']>;
  season?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export enum TreatmentScenarioType {
  WeedManagement = 'WEED_MANAGEMENT'
}

export type Trial = {
  __typename: 'Trial';
  assessmentTimings?: Maybe<Array<Maybe<AssessmentTiming>>>;
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  comment?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  disabledReplicates?: Maybe<Array<Maybe<TrialDisabledReplicate>>>;
  etag?: Maybe<Scalars['String']['output']>;
  factorLevelFieldZoneMappings: Array<FactorLevelFieldZoneMapping>;
  factorLevels?: Maybe<Scalars['Int']['output']>;
  factorUuid?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Use `factorLevelFieldZoneMappings` when factor-to-zone mappings matter. */
  fieldZones?: Maybe<Array<Maybe<FieldZone>>>;
  fieldZonesWithoutOrder?: Maybe<Array<Maybe<FieldZone>>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  lockedAt?: Maybe<Scalars['Date']['output']>;
  maxPlotArea?: Maybe<Scalars['Float']['output']>;
  minPlotArea?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  plotLength?: Maybe<Scalars['Float']['output']>;
  plotWidth?: Maybe<Scalars['Float']['output']>;
  protocol?: Maybe<Protocol>;
  replicates?: Maybe<Scalars['Int']['output']>;
  scoutingTasks?: Maybe<Array<Maybe<ScoutingTask>>>;
  trialNumber: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
};

export type TrialDisabledReplicate = {
  __typename: 'TrialDisabledReplicate';
  factorLevel: Scalars['Int']['output'];
  replicate: Scalars['Int']['output'];
};

export type TrialV2 = {
  __typename: 'TrialV2';
  assessmentTimings?: Maybe<Array<Maybe<AssessmentTiming>>>;
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  comment?: Maybe<Scalars['String']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  dateCreated?: Maybe<Scalars['Date']['output']>;
  disabledReplicates?: Maybe<Array<Maybe<TrialDisabledReplicate>>>;
  etag?: Maybe<Scalars['String']['output']>;
  factorLevelFieldZoneMappings: Array<FactorLevelFieldZoneMapping>;
  factorLevels?: Maybe<Scalars['Int']['output']>;
  factorUuid?: Maybe<Scalars['UUID']['output']>;
  farmName?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `factorLevelFieldZoneMappings` when factor-to-zone mappings matter. */
  fieldZones?: Maybe<Array<Maybe<FieldZone>>>;
  fieldZonesWithoutOrder?: Maybe<Array<Maybe<FieldZone>>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  lockedAt?: Maybe<Scalars['Date']['output']>;
  maxPlotArea?: Maybe<Scalars['Float']['output']>;
  minPlotArea?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  plotLength?: Maybe<Scalars['Float']['output']>;
  plotWidth?: Maybe<Scalars['Float']['output']>;
  protocol?: Maybe<Protocol>;
  protocolId?: Maybe<Scalars['String']['output']>;
  protocolName?: Maybe<Scalars['String']['output']>;
  replicates?: Maybe<Scalars['Int']['output']>;
  scoutingTasks?: Maybe<Array<Maybe<ScoutingTask>>>;
  scoutingTasksCount?: Maybe<Scalars['Int']['output']>;
  trialNumber: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
};

export enum TrialV2Column {
  FarmName = 'FARM_NAME',
  FieldName = 'FIELD_NAME',
  Name = 'NAME',
  ProtocolId = 'PROTOCOL_ID',
  ProtocolName = 'PROTOCOL_NAME'
}

export type TrialV2Sort = {
  column?: InputMaybe<TrialV2Column>;
  direction?: InputMaybe<SortDirection>;
};

export enum UpdateType {
  Patch = 'PATCH',
  Put = 'PUT'
}

export enum UploadDatasetFormat {
  Aft = 'AFT',
  Flatgeobuf = 'FLATGEOBUF',
  Geojson = 'GEOJSON',
  Isoxml = 'ISOXML',
  Parquet = 'PARQUET',
  Shp = 'SHP'
}

export enum UploadDatasetGeometryType {
  Point = 'POINT',
  Polygon = 'POLYGON'
}

export enum UploadDatasetStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  MissingInfo = 'MISSING_INFO',
  Pending = 'PENDING'
}

export type UploadDatasetSummary = {
  __typename: 'UploadDatasetSummary';
  count: Scalars['Int']['output'];
  status: UploadDatasetStatus;
};

export type UploadDatasetTotal = {
  __typename: 'UploadDatasetTotal';
  actualCulturalPractice?: Maybe<ActualCulturalPractice>;
  deviceElementDisplayName?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<UploadDatasetTotalSourceType>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export enum UploadDatasetTotalSourceType {
  UploadDataset = 'UPLOAD_DATASET',
  UploadDatasetGroup = 'UPLOAD_DATASET_GROUP'
}

export enum UploadDatasetType {
  Application = 'APPLICATION',
  Custom = 'CUSTOM',
  Other = 'OTHER',
  Seeding = 'SEEDING',
  Soil = 'SOIL',
  Tillage = 'TILLAGE',
  Yield = 'YIELD'
}

export type User = {
  __typename: 'User';
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hfMachineries?: Maybe<Array<Maybe<HfMachinery>>>;
  hfOffers?: Maybe<Array<Maybe<HfOffer>>>;
  initials?: Maybe<Scalars['String']['output']>;
  inviteCodeUuid?: Maybe<Scalars['UUID']['output']>;
  isEmailVerificationNeeded?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sharingMandates?: Maybe<Array<Maybe<SharingMandate>>>;
  smartSprayerRegistrations?: Maybe<Array<Maybe<SmartSprayerRegistration>>>;
  tenantUuid?: Maybe<Scalars['UUID']['output']>;
  userFarmPackages?: Maybe<Array<Maybe<UserFarmPackage>>>;
  userFeatures?: Maybe<Array<Maybe<UserFeature>>>;
  userPackages?: Maybe<Array<Maybe<UserPackage>>>;
  uuid: Scalars['String']['output'];
};


export type UserUserPackagesArgs = {
  historicalItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserDataVsValidationComparison = {
  __typename: 'UserDataVsValidationComparison';
  coverCropMatch?: Maybe<Comparison>;
  coverCropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  cropMatch?: Maybe<Comparison>;
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  detectedPractices?: Maybe<MonitorPractice>;
  fieldUuid: Scalars['UUID']['output'];
  fmCarbonRelatedData?: Maybe<FmCarbonRelatedData>;
  monitorResultAvailable: Scalars['Boolean']['output'];
  regrowCropName?: Maybe<Scalars['String']['output']>;
  tillages?: Maybe<Array<Maybe<MonitorTillage>>>;
};

export type UserDevice = {
  __typename: 'UserDevice';
  device?: Maybe<OneSoilDevice>;
  devicePackages?: Maybe<Array<Maybe<DevicePackage>>>;
  etag?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<DeviceFeature>>>;
  name?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
};


export type UserDeviceDevicePackagesArgs = {
  historicalItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFarmPackage = {
  __typename: 'UserFarmPackage';
  creatorId?: Maybe<Scalars['String']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  farmV2?: Maybe<FarmV2>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  userPackageUuid?: Maybe<Scalars['UUID']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type UserFeature = {
  __typename: 'UserFeature';
  crop?: Maybe<Crop>;
  name?: Maybe<FeatureName>;
  needsActivation?: Maybe<Scalars['Boolean']['output']>;
  packageType?: Maybe<PackageType>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type UserGroup = {
  __typename: 'UserGroup';
  group: Group;
  user: User;
};

export type UserLicenseRequest = {
  __typename: 'UserLicenseRequest';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  creatorUser?: Maybe<User>;
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierUser?: Maybe<User>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  license: License;
  organisation?: Maybe<Organisation>;
  organisationMemberUser?: Maybe<User>;
  quantity: Scalars['Float']['output'];
  status: LicenseRequestStatusType;
  user?: Maybe<User>;
  uuid: Scalars['UUID']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type UserNotification = {
  __typename: 'UserNotification';
  cropSeason?: Maybe<CropSeasonV2>;
  farm?: Maybe<FarmV2>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  objectUuid?: Maybe<Scalars['UUID']['output']>;
  payloadData?: Maybe<PayloadData>;
  scheduledDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<NotificationType>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type UserPackage = {
  __typename: 'UserPackage';
  creatorId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmAssignable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packageUuid?: Maybe<Scalars['UUID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityType?: Maybe<FarmPackageQuantityType>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<PackageType>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  validTill?: Maybe<Scalars['Date']['output']>;
};

export type UserSetting = {
  __typename: 'UserSetting';
  name?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ValueCode = {
  __typename: 'ValueCode';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type Variety = {
  __typename: 'Variety';
  breeder?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  breederReferenceNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  breederUuid?: Maybe<Scalars['UUID']['output']>;
  crop?: Maybe<Crop>;
  /** @deprecated Not supported anymore by MD2.0 */
  dictCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  dictCodeId?: Maybe<Scalars['Int']['output']>;
  farm?: Maybe<FarmV2>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registrationApplicationDate?: Maybe<Scalars['String']['output']>;
  registrationCountry?: Maybe<Scalars['String']['output']>;
  registrationCountryUuid?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  registrationDate?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  registrationStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  registrationStatusUuid?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  type?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported anymore by MD2.0 */
  typeUuid?: Maybe<Scalars['UUID']['output']>;
  uuid: Scalars['UUID']['output'];
};


export type VarietyCropArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

export type VarietyCharacteristic = {
  __typename: 'VarietyCharacteristic';
  altitudeMax?: Maybe<Scalars['Int']['output']>;
  altitudeMin?: Maybe<Scalars['Int']['output']>;
  characteristicId?: Maybe<Scalars['String']['output']>;
  characteristicName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  isIrrigated?: Maybe<Scalars['Boolean']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionUuid?: Maybe<Scalars['UUID']['output']>;
  scaleCode?: Maybe<Scalars['String']['output']>;
  scaleName?: Maybe<Scalars['String']['output']>;
  scaleUuid?: Maybe<Scalars['UUID']['output']>;
  seasonCode?: Maybe<Scalars['String']['output']>;
  seasonName?: Maybe<Scalars['String']['output']>;
  seasonUuid?: Maybe<Scalars['UUID']['output']>;
  sowingDateMax?: Maybe<Scalars['Date']['output']>;
  sowingDateMin?: Maybe<Scalars['Date']['output']>;
  stressCode?: Maybe<Scalars['String']['output']>;
  stressName?: Maybe<Scalars['String']['output']>;
  stressUuid?: Maybe<Scalars['UUID']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  valueCodes?: Maybe<Array<Maybe<ValueCode>>>;
  valueOrig?: Maybe<Scalars['Int']['output']>;
  valueUnitCode?: Maybe<Scalars['String']['output']>;
  valueUnitName?: Maybe<Scalars['String']['output']>;
  valueUnitSiCode?: Maybe<Scalars['String']['output']>;
  valueUnitSiName?: Maybe<Scalars['String']['output']>;
  valueUnitSiUuid?: Maybe<Scalars['UUID']['output']>;
  valueUnitUuid?: Maybe<Scalars['UUID']['output']>;
  varietyCode?: Maybe<Scalars['String']['output']>;
  varietyName?: Maybe<Scalars['String']['output']>;
  varietyUuid?: Maybe<Scalars['UUID']['output']>;
};

export type VarietyRanking = {
  __typename: 'VarietyRanking';
  rank?: Maybe<Scalars['Int']['output']>;
  recommendedFlatRate?: Maybe<Scalars['Float']['output']>;
  recommendedRates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  variety?: Maybe<Variety>;
  vpi?: Maybe<VarietyRatingVpi>;
};

export enum VarietyRatingVpi {
  High = 'HIGH',
  Low = 'LOW',
  Mid = 'MID'
}

export type VarietyRecommendation = {
  __typename: 'VarietyRecommendation';
  errorCode?: Maybe<ErrorCode>;
  field?: Maybe<FieldV2>;
  fieldVpiClassification?: Maybe<FieldVpiClassification>;
  percentageHighVpi?: Maybe<Scalars['Float']['output']>;
  percentageLowVpi?: Maybe<Scalars['Float']['output']>;
  percentageMidVpi?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<VarietyRecommendationStatus>;
  varietyRankings?: Maybe<Array<Maybe<VarietyRanking>>>;
};

export enum VarietyRecommendationStatus {
  Expired = 'EXPIRED',
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type VendorDeviceBlacklistEntry = {
  __typename: 'VendorDeviceBlacklistEntry';
  device?: Maybe<DtnVendorDevice>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceUuid: Scalars['UUID']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  intersectingOngoingCount?: Maybe<Scalars['Int']['output']>;
  variables?: Maybe<Array<Maybe<BlacklistVariableInfo>>>;
  vendor: DtnVendor;
  wasAnySensorDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type VendorDeviceDataAnomaly = {
  __typename: 'VendorDeviceDataAnomaly';
  anomalyTimestepCount?: Maybe<Scalars['Int']['output']>;
  device?: Maybe<DtnVendorDevice>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceUuid: Scalars['UUID']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  timeFormat?: Maybe<WeatherFormat>;
  variables?: Maybe<Array<Maybe<AnomalyVariableInfo>>>;
  vendor: DtnVendor;
  wasEverAnomaly?: Maybe<Scalars['Boolean']['output']>;
};

export type VendorDeviceDataMissing = {
  __typename: 'VendorDeviceDataMissing';
  device?: Maybe<DtnVendorDevice>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceUuid: Scalars['UUID']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  isReportingNow?: Maybe<Scalars['Boolean']['output']>;
  missingCount?: Maybe<Scalars['Float']['output']>;
  notReportingHistory?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  timeFormat?: Maybe<WeatherFormat>;
  vendor: DtnVendor;
  wasEverNotReporting?: Maybe<Scalars['Boolean']['output']>;
};

export type VendorDeviceInfo = {
  __typename: 'VendorDeviceInfo';
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendor?: Maybe<DtnVendor>;
  vendorDevice?: Maybe<DtnVendorDevice>;
  vendorDeviceId?: Maybe<Scalars['String']['output']>;
};

export type VendorDeviceSensorStatus = {
  __typename: 'VendorDeviceSensorStatus';
  device?: Maybe<DtnVendorDevice>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceUuid: Scalars['UUID']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  intersectingOngoingCount?: Maybe<Scalars['Int']['output']>;
  variables?: Maybe<Array<Maybe<SensorStatusVariableDetail>>>;
  vendor: DtnVendor;
  wasAnySensorDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type VendorDeviceStatus = {
  __typename: 'VendorDeviceStatus';
  device?: Maybe<DtnVendorDevice>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceUuid: Scalars['UUID']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  vendor: DtnVendor;
};

export enum WarningCode {
  GsdOutOfRange = 'GSD_OUT_OF_RANGE'
}

export enum WaterAvailableStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type WaterBalance = {
  __typename: 'WaterBalance';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  plantAvailableWaterCapacity0_100cm?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  transpirationReductionFactor?: Maybe<Scalars['Float']['output']>;
};

export enum WaterManagementAction {
  WaterManagement = 'WATER_MANAGEMENT'
}

export enum WaterManagementActionType {
  WaterManagement = 'WATER_MANAGEMENT'
}

export type WaterManagementScenario = {
  __typename: 'WaterManagementScenario';
  cropEstablishmentMethod?: Maybe<EstablishmentMethod>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<WaterManagementAction>;
  uuid: Scalars['UUID']['output'];
};

export type WaterManagementTask = {
  __typename: 'WaterManagementTask';
  assignee?: Maybe<Collaborator>;
  assignmentState?: Maybe<TaskAssignmentState>;
  autoExecutedOn?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  etag?: Maybe<Scalars['String']['output']>;
  executionDate?: Maybe<Scalars['Date']['output']>;
  executionStartDate?: Maybe<Scalars['Date']['output']>;
  fieldCoveragePercentage?: Maybe<Scalars['Float']['output']>;
  irrigationSystemUuid?: Maybe<Scalars['UUID']['output']>;
  isAutoExecutable?: Maybe<Scalars['Boolean']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['Date']['output']>;
  processedArea?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<TaskExecutionState>;
  taskMethodUuid?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<WaterManagementTaskType>;
  uuid: Scalars['UUID']['output'];
  waterHeight?: Maybe<Scalars['Float']['output']>;
  waterHeightDifference?: Maybe<Scalars['Float']['output']>;
};

export enum WaterManagementTaskType {
  Drainage = 'DRAINAGE',
  Irrigation = 'IRRIGATION'
}

export type WaterRecommendation = {
  __typename: 'WaterRecommendation';
  actionType?: Maybe<WaterManagementActionType>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  confidenceLevel?: Maybe<ConfidenceLevel>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  description?: Maybe<Scalars['String']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<WaterRecommendationStatus>;
};

export enum WaterRecommendationStatus {
  NotNeeded = 'NOT_NEEDED',
  Recommended = 'RECOMMENDED'
}

export enum WaterSensitivity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type WaterStatus = {
  __typename: 'WaterStatus';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<WaterStatusState>;
  type: WaterStatusType;
};

export enum WaterStatusState {
  High = 'HIGH',
  Low = 'LOW',
  Protected = 'PROTECTED'
}

export enum WaterStatusType {
  Water = 'WATER'
}

export type Weather = {
  __typename: 'Weather';
  airTempCAvg?: Maybe<Scalars['String']['output']>;
  airTempCMax?: Maybe<Scalars['String']['output']>;
  airTempCMin?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorCodeAvg?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorCodeMax?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorCodeMin?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorIconAvg?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorIconMax?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorIconMin?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorIdAvg?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorIdMax?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorIdMin?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorTextAvg?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorTextMax?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorTextMin?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorUrlAvg?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorUrlMax?: Maybe<Scalars['String']['output']>;
  cloudCoverDescriptorUrlMin?: Maybe<Scalars['String']['output']>;
  cloudCoverPctAvg?: Maybe<Scalars['String']['output']>;
  cloudCoverPctMax?: Maybe<Scalars['String']['output']>;
  cloudCoverPctMin?: Maybe<Scalars['String']['output']>;
  correctedPrecipitationMm?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['Date']['output']>;
  deltaTCAvg?: Maybe<Scalars['String']['output']>;
  endDatetime?: Maybe<Scalars['Date']['output']>;
  globalRadiationKjM2?: Maybe<Scalars['String']['output']>;
  globalRadiationKjM2Avg?: Maybe<Scalars['String']['output']>;
  globalRadiationKjM2Max?: Maybe<Scalars['String']['output']>;
  globalRadiationKjM2Min?: Maybe<Scalars['String']['output']>;
  globalRadiationKjM2Stddev?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  leafWetnessDurationH?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  precipitationAdjustedMm?: Maybe<Scalars['String']['output']>;
  precipitationBestMm?: Maybe<Scalars['String']['output']>;
  precipitationDescriptorCode?: Maybe<Scalars['String']['output']>;
  precipitationDescriptorIcon?: Maybe<Scalars['String']['output']>;
  precipitationDescriptorId?: Maybe<Scalars['String']['output']>;
  precipitationDescriptorText?: Maybe<Scalars['String']['output']>;
  precipitationDescriptorUrl?: Maybe<Scalars['String']['output']>;
  precipitationDurationH?: Maybe<Scalars['String']['output']>;
  precipitationMm?: Maybe<Scalars['String']['output']>;
  precipitationMmAcc?: Maybe<Scalars['String']['output']>;
  precipitationProbabilityPct?: Maybe<Scalars['String']['output']>;
  relativeHumidityPctAvg?: Maybe<Scalars['String']['output']>;
  relativeHumidityPctMax?: Maybe<Scalars['String']['output']>;
  relativeHumidityPctMin?: Maybe<Scalars['String']['output']>;
  startDatetime?: Maybe<Scalars['Date']['output']>;
  sunshineDurationH?: Maybe<Scalars['String']['output']>;
  uuidForeign?: Maybe<Scalars['UUID']['output']>;
  uuidLocation?: Maybe<Scalars['UUID']['output']>;
  weatherDescriptorCode?: Maybe<Scalars['String']['output']>;
  weatherDescriptorIcon?: Maybe<Scalars['String']['output']>;
  weatherDescriptorId?: Maybe<Scalars['String']['output']>;
  weatherDescriptorText?: Maybe<Scalars['String']['output']>;
  weatherDescriptorUrl?: Maybe<Scalars['String']['output']>;
  windDirectionDeg?: Maybe<Scalars['String']['output']>;
  windDirectionDegPlus180?: Maybe<Scalars['String']['output']>;
  windDirectionDescriptorCode?: Maybe<Scalars['String']['output']>;
  windDirectionDescriptorIcon?: Maybe<Scalars['String']['output']>;
  windDirectionDescriptorId?: Maybe<Scalars['String']['output']>;
  windDirectionDescriptorText?: Maybe<Scalars['String']['output']>;
  windDirectionDescriptorUrl?: Maybe<Scalars['String']['output']>;
  windSpeedMSAvg?: Maybe<Scalars['String']['output']>;
  windSpeedMSMax?: Maybe<Scalars['String']['output']>;
  windSpeedMSMin?: Maybe<Scalars['String']['output']>;
};

export enum WeatherFormat {
  Daily = 'DAILY',
  Hourly = 'HOURLY'
}

export enum WeatherProvider {
  Arable = 'ARABLE',
  Auto = 'AUTO',
  Custom = 'CUSTOM',
  Dwd = 'DWD',
  Ibm = 'IBM',
  InternalHlw = 'INTERNAL_HLW',
  Iteris = 'ITERIS',
  Observation = 'OBSERVATION',
  Station = 'STATION',
  Win = 'WIN'
}

export enum WeatherType {
  Climatology = 'CLIMATOLOGY',
  Climatology05Y = 'CLIMATOLOGY05Y',
  Climatology10Y = 'CLIMATOLOGY10Y',
  Forecast = 'FORECAST',
  Historic = 'HISTORIC'
}

export type WeatherUserData = {
  __typename: 'WeatherUserData';
  correctedPrecipitationMm: Scalars['Float']['output'];
  creatorId?: Maybe<Scalars['String']['output']>;
  endDatetime: Scalars['Date']['output'];
  etag?: Maybe<Scalars['String']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  locationType: LocationType;
  locationUuid: Scalars['UUID']['output'];
  startDatetime: Scalars['Date']['output'];
  uuid: Scalars['UUID']['output'];
};

export type WeatherV2 = {
  __typename: 'WeatherV2';
  airTemp5cmCAvg?: Maybe<Scalars['Float']['output']>;
  airTemp5cmCMin?: Maybe<Scalars['Float']['output']>;
  airTempCAvg?: Maybe<Scalars['Float']['output']>;
  airTempCMax?: Maybe<Scalars['Float']['output']>;
  airTempCMin?: Maybe<Scalars['Float']['output']>;
  airTempCStddev?: Maybe<Scalars['Float']['output']>;
  belowDeviceTempCAvg?: Maybe<Scalars['Float']['output']>;
  cloudCoverPctAvg?: Maybe<Scalars['Float']['output']>;
  correctedPrecipitationMm?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['Date']['output']>;
  deltaTCAvg?: Maybe<Scalars['Float']['output']>;
  dewPointCAvg?: Maybe<Scalars['Float']['output']>;
  dewPointCMax?: Maybe<Scalars['Float']['output']>;
  dewPointCMin?: Maybe<Scalars['Float']['output']>;
  endDatetime?: Maybe<Scalars['Date']['output']>;
  globalRadiationKjM2?: Maybe<Scalars['Float']['output']>;
  globalRadiationKjM2Avg?: Maybe<Scalars['Float']['output']>;
  globalRadiationKjM2Max?: Maybe<Scalars['Float']['output']>;
  globalRadiationKjM2Min?: Maybe<Scalars['Float']['output']>;
  globalRadiationKjM2Stddev?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  leafWetnessBool?: Maybe<Scalars['Boolean']['output']>;
  leafWetnessDurationH?: Maybe<Scalars['Float']['output']>;
  liquidMm?: Maybe<Scalars['Float']['output']>;
  locationUuid?: Maybe<Scalars['UUID']['output']>;
  longWaveRadiationWM2Avg?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  petMm?: Maybe<Scalars['Float']['output']>;
  precipitationBestMm?: Maybe<Scalars['Float']['output']>;
  precipitationDurationH?: Maybe<Scalars['Float']['output']>;
  precipitationHourlyMaxMm?: Maybe<Scalars['Float']['output']>;
  precipitationMm?: Maybe<Scalars['Float']['output']>;
  precipitationMmAcc?: Maybe<Scalars['Float']['output']>;
  precipitationProbabilityPct?: Maybe<Scalars['Float']['output']>;
  relativeHumidityDurationOver80pctH?: Maybe<Scalars['Float']['output']>;
  relativeHumidityDurationOver90pctH?: Maybe<Scalars['Float']['output']>;
  relativeHumidityPctAvg?: Maybe<Scalars['Float']['output']>;
  relativeHumidityPctMax?: Maybe<Scalars['Float']['output']>;
  relativeHumidityPctMin?: Maybe<Scalars['Float']['output']>;
  shortWaveRadiationWM2Avg?: Maybe<Scalars['Float']['output']>;
  snowMm?: Maybe<Scalars['Float']['output']>;
  soilMoisture0to10cmAbsScaled?: Maybe<Scalars['Float']['output']>;
  soilMoisture0to10cmAbsScaledPaw?: Maybe<Scalars['Float']['output']>;
  soilTemp0to10cmC?: Maybe<Scalars['Float']['output']>;
  soilTemp0to10cmCMin?: Maybe<Scalars['Float']['output']>;
  startDatetime?: Maybe<Scalars['Date']['output']>;
  sunshineDurationH?: Maybe<Scalars['Float']['output']>;
  visibilityKmAvg?: Maybe<Scalars['Float']['output']>;
  waterBalanceMm?: Maybe<Scalars['Float']['output']>;
  weatherDescriptorImage?: Maybe<Scalars['String']['output']>;
  windDirectionDeg?: Maybe<Scalars['Float']['output']>;
  windDirectionDegPlus180?: Maybe<Scalars['Float']['output']>;
  windDirectionDescriptorCode?: Maybe<Scalars['Int']['output']>;
  windDirectionDescriptorIcon?: Maybe<Scalars['String']['output']>;
  windDirectionDescriptorText?: Maybe<Scalars['String']['output']>;
  windSpeed2mMSAvg?: Maybe<Scalars['Float']['output']>;
  windSpeedMSAvg?: Maybe<Scalars['Float']['output']>;
  windSpeedMSMax?: Maybe<Scalars['Float']['output']>;
};

export type Weed = {
  __typename: 'Weed';
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** just on local schema to be able to use REST endpoint */
export type WeedManagementProgramRecommendation = {
  __typename: 'WeedManagementProgramRecommendation';
  uuid?: Maybe<Scalars['UUID']['output']>;
};

/** just on local schema to be able to use REST endpoint */
export type WeedManagementProgramRecommendationV3 = {
  __typename: 'WeedManagementProgramRecommendationV3';
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type WeedManagementRecommendation = {
  __typename: 'WeedManagementRecommendation';
  actionType?: Maybe<WeedManagementRecommendationType>;
  calculationDate?: Maybe<Scalars['Date']['output']>;
  confidenceLevel?: Maybe<ConfidenceLevel>;
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason: CropSeason;
  cropSeasonTreatmentProgramActionId?: Maybe<Scalars['String']['output']>;
  cropSeasonTreatmentProgramV3Index?: Maybe<Scalars['Int']['output']>;
  cropSeasonV2: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<WeedManagementRecommendationStatus>;
  type?: Maybe<WeedManagementRecommendationType>;
};

export enum WeedManagementRecommendationStatus {
  NotNeeded = 'NOT_NEEDED',
  Recommended = 'RECOMMENDED'
}

export enum WeedManagementRecommendationType {
  HerbicideApplication = 'HERBICIDE_APPLICATION',
  LandPreparation = 'LAND_PREPARATION'
}

export type WeedRecord = {
  __typename: 'WeedRecord';
  creatorId?: Maybe<Scalars['String']['output']>;
  cropSeasonUuid?: Maybe<Scalars['UUID']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['UUID']['output']>;
  fieldUuid?: Maybe<Scalars['UUID']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['Date']['output']>;
  retracted?: Maybe<Scalars['Boolean']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  sourceUuid?: Maybe<Scalars['UUID']['output']>;
  targetWeeds?: Maybe<Array<Maybe<TargetWeed>>>;
  uuid: Scalars['UUID']['output'];
};

export enum WeedRecordSourceType {
  ScoutingTask = 'SCOUTING_TASK',
  UserDefined = 'USER_DEFINED',
  UserInput = 'USER_INPUT'
}

export type WeedRisk = {
  __typename: 'WeedRisk';
  /** @deprecated Use `cropSeasonV2`. */
  cropSeason?: Maybe<CropSeason>;
  cropSeasonV2?: Maybe<CropSeasonV2>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<WeedRiskStatus>;
};

export enum WeedRiskStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  NoInformation = 'NO_INFORMATION',
  Protected = 'PROTECTED'
}

export type WeedStatus = {
  __typename: 'WeedStatus';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason: CropSeasonV2;
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<WeedStatusStatus>;
  type?: Maybe<WeedStatusType>;
};

export enum WeedStatusStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  NoData = 'NO_DATA',
  Protected = 'PROTECTED'
}

export enum WeedStatusType {
  Weed = 'WEED'
}

export type WeeklySeedingRecommendation = {
  __typename: 'WeeklySeedingRecommendation';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeasonUuid: Scalars['UUID']['output'];
  eTag?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isLocked: Scalars['Boolean']['output'];
  isStale?: Maybe<Scalars['Boolean']['output']>;
  seedingDensity?: Maybe<Scalars['Float']['output']>;
  seedingRate?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type WfsParameters = {
  __typename: 'WfsParameters';
  cql_filter?: Maybe<Scalars['String']['output']>;
  outputFormat?: Maybe<Scalars['String']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  typeNames?: Maybe<Scalars['String']['output']>;
  viewParams?: Maybe<Scalars['String']['output']>;
};

export type WiuzConnectionStatus = {
  __typename: 'WiuzConnectionStatus';
  accessTokenExpiry?: Maybe<Scalars['Date']['output']>;
  needsUpgrade?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<ConnectionStatus>;
};

export enum WiuzImportOrderStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Ongoing = 'ONGOING',
  PartlyFailed = 'PARTLY_FAILED',
  Pending = 'PENDING'
}

export type WiuzUserFarm = {
  __typename: 'WiuzUserFarm';
  farmV2?: Maybe<FarmV2>;
  lastImportedOnDate?: Maybe<Scalars['Date']['output']>;
  legalCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userFamilyName?: Maybe<Scalars['String']['output']>;
  userGivenName?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type WiuzUserfarmImportOrder = {
  __typename: 'WiuzUserfarmImportOrder';
  createdDate?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['String']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  failedImportNumberOfCropSeasons?: Maybe<Scalars['Float']['output']>;
  failedImportNumberOfFields?: Maybe<Scalars['Float']['output']>;
  farmV2?: Maybe<FarmV2>;
  importedNumberOfFields?: Maybe<Scalars['Float']['output']>;
  lastModifierId?: Maybe<Scalars['String']['output']>;
  noBoundaryNumberOfFields?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<WiuzImportOrderStatus>;
  totalNumberOfFields?: Maybe<Scalars['Float']['output']>;
  unsupportedCropNumberOfFields?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  uuid?: Maybe<Scalars['UUID']['output']>;
  wiuzUserfarmUuid?: Maybe<Scalars['UUID']['output']>;
};

export type WmsParameters = {
  __typename: 'WmsParameters';
  cql_filter?: Maybe<Scalars['String']['output']>;
  elevation?: Maybe<Scalars['String']['output']>;
  env?: Maybe<Scalars['String']['output']>;
  layers?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `styles` */
  style?: Maybe<Scalars['String']['output']>;
  styles?: Maybe<Scalars['String']['output']>;
  viewparams?: Maybe<Scalars['String']['output']>;
};

export type YellowTrapResult = ScoutingPoiResult & {
  __typename: 'YellowTrapResult';
  detectedPests?: Maybe<Array<Maybe<DetectedPest>>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ScoutingPoiResultStatus>;
};

export type YieldPrediction = {
  __typename: 'YieldPrediction';
  calculationDate?: Maybe<Scalars['Date']['output']>;
  cropSeason?: Maybe<CropSeasonV2>;
  eTag?: Maybe<Scalars['String']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  predictions?: Maybe<Array<Maybe<Prediction>>>;
};

export type YieldScenario = {
  __typename: 'YieldScenario';
  weatherType?: Maybe<YieldScenarioWeatherType>;
  yield?: Maybe<Scalars['Float']['output']>;
};

export enum YieldScenarioWeatherType {
  ColdDry = 'COLD_DRY',
  ColdWet = 'COLD_WET',
  HotDry = 'HOT_DRY',
  HotWet = 'HOT_WET',
  Normal = 'NORMAL'
}

export type ZonePercentageDifference = {
  __typename: 'ZonePercentageDifference';
  applicationStrategy: ApplicationStrategy;
  rateFactor: Scalars['Float']['output'];
  zoneId: Scalars['Int']['output'];
};

export type ZoneRateV2 = {
  __typename: 'ZoneRateV2';
  substanceRates?: Maybe<Array<Maybe<SubstanceRateV2>>>;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export enum ZoneSpecificStrategy {
  Always = 'ALWAYS',
  Balanced = 'BALANCED',
  CustomThreshold = 'CUSTOM_THRESHOLD',
  Efficacy = 'EFFICACY',
  LargeWeeds = 'LARGE_WEEDS',
  Never = 'NEVER',
  Savings = 'SAVINGS',
  Terminal1 = 'TERMINAL1',
  Terminal2 = 'TERMINAL2',
  Terminal3 = 'TERMINAL3',
  Terminal4 = 'TERMINAL4',
  Terminal5 = 'TERMINAL5',
  Terminal6 = 'TERMINAL6',
  Terminal7 = 'TERMINAL7',
  Terminal8 = 'TERMINAL8',
  Terminal9 = 'TERMINAL9',
  Terminal10 = 'TERMINAL10',
  Terminal11 = 'TERMINAL11',
  Terminal12 = 'TERMINAL12',
  Terminal13 = 'TERMINAL13',
  Terminal14 = 'TERMINAL14',
  Terminal15 = 'TERMINAL15'
}

export type ZoneStatisticsItem = {
  __typename: 'ZoneStatisticsItem';
  area: Scalars['Float']['output'];
  zoneId: Scalars['Int']['output'];
};

export type ZoneStrategy = {
  __typename: 'ZoneStrategy';
  /**  ZoneStrategy would have been better name but we have already exposed zoneStrategies as child */
  checksum?: Maybe<Scalars['String']['output']>;
  customAdjacentThreshold?: Maybe<Scalars['Int']['output']>;
  customThreshold?: Maybe<Scalars['Int']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  strategy?: Maybe<ZoneSpecificStrategy>;
};

export type ZonesToSamplingAreaMapping = {
  __typename: 'ZonesToSamplingAreaMapping';
  samplingAreaId?: Maybe<Scalars['String']['output']>;
  zoneArea?: Maybe<Scalars['Float']['output']>;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  FDLSourceUnion:
    | ( Omit<DosedMap, 'additives' | 'cropSeason' | 'cropSeasonV2' | 'fieldZones' | 'sourceMap'> & { additives?: Maybe<Array<Maybe<_RefType['AdditiveRate']>>>, cropSeason: _RefType['CropSeason'], cropSeasonV2: _RefType['CropSeasonV2'], fieldZones?: Maybe<Array<Maybe<_RefType['MappingFieldZone']>>>, sourceMap?: Maybe<_RefType['SourceMap']> } )
    | ( Omit<DroneFlight, 'abLine' | 'assignee' | 'cropSeason' | 'cropSeasonV2'> & { abLine?: Maybe<_RefType['AbLine']>, assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeason']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<FieldDataLayer, 'cropSeason' | 'cropSeasonV2' | 'field' | 'fieldDataLayerStatistics' | 'fieldV2' | 'source'> & { cropSeason?: Maybe<_RefType['CropSeason']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']>, field?: Maybe<_RefType['Field']>, fieldDataLayerStatistics?: Maybe<Array<Maybe<_RefType['FieldDataLayerStatistics']>>>, fieldV2?: Maybe<_RefType['FieldV2']>, source?: Maybe<_RefType['FDLSourceUnion']> } )
    | ( Omit<SourceMap, 'cropSeason' | 'cropSeasonV2' | 'field'> & { cropSeason?: Maybe<_RefType['CropSeason']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']>, field?: Maybe<_RefType['FieldV2']> } )
  ;
  GeneralTasksUnion:
    | ( Omit<CropEstablishment, 'assignee' | 'cropSeasonV2' | 'dosedMap'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']>, dosedMap?: Maybe<_RefType['DosedMap']> } )
    | ( Omit<CropResidueManagementTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<DroneFlight, 'abLine' | 'assignee' | 'cropSeason' | 'cropSeasonV2'> & { abLine?: Maybe<_RefType['AbLine']>, assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeason']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<GreenhouseWhiteningTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<Harvest, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<LandPreparation, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<LeafPruningTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<ProduceDeliveryTask, 'assignee' | 'cropSeasonV2'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<ScoutingTask, 'assessmentTiming' | 'assignee' | 'cropSeasonV2' | 'farm' | 'fieldV2' | 'scoutingPoisV2' | 'trial'> & { assessmentTiming?: Maybe<_RefType['AssessmentTiming']>, assignee?: Maybe<_RefType['Collaborator']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']>, farm?: Maybe<_RefType['FarmV2']>, fieldV2: _RefType['FieldV2'], scoutingPoisV2?: Maybe<Array<Maybe<_RefType['ScoutingPoiV2']>>>, trial?: Maybe<_RefType['Trial']> } )
    | ( Omit<SeedBoxTreatment, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<SeedTreatment, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<SmartSprayingTaskV2, 'assignee' | 'cropSeason' | 'dosedMaps' | 'smartSprayingExecution' | 'smartSprayingTaskDevicePayloads'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']>, dosedMaps?: Maybe<Array<Maybe<_RefType['SmartSprayingTaskDosedMap']>>>, smartSprayingExecution?: Maybe<_RefType['SmartSprayerExecution']>, smartSprayingTaskDevicePayloads?: Maybe<Array<Maybe<_RefType['SmartSprayingTaskDevicePayload']>>> } )
    | ( Omit<SoilSamplingTask, 'assignee' | 'cropSeasonV2' | 'soilSamplingSet'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']>, soilSamplingSet?: Maybe<_RefType['SoilSampling']> } )
    | ( Omit<SprayingV2, 'assignee' | 'availableDosedMaps' | 'cropSeason' | 'cropSeasonV2' | 'dosedMap' | 'hortaSpraying'> & { assignee?: Maybe<_RefType['Collaborator']>, availableDosedMaps?: Maybe<Array<_RefType['AvailableDosedMap']>>, cropSeason?: Maybe<_RefType['CropSeason']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']>, dosedMap?: Maybe<_RefType['DosedMap']>, hortaSpraying?: Maybe<_RefType['HortaSpraying']> } )
    | ( Omit<ToppingTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<WaterManagementTask, 'assignee' | 'cropSeasonV2'> & { assignee?: Maybe<_RefType['Collaborator']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']> } )
  ;
  NotificationObject:
    | ( Omit<CropSeason, 'actionRecommendationAggregations' | 'actionRecommendations' | 'crop' | 'field' | 'fieldV2' | 'nutritionRecommendations' | 'nutritionStatus' | 'observations' | 'protectionTimes' | 'recommendationSnoozes' | 'sourceMaps' | 'sprayings' | 'sprayingsV2' | 'timingStressesInfo' | 'variety' | 'weedManagementRecommendations' | 'weedRisk'> & { actionRecommendationAggregations?: Maybe<Array<Maybe<_RefType['ActionRecommendationAggregation']>>>, actionRecommendations?: Maybe<Array<Maybe<_RefType['ActionRecommendation']>>>, crop?: Maybe<_RefType['Crop']>, field: _RefType['Field'], fieldV2: _RefType['FieldV2'], nutritionRecommendations?: Maybe<Array<Maybe<_RefType['NutritionRecommendation']>>>, nutritionStatus?: Maybe<Array<Maybe<_RefType['NutritionStatus']>>>, observations?: Maybe<Array<Maybe<_RefType['Observation']>>>, protectionTimes?: Maybe<Array<Maybe<_RefType['ProtectionTime']>>>, recommendationSnoozes?: Maybe<Array<Maybe<_RefType['RecommendationSnooze']>>>, sourceMaps?: Maybe<Array<Maybe<_RefType['SourceMap']>>>, sprayings?: Maybe<Array<Maybe<_RefType['Spraying']>>>, sprayingsV2?: Maybe<Array<Maybe<_RefType['SprayingV2']>>>, timingStressesInfo?: Maybe<Array<Maybe<_RefType['TimingStressInfo']>>>, variety?: Maybe<_RefType['Variety']>, weedManagementRecommendations?: Maybe<Array<Maybe<_RefType['WeedManagementRecommendation']>>>, weedRisk?: Maybe<_RefType['WeedRisk']> } )
    | ( Omit<DroneFlight, 'abLine' | 'assignee' | 'cropSeason' | 'cropSeasonV2'> & { abLine?: Maybe<_RefType['AbLine']>, assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeason']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']> } )
    | ( Omit<FieldV2, 'abLines' | 'activations' | 'agBalanceFieldInput' | 'carbonFarmingRequests' | 'creator' | 'cropSeasons' | 'cropSeasonsV2' | 'currentWeedPredictions' | 'farmV2' | 'features' | 'fieldDataLayers' | 'fieldEntries' | 'fieldNotes' | 'fieldZones' | 'greenhouse' | 'modifier' | 'scoutingTasks' | 'seedSelectorInputs' | 'soilErosion' | 'soilSamplingResults' | 'soilSamplings' | 'sourceMaps' | 'sprayWeather' | 'tramlines' | 'varietyRecommendations'> & { abLines?: Maybe<Array<Maybe<_RefType['AbLine']>>>, activations?: Maybe<Array<Maybe<_RefType['FieldActivation']>>>, agBalanceFieldInput?: Maybe<_RefType['AgBalanceFieldInput']>, carbonFarmingRequests?: Maybe<Array<Maybe<_RefType['CarbonFarmingRequest']>>>, creator?: Maybe<_RefType['User']>, cropSeasons?: Maybe<Array<Maybe<_RefType['CropSeason']>>>, cropSeasonsV2?: Maybe<Array<_RefType['CropSeasonV2']>>, currentWeedPredictions?: Maybe<Array<Maybe<_RefType['CurrentWeedPrediction']>>>, farmV2?: Maybe<_RefType['FarmV2']>, features?: Maybe<Array<Maybe<_RefType['FieldFeature']>>>, fieldDataLayers?: Maybe<Array<Maybe<_RefType['FieldDataLayer']>>>, fieldEntries?: Maybe<Array<Maybe<_RefType['FieldEntry']>>>, fieldNotes?: Maybe<Array<Maybe<_RefType['FieldNote']>>>, fieldZones?: Maybe<Array<Maybe<_RefType['FieldZone']>>>, greenhouse?: Maybe<_RefType['Greenhouse']>, modifier?: Maybe<_RefType['User']>, scoutingTasks?: Maybe<Array<_RefType['ScoutingTask']>>, seedSelectorInputs?: Maybe<Array<Maybe<_RefType['SeedSelectorInput']>>>, soilErosion?: Maybe<Array<Maybe<_RefType['SoilErosion']>>>, soilSamplingResults?: Maybe<Array<Maybe<_RefType['SoilSamplingResult']>>>, soilSamplings?: Maybe<Array<Maybe<_RefType['SoilSampling']>>>, sourceMaps?: Maybe<Array<Maybe<_RefType['SourceMap']>>>, sprayWeather?: Maybe<Array<Maybe<_RefType['SprayWeather']>>>, tramlines?: Maybe<Array<Maybe<_RefType['Tramline']>>>, varietyRecommendations?: Maybe<Array<Maybe<_RefType['VarietyRecommendation']>>> } )
    | ( Omit<Permission, 'grantee' | 'granter'> & { grantee?: Maybe<_RefType['User']>, granter?: Maybe<_RefType['User']> } )
    | ( Omit<Spraying, 'cropSeason' | 'dosedMap'> & { cropSeason?: Maybe<_RefType['CropSeason']>, dosedMap?: Maybe<_RefType['DosedMap']> } )
  ;
  StacItemRenderSource: ( Omit<DroneFlight, 'abLine' | 'assignee' | 'cropSeason' | 'cropSeasonV2'> & { abLine?: Maybe<_RefType['AbLine']>, assignee?: Maybe<_RefType['Collaborator']>, cropSeason?: Maybe<_RefType['CropSeason']>, cropSeasonV2?: Maybe<_RefType['CropSeasonV2']> } );
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  BaseEntityAuditingType:
    | ( FarmEvidenceLink )
    | ( FieldEvidenceLink )
    | ( ScaleTicket )
    | ( ScaleTicketBooking )
    | ( ScaleTicketBookingDispute )
    | ( Omit<ScaleTicketDataMapping, 'organisation'> & { organisation?: Maybe<_RefType['Organisation']> } )
    | ( ScaleTicketHistory )
    | ( Omit<ScaleTicketSellerMapping, 'organisation'> & { organisation?: Maybe<_RefType['Organisation']> } )
    | ( ScaleTicketUpload )
    | ( ScaleTicketUploadSummary )
    | ( Omit<SustainabilityOrganisationCapability, 'organisation'> & { organisation?: Maybe<_RefType['Organisation']> } )
    | ( Omit<SustainabilityProgram, 'crops' | 'measureSubmissionOrders'> & { crops?: Maybe<Array<Maybe<_RefType['Crop']>>>, measureSubmissionOrders?: Maybe<Array<Maybe<_RefType['MeasureSubmissionOrder']>>> } )
    | ( Omit<SustainabilityProgramBranchAssignment, 'branchAddress' | 'organisationAddress' | 'organisationBranch' | 'sustainabilityProgram'> & { branchAddress?: Maybe<_RefType['Address']>, organisationAddress?: Maybe<_RefType['Address']>, organisationBranch?: Maybe<_RefType['OrganisationBranch']>, sustainabilityProgram?: Maybe<_RefType['SustainabilityProgram']> } )
    | ( Omit<SustainabilityProgramInvitation, 'sustainabilityProgram'> & { sustainabilityProgram?: Maybe<_RefType['SustainabilityProgram']> } )
    | ( Omit<SustainabilityProgramOrganisationParticipation, 'branchAddress' | 'organisationAddress'> & { branchAddress?: Maybe<_RefType['Address']>, organisationAddress?: Maybe<_RefType['Address']> } )
    | ( Omit<SustainabilityProgramStaffMember, 'sustainabilityProgram' | 'user'> & { sustainabilityProgram?: Maybe<_RefType['SustainabilityProgram']>, user?: Maybe<_RefType['User']> } )
  ;
  ScoutingPoiResult:
    | ( DiseaseIdentificationResult )
    | ( EmergenceAnalysisResult )
    | ( LeafDamageResult )
    | ( MultiWeedResult )
    | ( NitrogenStatusResult )
    | ( YellowTrapResult )
  ;
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AbLine: ResolverTypeWrapper<Omit<AbLine, 'fieldV2'> & { fieldV2: ResolversTypes['FieldV2'] }>;
  AbstractProductType: AbstractProductType;
  Access: Access;
  AccessMode: AccessMode;
  Action: ResolverTypeWrapper<Action>;
  ActionCode: ActionCode;
  ActionDate: ResolverTypeWrapper<ActionDate>;
  ActionDateInput: ActionDateInput;
  ActionDateType: ActionDateType;
  ActionDetail: ResolverTypeWrapper<ActionDetail>;
  ActionDetailAdditive: ResolverTypeWrapper<ActionDetailAdditive>;
  ActionDetailProduct: ResolverTypeWrapper<ActionDetailProduct>;
  ActionDetailTankMix: ResolverTypeWrapper<ActionDetailTankMix>;
  ActionDetailType: ActionDetailType;
  ActionDetailV2: ResolverTypeWrapper<ActionDetailV2>;
  ActionInput: ActionInput;
  ActionRecommendation: ResolverTypeWrapper<Omit<ActionRecommendation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  ActionRecommendationAggregation: ResolverTypeWrapper<Omit<ActionRecommendationAggregation, 'actions' | 'cropSeason' | 'cropSeasonV2'> & { actions?: Maybe<Array<Maybe<ResolversTypes['ActionRecommendationAggregationAction']>>>, cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  ActionRecommendationAggregationAction: ResolverTypeWrapper<ActionRecommendationAggregationAction>;
  ActionRecommendationAggregationStatus: ActionRecommendationAggregationStatus;
  ActionRecommendationReason: ActionRecommendationReason;
  ActionRecommendationStatus: ActionRecommendationStatus;
  ActionRecommendationType: ActionRecommendationType;
  ActionType: ActionType;
  ActionWindow: ResolverTypeWrapper<Omit<ActionWindow, 'cropSeasonV2'> & { cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  ActionWindowExecutionStatus: ActionWindowExecutionStatus;
  ActionWindowStatus: ActionWindowStatus;
  ActionWindowType: ActionWindowType;
  ActiveIngredient: ResolverTypeWrapper<ActiveIngredient>;
  ActualCulturalPractice: ActualCulturalPractice;
  AdditionalInfectionRiskFactor: ResolverTypeWrapper<Omit<AdditionalInfectionRiskFactor, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  AdditiveRate: ResolverTypeWrapper<AdditiveRate>;
  Address: ResolverTypeWrapper<Address>;
  AdeMode: AdeMode;
  AgBalanceFieldEmissionIndicator: ResolverTypeWrapper<Omit<AgBalanceFieldEmissionIndicator, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  AgBalanceFieldEmissionIndicatorIssue: ResolverTypeWrapper<AgBalanceFieldEmissionIndicatorIssue>;
  AgBalanceFieldEmissionIndicatorIssueSeverity: AgBalanceFieldEmissionIndicatorIssueSeverity;
  AgBalanceFieldEmissionIndicatorStatus: AgBalanceFieldEmissionIndicatorStatus;
  AgBalanceFieldInput: ResolverTypeWrapper<Omit<AgBalanceFieldInput, 'field'> & { field: ResolversTypes['FieldV2'] }>;
  AggregatedNotification: ResolverTypeWrapper<Omit<AggregatedNotification, 'payload'> & { payload?: Maybe<ResolversTypes['AggregatedNotificationPayload']> }>;
  AggregatedNotificationPayload: ResolverTypeWrapper<Omit<AggregatedNotificationPayload, 'farm' | 'farms'> & { farm?: Maybe<ResolversTypes['FarmV2']>, farms?: Maybe<Array<Maybe<ResolversTypes['FarmV2']>>> }>;
  AggregatedPestDevelopmentPrediction: ResolverTypeWrapper<Omit<AggregatedPestDevelopmentPrediction, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  AggregatedRisk: ResolverTypeWrapper<AggregatedRisk>;
  AgronomicIndexType: AgronomicIndexType;
  Alert: Alert;
  AlgorithmType: AlgorithmType;
  AnalyticsCollection: ResolverTypeWrapper<Omit<AnalyticsCollection, 'farm' | 'fieldDataLayers' | 'fieldNotes' | 'fieldZones' | 'mapItemMagnitudes'> & { farm?: Maybe<ResolversTypes['FarmV2']>, fieldDataLayers?: Maybe<Array<Maybe<ResolversTypes['AnalyticsCollectionFieldDataLayer']>>>, fieldNotes?: Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, fieldZones?: Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, mapItemMagnitudes?: Maybe<Array<Maybe<ResolversTypes['AnalyticsCollectionMapItemMagnitude']>>> }>;
  AnalyticsCollectionFieldDataLayer: ResolverTypeWrapper<Omit<AnalyticsCollectionFieldDataLayer, 'fieldDataLayer'> & { fieldDataLayer?: Maybe<ResolversTypes['FieldDataLayer']> }>;
  AnalyticsCollectionMapItemMagnitude: ResolverTypeWrapper<Omit<AnalyticsCollectionMapItemMagnitude, 'fieldDataLayerMagnitude' | 'stacItemMagnitude'> & { fieldDataLayerMagnitude?: Maybe<ResolversTypes['AnalyticsCollectionFieldDataLayer']>, stacItemMagnitude?: Maybe<ResolversTypes['AnalyticsCollectionStacItem']> }>;
  AnalyticsCollectionStacItem: ResolverTypeWrapper<Omit<AnalyticsCollectionStacItem, 'stacItemRender'> & { stacItemRender?: Maybe<ResolversTypes['StacItemRender']> }>;
  AnalyticsCollectionType: AnalyticsCollectionType;
  AnomalyHistory: ResolverTypeWrapper<AnomalyHistory>;
  AnomalyVariableInfo: ResolverTypeWrapper<AnomalyVariableInfo>;
  AppConfig: ResolverTypeWrapper<AppConfig>;
  AppConfigObjectType: AppConfigObjectType;
  AppConfigValue: ResolverTypeWrapper<Scalars['AppConfigValue']['output']>;
  ApplicableColumn: ResolverTypeWrapper<ApplicableColumn>;
  ApplicableStress: ResolverTypeWrapper<ApplicableStress>;
  ApplicableUnit: ResolverTypeWrapper<ApplicableUnit>;
  ApplicationCategory: ApplicationCategory;
  ApplicationFieldZone: ResolverTypeWrapper<ApplicationFieldZone>;
  ApplicationMapZone: ResolverTypeWrapper<ApplicationMapZone>;
  ApplicationMode: ApplicationMode;
  ApplicationRecommendation: ResolverTypeWrapper<Omit<ApplicationRecommendation, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']> }>;
  ApplicationRecommendationStatus: ApplicationRecommendationStatus;
  ApplicationRecommendationType: ApplicationRecommendationType;
  ApplicationSpot: ResolverTypeWrapper<ApplicationSpot>;
  ApplicationStrategy: ApplicationStrategy;
  ApplicationType: ApplicationType;
  ApplicationWindow: ResolverTypeWrapper<Omit<ApplicationWindow, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  ApplicationWindowStatus: ApplicationWindowStatus;
  ApplicationWindowType: ApplicationWindowType;
  ApplicationZone: ResolverTypeWrapper<ApplicationZone>;
  AppliedWithWater: AppliedWithWater;
  ArableApiKey: ResolverTypeWrapper<ArableApiKey>;
  ArableDevice: ResolverTypeWrapper<ArableDevice>;
  ArableDeviceLatestMeasurement: ResolverTypeWrapper<ArableDeviceLatestMeasurement>;
  ArableDeviceToLocation: ResolverTypeWrapper<ArableDeviceToLocation>;
  ArvalisCalculationBasis: ResolverTypeWrapper<Omit<ArvalisCalculationBasis, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  ArvalisCustomEfficacyInformation: ResolverTypeWrapper<Omit<ArvalisCustomEfficacyInformation, 'dosedMap'> & { dosedMap?: Maybe<ResolversTypes['DosedMap']> }>;
  ArvalisDeviceProviderType: ArvalisDeviceProviderType;
  ArvalisDeviceToCropSeason: ResolverTypeWrapper<Omit<ArvalisDeviceToCropSeason, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  ArvalisInformation: ResolverTypeWrapper<Omit<ArvalisInformation, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  Assessment: ResolverTypeWrapper<Assessment>;
  AssessmentAttachment: ResolverTypeWrapper<AssessmentAttachment>;
  AssessmentData: ResolverTypeWrapper<Omit<AssessmentData, 'fieldZone'> & { fieldZone?: Maybe<ResolversTypes['FieldZone']> }>;
  AssessmentNote: ResolverTypeWrapper<Omit<AssessmentNote, 'assessmentTiming' | 'fieldZone'> & { assessmentTiming: ResolversTypes['AssessmentTiming'], fieldZone?: Maybe<ResolversTypes['FieldZone']> }>;
  AssessmentTiming: ResolverTypeWrapper<Omit<AssessmentTiming, 'scoutingTask'> & { scoutingTask?: Maybe<ResolversTypes['ScoutingTask']> }>;
  AvailableDosedMap: ResolverTypeWrapper<Omit<AvailableDosedMap, 'dosedMap'> & { dosedMap: ResolversTypes['DosedMap'] }>;
  AvailablePackage: ResolverTypeWrapper<Omit<AvailablePackage, 'crop' | 'package'> & { crop?: Maybe<ResolversTypes['Crop']>, package: ResolversTypes['Package'] }>;
  BBCHScale: ResolverTypeWrapper<BbchScale>;
  BagCount: ResolverTypeWrapper<BagCount>;
  BagUnit: BagUnit;
  BaseEntityAuditingType: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['BaseEntityAuditingType']>;
  BaselineMethod: BaselineMethod;
  BeforeSeasonRisk: ResolverTypeWrapper<Omit<BeforeSeasonRisk, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  BillingAddress: ResolverTypeWrapper<BillingAddress>;
  BiodiversityIndicator: ResolverTypeWrapper<Omit<BiodiversityIndicator, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  BiomassAnalysisNdvi: ResolverTypeWrapper<BiomassAnalysisNdvi>;
  BlacklistVariableInfo: ResolverTypeWrapper<BlacklistVariableInfo>;
  BonusPayoutFactor: BonusPayoutFactor;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BufferZones: ResolverTypeWrapper<BufferZones>;
  BusinessLineLicense: ResolverTypeWrapper<BusinessLineLicense>;
  BusinessLineLicensePackageQuota: ResolverTypeWrapper<BusinessLineLicensePackageQuota>;
  BusinessLinePurchaseAggregation: ResolverTypeWrapper<Omit<BusinessLinePurchaseAggregation, 'farm' | 'user'> & { farm?: Maybe<ResolversTypes['FarmV2']>, user?: Maybe<ResolversTypes['User']> }>;
  BusinessLinePurchaseSourceType: BusinessLinePurchaseSourceType;
  CalculationBase: CalculationBase;
  CalculationMode: CalculationMode;
  CalculationStatusCode: CalculationStatusCode;
  CarbonCredit: ResolverTypeWrapper<CarbonCredit>;
  CarbonFarmingRequest: ResolverTypeWrapper<Omit<CarbonFarmingRequest, 'cropSeason' | 'field' | 'sustainabilityProgram'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, field?: Maybe<ResolversTypes['FieldV2']>, sustainabilityProgram?: Maybe<ResolversTypes['SustainabilityProgram']> }>;
  CarbonFarmingRequestStatus: CarbonFarmingRequestStatus;
  CarbonFarmingSeason: ResolverTypeWrapper<CarbonFarmingSeason>;
  CarbonFarmingSeasonStatus: CarbonFarmingSeasonStatus;
  CarbonIntensityIndicator: ResolverTypeWrapper<CarbonIntensityIndicator>;
  CarbonIntensityIndicatorIssue: ResolverTypeWrapper<CarbonIntensityIndicatorIssue>;
  CarbonIntensityIndicatorIssueSeverity: CarbonIntensityIndicatorIssueSeverity;
  CarbonIntensityIndicatorStatus: CarbonIntensityIndicatorStatus;
  CarbonIntensityIndicatorTillagePractice: CarbonIntensityIndicatorTillagePractice;
  CarbonPlausibilityComment: ResolverTypeWrapper<Omit<CarbonPlausibilityComment, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CarbonRelatedDataTillage: ResolverTypeWrapper<CarbonRelatedDataTillage>;
  Category: ResolverTypeWrapper<Category>;
  CautionLevel: CautionLevel;
  ClaasConnectStatus: ResolverTypeWrapper<ClaasConnectStatus>;
  ClaasFarm: ResolverTypeWrapper<ClaasFarm>;
  ClaasField: ResolverTypeWrapper<ClaasField>;
  ClaasOrganization: ResolverTypeWrapper<ClaasOrganization>;
  ClaimAttachment: ResolverTypeWrapper<ClaimAttachment>;
  ClaimCategory: ResolverTypeWrapper<ClaimCategory>;
  ClaimEvaluation: ResolverTypeWrapper<ClaimEvaluation>;
  CnhCompany: ResolverTypeWrapper<CnhCompany>;
  CnhFarm: ResolverTypeWrapper<CnhFarm>;
  CnhField: ResolverTypeWrapper<CnhField>;
  CnhGrower: ResolverTypeWrapper<CnhGrower>;
  CnhTask: ResolverTypeWrapper<CnhTask>;
  CnhTaskType: CnhTaskType;
  Collaborator: ResolverTypeWrapper<Omit<Collaborator, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  Color: ResolverTypeWrapper<Scalars['Color']['output']>;
  ColorCx: ResolverTypeWrapper<Scalars['ColorCx']['output']>;
  CommercialPartnerPreOrderStatus: CommercialPartnerPreOrderStatus;
  CommercialPartnerPreOrderType: CommercialPartnerPreOrderType;
  Comparison: Comparison;
  ConfidenceLevel: ConfidenceLevel;
  ConnectionSource: ConnectionSource;
  ConnectionStatus: ConnectionStatus;
  ConnectivitySource: ResolverTypeWrapper<ConnectivitySource>;
  ContactInformation: ResolverTypeWrapper<ContactInformation>;
  Container: ResolverTypeWrapper<Container>;
  ContaminationState: ContaminationState;
  CountryCropGrowthStagePrediction: ResolverTypeWrapper<Omit<CountryCropGrowthStagePrediction, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CountryCropStressSetting: ResolverTypeWrapper<CountryCropStressSetting>;
  CountryWeed: ResolverTypeWrapper<CountryWeed>;
  CoverCrop: CoverCrop;
  CreationFlowHint: CreationFlowHint;
  CreditEligibility: ResolverTypeWrapper<CreditEligibility>;
  Criteria: Criteria;
  CriticalCropStageRisk: ResolverTypeWrapper<Omit<CriticalCropStageRisk, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  CriticalCropStageRiskInfo: ResolverTypeWrapper<Omit<CriticalCropStageRiskInfo, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  CriticalGrowthStagePeriodRisk: ResolverTypeWrapper<Omit<CriticalGrowthStagePeriodRisk, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  Crop: ResolverTypeWrapper<Omit<Crop, 'varieties'> & { varieties?: Maybe<Array<Maybe<ResolversTypes['Variety']>>> }>;
  CropDictCode: ResolverTypeWrapper<CropDictCode>;
  CropEstablishment: ResolverTypeWrapper<Omit<CropEstablishment, 'assignee' | 'cropSeasonV2' | 'dosedMap'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, dosedMap?: Maybe<ResolversTypes['DosedMap']> }>;
  CropEstablishmentDetails: ResolverTypeWrapper<Omit<CropEstablishmentDetails, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropGrowthStage: ResolverTypeWrapper<CropGrowthStage>;
  CropGrowthStageImage: ResolverTypeWrapper<CropGrowthStageImage>;
  CropGrowthStageV2: ResolverTypeWrapper<CropGrowthStageV2>;
  CropMix: ResolverTypeWrapper<CropMix>;
  CropMixDetail: ResolverTypeWrapper<Omit<CropMixDetail, 'crop' | 'variety'> & { crop?: Maybe<ResolversTypes['Crop']>, variety?: Maybe<ResolversTypes['Variety']> }>;
  CropNutritionReportConfiguration: ResolverTypeWrapper<Omit<CropNutritionReportConfiguration, 'cover'> & { cover: ResolversTypes['CropNutritionReportCoverConfiguration'] }>;
  CropNutritionReportCoverConfiguration: ResolverTypeWrapper<Omit<CropNutritionReportCoverConfiguration, 'coverImage'> & { coverImage?: Maybe<ResolversTypes['File']> }>;
  CropNutritionReportFarmSummaryConfiguration: ResolverTypeWrapper<CropNutritionReportFarmSummaryConfiguration>;
  CropNutritionReportFieldDetailsConfiguration: ResolverTypeWrapper<CropNutritionReportFieldDetailsConfiguration>;
  CropResidueManagementTask: ResolverTypeWrapper<Omit<CropResidueManagementTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeason: ResolverTypeWrapper<Omit<CropSeason, 'actionRecommendationAggregations' | 'actionRecommendations' | 'crop' | 'field' | 'fieldV2' | 'nutritionRecommendations' | 'nutritionStatus' | 'observations' | 'protectionTimes' | 'recommendationSnoozes' | 'sourceMaps' | 'sprayings' | 'sprayingsV2' | 'timingStressesInfo' | 'variety' | 'weedManagementRecommendations' | 'weedRisk'> & { actionRecommendationAggregations?: Maybe<Array<Maybe<ResolversTypes['ActionRecommendationAggregation']>>>, actionRecommendations?: Maybe<Array<Maybe<ResolversTypes['ActionRecommendation']>>>, crop?: Maybe<ResolversTypes['Crop']>, field: ResolversTypes['Field'], fieldV2: ResolversTypes['FieldV2'], nutritionRecommendations?: Maybe<Array<Maybe<ResolversTypes['NutritionRecommendation']>>>, nutritionStatus?: Maybe<Array<Maybe<ResolversTypes['NutritionStatus']>>>, observations?: Maybe<Array<Maybe<ResolversTypes['Observation']>>>, protectionTimes?: Maybe<Array<Maybe<ResolversTypes['ProtectionTime']>>>, recommendationSnoozes?: Maybe<Array<Maybe<ResolversTypes['RecommendationSnooze']>>>, sourceMaps?: Maybe<Array<Maybe<ResolversTypes['SourceMap']>>>, sprayings?: Maybe<Array<Maybe<ResolversTypes['Spraying']>>>, sprayingsV2?: Maybe<Array<Maybe<ResolversTypes['SprayingV2']>>>, timingStressesInfo?: Maybe<Array<Maybe<ResolversTypes['TimingStressInfo']>>>, variety?: Maybe<ResolversTypes['Variety']>, weedManagementRecommendations?: Maybe<Array<Maybe<ResolversTypes['WeedManagementRecommendation']>>>, weedRisk?: Maybe<ResolversTypes['WeedRisk']> }>;
  CropSeasonData: ResolverTypeWrapper<Omit<CropSeasonData, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeasonNutritionProgram: ResolverTypeWrapper<Omit<CropSeasonNutritionProgram, 'cropSeason' | 'cropSystemRecommendation' | 'cropSystemRecommendationV2'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, cropSystemRecommendation?: Maybe<ResolversTypes['CropSystemRecommendation']>, cropSystemRecommendationV2?: Maybe<ResolversTypes['CropSystemRecommendationV2']> }>;
  CropSeasonNutritionProgramExecutionStatus: ResolverTypeWrapper<Omit<CropSeasonNutritionProgramExecutionStatus, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeasonNutritionRecommendation: ResolverTypeWrapper<Omit<CropSeasonNutritionRecommendation, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeasonStatus: ResolverTypeWrapper<Omit<CropSeasonStatus, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  CropSeasonStatusReportEmailSubscription: ResolverTypeWrapper<Omit<CropSeasonStatusReportEmailSubscription, 'farmV2'> & { farmV2: ResolversTypes['FarmV2'] }>;
  CropSeasonStatusState: CropSeasonStatusState;
  CropSeasonStatusType: CropSeasonStatusType;
  CropSeasonTreatmentProgram: ResolverTypeWrapper<Omit<CropSeasonTreatmentProgram, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeasonTreatmentProgramExecutionStatus: ResolverTypeWrapper<Omit<CropSeasonTreatmentProgramExecutionStatus, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeasonTreatmentProgramV2: ResolverTypeWrapper<Omit<CropSeasonTreatmentProgramV2, 'actionDetails' | 'cropSeason'> & { actionDetails?: Maybe<Array<Maybe<ResolversTypes['ActionDetailV2']>>>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeasonTreatmentProgramV3: ResolverTypeWrapper<Omit<CropSeasonTreatmentProgramV3, 'crop' | 'cropSeason'> & { crop?: Maybe<ResolversTypes['Crop']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSeasonV2: ResolverTypeWrapper<Omit<CropSeasonV2, 'actionRecommendationAggregations' | 'actionRecommendations' | 'activeCountryCropGrowthStage' | 'additionalInfectionRiskFactor' | 'agBalanceFieldEmissionIndicator' | 'aggregatedPestDevelopmentPredictions' | 'arvalisCalculationBasis' | 'arvalisDeviceToCropSeason' | 'arvalisInformation' | 'beforeSeasonRisks' | 'biodiversityIndicator' | 'carbonPlausibilityComment' | 'countryCropGrowthStagePredictions' | 'creator' | 'criticalCropStageRiskInfos' | 'criticalCropStageRisks' | 'criticalGrowthStagePeriodRisks' | 'crop' | 'cropEstablishmentDetails' | 'cropEstablishments' | 'cropResidueManagementTasks' | 'cropSeasonNutritionProgram' | 'cropSeasonNutritionProgramExecutionStatus' | 'cropSeasonTreatmentProgram' | 'cropSeasonTreatmentProgramExecutionStatus' | 'cropSeasonTreatmentProgramV2' | 'cropSeasonTreatmentProgramV3' | 'cropSeasonWaterManagementProgram' | 'cropWaterAvailabilities' | 'customPowerzoneOrders' | 'dailyFungusDetails' | 'dailyStressCharacteristics' | 'dailyStressEventProbabilities' | 'dailyWeedRiskDetails' | 'dryMatterAnalysis' | 'fieldDataLayers' | 'fieldV2' | 'fieldVariabilityIndexes' | 'fieldVariabilityInput' | 'frostRisks' | 'greenhouseWhiteningTasks' | 'growthStagePredictionDaily' | 'harvests' | 'hfClaims' | 'hfOfferCondition' | 'hfPrice' | 'hfServiceRequests' | 'hortaCropSeason' | 'hortaSustainabilityIndicator' | 'landPreparations' | 'leafPruningTasks' | 'modifier' | 'nextCountryCropGrowthStage' | 'nutritionRecommendations' | 'nutritionStatus' | 'observations' | 'operationalInstructions' | 'pestDevelopmentPredictions' | 'preCrop' | 'produceDeliveryTasks' | 'projectedIncidences' | 'protectionTimes' | 'recommendationSnoozes' | 'risksV2' | 'scoutingTasks' | 'seedBoxTreatments' | 'seedTreatmentTasks' | 'smartSprayingTasks' | 'smartSprayingTasksV2' | 'soilSamplingTasks' | 'sourceMaps' | 'sprayingsV2' | 'stressEfficacyCharacteristics' | 'stressSettings' | 'sustainabilityIndicator' | 'sustainabilityInput' | 'taskAggregations' | 'timingCalculationStatus' | 'timingProductRecommendations' | 'timingStressesInfo' | 'toppingTasks' | 'trials' | 'variety' | 'waterBalances' | 'waterManagementTasks' | 'waterRecommendations' | 'waterStatus' | 'weedManagementRecommendations' | 'weedRisk' | 'weedStatus' | 'yieldPrediction'> & { actionRecommendationAggregations?: Maybe<Array<Maybe<ResolversTypes['ActionRecommendationAggregation']>>>, actionRecommendations?: Maybe<Array<Maybe<ResolversTypes['ActionRecommendation']>>>, activeCountryCropGrowthStage?: Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>, additionalInfectionRiskFactor?: Maybe<ResolversTypes['AdditionalInfectionRiskFactor']>, agBalanceFieldEmissionIndicator?: Maybe<ResolversTypes['AgBalanceFieldEmissionIndicator']>, aggregatedPestDevelopmentPredictions?: Maybe<Array<Maybe<ResolversTypes['AggregatedPestDevelopmentPrediction']>>>, arvalisCalculationBasis?: Maybe<ResolversTypes['ArvalisCalculationBasis']>, arvalisDeviceToCropSeason?: Maybe<ResolversTypes['ArvalisDeviceToCropSeason']>, arvalisInformation?: Maybe<ResolversTypes['ArvalisInformation']>, beforeSeasonRisks?: Maybe<Array<ResolversTypes['BeforeSeasonRisk']>>, biodiversityIndicator?: Maybe<ResolversTypes['BiodiversityIndicator']>, carbonPlausibilityComment?: Maybe<ResolversTypes['CarbonPlausibilityComment']>, countryCropGrowthStagePredictions?: Maybe<Array<Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>>>, creator?: Maybe<ResolversTypes['User']>, criticalCropStageRiskInfos?: Maybe<Array<Maybe<ResolversTypes['CriticalCropStageRiskInfo']>>>, criticalCropStageRisks?: Maybe<Array<Maybe<ResolversTypes['CriticalCropStageRisk']>>>, criticalGrowthStagePeriodRisks?: Maybe<Array<Maybe<ResolversTypes['CriticalGrowthStagePeriodRisk']>>>, crop?: Maybe<ResolversTypes['Crop']>, cropEstablishmentDetails?: Maybe<ResolversTypes['CropEstablishmentDetails']>, cropEstablishments?: Maybe<Array<ResolversTypes['CropEstablishment']>>, cropResidueManagementTasks?: Maybe<Array<ResolversTypes['CropResidueManagementTask']>>, cropSeasonNutritionProgram?: Maybe<ResolversTypes['CropSeasonNutritionProgram']>, cropSeasonNutritionProgramExecutionStatus?: Maybe<ResolversTypes['CropSeasonNutritionProgramExecutionStatus']>, cropSeasonTreatmentProgram?: Maybe<ResolversTypes['CropSeasonTreatmentProgram']>, cropSeasonTreatmentProgramExecutionStatus?: Maybe<ResolversTypes['CropSeasonTreatmentProgramExecutionStatus']>, cropSeasonTreatmentProgramV2?: Maybe<ResolversTypes['CropSeasonTreatmentProgramV2']>, cropSeasonTreatmentProgramV3?: Maybe<ResolversTypes['CropSeasonTreatmentProgramV3']>, cropSeasonWaterManagementProgram?: Maybe<ResolversTypes['CropSeasonWaterManagementProgram']>, cropWaterAvailabilities?: Maybe<Array<Maybe<ResolversTypes['CropWaterAvailability']>>>, customPowerzoneOrders?: Maybe<Array<Maybe<ResolversTypes['CustomPowerzoneOrder']>>>, dailyFungusDetails?: Maybe<Array<Maybe<ResolversTypes['DailyFungusDetails']>>>, dailyStressCharacteristics?: Maybe<Array<Maybe<ResolversTypes['DailyStressCharacteristics']>>>, dailyStressEventProbabilities?: Maybe<Array<Maybe<ResolversTypes['DailyStressEventProbability']>>>, dailyWeedRiskDetails?: Maybe<Array<Maybe<ResolversTypes['DailyWeedRiskDetails']>>>, dryMatterAnalysis?: Maybe<Array<Maybe<ResolversTypes['DryMatterAnalysis']>>>, fieldDataLayers?: Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, fieldV2: ResolversTypes['FieldV2'], fieldVariabilityIndexes?: Maybe<Array<Maybe<ResolversTypes['FieldVariabilityIndex']>>>, fieldVariabilityInput?: Maybe<ResolversTypes['FieldVariabilityInput']>, frostRisks?: Maybe<Array<Maybe<ResolversTypes['FrostRisk']>>>, greenhouseWhiteningTasks?: Maybe<Array<ResolversTypes['GreenhouseWhiteningTask']>>, growthStagePredictionDaily?: Maybe<Array<Maybe<ResolversTypes['GrowthStagePredictionDaily']>>>, harvests?: Maybe<Array<ResolversTypes['Harvest']>>, hfClaims?: Maybe<Array<Maybe<ResolversTypes['HfClaim']>>>, hfOfferCondition?: Maybe<ResolversTypes['HfOfferCondition']>, hfPrice?: Maybe<ResolversTypes['HfPrice']>, hfServiceRequests?: Maybe<Array<Maybe<ResolversTypes['HFServiceRequest']>>>, hortaCropSeason?: Maybe<ResolversTypes['HortaCropSeason']>, hortaSustainabilityIndicator?: Maybe<ResolversTypes['HortaSustainabilityIndicator']>, landPreparations?: Maybe<Array<ResolversTypes['LandPreparation']>>, leafPruningTasks?: Maybe<Array<ResolversTypes['LeafPruningTask']>>, modifier?: Maybe<ResolversTypes['User']>, nextCountryCropGrowthStage?: Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>, nutritionRecommendations?: Maybe<Array<Maybe<ResolversTypes['NutritionRecommendation']>>>, nutritionStatus?: Maybe<Array<Maybe<ResolversTypes['NutritionStatus']>>>, observations?: Maybe<Array<ResolversTypes['Observation']>>, operationalInstructions?: Maybe<Array<Maybe<ResolversTypes['HfOperationalInstruction']>>>, pestDevelopmentPredictions?: Maybe<Array<Maybe<ResolversTypes['PestDevelopmentPrediction']>>>, preCrop?: Maybe<ResolversTypes['Crop']>, produceDeliveryTasks?: Maybe<Array<Maybe<ResolversTypes['ProduceDeliveryTask']>>>, projectedIncidences?: Maybe<Array<Maybe<ResolversTypes['ProjectedIncidences']>>>, protectionTimes?: Maybe<Array<Maybe<ResolversTypes['ProtectionTime']>>>, recommendationSnoozes?: Maybe<Array<Maybe<ResolversTypes['RecommendationSnooze']>>>, risksV2?: Maybe<Array<Maybe<ResolversTypes['RiskV2']>>>, scoutingTasks?: Maybe<Array<ResolversTypes['ScoutingTask']>>, seedBoxTreatments?: Maybe<Array<ResolversTypes['SeedBoxTreatment']>>, seedTreatmentTasks?: Maybe<Array<ResolversTypes['SeedTreatment']>>, smartSprayingTasks?: Maybe<Array<ResolversTypes['SmartSprayingTask']>>, smartSprayingTasksV2?: Maybe<Array<ResolversTypes['SmartSprayingTaskV2']>>, soilSamplingTasks?: Maybe<Array<Maybe<ResolversTypes['SoilSamplingTask']>>>, sourceMaps?: Maybe<Array<Maybe<ResolversTypes['SourceMap']>>>, sprayingsV2?: Maybe<Array<ResolversTypes['SprayingV2']>>, stressEfficacyCharacteristics?: Maybe<Array<Maybe<ResolversTypes['StressEfficacyCharacteristics']>>>, stressSettings?: Maybe<ResolversTypes['StressSettings']>, sustainabilityIndicator?: Maybe<ResolversTypes['SustainabilityIndicator']>, sustainabilityInput?: Maybe<ResolversTypes['SustainabilityInput']>, taskAggregations?: Maybe<Array<Maybe<ResolversTypes['TaskAggregation']>>>, timingCalculationStatus?: Maybe<ResolversTypes['TimingCalculationStatus']>, timingProductRecommendations?: Maybe<Array<ResolversTypes['TimingProductRecommendation']>>, timingStressesInfo?: Maybe<Array<Maybe<ResolversTypes['TimingStressInfo']>>>, toppingTasks?: Maybe<Array<ResolversTypes['ToppingTask']>>, trials?: Maybe<Array<Maybe<ResolversTypes['Trial']>>>, variety?: Maybe<ResolversTypes['Variety']>, waterBalances?: Maybe<Array<Maybe<ResolversTypes['WaterBalance']>>>, waterManagementTasks?: Maybe<Array<ResolversTypes['WaterManagementTask']>>, waterRecommendations?: Maybe<Array<Maybe<ResolversTypes['WaterRecommendation']>>>, waterStatus?: Maybe<Array<Maybe<ResolversTypes['WaterStatus']>>>, weedManagementRecommendations?: Maybe<Array<Maybe<ResolversTypes['WeedManagementRecommendation']>>>, weedRisk?: Maybe<ResolversTypes['WeedRisk']>, weedStatus?: Maybe<Array<Maybe<ResolversTypes['WeedStatus']>>>, yieldPrediction?: Maybe<ResolversTypes['YieldPrediction']> }>;
  CropSeasonWaterManagementProgram: ResolverTypeWrapper<Omit<CropSeasonWaterManagementProgram, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CropSystemRecommendation: ResolverTypeWrapper<Omit<CropSystemRecommendation, 'cropSeasons' | 'soilSamplingResult'> & { cropSeasons?: Maybe<Array<Maybe<ResolversTypes['CropSeasonData']>>>, soilSamplingResult?: Maybe<ResolversTypes['SoilSamplingResult']> }>;
  CropSystemRecommendationActionDetail: ResolverTypeWrapper<CropSystemRecommendationActionDetail>;
  CropSystemRecommendationRequest: ResolverTypeWrapper<CropSystemRecommendationRequest>;
  CropSystemRecommendationV2: ResolverTypeWrapper<Omit<CropSystemRecommendationV2, 'cropSeasons' | 'soilSamplingResult'> & { cropSeasons?: Maybe<Array<Maybe<ResolversTypes['CropSeasonData']>>>, soilSamplingResult?: Maybe<ResolversTypes['SoilSamplingResult']> }>;
  CropTankMixSummary: ResolverTypeWrapper<CropTankMixSummary>;
  CropUsage: ResolverTypeWrapper<CropUsage>;
  CropWaterAvailability: ResolverTypeWrapper<Omit<CropWaterAvailability, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  CurrentWeedPrediction: ResolverTypeWrapper<Omit<CurrentWeedPrediction, 'fieldV2'> & { fieldV2?: Maybe<ResolversTypes['FieldV2']> }>;
  CustomPowerzoneOrder: ResolverTypeWrapper<Omit<CustomPowerzoneOrder, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  CustomPowerzoneStatus: CustomPowerzoneStatus;
  CustomPowerzoneTimeWindow: ResolverTypeWrapper<CustomPowerzoneTimeWindow>;
  CustomPowerzoneType: CustomPowerzoneType;
  DailyFungusDetails: ResolverTypeWrapper<Omit<DailyFungusDetails, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  DailyStressCharacteristics: ResolverTypeWrapper<Omit<DailyStressCharacteristics, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  DailyStressCharacteristicsStatus: DailyStressCharacteristicsStatus;
  DailyStressCharacteristicsSubType: DailyStressCharacteristicsSubType;
  DailyStressCharacteristicsType: DailyStressCharacteristicsType;
  DailyStressEventProbability: ResolverTypeWrapper<Omit<DailyStressEventProbability, 'cropSeasonV2'> & { cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  DailyStressEventProbabilityStatus: DailyStressEventProbabilityStatus;
  DailyStressEventProbabilityType: DailyStressEventProbabilityType;
  DailyWeedRiskDetails: ResolverTypeWrapper<Omit<DailyWeedRiskDetails, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  DataReliability: DataReliability;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DeliveryDay: DeliveryDay;
  DemandEquationProduct: ResolverTypeWrapper<DemandEquationProduct>;
  DemandEquationRecommendation: ResolverTypeWrapper<Omit<DemandEquationRecommendation, 'cropSeason' | 'soilSamplingResult'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, soilSamplingResult?: Maybe<ResolversTypes['SoilSamplingResult']> }>;
  DemandEquationRecommendationV2: ResolverTypeWrapper<Omit<DemandEquationRecommendationV2, 'cropSeason' | 'soilSamplingResult'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, soilSamplingResult?: Maybe<ResolversTypes['SoilSamplingResult']> }>;
  DemandEquationSamplingArea: ResolverTypeWrapper<DemandEquationSamplingArea>;
  DemandEquationSamplingAreaProduct: ResolverTypeWrapper<DemandEquationSamplingAreaProduct>;
  DemandEquationZone: ResolverTypeWrapper<DemandEquationZone>;
  DescriptionAndSymptom: ResolverTypeWrapper<Omit<DescriptionAndSymptom, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  DetectedDisease: ResolverTypeWrapper<DetectedDisease>;
  DetectedNitrogenStatus: ResolverTypeWrapper<DetectedNitrogenStatus>;
  DetectedPest: ResolverTypeWrapper<DetectedPest>;
  DetectedWeed: ResolverTypeWrapper<DetectedWeed>;
  DevelopmentStage: DevelopmentStage;
  DeviceFeature: ResolverTypeWrapper<Omit<DeviceFeature, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  DeviceHealthStatus: DeviceHealthStatus;
  DevicePackage: ResolverTypeWrapper<DevicePackage>;
  DeviceScope: DeviceScope;
  DictcodeFeature: ResolverTypeWrapper<DictcodeFeature>;
  DictcodeHierarchy: ResolverTypeWrapper<DictcodeHierarchy>;
  Dictionary: ResolverTypeWrapper<Dictionary>;
  DisabledHistory: ResolverTypeWrapper<DisabledHistory>;
  DiseaseIdentificationResult: ResolverTypeWrapper<DiseaseIdentificationResult>;
  DistributorPartner: DistributorPartner;
  DoseKey: DoseKey;
  DosedMap: ResolverTypeWrapper<Omit<DosedMap, 'additives' | 'cropSeason' | 'cropSeasonV2' | 'fieldZones' | 'sourceMap'> & { additives?: Maybe<Array<Maybe<ResolversTypes['AdditiveRate']>>>, cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'], fieldZones?: Maybe<Array<Maybe<ResolversTypes['MappingFieldZone']>>>, sourceMap?: Maybe<ResolversTypes['SourceMap']> }>;
  DosedMapEquipmentType: DosedMapEquipmentType;
  DosedMapInput: DosedMapInput;
  DosedMapLegend: ResolverTypeWrapper<DosedMapLegend>;
  DosedMapLegendEntry: ResolverTypeWrapper<DosedMapLegendEntry>;
  DosedMapPreviewFormat: DosedMapPreviewFormat;
  DosedMapProductSummary: ResolverTypeWrapper<DosedMapProductSummary>;
  DroneFlight: ResolverTypeWrapper<Omit<DroneFlight, 'abLine' | 'assignee' | 'cropSeason' | 'cropSeasonV2'> & { abLine?: Maybe<ResolversTypes['AbLine']>, assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  DroneFlightError: ResolverTypeWrapper<DroneFlightError>;
  DroneFlightErrorCode: DroneFlightErrorCode;
  DroneFlightGridSize: DroneFlightGridSize;
  DroneFlightMapType: DroneFlightMapType;
  DroneFlightOrthomosaic: ResolverTypeWrapper<DroneFlightOrthomosaic>;
  DroneFlightQuota: ResolverTypeWrapper<Omit<DroneFlightQuota, 'droneFlightQuotaTransfers' | 'farmV2'> & { droneFlightQuotaTransfers?: Maybe<Array<Maybe<ResolversTypes['DroneFlightQuotaTransfer']>>>, farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  DroneFlightQuotaTransfer: ResolverTypeWrapper<DroneFlightQuotaTransfer>;
  DroneFlightStatus: DroneFlightStatus;
  DroneFlightSummary: ResolverTypeWrapper<DroneFlightSummary>;
  DronePlantingFailureMap: ResolverTypeWrapper<Omit<DronePlantingFailureMap, 'droneFlightQuota'> & { droneFlightQuota?: Maybe<ResolversTypes['DroneFlightQuota']> }>;
  DroneSprayerWeedMap: ResolverTypeWrapper<Omit<DroneSprayerWeedMap, 'droneFlightQuota'> & { droneFlightQuota?: Maybe<ResolversTypes['DroneFlightQuota']> }>;
  DryMatterAnalysis: ResolverTypeWrapper<Omit<DryMatterAnalysis, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  DryMatterAnalysisType: DryMatterAnalysisType;
  DtnVendor: DtnVendor;
  DtnVendorDevice: ResolverTypeWrapper<Omit<DtnVendorDevice, 'dtnVendorDeviceToLocations' | 'dtnVendorDeviceToLocationsV2' | 'dtnVendorLatestMeasurement'> & { dtnVendorDeviceToLocations?: Maybe<Array<Maybe<ResolversTypes['DtnVendorDeviceToLocation']>>>, dtnVendorDeviceToLocationsV2?: Maybe<Array<Maybe<ResolversTypes['DtnVendorDeviceToLocationV2']>>>, dtnVendorLatestMeasurement?: Maybe<ResolversTypes['DtnVendorDeviceLatestMeasurement']> }>;
  DtnVendorDeviceActivation: ResolverTypeWrapper<Omit<DtnVendorDeviceActivation, 'creator' | 'device'> & { creator?: Maybe<ResolversTypes['User']>, device: ResolversTypes['DtnVendorDevice'] }>;
  DtnVendorDeviceLatestMeasurement: ResolverTypeWrapper<Omit<DtnVendorDeviceLatestMeasurement, 'device'> & { device: ResolversTypes['DtnVendorDevice'] }>;
  DtnVendorDeviceToLocation: ResolverTypeWrapper<Omit<DtnVendorDeviceToLocation, 'creator' | 'device'> & { creator?: Maybe<ResolversTypes['User']>, device: ResolversTypes['DtnVendorDevice'] }>;
  DtnVendorDeviceToLocationV2: ResolverTypeWrapper<Omit<DtnVendorDeviceToLocationV2, 'creator' | 'device'> & { creator?: Maybe<ResolversTypes['User']>, device: ResolversTypes['DtnVendorDevice'] }>;
  DtnVendorKey: ResolverTypeWrapper<Omit<DtnVendorKey, 'creator' | 'user'> & { creator?: Maybe<ResolversTypes['User']>, user?: Maybe<ResolversTypes['User']> }>;
  DtnVendorKeyDevice: ResolverTypeWrapper<DtnVendorKeyDevice>;
  EmailSubscriptionStatus: EmailSubscriptionStatus;
  EmergenceAnalysisImageResult: ResolverTypeWrapper<EmergenceAnalysisImageResult>;
  EmergenceAnalysisResult: ResolverTypeWrapper<EmergenceAnalysisResult>;
  EntityHistory: ResolverTypeWrapper<Omit<EntityHistory, 'modifiedBy'> & { modifiedBy?: Maybe<ResolversTypes['User']> }>;
  EntityModification: ResolverTypeWrapper<EntityModification>;
  EquipmentType: EquipmentType;
  ErrorCode: ErrorCode;
  EscalationContact: ResolverTypeWrapper<EscalationContact>;
  EstablishmentMethod: EstablishmentMethod;
  EvidenceExpectedYieldProofType: EvidenceExpectedYieldProofType;
  EvidenceFile: ResolverTypeWrapper<EvidenceFile>;
  EvidenceFileSource: EvidenceFileSource;
  EvidenceFiles: ResolverTypeWrapper<EvidenceFiles>;
  EvidenceLivestockType: EvidenceLivestockType;
  EvidenceManagementSystem: EvidenceManagementSystem;
  EvidenceManureType: EvidenceManureType;
  EvidenceReceipt: ResolverTypeWrapper<EvidenceReceipt>;
  ExatrekApplicationMapDispatchOrder: ResolverTypeWrapper<ExatrekApplicationMapDispatchOrder>;
  ExatrekApplicationMapDispatchOrderFormat: ExatrekApplicationMapDispatchOrderFormat;
  ExatrekApplicationMapDispatchOrderStatus: ExatrekApplicationMapDispatchOrderStatus;
  ExatrekApplicationMapDispatchOrderTaskType: ExatrekApplicationMapDispatchOrderTaskType;
  ExatrekDeviceState: ResolverTypeWrapper<Omit<ExatrekDeviceState, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  ExatrekDeviceStatePosition: ResolverTypeWrapper<ExatrekDeviceStatePosition>;
  ExatrekUsbMode: ExatrekUsbMode;
  ExatrekUserDevice: ResolverTypeWrapper<Omit<ExatrekUserDevice, 'deviceState' | 'user'> & { deviceState?: Maybe<ResolversTypes['ExatrekDeviceState']>, user?: Maybe<ResolversTypes['User']> }>;
  ExatrekUserMachine: ResolverTypeWrapper<Omit<ExatrekUserMachine, 'userDevice'> & { userDevice: ResolversTypes['ExatrekUserDevice'] }>;
  ExecutionStatus: ExecutionStatus;
  ExecutionZoneStrategy: ResolverTypeWrapper<ExecutionZoneStrategy>;
  ExistingOrder: ResolverTypeWrapper<Omit<ExistingOrder, 'farm' | 'shopUserPackages'> & { farm?: Maybe<ResolversTypes['FarmV2']>, shopUserPackages?: Maybe<Array<Maybe<ResolversTypes['ShopUserPackage']>>> }>;
  ExportOrder: ResolverTypeWrapper<ExportOrder>;
  ExportOrderStatus: ExportOrderStatus;
  FDLSourceUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FDLSourceUnion']>;
  FactorLevelFieldZoneMapping: ResolverTypeWrapper<Omit<FactorLevelFieldZoneMapping, 'fieldZone'> & { fieldZone?: Maybe<ResolversTypes['FieldZone']> }>;
  FailureMap: ResolverTypeWrapper<FailureMap>;
  Farm: ResolverTypeWrapper<Omit<Farm, 'billingAddress' | 'fields' | 'fieldsV2' | 'shippingAddress'> & { billingAddress?: Maybe<ResolversTypes['Address']>, fields: Array<Maybe<ResolversTypes['Field']>>, fieldsV2: Array<Maybe<ResolversTypes['FieldV2']>>, shippingAddress?: Maybe<ResolversTypes['Address']> }>;
  FarmCarbonIntensityIndicator: ResolverTypeWrapper<FarmCarbonIntensityIndicator>;
  FarmCountryCropGrowthStagePredictions: ResolverTypeWrapper<Omit<FarmCountryCropGrowthStagePredictions, 'farm' | 'growthStages'> & { farm?: Maybe<ResolversTypes['FarmV2']>, growthStages?: Maybe<Array<Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>>> }>;
  FarmCropMetrics: ResolverTypeWrapper<Omit<FarmCropMetrics, 'crop' | 'farm'> & { crop?: Maybe<ResolversTypes['Crop']>, farm?: Maybe<ResolversTypes['FarmV2']> }>;
  FarmDataLayer: ResolverTypeWrapper<FarmDataLayer>;
  FarmDataLayerLegend: ResolverTypeWrapper<FarmDataLayerLegend>;
  FarmEvidence: ResolverTypeWrapper<FarmEvidence>;
  FarmEvidenceAcceptedTerm: ResolverTypeWrapper<FarmEvidenceAcceptedTerm>;
  FarmEvidenceAcceptedTerms: ResolverTypeWrapper<FarmEvidenceAcceptedTerms>;
  FarmEvidenceAgExpertStatement: ResolverTypeWrapper<FarmEvidenceAgExpertStatement>;
  FarmEvidenceAgExpertStatements: ResolverTypeWrapper<FarmEvidenceAgExpertStatements>;
  FarmEvidenceAudit: ResolverTypeWrapper<FarmEvidenceAudit>;
  FarmEvidenceAudits: ResolverTypeWrapper<FarmEvidenceAudits>;
  FarmEvidenceAverageCiScore: ResolverTypeWrapper<FarmEvidenceAverageCiScore>;
  FarmEvidenceCertification: ResolverTypeWrapper<FarmEvidenceCertification>;
  FarmEvidenceCertifications: ResolverTypeWrapper<FarmEvidenceCertifications>;
  FarmEvidenceCropScore: ResolverTypeWrapper<FarmEvidenceCropScore>;
  FarmEvidenceFieldBuckets: ResolverTypeWrapper<FarmEvidenceFieldBuckets>;
  FarmEvidenceFieldCount: ResolverTypeWrapper<FarmEvidenceFieldCount>;
  FarmEvidenceLink: ResolverTypeWrapper<FarmEvidenceLink>;
  FarmEvidenceLinkRecordType: FarmEvidenceLinkRecordType;
  FarmEvidenceLinkSort: FarmEvidenceLinkSort;
  FarmEvidenceLinkSortColumn: FarmEvidenceLinkSortColumn;
  FarmEvidenceLinks: ResolverTypeWrapper<FarmEvidenceLinks>;
  FarmEvidenceManureSource: ResolverTypeWrapper<FarmEvidenceManureSource>;
  FarmEvidenceManureSources: ResolverTypeWrapper<FarmEvidenceManureSources>;
  FarmEvidenceProgram: ResolverTypeWrapper<FarmEvidenceProgram>;
  FarmEvidenceRecords: ResolverTypeWrapper<FarmEvidenceRecords>;
  FarmEvidenceRecordsState: FarmEvidenceRecordsState;
  FarmFeature: ResolverTypeWrapper<Omit<FarmFeature, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  FarmFeatures: ResolverTypeWrapper<FarmFeatures>;
  FarmFeaturesStatus: FarmFeaturesStatus;
  FarmFeaturesSummary: ResolverTypeWrapper<Omit<FarmFeaturesSummary, 'farm'> & { farm: ResolversTypes['FarmV2'] }>;
  FarmGreetCarbonIntensityScore: ResolverTypeWrapper<FarmGreetCarbonIntensityScore>;
  FarmLayerSummaryCount: ResolverTypeWrapper<FarmLayerSummaryCount>;
  FarmPackage: ResolverTypeWrapper<FarmPackage>;
  FarmPackageConsumption: ResolverTypeWrapper<FarmPackageConsumption>;
  FarmPackageQuantityType: FarmPackageQuantityType;
  FarmPackageSourceType: FarmPackageSourceType;
  FarmPackageType: FarmPackageType;
  FarmReceipt: ResolverTypeWrapper<Omit<FarmReceipt, 'creator' | 'farmV2'> & { creator?: Maybe<ResolversTypes['User']>, farmV2: ResolversTypes['FarmV2'] }>;
  FarmReceiptKind: FarmReceiptKind;
  FarmReceiptReference: ResolverTypeWrapper<Omit<FarmReceiptReference, 'creator'> & { creator?: Maybe<ResolversTypes['User']> }>;
  FarmReceiptReferenceObjectType: FarmReceiptReferenceObjectType;
  FarmType: FarmType;
  FarmUuid: ResolverTypeWrapper<FarmUuid>;
  FarmV2: ResolverTypeWrapper<Omit<FarmV2, 'billingAddress' | 'collaborators' | 'creator' | 'cropNutritionReportConfiguration' | 'cropSeasonStatusReportEmailSubscriptions' | 'currentUserPermission' | 'droneFlightQuotas' | 'existingOrders' | 'farmActiveGrowthStages' | 'fieldsV2' | 'grower' | 'hfAlerts' | 'hfDiscounts' | 'hfServiceRequests' | 'importOrders' | 'jdNotificationSubscriptions' | 'kwsConsent' | 'latestScoutingTask' | 'owner' | 'recentlyUsedProducts' | 'shippingAddress'> & { billingAddress?: Maybe<ResolversTypes['Address']>, collaborators?: Maybe<Array<Maybe<ResolversTypes['Collaborator']>>>, creator?: Maybe<ResolversTypes['User']>, cropNutritionReportConfiguration?: Maybe<ResolversTypes['CropNutritionReportConfiguration']>, cropSeasonStatusReportEmailSubscriptions?: Maybe<Array<Maybe<ResolversTypes['CropSeasonStatusReportEmailSubscription']>>>, currentUserPermission?: Maybe<ResolversTypes['Permission']>, droneFlightQuotas?: Maybe<Array<Maybe<ResolversTypes['DroneFlightQuota']>>>, existingOrders?: Maybe<Array<Maybe<ResolversTypes['ExistingOrder']>>>, farmActiveGrowthStages?: Maybe<ResolversTypes['FarmCountryCropGrowthStagePredictions']>, fieldsV2?: Maybe<Array<ResolversTypes['FieldV2']>>, grower?: Maybe<ResolversTypes['Collaborator']>, hfAlerts?: Maybe<Array<Maybe<ResolversTypes['HfAlert']>>>, hfDiscounts?: Maybe<Array<Maybe<ResolversTypes['HfDiscount']>>>, hfServiceRequests?: Maybe<Array<Maybe<ResolversTypes['HFServiceRequest']>>>, importOrders?: Maybe<Array<Maybe<ResolversTypes['ImportOrder']>>>, jdNotificationSubscriptions?: Maybe<Array<Maybe<ResolversTypes['JdNotificationSubscription']>>>, kwsConsent?: Maybe<ResolversTypes['KwsConsent']>, latestScoutingTask?: Maybe<ResolversTypes['ScoutingTask']>, owner?: Maybe<ResolversTypes['User']>, recentlyUsedProducts?: Maybe<Array<Maybe<ResolversTypes['RecentlyUsedProduct']>>>, shippingAddress?: Maybe<ResolversTypes['Address']> }>;
  FeatureName: FeatureName;
  Field: ResolverTypeWrapper<Omit<Field, 'cropSeasons' | 'fieldDataLayers' | 'sprayWeather'> & { cropSeasons?: Maybe<Array<Maybe<ResolversTypes['CropSeason']>>>, fieldDataLayers?: Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, sprayWeather?: Maybe<Array<Maybe<ResolversTypes['SprayWeather']>>> }>;
  FieldActivation: ResolverTypeWrapper<Omit<FieldActivation, 'package'> & { package: ResolversTypes['Package'] }>;
  FieldActivationStatus: FieldActivationStatus;
  FieldBoundaryLookupScore: ResolverTypeWrapper<Omit<FieldBoundaryLookupScore, 'farm' | 'field'> & { farm?: Maybe<ResolversTypes['FarmV2']>, field?: Maybe<ResolversTypes['FieldV2']> }>;
  FieldDataDataMapping: ResolverTypeWrapper<FieldDataDataMapping>;
  FieldDataLayer: ResolverTypeWrapper<Omit<FieldDataLayer, 'cropSeason' | 'cropSeasonV2' | 'field' | 'fieldDataLayerStatistics' | 'fieldV2' | 'source'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, field?: Maybe<ResolversTypes['Field']>, fieldDataLayerStatistics?: Maybe<Array<Maybe<ResolversTypes['FieldDataLayerStatistics']>>>, fieldV2?: Maybe<ResolversTypes['FieldV2']>, source?: Maybe<ResolversTypes['FDLSourceUnion']> }>;
  FieldDataLayerClassification: ResolverTypeWrapper<FieldDataLayerClassification>;
  FieldDataLayerClassificationEntry: ResolverTypeWrapper<FieldDataLayerClassificationEntry>;
  FieldDataLayerLegend: ResolverTypeWrapper<Omit<FieldDataLayerLegend, 'fieldDataLayer'> & { fieldDataLayer?: Maybe<ResolversTypes['FieldDataLayer']> }>;
  FieldDataLayerSort: FieldDataLayerSort;
  FieldDataLayerSortColumn: FieldDataLayerSortColumn;
  FieldDataLayerSourceProperty: ResolverTypeWrapper<FieldDataLayerSourceProperty>;
  FieldDataLayerSourceProvider: FieldDataLayerSourceProvider;
  FieldDataLayerSourceType: FieldDataLayerSourceType;
  FieldDataLayerStatistics: ResolverTypeWrapper<FieldDataLayerStatistics>;
  FieldDataLayerTaskType: FieldDataLayerTaskType;
  FieldDataLayerType: FieldDataLayerType;
  FieldDataMeasurement: FieldDataMeasurement;
  FieldDataUploadApplicationType: FieldDataUploadApplicationType;
  FieldDataUploadDataset: ResolverTypeWrapper<Omit<FieldDataUploadDataset, 'cropSeasonV2' | 'farmV2' | 'fieldV2' | 'missingInfo'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, farmV2?: Maybe<ResolversTypes['FarmV2']>, fieldV2?: Maybe<ResolversTypes['FieldV2']>, missingInfo?: Maybe<ResolversTypes['FieldDataUploadDatasetMissingInfo']> }>;
  FieldDataUploadDatasetMissingInfo: ResolverTypeWrapper<Omit<FieldDataUploadDatasetMissingInfo, 'cropSeason' | 'field'> & { cropSeason?: Maybe<ResolversTypes['FieldDataUploadDatasetMissingInfoCropSeason']>, field?: Maybe<ResolversTypes['FieldDataUploadDatasetMissingInfoField']> }>;
  FieldDataUploadDatasetMissingInfoCropSeason: ResolverTypeWrapper<Omit<FieldDataUploadDatasetMissingInfoCropSeason, 'bestGuess' | 'possibleValues'> & { bestGuess?: Maybe<ResolversTypes['CropSeasonV2']>, possibleValues?: Maybe<Array<Maybe<ResolversTypes['CropSeasonV2']>>> }>;
  FieldDataUploadDatasetMissingInfoField: ResolverTypeWrapper<Omit<FieldDataUploadDatasetMissingInfoField, 'bestGuess' | 'possibleValues'> & { bestGuess?: Maybe<ResolversTypes['FieldV2']>, possibleValues?: Maybe<Array<Maybe<ResolversTypes['FieldV2']>>> }>;
  FieldDataUploadDatasetSort: FieldDataUploadDatasetSort;
  FieldDataUploadDatasetsSortColumn: FieldDataUploadDatasetsSortColumn;
  FieldEntry: ResolverTypeWrapper<Omit<FieldEntry, 'fieldV2'> & { fieldV2: ResolversTypes['FieldV2'] }>;
  FieldEvidence: ResolverTypeWrapper<FieldEvidence>;
  FieldEvidenceAph: ResolverTypeWrapper<FieldEvidenceAph>;
  FieldEvidenceCiScore: ResolverTypeWrapper<FieldEvidenceCiScore>;
  FieldEvidenceCoverCrop: ResolverTypeWrapper<FieldEvidenceCoverCrop>;
  FieldEvidenceCoverCropSeason: ResolverTypeWrapper<FieldEvidenceCoverCropSeason>;
  FieldEvidenceCropSeason: ResolverTypeWrapper<FieldEvidenceCropSeason>;
  FieldEvidenceExpectedYieldProof: ResolverTypeWrapper<FieldEvidenceExpectedYieldProof>;
  FieldEvidenceField: ResolverTypeWrapper<FieldEvidenceField>;
  FieldEvidenceHarvest: ResolverTypeWrapper<FieldEvidenceHarvest>;
  FieldEvidenceHarvestTask: ResolverTypeWrapper<FieldEvidenceHarvestTask>;
  FieldEvidenceLandLease: ResolverTypeWrapper<FieldEvidenceLandLease>;
  FieldEvidenceLandLeases: ResolverTypeWrapper<FieldEvidenceLandLeases>;
  FieldEvidenceLandUse: ResolverTypeWrapper<FieldEvidenceLandUse>;
  FieldEvidenceLandUses: ResolverTypeWrapper<FieldEvidenceLandUses>;
  FieldEvidenceLandownerRelease: ResolverTypeWrapper<FieldEvidenceLandownerRelease>;
  FieldEvidenceLandownerReleases: ResolverTypeWrapper<FieldEvidenceLandownerReleases>;
  FieldEvidenceLink: ResolverTypeWrapper<FieldEvidenceLink>;
  FieldEvidenceLinkRecordType: FieldEvidenceLinkRecordType;
  FieldEvidenceLinkSort: FieldEvidenceLinkSort;
  FieldEvidenceLinkSortColumn: FieldEvidenceLinkSortColumn;
  FieldEvidenceLinks: ResolverTypeWrapper<FieldEvidenceLinks>;
  FieldEvidenceManureTest: ResolverTypeWrapper<FieldEvidenceManureTest>;
  FieldEvidenceManureTests: ResolverTypeWrapper<FieldEvidenceManureTests>;
  FieldEvidenceNutrition: ResolverTypeWrapper<FieldEvidenceNutrition>;
  FieldEvidenceNutritionPlan: ResolverTypeWrapper<FieldEvidenceNutritionPlan>;
  FieldEvidenceNutritionTask: ResolverTypeWrapper<FieldEvidenceNutritionTask>;
  FieldEvidenceProgram: ResolverTypeWrapper<FieldEvidenceProgram>;
  FieldEvidenceRecords: ResolverTypeWrapper<FieldEvidenceRecords>;
  FieldEvidenceSale: ResolverTypeWrapper<FieldEvidenceSale>;
  FieldEvidenceSampleResults: ResolverTypeWrapper<FieldEvidenceSampleResults>;
  FieldEvidenceSeeding: ResolverTypeWrapper<FieldEvidenceSeeding>;
  FieldEvidenceSeedingTask: ResolverTypeWrapper<FieldEvidenceSeedingTask>;
  FieldEvidenceSoilTest: ResolverTypeWrapper<FieldEvidenceSoilTest>;
  FieldEvidenceSoilTests: ResolverTypeWrapper<FieldEvidenceSoilTests>;
  FieldEvidenceSort: FieldEvidenceSort;
  FieldEvidenceSortColumn: FieldEvidenceSortColumn;
  FieldEvidenceTDisc: ResolverTypeWrapper<FieldEvidenceTDisc>;
  FieldEvidenceTillage: ResolverTypeWrapper<FieldEvidenceTillage>;
  FieldEvidenceTillageTask: ResolverTypeWrapper<FieldEvidenceTillageTask>;
  FieldEvidenceYieldSales: ResolverTypeWrapper<FieldEvidenceYieldSales>;
  FieldFeature: ResolverTypeWrapper<Omit<FieldFeature, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  FieldIdentifierScore: ResolverTypeWrapper<FieldIdentifierScore>;
  FieldInputPackaging: ResolverTypeWrapper<Omit<FieldInputPackaging, 'farmV2'> & { farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  FieldInputType: FieldInputType;
  FieldNote: ResolverTypeWrapper<Omit<FieldNote, 'attachments' | 'creator' | 'cropSeason' | 'field' | 'scoutingPoi' | 'scoutingTask'> & { attachments?: Maybe<Array<Maybe<ResolversTypes['FieldNoteAttachment']>>>, creator?: Maybe<ResolversTypes['User']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, field?: Maybe<ResolversTypes['FieldV2']>, scoutingPoi?: Maybe<ResolversTypes['ScoutingPoiV2']>, scoutingTask?: Maybe<ResolversTypes['ScoutingTask']> }>;
  FieldNoteAggregation: ResolverTypeWrapper<Omit<FieldNoteAggregation, 'creators' | 'cropAggregations' | 'farm' | 'fieldNotes' | 'fields'> & { creators?: Maybe<Array<Maybe<ResolversTypes['User']>>>, cropAggregations?: Maybe<Array<Maybe<ResolversTypes['FieldNoteCropAggregation']>>>, farm?: Maybe<ResolversTypes['FarmV2']>, fieldNotes?: Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, fields?: Maybe<Array<Maybe<ResolversTypes['FieldV2']>>> }>;
  FieldNoteAnswer: ResolverTypeWrapper<FieldNoteAnswer>;
  FieldNoteAssessmentAggregation: ResolverTypeWrapper<FieldNoteAssessmentAggregation>;
  FieldNoteAttachment: ResolverTypeWrapper<Omit<FieldNoteAttachment, 'creator'> & { creator?: Maybe<ResolversTypes['User']> }>;
  FieldNoteAudioAttachment: ResolverTypeWrapper<FieldNoteAudioAttachment>;
  FieldNoteCategory: FieldNoteCategory;
  FieldNoteCropAggregation: ResolverTypeWrapper<Omit<FieldNoteCropAggregation, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  FieldNoteImage: ResolverTypeWrapper<FieldNoteImage>;
  FieldNoteLocationType: FieldNoteLocationType;
  FieldNoteObservation: ResolverTypeWrapper<FieldNoteObservation>;
  FieldNotePriority: FieldNotePriority;
  FieldNoteSort: FieldNoteSort;
  FieldNoteSortColumn: FieldNoteSortColumn;
  FieldNoteStressAggregation: ResolverTypeWrapper<FieldNoteStressAggregation>;
  FieldPointLookup: ResolverTypeWrapper<Omit<FieldPointLookup, 'farm' | 'field'> & { farm?: Maybe<ResolversTypes['FarmV2']>, field?: Maybe<ResolversTypes['FieldV2']> }>;
  FieldSummary: ResolverTypeWrapper<FieldSummary>;
  FieldV2: ResolverTypeWrapper<Omit<FieldV2, 'abLines' | 'activations' | 'agBalanceFieldInput' | 'carbonFarmingRequests' | 'creator' | 'cropSeasons' | 'cropSeasonsV2' | 'currentWeedPredictions' | 'farmV2' | 'features' | 'fieldDataLayers' | 'fieldEntries' | 'fieldNotes' | 'fieldZones' | 'greenhouse' | 'modifier' | 'scoutingTasks' | 'seedSelectorInputs' | 'soilErosion' | 'soilSamplingResults' | 'soilSamplings' | 'sourceMaps' | 'sprayWeather' | 'tramlines' | 'varietyRecommendations'> & { abLines?: Maybe<Array<Maybe<ResolversTypes['AbLine']>>>, activations?: Maybe<Array<Maybe<ResolversTypes['FieldActivation']>>>, agBalanceFieldInput?: Maybe<ResolversTypes['AgBalanceFieldInput']>, carbonFarmingRequests?: Maybe<Array<Maybe<ResolversTypes['CarbonFarmingRequest']>>>, creator?: Maybe<ResolversTypes['User']>, cropSeasons?: Maybe<Array<Maybe<ResolversTypes['CropSeason']>>>, cropSeasonsV2?: Maybe<Array<ResolversTypes['CropSeasonV2']>>, currentWeedPredictions?: Maybe<Array<Maybe<ResolversTypes['CurrentWeedPrediction']>>>, farmV2?: Maybe<ResolversTypes['FarmV2']>, features?: Maybe<Array<Maybe<ResolversTypes['FieldFeature']>>>, fieldDataLayers?: Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, fieldEntries?: Maybe<Array<Maybe<ResolversTypes['FieldEntry']>>>, fieldNotes?: Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, fieldZones?: Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, greenhouse?: Maybe<ResolversTypes['Greenhouse']>, modifier?: Maybe<ResolversTypes['User']>, scoutingTasks?: Maybe<Array<ResolversTypes['ScoutingTask']>>, seedSelectorInputs?: Maybe<Array<Maybe<ResolversTypes['SeedSelectorInput']>>>, soilErosion?: Maybe<Array<Maybe<ResolversTypes['SoilErosion']>>>, soilSamplingResults?: Maybe<Array<Maybe<ResolversTypes['SoilSamplingResult']>>>, soilSamplings?: Maybe<Array<Maybe<ResolversTypes['SoilSampling']>>>, sourceMaps?: Maybe<Array<Maybe<ResolversTypes['SourceMap']>>>, sprayWeather?: Maybe<Array<Maybe<ResolversTypes['SprayWeather']>>>, tramlines?: Maybe<Array<Maybe<ResolversTypes['Tramline']>>>, varietyRecommendations?: Maybe<Array<Maybe<ResolversTypes['VarietyRecommendation']>>> }>;
  FieldVariabilityInSeason: ResolverTypeWrapper<FieldVariabilityInSeason>;
  FieldVariabilityInSeasonIndex: ResolverTypeWrapper<FieldVariabilityInSeasonIndex>;
  FieldVariabilityIndex: ResolverTypeWrapper<Omit<FieldVariabilityIndex, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  FieldVariabilityIndexStatus: FieldVariabilityIndexStatus;
  FieldVariabilityInput: ResolverTypeWrapper<Omit<FieldVariabilityInput, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  FieldVariabilityTimeSeries: ResolverTypeWrapper<FieldVariabilityTimeSeries>;
  FieldVariabilityTimeSeriesIndex: ResolverTypeWrapper<FieldVariabilityTimeSeriesIndex>;
  FieldVpiClassification: FieldVpiClassification;
  FieldZone: ResolverTypeWrapper<Omit<FieldZone, 'cropSeasonV2' | 'fieldV2' | 'trials'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, fieldV2: ResolversTypes['FieldV2'], trials?: Maybe<Array<Maybe<ResolversTypes['Trial']>>> }>;
  FieldZoneType: FieldZoneType;
  File: ResolverTypeWrapper<Omit<File, 'creator'> & { creator?: Maybe<ResolversTypes['User']> }>;
  FileSort: FileSort;
  FileSortColumn: FileSortColumn;
  FileSource: FileSource;
  FileUploadOrderStatus: FileUploadOrderStatus;
  FileUploadStatus: FileUploadStatus;
  FilterStrategy: FilterStrategy;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FlowHint: FlowHint;
  FmCarbonRelatedData: ResolverTypeWrapper<FmCarbonRelatedData>;
  Footprint: ResolverTypeWrapper<Footprint>;
  ForeignCatchCrop: ResolverTypeWrapper<ForeignCatchCrop>;
  ForeignCrop: ResolverTypeWrapper<ForeignCrop>;
  ForeignPreCrop: ResolverTypeWrapper<ForeignPreCrop>;
  Formulation: Formulation;
  FreshBiomassOrder: ResolverTypeWrapper<Omit<FreshBiomassOrder, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  FreshBiomassOrderStatus: FreshBiomassOrderStatus;
  FrostRisk: ResolverTypeWrapper<Omit<FrostRisk, 'cropSeasonV2'> & { cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  FulfilledIntervention: ResolverTypeWrapper<FulfilledIntervention>;
  FulfilmentStatus: FulfilmentStatus;
  GeneralTask: ResolverTypeWrapper<Omit<GeneralTask, 'cropSeason' | 'taskDetails'> & { cropSeason: ResolversTypes['CropSeasonV2'], taskDetails: ResolversTypes['GeneralTasksUnion'] }>;
  GeneralTaskStatus: GeneralTaskStatus;
  GeneralTaskType: GeneralTaskType;
  GeneralTasksUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GeneralTasksUnion']>;
  GeoMapDetail: ResolverTypeWrapper<GeoMapDetail>;
  Greenhouse: ResolverTypeWrapper<Omit<Greenhouse, 'creator' | 'fieldV2'> & { creator?: Maybe<ResolversTypes['User']>, fieldV2: ResolversTypes['FieldV2'] }>;
  GreenhouseWhiteningTask: ResolverTypeWrapper<Omit<GreenhouseWhiteningTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  GreetApplication: ResolverTypeWrapper<GreetApplication>;
  GreetApplicationType: GreetApplicationType;
  GreetCarbonIntensityScore: ResolverTypeWrapper<GreetCarbonIntensityScore>;
  GreetCropProtection: ResolverTypeWrapper<GreetCropProtection>;
  Group: ResolverTypeWrapper<Group>;
  GrowthStage: ResolverTypeWrapper<Omit<GrowthStage, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  GrowthStagePredictionCalculatedPayload: ResolverTypeWrapper<GrowthStagePredictionCalculatedPayload>;
  GrowthStagePredictionDaily: ResolverTypeWrapper<Omit<GrowthStagePredictionDaily, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  GrowthStageProvider: GrowthStageProvider;
  HFContractorEquipment: ResolverTypeWrapper<HfContractorEquipment>;
  HFContractorRequest: ResolverTypeWrapper<Omit<HfContractorRequest, 'creator' | 'user'> & { creator?: Maybe<ResolversTypes['User']>, user?: Maybe<ResolversTypes['User']> }>;
  HFContractorRequestStatus: HfContractorRequestStatus;
  HFServiceRequest: ResolverTypeWrapper<Omit<HfServiceRequest, 'billingAddress' | 'collaborator' | 'cropSeason' | 'farm' | 'hfDiscounts' | 'requesteeUser'> & { billingAddress?: Maybe<ResolversTypes['BillingAddress']>, collaborator?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, farm?: Maybe<ResolversTypes['FarmV2']>, hfDiscounts?: Maybe<Array<Maybe<ResolversTypes['HfDiscount']>>>, requesteeUser?: Maybe<ResolversTypes['User']> }>;
  Harvest: ResolverTypeWrapper<Omit<Harvest, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  HarvestCondition: HarvestCondition;
  HarvestMethodCode: HarvestMethodCode;
  HarvestedProduceCode: HarvestedProduceCode;
  HfAddress: ResolverTypeWrapper<HfAddress>;
  HfAgRegion: ResolverTypeWrapper<HfAgRegion>;
  HfAlert: ResolverTypeWrapper<Omit<HfAlert, 'farm' | 'field'> & { farm?: Maybe<ResolversTypes['FarmV2']>, field?: Maybe<ResolversTypes['FieldV2']> }>;
  HfClaim: ResolverTypeWrapper<Omit<HfClaim, 'assigneeUser' | 'categories' | 'cropSeason' | 'fieldNotes' | 'hfServiceRequest'> & { assigneeUser?: Maybe<ResolversTypes['User']>, categories?: Maybe<Array<Maybe<ResolversTypes['ClaimCategory']>>>, cropSeason: ResolversTypes['CropSeasonV2'], fieldNotes?: Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, hfServiceRequest?: Maybe<ResolversTypes['HFServiceRequest']> }>;
  HfClaimCategory: HfClaimCategory;
  HfClaimStatus: HfClaimStatus;
  HfDiscount: ResolverTypeWrapper<Omit<HfDiscount, 'farm' | 'hfServiceRequest'> & { farm?: Maybe<ResolversTypes['FarmV2']>, hfServiceRequest?: Maybe<ResolversTypes['HFServiceRequest']> }>;
  HfDiscountUnit: HfDiscountUnit;
  HfDistributor: ResolverTypeWrapper<Omit<HfDistributor, 'distributorManagerId'> & { distributorManagerId?: Maybe<ResolversTypes['User']> }>;
  HfFarm: ResolverTypeWrapper<Omit<HfFarm, 'farm'> & { farm: ResolversTypes['FarmV2'] }>;
  HfInvoice: ResolverTypeWrapper<Omit<HfInvoice, 'hfServiceRequests'> & { hfServiceRequests: Array<ResolversTypes['HFServiceRequest']> }>;
  HfLevel: HfLevel;
  HfMachinery: ResolverTypeWrapper<HfMachinery>;
  HfOffer: ResolverTypeWrapper<Omit<HfOffer, 'hfServiceRequests' | 'recipientUser'> & { hfServiceRequests?: Maybe<Array<Maybe<ResolversTypes['HFServiceRequest']>>>, recipientUser?: Maybe<ResolversTypes['User']> }>;
  HfOfferCondition: ResolverTypeWrapper<Omit<HfOfferCondition, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  HfOperationalInstruction: ResolverTypeWrapper<Omit<HfOperationalInstruction, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  HfPreOrder: ResolverTypeWrapper<Omit<HfPreOrder, 'cropQuotas' | 'farm'> & { cropQuotas?: Maybe<Array<Maybe<ResolversTypes['PreOrderCropQuota']>>>, farm?: Maybe<ResolversTypes['FarmV2']> }>;
  HfPrice: ResolverTypeWrapper<Omit<HfPrice, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  HfRate: ResolverTypeWrapper<HfRate>;
  HfReferenceCode: ResolverTypeWrapper<Omit<HfReferenceCode, 'creator' | 'digitalServiceManager' | 'enabledCrops'> & { creator?: Maybe<ResolversTypes['User']>, digitalServiceManager?: Maybe<ResolversTypes['User']>, enabledCrops?: Maybe<Array<ResolversTypes['Crop']>> }>;
  HfReferenceCodeCategoryRate: ResolverTypeWrapper<HfReferenceCodeCategoryRate>;
  HfReferenceCodeMargin: ResolverTypeWrapper<HfReferenceCodeMargin>;
  HfReferenceCodePublic: ResolverTypeWrapper<Omit<HfReferenceCodePublic, 'enabledCrops'> & { enabledCrops?: Maybe<Array<ResolversTypes['Crop']>> }>;
  HfReferenceCodeRate: ResolverTypeWrapper<HfReferenceCodeRate>;
  HfRequestFarmPackageAddOn: ResolverTypeWrapper<Omit<HfRequestFarmPackageAddOn, 'creator' | 'farm' | 'lastModifier'> & { creator?: Maybe<ResolversTypes['User']>, farm?: Maybe<ResolversTypes['FarmV2']>, lastModifier?: Maybe<ResolversTypes['User']> }>;
  HfRiskClass: ResolverTypeWrapper<HfRiskClass>;
  HfSeason: ResolverTypeWrapper<HfSeason>;
  HfServiceRequestAreaClassType: HfServiceRequestAreaClassType;
  HfServiceTerm: HfServiceTerm;
  HfWeatherData: ResolverTypeWrapper<Omit<HfWeatherData, 'cropSeason' | 'farm'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, farm?: Maybe<ResolversTypes['FarmV2']> }>;
  HortaCropSeason: ResolverTypeWrapper<Omit<HortaCropSeason, 'fmCropSeason'> & { fmCropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  HortaSpraying: ResolverTypeWrapper<Omit<HortaSpraying, 'cropSeason' | 'fmSpraying'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, fmSpraying?: Maybe<ResolversTypes['SprayingV2']> }>;
  HortaStress: ResolverTypeWrapper<HortaStress>;
  HortaSustainabilityIndicator: ResolverTypeWrapper<Omit<HortaSustainabilityIndicator, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  Image: ResolverTypeWrapper<Image>;
  ImportOrder: ResolverTypeWrapper<Omit<ImportOrder, 'farm'> & { farm?: Maybe<ResolversTypes['FarmV2']> }>;
  ImportOrderFilterStrategy: ImportOrderFilterStrategy;
  ImportOrderStatus: ImportOrderStatus;
  ImportantGrowthStage: ResolverTypeWrapper<Omit<ImportantGrowthStage, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  IncubationLevel: ResolverTypeWrapper<IncubationLevel>;
  IndexableObject: ResolverTypeWrapper<Scalars['IndexableObject']['output']>;
  InfectionType: InfectionType;
  Ingredient: ResolverTypeWrapper<Ingredient>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Intervention: Intervention;
  InviteCode: ResolverTypeWrapper<Omit<InviteCode, 'creator'> & { creator?: Maybe<ResolversTypes['User']> }>;
  IrrigationEnergySource: IrrigationEnergySource;
  IsActiveGSModelFilter: IsActiveGsModelFilter;
  IssueType: IssueType;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  JdFieldSynchronizationOrder: ResolverTypeWrapper<JdFieldSynchronizationOrder>;
  JdFieldSynchronizationOrderStatus: JdFieldSynchronizationOrderStatus;
  JdNotificationSubscription: ResolverTypeWrapper<Omit<JdNotificationSubscription, 'farmV2'> & { farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  JdNotificationSubscriptionCategory: JdNotificationSubscriptionCategory;
  KubotaApplicationMapDispatchOrder: ResolverTypeWrapper<KubotaApplicationMapDispatchOrder>;
  KubotaApplicationMapDispatchOrderStatus: KubotaApplicationMapDispatchOrderStatus;
  KubotaApplicationMapDispatchOrderTaskType: KubotaApplicationMapDispatchOrderTaskType;
  KubotaField: ResolverTypeWrapper<KubotaField>;
  KwsConsent: ResolverTypeWrapper<Omit<KwsConsent, 'farmV2'> & { farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  KwsConsentStatus: KwsConsentStatus;
  KwsSupportedVariety: ResolverTypeWrapper<Omit<KwsSupportedVariety, 'variety'> & { variety?: Maybe<ResolversTypes['Variety']> }>;
  LandPreparation: ResolverTypeWrapper<Omit<LandPreparation, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  LeafDamageResult: ResolverTypeWrapper<LeafDamageResult>;
  LeafPruningTask: ResolverTypeWrapper<Omit<LeafPruningTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  LegendEntry: ResolverTypeWrapper<LegendEntry>;
  LegendType: LegendType;
  License: ResolverTypeWrapper<License>;
  LicenseRequest: ResolverTypeWrapper<Omit<LicenseRequest, 'creatorUser' | 'farm' | 'lastModifierUser' | 'organisation' | 'organisationMemberUser'> & { creatorUser?: Maybe<ResolversTypes['User']>, farm: ResolversTypes['FarmV2'], lastModifierUser?: Maybe<ResolversTypes['User']>, organisation?: Maybe<ResolversTypes['Organisation']>, organisationMemberUser?: Maybe<ResolversTypes['User']> }>;
  LicenseRequestSeason: ResolverTypeWrapper<LicenseRequestSeason>;
  LicenseRequestStatusType: LicenseRequestStatusType;
  LicenseSellerType: LicenseSellerType;
  LifecycleState: LifecycleState;
  LimitationReason: LimitationReason;
  LinkedDevice: ResolverTypeWrapper<Omit<LinkedDevice, 'devices'> & { devices?: Maybe<Array<Maybe<ResolversTypes['VendorDeviceInfo']>>> }>;
  Location: ResolverTypeWrapper<Location>;
  LocationType: LocationType;
  Magnitude: ResolverTypeWrapper<Omit<Magnitude, 'fieldDataLayer' | 'statistics'> & { fieldDataLayer?: Maybe<ResolversTypes['FieldDataLayer']>, statistics?: Maybe<ResolversTypes['FieldDataLayerStatistics']> }>;
  MagnitudeSourceInvalidReasonType: MagnitudeSourceInvalidReasonType;
  MagnitudeStrategy: MagnitudeStrategy;
  MagnitudeType: MagnitudeType;
  MagnitudeUnit: MagnitudeUnit;
  MandatoryStressSetting: MandatoryStressSetting;
  MapItem: ResolverTypeWrapper<Omit<MapItem, 'cropSeason' | 'farm' | 'field' | 'fieldDataLayer'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, farm?: Maybe<ResolversTypes['FarmV2']>, field?: Maybe<ResolversTypes['FieldV2']>, fieldDataLayer?: Maybe<ResolversTypes['FieldDataLayer']> }>;
  MapItemSort: MapItemSort;
  MapItemSortColumn: MapItemSortColumn;
  MapItemType: MapItemType;
  MappingFieldZone: ResolverTypeWrapper<Omit<MappingFieldZone, 'fieldZone'> & { fieldZone?: Maybe<ResolversTypes['FieldZone']> }>;
  Md2AggregatedProductusesByCrop: ResolverTypeWrapper<Md2AggregatedProductusesByCrop>;
  Md2Configuration: ResolverTypeWrapper<Md2Configuration>;
  Md2CountryCropConfiguration: ResolverTypeWrapper<Md2CountryCropConfiguration>;
  Md2DictionaryMapping: ResolverTypeWrapper<Md2DictionaryMapping>;
  Md2Item: ResolverTypeWrapper<Md2Item>;
  Md2ProductFeature: ResolverTypeWrapper<Md2ProductFeature>;
  Md2TillageDepth: ResolverTypeWrapper<Md2TillageDepth>;
  Md2VraAdvisorConfiguration: ResolverTypeWrapper<Md2VraAdvisorConfiguration>;
  Md2VraAdvisorFieldDataLayerConfiguration: ResolverTypeWrapper<Md2VraAdvisorFieldDataLayerConfiguration>;
  MdCoefficientOfVariationDetail: ResolverTypeWrapper<MdCoefficientOfVariationDetail>;
  MdSoilNematodeRisk: ResolverTypeWrapper<MdSoilNematodeRisk>;
  MdTaskType: MdTaskType;
  MdUnit: ResolverTypeWrapper<MdUnit>;
  MeasureSubmissionErrorCode: MeasureSubmissionErrorCode;
  MeasureSubmissionFieldOrder: ResolverTypeWrapper<Omit<MeasureSubmissionFieldOrder, 'errors' | 'field'> & { errors?: Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionFieldOrderError']>>>, field?: Maybe<ResolversTypes['FieldV2']> }>;
  MeasureSubmissionFieldOrderError: ResolverTypeWrapper<MeasureSubmissionFieldOrderError>;
  MeasureSubmissionFieldResult: ResolverTypeWrapper<Omit<MeasureSubmissionFieldResult, 'field'> & { field?: Maybe<ResolversTypes['FieldV2']> }>;
  MeasureSubmissionMode: MeasureSubmissionMode;
  MeasureSubmissionOrder: ResolverTypeWrapper<Omit<MeasureSubmissionOrder, 'fields' | 'sustainabilityProgram'> & { fields?: Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionFieldOrder']>>>, sustainabilityProgram?: Maybe<ResolversTypes['SustainabilityProgram']> }>;
  MeasureSubmissionOrderStatistics: ResolverTypeWrapper<MeasureSubmissionOrderStatistics>;
  MeasureSubmissionProjectLevelCropResult: ResolverTypeWrapper<MeasureSubmissionProjectLevelCropResult>;
  MeasureSubmissionProjectLevelResult: ResolverTypeWrapper<MeasureSubmissionProjectLevelResult>;
  MeasureSubmissionResult: ResolverTypeWrapper<Omit<MeasureSubmissionResult, 'fields' | 'measureSubmissionOrder'> & { fields?: Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionFieldResult']>>>, measureSubmissionOrder: ResolversTypes['MeasureSubmissionOrder'] }>;
  MeasureSubmissionStatus: MeasureSubmissionStatus;
  Measurement: ResolverTypeWrapper<Measurement>;
  MergeOrigin: MergeOrigin;
  MergedExecutionStatus: MergedExecutionStatus;
  MergedSmartSprayerExecution: ResolverTypeWrapper<MergedSmartSprayerExecution>;
  MissingInfoDataMapping: ResolverTypeWrapper<MissingInfoDataMapping>;
  MissingInfoDate: ResolverTypeWrapper<MissingInfoDate>;
  MissingInfoExampleData: ResolverTypeWrapper<MissingInfoExampleData>;
  MissingInfoUploadDatasetType: ResolverTypeWrapper<MissingInfoUploadDatasetType>;
  MonitorCoverCrop: ResolverTypeWrapper<MonitorCoverCrop>;
  MonitorPractice: ResolverTypeWrapper<Omit<MonitorPractice, 'field'> & { field?: Maybe<ResolversTypes['FieldV2']> }>;
  MonitorTillage: ResolverTypeWrapper<MonitorTillage>;
  MultiFile: ResolverTypeWrapper<MultiFile>;
  MultiFileSource: MultiFileSource;
  MultiFileUploadOrder: ResolverTypeWrapper<Omit<MultiFileUploadOrder, 'creator'> & { creator?: Maybe<ResolversTypes['User']> }>;
  MultiFileUploadType: MultiFileUploadType;
  MultiWeedResult: ResolverTypeWrapper<MultiWeedResult>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  MutationResponse: ResolverTypeWrapper<MutationResponse>;
  NamedCropMix: ResolverTypeWrapper<NamedCropMix>;
  NitrogenProduct: ResolverTypeWrapper<NitrogenProduct>;
  NitrogenStatusResult: ResolverTypeWrapper<NitrogenStatusResult>;
  NitrogenType: ResolverTypeWrapper<NitrogenType>;
  Node: ResolverTypeWrapper<Scalars['Node']['output']>;
  NodeWithTypename: ResolverTypeWrapper<Scalars['NodeWithTypename']['output']>;
  Notification: ResolverTypeWrapper<Omit<Notification, 'farmV2' | 'object'> & { farmV2?: Maybe<ResolversTypes['FarmV2']>, object?: Maybe<ResolversTypes['NotificationObject']> }>;
  NotificationConfiguration: ResolverTypeWrapper<NotificationConfiguration>;
  NotificationObject: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['NotificationObject']>;
  NotificationPayload: ResolverTypeWrapper<NotificationPayload>;
  NotificationPreference: ResolverTypeWrapper<Omit<NotificationPreference, 'cropSeasons' | 'user'> & { cropSeasons?: Maybe<Array<Maybe<ResolversTypes['NotificationPreferenceCropSeason']>>>, user?: Maybe<ResolversTypes['User']> }>;
  NotificationPreferenceCropSeason: ResolverTypeWrapper<Omit<NotificationPreferenceCropSeason, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  NotificationType: NotificationType;
  Nutrient: ResolverTypeWrapper<Nutrient>;
  NutrientMethodMapping: ResolverTypeWrapper<NutrientMethodMapping>;
  NutrientProduct: ResolverTypeWrapper<NutrientProduct>;
  NutrientRate: ResolverTypeWrapper<NutrientRate>;
  NutrientRateUnitCode: NutrientRateUnitCode;
  NutritionActionDetail: ResolverTypeWrapper<NutritionActionDetail>;
  NutritionActionNutrient: ResolverTypeWrapper<NutritionActionNutrient>;
  NutritionActionProduct: ResolverTypeWrapper<NutritionActionProduct>;
  NutritionActionValidity: ResolverTypeWrapper<NutritionActionValidity>;
  NutritionActionValidityType: NutritionActionValidityType;
  NutritionApplicationType: NutritionApplicationType;
  NutritionProgramProvider: NutritionProgramProvider;
  NutritionProgramStrategy: NutritionProgramStrategy;
  NutritionRecommendation: ResolverTypeWrapper<Omit<NutritionRecommendation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  NutritionRecommendationActionType: NutritionRecommendationActionType;
  NutritionRecommendationStatus: NutritionRecommendationStatus;
  NutritionStacItemVectorization: ResolverTypeWrapper<NutritionStacItemVectorization>;
  NutritionStatus: ResolverTypeWrapper<Omit<NutritionStatus, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  NutritionStatusState: NutritionStatusState;
  NutritionStatusType: NutritionStatusType;
  NutritionTargetRate: ResolverTypeWrapper<NutritionTargetRate>;
  Observation: ResolverTypeWrapper<Omit<Observation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  ObservationWeather: ResolverTypeWrapper<ObservationWeather>;
  OfferModel: OfferModel;
  OfflineBasedSmartSprayingTask: ResolverTypeWrapper<OfflineBasedSmartSprayingTask>;
  OnOffStatistics: ResolverTypeWrapper<Omit<OnOffStatistics, 'fieldDataLayer'> & { fieldDataLayer?: Maybe<ResolversTypes['FieldDataLayer']> }>;
  OneSoilApplicationMapDispatchOrder: ResolverTypeWrapper<OneSoilApplicationMapDispatchOrder>;
  OneSoilApplicationMapDispatchOrderFormat: OneSoilApplicationMapDispatchOrderFormat;
  OneSoilApplicationMapDispatchOrderStatus: OneSoilApplicationMapDispatchOrderStatus;
  OneSoilApplicationMapDispatchOrderTaskType: OneSoilApplicationMapDispatchOrderTaskType;
  OneSoilDevice: ResolverTypeWrapper<OneSoilDevice>;
  OneSoilDeviceLicense: ResolverTypeWrapper<OneSoilDeviceLicense>;
  OneSoilFarmReceivedFile: ResolverTypeWrapper<Omit<OneSoilFarmReceivedFile, 'farm' | 'receivedFile'> & { farm?: Maybe<ResolversTypes['FarmV2']>, receivedFile?: Maybe<ResolversTypes['OneSoilReceivedFile']> }>;
  OneSoilReceivedFile: ResolverTypeWrapper<Omit<OneSoilReceivedFile, 'farmReceivedFiles'> & { farmReceivedFiles?: Maybe<Array<Maybe<ResolversTypes['OneSoilFarmReceivedFile']>>> }>;
  OneSoilReceivedFileSourceEvent: OneSoilReceivedFileSourceEvent;
  OneSoilUploadDatasetOrder: ResolverTypeWrapper<Omit<OneSoilUploadDatasetOrder, 'farm' | 'receivedFiles' | 'uploadDatasetResults'> & { farm?: Maybe<ResolversTypes['FarmV2']>, receivedFiles?: Maybe<Array<Maybe<ResolversTypes['OneSoilReceivedFile']>>>, uploadDatasetResults?: Maybe<Array<Maybe<ResolversTypes['OneSoilUploadDatasetResult']>>> }>;
  OneSoilUploadDatasetResult: ResolverTypeWrapper<Omit<OneSoilUploadDatasetResult, 'receivedFile'> & { receivedFile?: Maybe<ResolversTypes['OneSoilReceivedFile']> }>;
  OnesoilUploadDatasetOrderStatus: OnesoilUploadDatasetOrderStatus;
  OperationMode: OperationMode;
  OrderAffiliate: ResolverTypeWrapper<OrderAffiliate>;
  OrderState: OrderState;
  Organisation: ResolverTypeWrapper<Omit<Organisation, 'billingAddress' | 'owner'> & { billingAddress?: Maybe<ResolversTypes['Address']>, owner?: Maybe<ResolversTypes['User']> }>;
  OrganisationBranch: ResolverTypeWrapper<Omit<OrganisationBranch, 'address' | 'organisation'> & { address?: Maybe<ResolversTypes['Address']>, organisation?: Maybe<ResolversTypes['Organisation']> }>;
  OrganisationFarmAssignment: ResolverTypeWrapper<Omit<OrganisationFarmAssignment, 'farm' | 'organisation'> & { farm: ResolversTypes['FarmV2'], organisation?: Maybe<ResolversTypes['Organisation']> }>;
  OrganisationFarmAssignmentRole: OrganisationFarmAssignmentRole;
  OrganisationFeature: ResolverTypeWrapper<Omit<OrganisationFeature, 'organisation'> & { organisation: ResolversTypes['Organisation'] }>;
  OrganisationFeatureType: OrganisationFeatureType;
  OrganisationMember: ResolverTypeWrapper<Omit<OrganisationMember, 'branch' | 'manager' | 'organisation' | 'user'> & { branch?: Maybe<ResolversTypes['OrganisationBranch']>, manager?: Maybe<ResolversTypes['OrganisationMember']>, organisation?: Maybe<ResolversTypes['Organisation']>, user?: Maybe<ResolversTypes['User']> }>;
  OrganisationMemberPrivilege: OrganisationMemberPrivilege;
  OrganisationMembershipRequest: ResolverTypeWrapper<Omit<OrganisationMembershipRequest, 'branch' | 'manager' | 'requestee' | 'requester'> & { branch?: Maybe<ResolversTypes['OrganisationBranch']>, manager?: Maybe<ResolversTypes['OrganisationMember']>, requestee?: Maybe<ResolversTypes['User']>, requester?: Maybe<ResolversTypes['User']> }>;
  OrganisationMembershipRequestStatus: OrganisationMembershipRequestStatus;
  OrganisationMethod: ResolverTypeWrapper<Omit<OrganisationMethod, 'organisation'> & { organisation: ResolversTypes['Organisation'] }>;
  OrganisationQuota: ResolverTypeWrapper<OrganisationQuota>;
  OrganisationQuotaLedger: ResolverTypeWrapper<OrganisationQuotaLedger>;
  OrganisationQuotaLedgerSort: OrganisationQuotaLedgerSort;
  OrganisationQuotaLedgerSortColumn: OrganisationQuotaLedgerSortColumn;
  OrganisationQuotaOperationType: OrganisationQuotaOperationType;
  OrganisationQuotaPartyType: OrganisationQuotaPartyType;
  OrganisationTag: ResolverTypeWrapper<OrganisationTag>;
  OrganisationTagType: OrganisationTagType;
  OrganisationType: OrganisationType;
  Organization: ResolverTypeWrapper<Organization>;
  Package: ResolverTypeWrapper<Omit<Package, 'activatesPackages' | 'crop'> & { activatesPackages?: Maybe<Array<Maybe<ResolversTypes['Package']>>>, crop?: Maybe<ResolversTypes['Crop']> }>;
  PackageType: PackageType;
  PaginatedFarmEvidenceLink: ResolverTypeWrapper<PaginatedFarmEvidenceLink>;
  PaginatedFarmReceipt: ResolverTypeWrapper<Omit<PaginatedFarmReceipt, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['FarmReceipt']>>> }>;
  PaginatedFieldDataLayer: ResolverTypeWrapper<Omit<PaginatedFieldDataLayer, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>> }>;
  PaginatedFieldEvidence: ResolverTypeWrapper<PaginatedFieldEvidence>;
  PaginatedFieldEvidenceLink: ResolverTypeWrapper<PaginatedFieldEvidenceLink>;
  PaginatedFieldNote: ResolverTypeWrapper<Omit<PaginatedFieldNote, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['FieldNote']>>> }>;
  PaginatedFile: ResolverTypeWrapper<Omit<PaginatedFile, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['File']>>> }>;
  PaginatedHfClaim: ResolverTypeWrapper<Omit<PaginatedHfClaim, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['HfClaim']>>> }>;
  PaginatedHfContractorRequest: ResolverTypeWrapper<Omit<PaginatedHfContractorRequest, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['HFContractorRequest']>>> }>;
  PaginatedHfOperationalInstruction: ResolverTypeWrapper<Omit<PaginatedHfOperationalInstruction, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['HfOperationalInstruction']>>> }>;
  PaginatedMapItem: ResolverTypeWrapper<Omit<PaginatedMapItem, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['MapItem']>>> }>;
  PaginatedMd2DictionaryMapping: ResolverTypeWrapper<PaginatedMd2DictionaryMapping>;
  PaginatedOrganisation: ResolverTypeWrapper<Omit<PaginatedOrganisation, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['Organisation']>>> }>;
  PaginatedOrganisationQuotaLedger: ResolverTypeWrapper<PaginatedOrganisationQuotaLedger>;
  PaginatedPreOrder: ResolverTypeWrapper<Omit<PaginatedPreOrder, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['PreOrder']>>> }>;
  PaginatedScaleTicket: ResolverTypeWrapper<PaginatedScaleTicket>;
  PaginatedScaleTicketBooking: ResolverTypeWrapper<PaginatedScaleTicketBooking>;
  PaginatedScaleTicketBookingDispute: ResolverTypeWrapper<PaginatedScaleTicketBookingDispute>;
  PaginatedScaleTicketDataMapping: ResolverTypeWrapper<Omit<PaginatedScaleTicketDataMapping, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['ScaleTicketDataMapping']>>> }>;
  PaginatedScaleTicketHistory: ResolverTypeWrapper<PaginatedScaleTicketHistory>;
  PaginatedScaleTicketSellerMapping: ResolverTypeWrapper<Omit<PaginatedScaleTicketSellerMapping, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['ScaleTicketSellerMapping']>>> }>;
  PaginatedScaleTicketUpload: ResolverTypeWrapper<PaginatedScaleTicketUpload>;
  PaginatedScoutingTask: ResolverTypeWrapper<Omit<PaginatedScoutingTask, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['ScoutingTask']>>> }>;
  PaginatedSmartSprayerExecution: ResolverTypeWrapper<Omit<PaginatedSmartSprayerExecution, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['SmartSprayerExecution']>>> }>;
  PaginatedSmartSprayerRegistration: ResolverTypeWrapper<PaginatedSmartSprayerRegistration>;
  PaginatedSmartSprayerWeedPressureFields: ResolverTypeWrapper<Omit<PaginatedSmartSprayerWeedPressureFields, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['SmartSprayerWeedPressureFieldListItem']>>> }>;
  PaginatedSustainabilityOrganisationCapability: ResolverTypeWrapper<Omit<PaginatedSustainabilityOrganisationCapability, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['SustainabilityOrganisationCapability']>>> }>;
  PaginatedSustainabilityProgram: ResolverTypeWrapper<Omit<PaginatedSustainabilityProgram, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['SustainabilityProgram']>>> }>;
  PaginatedSustainabilityProgramBranchAssignment: ResolverTypeWrapper<Omit<PaginatedSustainabilityProgramBranchAssignment, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramBranchAssignment']>>> }>;
  PaginatedSustainabilityProgramEnrolledField: ResolverTypeWrapper<PaginatedSustainabilityProgramEnrolledField>;
  PaginatedSustainabilityProgramInvitation: ResolverTypeWrapper<Omit<PaginatedSustainabilityProgramInvitation, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramInvitation']>>> }>;
  PaginatedSustainabilityProgramOrganisationParticipation: ResolverTypeWrapper<Omit<PaginatedSustainabilityProgramOrganisationParticipation, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramOrganisationParticipation']>>> }>;
  PaginatedTask: ResolverTypeWrapper<Omit<PaginatedTask, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['GeneralTask']>>> }>;
  PaginatedTrialsV2: ResolverTypeWrapper<Omit<PaginatedTrialsV2, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['TrialV2']>>> }>;
  PaginatedUploadDataset: ResolverTypeWrapper<Omit<PaginatedUploadDataset, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['FieldDataUploadDataset']>>> }>;
  PaginatedVariety: ResolverTypeWrapper<Omit<PaginatedVariety, 'items'> & { items?: Maybe<Array<Maybe<ResolversTypes['Variety']>>> }>;
  Pagination: ResolverTypeWrapper<Pagination>;
  PanoramaClient: ResolverTypeWrapper<PanoramaClient>;
  PanoramaConnectionStatus: ResolverTypeWrapper<PanoramaConnectionStatus>;
  PanoramaFarm: ResolverTypeWrapper<PanoramaFarm>;
  PanoramaField: ResolverTypeWrapper<PanoramaField>;
  PanoramaOrganization: ResolverTypeWrapper<PanoramaOrganization>;
  PayloadData: ResolverTypeWrapper<Omit<PayloadData, 'payload'> & { payload?: Maybe<ResolversTypes['AggregatedNotificationPayload']> }>;
  PaymentType: PaymentType;
  Permission: ResolverTypeWrapper<Omit<Permission, 'grantee' | 'granter'> & { grantee?: Maybe<ResolversTypes['User']>, granter?: Maybe<ResolversTypes['User']> }>;
  PermissionRequest: ResolverTypeWrapper<Omit<PermissionRequest, 'requestee' | 'requester'> & { requestee?: Maybe<ResolversTypes['User']>, requester?: Maybe<ResolversTypes['User']> }>;
  PermissionRequestStatus: PermissionRequestStatus;
  PermissionTag: PermissionTag;
  PestDevelopmentPrediction: ResolverTypeWrapper<Omit<PestDevelopmentPrediction, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  PestDevelopmentStatus: PestDevelopmentStatus;
  PlannedExecutionStatus: PlannedExecutionStatus;
  Plausibility: ResolverTypeWrapper<Plausibility>;
  PreOrder: ResolverTypeWrapper<Omit<PreOrder, 'crop' | 'farm' | 'hfServiceDetails'> & { crop?: Maybe<ResolversTypes['Crop']>, farm: ResolversTypes['FarmV2'], hfServiceDetails?: Maybe<ResolversTypes['PreOrderHfServiceDetails']> }>;
  PreOrderCropQuota: ResolverTypeWrapper<Omit<PreOrderCropQuota, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  PreOrderHfServiceDetails: ResolverTypeWrapper<Omit<PreOrderHfServiceDetails, 'areaClasses' | 'assignedAgronomicConsultant' | 'assignedContractor' | 'hfReferenceCodePublic' | 'quotas'> & { areaClasses?: Maybe<Array<ResolversTypes['PreOrderHfServiceRequestAreaClass']>>, assignedAgronomicConsultant?: Maybe<ResolversTypes['User']>, assignedContractor?: Maybe<ResolversTypes['User']>, hfReferenceCodePublic?: Maybe<ResolversTypes['HfReferenceCodePublic']>, quotas?: Maybe<Array<Maybe<ResolversTypes['PreOrderQuota']>>> }>;
  PreOrderHfServiceRequestAreaClass: ResolverTypeWrapper<Omit<PreOrderHfServiceRequestAreaClass, 'crop'> & { crop: ResolversTypes['Crop'] }>;
  PreOrderHfServiceRequestShippingAddress: ResolverTypeWrapper<PreOrderHfServiceRequestShippingAddress>;
  PreOrderQuota: ResolverTypeWrapper<Omit<PreOrderQuota, 'crop'> & { crop: ResolversTypes['Crop'] }>;
  PrecifieldBiomassMap: ResolverTypeWrapper<Omit<PrecifieldBiomassMap, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  PrecifieldCerealsMapSubscription: ResolverTypeWrapper<Omit<PrecifieldCerealsMapSubscription, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  PrecifieldNitrogenPrescriptionMap: ResolverTypeWrapper<Omit<PrecifieldNitrogenPrescriptionMap, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  PrecifieldOsrMapSubscription: ResolverTypeWrapper<Omit<PrecifieldOsrMapSubscription, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  PrecifieldSubscriptionStatus: PrecifieldSubscriptionStatus;
  PrecifieldYieldPotentialMap: ResolverTypeWrapper<Omit<PrecifieldYieldPotentialMap, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  Prediction: ResolverTypeWrapper<Prediction>;
  PremiumBand: ResolverTypeWrapper<PremiumBand>;
  Pricing: Pricing;
  PricingSeason: PricingSeason;
  ProcessingType: ProcessingType;
  ProduceDeliveryTask: ResolverTypeWrapper<Omit<ProduceDeliveryTask, 'assignee' | 'cropSeasonV2'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  ProduceDeliveryTaskProduceProperties: ResolverTypeWrapper<ProduceDeliveryTaskProduceProperties>;
  Product: ResolverTypeWrapper<Product>;
  ProductApplicationRate: ResolverTypeWrapper<ProductApplicationRate>;
  ProductCategoryType: ProductCategoryType;
  ProductFeature: ResolverTypeWrapper<Omit<ProductFeature, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  ProductFeatureType: ProductFeatureType;
  ProductFormulationTypeGroup: ProductFormulationTypeGroup;
  ProductPack: ResolverTypeWrapper<Omit<ProductPack, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  ProductPermissibleRate: ResolverTypeWrapper<Omit<ProductPermissibleRate, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  ProductPermissibleRateV2: ResolverTypeWrapper<Omit<ProductPermissibleRateV2, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  ProductRate: ResolverTypeWrapper<ProductRate>;
  ProductRateInput: ProductRateInput;
  ProductRecommendationTankMix: ResolverTypeWrapper<ProductRecommendationTankMix>;
  ProductRecommendationsGroupSort: ProductRecommendationsGroupSort;
  ProductV2: ResolverTypeWrapper<Omit<ProductV2, 'farmV2'> & { farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  ProgramType: ProgramType;
  ProjectedDailyIncidence: ResolverTypeWrapper<ProjectedDailyIncidence>;
  ProjectedIncidences: ResolverTypeWrapper<Omit<ProjectedIncidences, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  ProofOfPurchaseStatus: ProofOfPurchaseStatus;
  ProtectionLevel: ProtectionLevel;
  ProtectionTime: ResolverTypeWrapper<Omit<ProtectionTime, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  ProtectionType: ProtectionType;
  Protocol: ResolverTypeWrapper<Protocol>;
  ProtocolAttachment: ResolverTypeWrapper<ProtocolAttachment>;
  PublicOrganisation: ResolverTypeWrapper<Omit<PublicOrganisation, 'billingAddress' | 'owner'> & { billingAddress?: Maybe<ResolversTypes['Address']>, owner?: Maybe<ResolversTypes['User']> }>;
  PurchasedLicense: ResolverTypeWrapper<PurchasedLicense>;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  QuotaLimit: ResolverTypeWrapper<Omit<QuotaLimit, 'creator' | 'organisation'> & { creator?: Maybe<ResolversTypes['User']>, organisation: ResolversTypes['Organisation'] }>;
  QuotaTransfer: ResolverTypeWrapper<Omit<QuotaTransfer, 'creator'> & { creator?: Maybe<ResolversTypes['User']> }>;
  RateByZone: ResolverTypeWrapper<RateByZone>;
  RateCategory: RateCategory;
  RateUnit: RateUnit;
  RatesCalculationRequest: ResolverTypeWrapper<RatesCalculationRequest>;
  RecentlyUsedProduct: ResolverTypeWrapper<Omit<RecentlyUsedProduct, 'farmV2'> & { farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  RecommendationActionValidity: ResolverTypeWrapper<RecommendationActionValidity>;
  RecommendationSnooze: ResolverTypeWrapper<Omit<RecommendationSnooze, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  RecommendationSnoozeType: RecommendationSnoozeType;
  RecommendationStatusType: RecommendationStatusType;
  RecommendedRate: ResolverTypeWrapper<RecommendedRate>;
  RecommendedTimingForApplication: ResolverTypeWrapper<RecommendedTimingForApplication>;
  ReferenceProductRate: ResolverTypeWrapper<ReferenceProductRate>;
  ReferenceTotalMixtureRate: ResolverTypeWrapper<ReferenceTotalMixtureRate>;
  RegionRate: ResolverTypeWrapper<RegionRate>;
  RelativeMaturity: ResolverTypeWrapper<RelativeMaturity>;
  RenderingType: RenderingType;
  ResidualActivation: ResolverTypeWrapper<ResidualActivation>;
  ResidualActivationStatus: ResidualActivationStatus;
  ResponseStatus: ResolverTypeWrapper<ResponseStatus>;
  Risk: ResolverTypeWrapper<Omit<Risk, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  RiskClass: RiskClass;
  RiskClassification: ResolverTypeWrapper<RiskClassification>;
  RiskLevel: RiskLevel;
  RiskMap: ResolverTypeWrapper<RiskMap>;
  RiskType: RiskType;
  RiskV2: ResolverTypeWrapper<Omit<RiskV2, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  RoleFeatureName: RoleFeatureName;
  SampledPoint: ResolverTypeWrapper<SampledPoint>;
  SamplingArea: ResolverTypeWrapper<SamplingArea>;
  SamplingDepth: ResolverTypeWrapper<SamplingDepth>;
  SamplingId: ResolverTypeWrapper<SamplingId>;
  SamplingPoint: ResolverTypeWrapper<SamplingPoint>;
  Scale: Scale;
  ScaleTicket: ResolverTypeWrapper<ScaleTicket>;
  ScaleTicketBooking: ResolverTypeWrapper<ScaleTicketBooking>;
  ScaleTicketBookingDispute: ResolverTypeWrapper<ScaleTicketBookingDispute>;
  ScaleTicketBookingDisputeCorrectionReason: ScaleTicketBookingDisputeCorrectionReason;
  ScaleTicketBookingDisputeReason: ScaleTicketBookingDisputeReason;
  ScaleTicketBookingDisputeSort: ScaleTicketBookingDisputeSort;
  ScaleTicketBookingDisputeSortColumn: ScaleTicketBookingDisputeSortColumn;
  ScaleTicketBookingDisputeSplit: ResolverTypeWrapper<ScaleTicketBookingDisputeSplit>;
  ScaleTicketBookingDisputeState: ScaleTicketBookingDisputeState;
  ScaleTicketBookingSort: ScaleTicketBookingSort;
  ScaleTicketBookingSortColumn: ScaleTicketBookingSortColumn;
  ScaleTicketBookingState: ScaleTicketBookingState;
  ScaleTicketDataMapping: ResolverTypeWrapper<Omit<ScaleTicketDataMapping, 'organisation'> & { organisation?: Maybe<ResolversTypes['Organisation']> }>;
  ScaleTicketDataMappingSort: ScaleTicketDataMappingSort;
  ScaleTicketDataMappingSortColumn: ScaleTicketDataMappingSortColumn;
  ScaleTicketDuplicateNumberSummary: ResolverTypeWrapper<ScaleTicketDuplicateNumberSummary>;
  ScaleTicketDuplicateTicket: ResolverTypeWrapper<ScaleTicketDuplicateTicket>;
  ScaleTicketHarvestCapSummary: ResolverTypeWrapper<ScaleTicketHarvestCapSummary>;
  ScaleTicketHistory: ResolverTypeWrapper<ScaleTicketHistory>;
  ScaleTicketHistoryField: ScaleTicketHistoryField;
  ScaleTicketHistoryKind: ScaleTicketHistoryKind;
  ScaleTicketHistorySort: ScaleTicketHistorySort;
  ScaleTicketHistorySortColumn: ScaleTicketHistorySortColumn;
  ScaleTicketMissingHarvestSummary: ResolverTypeWrapper<ScaleTicketMissingHarvestSummary>;
  ScaleTicketMissingMoistureSummary: ResolverTypeWrapper<ScaleTicketMissingMoistureSummary>;
  ScaleTicketNamedRef: ResolverTypeWrapper<ScaleTicketNamedRef>;
  ScaleTicketSellerMapping: ResolverTypeWrapper<Omit<ScaleTicketSellerMapping, 'organisation'> & { organisation?: Maybe<ResolversTypes['Organisation']> }>;
  ScaleTicketSellerMappingSort: ScaleTicketSellerMappingSort;
  ScaleTicketSellerMappingSortColumn: ScaleTicketSellerMappingSortColumn;
  ScaleTicketSellerNotMatched: ResolverTypeWrapper<ScaleTicketSellerNotMatched>;
  ScaleTicketSellerRef: ResolverTypeWrapper<ScaleTicketSellerRef>;
  ScaleTicketSort: ScaleTicketSort;
  ScaleTicketSortColumn: ScaleTicketSortColumn;
  ScaleTicketState: ScaleTicketState;
  ScaleTicketStateSummary: ResolverTypeWrapper<ScaleTicketStateSummary>;
  ScaleTicketStates: ResolverTypeWrapper<ScaleTicketStates>;
  ScaleTicketSummary: ResolverTypeWrapper<ScaleTicketSummary>;
  ScaleTicketUpload: ResolverTypeWrapper<ScaleTicketUpload>;
  ScaleTicketUploadError: ScaleTicketUploadError;
  ScaleTicketUploadSort: ScaleTicketUploadSort;
  ScaleTicketUploadSortColumn: ScaleTicketUploadSortColumn;
  ScaleTicketUploadState: ScaleTicketUploadState;
  ScaleTicketUploadSummary: ResolverTypeWrapper<ScaleTicketUploadSummary>;
  ScaleTicketUploadTicketStates: ResolverTypeWrapper<ScaleTicketUploadTicketStates>;
  ScaleV2: ScaleV2;
  ScoutingGrowthStage: ResolverTypeWrapper<ScoutingGrowthStage>;
  ScoutingPoi: ResolverTypeWrapper<Omit<ScoutingPoi, 'creator'> & { creator?: Maybe<ResolversTypes['User']> }>;
  ScoutingPoiAlgorithmType: ScoutingPoiAlgorithmType;
  ScoutingPoiImage: ResolverTypeWrapper<ScoutingPoiImage>;
  ScoutingPoiResult: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ScoutingPoiResult']>;
  ScoutingPoiResultStatus: ScoutingPoiResultStatus;
  ScoutingPoiV2: ResolverTypeWrapper<Omit<ScoutingPoiV2, 'creator' | 'result'> & { creator?: Maybe<ResolversTypes['User']>, result?: Maybe<ResolversTypes['ScoutingPoiResult']> }>;
  ScoutingProtocol: ResolverTypeWrapper<Omit<ScoutingProtocol, 'crop' | 'organisation'> & { crop?: Maybe<ResolversTypes['Crop']>, organisation?: Maybe<ResolversTypes['Organisation']> }>;
  ScoutingReport: ResolverTypeWrapper<Omit<ScoutingReport, 'farm' | 'fieldNotes'> & { farm?: Maybe<ResolversTypes['FarmV2']>, fieldNotes?: Maybe<Array<Maybe<ResolversTypes['FieldNote']>>> }>;
  ScoutingReportDispatchOrder: ResolverTypeWrapper<Omit<ScoutingReportDispatchOrder, 'recipients' | 'scoutingReport'> & { recipients?: Maybe<Array<Maybe<ResolversTypes['User']>>>, scoutingReport?: Maybe<ResolversTypes['ScoutingReport']> }>;
  ScoutingReportDispatchOrderStatus: ScoutingReportDispatchOrderStatus;
  ScoutingReportShareType: ScoutingReportShareType;
  ScoutingStressAnswer: ResolverTypeWrapper<ScoutingStressAnswer>;
  ScoutingStressQuestion: ResolverTypeWrapper<Omit<ScoutingStressQuestion, 'crop'> & { crop: ResolversTypes['Crop'] }>;
  ScoutingTask: ResolverTypeWrapper<Omit<ScoutingTask, 'assessmentTiming' | 'assignee' | 'cropSeasonV2' | 'farm' | 'fieldV2' | 'scoutingPoisV2' | 'trial'> & { assessmentTiming?: Maybe<ResolversTypes['AssessmentTiming']>, assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, farm?: Maybe<ResolversTypes['FarmV2']>, fieldV2: ResolversTypes['FieldV2'], scoutingPoisV2?: Maybe<Array<Maybe<ResolversTypes['ScoutingPoiV2']>>>, trial?: Maybe<ResolversTypes['Trial']> }>;
  ScoutingTaskAssignmentState: ScoutingTaskAssignmentState;
  ScoutingTaskSort: ScoutingTaskSort;
  ScoutingTaskSortColumn: ScoutingTaskSortColumn;
  ScoutingTaskState: ScoutingTaskState;
  SearchTreatmentProgramActionDateInput: SearchTreatmentProgramActionDateInput;
  SearchTreatmentProgramActionInput: SearchTreatmentProgramActionInput;
  SeasonResolutionStatus: SeasonResolutionStatus;
  SeasonTimeline: ResolverTypeWrapper<SeasonTimeline>;
  SeasonTimelineFeatures: ResolverTypeWrapper<SeasonTimelineFeatures>;
  Section: ResolverTypeWrapper<Section>;
  SectionInput: SectionInput;
  SectionSummary: ResolverTypeWrapper<SectionSummary>;
  SectionSummaryInput: SectionSummaryInput;
  SeedBoxTreatment: ResolverTypeWrapper<Omit<SeedBoxTreatment, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  SeedSelectorInput: ResolverTypeWrapper<Omit<SeedSelectorInput, 'field' | 'variety'> & { field?: Maybe<ResolversTypes['FieldV2']>, variety?: Maybe<ResolversTypes['Variety']> }>;
  SeedTreatment: ResolverTypeWrapper<Omit<SeedTreatment, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  SeedTreatmentType: ResolverTypeWrapper<SeedTreatmentType>;
  SelectedYear: ResolverTypeWrapper<SelectedYear>;
  Sensitivity: Sensitivity;
  SensorStatusVariableDetail: ResolverTypeWrapper<SensorStatusVariableDetail>;
  ServiceType: ServiceType;
  SharingMandate: ResolverTypeWrapper<SharingMandate>;
  SharingMandatePermission: ResolverTypeWrapper<SharingMandatePermission>;
  ShopDevicePackage: ResolverTypeWrapper<ShopDevicePackage>;
  ShopFarmPackage: ResolverTypeWrapper<ShopFarmPackage>;
  ShopGiftCard: ResolverTypeWrapper<ShopGiftCard>;
  ShopPaymentVendor: ShopPaymentVendor;
  ShopSubscription: ResolverTypeWrapper<Omit<ShopSubscription, 'owner' | 'subscriptionItems' | 'subscriptionPeriods'> & { owner?: Maybe<ResolversTypes['User']>, subscriptionItems?: Maybe<Array<Maybe<ResolversTypes['ShopSubscriptionItem']>>>, subscriptionPeriods?: Maybe<Array<Maybe<ResolversTypes['ShopSubscriptionPeriod']>>> }>;
  ShopSubscriptionAddressInformation: ResolverTypeWrapper<ShopSubscriptionAddressInformation>;
  ShopSubscriptionBillingAddress: ResolverTypeWrapper<ShopSubscriptionBillingAddress>;
  ShopSubscriptionItem: ResolverTypeWrapper<Omit<ShopSubscriptionItem, 'farm' | 'owner' | 'subscription' | 'user'> & { farm?: Maybe<ResolversTypes['FarmV2']>, owner?: Maybe<ResolversTypes['User']>, subscription?: Maybe<ResolversTypes['ShopSubscription']>, user?: Maybe<ResolversTypes['User']> }>;
  ShopSubscriptionPaymentDetails: ResolverTypeWrapper<ShopSubscriptionPaymentDetails>;
  ShopSubscriptionPeriod: ResolverTypeWrapper<Omit<ShopSubscriptionPeriod, 'owner' | 'subscription'> & { owner?: Maybe<ResolversTypes['User']>, subscription?: Maybe<ResolversTypes['ShopSubscription']> }>;
  ShopSubscriptionShippingAddress: ResolverTypeWrapper<ShopSubscriptionShippingAddress>;
  ShopSubscriptionStatus: ShopSubscriptionStatus;
  ShopUserPackage: ResolverTypeWrapper<Omit<ShopUserPackage, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  Site: ResolverTypeWrapper<Site>;
  SmagConnectionStatus: ResolverTypeWrapper<SmagConnectionStatus>;
  SmartSprayerDeviceFeature: SmartSprayerDeviceFeature;
  SmartSprayerExecution: ResolverTypeWrapper<Omit<SmartSprayerExecution, 'crop' | 'field' | 'offlineTask' | 'smartSprayingTaskV2' | 'terminalTask'> & { crop?: Maybe<ResolversTypes['Crop']>, field?: Maybe<ResolversTypes['FieldV2']>, offlineTask?: Maybe<ResolversTypes['SmartSprayingOfflineTask']>, smartSprayingTaskV2?: Maybe<ResolversTypes['SmartSprayingTaskV2']>, terminalTask?: Maybe<ResolversTypes['SmartSprayingTerminalTask']> }>;
  SmartSprayerExecutionFieldInfo: ResolverTypeWrapper<SmartSprayerExecutionFieldInfo>;
  SmartSprayerExecutionMissingInfo: ResolverTypeWrapper<SmartSprayerExecutionMissingInfo>;
  SmartSprayerExecutionSort: SmartSprayerExecutionSort;
  SmartSprayerExecutionSortColumn: SmartSprayerExecutionSortColumn;
  SmartSprayerExecutionStatistics: ResolverTypeWrapper<SmartSprayerExecutionStatistics>;
  SmartSprayerExecutionSummary: ResolverTypeWrapper<SmartSprayerExecutionSummary>;
  SmartSprayerLicense: ResolverTypeWrapper<SmartSprayerLicense>;
  SmartSprayerRegistration: ResolverTypeWrapper<Omit<SmartSprayerRegistration, 'smartSprayerExecutions' | 'user'> & { smartSprayerExecutions?: Maybe<Array<Maybe<ResolversTypes['SmartSprayerExecution']>>>, user?: Maybe<ResolversTypes['User']> }>;
  SmartSprayerRegistrationOem: SmartSprayerRegistrationOem;
  SmartSprayerRegistrationSort: SmartSprayerRegistrationSort;
  SmartSprayerRegistrationSortColumn: SmartSprayerRegistrationSortColumn;
  SmartSprayerRegistrationStatus: ResolverTypeWrapper<SmartSprayerRegistrationStatus>;
  SmartSprayerRegistrationType: SmartSprayerRegistrationType;
  SmartSprayerStatusPackage: ResolverTypeWrapper<SmartSprayerStatusPackage>;
  SmartSprayerWeedPressureApplication: ResolverTypeWrapper<SmartSprayerWeedPressureApplication>;
  SmartSprayerWeedPressureApplicationSelection: ResolverTypeWrapper<SmartSprayerWeedPressureApplicationSelection>;
  SmartSprayerWeedPressureCalculationState: SmartSprayerWeedPressureCalculationState;
  SmartSprayerWeedPressureExclusionSet: ResolverTypeWrapper<SmartSprayerWeedPressureExclusionSet>;
  SmartSprayerWeedPressureField: ResolverTypeWrapper<Omit<SmartSprayerWeedPressureField, 'farm' | 'field'> & { farm?: Maybe<ResolversTypes['FarmV2']>, field?: Maybe<ResolversTypes['FieldV2']> }>;
  SmartSprayerWeedPressureFieldDataState: SmartSprayerWeedPressureFieldDataState;
  SmartSprayerWeedPressureFieldListItem: ResolverTypeWrapper<Omit<SmartSprayerWeedPressureFieldListItem, 'farm' | 'field'> & { farm?: Maybe<ResolversTypes['FarmV2']>, field?: Maybe<ResolversTypes['FieldV2']> }>;
  SmartSprayerWeedPressureFieldSort: SmartSprayerWeedPressureFieldSort;
  SmartSprayerWeedPressureFieldSortColumn: SmartSprayerWeedPressureFieldSortColumn;
  SmartSprayerWeedPressureHistoryKind: SmartSprayerWeedPressureHistoryKind;
  SmartSprayerWeedPressureHotSpotHistoryPoint: ResolverTypeWrapper<SmartSprayerWeedPressureHotSpotHistoryPoint>;
  SmartSprayerWeedPressureRecalculation: ResolverTypeWrapper<SmartSprayerWeedPressureRecalculation>;
  SmartSprayerWeedPressureRecalculationReason: SmartSprayerWeedPressureRecalculationReason;
  SmartSprayerWeedPressureRecalculationStatus: SmartSprayerWeedPressureRecalculationStatus;
  SmartSprayerWeedPressureSeasonKind: SmartSprayerWeedPressureSeasonKind;
  SmartSprayerWeedPressureSettingsApplied: ResolverTypeWrapper<SmartSprayerWeedPressureSettingsApplied>;
  SmartSprayerWeedPressureStatistics: ResolverTypeWrapper<SmartSprayerWeedPressureStatistics>;
  SmartSprayerWeedPressureStatisticsSummary: ResolverTypeWrapper<SmartSprayerWeedPressureStatisticsSummary>;
  SmartSprayerWeedPressureTimeWeighting: SmartSprayerWeedPressureTimeWeighting;
  SmartSprayerWeedPressureTrendDirection: SmartSprayerWeedPressureTrendDirection;
  SmartSprayerWeedPressureWeedSize: SmartSprayerWeedPressureWeedSize;
  SmartSprayerWeedPressureWeightingMode: SmartSprayerWeedPressureWeightingMode;
  SmartSprayingOfflineTask: ResolverTypeWrapper<Omit<SmartSprayingOfflineTask, 'crop' | 'cropSeason' | 'field' | 'smartSprayingExecution' | 'smartSprayingTask' | 'smartSprayingTaskV2'> & { crop?: Maybe<ResolversTypes['Crop']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, field?: Maybe<ResolversTypes['FieldV2']>, smartSprayingExecution?: Maybe<ResolversTypes['SmartSprayerExecution']>, smartSprayingTask?: Maybe<ResolversTypes['SmartSprayingTask']>, smartSprayingTaskV2?: Maybe<ResolversTypes['SmartSprayingTaskV2']> }>;
  SmartSprayingTask: ResolverTypeWrapper<Omit<SmartSprayingTask, 'assignee' | 'cropSeason' | 'dosedMap' | 'smartSprayingExecution' | 'smartSprayingTaskDevicePayloads'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, dosedMap?: Maybe<ResolversTypes['DosedMap']>, smartSprayingExecution?: Maybe<ResolversTypes['SmartSprayerExecution']>, smartSprayingTaskDevicePayloads?: Maybe<Array<Maybe<ResolversTypes['SmartSprayingTaskDevicePayload']>>> }>;
  SmartSprayingTaskDevicePayload: ResolverTypeWrapper<Omit<SmartSprayingTaskDevicePayload, 'smartSprayingTask' | 'smartSprayingTaskV2'> & { smartSprayingTask?: Maybe<ResolversTypes['SmartSprayingTask']>, smartSprayingTaskV2?: Maybe<ResolversTypes['SmartSprayingTaskV2']> }>;
  SmartSprayingTaskDevicePayloadError: SmartSprayingTaskDevicePayloadError;
  SmartSprayingTaskDevicePayloadStatus: SmartSprayingTaskDevicePayloadStatus;
  SmartSprayingTaskDevicePayloadWarning: SmartSprayingTaskDevicePayloadWarning;
  SmartSprayingTaskDosedMap: ResolverTypeWrapper<Omit<SmartSprayingTaskDosedMap, 'dosedMap'> & { dosedMap?: Maybe<ResolversTypes['DosedMap']> }>;
  SmartSprayingTaskV2: ResolverTypeWrapper<Omit<SmartSprayingTaskV2, 'assignee' | 'cropSeason' | 'dosedMaps' | 'smartSprayingExecution' | 'smartSprayingTaskDevicePayloads'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, dosedMaps?: Maybe<Array<Maybe<ResolversTypes['SmartSprayingTaskDosedMap']>>>, smartSprayingExecution?: Maybe<ResolversTypes['SmartSprayerExecution']>, smartSprayingTaskDevicePayloads?: Maybe<Array<Maybe<ResolversTypes['SmartSprayingTaskDevicePayload']>>> }>;
  SmartSprayingTerminalStrategyMappings: ResolverTypeWrapper<SmartSprayingTerminalStrategyMappings>;
  SmartSprayingTerminalTask: ResolverTypeWrapper<Omit<SmartSprayingTerminalTask, 'smartSprayingExecution' | 'smartSprayingTask' | 'smartSprayingTaskV2'> & { smartSprayingExecution?: Maybe<ResolversTypes['SmartSprayerExecution']>, smartSprayingTask?: Maybe<ResolversTypes['SmartSprayingTask']>, smartSprayingTaskV2?: Maybe<ResolversTypes['SmartSprayingTaskV2']> }>;
  SoilDrainageClass: SoilDrainageClass;
  SoilErosion: ResolverTypeWrapper<Omit<SoilErosion, 'fieldV2'> & { fieldV2?: Maybe<ResolversTypes['FieldV2']> }>;
  SoilPropertyType: SoilPropertyType;
  SoilSample: ResolverTypeWrapper<SoilSample>;
  SoilSampling: ResolverTypeWrapper<Omit<SoilSampling, 'field' | 'samplingAreas' | 'soilSamplingTasks'> & { field?: Maybe<ResolversTypes['FieldV2']>, samplingAreas?: Maybe<Array<Maybe<ResolversTypes['SamplingArea']>>>, soilSamplingTasks?: Maybe<Array<Maybe<ResolversTypes['SoilSamplingTask']>>> }>;
  SoilSamplingMeasurement: ResolverTypeWrapper<SoilSamplingMeasurement>;
  SoilSamplingPattern: SoilSamplingPattern;
  SoilSamplingResult: ResolverTypeWrapper<Omit<SoilSamplingResult, 'field' | 'files' | 'soilSampling' | 'sourceSoilSamplingResult'> & { field?: Maybe<ResolversTypes['FieldV2']>, files?: Maybe<Array<Maybe<ResolversTypes['File']>>>, soilSampling?: Maybe<ResolversTypes['SoilSampling']>, sourceSoilSamplingResult?: Maybe<ResolversTypes['SoilSamplingResult']> }>;
  SoilSamplingResultArea: ResolverTypeWrapper<SoilSamplingResultArea>;
  SoilSamplingResultSourceMap: ResolverTypeWrapper<SoilSamplingResultSourceMap>;
  SoilSamplingResultStatus: SoilSamplingResultStatus;
  SoilSamplingStressAnalysis: ResolverTypeWrapper<Omit<SoilSamplingStressAnalysis, 'field' | 'soilSamplingResult'> & { field?: Maybe<ResolversTypes['FieldV2']>, soilSamplingResult?: Maybe<ResolversTypes['SoilSamplingResult']> }>;
  SoilSamplingTask: ResolverTypeWrapper<Omit<SoilSamplingTask, 'assignee' | 'cropSeasonV2' | 'soilSamplingSet'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, soilSamplingSet?: Maybe<ResolversTypes['SoilSampling']> }>;
  SoilSamplingType: SoilSamplingType;
  SoilSamplingUnit: SoilSamplingUnit;
  SoilTaxonomy: ResolverTypeWrapper<SoilTaxonomy>;
  SoilTexture: ResolverTypeWrapper<SoilTexture>;
  SortDirection: SortDirection;
  SourceCardinality: SourceCardinality;
  SourceMap: ResolverTypeWrapper<Omit<SourceMap, 'cropSeason' | 'cropSeasonV2' | 'field'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, field?: Maybe<ResolversTypes['FieldV2']> }>;
  SourceMapStyle: ResolverTypeWrapper<SourceMapStyle>;
  SourceMapStyleEntry: ResolverTypeWrapper<SourceMapStyleEntry>;
  SourceMapType: SourceMapType;
  SourceType: SourceType;
  SourceValueMapping: ResolverTypeWrapper<SourceValueMapping>;
  SpecialisedUsageType: SpecialisedUsageType;
  SpeciesLossType: SpeciesLossType;
  SprayWeather: ResolverTypeWrapper<Omit<SprayWeather, 'factors' | 'field' | 'fieldV2'> & { factors?: Maybe<Array<Maybe<ResolversTypes['SprayWeatherFactor']>>>, field?: Maybe<ResolversTypes['Field']>, fieldV2?: Maybe<ResolversTypes['FieldV2']> }>;
  SprayWeatherFactor: ResolverTypeWrapper<SprayWeatherFactor>;
  SprayWeatherFactorFactor: SprayWeatherFactorFactor;
  SprayWeatherResult: SprayWeatherResult;
  Sprayer: ResolverTypeWrapper<Sprayer>;
  SprayerManufacturer: ResolverTypeWrapper<SprayerManufacturer>;
  SprayerType: ResolverTypeWrapper<SprayerType>;
  Spraying: ResolverTypeWrapper<Omit<Spraying, 'cropSeason' | 'dosedMap'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, dosedMap?: Maybe<ResolversTypes['DosedMap']> }>;
  SprayingNutrient: ResolverTypeWrapper<SprayingNutrient>;
  SprayingV2: ResolverTypeWrapper<Omit<SprayingV2, 'assignee' | 'availableDosedMaps' | 'cropSeason' | 'cropSeasonV2' | 'dosedMap' | 'hortaSpraying'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, availableDosedMaps?: Maybe<Array<ResolversTypes['AvailableDosedMap']>>, cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']>, dosedMap?: Maybe<ResolversTypes['DosedMap']>, hortaSpraying?: Maybe<ResolversTypes['HortaSpraying']> }>;
  SprayingWindow: ResolverTypeWrapper<SprayingWindow>;
  SprayingWindowStatus: SprayingWindowStatus;
  StacFarmStatistics: ResolverTypeWrapper<StacFarmStatistics>;
  StacFieldDataLayer: StacFieldDataLayer;
  StacHistogram: ResolverTypeWrapper<StacHistogram>;
  StacItemRender: ResolverTypeWrapper<Omit<StacItemRender, 'cropSeason' | 'field' | 'source'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, field: ResolversTypes['FieldV2'], source?: Maybe<ResolversTypes['StacItemRenderSource']> }>;
  StacItemRenderSource: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['StacItemRenderSource']>;
  StacItemSelectionReason: StacItemSelectionReason;
  StacItemVectorizeGeometry: ResolverTypeWrapper<StacItemVectorizeGeometry>;
  StacLegend: ResolverTypeWrapper<StacLegend>;
  StacMagnitudeType: StacMagnitudeType;
  StacMosaicRender: ResolverTypeWrapper<StacMosaicRender>;
  StacStatistics: ResolverTypeWrapper<StacStatistics>;
  Statistic: ResolverTypeWrapper<Statistic>;
  Status: Status;
  StirObject: ResolverTypeWrapper<StirObject>;
  StirOperation: ResolverTypeWrapper<StirOperation>;
  StirTaskType: StirTaskType;
  Strategy: Strategy;
  Stress: ResolverTypeWrapper<Stress>;
  StressAnswer: ResolverTypeWrapper<StressAnswer>;
  StressEfficacyCharacteristics: ResolverTypeWrapper<Omit<StressEfficacyCharacteristics, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  StressQuestion: ResolverTypeWrapper<Omit<StressQuestion, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  StressRisk: ResolverTypeWrapper<StressRisk>;
  StressRiskValue: StressRiskValue;
  StressSetting: ResolverTypeWrapper<StressSetting>;
  StressSettings: ResolverTypeWrapper<Omit<StressSettings, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  StressV2: ResolverTypeWrapper<StressV2>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Subscription: ResolverTypeWrapper<Record<PropertyKey, never>>;
  SubscriptionPreference: ResolverTypeWrapper<Omit<SubscriptionPreference, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  SubscriptionPreferenceCategory: SubscriptionPreferenceCategory;
  SubscriptionPreferenceFarm: ResolverTypeWrapper<SubscriptionPreferenceFarm>;
  SubscriptionStatus: SubscriptionStatus;
  SubstanceApplicationRate: ResolverTypeWrapper<SubstanceApplicationRate>;
  SubstanceRateV2: ResolverTypeWrapper<SubstanceRateV2>;
  SubstanceType: SubstanceType;
  SupportedTaskType: ResolverTypeWrapper<SupportedTaskType>;
  SustainabilityAdjudicator: SustainabilityAdjudicator;
  SustainabilityIndicator: ResolverTypeWrapper<Omit<SustainabilityIndicator, 'co2EquivalentFootprint' | 'cropSeason' | 'nitrogenFootprint' | 'waterFootprint'> & { co2EquivalentFootprint?: Maybe<ResolversTypes['Footprint']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, nitrogenFootprint?: Maybe<ResolversTypes['Footprint']>, waterFootprint?: Maybe<ResolversTypes['Footprint']> }>;
  SustainabilityInput: ResolverTypeWrapper<Omit<SustainabilityInput, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  SustainabilityOrganisationCapability: ResolverTypeWrapper<Omit<SustainabilityOrganisationCapability, 'organisation'> & { organisation?: Maybe<ResolversTypes['Organisation']> }>;
  SustainabilityOrganisationCapabilitySort: SustainabilityOrganisationCapabilitySort;
  SustainabilityOrganisationCapabilitySortColumn: SustainabilityOrganisationCapabilitySortColumn;
  SustainabilityOrganisationCapabilityType: SustainabilityOrganisationCapabilityType;
  SustainabilityProgram: ResolverTypeWrapper<Omit<SustainabilityProgram, 'crops' | 'measureSubmissionOrders'> & { crops?: Maybe<Array<Maybe<ResolversTypes['Crop']>>>, measureSubmissionOrders?: Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionOrder']>>> }>;
  SustainabilityProgramAllocationOrder: SustainabilityProgramAllocationOrder;
  SustainabilityProgramBranchAssignment: ResolverTypeWrapper<Omit<SustainabilityProgramBranchAssignment, 'branchAddress' | 'organisationAddress' | 'organisationBranch' | 'sustainabilityProgram'> & { branchAddress?: Maybe<ResolversTypes['Address']>, organisationAddress?: Maybe<ResolversTypes['Address']>, organisationBranch?: Maybe<ResolversTypes['OrganisationBranch']>, sustainabilityProgram?: Maybe<ResolversTypes['SustainabilityProgram']> }>;
  SustainabilityProgramBranchAssignmentSort: SustainabilityProgramBranchAssignmentSort;
  SustainabilityProgramBranchAssignmentSortColumn: SustainabilityProgramBranchAssignmentSortColumn;
  SustainabilityProgramCertificationScheme: SustainabilityProgramCertificationScheme;
  SustainabilityProgramEnrolledField: ResolverTypeWrapper<SustainabilityProgramEnrolledField>;
  SustainabilityProgramEnrolledSort: SustainabilityProgramEnrolledSort;
  SustainabilityProgramEnrolledSortColumn: SustainabilityProgramEnrolledSortColumn;
  SustainabilityProgramInvitation: ResolverTypeWrapper<Omit<SustainabilityProgramInvitation, 'sustainabilityProgram'> & { sustainabilityProgram?: Maybe<ResolversTypes['SustainabilityProgram']> }>;
  SustainabilityProgramInvitationSort: SustainabilityProgramInvitationSort;
  SustainabilityProgramInvitationSortColumn: SustainabilityProgramInvitationSortColumn;
  SustainabilityProgramNamedRef: ResolverTypeWrapper<SustainabilityProgramNamedRef>;
  SustainabilityProgramOrganisationParticipation: ResolverTypeWrapper<Omit<SustainabilityProgramOrganisationParticipation, 'branchAddress' | 'organisationAddress'> & { branchAddress?: Maybe<ResolversTypes['Address']>, organisationAddress?: Maybe<ResolversTypes['Address']> }>;
  SustainabilityProgramOrganisationParticipationSort: SustainabilityProgramOrganisationParticipationSort;
  SustainabilityProgramOrganisationParticipationSortColumn: SustainabilityProgramOrganisationParticipationSortColumn;
  SustainabilityProgramOrganisationParticipationStatus: SustainabilityProgramOrganisationParticipationStatus;
  SustainabilityProgramProtocol: SustainabilityProgramProtocol;
  SustainabilityProgramSort: SustainabilityProgramSort;
  SustainabilityProgramSortColumn: SustainabilityProgramSortColumn;
  SustainabilityProgramStaffMember: ResolverTypeWrapper<Omit<SustainabilityProgramStaffMember, 'sustainabilityProgram' | 'user'> & { sustainabilityProgram?: Maybe<ResolversTypes['SustainabilityProgram']>, user?: Maybe<ResolversTypes['User']> }>;
  SustainabilityProgramStaffMemberRole: SustainabilityProgramStaffMemberRole;
  SustainabilityProgramStatus: SustainabilityProgramStatus;
  SustainabilityProgramStrategy: SustainabilityProgramStrategy;
  SustainabilityProgramType: SustainabilityProgramType;
  SustainabilityProgramVisibilityMode: SustainabilityProgramVisibilityMode;
  TDiskAssignment: ResolverTypeWrapper<TDiskAssignment>;
  TDiskOperation: ResolverTypeWrapper<TDiskOperation>;
  TDiskTaskType: TDiskTaskType;
  TargetWeed: ResolverTypeWrapper<TargetWeed>;
  TargetWeedResistance: TargetWeedResistance;
  TargetWeedWeight: TargetWeedWeight;
  Task: ResolverTypeWrapper<Task>;
  TaskAggregation: ResolverTypeWrapper<Omit<TaskAggregation, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  TaskAggregationType: TaskAggregationType;
  TaskAssignmentState: TaskAssignmentState;
  TaskExecutionState: TaskExecutionState;
  TaskMethod: ResolverTypeWrapper<TaskMethod>;
  TaskSort: TaskSort;
  TaskSortColumn: TaskSortColumn;
  TaskSummary: ResolverTypeWrapper<Omit<TaskSummary, 'farm'> & { farm?: Maybe<ResolversTypes['FarmV2']> }>;
  TaskSummaryDetail: ResolverTypeWrapper<TaskSummaryDetail>;
  TaskType: TaskType;
  TaskTypeCode: TaskTypeCode;
  TaxonomicRank: TaxonomicRank;
  Tenant: ResolverTypeWrapper<Tenant>;
  TillageSystem: ResolverTypeWrapper<TillageSystem>;
  Tillages: ResolverTypeWrapper<Tillages>;
  TimeFormat: TimeFormat;
  TimingCalculationStatus: ResolverTypeWrapper<Omit<TimingCalculationStatus, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  TimingLimitationV2: ResolverTypeWrapper<Omit<TimingLimitationV2, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  TimingLimitationsV2Input: TimingLimitationsV2Input;
  TimingProductRecommendation: ResolverTypeWrapper<Omit<TimingProductRecommendation, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  TimingProductRecommendationCharacteristic: TimingProductRecommendationCharacteristic;
  TimingProductRecommendationGroupDoseRate: ResolverTypeWrapper<Omit<TimingProductRecommendationGroupDoseRate, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  TimingProductRecommendationGroupRecipe: ResolverTypeWrapper<Omit<TimingProductRecommendationGroupRecipe, 'doseRates'> & { doseRates?: Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationGroupDoseRate']>>> }>;
  TimingProductRecommendationRecipe: ResolverTypeWrapper<TimingProductRecommendationRecipe>;
  TimingProductRecommendationStressEfficacy: ResolverTypeWrapper<TimingProductRecommendationStressEfficacy>;
  TimingProductRecommendationType: TimingProductRecommendationType;
  TimingProductRecommendationVraCapability: TimingProductRecommendationVraCapability;
  TimingProductRecommendationsGroup: ResolverTypeWrapper<Omit<TimingProductRecommendationsGroup, 'cropSeasons' | 'recipe'> & { cropSeasons?: Maybe<Array<Maybe<ResolversTypes['CropSeasonV2']>>>, recipe?: Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationGroupRecipe']>>> }>;
  TimingProductRecommendationsGroupType: TimingProductRecommendationsGroupType;
  TimingStressInfo: ResolverTypeWrapper<Omit<TimingStressInfo, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  ToppingTask: ResolverTypeWrapper<Omit<ToppingTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  TotalNutrients: ResolverTypeWrapper<TotalNutrients>;
  TotalNutrientsDelta: ResolverTypeWrapper<TotalNutrientsDelta>;
  TotalProducts: ResolverTypeWrapper<TotalProducts>;
  Tramline: ResolverTypeWrapper<Omit<Tramline, 'abLine' | 'fieldV2'> & { abLine?: Maybe<ResolversTypes['AbLine']>, fieldV2: ResolversTypes['FieldV2'] }>;
  TranslationId: ResolverTypeWrapper<Scalars['TranslationId']['output']>;
  TreatmentEquipmentType: TreatmentEquipmentType;
  TreatmentProduct: ResolverTypeWrapper<TreatmentProduct>;
  TreatmentProductUnit: TreatmentProductUnit;
  TreatmentProgramAction: ResolverTypeWrapper<TreatmentProgramAction>;
  TreatmentProgramActionWindow: ResolverTypeWrapper<TreatmentProgramActionWindow>;
  TreatmentProgramActionWindowTask: ResolverTypeWrapper<TreatmentProgramActionWindowTask>;
  TreatmentProgramApplicationType: TreatmentProgramApplicationType;
  TreatmentProgramType: TreatmentProgramType;
  TreatmentReason: ResolverTypeWrapper<TreatmentReason>;
  TreatmentScenario: ResolverTypeWrapper<Omit<TreatmentScenario, 'farm'> & { farm?: Maybe<ResolversTypes['FarmV2']> }>;
  TreatmentScenarioType: TreatmentScenarioType;
  Trial: ResolverTypeWrapper<Omit<Trial, 'assessmentTimings' | 'cropSeason' | 'fieldZones' | 'fieldZonesWithoutOrder' | 'scoutingTasks'> & { assessmentTimings?: Maybe<Array<Maybe<ResolversTypes['AssessmentTiming']>>>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, fieldZones?: Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, fieldZonesWithoutOrder?: Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, scoutingTasks?: Maybe<Array<Maybe<ResolversTypes['ScoutingTask']>>> }>;
  TrialDisabledReplicate: ResolverTypeWrapper<TrialDisabledReplicate>;
  TrialV2: ResolverTypeWrapper<Omit<TrialV2, 'assessmentTimings' | 'cropSeason' | 'fieldZones' | 'fieldZonesWithoutOrder' | 'scoutingTasks'> & { assessmentTimings?: Maybe<Array<Maybe<ResolversTypes['AssessmentTiming']>>>, cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, fieldZones?: Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, fieldZonesWithoutOrder?: Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, scoutingTasks?: Maybe<Array<Maybe<ResolversTypes['ScoutingTask']>>> }>;
  TrialV2Column: TrialV2Column;
  TrialV2Sort: TrialV2Sort;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  UpdateType: UpdateType;
  UploadDatasetFormat: UploadDatasetFormat;
  UploadDatasetGeometryType: UploadDatasetGeometryType;
  UploadDatasetStatus: UploadDatasetStatus;
  UploadDatasetSummary: ResolverTypeWrapper<UploadDatasetSummary>;
  UploadDatasetTotal: ResolverTypeWrapper<UploadDatasetTotal>;
  UploadDatasetTotalSourceType: UploadDatasetTotalSourceType;
  UploadDatasetType: UploadDatasetType;
  User: ResolverTypeWrapper<Omit<User, 'hfOffers' | 'userPackages'> & { hfOffers?: Maybe<Array<Maybe<ResolversTypes['HfOffer']>>>, userPackages?: Maybe<Array<Maybe<ResolversTypes['UserPackage']>>> }>;
  UserDataVsValidationComparison: ResolverTypeWrapper<UserDataVsValidationComparison>;
  UserDevice: ResolverTypeWrapper<Omit<UserDevice, 'features' | 'user'> & { features?: Maybe<Array<Maybe<ResolversTypes['DeviceFeature']>>>, user?: Maybe<ResolversTypes['User']> }>;
  UserFarmPackage: ResolverTypeWrapper<Omit<UserFarmPackage, 'farmV2'> & { farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  UserFeature: ResolverTypeWrapper<Omit<UserFeature, 'crop'> & { crop?: Maybe<ResolversTypes['Crop']> }>;
  UserGroup: ResolverTypeWrapper<Omit<UserGroup, 'user'> & { user: ResolversTypes['User'] }>;
  UserLicenseRequest: ResolverTypeWrapper<Omit<UserLicenseRequest, 'creatorUser' | 'lastModifierUser' | 'organisation' | 'organisationMemberUser' | 'user'> & { creatorUser?: Maybe<ResolversTypes['User']>, lastModifierUser?: Maybe<ResolversTypes['User']>, organisation?: Maybe<ResolversTypes['Organisation']>, organisationMemberUser?: Maybe<ResolversTypes['User']>, user?: Maybe<ResolversTypes['User']> }>;
  UserNotification: ResolverTypeWrapper<Omit<UserNotification, 'cropSeason' | 'farm' | 'payloadData' | 'user'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']>, farm?: Maybe<ResolversTypes['FarmV2']>, payloadData?: Maybe<ResolversTypes['PayloadData']>, user?: Maybe<ResolversTypes['User']> }>;
  UserPackage: ResolverTypeWrapper<Omit<UserPackage, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  UserSetting: ResolverTypeWrapper<UserSetting>;
  ValueCode: ResolverTypeWrapper<ValueCode>;
  Variety: ResolverTypeWrapper<Omit<Variety, 'crop' | 'farm'> & { crop?: Maybe<ResolversTypes['Crop']>, farm?: Maybe<ResolversTypes['FarmV2']> }>;
  VarietyCharacteristic: ResolverTypeWrapper<VarietyCharacteristic>;
  VarietyRanking: ResolverTypeWrapper<Omit<VarietyRanking, 'variety'> & { variety?: Maybe<ResolversTypes['Variety']> }>;
  VarietyRatingVpi: VarietyRatingVpi;
  VarietyRecommendation: ResolverTypeWrapper<Omit<VarietyRecommendation, 'field' | 'varietyRankings'> & { field?: Maybe<ResolversTypes['FieldV2']>, varietyRankings?: Maybe<Array<Maybe<ResolversTypes['VarietyRanking']>>> }>;
  VarietyRecommendationStatus: VarietyRecommendationStatus;
  VendorDeviceBlacklistEntry: ResolverTypeWrapper<Omit<VendorDeviceBlacklistEntry, 'device'> & { device?: Maybe<ResolversTypes['DtnVendorDevice']> }>;
  VendorDeviceDataAnomaly: ResolverTypeWrapper<Omit<VendorDeviceDataAnomaly, 'device'> & { device?: Maybe<ResolversTypes['DtnVendorDevice']> }>;
  VendorDeviceDataMissing: ResolverTypeWrapper<Omit<VendorDeviceDataMissing, 'device'> & { device?: Maybe<ResolversTypes['DtnVendorDevice']> }>;
  VendorDeviceInfo: ResolverTypeWrapper<Omit<VendorDeviceInfo, 'vendorDevice'> & { vendorDevice?: Maybe<ResolversTypes['DtnVendorDevice']> }>;
  VendorDeviceSensorStatus: ResolverTypeWrapper<Omit<VendorDeviceSensorStatus, 'device'> & { device?: Maybe<ResolversTypes['DtnVendorDevice']> }>;
  VendorDeviceStatus: ResolverTypeWrapper<Omit<VendorDeviceStatus, 'device'> & { device?: Maybe<ResolversTypes['DtnVendorDevice']> }>;
  WarningCode: WarningCode;
  WaterAvailableStatus: WaterAvailableStatus;
  WaterBalance: ResolverTypeWrapper<Omit<WaterBalance, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  WaterManagementAction: WaterManagementAction;
  WaterManagementActionType: WaterManagementActionType;
  WaterManagementScenario: ResolverTypeWrapper<WaterManagementScenario>;
  WaterManagementTask: ResolverTypeWrapper<Omit<WaterManagementTask, 'assignee' | 'cropSeasonV2'> & { assignee?: Maybe<ResolversTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  WaterManagementTaskType: WaterManagementTaskType;
  WaterRecommendation: ResolverTypeWrapper<Omit<WaterRecommendation, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  WaterRecommendationStatus: WaterRecommendationStatus;
  WaterSensitivity: WaterSensitivity;
  WaterStatus: ResolverTypeWrapper<Omit<WaterStatus, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  WaterStatusState: WaterStatusState;
  WaterStatusType: WaterStatusType;
  Weather: ResolverTypeWrapper<Weather>;
  WeatherFormat: WeatherFormat;
  WeatherProvider: WeatherProvider;
  WeatherType: WeatherType;
  WeatherUserData: ResolverTypeWrapper<WeatherUserData>;
  WeatherV2: ResolverTypeWrapper<WeatherV2>;
  Weed: ResolverTypeWrapper<Weed>;
  WeedManagementProgramRecommendation: ResolverTypeWrapper<WeedManagementProgramRecommendation>;
  WeedManagementProgramRecommendationV3: ResolverTypeWrapper<WeedManagementProgramRecommendationV3>;
  WeedManagementRecommendation: ResolverTypeWrapper<Omit<WeedManagementRecommendation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversTypes['CropSeason'], cropSeasonV2: ResolversTypes['CropSeasonV2'] }>;
  WeedManagementRecommendationStatus: WeedManagementRecommendationStatus;
  WeedManagementRecommendationType: WeedManagementRecommendationType;
  WeedRecord: ResolverTypeWrapper<WeedRecord>;
  WeedRecordSourceType: WeedRecordSourceType;
  WeedRisk: ResolverTypeWrapper<Omit<WeedRisk, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  WeedRiskStatus: WeedRiskStatus;
  WeedStatus: ResolverTypeWrapper<Omit<WeedStatus, 'cropSeason'> & { cropSeason: ResolversTypes['CropSeasonV2'] }>;
  WeedStatusStatus: WeedStatusStatus;
  WeedStatusType: WeedStatusType;
  WeeklySeedingRecommendation: ResolverTypeWrapper<WeeklySeedingRecommendation>;
  WfsParameters: ResolverTypeWrapper<WfsParameters>;
  WiuzConnectionStatus: ResolverTypeWrapper<WiuzConnectionStatus>;
  WiuzImportOrderStatus: WiuzImportOrderStatus;
  WiuzUserFarm: ResolverTypeWrapper<Omit<WiuzUserFarm, 'farmV2'> & { farmV2?: Maybe<ResolversTypes['FarmV2']> }>;
  WiuzUserfarmImportOrder: ResolverTypeWrapper<Omit<WiuzUserfarmImportOrder, 'farmV2' | 'user'> & { farmV2?: Maybe<ResolversTypes['FarmV2']>, user?: Maybe<ResolversTypes['User']> }>;
  WmsParameters: ResolverTypeWrapper<WmsParameters>;
  YellowTrapResult: ResolverTypeWrapper<YellowTrapResult>;
  YieldPrediction: ResolverTypeWrapper<Omit<YieldPrediction, 'cropSeason'> & { cropSeason?: Maybe<ResolversTypes['CropSeasonV2']> }>;
  YieldScenario: ResolverTypeWrapper<YieldScenario>;
  YieldScenarioWeatherType: YieldScenarioWeatherType;
  ZonePercentageDifference: ResolverTypeWrapper<ZonePercentageDifference>;
  ZoneRateV2: ResolverTypeWrapper<ZoneRateV2>;
  ZoneSpecificStrategy: ZoneSpecificStrategy;
  ZoneStatisticsItem: ResolverTypeWrapper<ZoneStatisticsItem>;
  ZoneStrategy: ResolverTypeWrapper<ZoneStrategy>;
  ZonesToSamplingAreaMapping: ResolverTypeWrapper<ZonesToSamplingAreaMapping>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AbLine: Omit<AbLine, 'fieldV2'> & { fieldV2: ResolversParentTypes['FieldV2'] };
  Action: Action;
  ActionDate: ActionDate;
  ActionDateInput: ActionDateInput;
  ActionDetail: ActionDetail;
  ActionDetailAdditive: ActionDetailAdditive;
  ActionDetailProduct: ActionDetailProduct;
  ActionDetailTankMix: ActionDetailTankMix;
  ActionDetailV2: ActionDetailV2;
  ActionInput: ActionInput;
  ActionRecommendation: Omit<ActionRecommendation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  ActionRecommendationAggregation: Omit<ActionRecommendationAggregation, 'actions' | 'cropSeason' | 'cropSeasonV2'> & { actions?: Maybe<Array<Maybe<ResolversParentTypes['ActionRecommendationAggregationAction']>>>, cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  ActionRecommendationAggregationAction: ActionRecommendationAggregationAction;
  ActionWindow: Omit<ActionWindow, 'cropSeasonV2'> & { cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  ActiveIngredient: ActiveIngredient;
  AdditionalInfectionRiskFactor: Omit<AdditionalInfectionRiskFactor, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  AdditiveRate: AdditiveRate;
  Address: Address;
  AgBalanceFieldEmissionIndicator: Omit<AgBalanceFieldEmissionIndicator, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  AgBalanceFieldEmissionIndicatorIssue: AgBalanceFieldEmissionIndicatorIssue;
  AgBalanceFieldInput: Omit<AgBalanceFieldInput, 'field'> & { field: ResolversParentTypes['FieldV2'] };
  AggregatedNotification: Omit<AggregatedNotification, 'payload'> & { payload?: Maybe<ResolversParentTypes['AggregatedNotificationPayload']> };
  AggregatedNotificationPayload: Omit<AggregatedNotificationPayload, 'farm' | 'farms'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, farms?: Maybe<Array<Maybe<ResolversParentTypes['FarmV2']>>> };
  AggregatedPestDevelopmentPrediction: Omit<AggregatedPestDevelopmentPrediction, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  AggregatedRisk: AggregatedRisk;
  AnalyticsCollection: Omit<AnalyticsCollection, 'farm' | 'fieldDataLayers' | 'fieldNotes' | 'fieldZones' | 'mapItemMagnitudes'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, fieldDataLayers?: Maybe<Array<Maybe<ResolversParentTypes['AnalyticsCollectionFieldDataLayer']>>>, fieldNotes?: Maybe<Array<Maybe<ResolversParentTypes['FieldNote']>>>, fieldZones?: Maybe<Array<Maybe<ResolversParentTypes['FieldZone']>>>, mapItemMagnitudes?: Maybe<Array<Maybe<ResolversParentTypes['AnalyticsCollectionMapItemMagnitude']>>> };
  AnalyticsCollectionFieldDataLayer: Omit<AnalyticsCollectionFieldDataLayer, 'fieldDataLayer'> & { fieldDataLayer?: Maybe<ResolversParentTypes['FieldDataLayer']> };
  AnalyticsCollectionMapItemMagnitude: Omit<AnalyticsCollectionMapItemMagnitude, 'fieldDataLayerMagnitude' | 'stacItemMagnitude'> & { fieldDataLayerMagnitude?: Maybe<ResolversParentTypes['AnalyticsCollectionFieldDataLayer']>, stacItemMagnitude?: Maybe<ResolversParentTypes['AnalyticsCollectionStacItem']> };
  AnalyticsCollectionStacItem: Omit<AnalyticsCollectionStacItem, 'stacItemRender'> & { stacItemRender?: Maybe<ResolversParentTypes['StacItemRender']> };
  AnomalyHistory: AnomalyHistory;
  AnomalyVariableInfo: AnomalyVariableInfo;
  AppConfig: AppConfig;
  AppConfigValue: Scalars['AppConfigValue']['output'];
  ApplicableColumn: ApplicableColumn;
  ApplicableStress: ApplicableStress;
  ApplicableUnit: ApplicableUnit;
  ApplicationFieldZone: ApplicationFieldZone;
  ApplicationMapZone: ApplicationMapZone;
  ApplicationRecommendation: Omit<ApplicationRecommendation, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']> };
  ApplicationSpot: ApplicationSpot;
  ApplicationWindow: Omit<ApplicationWindow, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  ApplicationZone: ApplicationZone;
  ArableApiKey: ArableApiKey;
  ArableDevice: ArableDevice;
  ArableDeviceLatestMeasurement: ArableDeviceLatestMeasurement;
  ArableDeviceToLocation: ArableDeviceToLocation;
  ArvalisCalculationBasis: Omit<ArvalisCalculationBasis, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  ArvalisCustomEfficacyInformation: Omit<ArvalisCustomEfficacyInformation, 'dosedMap'> & { dosedMap?: Maybe<ResolversParentTypes['DosedMap']> };
  ArvalisDeviceToCropSeason: Omit<ArvalisDeviceToCropSeason, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  ArvalisInformation: Omit<ArvalisInformation, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  Assessment: Assessment;
  AssessmentAttachment: AssessmentAttachment;
  AssessmentData: Omit<AssessmentData, 'fieldZone'> & { fieldZone?: Maybe<ResolversParentTypes['FieldZone']> };
  AssessmentNote: Omit<AssessmentNote, 'assessmentTiming' | 'fieldZone'> & { assessmentTiming: ResolversParentTypes['AssessmentTiming'], fieldZone?: Maybe<ResolversParentTypes['FieldZone']> };
  AssessmentTiming: Omit<AssessmentTiming, 'scoutingTask'> & { scoutingTask?: Maybe<ResolversParentTypes['ScoutingTask']> };
  AvailableDosedMap: Omit<AvailableDosedMap, 'dosedMap'> & { dosedMap: ResolversParentTypes['DosedMap'] };
  AvailablePackage: Omit<AvailablePackage, 'crop' | 'package'> & { crop?: Maybe<ResolversParentTypes['Crop']>, package: ResolversParentTypes['Package'] };
  BBCHScale: BbchScale;
  BagCount: BagCount;
  BaseEntityAuditingType: ResolversInterfaceTypes<ResolversParentTypes>['BaseEntityAuditingType'];
  BeforeSeasonRisk: Omit<BeforeSeasonRisk, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  BillingAddress: BillingAddress;
  BiodiversityIndicator: Omit<BiodiversityIndicator, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  BiomassAnalysisNdvi: BiomassAnalysisNdvi;
  BlacklistVariableInfo: BlacklistVariableInfo;
  Boolean: Scalars['Boolean']['output'];
  BufferZones: BufferZones;
  BusinessLineLicense: BusinessLineLicense;
  BusinessLineLicensePackageQuota: BusinessLineLicensePackageQuota;
  BusinessLinePurchaseAggregation: Omit<BusinessLinePurchaseAggregation, 'farm' | 'user'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, user?: Maybe<ResolversParentTypes['User']> };
  CarbonCredit: CarbonCredit;
  CarbonFarmingRequest: Omit<CarbonFarmingRequest, 'cropSeason' | 'field' | 'sustainabilityProgram'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, field?: Maybe<ResolversParentTypes['FieldV2']>, sustainabilityProgram?: Maybe<ResolversParentTypes['SustainabilityProgram']> };
  CarbonFarmingSeason: CarbonFarmingSeason;
  CarbonIntensityIndicator: CarbonIntensityIndicator;
  CarbonIntensityIndicatorIssue: CarbonIntensityIndicatorIssue;
  CarbonPlausibilityComment: Omit<CarbonPlausibilityComment, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CarbonRelatedDataTillage: CarbonRelatedDataTillage;
  Category: Category;
  ClaasConnectStatus: ClaasConnectStatus;
  ClaasFarm: ClaasFarm;
  ClaasField: ClaasField;
  ClaasOrganization: ClaasOrganization;
  ClaimAttachment: ClaimAttachment;
  ClaimCategory: ClaimCategory;
  ClaimEvaluation: ClaimEvaluation;
  CnhCompany: CnhCompany;
  CnhFarm: CnhFarm;
  CnhField: CnhField;
  CnhGrower: CnhGrower;
  CnhTask: CnhTask;
  Collaborator: Omit<Collaborator, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  Color: Scalars['Color']['output'];
  ColorCx: Scalars['ColorCx']['output'];
  ConnectivitySource: ConnectivitySource;
  ContactInformation: ContactInformation;
  Container: Container;
  CountryCropGrowthStagePrediction: Omit<CountryCropGrowthStagePrediction, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CountryCropStressSetting: CountryCropStressSetting;
  CountryWeed: CountryWeed;
  CreditEligibility: CreditEligibility;
  CriticalCropStageRisk: Omit<CriticalCropStageRisk, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  CriticalCropStageRiskInfo: Omit<CriticalCropStageRiskInfo, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  CriticalGrowthStagePeriodRisk: Omit<CriticalGrowthStagePeriodRisk, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  Crop: Omit<Crop, 'varieties'> & { varieties?: Maybe<Array<Maybe<ResolversParentTypes['Variety']>>> };
  CropDictCode: CropDictCode;
  CropEstablishment: Omit<CropEstablishment, 'assignee' | 'cropSeasonV2' | 'dosedMap'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, dosedMap?: Maybe<ResolversParentTypes['DosedMap']> };
  CropEstablishmentDetails: Omit<CropEstablishmentDetails, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropGrowthStage: CropGrowthStage;
  CropGrowthStageImage: CropGrowthStageImage;
  CropGrowthStageV2: CropGrowthStageV2;
  CropMix: CropMix;
  CropMixDetail: Omit<CropMixDetail, 'crop' | 'variety'> & { crop?: Maybe<ResolversParentTypes['Crop']>, variety?: Maybe<ResolversParentTypes['Variety']> };
  CropNutritionReportConfiguration: Omit<CropNutritionReportConfiguration, 'cover'> & { cover: ResolversParentTypes['CropNutritionReportCoverConfiguration'] };
  CropNutritionReportCoverConfiguration: Omit<CropNutritionReportCoverConfiguration, 'coverImage'> & { coverImage?: Maybe<ResolversParentTypes['File']> };
  CropNutritionReportFarmSummaryConfiguration: CropNutritionReportFarmSummaryConfiguration;
  CropNutritionReportFieldDetailsConfiguration: CropNutritionReportFieldDetailsConfiguration;
  CropResidueManagementTask: Omit<CropResidueManagementTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeason: Omit<CropSeason, 'actionRecommendationAggregations' | 'actionRecommendations' | 'crop' | 'field' | 'fieldV2' | 'nutritionRecommendations' | 'nutritionStatus' | 'observations' | 'protectionTimes' | 'recommendationSnoozes' | 'sourceMaps' | 'sprayings' | 'sprayingsV2' | 'timingStressesInfo' | 'variety' | 'weedManagementRecommendations' | 'weedRisk'> & { actionRecommendationAggregations?: Maybe<Array<Maybe<ResolversParentTypes['ActionRecommendationAggregation']>>>, actionRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['ActionRecommendation']>>>, crop?: Maybe<ResolversParentTypes['Crop']>, field: ResolversParentTypes['Field'], fieldV2: ResolversParentTypes['FieldV2'], nutritionRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['NutritionRecommendation']>>>, nutritionStatus?: Maybe<Array<Maybe<ResolversParentTypes['NutritionStatus']>>>, observations?: Maybe<Array<Maybe<ResolversParentTypes['Observation']>>>, protectionTimes?: Maybe<Array<Maybe<ResolversParentTypes['ProtectionTime']>>>, recommendationSnoozes?: Maybe<Array<Maybe<ResolversParentTypes['RecommendationSnooze']>>>, sourceMaps?: Maybe<Array<Maybe<ResolversParentTypes['SourceMap']>>>, sprayings?: Maybe<Array<Maybe<ResolversParentTypes['Spraying']>>>, sprayingsV2?: Maybe<Array<Maybe<ResolversParentTypes['SprayingV2']>>>, timingStressesInfo?: Maybe<Array<Maybe<ResolversParentTypes['TimingStressInfo']>>>, variety?: Maybe<ResolversParentTypes['Variety']>, weedManagementRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['WeedManagementRecommendation']>>>, weedRisk?: Maybe<ResolversParentTypes['WeedRisk']> };
  CropSeasonData: Omit<CropSeasonData, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeasonNutritionProgram: Omit<CropSeasonNutritionProgram, 'cropSeason' | 'cropSystemRecommendation' | 'cropSystemRecommendationV2'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, cropSystemRecommendation?: Maybe<ResolversParentTypes['CropSystemRecommendation']>, cropSystemRecommendationV2?: Maybe<ResolversParentTypes['CropSystemRecommendationV2']> };
  CropSeasonNutritionProgramExecutionStatus: Omit<CropSeasonNutritionProgramExecutionStatus, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeasonNutritionRecommendation: Omit<CropSeasonNutritionRecommendation, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeasonStatus: Omit<CropSeasonStatus, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  CropSeasonStatusReportEmailSubscription: Omit<CropSeasonStatusReportEmailSubscription, 'farmV2'> & { farmV2: ResolversParentTypes['FarmV2'] };
  CropSeasonTreatmentProgram: Omit<CropSeasonTreatmentProgram, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeasonTreatmentProgramExecutionStatus: Omit<CropSeasonTreatmentProgramExecutionStatus, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeasonTreatmentProgramV2: Omit<CropSeasonTreatmentProgramV2, 'actionDetails' | 'cropSeason'> & { actionDetails?: Maybe<Array<Maybe<ResolversParentTypes['ActionDetailV2']>>>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeasonTreatmentProgramV3: Omit<CropSeasonTreatmentProgramV3, 'crop' | 'cropSeason'> & { crop?: Maybe<ResolversParentTypes['Crop']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSeasonV2: Omit<CropSeasonV2, 'actionRecommendationAggregations' | 'actionRecommendations' | 'activeCountryCropGrowthStage' | 'additionalInfectionRiskFactor' | 'agBalanceFieldEmissionIndicator' | 'aggregatedPestDevelopmentPredictions' | 'arvalisCalculationBasis' | 'arvalisDeviceToCropSeason' | 'arvalisInformation' | 'beforeSeasonRisks' | 'biodiversityIndicator' | 'carbonPlausibilityComment' | 'countryCropGrowthStagePredictions' | 'creator' | 'criticalCropStageRiskInfos' | 'criticalCropStageRisks' | 'criticalGrowthStagePeriodRisks' | 'crop' | 'cropEstablishmentDetails' | 'cropEstablishments' | 'cropResidueManagementTasks' | 'cropSeasonNutritionProgram' | 'cropSeasonNutritionProgramExecutionStatus' | 'cropSeasonTreatmentProgram' | 'cropSeasonTreatmentProgramExecutionStatus' | 'cropSeasonTreatmentProgramV2' | 'cropSeasonTreatmentProgramV3' | 'cropSeasonWaterManagementProgram' | 'cropWaterAvailabilities' | 'customPowerzoneOrders' | 'dailyFungusDetails' | 'dailyStressCharacteristics' | 'dailyStressEventProbabilities' | 'dailyWeedRiskDetails' | 'dryMatterAnalysis' | 'fieldDataLayers' | 'fieldV2' | 'fieldVariabilityIndexes' | 'fieldVariabilityInput' | 'frostRisks' | 'greenhouseWhiteningTasks' | 'growthStagePredictionDaily' | 'harvests' | 'hfClaims' | 'hfOfferCondition' | 'hfPrice' | 'hfServiceRequests' | 'hortaCropSeason' | 'hortaSustainabilityIndicator' | 'landPreparations' | 'leafPruningTasks' | 'modifier' | 'nextCountryCropGrowthStage' | 'nutritionRecommendations' | 'nutritionStatus' | 'observations' | 'operationalInstructions' | 'pestDevelopmentPredictions' | 'preCrop' | 'produceDeliveryTasks' | 'projectedIncidences' | 'protectionTimes' | 'recommendationSnoozes' | 'risksV2' | 'scoutingTasks' | 'seedBoxTreatments' | 'seedTreatmentTasks' | 'smartSprayingTasks' | 'smartSprayingTasksV2' | 'soilSamplingTasks' | 'sourceMaps' | 'sprayingsV2' | 'stressEfficacyCharacteristics' | 'stressSettings' | 'sustainabilityIndicator' | 'sustainabilityInput' | 'taskAggregations' | 'timingCalculationStatus' | 'timingProductRecommendations' | 'timingStressesInfo' | 'toppingTasks' | 'trials' | 'variety' | 'waterBalances' | 'waterManagementTasks' | 'waterRecommendations' | 'waterStatus' | 'weedManagementRecommendations' | 'weedRisk' | 'weedStatus' | 'yieldPrediction'> & { actionRecommendationAggregations?: Maybe<Array<Maybe<ResolversParentTypes['ActionRecommendationAggregation']>>>, actionRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['ActionRecommendation']>>>, activeCountryCropGrowthStage?: Maybe<ResolversParentTypes['CountryCropGrowthStagePrediction']>, additionalInfectionRiskFactor?: Maybe<ResolversParentTypes['AdditionalInfectionRiskFactor']>, agBalanceFieldEmissionIndicator?: Maybe<ResolversParentTypes['AgBalanceFieldEmissionIndicator']>, aggregatedPestDevelopmentPredictions?: Maybe<Array<Maybe<ResolversParentTypes['AggregatedPestDevelopmentPrediction']>>>, arvalisCalculationBasis?: Maybe<ResolversParentTypes['ArvalisCalculationBasis']>, arvalisDeviceToCropSeason?: Maybe<ResolversParentTypes['ArvalisDeviceToCropSeason']>, arvalisInformation?: Maybe<ResolversParentTypes['ArvalisInformation']>, beforeSeasonRisks?: Maybe<Array<ResolversParentTypes['BeforeSeasonRisk']>>, biodiversityIndicator?: Maybe<ResolversParentTypes['BiodiversityIndicator']>, carbonPlausibilityComment?: Maybe<ResolversParentTypes['CarbonPlausibilityComment']>, countryCropGrowthStagePredictions?: Maybe<Array<Maybe<ResolversParentTypes['CountryCropGrowthStagePrediction']>>>, creator?: Maybe<ResolversParentTypes['User']>, criticalCropStageRiskInfos?: Maybe<Array<Maybe<ResolversParentTypes['CriticalCropStageRiskInfo']>>>, criticalCropStageRisks?: Maybe<Array<Maybe<ResolversParentTypes['CriticalCropStageRisk']>>>, criticalGrowthStagePeriodRisks?: Maybe<Array<Maybe<ResolversParentTypes['CriticalGrowthStagePeriodRisk']>>>, crop?: Maybe<ResolversParentTypes['Crop']>, cropEstablishmentDetails?: Maybe<ResolversParentTypes['CropEstablishmentDetails']>, cropEstablishments?: Maybe<Array<ResolversParentTypes['CropEstablishment']>>, cropResidueManagementTasks?: Maybe<Array<ResolversParentTypes['CropResidueManagementTask']>>, cropSeasonNutritionProgram?: Maybe<ResolversParentTypes['CropSeasonNutritionProgram']>, cropSeasonNutritionProgramExecutionStatus?: Maybe<ResolversParentTypes['CropSeasonNutritionProgramExecutionStatus']>, cropSeasonTreatmentProgram?: Maybe<ResolversParentTypes['CropSeasonTreatmentProgram']>, cropSeasonTreatmentProgramExecutionStatus?: Maybe<ResolversParentTypes['CropSeasonTreatmentProgramExecutionStatus']>, cropSeasonTreatmentProgramV2?: Maybe<ResolversParentTypes['CropSeasonTreatmentProgramV2']>, cropSeasonTreatmentProgramV3?: Maybe<ResolversParentTypes['CropSeasonTreatmentProgramV3']>, cropSeasonWaterManagementProgram?: Maybe<ResolversParentTypes['CropSeasonWaterManagementProgram']>, cropWaterAvailabilities?: Maybe<Array<Maybe<ResolversParentTypes['CropWaterAvailability']>>>, customPowerzoneOrders?: Maybe<Array<Maybe<ResolversParentTypes['CustomPowerzoneOrder']>>>, dailyFungusDetails?: Maybe<Array<Maybe<ResolversParentTypes['DailyFungusDetails']>>>, dailyStressCharacteristics?: Maybe<Array<Maybe<ResolversParentTypes['DailyStressCharacteristics']>>>, dailyStressEventProbabilities?: Maybe<Array<Maybe<ResolversParentTypes['DailyStressEventProbability']>>>, dailyWeedRiskDetails?: Maybe<Array<Maybe<ResolversParentTypes['DailyWeedRiskDetails']>>>, dryMatterAnalysis?: Maybe<Array<Maybe<ResolversParentTypes['DryMatterAnalysis']>>>, fieldDataLayers?: Maybe<Array<Maybe<ResolversParentTypes['FieldDataLayer']>>>, fieldV2: ResolversParentTypes['FieldV2'], fieldVariabilityIndexes?: Maybe<Array<Maybe<ResolversParentTypes['FieldVariabilityIndex']>>>, fieldVariabilityInput?: Maybe<ResolversParentTypes['FieldVariabilityInput']>, frostRisks?: Maybe<Array<Maybe<ResolversParentTypes['FrostRisk']>>>, greenhouseWhiteningTasks?: Maybe<Array<ResolversParentTypes['GreenhouseWhiteningTask']>>, growthStagePredictionDaily?: Maybe<Array<Maybe<ResolversParentTypes['GrowthStagePredictionDaily']>>>, harvests?: Maybe<Array<ResolversParentTypes['Harvest']>>, hfClaims?: Maybe<Array<Maybe<ResolversParentTypes['HfClaim']>>>, hfOfferCondition?: Maybe<ResolversParentTypes['HfOfferCondition']>, hfPrice?: Maybe<ResolversParentTypes['HfPrice']>, hfServiceRequests?: Maybe<Array<Maybe<ResolversParentTypes['HFServiceRequest']>>>, hortaCropSeason?: Maybe<ResolversParentTypes['HortaCropSeason']>, hortaSustainabilityIndicator?: Maybe<ResolversParentTypes['HortaSustainabilityIndicator']>, landPreparations?: Maybe<Array<ResolversParentTypes['LandPreparation']>>, leafPruningTasks?: Maybe<Array<ResolversParentTypes['LeafPruningTask']>>, modifier?: Maybe<ResolversParentTypes['User']>, nextCountryCropGrowthStage?: Maybe<ResolversParentTypes['CountryCropGrowthStagePrediction']>, nutritionRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['NutritionRecommendation']>>>, nutritionStatus?: Maybe<Array<Maybe<ResolversParentTypes['NutritionStatus']>>>, observations?: Maybe<Array<ResolversParentTypes['Observation']>>, operationalInstructions?: Maybe<Array<Maybe<ResolversParentTypes['HfOperationalInstruction']>>>, pestDevelopmentPredictions?: Maybe<Array<Maybe<ResolversParentTypes['PestDevelopmentPrediction']>>>, preCrop?: Maybe<ResolversParentTypes['Crop']>, produceDeliveryTasks?: Maybe<Array<Maybe<ResolversParentTypes['ProduceDeliveryTask']>>>, projectedIncidences?: Maybe<Array<Maybe<ResolversParentTypes['ProjectedIncidences']>>>, protectionTimes?: Maybe<Array<Maybe<ResolversParentTypes['ProtectionTime']>>>, recommendationSnoozes?: Maybe<Array<Maybe<ResolversParentTypes['RecommendationSnooze']>>>, risksV2?: Maybe<Array<Maybe<ResolversParentTypes['RiskV2']>>>, scoutingTasks?: Maybe<Array<ResolversParentTypes['ScoutingTask']>>, seedBoxTreatments?: Maybe<Array<ResolversParentTypes['SeedBoxTreatment']>>, seedTreatmentTasks?: Maybe<Array<ResolversParentTypes['SeedTreatment']>>, smartSprayingTasks?: Maybe<Array<ResolversParentTypes['SmartSprayingTask']>>, smartSprayingTasksV2?: Maybe<Array<ResolversParentTypes['SmartSprayingTaskV2']>>, soilSamplingTasks?: Maybe<Array<Maybe<ResolversParentTypes['SoilSamplingTask']>>>, sourceMaps?: Maybe<Array<Maybe<ResolversParentTypes['SourceMap']>>>, sprayingsV2?: Maybe<Array<ResolversParentTypes['SprayingV2']>>, stressEfficacyCharacteristics?: Maybe<Array<Maybe<ResolversParentTypes['StressEfficacyCharacteristics']>>>, stressSettings?: Maybe<ResolversParentTypes['StressSettings']>, sustainabilityIndicator?: Maybe<ResolversParentTypes['SustainabilityIndicator']>, sustainabilityInput?: Maybe<ResolversParentTypes['SustainabilityInput']>, taskAggregations?: Maybe<Array<Maybe<ResolversParentTypes['TaskAggregation']>>>, timingCalculationStatus?: Maybe<ResolversParentTypes['TimingCalculationStatus']>, timingProductRecommendations?: Maybe<Array<ResolversParentTypes['TimingProductRecommendation']>>, timingStressesInfo?: Maybe<Array<Maybe<ResolversParentTypes['TimingStressInfo']>>>, toppingTasks?: Maybe<Array<ResolversParentTypes['ToppingTask']>>, trials?: Maybe<Array<Maybe<ResolversParentTypes['Trial']>>>, variety?: Maybe<ResolversParentTypes['Variety']>, waterBalances?: Maybe<Array<Maybe<ResolversParentTypes['WaterBalance']>>>, waterManagementTasks?: Maybe<Array<ResolversParentTypes['WaterManagementTask']>>, waterRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['WaterRecommendation']>>>, waterStatus?: Maybe<Array<Maybe<ResolversParentTypes['WaterStatus']>>>, weedManagementRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['WeedManagementRecommendation']>>>, weedRisk?: Maybe<ResolversParentTypes['WeedRisk']>, weedStatus?: Maybe<Array<Maybe<ResolversParentTypes['WeedStatus']>>>, yieldPrediction?: Maybe<ResolversParentTypes['YieldPrediction']> };
  CropSeasonWaterManagementProgram: Omit<CropSeasonWaterManagementProgram, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CropSystemRecommendation: Omit<CropSystemRecommendation, 'cropSeasons' | 'soilSamplingResult'> & { cropSeasons?: Maybe<Array<Maybe<ResolversParentTypes['CropSeasonData']>>>, soilSamplingResult?: Maybe<ResolversParentTypes['SoilSamplingResult']> };
  CropSystemRecommendationActionDetail: CropSystemRecommendationActionDetail;
  CropSystemRecommendationRequest: CropSystemRecommendationRequest;
  CropSystemRecommendationV2: Omit<CropSystemRecommendationV2, 'cropSeasons' | 'soilSamplingResult'> & { cropSeasons?: Maybe<Array<Maybe<ResolversParentTypes['CropSeasonData']>>>, soilSamplingResult?: Maybe<ResolversParentTypes['SoilSamplingResult']> };
  CropTankMixSummary: CropTankMixSummary;
  CropUsage: CropUsage;
  CropWaterAvailability: Omit<CropWaterAvailability, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  CurrentWeedPrediction: Omit<CurrentWeedPrediction, 'fieldV2'> & { fieldV2?: Maybe<ResolversParentTypes['FieldV2']> };
  CustomPowerzoneOrder: Omit<CustomPowerzoneOrder, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  CustomPowerzoneTimeWindow: CustomPowerzoneTimeWindow;
  DailyFungusDetails: Omit<DailyFungusDetails, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  DailyStressCharacteristics: Omit<DailyStressCharacteristics, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  DailyStressEventProbability: Omit<DailyStressEventProbability, 'cropSeasonV2'> & { cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  DailyWeedRiskDetails: Omit<DailyWeedRiskDetails, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  Date: Scalars['Date']['output'];
  DemandEquationProduct: DemandEquationProduct;
  DemandEquationRecommendation: Omit<DemandEquationRecommendation, 'cropSeason' | 'soilSamplingResult'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, soilSamplingResult?: Maybe<ResolversParentTypes['SoilSamplingResult']> };
  DemandEquationRecommendationV2: Omit<DemandEquationRecommendationV2, 'cropSeason' | 'soilSamplingResult'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, soilSamplingResult?: Maybe<ResolversParentTypes['SoilSamplingResult']> };
  DemandEquationSamplingArea: DemandEquationSamplingArea;
  DemandEquationSamplingAreaProduct: DemandEquationSamplingAreaProduct;
  DemandEquationZone: DemandEquationZone;
  DescriptionAndSymptom: Omit<DescriptionAndSymptom, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  DetectedDisease: DetectedDisease;
  DetectedNitrogenStatus: DetectedNitrogenStatus;
  DetectedPest: DetectedPest;
  DetectedWeed: DetectedWeed;
  DeviceFeature: Omit<DeviceFeature, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  DevicePackage: DevicePackage;
  DictcodeFeature: DictcodeFeature;
  DictcodeHierarchy: DictcodeHierarchy;
  Dictionary: Dictionary;
  DisabledHistory: DisabledHistory;
  DiseaseIdentificationResult: DiseaseIdentificationResult;
  DosedMap: Omit<DosedMap, 'additives' | 'cropSeason' | 'cropSeasonV2' | 'fieldZones' | 'sourceMap'> & { additives?: Maybe<Array<Maybe<ResolversParentTypes['AdditiveRate']>>>, cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'], fieldZones?: Maybe<Array<Maybe<ResolversParentTypes['MappingFieldZone']>>>, sourceMap?: Maybe<ResolversParentTypes['SourceMap']> };
  DosedMapInput: DosedMapInput;
  DosedMapLegend: DosedMapLegend;
  DosedMapLegendEntry: DosedMapLegendEntry;
  DosedMapProductSummary: DosedMapProductSummary;
  DroneFlight: Omit<DroneFlight, 'abLine' | 'assignee' | 'cropSeason' | 'cropSeasonV2'> & { abLine?: Maybe<ResolversParentTypes['AbLine']>, assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  DroneFlightError: DroneFlightError;
  DroneFlightOrthomosaic: DroneFlightOrthomosaic;
  DroneFlightQuota: Omit<DroneFlightQuota, 'droneFlightQuotaTransfers' | 'farmV2'> & { droneFlightQuotaTransfers?: Maybe<Array<Maybe<ResolversParentTypes['DroneFlightQuotaTransfer']>>>, farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  DroneFlightQuotaTransfer: DroneFlightQuotaTransfer;
  DroneFlightSummary: DroneFlightSummary;
  DronePlantingFailureMap: Omit<DronePlantingFailureMap, 'droneFlightQuota'> & { droneFlightQuota?: Maybe<ResolversParentTypes['DroneFlightQuota']> };
  DroneSprayerWeedMap: Omit<DroneSprayerWeedMap, 'droneFlightQuota'> & { droneFlightQuota?: Maybe<ResolversParentTypes['DroneFlightQuota']> };
  DryMatterAnalysis: Omit<DryMatterAnalysis, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  DtnVendorDevice: Omit<DtnVendorDevice, 'dtnVendorDeviceToLocations' | 'dtnVendorDeviceToLocationsV2' | 'dtnVendorLatestMeasurement'> & { dtnVendorDeviceToLocations?: Maybe<Array<Maybe<ResolversParentTypes['DtnVendorDeviceToLocation']>>>, dtnVendorDeviceToLocationsV2?: Maybe<Array<Maybe<ResolversParentTypes['DtnVendorDeviceToLocationV2']>>>, dtnVendorLatestMeasurement?: Maybe<ResolversParentTypes['DtnVendorDeviceLatestMeasurement']> };
  DtnVendorDeviceActivation: Omit<DtnVendorDeviceActivation, 'creator' | 'device'> & { creator?: Maybe<ResolversParentTypes['User']>, device: ResolversParentTypes['DtnVendorDevice'] };
  DtnVendorDeviceLatestMeasurement: Omit<DtnVendorDeviceLatestMeasurement, 'device'> & { device: ResolversParentTypes['DtnVendorDevice'] };
  DtnVendorDeviceToLocation: Omit<DtnVendorDeviceToLocation, 'creator' | 'device'> & { creator?: Maybe<ResolversParentTypes['User']>, device: ResolversParentTypes['DtnVendorDevice'] };
  DtnVendorDeviceToLocationV2: Omit<DtnVendorDeviceToLocationV2, 'creator' | 'device'> & { creator?: Maybe<ResolversParentTypes['User']>, device: ResolversParentTypes['DtnVendorDevice'] };
  DtnVendorKey: Omit<DtnVendorKey, 'creator' | 'user'> & { creator?: Maybe<ResolversParentTypes['User']>, user?: Maybe<ResolversParentTypes['User']> };
  DtnVendorKeyDevice: DtnVendorKeyDevice;
  EmergenceAnalysisImageResult: EmergenceAnalysisImageResult;
  EmergenceAnalysisResult: EmergenceAnalysisResult;
  EntityHistory: Omit<EntityHistory, 'modifiedBy'> & { modifiedBy?: Maybe<ResolversParentTypes['User']> };
  EntityModification: EntityModification;
  EscalationContact: EscalationContact;
  EvidenceFile: EvidenceFile;
  EvidenceFiles: EvidenceFiles;
  EvidenceReceipt: EvidenceReceipt;
  ExatrekApplicationMapDispatchOrder: ExatrekApplicationMapDispatchOrder;
  ExatrekDeviceState: Omit<ExatrekDeviceState, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  ExatrekDeviceStatePosition: ExatrekDeviceStatePosition;
  ExatrekUserDevice: Omit<ExatrekUserDevice, 'deviceState' | 'user'> & { deviceState?: Maybe<ResolversParentTypes['ExatrekDeviceState']>, user?: Maybe<ResolversParentTypes['User']> };
  ExatrekUserMachine: Omit<ExatrekUserMachine, 'userDevice'> & { userDevice: ResolversParentTypes['ExatrekUserDevice'] };
  ExecutionZoneStrategy: ExecutionZoneStrategy;
  ExistingOrder: Omit<ExistingOrder, 'farm' | 'shopUserPackages'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, shopUserPackages?: Maybe<Array<Maybe<ResolversParentTypes['ShopUserPackage']>>> };
  ExportOrder: ExportOrder;
  FDLSourceUnion: ResolversUnionTypes<ResolversParentTypes>['FDLSourceUnion'];
  FactorLevelFieldZoneMapping: Omit<FactorLevelFieldZoneMapping, 'fieldZone'> & { fieldZone?: Maybe<ResolversParentTypes['FieldZone']> };
  FailureMap: FailureMap;
  Farm: Omit<Farm, 'billingAddress' | 'fields' | 'fieldsV2' | 'shippingAddress'> & { billingAddress?: Maybe<ResolversParentTypes['Address']>, fields: Array<Maybe<ResolversParentTypes['Field']>>, fieldsV2: Array<Maybe<ResolversParentTypes['FieldV2']>>, shippingAddress?: Maybe<ResolversParentTypes['Address']> };
  FarmCarbonIntensityIndicator: FarmCarbonIntensityIndicator;
  FarmCountryCropGrowthStagePredictions: Omit<FarmCountryCropGrowthStagePredictions, 'farm' | 'growthStages'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, growthStages?: Maybe<Array<Maybe<ResolversParentTypes['CountryCropGrowthStagePrediction']>>> };
  FarmCropMetrics: Omit<FarmCropMetrics, 'crop' | 'farm'> & { crop?: Maybe<ResolversParentTypes['Crop']>, farm?: Maybe<ResolversParentTypes['FarmV2']> };
  FarmDataLayer: FarmDataLayer;
  FarmDataLayerLegend: FarmDataLayerLegend;
  FarmEvidence: FarmEvidence;
  FarmEvidenceAcceptedTerm: FarmEvidenceAcceptedTerm;
  FarmEvidenceAcceptedTerms: FarmEvidenceAcceptedTerms;
  FarmEvidenceAgExpertStatement: FarmEvidenceAgExpertStatement;
  FarmEvidenceAgExpertStatements: FarmEvidenceAgExpertStatements;
  FarmEvidenceAudit: FarmEvidenceAudit;
  FarmEvidenceAudits: FarmEvidenceAudits;
  FarmEvidenceAverageCiScore: FarmEvidenceAverageCiScore;
  FarmEvidenceCertification: FarmEvidenceCertification;
  FarmEvidenceCertifications: FarmEvidenceCertifications;
  FarmEvidenceCropScore: FarmEvidenceCropScore;
  FarmEvidenceFieldBuckets: FarmEvidenceFieldBuckets;
  FarmEvidenceFieldCount: FarmEvidenceFieldCount;
  FarmEvidenceLink: FarmEvidenceLink;
  FarmEvidenceLinkSort: FarmEvidenceLinkSort;
  FarmEvidenceLinks: FarmEvidenceLinks;
  FarmEvidenceManureSource: FarmEvidenceManureSource;
  FarmEvidenceManureSources: FarmEvidenceManureSources;
  FarmEvidenceProgram: FarmEvidenceProgram;
  FarmEvidenceRecords: FarmEvidenceRecords;
  FarmFeature: Omit<FarmFeature, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  FarmFeatures: FarmFeatures;
  FarmFeaturesSummary: Omit<FarmFeaturesSummary, 'farm'> & { farm: ResolversParentTypes['FarmV2'] };
  FarmGreetCarbonIntensityScore: FarmGreetCarbonIntensityScore;
  FarmLayerSummaryCount: FarmLayerSummaryCount;
  FarmPackage: FarmPackage;
  FarmPackageConsumption: FarmPackageConsumption;
  FarmReceipt: Omit<FarmReceipt, 'creator' | 'farmV2'> & { creator?: Maybe<ResolversParentTypes['User']>, farmV2: ResolversParentTypes['FarmV2'] };
  FarmReceiptReference: Omit<FarmReceiptReference, 'creator'> & { creator?: Maybe<ResolversParentTypes['User']> };
  FarmUuid: FarmUuid;
  FarmV2: Omit<FarmV2, 'billingAddress' | 'collaborators' | 'creator' | 'cropNutritionReportConfiguration' | 'cropSeasonStatusReportEmailSubscriptions' | 'currentUserPermission' | 'droneFlightQuotas' | 'existingOrders' | 'farmActiveGrowthStages' | 'fieldsV2' | 'grower' | 'hfAlerts' | 'hfDiscounts' | 'hfServiceRequests' | 'importOrders' | 'jdNotificationSubscriptions' | 'kwsConsent' | 'latestScoutingTask' | 'owner' | 'recentlyUsedProducts' | 'shippingAddress'> & { billingAddress?: Maybe<ResolversParentTypes['Address']>, collaborators?: Maybe<Array<Maybe<ResolversParentTypes['Collaborator']>>>, creator?: Maybe<ResolversParentTypes['User']>, cropNutritionReportConfiguration?: Maybe<ResolversParentTypes['CropNutritionReportConfiguration']>, cropSeasonStatusReportEmailSubscriptions?: Maybe<Array<Maybe<ResolversParentTypes['CropSeasonStatusReportEmailSubscription']>>>, currentUserPermission?: Maybe<ResolversParentTypes['Permission']>, droneFlightQuotas?: Maybe<Array<Maybe<ResolversParentTypes['DroneFlightQuota']>>>, existingOrders?: Maybe<Array<Maybe<ResolversParentTypes['ExistingOrder']>>>, farmActiveGrowthStages?: Maybe<ResolversParentTypes['FarmCountryCropGrowthStagePredictions']>, fieldsV2?: Maybe<Array<ResolversParentTypes['FieldV2']>>, grower?: Maybe<ResolversParentTypes['Collaborator']>, hfAlerts?: Maybe<Array<Maybe<ResolversParentTypes['HfAlert']>>>, hfDiscounts?: Maybe<Array<Maybe<ResolversParentTypes['HfDiscount']>>>, hfServiceRequests?: Maybe<Array<Maybe<ResolversParentTypes['HFServiceRequest']>>>, importOrders?: Maybe<Array<Maybe<ResolversParentTypes['ImportOrder']>>>, jdNotificationSubscriptions?: Maybe<Array<Maybe<ResolversParentTypes['JdNotificationSubscription']>>>, kwsConsent?: Maybe<ResolversParentTypes['KwsConsent']>, latestScoutingTask?: Maybe<ResolversParentTypes['ScoutingTask']>, owner?: Maybe<ResolversParentTypes['User']>, recentlyUsedProducts?: Maybe<Array<Maybe<ResolversParentTypes['RecentlyUsedProduct']>>>, shippingAddress?: Maybe<ResolversParentTypes['Address']> };
  Field: Omit<Field, 'cropSeasons' | 'fieldDataLayers' | 'sprayWeather'> & { cropSeasons?: Maybe<Array<Maybe<ResolversParentTypes['CropSeason']>>>, fieldDataLayers?: Maybe<Array<Maybe<ResolversParentTypes['FieldDataLayer']>>>, sprayWeather?: Maybe<Array<Maybe<ResolversParentTypes['SprayWeather']>>> };
  FieldActivation: Omit<FieldActivation, 'package'> & { package: ResolversParentTypes['Package'] };
  FieldBoundaryLookupScore: Omit<FieldBoundaryLookupScore, 'farm' | 'field'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, field?: Maybe<ResolversParentTypes['FieldV2']> };
  FieldDataDataMapping: FieldDataDataMapping;
  FieldDataLayer: Omit<FieldDataLayer, 'cropSeason' | 'cropSeasonV2' | 'field' | 'fieldDataLayerStatistics' | 'fieldV2' | 'source'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, field?: Maybe<ResolversParentTypes['Field']>, fieldDataLayerStatistics?: Maybe<Array<Maybe<ResolversParentTypes['FieldDataLayerStatistics']>>>, fieldV2?: Maybe<ResolversParentTypes['FieldV2']>, source?: Maybe<ResolversParentTypes['FDLSourceUnion']> };
  FieldDataLayerClassification: FieldDataLayerClassification;
  FieldDataLayerClassificationEntry: FieldDataLayerClassificationEntry;
  FieldDataLayerLegend: Omit<FieldDataLayerLegend, 'fieldDataLayer'> & { fieldDataLayer?: Maybe<ResolversParentTypes['FieldDataLayer']> };
  FieldDataLayerSort: FieldDataLayerSort;
  FieldDataLayerSourceProperty: FieldDataLayerSourceProperty;
  FieldDataLayerStatistics: FieldDataLayerStatistics;
  FieldDataUploadDataset: Omit<FieldDataUploadDataset, 'cropSeasonV2' | 'farmV2' | 'fieldV2' | 'missingInfo'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, farmV2?: Maybe<ResolversParentTypes['FarmV2']>, fieldV2?: Maybe<ResolversParentTypes['FieldV2']>, missingInfo?: Maybe<ResolversParentTypes['FieldDataUploadDatasetMissingInfo']> };
  FieldDataUploadDatasetMissingInfo: Omit<FieldDataUploadDatasetMissingInfo, 'cropSeason' | 'field'> & { cropSeason?: Maybe<ResolversParentTypes['FieldDataUploadDatasetMissingInfoCropSeason']>, field?: Maybe<ResolversParentTypes['FieldDataUploadDatasetMissingInfoField']> };
  FieldDataUploadDatasetMissingInfoCropSeason: Omit<FieldDataUploadDatasetMissingInfoCropSeason, 'bestGuess' | 'possibleValues'> & { bestGuess?: Maybe<ResolversParentTypes['CropSeasonV2']>, possibleValues?: Maybe<Array<Maybe<ResolversParentTypes['CropSeasonV2']>>> };
  FieldDataUploadDatasetMissingInfoField: Omit<FieldDataUploadDatasetMissingInfoField, 'bestGuess' | 'possibleValues'> & { bestGuess?: Maybe<ResolversParentTypes['FieldV2']>, possibleValues?: Maybe<Array<Maybe<ResolversParentTypes['FieldV2']>>> };
  FieldDataUploadDatasetSort: FieldDataUploadDatasetSort;
  FieldEntry: Omit<FieldEntry, 'fieldV2'> & { fieldV2: ResolversParentTypes['FieldV2'] };
  FieldEvidence: FieldEvidence;
  FieldEvidenceAph: FieldEvidenceAph;
  FieldEvidenceCiScore: FieldEvidenceCiScore;
  FieldEvidenceCoverCrop: FieldEvidenceCoverCrop;
  FieldEvidenceCoverCropSeason: FieldEvidenceCoverCropSeason;
  FieldEvidenceCropSeason: FieldEvidenceCropSeason;
  FieldEvidenceExpectedYieldProof: FieldEvidenceExpectedYieldProof;
  FieldEvidenceField: FieldEvidenceField;
  FieldEvidenceHarvest: FieldEvidenceHarvest;
  FieldEvidenceHarvestTask: FieldEvidenceHarvestTask;
  FieldEvidenceLandLease: FieldEvidenceLandLease;
  FieldEvidenceLandLeases: FieldEvidenceLandLeases;
  FieldEvidenceLandUse: FieldEvidenceLandUse;
  FieldEvidenceLandUses: FieldEvidenceLandUses;
  FieldEvidenceLandownerRelease: FieldEvidenceLandownerRelease;
  FieldEvidenceLandownerReleases: FieldEvidenceLandownerReleases;
  FieldEvidenceLink: FieldEvidenceLink;
  FieldEvidenceLinkSort: FieldEvidenceLinkSort;
  FieldEvidenceLinks: FieldEvidenceLinks;
  FieldEvidenceManureTest: FieldEvidenceManureTest;
  FieldEvidenceManureTests: FieldEvidenceManureTests;
  FieldEvidenceNutrition: FieldEvidenceNutrition;
  FieldEvidenceNutritionPlan: FieldEvidenceNutritionPlan;
  FieldEvidenceNutritionTask: FieldEvidenceNutritionTask;
  FieldEvidenceProgram: FieldEvidenceProgram;
  FieldEvidenceRecords: FieldEvidenceRecords;
  FieldEvidenceSale: FieldEvidenceSale;
  FieldEvidenceSampleResults: FieldEvidenceSampleResults;
  FieldEvidenceSeeding: FieldEvidenceSeeding;
  FieldEvidenceSeedingTask: FieldEvidenceSeedingTask;
  FieldEvidenceSoilTest: FieldEvidenceSoilTest;
  FieldEvidenceSoilTests: FieldEvidenceSoilTests;
  FieldEvidenceSort: FieldEvidenceSort;
  FieldEvidenceTDisc: FieldEvidenceTDisc;
  FieldEvidenceTillage: FieldEvidenceTillage;
  FieldEvidenceTillageTask: FieldEvidenceTillageTask;
  FieldEvidenceYieldSales: FieldEvidenceYieldSales;
  FieldFeature: Omit<FieldFeature, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  FieldIdentifierScore: FieldIdentifierScore;
  FieldInputPackaging: Omit<FieldInputPackaging, 'farmV2'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  FieldNote: Omit<FieldNote, 'attachments' | 'creator' | 'cropSeason' | 'field' | 'scoutingPoi' | 'scoutingTask'> & { attachments?: Maybe<Array<Maybe<ResolversParentTypes['FieldNoteAttachment']>>>, creator?: Maybe<ResolversParentTypes['User']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, field?: Maybe<ResolversParentTypes['FieldV2']>, scoutingPoi?: Maybe<ResolversParentTypes['ScoutingPoiV2']>, scoutingTask?: Maybe<ResolversParentTypes['ScoutingTask']> };
  FieldNoteAggregation: Omit<FieldNoteAggregation, 'creators' | 'cropAggregations' | 'farm' | 'fieldNotes' | 'fields'> & { creators?: Maybe<Array<Maybe<ResolversParentTypes['User']>>>, cropAggregations?: Maybe<Array<Maybe<ResolversParentTypes['FieldNoteCropAggregation']>>>, farm?: Maybe<ResolversParentTypes['FarmV2']>, fieldNotes?: Maybe<Array<Maybe<ResolversParentTypes['FieldNote']>>>, fields?: Maybe<Array<Maybe<ResolversParentTypes['FieldV2']>>> };
  FieldNoteAnswer: FieldNoteAnswer;
  FieldNoteAssessmentAggregation: FieldNoteAssessmentAggregation;
  FieldNoteAttachment: Omit<FieldNoteAttachment, 'creator'> & { creator?: Maybe<ResolversParentTypes['User']> };
  FieldNoteAudioAttachment: FieldNoteAudioAttachment;
  FieldNoteCropAggregation: Omit<FieldNoteCropAggregation, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  FieldNoteImage: FieldNoteImage;
  FieldNoteObservation: FieldNoteObservation;
  FieldNoteSort: FieldNoteSort;
  FieldNoteStressAggregation: FieldNoteStressAggregation;
  FieldPointLookup: Omit<FieldPointLookup, 'farm' | 'field'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, field?: Maybe<ResolversParentTypes['FieldV2']> };
  FieldSummary: FieldSummary;
  FieldV2: Omit<FieldV2, 'abLines' | 'activations' | 'agBalanceFieldInput' | 'carbonFarmingRequests' | 'creator' | 'cropSeasons' | 'cropSeasonsV2' | 'currentWeedPredictions' | 'farmV2' | 'features' | 'fieldDataLayers' | 'fieldEntries' | 'fieldNotes' | 'fieldZones' | 'greenhouse' | 'modifier' | 'scoutingTasks' | 'seedSelectorInputs' | 'soilErosion' | 'soilSamplingResults' | 'soilSamplings' | 'sourceMaps' | 'sprayWeather' | 'tramlines' | 'varietyRecommendations'> & { abLines?: Maybe<Array<Maybe<ResolversParentTypes['AbLine']>>>, activations?: Maybe<Array<Maybe<ResolversParentTypes['FieldActivation']>>>, agBalanceFieldInput?: Maybe<ResolversParentTypes['AgBalanceFieldInput']>, carbonFarmingRequests?: Maybe<Array<Maybe<ResolversParentTypes['CarbonFarmingRequest']>>>, creator?: Maybe<ResolversParentTypes['User']>, cropSeasons?: Maybe<Array<Maybe<ResolversParentTypes['CropSeason']>>>, cropSeasonsV2?: Maybe<Array<ResolversParentTypes['CropSeasonV2']>>, currentWeedPredictions?: Maybe<Array<Maybe<ResolversParentTypes['CurrentWeedPrediction']>>>, farmV2?: Maybe<ResolversParentTypes['FarmV2']>, features?: Maybe<Array<Maybe<ResolversParentTypes['FieldFeature']>>>, fieldDataLayers?: Maybe<Array<Maybe<ResolversParentTypes['FieldDataLayer']>>>, fieldEntries?: Maybe<Array<Maybe<ResolversParentTypes['FieldEntry']>>>, fieldNotes?: Maybe<Array<Maybe<ResolversParentTypes['FieldNote']>>>, fieldZones?: Maybe<Array<Maybe<ResolversParentTypes['FieldZone']>>>, greenhouse?: Maybe<ResolversParentTypes['Greenhouse']>, modifier?: Maybe<ResolversParentTypes['User']>, scoutingTasks?: Maybe<Array<ResolversParentTypes['ScoutingTask']>>, seedSelectorInputs?: Maybe<Array<Maybe<ResolversParentTypes['SeedSelectorInput']>>>, soilErosion?: Maybe<Array<Maybe<ResolversParentTypes['SoilErosion']>>>, soilSamplingResults?: Maybe<Array<Maybe<ResolversParentTypes['SoilSamplingResult']>>>, soilSamplings?: Maybe<Array<Maybe<ResolversParentTypes['SoilSampling']>>>, sourceMaps?: Maybe<Array<Maybe<ResolversParentTypes['SourceMap']>>>, sprayWeather?: Maybe<Array<Maybe<ResolversParentTypes['SprayWeather']>>>, tramlines?: Maybe<Array<Maybe<ResolversParentTypes['Tramline']>>>, varietyRecommendations?: Maybe<Array<Maybe<ResolversParentTypes['VarietyRecommendation']>>> };
  FieldVariabilityInSeason: FieldVariabilityInSeason;
  FieldVariabilityInSeasonIndex: FieldVariabilityInSeasonIndex;
  FieldVariabilityIndex: Omit<FieldVariabilityIndex, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  FieldVariabilityInput: Omit<FieldVariabilityInput, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  FieldVariabilityTimeSeries: FieldVariabilityTimeSeries;
  FieldVariabilityTimeSeriesIndex: FieldVariabilityTimeSeriesIndex;
  FieldZone: Omit<FieldZone, 'cropSeasonV2' | 'fieldV2' | 'trials'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, fieldV2: ResolversParentTypes['FieldV2'], trials?: Maybe<Array<Maybe<ResolversParentTypes['Trial']>>> };
  File: Omit<File, 'creator'> & { creator?: Maybe<ResolversParentTypes['User']> };
  FileSort: FileSort;
  Float: Scalars['Float']['output'];
  FmCarbonRelatedData: FmCarbonRelatedData;
  Footprint: Footprint;
  ForeignCatchCrop: ForeignCatchCrop;
  ForeignCrop: ForeignCrop;
  ForeignPreCrop: ForeignPreCrop;
  FreshBiomassOrder: Omit<FreshBiomassOrder, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  FrostRisk: Omit<FrostRisk, 'cropSeasonV2'> & { cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  FulfilledIntervention: FulfilledIntervention;
  GeneralTask: Omit<GeneralTask, 'cropSeason' | 'taskDetails'> & { cropSeason: ResolversParentTypes['CropSeasonV2'], taskDetails: ResolversParentTypes['GeneralTasksUnion'] };
  GeneralTasksUnion: ResolversUnionTypes<ResolversParentTypes>['GeneralTasksUnion'];
  GeoMapDetail: GeoMapDetail;
  Greenhouse: Omit<Greenhouse, 'creator' | 'fieldV2'> & { creator?: Maybe<ResolversParentTypes['User']>, fieldV2: ResolversParentTypes['FieldV2'] };
  GreenhouseWhiteningTask: Omit<GreenhouseWhiteningTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  GreetApplication: GreetApplication;
  GreetCarbonIntensityScore: GreetCarbonIntensityScore;
  GreetCropProtection: GreetCropProtection;
  Group: Group;
  GrowthStage: Omit<GrowthStage, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  GrowthStagePredictionCalculatedPayload: GrowthStagePredictionCalculatedPayload;
  GrowthStagePredictionDaily: Omit<GrowthStagePredictionDaily, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  HFContractorEquipment: HfContractorEquipment;
  HFContractorRequest: Omit<HfContractorRequest, 'creator' | 'user'> & { creator?: Maybe<ResolversParentTypes['User']>, user?: Maybe<ResolversParentTypes['User']> };
  HFServiceRequest: Omit<HfServiceRequest, 'billingAddress' | 'collaborator' | 'cropSeason' | 'farm' | 'hfDiscounts' | 'requesteeUser'> & { billingAddress?: Maybe<ResolversParentTypes['BillingAddress']>, collaborator?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, farm?: Maybe<ResolversParentTypes['FarmV2']>, hfDiscounts?: Maybe<Array<Maybe<ResolversParentTypes['HfDiscount']>>>, requesteeUser?: Maybe<ResolversParentTypes['User']> };
  Harvest: Omit<Harvest, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  HfAddress: HfAddress;
  HfAgRegion: HfAgRegion;
  HfAlert: Omit<HfAlert, 'farm' | 'field'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, field?: Maybe<ResolversParentTypes['FieldV2']> };
  HfClaim: Omit<HfClaim, 'assigneeUser' | 'categories' | 'cropSeason' | 'fieldNotes' | 'hfServiceRequest'> & { assigneeUser?: Maybe<ResolversParentTypes['User']>, categories?: Maybe<Array<Maybe<ResolversParentTypes['ClaimCategory']>>>, cropSeason: ResolversParentTypes['CropSeasonV2'], fieldNotes?: Maybe<Array<Maybe<ResolversParentTypes['FieldNote']>>>, hfServiceRequest?: Maybe<ResolversParentTypes['HFServiceRequest']> };
  HfDiscount: Omit<HfDiscount, 'farm' | 'hfServiceRequest'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, hfServiceRequest?: Maybe<ResolversParentTypes['HFServiceRequest']> };
  HfDistributor: Omit<HfDistributor, 'distributorManagerId'> & { distributorManagerId?: Maybe<ResolversParentTypes['User']> };
  HfFarm: Omit<HfFarm, 'farm'> & { farm: ResolversParentTypes['FarmV2'] };
  HfInvoice: Omit<HfInvoice, 'hfServiceRequests'> & { hfServiceRequests: Array<ResolversParentTypes['HFServiceRequest']> };
  HfMachinery: HfMachinery;
  HfOffer: Omit<HfOffer, 'hfServiceRequests' | 'recipientUser'> & { hfServiceRequests?: Maybe<Array<Maybe<ResolversParentTypes['HFServiceRequest']>>>, recipientUser?: Maybe<ResolversParentTypes['User']> };
  HfOfferCondition: Omit<HfOfferCondition, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  HfOperationalInstruction: Omit<HfOperationalInstruction, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  HfPreOrder: Omit<HfPreOrder, 'cropQuotas' | 'farm'> & { cropQuotas?: Maybe<Array<Maybe<ResolversParentTypes['PreOrderCropQuota']>>>, farm?: Maybe<ResolversParentTypes['FarmV2']> };
  HfPrice: Omit<HfPrice, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  HfRate: HfRate;
  HfReferenceCode: Omit<HfReferenceCode, 'creator' | 'digitalServiceManager' | 'enabledCrops'> & { creator?: Maybe<ResolversParentTypes['User']>, digitalServiceManager?: Maybe<ResolversParentTypes['User']>, enabledCrops?: Maybe<Array<ResolversParentTypes['Crop']>> };
  HfReferenceCodeCategoryRate: HfReferenceCodeCategoryRate;
  HfReferenceCodeMargin: HfReferenceCodeMargin;
  HfReferenceCodePublic: Omit<HfReferenceCodePublic, 'enabledCrops'> & { enabledCrops?: Maybe<Array<ResolversParentTypes['Crop']>> };
  HfReferenceCodeRate: HfReferenceCodeRate;
  HfRequestFarmPackageAddOn: Omit<HfRequestFarmPackageAddOn, 'creator' | 'farm' | 'lastModifier'> & { creator?: Maybe<ResolversParentTypes['User']>, farm?: Maybe<ResolversParentTypes['FarmV2']>, lastModifier?: Maybe<ResolversParentTypes['User']> };
  HfRiskClass: HfRiskClass;
  HfSeason: HfSeason;
  HfWeatherData: Omit<HfWeatherData, 'cropSeason' | 'farm'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, farm?: Maybe<ResolversParentTypes['FarmV2']> };
  HortaCropSeason: Omit<HortaCropSeason, 'fmCropSeason'> & { fmCropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  HortaSpraying: Omit<HortaSpraying, 'cropSeason' | 'fmSpraying'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, fmSpraying?: Maybe<ResolversParentTypes['SprayingV2']> };
  HortaStress: HortaStress;
  HortaSustainabilityIndicator: Omit<HortaSustainabilityIndicator, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  Image: Image;
  ImportOrder: Omit<ImportOrder, 'farm'> & { farm?: Maybe<ResolversParentTypes['FarmV2']> };
  ImportantGrowthStage: Omit<ImportantGrowthStage, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  IncubationLevel: IncubationLevel;
  IndexableObject: Scalars['IndexableObject']['output'];
  Ingredient: Ingredient;
  Int: Scalars['Int']['output'];
  InviteCode: Omit<InviteCode, 'creator'> & { creator?: Maybe<ResolversParentTypes['User']> };
  JSONObject: Scalars['JSONObject']['output'];
  JdFieldSynchronizationOrder: JdFieldSynchronizationOrder;
  JdNotificationSubscription: Omit<JdNotificationSubscription, 'farmV2'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  KubotaApplicationMapDispatchOrder: KubotaApplicationMapDispatchOrder;
  KubotaField: KubotaField;
  KwsConsent: Omit<KwsConsent, 'farmV2'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  KwsSupportedVariety: Omit<KwsSupportedVariety, 'variety'> & { variety?: Maybe<ResolversParentTypes['Variety']> };
  LandPreparation: Omit<LandPreparation, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  LeafDamageResult: LeafDamageResult;
  LeafPruningTask: Omit<LeafPruningTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  LegendEntry: LegendEntry;
  License: License;
  LicenseRequest: Omit<LicenseRequest, 'creatorUser' | 'farm' | 'lastModifierUser' | 'organisation' | 'organisationMemberUser'> & { creatorUser?: Maybe<ResolversParentTypes['User']>, farm: ResolversParentTypes['FarmV2'], lastModifierUser?: Maybe<ResolversParentTypes['User']>, organisation?: Maybe<ResolversParentTypes['Organisation']>, organisationMemberUser?: Maybe<ResolversParentTypes['User']> };
  LicenseRequestSeason: LicenseRequestSeason;
  LinkedDevice: Omit<LinkedDevice, 'devices'> & { devices?: Maybe<Array<Maybe<ResolversParentTypes['VendorDeviceInfo']>>> };
  Location: Location;
  Magnitude: Omit<Magnitude, 'fieldDataLayer' | 'statistics'> & { fieldDataLayer?: Maybe<ResolversParentTypes['FieldDataLayer']>, statistics?: Maybe<ResolversParentTypes['FieldDataLayerStatistics']> };
  MapItem: Omit<MapItem, 'cropSeason' | 'farm' | 'field' | 'fieldDataLayer'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, farm?: Maybe<ResolversParentTypes['FarmV2']>, field?: Maybe<ResolversParentTypes['FieldV2']>, fieldDataLayer?: Maybe<ResolversParentTypes['FieldDataLayer']> };
  MapItemSort: MapItemSort;
  MappingFieldZone: Omit<MappingFieldZone, 'fieldZone'> & { fieldZone?: Maybe<ResolversParentTypes['FieldZone']> };
  Md2AggregatedProductusesByCrop: Md2AggregatedProductusesByCrop;
  Md2Configuration: Md2Configuration;
  Md2CountryCropConfiguration: Md2CountryCropConfiguration;
  Md2DictionaryMapping: Md2DictionaryMapping;
  Md2Item: Md2Item;
  Md2ProductFeature: Md2ProductFeature;
  Md2TillageDepth: Md2TillageDepth;
  Md2VraAdvisorConfiguration: Md2VraAdvisorConfiguration;
  Md2VraAdvisorFieldDataLayerConfiguration: Md2VraAdvisorFieldDataLayerConfiguration;
  MdCoefficientOfVariationDetail: MdCoefficientOfVariationDetail;
  MdSoilNematodeRisk: MdSoilNematodeRisk;
  MdUnit: MdUnit;
  MeasureSubmissionFieldOrder: Omit<MeasureSubmissionFieldOrder, 'errors' | 'field'> & { errors?: Maybe<Array<Maybe<ResolversParentTypes['MeasureSubmissionFieldOrderError']>>>, field?: Maybe<ResolversParentTypes['FieldV2']> };
  MeasureSubmissionFieldOrderError: MeasureSubmissionFieldOrderError;
  MeasureSubmissionFieldResult: Omit<MeasureSubmissionFieldResult, 'field'> & { field?: Maybe<ResolversParentTypes['FieldV2']> };
  MeasureSubmissionOrder: Omit<MeasureSubmissionOrder, 'fields' | 'sustainabilityProgram'> & { fields?: Maybe<Array<Maybe<ResolversParentTypes['MeasureSubmissionFieldOrder']>>>, sustainabilityProgram?: Maybe<ResolversParentTypes['SustainabilityProgram']> };
  MeasureSubmissionOrderStatistics: MeasureSubmissionOrderStatistics;
  MeasureSubmissionProjectLevelCropResult: MeasureSubmissionProjectLevelCropResult;
  MeasureSubmissionProjectLevelResult: MeasureSubmissionProjectLevelResult;
  MeasureSubmissionResult: Omit<MeasureSubmissionResult, 'fields' | 'measureSubmissionOrder'> & { fields?: Maybe<Array<Maybe<ResolversParentTypes['MeasureSubmissionFieldResult']>>>, measureSubmissionOrder: ResolversParentTypes['MeasureSubmissionOrder'] };
  Measurement: Measurement;
  MergedSmartSprayerExecution: MergedSmartSprayerExecution;
  MissingInfoDataMapping: MissingInfoDataMapping;
  MissingInfoDate: MissingInfoDate;
  MissingInfoExampleData: MissingInfoExampleData;
  MissingInfoUploadDatasetType: MissingInfoUploadDatasetType;
  MonitorCoverCrop: MonitorCoverCrop;
  MonitorPractice: Omit<MonitorPractice, 'field'> & { field?: Maybe<ResolversParentTypes['FieldV2']> };
  MonitorTillage: MonitorTillage;
  MultiFile: MultiFile;
  MultiFileUploadOrder: Omit<MultiFileUploadOrder, 'creator'> & { creator?: Maybe<ResolversParentTypes['User']> };
  MultiWeedResult: MultiWeedResult;
  Mutation: Record<PropertyKey, never>;
  MutationResponse: MutationResponse;
  NamedCropMix: NamedCropMix;
  NitrogenProduct: NitrogenProduct;
  NitrogenStatusResult: NitrogenStatusResult;
  NitrogenType: NitrogenType;
  Node: Scalars['Node']['output'];
  NodeWithTypename: Scalars['NodeWithTypename']['output'];
  Notification: Omit<Notification, 'farmV2' | 'object'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']>, object?: Maybe<ResolversParentTypes['NotificationObject']> };
  NotificationConfiguration: NotificationConfiguration;
  NotificationObject: ResolversUnionTypes<ResolversParentTypes>['NotificationObject'];
  NotificationPayload: NotificationPayload;
  NotificationPreference: Omit<NotificationPreference, 'cropSeasons' | 'user'> & { cropSeasons?: Maybe<Array<Maybe<ResolversParentTypes['NotificationPreferenceCropSeason']>>>, user?: Maybe<ResolversParentTypes['User']> };
  NotificationPreferenceCropSeason: Omit<NotificationPreferenceCropSeason, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  Nutrient: Nutrient;
  NutrientMethodMapping: NutrientMethodMapping;
  NutrientProduct: NutrientProduct;
  NutrientRate: NutrientRate;
  NutritionActionDetail: NutritionActionDetail;
  NutritionActionNutrient: NutritionActionNutrient;
  NutritionActionProduct: NutritionActionProduct;
  NutritionActionValidity: NutritionActionValidity;
  NutritionRecommendation: Omit<NutritionRecommendation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  NutritionStacItemVectorization: NutritionStacItemVectorization;
  NutritionStatus: Omit<NutritionStatus, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  NutritionTargetRate: NutritionTargetRate;
  Observation: Omit<Observation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  ObservationWeather: ObservationWeather;
  OfflineBasedSmartSprayingTask: OfflineBasedSmartSprayingTask;
  OnOffStatistics: Omit<OnOffStatistics, 'fieldDataLayer'> & { fieldDataLayer?: Maybe<ResolversParentTypes['FieldDataLayer']> };
  OneSoilApplicationMapDispatchOrder: OneSoilApplicationMapDispatchOrder;
  OneSoilDevice: OneSoilDevice;
  OneSoilDeviceLicense: OneSoilDeviceLicense;
  OneSoilFarmReceivedFile: Omit<OneSoilFarmReceivedFile, 'farm' | 'receivedFile'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, receivedFile?: Maybe<ResolversParentTypes['OneSoilReceivedFile']> };
  OneSoilReceivedFile: Omit<OneSoilReceivedFile, 'farmReceivedFiles'> & { farmReceivedFiles?: Maybe<Array<Maybe<ResolversParentTypes['OneSoilFarmReceivedFile']>>> };
  OneSoilUploadDatasetOrder: Omit<OneSoilUploadDatasetOrder, 'farm' | 'receivedFiles' | 'uploadDatasetResults'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, receivedFiles?: Maybe<Array<Maybe<ResolversParentTypes['OneSoilReceivedFile']>>>, uploadDatasetResults?: Maybe<Array<Maybe<ResolversParentTypes['OneSoilUploadDatasetResult']>>> };
  OneSoilUploadDatasetResult: Omit<OneSoilUploadDatasetResult, 'receivedFile'> & { receivedFile?: Maybe<ResolversParentTypes['OneSoilReceivedFile']> };
  OrderAffiliate: OrderAffiliate;
  Organisation: Omit<Organisation, 'billingAddress' | 'owner'> & { billingAddress?: Maybe<ResolversParentTypes['Address']>, owner?: Maybe<ResolversParentTypes['User']> };
  OrganisationBranch: Omit<OrganisationBranch, 'address' | 'organisation'> & { address?: Maybe<ResolversParentTypes['Address']>, organisation?: Maybe<ResolversParentTypes['Organisation']> };
  OrganisationFarmAssignment: Omit<OrganisationFarmAssignment, 'farm' | 'organisation'> & { farm: ResolversParentTypes['FarmV2'], organisation?: Maybe<ResolversParentTypes['Organisation']> };
  OrganisationFeature: Omit<OrganisationFeature, 'organisation'> & { organisation: ResolversParentTypes['Organisation'] };
  OrganisationMember: Omit<OrganisationMember, 'branch' | 'manager' | 'organisation' | 'user'> & { branch?: Maybe<ResolversParentTypes['OrganisationBranch']>, manager?: Maybe<ResolversParentTypes['OrganisationMember']>, organisation?: Maybe<ResolversParentTypes['Organisation']>, user?: Maybe<ResolversParentTypes['User']> };
  OrganisationMembershipRequest: Omit<OrganisationMembershipRequest, 'branch' | 'manager' | 'requestee' | 'requester'> & { branch?: Maybe<ResolversParentTypes['OrganisationBranch']>, manager?: Maybe<ResolversParentTypes['OrganisationMember']>, requestee?: Maybe<ResolversParentTypes['User']>, requester?: Maybe<ResolversParentTypes['User']> };
  OrganisationMethod: Omit<OrganisationMethod, 'organisation'> & { organisation: ResolversParentTypes['Organisation'] };
  OrganisationQuota: OrganisationQuota;
  OrganisationQuotaLedger: OrganisationQuotaLedger;
  OrganisationQuotaLedgerSort: OrganisationQuotaLedgerSort;
  OrganisationTag: OrganisationTag;
  Organization: Organization;
  Package: Omit<Package, 'activatesPackages' | 'crop'> & { activatesPackages?: Maybe<Array<Maybe<ResolversParentTypes['Package']>>>, crop?: Maybe<ResolversParentTypes['Crop']> };
  PaginatedFarmEvidenceLink: PaginatedFarmEvidenceLink;
  PaginatedFarmReceipt: Omit<PaginatedFarmReceipt, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['FarmReceipt']>>> };
  PaginatedFieldDataLayer: Omit<PaginatedFieldDataLayer, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['FieldDataLayer']>>> };
  PaginatedFieldEvidence: PaginatedFieldEvidence;
  PaginatedFieldEvidenceLink: PaginatedFieldEvidenceLink;
  PaginatedFieldNote: Omit<PaginatedFieldNote, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['FieldNote']>>> };
  PaginatedFile: Omit<PaginatedFile, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['File']>>> };
  PaginatedHfClaim: Omit<PaginatedHfClaim, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['HfClaim']>>> };
  PaginatedHfContractorRequest: Omit<PaginatedHfContractorRequest, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['HFContractorRequest']>>> };
  PaginatedHfOperationalInstruction: Omit<PaginatedHfOperationalInstruction, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['HfOperationalInstruction']>>> };
  PaginatedMapItem: Omit<PaginatedMapItem, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['MapItem']>>> };
  PaginatedMd2DictionaryMapping: PaginatedMd2DictionaryMapping;
  PaginatedOrganisation: Omit<PaginatedOrganisation, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['Organisation']>>> };
  PaginatedOrganisationQuotaLedger: PaginatedOrganisationQuotaLedger;
  PaginatedPreOrder: Omit<PaginatedPreOrder, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['PreOrder']>>> };
  PaginatedScaleTicket: PaginatedScaleTicket;
  PaginatedScaleTicketBooking: PaginatedScaleTicketBooking;
  PaginatedScaleTicketBookingDispute: PaginatedScaleTicketBookingDispute;
  PaginatedScaleTicketDataMapping: Omit<PaginatedScaleTicketDataMapping, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['ScaleTicketDataMapping']>>> };
  PaginatedScaleTicketHistory: PaginatedScaleTicketHistory;
  PaginatedScaleTicketSellerMapping: Omit<PaginatedScaleTicketSellerMapping, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['ScaleTicketSellerMapping']>>> };
  PaginatedScaleTicketUpload: PaginatedScaleTicketUpload;
  PaginatedScoutingTask: Omit<PaginatedScoutingTask, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['ScoutingTask']>>> };
  PaginatedSmartSprayerExecution: Omit<PaginatedSmartSprayerExecution, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['SmartSprayerExecution']>>> };
  PaginatedSmartSprayerRegistration: PaginatedSmartSprayerRegistration;
  PaginatedSmartSprayerWeedPressureFields: Omit<PaginatedSmartSprayerWeedPressureFields, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['SmartSprayerWeedPressureFieldListItem']>>> };
  PaginatedSustainabilityOrganisationCapability: Omit<PaginatedSustainabilityOrganisationCapability, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['SustainabilityOrganisationCapability']>>> };
  PaginatedSustainabilityProgram: Omit<PaginatedSustainabilityProgram, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['SustainabilityProgram']>>> };
  PaginatedSustainabilityProgramBranchAssignment: Omit<PaginatedSustainabilityProgramBranchAssignment, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['SustainabilityProgramBranchAssignment']>>> };
  PaginatedSustainabilityProgramEnrolledField: PaginatedSustainabilityProgramEnrolledField;
  PaginatedSustainabilityProgramInvitation: Omit<PaginatedSustainabilityProgramInvitation, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['SustainabilityProgramInvitation']>>> };
  PaginatedSustainabilityProgramOrganisationParticipation: Omit<PaginatedSustainabilityProgramOrganisationParticipation, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['SustainabilityProgramOrganisationParticipation']>>> };
  PaginatedTask: Omit<PaginatedTask, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['GeneralTask']>>> };
  PaginatedTrialsV2: Omit<PaginatedTrialsV2, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['TrialV2']>>> };
  PaginatedUploadDataset: Omit<PaginatedUploadDataset, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['FieldDataUploadDataset']>>> };
  PaginatedVariety: Omit<PaginatedVariety, 'items'> & { items?: Maybe<Array<Maybe<ResolversParentTypes['Variety']>>> };
  Pagination: Pagination;
  PanoramaClient: PanoramaClient;
  PanoramaConnectionStatus: PanoramaConnectionStatus;
  PanoramaFarm: PanoramaFarm;
  PanoramaField: PanoramaField;
  PanoramaOrganization: PanoramaOrganization;
  PayloadData: Omit<PayloadData, 'payload'> & { payload?: Maybe<ResolversParentTypes['AggregatedNotificationPayload']> };
  Permission: Omit<Permission, 'grantee' | 'granter'> & { grantee?: Maybe<ResolversParentTypes['User']>, granter?: Maybe<ResolversParentTypes['User']> };
  PermissionRequest: Omit<PermissionRequest, 'requestee' | 'requester'> & { requestee?: Maybe<ResolversParentTypes['User']>, requester?: Maybe<ResolversParentTypes['User']> };
  PestDevelopmentPrediction: Omit<PestDevelopmentPrediction, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  Plausibility: Plausibility;
  PreOrder: Omit<PreOrder, 'crop' | 'farm' | 'hfServiceDetails'> & { crop?: Maybe<ResolversParentTypes['Crop']>, farm: ResolversParentTypes['FarmV2'], hfServiceDetails?: Maybe<ResolversParentTypes['PreOrderHfServiceDetails']> };
  PreOrderCropQuota: Omit<PreOrderCropQuota, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  PreOrderHfServiceDetails: Omit<PreOrderHfServiceDetails, 'areaClasses' | 'assignedAgronomicConsultant' | 'assignedContractor' | 'hfReferenceCodePublic' | 'quotas'> & { areaClasses?: Maybe<Array<ResolversParentTypes['PreOrderHfServiceRequestAreaClass']>>, assignedAgronomicConsultant?: Maybe<ResolversParentTypes['User']>, assignedContractor?: Maybe<ResolversParentTypes['User']>, hfReferenceCodePublic?: Maybe<ResolversParentTypes['HfReferenceCodePublic']>, quotas?: Maybe<Array<Maybe<ResolversParentTypes['PreOrderQuota']>>> };
  PreOrderHfServiceRequestAreaClass: Omit<PreOrderHfServiceRequestAreaClass, 'crop'> & { crop: ResolversParentTypes['Crop'] };
  PreOrderHfServiceRequestShippingAddress: PreOrderHfServiceRequestShippingAddress;
  PreOrderQuota: Omit<PreOrderQuota, 'crop'> & { crop: ResolversParentTypes['Crop'] };
  PrecifieldBiomassMap: Omit<PrecifieldBiomassMap, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  PrecifieldCerealsMapSubscription: Omit<PrecifieldCerealsMapSubscription, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  PrecifieldNitrogenPrescriptionMap: Omit<PrecifieldNitrogenPrescriptionMap, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  PrecifieldOsrMapSubscription: Omit<PrecifieldOsrMapSubscription, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  PrecifieldYieldPotentialMap: Omit<PrecifieldYieldPotentialMap, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  Prediction: Prediction;
  PremiumBand: PremiumBand;
  ProduceDeliveryTask: Omit<ProduceDeliveryTask, 'assignee' | 'cropSeasonV2'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  ProduceDeliveryTaskProduceProperties: ProduceDeliveryTaskProduceProperties;
  Product: Product;
  ProductApplicationRate: ProductApplicationRate;
  ProductFeature: Omit<ProductFeature, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  ProductPack: Omit<ProductPack, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  ProductPermissibleRate: Omit<ProductPermissibleRate, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  ProductPermissibleRateV2: Omit<ProductPermissibleRateV2, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  ProductRate: ProductRate;
  ProductRateInput: ProductRateInput;
  ProductRecommendationTankMix: ProductRecommendationTankMix;
  ProductV2: Omit<ProductV2, 'farmV2'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  ProjectedDailyIncidence: ProjectedDailyIncidence;
  ProjectedIncidences: Omit<ProjectedIncidences, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  ProtectionTime: Omit<ProtectionTime, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  Protocol: Protocol;
  ProtocolAttachment: ProtocolAttachment;
  PublicOrganisation: Omit<PublicOrganisation, 'billingAddress' | 'owner'> & { billingAddress?: Maybe<ResolversParentTypes['Address']>, owner?: Maybe<ResolversParentTypes['User']> };
  PurchasedLicense: PurchasedLicense;
  Query: Record<PropertyKey, never>;
  QuotaLimit: Omit<QuotaLimit, 'creator' | 'organisation'> & { creator?: Maybe<ResolversParentTypes['User']>, organisation: ResolversParentTypes['Organisation'] };
  QuotaTransfer: Omit<QuotaTransfer, 'creator'> & { creator?: Maybe<ResolversParentTypes['User']> };
  RateByZone: RateByZone;
  RatesCalculationRequest: RatesCalculationRequest;
  RecentlyUsedProduct: Omit<RecentlyUsedProduct, 'farmV2'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  RecommendationActionValidity: RecommendationActionValidity;
  RecommendationSnooze: Omit<RecommendationSnooze, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  RecommendedRate: RecommendedRate;
  RecommendedTimingForApplication: RecommendedTimingForApplication;
  ReferenceProductRate: ReferenceProductRate;
  ReferenceTotalMixtureRate: ReferenceTotalMixtureRate;
  RegionRate: RegionRate;
  RelativeMaturity: RelativeMaturity;
  ResidualActivation: ResidualActivation;
  ResponseStatus: ResponseStatus;
  Risk: Omit<Risk, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  RiskClassification: RiskClassification;
  RiskMap: RiskMap;
  RiskV2: Omit<RiskV2, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  SampledPoint: SampledPoint;
  SamplingArea: SamplingArea;
  SamplingDepth: SamplingDepth;
  SamplingId: SamplingId;
  SamplingPoint: SamplingPoint;
  ScaleTicket: ScaleTicket;
  ScaleTicketBooking: ScaleTicketBooking;
  ScaleTicketBookingDispute: ScaleTicketBookingDispute;
  ScaleTicketBookingDisputeSort: ScaleTicketBookingDisputeSort;
  ScaleTicketBookingDisputeSplit: ScaleTicketBookingDisputeSplit;
  ScaleTicketBookingSort: ScaleTicketBookingSort;
  ScaleTicketDataMapping: Omit<ScaleTicketDataMapping, 'organisation'> & { organisation?: Maybe<ResolversParentTypes['Organisation']> };
  ScaleTicketDataMappingSort: ScaleTicketDataMappingSort;
  ScaleTicketDuplicateNumberSummary: ScaleTicketDuplicateNumberSummary;
  ScaleTicketDuplicateTicket: ScaleTicketDuplicateTicket;
  ScaleTicketHarvestCapSummary: ScaleTicketHarvestCapSummary;
  ScaleTicketHistory: ScaleTicketHistory;
  ScaleTicketHistorySort: ScaleTicketHistorySort;
  ScaleTicketMissingHarvestSummary: ScaleTicketMissingHarvestSummary;
  ScaleTicketMissingMoistureSummary: ScaleTicketMissingMoistureSummary;
  ScaleTicketNamedRef: ScaleTicketNamedRef;
  ScaleTicketSellerMapping: Omit<ScaleTicketSellerMapping, 'organisation'> & { organisation?: Maybe<ResolversParentTypes['Organisation']> };
  ScaleTicketSellerMappingSort: ScaleTicketSellerMappingSort;
  ScaleTicketSellerNotMatched: ScaleTicketSellerNotMatched;
  ScaleTicketSellerRef: ScaleTicketSellerRef;
  ScaleTicketSort: ScaleTicketSort;
  ScaleTicketStateSummary: ScaleTicketStateSummary;
  ScaleTicketStates: ScaleTicketStates;
  ScaleTicketSummary: ScaleTicketSummary;
  ScaleTicketUpload: ScaleTicketUpload;
  ScaleTicketUploadSort: ScaleTicketUploadSort;
  ScaleTicketUploadSummary: ScaleTicketUploadSummary;
  ScaleTicketUploadTicketStates: ScaleTicketUploadTicketStates;
  ScoutingGrowthStage: ScoutingGrowthStage;
  ScoutingPoi: Omit<ScoutingPoi, 'creator'> & { creator?: Maybe<ResolversParentTypes['User']> };
  ScoutingPoiImage: ScoutingPoiImage;
  ScoutingPoiResult: ResolversInterfaceTypes<ResolversParentTypes>['ScoutingPoiResult'];
  ScoutingPoiV2: Omit<ScoutingPoiV2, 'creator' | 'result'> & { creator?: Maybe<ResolversParentTypes['User']>, result?: Maybe<ResolversParentTypes['ScoutingPoiResult']> };
  ScoutingProtocol: Omit<ScoutingProtocol, 'crop' | 'organisation'> & { crop?: Maybe<ResolversParentTypes['Crop']>, organisation?: Maybe<ResolversParentTypes['Organisation']> };
  ScoutingReport: Omit<ScoutingReport, 'farm' | 'fieldNotes'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, fieldNotes?: Maybe<Array<Maybe<ResolversParentTypes['FieldNote']>>> };
  ScoutingReportDispatchOrder: Omit<ScoutingReportDispatchOrder, 'recipients' | 'scoutingReport'> & { recipients?: Maybe<Array<Maybe<ResolversParentTypes['User']>>>, scoutingReport?: Maybe<ResolversParentTypes['ScoutingReport']> };
  ScoutingStressAnswer: ScoutingStressAnswer;
  ScoutingStressQuestion: Omit<ScoutingStressQuestion, 'crop'> & { crop: ResolversParentTypes['Crop'] };
  ScoutingTask: Omit<ScoutingTask, 'assessmentTiming' | 'assignee' | 'cropSeasonV2' | 'farm' | 'fieldV2' | 'scoutingPoisV2' | 'trial'> & { assessmentTiming?: Maybe<ResolversParentTypes['AssessmentTiming']>, assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, farm?: Maybe<ResolversParentTypes['FarmV2']>, fieldV2: ResolversParentTypes['FieldV2'], scoutingPoisV2?: Maybe<Array<Maybe<ResolversParentTypes['ScoutingPoiV2']>>>, trial?: Maybe<ResolversParentTypes['Trial']> };
  ScoutingTaskSort: ScoutingTaskSort;
  SearchTreatmentProgramActionDateInput: SearchTreatmentProgramActionDateInput;
  SearchTreatmentProgramActionInput: SearchTreatmentProgramActionInput;
  SeasonTimeline: SeasonTimeline;
  SeasonTimelineFeatures: SeasonTimelineFeatures;
  Section: Section;
  SectionInput: SectionInput;
  SectionSummary: SectionSummary;
  SectionSummaryInput: SectionSummaryInput;
  SeedBoxTreatment: Omit<SeedBoxTreatment, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  SeedSelectorInput: Omit<SeedSelectorInput, 'field' | 'variety'> & { field?: Maybe<ResolversParentTypes['FieldV2']>, variety?: Maybe<ResolversParentTypes['Variety']> };
  SeedTreatment: Omit<SeedTreatment, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  SeedTreatmentType: SeedTreatmentType;
  SelectedYear: SelectedYear;
  SensorStatusVariableDetail: SensorStatusVariableDetail;
  SharingMandate: SharingMandate;
  SharingMandatePermission: SharingMandatePermission;
  ShopDevicePackage: ShopDevicePackage;
  ShopFarmPackage: ShopFarmPackage;
  ShopGiftCard: ShopGiftCard;
  ShopSubscription: Omit<ShopSubscription, 'owner' | 'subscriptionItems' | 'subscriptionPeriods'> & { owner?: Maybe<ResolversParentTypes['User']>, subscriptionItems?: Maybe<Array<Maybe<ResolversParentTypes['ShopSubscriptionItem']>>>, subscriptionPeriods?: Maybe<Array<Maybe<ResolversParentTypes['ShopSubscriptionPeriod']>>> };
  ShopSubscriptionAddressInformation: ShopSubscriptionAddressInformation;
  ShopSubscriptionBillingAddress: ShopSubscriptionBillingAddress;
  ShopSubscriptionItem: Omit<ShopSubscriptionItem, 'farm' | 'owner' | 'subscription' | 'user'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, owner?: Maybe<ResolversParentTypes['User']>, subscription?: Maybe<ResolversParentTypes['ShopSubscription']>, user?: Maybe<ResolversParentTypes['User']> };
  ShopSubscriptionPaymentDetails: ShopSubscriptionPaymentDetails;
  ShopSubscriptionPeriod: Omit<ShopSubscriptionPeriod, 'owner' | 'subscription'> & { owner?: Maybe<ResolversParentTypes['User']>, subscription?: Maybe<ResolversParentTypes['ShopSubscription']> };
  ShopSubscriptionShippingAddress: ShopSubscriptionShippingAddress;
  ShopUserPackage: Omit<ShopUserPackage, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  Site: Site;
  SmagConnectionStatus: SmagConnectionStatus;
  SmartSprayerExecution: Omit<SmartSprayerExecution, 'crop' | 'field' | 'offlineTask' | 'smartSprayingTaskV2' | 'terminalTask'> & { crop?: Maybe<ResolversParentTypes['Crop']>, field?: Maybe<ResolversParentTypes['FieldV2']>, offlineTask?: Maybe<ResolversParentTypes['SmartSprayingOfflineTask']>, smartSprayingTaskV2?: Maybe<ResolversParentTypes['SmartSprayingTaskV2']>, terminalTask?: Maybe<ResolversParentTypes['SmartSprayingTerminalTask']> };
  SmartSprayerExecutionFieldInfo: SmartSprayerExecutionFieldInfo;
  SmartSprayerExecutionMissingInfo: SmartSprayerExecutionMissingInfo;
  SmartSprayerExecutionSort: SmartSprayerExecutionSort;
  SmartSprayerExecutionStatistics: SmartSprayerExecutionStatistics;
  SmartSprayerExecutionSummary: SmartSprayerExecutionSummary;
  SmartSprayerLicense: SmartSprayerLicense;
  SmartSprayerRegistration: Omit<SmartSprayerRegistration, 'smartSprayerExecutions' | 'user'> & { smartSprayerExecutions?: Maybe<Array<Maybe<ResolversParentTypes['SmartSprayerExecution']>>>, user?: Maybe<ResolversParentTypes['User']> };
  SmartSprayerRegistrationSort: SmartSprayerRegistrationSort;
  SmartSprayerRegistrationStatus: SmartSprayerRegistrationStatus;
  SmartSprayerStatusPackage: SmartSprayerStatusPackage;
  SmartSprayerWeedPressureApplication: SmartSprayerWeedPressureApplication;
  SmartSprayerWeedPressureApplicationSelection: SmartSprayerWeedPressureApplicationSelection;
  SmartSprayerWeedPressureExclusionSet: SmartSprayerWeedPressureExclusionSet;
  SmartSprayerWeedPressureField: Omit<SmartSprayerWeedPressureField, 'farm' | 'field'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, field?: Maybe<ResolversParentTypes['FieldV2']> };
  SmartSprayerWeedPressureFieldListItem: Omit<SmartSprayerWeedPressureFieldListItem, 'farm' | 'field'> & { farm?: Maybe<ResolversParentTypes['FarmV2']>, field?: Maybe<ResolversParentTypes['FieldV2']> };
  SmartSprayerWeedPressureFieldSort: SmartSprayerWeedPressureFieldSort;
  SmartSprayerWeedPressureHotSpotHistoryPoint: SmartSprayerWeedPressureHotSpotHistoryPoint;
  SmartSprayerWeedPressureRecalculation: SmartSprayerWeedPressureRecalculation;
  SmartSprayerWeedPressureSettingsApplied: SmartSprayerWeedPressureSettingsApplied;
  SmartSprayerWeedPressureStatistics: SmartSprayerWeedPressureStatistics;
  SmartSprayerWeedPressureStatisticsSummary: SmartSprayerWeedPressureStatisticsSummary;
  SmartSprayingOfflineTask: Omit<SmartSprayingOfflineTask, 'crop' | 'cropSeason' | 'field' | 'smartSprayingExecution' | 'smartSprayingTask' | 'smartSprayingTaskV2'> & { crop?: Maybe<ResolversParentTypes['Crop']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, field?: Maybe<ResolversParentTypes['FieldV2']>, smartSprayingExecution?: Maybe<ResolversParentTypes['SmartSprayerExecution']>, smartSprayingTask?: Maybe<ResolversParentTypes['SmartSprayingTask']>, smartSprayingTaskV2?: Maybe<ResolversParentTypes['SmartSprayingTaskV2']> };
  SmartSprayingTask: Omit<SmartSprayingTask, 'assignee' | 'cropSeason' | 'dosedMap' | 'smartSprayingExecution' | 'smartSprayingTaskDevicePayloads'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, dosedMap?: Maybe<ResolversParentTypes['DosedMap']>, smartSprayingExecution?: Maybe<ResolversParentTypes['SmartSprayerExecution']>, smartSprayingTaskDevicePayloads?: Maybe<Array<Maybe<ResolversParentTypes['SmartSprayingTaskDevicePayload']>>> };
  SmartSprayingTaskDevicePayload: Omit<SmartSprayingTaskDevicePayload, 'smartSprayingTask' | 'smartSprayingTaskV2'> & { smartSprayingTask?: Maybe<ResolversParentTypes['SmartSprayingTask']>, smartSprayingTaskV2?: Maybe<ResolversParentTypes['SmartSprayingTaskV2']> };
  SmartSprayingTaskDosedMap: Omit<SmartSprayingTaskDosedMap, 'dosedMap'> & { dosedMap?: Maybe<ResolversParentTypes['DosedMap']> };
  SmartSprayingTaskV2: Omit<SmartSprayingTaskV2, 'assignee' | 'cropSeason' | 'dosedMaps' | 'smartSprayingExecution' | 'smartSprayingTaskDevicePayloads'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, dosedMaps?: Maybe<Array<Maybe<ResolversParentTypes['SmartSprayingTaskDosedMap']>>>, smartSprayingExecution?: Maybe<ResolversParentTypes['SmartSprayerExecution']>, smartSprayingTaskDevicePayloads?: Maybe<Array<Maybe<ResolversParentTypes['SmartSprayingTaskDevicePayload']>>> };
  SmartSprayingTerminalStrategyMappings: SmartSprayingTerminalStrategyMappings;
  SmartSprayingTerminalTask: Omit<SmartSprayingTerminalTask, 'smartSprayingExecution' | 'smartSprayingTask' | 'smartSprayingTaskV2'> & { smartSprayingExecution?: Maybe<ResolversParentTypes['SmartSprayerExecution']>, smartSprayingTask?: Maybe<ResolversParentTypes['SmartSprayingTask']>, smartSprayingTaskV2?: Maybe<ResolversParentTypes['SmartSprayingTaskV2']> };
  SoilErosion: Omit<SoilErosion, 'fieldV2'> & { fieldV2?: Maybe<ResolversParentTypes['FieldV2']> };
  SoilSample: SoilSample;
  SoilSampling: Omit<SoilSampling, 'field' | 'samplingAreas' | 'soilSamplingTasks'> & { field?: Maybe<ResolversParentTypes['FieldV2']>, samplingAreas?: Maybe<Array<Maybe<ResolversParentTypes['SamplingArea']>>>, soilSamplingTasks?: Maybe<Array<Maybe<ResolversParentTypes['SoilSamplingTask']>>> };
  SoilSamplingMeasurement: SoilSamplingMeasurement;
  SoilSamplingResult: Omit<SoilSamplingResult, 'field' | 'files' | 'soilSampling' | 'sourceSoilSamplingResult'> & { field?: Maybe<ResolversParentTypes['FieldV2']>, files?: Maybe<Array<Maybe<ResolversParentTypes['File']>>>, soilSampling?: Maybe<ResolversParentTypes['SoilSampling']>, sourceSoilSamplingResult?: Maybe<ResolversParentTypes['SoilSamplingResult']> };
  SoilSamplingResultArea: SoilSamplingResultArea;
  SoilSamplingResultSourceMap: SoilSamplingResultSourceMap;
  SoilSamplingStressAnalysis: Omit<SoilSamplingStressAnalysis, 'field' | 'soilSamplingResult'> & { field?: Maybe<ResolversParentTypes['FieldV2']>, soilSamplingResult?: Maybe<ResolversParentTypes['SoilSamplingResult']> };
  SoilSamplingTask: Omit<SoilSamplingTask, 'assignee' | 'cropSeasonV2' | 'soilSamplingSet'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, soilSamplingSet?: Maybe<ResolversParentTypes['SoilSampling']> };
  SoilTaxonomy: SoilTaxonomy;
  SoilTexture: SoilTexture;
  SourceMap: Omit<SourceMap, 'cropSeason' | 'cropSeasonV2' | 'field'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, field?: Maybe<ResolversParentTypes['FieldV2']> };
  SourceMapStyle: SourceMapStyle;
  SourceMapStyleEntry: SourceMapStyleEntry;
  SourceValueMapping: SourceValueMapping;
  SprayWeather: Omit<SprayWeather, 'factors' | 'field' | 'fieldV2'> & { factors?: Maybe<Array<Maybe<ResolversParentTypes['SprayWeatherFactor']>>>, field?: Maybe<ResolversParentTypes['Field']>, fieldV2?: Maybe<ResolversParentTypes['FieldV2']> };
  SprayWeatherFactor: SprayWeatherFactor;
  Sprayer: Sprayer;
  SprayerManufacturer: SprayerManufacturer;
  SprayerType: SprayerType;
  Spraying: Omit<Spraying, 'cropSeason' | 'dosedMap'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, dosedMap?: Maybe<ResolversParentTypes['DosedMap']> };
  SprayingNutrient: SprayingNutrient;
  SprayingV2: Omit<SprayingV2, 'assignee' | 'availableDosedMaps' | 'cropSeason' | 'cropSeasonV2' | 'dosedMap' | 'hortaSpraying'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, availableDosedMaps?: Maybe<Array<ResolversParentTypes['AvailableDosedMap']>>, cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']>, dosedMap?: Maybe<ResolversParentTypes['DosedMap']>, hortaSpraying?: Maybe<ResolversParentTypes['HortaSpraying']> };
  SprayingWindow: SprayingWindow;
  StacFarmStatistics: StacFarmStatistics;
  StacHistogram: StacHistogram;
  StacItemRender: Omit<StacItemRender, 'cropSeason' | 'field' | 'source'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, field: ResolversParentTypes['FieldV2'], source?: Maybe<ResolversParentTypes['StacItemRenderSource']> };
  StacItemRenderSource: ResolversUnionTypes<ResolversParentTypes>['StacItemRenderSource'];
  StacItemVectorizeGeometry: StacItemVectorizeGeometry;
  StacLegend: StacLegend;
  StacMosaicRender: StacMosaicRender;
  StacStatistics: StacStatistics;
  Statistic: Statistic;
  StirObject: StirObject;
  StirOperation: StirOperation;
  Stress: Stress;
  StressAnswer: StressAnswer;
  StressEfficacyCharacteristics: Omit<StressEfficacyCharacteristics, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  StressQuestion: Omit<StressQuestion, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  StressRisk: StressRisk;
  StressSetting: StressSetting;
  StressSettings: Omit<StressSettings, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  StressV2: StressV2;
  String: Scalars['String']['output'];
  Subscription: Record<PropertyKey, never>;
  SubscriptionPreference: Omit<SubscriptionPreference, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  SubscriptionPreferenceFarm: SubscriptionPreferenceFarm;
  SubstanceApplicationRate: SubstanceApplicationRate;
  SubstanceRateV2: SubstanceRateV2;
  SupportedTaskType: SupportedTaskType;
  SustainabilityIndicator: Omit<SustainabilityIndicator, 'co2EquivalentFootprint' | 'cropSeason' | 'nitrogenFootprint' | 'waterFootprint'> & { co2EquivalentFootprint?: Maybe<ResolversParentTypes['Footprint']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, nitrogenFootprint?: Maybe<ResolversParentTypes['Footprint']>, waterFootprint?: Maybe<ResolversParentTypes['Footprint']> };
  SustainabilityInput: Omit<SustainabilityInput, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  SustainabilityOrganisationCapability: Omit<SustainabilityOrganisationCapability, 'organisation'> & { organisation?: Maybe<ResolversParentTypes['Organisation']> };
  SustainabilityOrganisationCapabilitySort: SustainabilityOrganisationCapabilitySort;
  SustainabilityProgram: Omit<SustainabilityProgram, 'crops' | 'measureSubmissionOrders'> & { crops?: Maybe<Array<Maybe<ResolversParentTypes['Crop']>>>, measureSubmissionOrders?: Maybe<Array<Maybe<ResolversParentTypes['MeasureSubmissionOrder']>>> };
  SustainabilityProgramBranchAssignment: Omit<SustainabilityProgramBranchAssignment, 'branchAddress' | 'organisationAddress' | 'organisationBranch' | 'sustainabilityProgram'> & { branchAddress?: Maybe<ResolversParentTypes['Address']>, organisationAddress?: Maybe<ResolversParentTypes['Address']>, organisationBranch?: Maybe<ResolversParentTypes['OrganisationBranch']>, sustainabilityProgram?: Maybe<ResolversParentTypes['SustainabilityProgram']> };
  SustainabilityProgramBranchAssignmentSort: SustainabilityProgramBranchAssignmentSort;
  SustainabilityProgramEnrolledField: SustainabilityProgramEnrolledField;
  SustainabilityProgramEnrolledSort: SustainabilityProgramEnrolledSort;
  SustainabilityProgramInvitation: Omit<SustainabilityProgramInvitation, 'sustainabilityProgram'> & { sustainabilityProgram?: Maybe<ResolversParentTypes['SustainabilityProgram']> };
  SustainabilityProgramInvitationSort: SustainabilityProgramInvitationSort;
  SustainabilityProgramNamedRef: SustainabilityProgramNamedRef;
  SustainabilityProgramOrganisationParticipation: Omit<SustainabilityProgramOrganisationParticipation, 'branchAddress' | 'organisationAddress'> & { branchAddress?: Maybe<ResolversParentTypes['Address']>, organisationAddress?: Maybe<ResolversParentTypes['Address']> };
  SustainabilityProgramOrganisationParticipationSort: SustainabilityProgramOrganisationParticipationSort;
  SustainabilityProgramSort: SustainabilityProgramSort;
  SustainabilityProgramStaffMember: Omit<SustainabilityProgramStaffMember, 'sustainabilityProgram' | 'user'> & { sustainabilityProgram?: Maybe<ResolversParentTypes['SustainabilityProgram']>, user?: Maybe<ResolversParentTypes['User']> };
  TDiskAssignment: TDiskAssignment;
  TDiskOperation: TDiskOperation;
  TargetWeed: TargetWeed;
  Task: Task;
  TaskAggregation: Omit<TaskAggregation, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  TaskMethod: TaskMethod;
  TaskSort: TaskSort;
  TaskSummary: Omit<TaskSummary, 'farm'> & { farm?: Maybe<ResolversParentTypes['FarmV2']> };
  TaskSummaryDetail: TaskSummaryDetail;
  Tenant: Tenant;
  TillageSystem: TillageSystem;
  Tillages: Tillages;
  TimingCalculationStatus: Omit<TimingCalculationStatus, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  TimingLimitationV2: Omit<TimingLimitationV2, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  TimingLimitationsV2Input: TimingLimitationsV2Input;
  TimingProductRecommendation: Omit<TimingProductRecommendation, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  TimingProductRecommendationGroupDoseRate: Omit<TimingProductRecommendationGroupDoseRate, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  TimingProductRecommendationGroupRecipe: Omit<TimingProductRecommendationGroupRecipe, 'doseRates'> & { doseRates?: Maybe<Array<Maybe<ResolversParentTypes['TimingProductRecommendationGroupDoseRate']>>> };
  TimingProductRecommendationRecipe: TimingProductRecommendationRecipe;
  TimingProductRecommendationStressEfficacy: TimingProductRecommendationStressEfficacy;
  TimingProductRecommendationsGroup: Omit<TimingProductRecommendationsGroup, 'cropSeasons' | 'recipe'> & { cropSeasons?: Maybe<Array<Maybe<ResolversParentTypes['CropSeasonV2']>>>, recipe?: Maybe<Array<Maybe<ResolversParentTypes['TimingProductRecommendationGroupRecipe']>>> };
  TimingStressInfo: Omit<TimingStressInfo, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  ToppingTask: Omit<ToppingTask, 'assignee' | 'cropSeason'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  TotalNutrients: TotalNutrients;
  TotalNutrientsDelta: TotalNutrientsDelta;
  TotalProducts: TotalProducts;
  Tramline: Omit<Tramline, 'abLine' | 'fieldV2'> & { abLine?: Maybe<ResolversParentTypes['AbLine']>, fieldV2: ResolversParentTypes['FieldV2'] };
  TranslationId: Scalars['TranslationId']['output'];
  TreatmentProduct: TreatmentProduct;
  TreatmentProgramAction: TreatmentProgramAction;
  TreatmentProgramActionWindow: TreatmentProgramActionWindow;
  TreatmentProgramActionWindowTask: TreatmentProgramActionWindowTask;
  TreatmentReason: TreatmentReason;
  TreatmentScenario: Omit<TreatmentScenario, 'farm'> & { farm?: Maybe<ResolversParentTypes['FarmV2']> };
  Trial: Omit<Trial, 'assessmentTimings' | 'cropSeason' | 'fieldZones' | 'fieldZonesWithoutOrder' | 'scoutingTasks'> & { assessmentTimings?: Maybe<Array<Maybe<ResolversParentTypes['AssessmentTiming']>>>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, fieldZones?: Maybe<Array<Maybe<ResolversParentTypes['FieldZone']>>>, fieldZonesWithoutOrder?: Maybe<Array<Maybe<ResolversParentTypes['FieldZone']>>>, scoutingTasks?: Maybe<Array<Maybe<ResolversParentTypes['ScoutingTask']>>> };
  TrialDisabledReplicate: TrialDisabledReplicate;
  TrialV2: Omit<TrialV2, 'assessmentTimings' | 'cropSeason' | 'fieldZones' | 'fieldZonesWithoutOrder' | 'scoutingTasks'> & { assessmentTimings?: Maybe<Array<Maybe<ResolversParentTypes['AssessmentTiming']>>>, cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, fieldZones?: Maybe<Array<Maybe<ResolversParentTypes['FieldZone']>>>, fieldZonesWithoutOrder?: Maybe<Array<Maybe<ResolversParentTypes['FieldZone']>>>, scoutingTasks?: Maybe<Array<Maybe<ResolversParentTypes['ScoutingTask']>>> };
  TrialV2Sort: TrialV2Sort;
  UUID: Scalars['UUID']['output'];
  UploadDatasetSummary: UploadDatasetSummary;
  UploadDatasetTotal: UploadDatasetTotal;
  User: Omit<User, 'hfOffers' | 'userPackages'> & { hfOffers?: Maybe<Array<Maybe<ResolversParentTypes['HfOffer']>>>, userPackages?: Maybe<Array<Maybe<ResolversParentTypes['UserPackage']>>> };
  UserDataVsValidationComparison: UserDataVsValidationComparison;
  UserDevice: Omit<UserDevice, 'features' | 'user'> & { features?: Maybe<Array<Maybe<ResolversParentTypes['DeviceFeature']>>>, user?: Maybe<ResolversParentTypes['User']> };
  UserFarmPackage: Omit<UserFarmPackage, 'farmV2'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  UserFeature: Omit<UserFeature, 'crop'> & { crop?: Maybe<ResolversParentTypes['Crop']> };
  UserGroup: Omit<UserGroup, 'user'> & { user: ResolversParentTypes['User'] };
  UserLicenseRequest: Omit<UserLicenseRequest, 'creatorUser' | 'lastModifierUser' | 'organisation' | 'organisationMemberUser' | 'user'> & { creatorUser?: Maybe<ResolversParentTypes['User']>, lastModifierUser?: Maybe<ResolversParentTypes['User']>, organisation?: Maybe<ResolversParentTypes['Organisation']>, organisationMemberUser?: Maybe<ResolversParentTypes['User']>, user?: Maybe<ResolversParentTypes['User']> };
  UserNotification: Omit<UserNotification, 'cropSeason' | 'farm' | 'payloadData' | 'user'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']>, farm?: Maybe<ResolversParentTypes['FarmV2']>, payloadData?: Maybe<ResolversParentTypes['PayloadData']>, user?: Maybe<ResolversParentTypes['User']> };
  UserPackage: Omit<UserPackage, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  UserSetting: UserSetting;
  ValueCode: ValueCode;
  Variety: Omit<Variety, 'crop' | 'farm'> & { crop?: Maybe<ResolversParentTypes['Crop']>, farm?: Maybe<ResolversParentTypes['FarmV2']> };
  VarietyCharacteristic: VarietyCharacteristic;
  VarietyRanking: Omit<VarietyRanking, 'variety'> & { variety?: Maybe<ResolversParentTypes['Variety']> };
  VarietyRecommendation: Omit<VarietyRecommendation, 'field' | 'varietyRankings'> & { field?: Maybe<ResolversParentTypes['FieldV2']>, varietyRankings?: Maybe<Array<Maybe<ResolversParentTypes['VarietyRanking']>>> };
  VendorDeviceBlacklistEntry: Omit<VendorDeviceBlacklistEntry, 'device'> & { device?: Maybe<ResolversParentTypes['DtnVendorDevice']> };
  VendorDeviceDataAnomaly: Omit<VendorDeviceDataAnomaly, 'device'> & { device?: Maybe<ResolversParentTypes['DtnVendorDevice']> };
  VendorDeviceDataMissing: Omit<VendorDeviceDataMissing, 'device'> & { device?: Maybe<ResolversParentTypes['DtnVendorDevice']> };
  VendorDeviceInfo: Omit<VendorDeviceInfo, 'vendorDevice'> & { vendorDevice?: Maybe<ResolversParentTypes['DtnVendorDevice']> };
  VendorDeviceSensorStatus: Omit<VendorDeviceSensorStatus, 'device'> & { device?: Maybe<ResolversParentTypes['DtnVendorDevice']> };
  VendorDeviceStatus: Omit<VendorDeviceStatus, 'device'> & { device?: Maybe<ResolversParentTypes['DtnVendorDevice']> };
  WaterBalance: Omit<WaterBalance, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  WaterManagementScenario: WaterManagementScenario;
  WaterManagementTask: Omit<WaterManagementTask, 'assignee' | 'cropSeasonV2'> & { assignee?: Maybe<ResolversParentTypes['Collaborator']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  WaterRecommendation: Omit<WaterRecommendation, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  WaterStatus: Omit<WaterStatus, 'cropSeasonV2'> & { cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  Weather: Weather;
  WeatherUserData: WeatherUserData;
  WeatherV2: WeatherV2;
  Weed: Weed;
  WeedManagementProgramRecommendation: WeedManagementProgramRecommendation;
  WeedManagementProgramRecommendationV3: WeedManagementProgramRecommendationV3;
  WeedManagementRecommendation: Omit<WeedManagementRecommendation, 'cropSeason' | 'cropSeasonV2'> & { cropSeason: ResolversParentTypes['CropSeason'], cropSeasonV2: ResolversParentTypes['CropSeasonV2'] };
  WeedRecord: WeedRecord;
  WeedRisk: Omit<WeedRisk, 'cropSeason' | 'cropSeasonV2'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeason']>, cropSeasonV2?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  WeedStatus: Omit<WeedStatus, 'cropSeason'> & { cropSeason: ResolversParentTypes['CropSeasonV2'] };
  WeeklySeedingRecommendation: WeeklySeedingRecommendation;
  WfsParameters: WfsParameters;
  WiuzConnectionStatus: WiuzConnectionStatus;
  WiuzUserFarm: Omit<WiuzUserFarm, 'farmV2'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']> };
  WiuzUserfarmImportOrder: Omit<WiuzUserfarmImportOrder, 'farmV2' | 'user'> & { farmV2?: Maybe<ResolversParentTypes['FarmV2']>, user?: Maybe<ResolversParentTypes['User']> };
  WmsParameters: WmsParameters;
  YellowTrapResult: YellowTrapResult;
  YieldPrediction: Omit<YieldPrediction, 'cropSeason'> & { cropSeason?: Maybe<ResolversParentTypes['CropSeasonV2']> };
  YieldScenario: YieldScenario;
  ZonePercentageDifference: ZonePercentageDifference;
  ZoneRateV2: ZoneRateV2;
  ZoneStatisticsItem: ZoneStatisticsItem;
  ZoneStrategy: ZoneStrategy;
  ZonesToSamplingAreaMapping: ZonesToSamplingAreaMapping;
}>;

export type CalculatedThingDirectiveArgs = {
  parentUuidFieldName?: Maybe<Scalars['String']['input']>;
  singleton: Scalars['Boolean']['input'];
};

export type CalculatedThingDirectiveResolver<Result, Parent, ContextType = GraphqlContext, Args = CalculatedThingDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type DeferDirectiveArgs = {
  if?: Scalars['Boolean']['input'];
  label?: Maybe<Scalars['String']['input']>;
};

export type DeferDirectiveResolver<Result, Parent, ContextType = GraphqlContext, Args = DeferDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Experimental_DisableErrorPropagationDirectiveArgs = { };

export type Experimental_DisableErrorPropagationDirectiveResolver<Result, Parent, ContextType = GraphqlContext, Args = Experimental_DisableErrorPropagationDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AbLineResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AbLine'] = ResolversParentTypes['AbLine']> = ResolversObject<{
  createdDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  geometry?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ActionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Action'] = ResolversParentTypes['Action']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['ActionCode']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  labelKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionDetailType']>, ParentType, ContextType>;
}>;

export type ActionDateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionDate'] = ResolversParentTypes['ActionDate']> = ResolversObject<{
  calendarDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  daysAfterPrevious?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  daysAfterSeeding?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  growthStageIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growthStageScale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionDateType']>, ParentType, ContextType>;
}>;

export type ActionDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionDetail'] = ResolversParentTypes['ActionDetail']> = ResolversObject<{
  action?: Resolver<Maybe<ResolversTypes['Action']>, ParentType, ContextType>;
  additives?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetailAdditive']>>>, ParentType, ContextType>;
  applicationSpots?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationSpot']>>>, ParentType, ContextType, Partial<ActionDetailApplicationSpotsArgs>>;
  applicationTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProgramApplicationType']>>>, ParentType, ContextType>;
  maxTotalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minTotalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetailProduct']>>>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionDetailType']>, ParentType, ContextType>;
  typeIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
}>;

export type ActionDetailAdditiveResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionDetailAdditive'] = ResolversParentTypes['ActionDetailAdditive']> = ResolversObject<{
  applicationRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
}>;

export type ActionDetailProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionDetailProduct'] = ResolversParentTypes['ActionDetailProduct']> = ResolversObject<{
  applicationRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
}>;

export type ActionDetailTankMixResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionDetailTankMix'] = ResolversParentTypes['ActionDetailTankMix']> = ResolversObject<{
  additives?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetailAdditive']>>>, ParentType, ContextType>;
  applicationSpot?: Resolver<Maybe<ResolversTypes['ApplicationSpot']>, ParentType, ContextType, Partial<ActionDetailTankMixApplicationSpotArgs>>;
  applicationSpots?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationSpot']>>>, ParentType, ContextType, Partial<ActionDetailTankMixApplicationSpotsArgs>>;
  applicationTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProgramApplicationType']>>>, ParentType, ContextType>;
  maxTotalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minTotalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetailProduct']>>>, ParentType, ContextType>;
  tankNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  taskMethod?: Resolver<Maybe<ResolversTypes['TaskMethod']>, ParentType, ContextType, Partial<ActionDetailTankMixTaskMethodArgs>>;
  totalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
}>;

export type ActionDetailV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionDetailV2'] = ResolversParentTypes['ActionDetailV2']> = ResolversObject<{
  action?: Resolver<Maybe<ResolversTypes['Action']>, ParentType, ContextType>;
  additionalNoticeKeys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  tankMixes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetailTankMix']>>>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionDetailType']>, ParentType, ContextType>;
}>;

export type ActionRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionRecommendation'] = ResolversParentTypes['ActionRecommendation']> = ResolversObject<{
  actionType?: Resolver<Maybe<ResolversTypes['ActionType']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  confidenceLevel?: Resolver<Maybe<ResolversTypes['ConfidenceLevel']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionRecommendationReason']>>>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ActionRecommendationStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionType']>, ParentType, ContextType>;
}>;

export type ActionRecommendationAggregationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionRecommendationAggregation'] = ResolversParentTypes['ActionRecommendationAggregation']> = ResolversObject<{
  actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionRecommendationAggregationAction']>>>, ParentType, ContextType>;
  aggregatedStatus?: Resolver<Maybe<ResolversTypes['ActionRecommendationAggregationStatus']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
}>;

export type ActionRecommendationAggregationActionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionRecommendationAggregationAction'] = ResolversParentTypes['ActionRecommendationAggregationAction']> = ResolversObject<{
  status?: Resolver<Maybe<ResolversTypes['ActionRecommendationAggregationStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionRecommendationType']>, ParentType, ContextType>;
}>;

export type ActionWindowResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActionWindow'] = ResolversParentTypes['ActionWindow']> = ResolversObject<{
  actionType?: Resolver<ResolversTypes['ActionWindowType'], ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ActionWindowStatus'], ParentType, ContextType>;
  windowEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  windowStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type ActiveIngredientResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ActiveIngredient'] = ResolversParentTypes['ActiveIngredient']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AdditionalInfectionRiskFactorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AdditionalInfectionRiskFactor'] = ResolversParentTypes['AdditionalInfectionRiskFactor']> = ResolversObject<{
  additionalInfectionRiskFactor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AdditiveRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AdditiveRate'] = ResolversParentTypes['AdditiveRate']> = ResolversObject<{
  rates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type AddressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provinceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type AgBalanceFieldEmissionIndicatorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AgBalanceFieldEmissionIndicator'] = ResolversParentTypes['AgBalanceFieldEmissionIndicator']> = ResolversObject<{
  calculationDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  carbonFarmingSeason?: Resolver<Maybe<ResolversTypes['CarbonFarmingSeason']>, ParentType, ContextType>;
  ch4FieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  co2EnergyFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  directCO2MineralFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  directN2OMineralFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  directN2OOrganicFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  directN2OResiduesFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  indirectN2OMineralFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  indirectN2OOrganicFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  indirectN2OResiduesFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  issues?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgBalanceFieldEmissionIndicatorIssue']>>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AgBalanceFieldEmissionIndicatorStatus'], ParentType, ContextType>;
  totalFieldEmission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type AgBalanceFieldEmissionIndicatorIssueResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AgBalanceFieldEmissionIndicatorIssue'] = ResolversParentTypes['AgBalanceFieldEmissionIndicatorIssue']> = ResolversObject<{
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['AgBalanceFieldEmissionIndicatorIssueSeverity'], ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type AgBalanceFieldInputResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AgBalanceFieldInput'] = ResolversParentTypes['AgBalanceFieldInput']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilDrainageClassCode?: Resolver<Maybe<ResolversTypes['SoilDrainageClass']>, ParentType, ContextType>;
  soilDrainageClassUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AggregatedNotificationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AggregatedNotification'] = ResolversParentTypes['AggregatedNotification']> = ResolversObject<{
  aggregationFromDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  aggregationTillDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newestNotificationTimestamp?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['AggregatedNotificationPayload']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type AggregatedNotificationPayloadResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AggregatedNotificationPayload'] = ResolversParentTypes['AggregatedNotificationPayload']> = ResolversObject<{
  cropSeasonUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  farms?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmV2']>>>, ParentType, ContextType>;
  fieldDataLayerUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  fieldUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  flightTaskUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  nutritionProgramUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  optimalDates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Date']>>>, ParentType, ContextType>;
  scoutingTaskUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  scoutingTypeByTaskUuid?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  seedBoxTreatmentTaskUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  seedTreatmentTaskUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  seedingTaskUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  sprayingUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  stressUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['NotificationType']>, ParentType, ContextType>;
  usersUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
}>;

export type AggregatedPestDevelopmentPredictionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AggregatedPestDevelopmentPrediction'] = ResolversParentTypes['AggregatedPestDevelopmentPrediction']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  developmentStage?: Resolver<Maybe<ResolversTypes['DevelopmentStage']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mainGeneration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<AggregatedPestDevelopmentPredictionStressArgs>>;
}>;

export type AggregatedRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AggregatedRisk'] = ResolversParentTypes['AggregatedRisk']> = ResolversObject<{
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type AnalyticsCollectionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AnalyticsCollection'] = ResolversParentTypes['AnalyticsCollection']> = ResolversObject<{
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  fieldDataLayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnalyticsCollectionFieldDataLayer']>>>, ParentType, ContextType>;
  fieldNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, ParentType, ContextType>;
  fieldZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, ParentType, ContextType>;
  isPrivate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mapItemMagnitudes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnalyticsCollectionMapItemMagnitude']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AnalyticsCollectionType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AnalyticsCollectionFieldDataLayerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AnalyticsCollectionFieldDataLayer'] = ResolversParentTypes['AnalyticsCollectionFieldDataLayer']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldDataLayer?: Resolver<Maybe<ResolversTypes['FieldDataLayer']>, ParentType, ContextType>;
  magnitudeType?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  maxElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingType?: Resolver<Maybe<ResolversTypes['ProcessingType']>, ParentType, ContextType>;
}>;

export type AnalyticsCollectionMapItemMagnitudeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AnalyticsCollectionMapItemMagnitude'] = ResolversParentTypes['AnalyticsCollectionMapItemMagnitude']> = ResolversObject<{
  fieldDataLayerMagnitude?: Resolver<Maybe<ResolversTypes['AnalyticsCollectionFieldDataLayer']>, ParentType, ContextType>;
  mapType?: Resolver<ResolversTypes['MapItemType'], ParentType, ContextType>;
  stacItemMagnitude?: Resolver<Maybe<ResolversTypes['AnalyticsCollectionStacItem']>, ParentType, ContextType>;
}>;

export type AnalyticsCollectionStacItemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AnalyticsCollectionStacItem'] = ResolversParentTypes['AnalyticsCollectionStacItem']> = ResolversObject<{
  stacFieldDataLayerType?: Resolver<ResolversTypes['StacFieldDataLayer'], ParentType, ContextType>;
  stacItemRender?: Resolver<Maybe<ResolversTypes['StacItemRender']>, ParentType, ContextType>;
  stacMagnitudeType?: Resolver<ResolversTypes['StacMagnitudeType'], ParentType, ContextType>;
}>;

export type AnomalyHistoryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AnomalyHistory'] = ResolversParentTypes['AnomalyHistory']> = ResolversObject<{
  qcCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDatetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  wx3QcCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type AnomalyVariableInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AnomalyVariableInfo'] = ResolversParentTypes['AnomalyVariableInfo']> = ResolversObject<{
  anomalyHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnomalyHistory']>>>, ParentType, ContextType>;
  variableName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wasEverAnomaly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type AppConfigResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AppConfig'] = ResolversParentTypes['AppConfig']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectType?: Resolver<Maybe<ResolversTypes['AppConfigObjectType']>, ParentType, ContextType>;
  requiresFunctionality?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['AppConfigValue']>, ParentType, ContextType>;
}>;

export interface AppConfigValueScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AppConfigValue'], any> {
  name: 'AppConfigValue';
}

export type ApplicableColumnResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicableColumn'] = ResolversParentTypes['ApplicableColumn']> = ResolversObject<{
  bestGuess?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  indices?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
}>;

export type ApplicableStressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicableStress'] = ResolversParentTypes['ApplicableStress']> = ResolversObject<{
  assessmentObjectUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  units?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
}>;

export type ApplicableUnitResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicableUnit'] = ResolversParentTypes['ApplicableUnit']> = ResolversObject<{
  bestGuess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
}>;

export type ApplicationFieldZoneResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicationFieldZone'] = ResolversParentTypes['ApplicationFieldZone']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fieldZoneUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fixedMixtureRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ApplicationMapZoneResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicationMapZone'] = ResolversParentTypes['ApplicationMapZone']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  zoneId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ApplicationRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicationRecommendation'] = ResolversParentTypes['ApplicationRecommendation']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  recommendedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ApplicationRecommendationStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ApplicationRecommendationType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ApplicationSpotResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicationSpot'] = ResolversParentTypes['ApplicationSpot']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ApplicationWindowResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicationWindow'] = ResolversParentTypes['ApplicationWindow']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  executionStatus?: Resolver<Maybe<ResolversTypes['ApplicationWindowStatus']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ApplicationWindowType']>, ParentType, ContextType>;
}>;

export type ApplicationZoneResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ApplicationZone'] = ResolversParentTypes['ApplicationZone']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['ApplicationCategory']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ArableApiKeyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArableApiKey'] = ResolversParentTypes['ArableApiKey']> = ResolversObject<{
  apiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ArableDeviceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArableDevice'] = ResolversParentTypes['ArableDevice']> = ResolversObject<{
  arableDeviceToLocations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArableDeviceToLocation']>>>, ParentType, ContextType>;
  batteryPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  elevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastPost?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  latestMeasurement?: Resolver<Maybe<ResolversTypes['ArableDeviceLatestMeasurement']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  locationType?: Resolver<Maybe<ResolversTypes['LocationType']>, ParentType, ContextType>;
  locationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signalStrength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ArableDeviceLatestMeasurementResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArableDeviceLatestMeasurement'] = ResolversParentTypes['ArableDeviceLatestMeasurement']> = ResolversObject<{
  device?: Resolver<ResolversTypes['ArableDevice'], ParentType, ContextType>;
  humidity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  precipitation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  solarRadiation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  windDirection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windSpeed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ArableDeviceToLocationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArableDeviceToLocation'] = ResolversParentTypes['ArableDeviceToLocation']> = ResolversObject<{
  device?: Resolver<ResolversTypes['ArableDevice'], ParentType, ContextType>;
  fromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  locationAccessible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locationType?: Resolver<ResolversTypes['LocationType'], ParentType, ContextType>;
  locationUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tillDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ArvalisCalculationBasisResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArvalisCalculationBasis'] = ResolversParentTypes['ArvalisCalculationBasis']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  isRisksBasedOnDefaultVarietyCharacteristics?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type ArvalisCustomEfficacyInformationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArvalisCustomEfficacyInformation'] = ResolversParentTypes['ArvalisCustomEfficacyInformation']> = ResolversObject<{
  customProtectionDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dosedMap?: Resolver<Maybe<ResolversTypes['DosedMap']>, ParentType, ContextType>;
}>;

export type ArvalisDeviceToCropSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArvalisDeviceToCropSeason'] = ResolversParentTypes['ArvalisDeviceToCropSeason']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  health?: Resolver<Maybe<ResolversTypes['DeviceHealthStatus']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['ArvalisDeviceProviderType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ArvalisInformationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ArvalisInformation'] = ResolversParentTypes['ArvalisInformation']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  visioFarmLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type AssessmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Assessment'] = ResolversParentTypes['Assessment']> = ResolversObject<{
  assessmentData?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssessmentData']>>>, ParentType, ContextType>;
  assessmentTimingUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  assessmentTypeUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  denominatorUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  displayUnit?: Resolver<Maybe<ResolversTypes['MdUnit']>, ParentType, ContextType, Partial<AssessmentDisplayUnitArgs>>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  numberOfSubSamples?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numeratorUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sampleSizeUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sampleSizeValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  stressV2?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<AssessmentStressV2Args>>;
  trialUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AssessmentAttachmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AssessmentAttachment'] = ResolversParentTypes['AssessmentAttachment']> = ResolversObject<{
  assessmentNote?: Resolver<ResolversTypes['AssessmentNote'], ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AssessmentDataResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AssessmentData'] = ResolversParentTypes['AssessmentData']> = ResolversObject<{
  actualCreatedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  actualModifiedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  assessmentUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factorLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fieldZone?: Resolver<Maybe<ResolversTypes['FieldZone']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  replicate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subsample?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type AssessmentNoteResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AssessmentNote'] = ResolversParentTypes['AssessmentNote']> = ResolversObject<{
  assessment?: Resolver<Maybe<ResolversTypes['Assessment']>, ParentType, ContextType>;
  assessmentAttachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssessmentAttachment']>>>, ParentType, ContextType>;
  assessmentTiming?: Resolver<ResolversTypes['AssessmentTiming'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factorLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fieldZone?: Resolver<Maybe<ResolversTypes['FieldZone']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  replicate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subsample?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AssessmentTimingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AssessmentTiming'] = ResolversParentTypes['AssessmentTiming']> = ResolversObject<{
  assessmentEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  assessmentNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssessmentNote']>>>, ParentType, ContextType>;
  assessmentStartDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  assessments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Assessment']>>>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropGrowthStageMajorIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropGrowthStageMaxIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropGrowthStageMinIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropGrowthStageScale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoutingTask?: Resolver<Maybe<ResolversTypes['ScoutingTask']>, ParentType, ContextType>;
  trialUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type AvailableDosedMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AvailableDosedMap'] = ResolversParentTypes['AvailableDosedMap']> = ResolversObject<{
  dosedMap?: Resolver<ResolversTypes['DosedMap'], ParentType, ContextType>;
  equipmentType?: Resolver<ResolversTypes['DosedMapEquipmentType'], ParentType, ContextType>;
}>;

export type AvailablePackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['AvailablePackage'] = ResolversParentTypes['AvailablePackage']> = ResolversObject<{
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  farmSpecialisedUsageType?: Resolver<Maybe<ResolversTypes['SpecialisedUsageType']>, ParentType, ContextType>;
  farmType?: Resolver<Maybe<ResolversTypes['FarmType']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['FeatureName']>>>, ParentType, ContextType>;
  package?: Resolver<ResolversTypes['Package'], ParentType, ContextType>;
  packageUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tenantUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type BbchScaleResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BBCHScale'] = ResolversParentTypes['BBCHScale']> = ResolversObject<{
  growthStageIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  growthStageScale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type BagCountResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BagCount'] = ResolversParentTypes['BagCount']> = ResolversObject<{
  mdBagUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  totalApplication?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalBagCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['BagUnit']>, ParentType, ContextType>;
}>;

export type BaseEntityAuditingTypeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BaseEntityAuditingType'] = ResolversParentTypes['BaseEntityAuditingType']> = ResolversObject<{
  __resolveType: TypeResolveFn<'FarmEvidenceLink' | 'FieldEvidenceLink' | 'ScaleTicket' | 'ScaleTicketBooking' | 'ScaleTicketBookingDispute' | 'ScaleTicketDataMapping' | 'ScaleTicketHistory' | 'ScaleTicketSellerMapping' | 'ScaleTicketUpload' | 'ScaleTicketUploadSummary' | 'SustainabilityOrganisationCapability' | 'SustainabilityProgram' | 'SustainabilityProgramBranchAssignment' | 'SustainabilityProgramInvitation' | 'SustainabilityProgramOrganisationParticipation' | 'SustainabilityProgramStaffMember', ParentType, ContextType>;
}>;

export type BeforeSeasonRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BeforeSeasonRisk'] = ResolversParentTypes['BeforeSeasonRisk']> = ResolversObject<{
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  stressRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressRisk']>>>, ParentType, ContextType>;
}>;

export type BillingAddressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BillingAddress'] = ResolversParentTypes['BillingAddress']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type BiodiversityIndicatorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BiodiversityIndicator'] = ResolversParentTypes['BiodiversityIndicator']> = ResolversObject<{
  benchmarkBiodiversityScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  biodiversityScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  biodiversityScoreMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  biodiversityScoreMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  speciesLoss?: Resolver<Maybe<ResolversTypes['SpeciesLossType']>, ParentType, ContextType>;
  speciesLossTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
}>;

export type BiomassAnalysisNdviResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BiomassAnalysisNdvi'] = ResolversParentTypes['BiomassAnalysisNdvi']> = ResolversObject<{
  acquisitionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  boundaryChecksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  dynamicZones?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  s3CoverageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  satImageResolution?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  zone?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  zones?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
}>;

export type BlacklistVariableInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BlacklistVariableInfo'] = ResolversParentTypes['BlacklistVariableInfo']> = ResolversObject<{
  disabledHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['DisabledHistory']>>>, ParentType, ContextType>;
  variableName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wasEverDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type BufferZonesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BufferZones'] = ResolversParentTypes['BufferZones']> = ResolversObject<{
  applicationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  driftReductionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type BusinessLineLicenseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BusinessLineLicense'] = ResolversParentTypes['BusinessLineLicense']> = ResolversObject<{
  assignmentDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  licenseUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  quotaPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessLineLicensePackageQuota']>>>, ParentType, ContextType>;
}>;

export type BusinessLineLicensePackageQuotaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BusinessLineLicensePackageQuota'] = ResolversParentTypes['BusinessLineLicensePackageQuota']> = ResolversObject<{
  packageUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  quota?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  usedQuota?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type BusinessLinePurchaseAggregationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['BusinessLinePurchaseAggregation'] = ResolversParentTypes['BusinessLinePurchaseAggregation']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  licenses?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessLineLicense']>>>, ParentType, ContextType>;
  sourceType?: Resolver<ResolversTypes['BusinessLinePurchaseSourceType'], ParentType, ContextType>;
  sourceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
}>;

export type CarbonCreditResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CarbonCredit'] = ResolversParentTypes['CarbonCredit']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  carbonFarmingSeason?: Resolver<ResolversTypes['CarbonFarmingSeason'], ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  nonReversibleCarbonCredits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reportingInformationEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  reportingInformationStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  reversibleCarbonCredits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCarbonCredits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type CarbonFarmingRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CarbonFarmingRequest'] = ResolversParentTypes['CarbonFarmingRequest']> = ResolversObject<{
  carbonFarmingSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonFarmingSeason']>>>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  firstInterventionYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CarbonFarmingRequestStatus'], ParentType, ContextType>;
  sustainabilityProgram?: Resolver<Maybe<ResolversTypes['SustainabilityProgram']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CarbonFarmingSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CarbonFarmingSeason'] = ResolversParentTypes['CarbonFarmingSeason']> = ResolversObject<{
  bonusPayoutFactor?: Resolver<Maybe<ResolversTypes['BonusPayoutFactor']>, ParentType, ContextType>;
  bonusPayoutFactorOverride?: Resolver<Maybe<ResolversTypes['BonusPayoutFactor']>, ParentType, ContextType>;
  carbonCredits?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonCredit']>>>, ParentType, ContextType>;
  carbonFarmingRequestUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditEligibilities?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditEligibility']>>>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  greetCarbonIntensityScore?: Resolver<Maybe<ResolversTypes['GreetCarbonIntensityScore']>, ParentType, ContextType>;
  interventions?: Resolver<Maybe<Array<Maybe<ResolversTypes['FulfilledIntervention']>>>, ParentType, ContextType>;
  isConflictBetweenUserDataAndValidation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signupDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CarbonFarmingSeasonStatus'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CarbonIntensityIndicatorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CarbonIntensityIndicator'] = ResolversParentTypes['CarbonIntensityIndicator']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  carbonFarmingSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  issues?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonIntensityIndicatorIssue']>>>, ParentType, ContextType>;
  nationalAverageScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resolvedTillagePractice?: Resolver<Maybe<ResolversTypes['CarbonIntensityIndicatorTillagePractice']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CarbonIntensityIndicatorStatus'], ParentType, ContextType>;
  totalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type CarbonIntensityIndicatorIssueResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CarbonIntensityIndicatorIssue'] = ResolversParentTypes['CarbonIntensityIndicatorIssue']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['CarbonIntensityIndicatorIssueSeverity'], ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CarbonPlausibilityCommentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CarbonPlausibilityComment'] = ResolversParentTypes['CarbonPlausibilityComment']> = ResolversObject<{
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CarbonRelatedDataTillageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CarbonRelatedDataTillage'] = ResolversParentTypes['CarbonRelatedDataTillage']> = ResolversObject<{
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CategoryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Category'] = ResolversParentTypes['Category']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ClaasConnectStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ClaasConnectStatus'] = ResolversParentTypes['ClaasConnectStatus']> = ResolversObject<{
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ClaasFarmResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ClaasFarm'] = ResolversParentTypes['ClaasFarm']> = ResolversObject<{
  claasFarmId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  claasFarmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ClaasFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ClaasField'] = ResolversParentTypes['ClaasField']> = ResolversObject<{
  alreadyImported?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  claasFieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  claasFieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  hasValidBoundary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type ClaasOrganizationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ClaasOrganization'] = ResolversParentTypes['ClaasOrganization']> = ResolversObject<{
  claasOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  claasOrganizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ClaimAttachmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ClaimAttachment'] = ResolversParentTypes['ClaimAttachment']> = ResolversObject<{
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type ClaimCategoryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ClaimCategory'] = ResolversParentTypes['ClaimCategory']> = ResolversObject<{
  category?: Resolver<Maybe<ResolversTypes['HfClaimCategory']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ClaimEvaluationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ClaimEvaluation'] = ResolversParentTypes['ClaimEvaluation']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['ClaimAttachment']>>>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type CnhCompanyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CnhCompany'] = ResolversParentTypes['CnhCompany']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type CnhFarmResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CnhFarm'] = ResolversParentTypes['CnhFarm']> = ResolversObject<{
  cnhCompany?: Resolver<Maybe<ResolversTypes['CnhCompany']>, ParentType, ContextType>;
  cnhGrower?: Resolver<Maybe<ResolversTypes['CnhGrower']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CnhFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CnhField'] = ResolversParentTypes['CnhField']> = ResolversObject<{
  alreadyImported?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cnhCompany?: Resolver<Maybe<ResolversTypes['CnhCompany']>, ParentType, ContextType>;
  cnhFarm?: Resolver<Maybe<ResolversTypes['CnhFarm']>, ParentType, ContextType>;
  cnhGrower?: Resolver<Maybe<ResolversTypes['CnhGrower']>, ParentType, ContextType>;
  hasValidBoundary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CnhGrowerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CnhGrower'] = ResolversParentTypes['CnhGrower']> = ResolversObject<{
  cnhCompany?: Resolver<Maybe<ResolversTypes['CnhCompany']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CnhTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CnhTask'] = ResolversParentTypes['CnhTask']> = ResolversObject<{
  cnhCompany?: Resolver<Maybe<ResolversTypes['CnhCompany']>, ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CnhTaskType']>, ParentType, ContextType>;
  unitsPerAreaUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  useSinglepartPolygons?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  volumePerAreaUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weightPerAreaUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CollaboratorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Collaborator'] = ResolversParentTypes['Collaborator']> = ResolversObject<{
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  farmUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export interface ColorScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Color'], any> {
  name: 'Color';
}

export interface ColorCxScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ColorCx'], any> {
  name: 'ColorCx';
}

export type ConnectivitySourceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ConnectivitySource'] = ResolversParentTypes['ConnectivitySource']> = ResolversObject<{
  isInterested?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  source?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConnectionSource']>>>, ParentType, ContextType>;
}>;

export type ContactInformationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ContactInformation'] = ResolversParentTypes['ContactInformation']> = ResolversObject<{
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ContainerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Container'] = ResolversParentTypes['Container']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  containerTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  containerTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  containerTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supportedTaskTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['SupportedTaskType']>>>, ParentType, ContextType>;
  unitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitSiConversionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CountryCropGrowthStagePredictionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CountryCropGrowthStagePrediction'] = ResolversParentTypes['CountryCropGrowthStagePrediction']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropGrowthStageV2?: Resolver<Maybe<ResolversTypes['CropGrowthStageV2']>, ParentType, ContextType, Partial<CountryCropGrowthStagePredictionCropGrowthStageV2Args>>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  displayCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  gsOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['GrowthStageProvider']>, ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type CountryCropStressSettingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CountryCropStressSetting'] = ResolversParentTypes['CountryCropStressSetting']> = ResolversObject<{
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  mandatorySettings?: Resolver<Array<Maybe<ResolversTypes['MandatoryStressSetting']>>, ParentType, ContextType>;
  stress?: Resolver<ResolversTypes['StressV2'], ParentType, ContextType, Partial<CountryCropStressSettingStressArgs>>;
}>;

export type CountryWeedResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CountryWeed'] = ResolversParentTypes['CountryWeed']> = ResolversObject<{
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characteristicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  codes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CreditEligibilityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CreditEligibility'] = ResolversParentTypes['CreditEligibility']> = ResolversObject<{
  criteria?: Resolver<Maybe<ResolversTypes['Criteria']>, ParentType, ContextType>;
  deadlineDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isEligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type CriticalCropStageRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CriticalCropStageRisk'] = ResolversParentTypes['CriticalCropStageRisk']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issueType?: Resolver<Maybe<ResolversTypes['IssueType']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CropSeasonStatusState']>, ParentType, ContextType>;
  statusPrecision?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CropSeasonStatusType']>, ParentType, ContextType>;
}>;

export type CriticalCropStageRiskInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CriticalCropStageRiskInfo'] = ResolversParentTypes['CriticalCropStageRiskInfo']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issueType?: Resolver<Maybe<ResolversTypes['IssueType']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CropSeasonStatusType']>, ParentType, ContextType>;
}>;

export type CriticalGrowthStagePeriodRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CriticalGrowthStagePeriodRisk'] = ResolversParentTypes['CriticalGrowthStagePeriodRisk']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CropSeasonStatusState']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CropSeasonStatusType']>, ParentType, ContextType>;
}>;

export type CropResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Crop'] = ResolversParentTypes['Crop']> = ResolversObject<{
  eppocode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landUse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landUseUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scientificName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  varieties?: Resolver<Maybe<Array<Maybe<ResolversTypes['Variety']>>>, ParentType, ContextType>;
}>;

export type CropDictCodeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropDictCode'] = ResolversParentTypes['CropDictCode']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropEstablishmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropEstablishment'] = ResolversParentTypes['CropEstablishment']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dosedMap?: Resolver<Maybe<ResolversTypes['DosedMap']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldInputPackagingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CropEstablishmentDetailsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropEstablishmentDetails'] = ResolversParentTypes['CropEstablishmentDetails']> = ResolversObject<{
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  seedBoxPerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  seedWeightPerSeedBox?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  yieldExpectation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type CropGrowthStageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropGrowthStage'] = ResolversParentTypes['CropGrowthStage']> = ResolversObject<{
  bbch2DigitCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cdnImagePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cdnLogoPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growthStageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mesoStageCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  plantType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plantTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  primaryGrowthStage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryGrowthStage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryGrowthStageCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  secondaryGrowthStageName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type CropGrowthStageImageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropGrowthStageImage'] = ResolversParentTypes['CropGrowthStageImage']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageThumbnailPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  usage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropGrowthStageV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropGrowthStageV2'] = ResolversParentTypes['CropGrowthStageV2']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropGrowthStageImage']>>>, ParentType, ContextType>;
  isActiveGSModel?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMilestone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mainGSCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainGSName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainGSUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaleCode?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  scaleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropMixResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropMix'] = ResolversParentTypes['CropMix']> = ResolversObject<{
  crops?: Resolver<Array<ResolversTypes['CropMixDetail']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropMixDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropMixDetail'] = ResolversParentTypes['CropMixDetail']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType, Partial<CropMixDetailCropArgs>>;
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  variety?: Resolver<Maybe<ResolversTypes['Variety']>, ParentType, ContextType>;
  varietyUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropNutritionReportConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropNutritionReportConfiguration'] = ResolversParentTypes['CropNutritionReportConfiguration']> = ResolversObject<{
  cover?: Resolver<ResolversTypes['CropNutritionReportCoverConfiguration'], ParentType, ContextType>;
  creatorId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  etag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  farmSummary?: Resolver<ResolversTypes['CropNutritionReportFarmSummaryConfiguration'], ParentType, ContextType>;
  fieldDetails?: Resolver<ResolversTypes['CropNutritionReportFieldDetailsConfiguration'], ParentType, ContextType>;
  lastModifierId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CropNutritionReportCoverConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropNutritionReportCoverConfiguration'] = ResolversParentTypes['CropNutritionReportCoverConfiguration']> = ResolversObject<{
  coverImage?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  includeCoverImage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeFarmName?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeFieldList?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeGrowerName?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeTotalArea?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type CropNutritionReportFarmSummaryConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropNutritionReportFarmSummaryConfiguration'] = ResolversParentTypes['CropNutritionReportFarmSummaryConfiguration']> = ResolversObject<{
  includeApplicationPrescriptionMaps?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includePowerzone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeSoilSamplingResultParameters?: Resolver<Array<ResolversTypes['SoilPropertyType']>, ParentType, ContextType>;
  includeSoilSamplingSetLayout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type CropNutritionReportFieldDetailsConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropNutritionReportFieldDetailsConfiguration'] = ResolversParentTypes['CropNutritionReportFieldDetailsConfiguration']> = ResolversObject<{
  includeApplicationPrescriptionMaps?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includePowerzone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  includeSoilSamplingResultParameters?: Resolver<Array<ResolversTypes['SoilPropertyType']>, ParentType, ContextType>;
  includeSoilSamplingSetLayout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  included?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type CropResidueManagementTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropResidueManagementTask'] = ResolversParentTypes['CropResidueManagementTask']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  residueManagementUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CropSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeason'] = ResolversParentTypes['CropSeason']> = ResolversObject<{
  actionRecommendationAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionRecommendationAggregation']>>>, ParentType, ContextType, Partial<CropSeasonActionRecommendationAggregationsArgs>>;
  actionRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionRecommendation']>>>, ParentType, ContextType, Partial<CropSeasonActionRecommendationsArgs>>;
  actionWindows?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionWindow']>>>, ParentType, ContextType>;
  activeGrowthStage?: Resolver<Maybe<ResolversTypes['GrowthStage']>, ParentType, ContextType>;
  aggregatedRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['AggregatedRisk']>>>, ParentType, ContextType>;
  applicationRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationRecommendation']>>>, ParentType, ContextType, RequireFields<CropSeasonApplicationRecommendationsArgs, 'fromDate' | 'tillDate'>>;
  applicationWindows?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationWindow']>>>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  cropEstablishmentGrowthStageIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropEstablishmentMethod?: Resolver<Maybe<ResolversTypes['EstablishmentMethod']>, ParentType, ContextType>;
  cropSeasonStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonStatus']>>>, ParentType, ContextType, Partial<CropSeasonCropSeasonStatusArgs>>;
  cropUsage?: Resolver<Maybe<ResolversTypes['CropUsage']>, ParentType, ContextType>;
  droneFlights?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlight']>>>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  field?: Resolver<ResolversTypes['Field'], ParentType, ContextType>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  growthStages?: Resolver<Maybe<Array<Maybe<ResolversTypes['GrowthStage']>>>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHealthyField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lifecycleState?: Resolver<Maybe<ResolversTypes['LifecycleState']>, ParentType, ContextType>;
  nutritionRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionRecommendation']>>>, ParentType, ContextType, Partial<CropSeasonNutritionRecommendationsArgs>>;
  nutritionStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionStatus']>>>, ParentType, ContextType>;
  observations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Observation']>>>, ParentType, ContextType>;
  preCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  protectionTimes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProtectionTime']>>>, ParentType, ContextType>;
  recommendationSnoozes?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecommendationSnooze']>>>, ParentType, ContextType>;
  risks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Risk']>>>, ParentType, ContextType, RequireFields<CropSeasonRisksArgs, 'fromDate' | 'tillDate'>>;
  seedingTillageSystem?: Resolver<Maybe<ResolversTypes['TillageSystem']>, ParentType, ContextType>;
  sourceMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['SourceMap']>>>, ParentType, ContextType, Partial<CropSeasonSourceMapsArgs>>;
  sprayingWindow?: Resolver<Maybe<ResolversTypes['SprayingWindow']>, ParentType, ContextType>;
  sprayings?: Resolver<Maybe<Array<Maybe<ResolversTypes['Spraying']>>>, ParentType, ContextType>;
  sprayingsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['SprayingV2']>>>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  tillageSystem?: Resolver<Maybe<ResolversTypes['TillageSystem']>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  timingStressesInfo?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingStressInfo']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  variety?: Resolver<Maybe<ResolversTypes['Variety']>, ParentType, ContextType>;
  weedManagementRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeedManagementRecommendation']>>>, ParentType, ContextType, Partial<CropSeasonWeedManagementRecommendationsArgs>>;
  weedRisk?: Resolver<Maybe<ResolversTypes['WeedRisk']>, ParentType, ContextType>;
  yield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yieldExpectation?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CropSeasonDataResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonData'] = ResolversParentTypes['CropSeasonData']> = ResolversObject<{
  actionDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSystemRecommendationActionDetail']>>>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  nutritionTargetRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
}>;

export type CropSeasonNutritionProgramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonNutritionProgram'] = ResolversParentTypes['CropSeasonNutritionProgram']> = ResolversObject<{
  actionDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionActionDetail']>>>, ParentType, ContextType>;
  averageCropYieldFiveYears?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  cropSystemRecommendation?: Resolver<Maybe<ResolversTypes['CropSystemRecommendation']>, ParentType, ContextType>;
  cropSystemRecommendationV2?: Resolver<Maybe<ResolversTypes['CropSystemRecommendationV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isOrganicFertilizerApplicationPlanned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nitrogenMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nitrogenMineralInSoil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nutritionTargetRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionTargetRate']>>>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['NutritionProgramProvider']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['NutritionProgramStrategy']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CropSeasonNutritionProgramExecutionStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonNutritionProgramExecutionStatus'] = ResolversParentTypes['CropSeasonNutritionProgramExecutionStatus']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  sprayingNutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['SprayingNutrient']>>>, ParentType, ContextType>;
  totalNutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['TotalNutrients']>>>, ParentType, ContextType>;
  totalNutrientsDelta?: Resolver<Maybe<Array<Maybe<ResolversTypes['TotalNutrientsDelta']>>>, ParentType, ContextType>;
  totalProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['TotalProducts']>>>, ParentType, ContextType>;
}>;

export type CropSeasonNutritionRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonNutritionRecommendation'] = ResolversParentTypes['CropSeasonNutritionRecommendation']> = ResolversObject<{
  actionDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionActionDetail']>>>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  isOrganicFertilizerApplicationPlanned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nitrogenMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nutritionTargetRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionTargetRate']>>>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['NutritionProgramProvider']>, ParentType, ContextType>;
}>;

export type CropSeasonStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonStatus'] = ResolversParentTypes['CropSeasonStatus']> = ResolversObject<{
  basedOn?: Resolver<Maybe<ResolversTypes['CalculationBase']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CropSeasonStatusState']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CropSeasonStatusType']>, ParentType, ContextType>;
}>;

export type CropSeasonStatusReportEmailSubscriptionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonStatusReportEmailSubscription'] = ResolversParentTypes['CropSeasonStatusReportEmailSubscription']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDays?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeliveryDay']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmV2?: Resolver<ResolversTypes['FarmV2'], ParentType, ContextType>;
  lastExecutionTime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sections?: Resolver<Maybe<ResolversTypes['Section']>, ParentType, ContextType>;
  subscriptionStatus?: Resolver<Maybe<ResolversTypes['EmailSubscriptionStatus']>, ParentType, ContextType>;
  theme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CropSeasonTreatmentProgramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonTreatmentProgram'] = ResolversParentTypes['CropSeasonTreatmentProgram']> = ResolversObject<{
  actionDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetail']>>>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationStatus?: Resolver<Maybe<ResolversTypes['RecommendationStatusType']>, ParentType, ContextType>;
  treatmentScenario?: Resolver<Maybe<ResolversTypes['TreatmentScenario']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weedManagementProgramRecommendationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropSeasonTreatmentProgramExecutionStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonTreatmentProgramExecutionStatus'] = ResolversParentTypes['CropSeasonTreatmentProgramExecutionStatus']> = ResolversObject<{
  actionWindows?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProgramActionWindow']>>>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionStatus?: Resolver<Maybe<ResolversTypes['ExecutionStatus']>, ParentType, ContextType>;
  outOfWindowsTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProgramActionWindowTask']>>>, ParentType, ContextType>;
  plannedExecutionStatus?: Resolver<Maybe<ResolversTypes['PlannedExecutionStatus']>, ParentType, ContextType>;
  treatmentScenarioUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropSeasonTreatmentProgramV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonTreatmentProgramV2'] = ResolversParentTypes['CropSeasonTreatmentProgramV2']> = ResolversObject<{
  actionDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetailV2']>>>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationStatus?: Resolver<Maybe<ResolversTypes['RecommendationStatusType']>, ParentType, ContextType>;
  scenarioDescriptionKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatmentScenario?: Resolver<Maybe<ResolversTypes['TreatmentScenario']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weedManagementProgramRecommendationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropSeasonTreatmentProgramV3Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonTreatmentProgramV3'] = ResolversParentTypes['CropSeasonTreatmentProgramV3']> = ResolversObject<{
  actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProgramAction']>>>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  cropEstablishmentGrowthStageIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropEstablishmentGrowthStageScaleCode?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  cropEstablishmentMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  equipmentType?: Resolver<Maybe<ResolversTypes['TreatmentEquipmentType']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationStatus?: Resolver<Maybe<ResolversTypes['RecommendationStatusType']>, ParentType, ContextType>;
  scenarioDescriptionKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TreatmentProgramType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weedManagementProgramRecommendationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropSeasonV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonV2'] = ResolversParentTypes['CropSeasonV2']> = ResolversObject<{
  actionRecommendationAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionRecommendationAggregation']>>>, ParentType, ContextType, Partial<CropSeasonV2ActionRecommendationAggregationsArgs>>;
  actionRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionRecommendation']>>>, ParentType, ContextType, Partial<CropSeasonV2ActionRecommendationsArgs>>;
  actionWindows?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionWindow']>>>, ParentType, ContextType, Partial<CropSeasonV2ActionWindowsArgs>>;
  activeCountryCropGrowthStage?: Resolver<Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>, ParentType, ContextType>;
  activeGrowthStage?: Resolver<Maybe<ResolversTypes['GrowthStage']>, ParentType, ContextType>;
  additionalInfectionRiskFactor?: Resolver<Maybe<ResolversTypes['AdditionalInfectionRiskFactor']>, ParentType, ContextType>;
  agBalanceFieldEmissionIndicator?: Resolver<Maybe<ResolversTypes['AgBalanceFieldEmissionIndicator']>, ParentType, ContextType>;
  aggregatedPestDevelopmentPredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AggregatedPestDevelopmentPrediction']>>>, ParentType, ContextType, Partial<CropSeasonV2AggregatedPestDevelopmentPredictionsArgs>>;
  applicationWindows?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationWindow']>>>, ParentType, ContextType>;
  arvalisCalculationBasis?: Resolver<Maybe<ResolversTypes['ArvalisCalculationBasis']>, ParentType, ContextType>;
  arvalisDeviceToCropSeason?: Resolver<Maybe<ResolversTypes['ArvalisDeviceToCropSeason']>, ParentType, ContextType>;
  arvalisInformation?: Resolver<Maybe<ResolversTypes['ArvalisInformation']>, ParentType, ContextType>;
  averageHeightOfCanopy?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageThicknessOfCanopy?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  beforeSeasonRisks?: Resolver<Maybe<Array<ResolversTypes['BeforeSeasonRisk']>>, ParentType, ContextType>;
  biodiversityIndicator?: Resolver<Maybe<ResolversTypes['BiodiversityIndicator']>, ParentType, ContextType>;
  biomassPerAreaAtTermination?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  boundary?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  boundaryChecksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  campaignYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  carbonPlausibilityComment?: Resolver<Maybe<ResolversTypes['CarbonPlausibilityComment']>, ParentType, ContextType>;
  countryCropGrowthStagePredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>>>, ParentType, ContextType, Partial<CropSeasonV2CountryCropGrowthStagePredictionsArgs>>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  criticalCropStageRiskInfos?: Resolver<Maybe<Array<Maybe<ResolversTypes['CriticalCropStageRiskInfo']>>>, ParentType, ContextType>;
  criticalCropStageRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['CriticalCropStageRisk']>>>, ParentType, ContextType, Partial<CropSeasonV2CriticalCropStageRisksArgs>>;
  criticalGrowthStagePeriodRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['CriticalGrowthStagePeriodRisk']>>>, ParentType, ContextType, Partial<CropSeasonV2CriticalGrowthStagePeriodRisksArgs>>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType, Partial<CropSeasonV2CropArgs>>;
  cropEstablishmentDetails?: Resolver<Maybe<ResolversTypes['CropEstablishmentDetails']>, ParentType, ContextType>;
  cropEstablishmentGrowthStageIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropEstablishmentGrowthStageScaleCode?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  cropEstablishmentMethodCode?: Resolver<Maybe<ResolversTypes['EstablishmentMethod']>, ParentType, ContextType>;
  cropEstablishments?: Resolver<Maybe<Array<ResolversTypes['CropEstablishment']>>, ParentType, ContextType>;
  cropMix?: Resolver<ResolversTypes['CropMix'], ParentType, ContextType>;
  cropResidueManagementTasks?: Resolver<Maybe<Array<ResolversTypes['CropResidueManagementTask']>>, ParentType, ContextType>;
  cropSeasonNutritionProgram?: Resolver<Maybe<ResolversTypes['CropSeasonNutritionProgram']>, ParentType, ContextType>;
  cropSeasonNutritionProgramExecutionStatus?: Resolver<Maybe<ResolversTypes['CropSeasonNutritionProgramExecutionStatus']>, ParentType, ContextType>;
  cropSeasonStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonStatus']>>>, ParentType, ContextType, Partial<CropSeasonV2CropSeasonStatusArgs>>;
  cropSeasonTreatmentProgram?: Resolver<Maybe<ResolversTypes['CropSeasonTreatmentProgram']>, ParentType, ContextType>;
  cropSeasonTreatmentProgramExecutionStatus?: Resolver<Maybe<ResolversTypes['CropSeasonTreatmentProgramExecutionStatus']>, ParentType, ContextType>;
  cropSeasonTreatmentProgramV2?: Resolver<Maybe<ResolversTypes['CropSeasonTreatmentProgramV2']>, ParentType, ContextType>;
  cropSeasonTreatmentProgramV3?: Resolver<Maybe<ResolversTypes['CropSeasonTreatmentProgramV3']>, ParentType, ContextType>;
  cropSeasonWaterManagementProgram?: Resolver<Maybe<ResolversTypes['CropSeasonWaterManagementProgram']>, ParentType, ContextType>;
  cropUsage?: Resolver<Maybe<ResolversTypes['CropUsage']>, ParentType, ContextType, Partial<CropSeasonV2CropUsageArgs>>;
  cropWaterAvailabilities?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropWaterAvailability']>>>, ParentType, ContextType, Partial<CropSeasonV2CropWaterAvailabilitiesArgs>>;
  croppingSystem?: Resolver<Maybe<ResolversTypes['Dictionary']>, ParentType, ContextType, Partial<CropSeasonV2CroppingSystemArgs>>;
  customPowerzoneOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomPowerzoneOrder']>>>, ParentType, ContextType>;
  dailyFungusDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyFungusDetails']>>>, ParentType, ContextType, Partial<CropSeasonV2DailyFungusDetailsArgs>>;
  dailyStressCharacteristics?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyStressCharacteristics']>>>, ParentType, ContextType, Partial<CropSeasonV2DailyStressCharacteristicsArgs>>;
  dailyStressEventProbabilities?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyStressEventProbability']>>>, ParentType, ContextType, Partial<CropSeasonV2DailyStressEventProbabilitiesArgs>>;
  dailyWeedRiskDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyWeedRiskDetails']>>>, ParentType, ContextType, Partial<CropSeasonV2DailyWeedRiskDetailsArgs>>;
  depthOfRoots?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  droneFlights?: Resolver<Maybe<Array<ResolversTypes['DroneFlight']>>, ParentType, ContextType>;
  dryMatterAnalysis?: Resolver<Maybe<Array<Maybe<ResolversTypes['DryMatterAnalysis']>>>, ParentType, ContextType, Partial<CropSeasonV2DryMatterAnalysisArgs>>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldDataLayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, ParentType, ContextType, RequireFields<CropSeasonV2FieldDataLayersArgs, 'types'>>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  fieldVariabilityIndexes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldVariabilityIndex']>>>, ParentType, ContextType>;
  fieldVariabilityInput?: Resolver<Maybe<ResolversTypes['FieldVariabilityInput']>, ParentType, ContextType>;
  foreignCatchCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  foreignCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  foreignPreCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  frostRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['FrostRisk']>>>, ParentType, ContextType, Partial<CropSeasonV2FrostRisksArgs>>;
  greenhouseWhiteningTasks?: Resolver<Maybe<Array<ResolversTypes['GreenhouseWhiteningTask']>>, ParentType, ContextType>;
  groundWaterDepth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  growthStagePredictionDaily?: Resolver<Maybe<Array<Maybe<ResolversTypes['GrowthStagePredictionDaily']>>>, ParentType, ContextType>;
  growthStages?: Resolver<Maybe<Array<Maybe<ResolversTypes['GrowthStage']>>>, ParentType, ContextType, Partial<CropSeasonV2GrowthStagesArgs>>;
  harvests?: Resolver<Maybe<Array<ResolversTypes['Harvest']>>, ParentType, ContextType>;
  hfClaims?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfClaim']>>>, ParentType, ContextType>;
  hfOfferCondition?: Resolver<Maybe<ResolversTypes['HfOfferCondition']>, ParentType, ContextType>;
  hfPrice?: Resolver<Maybe<ResolversTypes['HfPrice']>, ParentType, ContextType>;
  hfServiceRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['HFServiceRequest']>>>, ParentType, ContextType>;
  hortaCropSeason?: Resolver<Maybe<ResolversTypes['HortaCropSeason']>, ParentType, ContextType>;
  hortaSustainabilityIndicator?: Resolver<Maybe<ResolversTypes['HortaSustainabilityIndicator']>, ParentType, ContextType>;
  initialWaterContentInSoil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAutoGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHealthyField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOrganicFarming?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  landPreparations?: Resolver<Maybe<Array<ResolversTypes['LandPreparation']>>, ParentType, ContextType>;
  leafPruningTasks?: Resolver<Maybe<Array<ResolversTypes['LeafPruningTask']>>, ParentType, ContextType>;
  lifecycleState?: Resolver<Maybe<ResolversTypes['LifecycleState']>, ParentType, ContextType>;
  modifier?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  monitorPractices?: Resolver<Maybe<Array<Maybe<ResolversTypes['MonitorPractice']>>>, ParentType, ContextType>;
  nextCountryCropGrowthStage?: Resolver<Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>, ParentType, ContextType>;
  nextGrowthStage?: Resolver<Maybe<ResolversTypes['GrowthStage']>, ParentType, ContextType>;
  nutritionRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionRecommendation']>>>, ParentType, ContextType, Partial<CropSeasonV2NutritionRecommendationsArgs>>;
  nutritionStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionStatus']>>>, ParentType, ContextType, Partial<CropSeasonV2NutritionStatusArgs>>;
  observations?: Resolver<Maybe<Array<ResolversTypes['Observation']>>, ParentType, ContextType>;
  operationalInstructions?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfOperationalInstruction']>>>, ParentType, ContextType, RequireFields<CropSeasonV2OperationalInstructionsArgs, 'roleFeatureName'>>;
  pestDevelopmentPredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PestDevelopmentPrediction']>>>, ParentType, ContextType, Partial<CropSeasonV2PestDevelopmentPredictionsArgs>>;
  preCrop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType, Partial<CropSeasonV2PreCropArgs>>;
  preCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  produceDeliveryTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProduceDeliveryTask']>>>, ParentType, ContextType>;
  projectedIncidences?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProjectedIncidences']>>>, ParentType, ContextType>;
  protectionTimes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProtectionTime']>>>, ParentType, ContextType>;
  recommendationSnoozes?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecommendationSnooze']>>>, ParentType, ContextType>;
  residueLeft?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  risks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Risk']>>>, ParentType, ContextType, Partial<CropSeasonV2RisksArgs>>;
  risksV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['RiskV2']>>>, ParentType, ContextType, Partial<CropSeasonV2RisksV2Args>>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoutingTasks?: Resolver<Maybe<Array<ResolversTypes['ScoutingTask']>>, ParentType, ContextType, Partial<CropSeasonV2ScoutingTasksArgs>>;
  seedBoxTreatments?: Resolver<Maybe<Array<ResolversTypes['SeedBoxTreatment']>>, ParentType, ContextType>;
  seedTreatment?: Resolver<Maybe<ResolversTypes['SeedTreatmentType']>, ParentType, ContextType>;
  seedTreatmentTasks?: Resolver<Maybe<Array<ResolversTypes['SeedTreatment']>>, ParentType, ContextType>;
  seedTreatmentType?: Resolver<Maybe<ResolversTypes['SeedTreatmentType']>, ParentType, ContextType>;
  seedWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  seedbedQualityUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  seedingTillageSystem?: Resolver<Maybe<ResolversTypes['TillageSystem']>, ParentType, ContextType, Partial<CropSeasonV2SeedingTillageSystemArgs>>;
  shootsPerPlantCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  smartSprayingTasks?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingTask']>>, ParentType, ContextType>;
  smartSprayingTasksV2?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingTaskV2']>>, ParentType, ContextType>;
  soilSamplingTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingTask']>>>, ParentType, ContextType>;
  soilSolarizationMaterialUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sourceMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['SourceMap']>>>, ParentType, ContextType, Partial<CropSeasonV2SourceMapsArgs>>;
  sowingDepthClassUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sprayingsV2?: Resolver<Maybe<Array<ResolversTypes['SprayingV2']>>, ParentType, ContextType, Partial<CropSeasonV2SprayingsV2Args>>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  stressEfficacyCharacteristics?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressEfficacyCharacteristics']>>>, ParentType, ContextType, Partial<CropSeasonV2StressEfficacyCharacteristicsArgs>>;
  stressSettings?: Resolver<Maybe<ResolversTypes['StressSettings']>, ParentType, ContextType>;
  sustainabilityIndicator?: Resolver<Maybe<ResolversTypes['SustainabilityIndicator']>, ParentType, ContextType>;
  sustainabilityInput?: Resolver<Maybe<ResolversTypes['SustainabilityInput']>, ParentType, ContextType>;
  taskAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskAggregation']>>>, ParentType, ContextType>;
  tillageSystem?: Resolver<Maybe<ResolversTypes['TillageSystem']>, ParentType, ContextType, Partial<CropSeasonV2TillageSystemArgs>>;
  timingCalculationStatus?: Resolver<Maybe<ResolversTypes['TimingCalculationStatus']>, ParentType, ContextType>;
  timingProductRecommendations?: Resolver<Maybe<Array<ResolversTypes['TimingProductRecommendation']>>, ParentType, ContextType>;
  timingStressesInfo?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingStressInfo']>>>, ParentType, ContextType>;
  toppingTasks?: Resolver<Maybe<Array<ResolversTypes['ToppingTask']>>, ParentType, ContextType>;
  trainingSystemUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  trials?: Resolver<Maybe<Array<Maybe<ResolversTypes['Trial']>>>, ParentType, ContextType>;
  underSeedManagementUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  useOrganicFertilizer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  variety?: Resolver<Maybe<ResolversTypes['Variety']>, ParentType, ContextType, Partial<CropSeasonV2VarietyArgs>>;
  waterBalances?: Resolver<Maybe<Array<Maybe<ResolversTypes['WaterBalance']>>>, ParentType, ContextType>;
  waterManagementTasks?: Resolver<Maybe<Array<ResolversTypes['WaterManagementTask']>>, ParentType, ContextType>;
  waterRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['WaterRecommendation']>>>, ParentType, ContextType, Partial<CropSeasonV2WaterRecommendationsArgs>>;
  waterStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['WaterStatus']>>>, ParentType, ContextType, Partial<CropSeasonV2WaterStatusArgs>>;
  waterloggingRiskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weedManagementRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeedManagementRecommendation']>>>, ParentType, ContextType, Partial<CropSeasonV2WeedManagementRecommendationsArgs>>;
  weedRisk?: Resolver<Maybe<ResolversTypes['WeedRisk']>, ParentType, ContextType>;
  weedStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeedStatus']>>>, ParentType, ContextType, Partial<CropSeasonV2WeedStatusArgs>>;
  weeklySeedingRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeeklySeedingRecommendation']>>>, ParentType, ContextType>;
  yield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yieldExpectation?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  yieldPrediction?: Resolver<Maybe<ResolversTypes['YieldPrediction']>, ParentType, ContextType>;
}>;

export type CropSeasonWaterManagementProgramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSeasonWaterManagementProgram'] = ResolversParentTypes['CropSeasonWaterManagementProgram']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  waterManagementScenario?: Resolver<Maybe<ResolversTypes['WaterManagementScenario']>, ParentType, ContextType>;
}>;

export type CropSystemRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSystemRecommendation'] = ResolversParentTypes['CropSystemRecommendation']> = ResolversObject<{
  cropSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonData']>>>, ParentType, ContextType>;
  nutrientRateUnitCode?: Resolver<Maybe<ResolversTypes['NutrientRateUnitCode']>, ParentType, ContextType>;
  provider?: Resolver<ResolversTypes['NutritionProgramProvider'], ParentType, ContextType>;
  soilSamplingResult?: Resolver<Maybe<ResolversTypes['SoilSamplingResult']>, ParentType, ContextType>;
  totalNutritionTargetRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CropSystemRecommendationActionDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSystemRecommendationActionDetail'] = ResolversParentTypes['CropSystemRecommendationActionDetail']> = ResolversObject<{
  appliedNutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  nutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionActionNutrient']>>>, ParentType, ContextType>;
  nutrientsDemandDelta?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  totalNutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['NutritionRecommendationActionType']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['RecommendationActionValidity']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['RecommendationActionValidity']>, ParentType, ContextType>;
}>;

export type CropSystemRecommendationRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSystemRecommendationRequest'] = ResolversParentTypes['CropSystemRecommendationRequest']> = ResolversObject<{
  averageCropYieldFiveYears?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropSeasonUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  croppingSystemUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  customNutrientRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  isQualitativeCalcium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativeMagnesium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativeNitrogen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativePhosphorus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativePotassium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nitrogenMineralInSoil?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  previousYearOrganicNitrogen?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['NutritionProgramProvider']>, ParentType, ContextType>;
  relativePowerOfTotalNeutralisation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilSamplingResultUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type CropSystemRecommendationV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropSystemRecommendationV2'] = ResolversParentTypes['CropSystemRecommendationV2']> = ResolversObject<{
  cropSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonData']>>>, ParentType, ContextType>;
  cropSystemRecommendationRequest?: Resolver<Maybe<ResolversTypes['CropSystemRecommendationRequest']>, ParentType, ContextType>;
  croppingSystem?: Resolver<Maybe<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  isInRedZone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativeCalcium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativeMagnesium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativeNitrogen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativePhosphorus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQualitativePotassium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  previousYearOrganicNitrogen?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['NutritionProgramProvider']>, ParentType, ContextType>;
  recommendationRequestUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  relativePowerOfTotalNeutralisation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilSamplingResult?: Resolver<Maybe<ResolversTypes['SoilSamplingResult']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['NutritionProgramStrategy']>, ParentType, ContextType>;
  totalNutritionTargetRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CropTankMixSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropTankMixSummary'] = ResolversParentTypes['CropTankMixSummary']> = ResolversObject<{
  cropSeasonsHavingAtLeastOneTankMix?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  numberOfTankMixes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type CropUsageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropUsage'] = ResolversParentTypes['CropUsage']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type CropWaterAvailabilityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CropWaterAvailability'] = ResolversParentTypes['CropWaterAvailability']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  evapotranspiration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  optimalEvapotranspiration?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  optimalWaterAvailableQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  waterAvailablePercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  waterAvailableQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  waterAvailableStatus?: Resolver<Maybe<ResolversTypes['WaterAvailableStatus']>, ParentType, ContextType>;
  waterSensitivity?: Resolver<Maybe<ResolversTypes['WaterSensitivity']>, ParentType, ContextType>;
}>;

export type CurrentWeedPredictionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CurrentWeedPrediction'] = ResolversParentTypes['CurrentWeedPrediction']> = ResolversObject<{
  fieldV2?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  relevant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resistanceUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  resistances?: Resolver<Maybe<Array<Maybe<ResolversTypes['TargetWeedResistance']>>>, ParentType, ContextType>;
  targetWeedUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taxonomicRank?: Resolver<Maybe<ResolversTypes['TaxonomicRank']>, ParentType, ContextType>;
  weedRecord?: Resolver<Maybe<ResolversTypes['WeedRecord']>, ParentType, ContextType>;
  weedRecordCreationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  weedRecordSourceType?: Resolver<Maybe<ResolversTypes['WeedRecordSourceType']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['TargetWeedWeight']>, ParentType, ContextType>;
}>;

export type CustomPowerzoneOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CustomPowerzoneOrder'] = ResolversParentTypes['CustomPowerzoneOrder']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minGeometryArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CustomPowerzoneStatus']>, ParentType, ContextType>;
  timeWindows?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomPowerzoneTimeWindow']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CustomPowerzoneType']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  zoneNr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type CustomPowerzoneTimeWindowResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['CustomPowerzoneTimeWindow'] = ResolversParentTypes['CustomPowerzoneTimeWindow']> = ResolversObject<{
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type DailyFungusDetailsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DailyFungusDetails'] = ResolversParentTypes['DailyFungusDetails']> = ResolversObject<{
  basedOn?: Resolver<Maybe<ResolversTypes['CalculationBase']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  contaminationIndex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contaminationIndexStatus?: Resolver<Maybe<ResolversTypes['ContaminationState']>, ParentType, ContextType>;
  contaminationWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contaminationWeightStatus?: Resolver<Maybe<ResolversTypes['ContaminationState']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rain?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  remainingLeachingResistance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sporeReserve?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sporulationPotential?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<DailyFungusDetailsStressArgs>>;
  treatmentDateAdviced?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  varietyThreshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type DailyStressCharacteristicsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DailyStressCharacteristics'] = ResolversParentTypes['DailyStressCharacteristics']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  groupingDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isActionRelevant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPotential?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DailyStressCharacteristicsStatus']>, ParentType, ContextType>;
  stressRiskType?: Resolver<Maybe<ResolversTypes['RiskType']>, ParentType, ContextType>;
  stresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressV2']>>>, ParentType, ContextType, Partial<DailyStressCharacteristicsStressesArgs>>;
  subType?: Resolver<Maybe<ResolversTypes['DailyStressCharacteristicsSubType']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['DailyStressCharacteristicsType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type DailyStressEventProbabilityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DailyStressEventProbability'] = ResolversParentTypes['DailyStressEventProbability']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  incubationLevels?: Resolver<Maybe<Array<Maybe<ResolversTypes['IncubationLevel']>>>, ParentType, ContextType>;
  infectionType?: Resolver<Maybe<ResolversTypes['InfectionType']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPotential?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DailyStressEventProbabilityStatus']>, ParentType, ContextType>;
  stressV2?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<DailyStressEventProbabilityStressV2Args>>;
  type?: Resolver<Maybe<ResolversTypes['DailyStressEventProbabilityType']>, ParentType, ContextType>;
}>;

export type DailyWeedRiskDetailsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DailyWeedRiskDetails'] = ResolversParentTypes['DailyWeedRiskDetails']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isEmerging?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLast?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  leafIndexCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<DailyWeedRiskDetailsStressArgs>>;
  weedGrowthStageIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weedGrowthStageScale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DemandEquationProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DemandEquationProduct'] = ResolversParentTypes['DemandEquationProduct']> = ResolversObject<{
  averageRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zones?: Resolver<Maybe<Array<Maybe<ResolversTypes['DemandEquationZone']>>>, ParentType, ContextType>;
}>;

export type DemandEquationRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DemandEquationRecommendation'] = ResolversParentTypes['DemandEquationRecommendation']> = ResolversObject<{
  calciumOxideInLime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  desiredBaseSaturation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredCalciumSaturation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredCationExchangeCapacityPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredGypsumPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredNutrientLevel?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nutritionMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['DemandEquationProduct']>>>, ParentType, ContextType>;
  relativePowerOfTotalNeutralisation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilSamplingResult?: Resolver<Maybe<ResolversTypes['SoilSamplingResult']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type DemandEquationRecommendationV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DemandEquationRecommendationV2'] = ResolversParentTypes['DemandEquationRecommendationV2']> = ResolversObject<{
  calciumOxideInLime?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  desiredBaseSaturation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredCalciumSaturation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredCationExchangeCapacityPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredGypsumPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  desiredNutrientLevel?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nutritionMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  relativePowerOfTotalNeutralisation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  samplingAreas?: Resolver<Maybe<Array<Maybe<ResolversTypes['DemandEquationSamplingArea']>>>, ParentType, ContextType>;
  soilSamplingResult?: Resolver<Maybe<ResolversTypes['SoilSamplingResult']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type DemandEquationSamplingAreaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DemandEquationSamplingArea'] = ResolversParentTypes['DemandEquationSamplingArea']> = ResolversObject<{
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['DemandEquationSamplingAreaProduct']>>>, ParentType, ContextType>;
  samplingAreaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type DemandEquationSamplingAreaProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DemandEquationSamplingAreaProduct'] = ResolversParentTypes['DemandEquationSamplingAreaProduct']> = ResolversObject<{
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type DemandEquationZoneResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DemandEquationZone'] = ResolversParentTypes['DemandEquationZone']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type DescriptionAndSymptomResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DescriptionAndSymptom'] = ResolversParentTypes['DescriptionAndSymptom']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stressCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  symptom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  symptomCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  symptomName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  symptomUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type DetectedDiseaseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DetectedDisease'] = ResolversParentTypes['DetectedDisease']> = ResolversObject<{
  eppoCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latinName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referenceImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userSelected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type DetectedNitrogenStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DetectedNitrogenStatus'] = ResolversParentTypes['DetectedNitrogenStatus']> = ResolversObject<{
  freshMatter?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nitrogenUptake?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type DetectedPestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DetectedPest'] = ResolversParentTypes['DetectedPest']> = ResolversObject<{
  colorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eppoCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latinName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type DetectedWeedResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DetectedWeed'] = ResolversParentTypes['DetectedWeed']> = ResolversObject<{
  colorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  eppoCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latinName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  probability?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxonomicRank?: Resolver<Maybe<ResolversTypes['TaxonomicRank']>, ParentType, ContextType>;
}>;

export type DeviceFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DeviceFeature'] = ResolversParentTypes['DeviceFeature']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  deviceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['FeatureName']>, ParentType, ContextType>;
  packageType?: Resolver<Maybe<ResolversTypes['PackageType']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type DevicePackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DevicePackage'] = ResolversParentTypes['DevicePackage']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityType?: Resolver<Maybe<ResolversTypes['FarmPackageQuantityType']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FarmPackageType']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type DictcodeFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DictcodeFeature'] = ResolversParentTypes['DictcodeFeature']> = ResolversObject<{
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characteristicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropStageGroupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropStageGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropStageGroupUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValueCode']>>>, ParentType, ContextType>;
  valueUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valueUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type DictcodeHierarchyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DictcodeHierarchy'] = ResolversParentTypes['DictcodeHierarchy']> = ResolversObject<{
  childDict?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  childDictCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  childDictName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  childDictcodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  childDictcodeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  parentDict?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentDictCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentDictName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentDictcodeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentDictcodeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type DictionaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Dictionary'] = ResolversParentTypes['Dictionary']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type DisabledHistoryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DisabledHistory'] = ResolversParentTypes['DisabledHistory']> = ResolversObject<{
  endDatetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDatetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type DiseaseIdentificationResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DiseaseIdentificationResult'] = ResolversParentTypes['DiseaseIdentificationResult']> = ResolversObject<{
  detectedDiseases?: Resolver<Maybe<Array<Maybe<ResolversTypes['DetectedDisease']>>>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recognizedCropEppoCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ScoutingPoiResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DosedMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DosedMap'] = ResolversParentTypes['DosedMap']> = ResolversObject<{
  actionTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionType']>>>, ParentType, ContextType>;
  additives?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditiveRate']>>>, ParentType, ContextType>;
  applicationDepth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  applicationMode?: Resolver<Maybe<ResolversTypes['ApplicationMode']>, ParentType, ContextType>;
  applicationSpotUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  applicationStrategy?: Resolver<Maybe<ResolversTypes['ApplicationStrategy']>, ParentType, ContextType>;
  applicationType?: Resolver<Maybe<ResolversTypes['ApplicationType']>, ParentType, ContextType>;
  applicationZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationZone']>>>, ParentType, ContextType>;
  arvalisCustomEfficacyInformation?: Resolver<Maybe<ResolversTypes['ArvalisCustomEfficacyInformation']>, ParentType, ContextType>;
  averageTargetRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageWaterRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bufferZones?: Resolver<Maybe<ResolversTypes['BufferZones']>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creationFlowHint?: Resolver<Maybe<ResolversTypes['CreationFlowHint']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  doseKey?: Resolver<Maybe<ResolversTypes['DoseKey']>, ParentType, ContextType>;
  fieldZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['MappingFieldZone']>>>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inhibitorUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  isHighFlow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  legend?: Resolver<Maybe<ResolversTypes['DosedMapLegend']>, ParentType, ContextType>;
  limitationReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['LimitationReason']>>>, ParentType, ContextType>;
  limitedVra?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lowestZoneExcluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  masterVraRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  nitrificationInhibitorUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  overrideVraRestriction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  percentageSpread?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<DosedMapPreviewArgs, 'format'>>;
  productPackUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  rates?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductRate']>>>, ParentType, ContextType>;
  ratesCalculationRequest?: Resolver<Maybe<ResolversTypes['RatesCalculationRequest']>, ParentType, ContextType>;
  ratesV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZoneRateV2']>>>, ParentType, ContextType>;
  recipe?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductApplicationRate']>>>, ParentType, ContextType>;
  recipeV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubstanceApplicationRate']>>>, ParentType, ContextType>;
  recommendationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  recommendedNumberOfZones?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceZoneId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restrictFallbackToFlat?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceMap?: Resolver<Maybe<ResolversTypes['SourceMap']>, ParentType, ContextType, Partial<DosedMapSourceMapArgs>>;
  sourceMapUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sprayZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationCategory']>>>, ParentType, ContextType>;
  subscriptionStatus?: Resolver<Maybe<ResolversTypes['SubscriptionStatus']>, ParentType, ContextType>;
  targetNutrientUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalTargetAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  treatmentReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentReason']>>>, ParentType, ContextType>;
  ureaseInhibitorUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  waterAverageApplicationRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  waterRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  waterTotalApplication?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weedPressureThreshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  zonePercentageDifferences?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZonePercentageDifference']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DosedMapLegendResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DosedMapLegend'] = ResolversParentTypes['DosedMapLegend']> = ResolversObject<{
  applicationType?: Resolver<Maybe<ResolversTypes['ApplicationType']>, ParentType, ContextType>;
  dosedMapUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['DosedMapLegendEntry']>>>, ParentType, ContextType>;
}>;

export type DosedMapLegendEntryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DosedMapLegendEntry'] = ResolversParentTypes['DosedMapLegendEntry']> = ResolversObject<{
  category?: Resolver<Maybe<ResolversTypes['ApplicationCategory']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type DosedMapProductSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DosedMapProductSummary'] = ResolversParentTypes['DosedMapProductSummary']> = ResolversObject<{
  formulation?: Resolver<Maybe<ResolversTypes['Formulation']>, ParentType, ContextType>;
  totalAreaApplied?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalProductAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SubstanceType']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type DroneFlightResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DroneFlight'] = ResolversParentTypes['DroneFlight']> = ResolversObject<{
  abLine?: Resolver<Maybe<ResolversTypes['AbLine']>, ParentType, ContextType>;
  acceptableStatusChanges?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightStatus']>>>, ParentType, ContextType>;
  algorithmType?: Resolver<Maybe<ResolversTypes['AlgorithmType']>, ParentType, ContextType>;
  algorithmTypeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  cancelledDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  droneFlightOrthomosaics?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightOrthomosaic']>>>, ParentType, ContextType>;
  equipmentType?: Resolver<Maybe<ResolversTypes['EquipmentType']>, ParentType, ContextType>;
  equipmentTypeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['DroneFlightErrorCode']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightError']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  flightCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gridSizeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  gridSizes?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightGridSize']>>>, ParentType, ContextType>;
  groundSampleDistance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mapTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightMapType']>>>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedDeniedQuotaExhaustedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedFailedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processingTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  referenceDroneFlightTask?: Resolver<Maybe<ResolversTypes['DroneFlight']>, ParentType, ContextType>;
  resubmittedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  scheduledDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  serviceType?: Resolver<Maybe<ResolversTypes['ServiceType']>, ParentType, ContextType>;
  serviceTypeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DroneFlightStatus']>, ParentType, ContextType>;
  statusDescriptionTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  statusTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  uploadPendingDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uploadedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  warningCode?: Resolver<Maybe<ResolversTypes['WarningCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DroneFlightErrorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DroneFlightError'] = ResolversParentTypes['DroneFlightError']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['DroneFlightErrorCode']>, ParentType, ContextType>;
  fileNames?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
}>;

export type DroneFlightOrthomosaicResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DroneFlightOrthomosaic'] = ResolversParentTypes['DroneFlightOrthomosaic']> = ResolversObject<{
  fileLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileLocationOfPreview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flightUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type DroneFlightQuotaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DroneFlightQuota'] = ResolversParentTypes['DroneFlightQuota']> = ResolversObject<{
  availableArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  consumedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  droneFlightQuotaTransfers?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightQuotaTransfer']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceType?: Resolver<Maybe<ResolversTypes['ServiceType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type DroneFlightQuotaTransferResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DroneFlightQuotaTransfer'] = ResolversParentTypes['DroneFlightQuotaTransfer']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceDroneFlightQuotaUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  targetDroneFlightQuotaUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type DroneFlightSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DroneFlightSummary'] = ResolversParentTypes['DroneFlightSummary']> = ResolversObject<{
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  serviceType?: Resolver<ResolversTypes['ServiceType'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DroneFlightStatus'], ParentType, ContextType>;
  taskCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type DronePlantingFailureMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DronePlantingFailureMap'] = ResolversParentTypes['DronePlantingFailureMap']> = ResolversObject<{
  classBreaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  consumedAreaDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  droneFlight?: Resolver<Maybe<ResolversTypes['DroneFlight']>, ParentType, ContextType>;
  droneFlightQuota?: Resolver<Maybe<ResolversTypes['DroneFlightQuota']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failureMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['FailureMap']>>>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type DroneSprayerWeedMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DroneSprayerWeedMap'] = ResolversParentTypes['DroneSprayerWeedMap']> = ResolversObject<{
  consumedAreaDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  droneFlight?: Resolver<Maybe<ResolversTypes['DroneFlight']>, ParentType, ContextType>;
  droneFlightQuota?: Resolver<Maybe<ResolversTypes['DroneFlightQuota']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['Weed']>>>, ParentType, ContextType>;
}>;

export type DryMatterAnalysisResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DryMatterAnalysis'] = ResolversParentTypes['DryMatterAnalysis']> = ResolversObject<{
  average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  harvestCondition?: Resolver<Maybe<ResolversTypes['HarvestCondition']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['DryMatterAnalysisType']>, ParentType, ContextType>;
}>;

export type DtnVendorDeviceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DtnVendorDevice'] = ResolversParentTypes['DtnVendorDevice']> = ResolversObject<{
  distanceFromSearchCenter?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dtnVendorDeviceToLocations?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorDeviceToLocation']>>>, ParentType, ContextType>;
  dtnVendorDeviceToLocationsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorDeviceToLocationV2']>>>, ParentType, ContextType>;
  dtnVendorLatestMeasurement?: Resolver<Maybe<ResolversTypes['DtnVendorDeviceLatestMeasurement']>, ParentType, ContextType>;
  elevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  locationType?: Resolver<Maybe<ResolversTypes['LocationType']>, ParentType, ContextType>;
  locationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['DtnVendor']>, ParentType, ContextType>;
}>;

export type DtnVendorDeviceActivationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DtnVendorDeviceActivation'] = ResolversParentTypes['DtnVendorDeviceActivation']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['DtnVendorDevice'], ParentType, ContextType>;
  dfFarmPackageUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validFrom?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  validTill?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['DtnVendor']>, ParentType, ContextType>;
}>;

export type DtnVendorDeviceLatestMeasurementResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DtnVendorDeviceLatestMeasurement'] = ResolversParentTypes['DtnVendorDeviceLatestMeasurement']> = ResolversObject<{
  device?: Resolver<ResolversTypes['DtnVendorDevice'], ParentType, ContextType>;
  humidity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  locationType?: Resolver<Maybe<ResolversTypes['LocationType']>, ParentType, ContextType>;
  locationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  solarRadiation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  temperature?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  time?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['DtnVendor']>, ParentType, ContextType>;
  windDirection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windSpeed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type DtnVendorDeviceToLocationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DtnVendorDeviceToLocation'] = ResolversParentTypes['DtnVendorDeviceToLocation']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['DtnVendorDevice'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationAccessible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locationType?: Resolver<ResolversTypes['LocationType'], ParentType, ContextType>;
  locationUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tillDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['DtnVendor']>, ParentType, ContextType>;
}>;

export type DtnVendorDeviceToLocationV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DtnVendorDeviceToLocationV2'] = ResolversParentTypes['DtnVendorDeviceToLocationV2']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['DtnVendorDevice'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationAccessible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locationType?: Resolver<ResolversTypes['LocationType'], ParentType, ContextType>;
  locationUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  tillDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['DtnVendor'], ParentType, ContextType>;
}>;

export type DtnVendorKeyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DtnVendorKey'] = ResolversParentTypes['DtnVendorKey']> = ResolversObject<{
  apiKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiSecret?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  devices?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorKeyDevice']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['DtnVendor']>, ParentType, ContextType>;
}>;

export type DtnVendorKeyDeviceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['DtnVendorKeyDevice'] = ResolversParentTypes['DtnVendorKeyDevice']> = ResolversObject<{
  deviceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type EmergenceAnalysisImageResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EmergenceAnalysisImageResult'] = ResolversParentTypes['EmergenceAnalysisImageResult']> = ResolversObject<{
  areaMeasured?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  imageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  numberOfPlants?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  svgUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type EmergenceAnalysisResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EmergenceAnalysisResult'] = ResolversParentTypes['EmergenceAnalysisResult']> = ResolversObject<{
  averageNumberOfPlantsPerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageNumberOfPlantsPerImage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  imageResults?: Resolver<Maybe<Array<Maybe<ResolversTypes['EmergenceAnalysisImageResult']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ScoutingPoiResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EntityHistoryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EntityHistory'] = ResolversParentTypes['EntityHistory']> = ResolversObject<{
  entityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isDeleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  modifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['EntityModification']>>>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
}>;

export type EntityModificationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EntityModification'] = ResolversParentTypes['EntityModification']> = ResolversObject<{
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type EscalationContactResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EscalationContact'] = ResolversParentTypes['EscalationContact']> = ResolversObject<{
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type EvidenceFileResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EvidenceFile'] = ResolversParentTypes['EvidenceFile']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type EvidenceFilesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EvidenceFiles'] = ResolversParentTypes['EvidenceFiles']> = ResolversObject<{
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
}>;

export type EvidenceReceiptResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['EvidenceReceipt'] = ResolversParentTypes['EvidenceReceipt']> = ResolversObject<{
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ExatrekApplicationMapDispatchOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExatrekApplicationMapDispatchOrder'] = ResolversParentTypes['ExatrekApplicationMapDispatchOrder']> = ResolversObject<{
  abLineUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  dispatchDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  exportForm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['ExatrekApplicationMapDispatchOrderFormat']>, ParentType, ContextType>;
  includeBoundary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ExatrekApplicationMapDispatchOrderStatus']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['ExatrekApplicationMapDispatchOrderTaskType']>, ParentType, ContextType>;
  taskUuids?: Resolver<Array<ResolversTypes['UUID']>, ParentType, ContextType>;
  terminalUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  userDeviceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ExatrekDeviceStateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExatrekDeviceState'] = ResolversParentTypes['ExatrekDeviceState']> = ResolversObject<{
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firmwareVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastUpdateTime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  mac?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['ExatrekDeviceStatePosition']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  workstate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ExatrekDeviceStatePositionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExatrekDeviceStatePosition'] = ResolversParentTypes['ExatrekDeviceStatePosition']> = ResolversObject<{
  altitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ExatrekUserDeviceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExatrekUserDevice'] = ResolversParentTypes['ExatrekUserDevice']> = ResolversObject<{
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceState?: Resolver<Maybe<ResolversTypes['ExatrekDeviceState']>, ParentType, ContextType>;
  etag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ExatrekUserMachineResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExatrekUserMachine'] = ResolversParentTypes['ExatrekUserMachine']> = ResolversObject<{
  etag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  manufacturerUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  modelUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tcActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tcCompatModeActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  typeUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  usbMode?: Resolver<ResolversTypes['ExatrekUsbMode'], ParentType, ContextType>;
  userDevice?: Resolver<ResolversTypes['ExatrekUserDevice'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ExecutionZoneStrategyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExecutionZoneStrategy'] = ResolversParentTypes['ExecutionZoneStrategy']> = ResolversObject<{
  adeSavings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adeSprayedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adeTotalArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  smartSprayerRegistration?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistration']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['ZoneSpecificStrategy']>, ParentType, ContextType>;
}>;

export type ExistingOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExistingOrder'] = ResolversParentTypes['ExistingOrder']> = ResolversObject<{
  affiliateCodeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currencyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  invoiceUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenses?: Resolver<Maybe<Array<Maybe<ResolversTypes['PurchasedLicense']>>>, ParentType, ContextType>;
  magentoOrderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  magentoOrderObjectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  paidAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parentExistingOrderUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  shopDevicePackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopDevicePackage']>>>, ParentType, ContextType>;
  shopFarmPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopFarmPackage']>>>, ParentType, ContextType>;
  shopUserPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopUserPackage']>>>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['OrderState']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ExportOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ExportOrder'] = ResolversParentTypes['ExportOrder']> = ResolversObject<{
  status?: Resolver<Maybe<ResolversTypes['ExportOrderStatus']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FdlSourceUnionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FDLSourceUnion'] = ResolversParentTypes['FDLSourceUnion']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DosedMap' | 'DroneFlight' | 'FieldDataLayer' | 'SourceMap', ParentType, ContextType>;
}>;

export type FactorLevelFieldZoneMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FactorLevelFieldZoneMapping'] = ResolversParentTypes['FactorLevelFieldZoneMapping']> = ResolversObject<{
  factorLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fieldZone?: Resolver<Maybe<ResolversTypes['FieldZone']>, ParentType, ContextType>;
}>;

export type FailureMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FailureMap'] = ResolversParentTypes['FailureMap']> = ResolversObject<{
  failureLengthThresholdInCm?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statistics?: Resolver<Maybe<ResolversTypes['Statistic']>, ParentType, ContextType>;
}>;

export type FarmResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Farm'] = ResolversParentTypes['Farm']> = ResolversObject<{
  access?: Resolver<Maybe<ResolversTypes['Access']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  creatorUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmFeatures?: Resolver<Maybe<ResolversTypes['FarmFeatures']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmFeature']>>>, ParentType, ContextType>;
  fieldInputPackaging?: Resolver<Maybe<ResolversTypes['FieldInputPackaging']>, ParentType, ContextType>;
  fields?: Resolver<Array<Maybe<ResolversTypes['Field']>>, ParentType, ContextType>;
  fieldsV2?: Resolver<Array<Maybe<ResolversTypes['FieldV2']>>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  legalEntityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FarmCarbonIntensityIndicatorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmCarbonIntensityIndicator'] = ResolversParentTypes['FarmCarbonIntensityIndicator']> = ResolversObject<{
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  currentFieldsAverageScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currentFieldsCropSeasonUuids?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  currentFieldsTotalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  submittedFieldsAverageScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  submittedFieldsCropSeasonUuids?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  submittedFieldsTotalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sustainabilityProgramUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type FarmCountryCropGrowthStagePredictionsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmCountryCropGrowthStagePredictions'] = ResolversParentTypes['FarmCountryCropGrowthStagePredictions']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  growthStages?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>>>, ParentType, ContextType>;
}>;

export type FarmCropMetricsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmCropMetrics'] = ResolversParentTypes['FarmCropMetrics']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  totalActiveCropSeasonArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FarmDataLayerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmDataLayer'] = ResolversParentTypes['FarmDataLayer']> = ResolversObject<{
  legend?: Resolver<Maybe<ResolversTypes['FarmDataLayerLegend']>, ParentType, ContextType>;
  magnitude?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  parameters?: Resolver<Maybe<ResolversTypes['WmsParameters']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FieldDataLayerType']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FarmDataLayerLegendResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmDataLayerLegend'] = ResolversParentTypes['FarmDataLayerLegend']> = ResolversObject<{
  entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['LegendEntry']>>>, ParentType, ContextType>;
  legendType?: Resolver<Maybe<ResolversTypes['LegendType']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['MagnitudeUnit']>, ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FarmEvidenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidence'] = ResolversParentTypes['FarmEvidence']> = ResolversObject<{
  averageCiScore?: Resolver<Maybe<ResolversTypes['FarmEvidenceAverageCiScore']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['FarmEvidenceLinks']>, ParentType, ContextType>;
  program?: Resolver<Maybe<ResolversTypes['FarmEvidenceProgram']>, ParentType, ContextType>;
  records?: Resolver<Maybe<ResolversTypes['FarmEvidenceRecords']>, ParentType, ContextType>;
}>;

export type FarmEvidenceAcceptedTermResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceAcceptedTerm'] = ResolversParentTypes['FarmEvidenceAcceptedTerm']> = ResolversObject<{
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FarmEvidenceAcceptedTermsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceAcceptedTerms'] = ResolversParentTypes['FarmEvidenceAcceptedTerms']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceAcceptedTerm']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FarmEvidenceAgExpertStatementResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceAgExpertStatement'] = ResolversParentTypes['FarmEvidenceAgExpertStatement']> = ResolversObject<{
  certificationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certificationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credentials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FarmEvidenceAgExpertStatementsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceAgExpertStatements'] = ResolversParentTypes['FarmEvidenceAgExpertStatements']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceAgExpertStatement']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FarmEvidenceAuditResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceAudit'] = ResolversParentTypes['FarmEvidenceAudit']> = ResolversObject<{
  auditDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FarmEvidenceAuditsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceAudits'] = ResolversParentTypes['FarmEvidenceAudits']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceAudit']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FarmEvidenceAverageCiScoreResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceAverageCiScore'] = ResolversParentTypes['FarmEvidenceAverageCiScore']> = ResolversObject<{
  crops?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceCropScore']>>>, ParentType, ContextType>;
}>;

export type FarmEvidenceCertificationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceCertification'] = ResolversParentTypes['FarmEvidenceCertification']> = ResolversObject<{
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FarmEvidenceCertificationsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceCertifications'] = ResolversParentTypes['FarmEvidenceCertifications']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceCertification']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FarmEvidenceCropScoreResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceCropScore'] = ResolversParentTypes['FarmEvidenceCropScore']> = ResolversObject<{
  averageCiScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  scoreUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FarmEvidenceFieldBucketsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceFieldBuckets'] = ResolversParentTypes['FarmEvidenceFieldBuckets']> = ResolversObject<{
  complete?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceFieldCount']>>>, ParentType, ContextType>;
  open?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceFieldCount']>>>, ParentType, ContextType>;
  total?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceFieldCount']>>>, ParentType, ContextType>;
  withVerifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceFieldCount']>>>, ParentType, ContextType>;
}>;

export type FarmEvidenceFieldCountResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceFieldCount'] = ResolversParentTypes['FarmEvidenceFieldCount']> = ResolversObject<{
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  missing?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type FarmEvidenceLinkResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceLink'] = ResolversParentTypes['FarmEvidenceLink']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordType?: Resolver<Maybe<ResolversTypes['FarmEvidenceLinkRecordType']>, ParentType, ContextType>;
  recordUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  removed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  removedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sustainabilityProgramUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FarmEvidenceLinksResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceLinks'] = ResolversParentTypes['FarmEvidenceLinks']> = ResolversObject<{
  agExpertStatements?: Resolver<Maybe<ResolversTypes['FarmEvidenceAgExpertStatements']>, ParentType, ContextType>;
  audits?: Resolver<Maybe<ResolversTypes['FarmEvidenceAudits']>, ParentType, ContextType>;
  certifications?: Resolver<Maybe<ResolversTypes['FarmEvidenceCertifications']>, ParentType, ContextType>;
  manureSources?: Resolver<Maybe<ResolversTypes['FarmEvidenceManureSources']>, ParentType, ContextType>;
}>;

export type FarmEvidenceManureSourceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceManureSource'] = ResolversParentTypes['FarmEvidenceManureSource']> = ResolversObject<{
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  livestockType?: Resolver<Maybe<ResolversTypes['EvidenceLivestockType']>, ParentType, ContextType>;
  managementSystem?: Resolver<Maybe<ResolversTypes['EvidenceManagementSystem']>, ParentType, ContextType>;
  manureType?: Resolver<Maybe<ResolversTypes['EvidenceManureType']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FarmEvidenceManureSourcesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceManureSources'] = ResolversParentTypes['FarmEvidenceManureSources']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceManureSource']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FarmEvidenceProgramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceProgram'] = ResolversParentTypes['FarmEvidenceProgram']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportDue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FarmEvidenceRecordsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmEvidenceRecords'] = ResolversParentTypes['FarmEvidenceRecords']> = ResolversObject<{
  acceptedTerms?: Resolver<Maybe<ResolversTypes['FarmEvidenceAcceptedTerms']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<ResolversTypes['FarmEvidenceFieldBuckets']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['FarmEvidenceRecordsState']>, ParentType, ContextType>;
}>;

export type FarmFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmFeature'] = ResolversParentTypes['FarmFeature']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['FeatureName']>, ParentType, ContextType>;
  needsActivation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageType?: Resolver<Maybe<ResolversTypes['PackageType']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type FarmFeaturesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmFeatures'] = ResolversParentTypes['FarmFeatures']> = ResolversObject<{
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  freeOfCharge?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mapping?: Resolver<Maybe<ResolversTypes['FarmFeaturesStatus']>, ParentType, ContextType>;
  mappingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  mappingValidTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  timing?: Resolver<Maybe<ResolversTypes['FarmFeaturesStatus']>, ParentType, ContextType>;
  timingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  timingValidTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type FarmFeaturesSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmFeaturesSummary'] = ResolversParentTypes['FarmFeaturesSummary']> = ResolversObject<{
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  farm?: Resolver<ResolversTypes['FarmV2'], ParentType, ContextType>;
  featureName?: Resolver<ResolversTypes['FeatureName'], ParentType, ContextType>;
  fieldCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type FarmGreetCarbonIntensityScoreResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmGreetCarbonIntensityScore'] = ResolversParentTypes['FarmGreetCarbonIntensityScore']> = ResolversObject<{
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  currentFieldsAverageScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currentFieldsCropSeasonUuids?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  currentFieldsTotalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  scoreUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedFieldsAverageScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  submittedFieldsCropSeasonUuids?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  submittedFieldsTotalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sustainabilityProgramUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type FarmLayerSummaryCountResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmLayerSummaryCount'] = ResolversParentTypes['FarmLayerSummaryCount']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['FieldDataLayerSourceType']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FieldDataLayerType']>, ParentType, ContextType>;
}>;

export type FarmPackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmPackage'] = ResolversParentTypes['FarmPackage']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  needsActivation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  purchaseDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityLeft?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityType?: Resolver<Maybe<ResolversTypes['FarmPackageQuantityType']>, ParentType, ContextType>;
  sourceType?: Resolver<ResolversTypes['FarmPackageSourceType'], ParentType, ContextType>;
  sourceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FarmPackageType']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type FarmPackageConsumptionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmPackageConsumption'] = ResolversParentTypes['FarmPackageConsumption']> = ResolversObject<{
  consumptionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  farmPackage?: Resolver<ResolversTypes['FarmPackage'], ParentType, ContextType>;
  quantityConsumed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalQuantityRequired?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FarmReceiptResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmReceipt'] = ResolversParentTypes['FarmReceipt']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  farmV2?: Resolver<ResolversTypes['FarmV2'], ParentType, ContextType>;
  fileBatchUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  receiptKind?: Resolver<Array<ResolversTypes['FarmReceiptKind']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FarmReceiptReferenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmReceiptReference'] = ResolversParentTypes['FarmReceiptReference']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  objectType?: Resolver<ResolversTypes['FarmReceiptReferenceObjectType'], ParentType, ContextType>;
  objectUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  receiptUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FarmUuidResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmUuid'] = ResolversParentTypes['FarmUuid']> = ResolversObject<{
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FarmV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FarmV2'] = ResolversParentTypes['FarmV2']> = ResolversObject<{
  billingAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  collaborators?: Resolver<Maybe<Array<Maybe<ResolversTypes['Collaborator']>>>, ParentType, ContextType>;
  countrySecondLevelSubDivision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countrySubDivision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropNutritionReportConfiguration?: Resolver<Maybe<ResolversTypes['CropNutritionReportConfiguration']>, ParentType, ContextType>;
  cropSeasonStatusReportEmailSubscriptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonStatusReportEmailSubscription']>>>, ParentType, ContextType>;
  currentUserPermission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType>;
  droneFlightQuotas?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightQuota']>>>, ParentType, ContextType>;
  energyConsumptionRateDiesel?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateElectricity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateGasoline?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateLiquefiedPetroleumGas?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateNaturalGas?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  existingOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExistingOrder']>>>, ParentType, ContextType>;
  farmActiveGrowthStages?: Resolver<Maybe<ResolversTypes['FarmCountryCropGrowthStagePredictions']>, ParentType, ContextType, Partial<FarmV2FarmActiveGrowthStagesArgs>>;
  farmType?: Resolver<Maybe<ResolversTypes['FarmType']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmFeature']>>>, ParentType, ContextType>;
  fieldInputPackaging?: Resolver<Maybe<ResolversTypes['FieldInputPackaging']>, ParentType, ContextType>;
  fieldSummary?: Resolver<Maybe<ResolversTypes['FieldSummary']>, ParentType, ContextType>;
  fieldsV2?: Resolver<Maybe<Array<ResolversTypes['FieldV2']>>, ParentType, ContextType, Partial<FarmV2FieldsV2Args>>;
  grower?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  hfAlerts?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfAlert']>>>, ParentType, ContextType>;
  hfDiscounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfDiscount']>>>, ParentType, ContextType>;
  hfServiceRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['HFServiceRequest']>>>, ParentType, ContextType>;
  importOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ImportOrder']>>>, ParentType, ContextType>;
  isCombinedUsageType?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMyFarm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  jdNotificationSubscriptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['JdNotificationSubscription']>>>, ParentType, ContextType>;
  kwsConsent?: Resolver<Maybe<ResolversTypes['KwsConsent']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  latestScoutingTask?: Resolver<Maybe<ResolversTypes['ScoutingTask']>, ParentType, ContextType, Partial<FarmV2LatestScoutingTaskArgs>>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  legalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalEntityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  packages?: Resolver<Maybe<Array<ResolversTypes['FarmPackage']>>, ParentType, ContextType, Partial<FarmV2PackagesArgs>>;
  recentlyUsedProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecentlyUsedProduct']>>>, ParentType, ContextType, Partial<FarmV2RecentlyUsedProductsArgs>>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  specialisedUsageType?: Resolver<Maybe<ResolversTypes['SpecialisedUsageType']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  tenantUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatmentScenarios?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentScenario']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weather?: Resolver<Maybe<Array<Maybe<ResolversTypes['Weather']>>>, ParentType, ContextType, RequireFields<FarmV2WeatherArgs, 'fromDate' | 'tillDate'>>;
  weatherV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeatherV2']>>>, ParentType, ContextType, RequireFields<FarmV2WeatherV2Args, 'fromDate' | 'tillDate'>>;
}>;

export type FieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Field'] = ResolversParentTypes['Field']> = ResolversObject<{
  area?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  boundarySvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeason']>>>, ParentType, ContextType, RequireFields<FieldCropSeasonsArgs, 'lifecycleState'>>;
  farm?: Resolver<Maybe<ResolversTypes['Farm']>, ParentType, ContextType>;
  fieldDataLayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  soilTaxonomy?: Resolver<Maybe<ResolversTypes['SoilTaxonomy']>, ParentType, ContextType>;
  soilTexture?: Resolver<Maybe<ResolversTypes['SoilTexture']>, ParentType, ContextType>;
  sprayWeather?: Resolver<Maybe<Array<Maybe<ResolversTypes['SprayWeather']>>>, ParentType, ContextType, RequireFields<FieldSprayWeatherArgs, 'fromDate' | 'toDate'>>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weather?: Resolver<Maybe<Array<Maybe<ResolversTypes['Weather']>>>, ParentType, ContextType, RequireFields<FieldWeatherArgs, 'fromDate' | 'tillDate'>>;
}>;

export type FieldActivationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldActivation'] = ResolversParentTypes['FieldActivation']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmPackageConsumptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmPackageConsumption']>>>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  package?: Resolver<ResolversTypes['Package'], ParentType, ContextType>;
  quantityConsumed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityPending?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FieldActivationStatus'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type FieldBoundaryLookupScoreResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldBoundaryLookupScore'] = ResolversParentTypes['FieldBoundaryLookupScore']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldDataDataMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataDataMapping'] = ResolversParentTypes['FieldDataDataMapping']> = ResolversObject<{
  columnIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  columnName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  measurement?: Resolver<Maybe<ResolversTypes['FieldDataMeasurement']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FieldDataLayerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataLayer'] = ResolversParentTypes['FieldDataLayer']> = ResolversObject<{
  applicationTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataUploadApplicationType']>>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  droneFlight?: Resolver<Maybe<ResolversTypes['DroneFlight']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['Field']>, ParentType, ContextType>;
  fieldDataLayerLegends?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayerLegend']>>>, ParentType, ContextType, Partial<FieldDataLayerFieldDataLayerLegendsArgs>>;
  fieldDataLayerStatistics?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayerStatistics']>>>, ParentType, ContextType, Partial<FieldDataLayerFieldDataLayerStatisticsArgs>>;
  fieldV2?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  magnitudeStrategy?: Resolver<Maybe<ResolversTypes['MagnitudeStrategy']>, ParentType, ContextType>;
  magnitudes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Magnitude']>>>, ParentType, ContextType>;
  mbTilesUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['FDLSourceUnion']>, ParentType, ContextType>;
  sourceDescription?: Resolver<Maybe<ResolversTypes['FieldDataLayerSourceProperty']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['FieldDataLayerSourceType']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['TaskType']>, ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FieldDataLayerType']>, ParentType, ContextType>;
  typeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  vectorTilesStyleUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorTilesUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wmsParameters?: Resolver<Maybe<ResolversTypes['WmsParameters']>, ParentType, ContextType>;
  wmsUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FieldDataLayerClassificationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataLayerClassification'] = ResolversParentTypes['FieldDataLayerClassification']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classificationEntries?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayerClassificationEntry']>>>, ParentType, ContextType>;
  classificationType?: Resolver<Maybe<ResolversTypes['LegendType']>, ParentType, ContextType>;
  elevation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldDataLayerUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  magnitudeType?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  maxElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingType?: Resolver<Maybe<ResolversTypes['ProcessingType']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['MagnitudeUnit']>, ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldDataLayerClassificationEntryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataLayerClassificationEntry'] = ResolversParentTypes['FieldDataLayerClassificationEntry']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  featureId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldDataLayerLegendResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataLayerLegend'] = ResolversParentTypes['FieldDataLayerLegend']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['LegendEntry']>>>, ParentType, ContextType>;
  fieldDataLayer?: Resolver<Maybe<ResolversTypes['FieldDataLayer']>, ParentType, ContextType, Partial<FieldDataLayerLegendFieldDataLayerArgs>>;
  fieldDataLayerUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  legendType?: Resolver<Maybe<ResolversTypes['LegendType']>, ParentType, ContextType>;
  magnitude?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  magnitudeType?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  maxElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingType?: Resolver<Maybe<ResolversTypes['ProcessingType']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['MagnitudeUnit']>, ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldDataLayerSourcePropertyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataLayerSourceProperty'] = ResolversParentTypes['FieldDataLayerSourceProperty']> = ResolversObject<{
  cloudCover?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['FieldDataLayerSourceProvider']>, ParentType, ContextType>;
  weeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['Weed']>>>, ParentType, ContextType>;
}>;

export type FieldDataLayerStatisticsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataLayerStatistics'] = ResolversParentTypes['FieldDataLayerStatistics']> = ResolversObject<{
  average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldDataLayerUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  magnitudeType?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingType?: Resolver<Maybe<ResolversTypes['ProcessingType']>, ParentType, ContextType>;
  regionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['MagnitudeUnit']>, ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldDataUploadDatasetResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataUploadDataset'] = ResolversParentTypes['FieldDataUploadDataset']> = ResolversObject<{
  applicationTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataUploadApplicationType']>>>, ParentType, ContextType>;
  boundary?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  boundaryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dataMapping?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataDataMapping']>>>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  fieldV2?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['UploadDatasetFormat']>, ParentType, ContextType>;
  geometryType?: Resolver<Maybe<ResolversTypes['UploadDatasetGeometryType']>, ParentType, ContextType>;
  hasDeletedFieldDataLayers?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  includedFileUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  includedFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  missingInfo?: Resolver<Maybe<ResolversTypes['FieldDataUploadDatasetMissingInfo']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['FileSource']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['UploadDatasetStatus']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['TaskType']>, ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UploadDatasetType']>, ParentType, ContextType>;
  uploadDatasetGroupUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uploadDatasetTotals?: Resolver<Maybe<Array<Maybe<ResolversTypes['UploadDatasetTotal']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  workingWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldDataUploadDatasetMissingInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataUploadDatasetMissingInfo'] = ResolversParentTypes['FieldDataUploadDatasetMissingInfo']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['FieldDataUploadDatasetMissingInfoCropSeason']>, ParentType, ContextType>;
  dataMapping?: Resolver<Maybe<Array<Maybe<ResolversTypes['MissingInfoDataMapping']>>>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['MissingInfoDate']>, ParentType, ContextType>;
  exampleData?: Resolver<Maybe<Array<Maybe<ResolversTypes['MissingInfoExampleData']>>>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldDataUploadDatasetMissingInfoField']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['MissingInfoUploadDatasetType']>, ParentType, ContextType>;
}>;

export type FieldDataUploadDatasetMissingInfoCropSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataUploadDatasetMissingInfoCropSeason'] = ResolversParentTypes['FieldDataUploadDatasetMissingInfoCropSeason']> = ResolversObject<{
  bestGuess?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  possibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonV2']>>>, ParentType, ContextType>;
}>;

export type FieldDataUploadDatasetMissingInfoFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldDataUploadDatasetMissingInfoField'] = ResolversParentTypes['FieldDataUploadDatasetMissingInfoField']> = ResolversObject<{
  bestGuess?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  possibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldV2']>>>, ParentType, ContextType>;
}>;

export type FieldEntryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEntry'] = ResolversParentTypes['FieldEntry']> = ResolversObject<{
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldEvidenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidence'] = ResolversParentTypes['FieldEvidence']> = ResolversObject<{
  carbonFarmingSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['FieldEvidenceCropSeason']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldEvidenceField']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['FieldEvidenceLinks']>, ParentType, ContextType>;
  program?: Resolver<Maybe<ResolversTypes['FieldEvidenceProgram']>, ParentType, ContextType>;
  records?: Resolver<Maybe<ResolversTypes['FieldEvidenceRecords']>, ParentType, ContextType>;
}>;

export type FieldEvidenceAphResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceAph'] = ResolversParentTypes['FieldEvidenceAph']> = ResolversObject<{
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceCiScoreResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceCiScore'] = ResolversParentTypes['FieldEvidenceCiScore']> = ResolversObject<{
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scoreUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FieldEvidenceCoverCropResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceCoverCrop'] = ResolversParentTypes['FieldEvidenceCoverCrop']> = ResolversObject<{
  seasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceCoverCropSeason']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceCoverCropSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceCoverCropSeason'] = ResolversParentTypes['FieldEvidenceCoverCropSeason']> = ResolversObject<{
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  photos?: Resolver<Maybe<ResolversTypes['EvidenceFiles']>, ParentType, ContextType>;
  receipts?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceReceipt']>>>, ParentType, ContextType>;
  seedingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  terminationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceCropSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceCropSeason'] = ResolversParentTypes['FieldEvidenceCropSeason']> = ResolversObject<{
  ciScore?: Resolver<Maybe<ResolversTypes['FieldEvidenceCiScore']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceExpectedYieldProofResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceExpectedYieldProof'] = ResolversParentTypes['FieldEvidenceExpectedYieldProof']> = ResolversObject<{
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  documentDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  insurer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proofType?: Resolver<Maybe<ResolversTypes['EvidenceExpectedYieldProofType']>, ParentType, ContextType>;
  publishedValueKgSqm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceField'] = ResolversParentTypes['FieldEvidenceField']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceHarvestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceHarvest'] = ResolversParentTypes['FieldEvidenceHarvest']> = ResolversObject<{
  aph?: Resolver<Maybe<ResolversTypes['FieldEvidenceAph']>, ParentType, ContextType>;
  averageExpectedYieldDry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageYieldDry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageYieldWet?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  expectedYieldProof?: Resolver<Maybe<ResolversTypes['FieldEvidenceExpectedYieldProof']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceHarvestTask']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  yieldSales?: Resolver<Maybe<ResolversTypes['FieldEvidenceYieldSales']>, ParentType, ContextType>;
}>;

export type FieldEvidenceHarvestTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceHarvestTask'] = ResolversParentTypes['FieldEvidenceHarvestTask']> = ResolversObject<{
  averageMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageYieldDry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageYieldWet?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceLandLeaseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLandLease'] = ResolversParentTypes['FieldEvidenceLandLease']> = ResolversObject<{
  endDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FieldEvidenceLandLeasesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLandLeases'] = ResolversParentTypes['FieldEvidenceLandLeases']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceLandLease']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceLandUseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLandUse'] = ResolversParentTypes['FieldEvidenceLandUse']> = ResolversObject<{
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceLandUsesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLandUses'] = ResolversParentTypes['FieldEvidenceLandUses']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceLandUse']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceLandownerReleaseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLandownerRelease'] = ResolversParentTypes['FieldEvidenceLandownerRelease']> = ResolversObject<{
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceLandownerReleasesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLandownerReleases'] = ResolversParentTypes['FieldEvidenceLandownerReleases']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceLandownerRelease']>>>, ParentType, ContextType>;
}>;

export type FieldEvidenceLinkResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLink'] = ResolversParentTypes['FieldEvidenceLink']> = ResolversObject<{
  carbonFarmingSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordType?: Resolver<Maybe<ResolversTypes['FieldEvidenceLinkRecordType']>, ParentType, ContextType>;
  recordUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  removed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  removedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  removedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FieldEvidenceLinksResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceLinks'] = ResolversParentTypes['FieldEvidenceLinks']> = ResolversObject<{
  landLease?: Resolver<Maybe<ResolversTypes['FieldEvidenceLandLeases']>, ParentType, ContextType>;
  landUse?: Resolver<Maybe<ResolversTypes['FieldEvidenceLandUses']>, ParentType, ContextType>;
  landownerRelease?: Resolver<Maybe<ResolversTypes['FieldEvidenceLandownerReleases']>, ParentType, ContextType>;
  manureTest?: Resolver<Maybe<ResolversTypes['FieldEvidenceManureTests']>, ParentType, ContextType>;
  soilTest?: Resolver<Maybe<ResolversTypes['FieldEvidenceSoilTests']>, ParentType, ContextType>;
}>;

export type FieldEvidenceManureTestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceManureTest'] = ResolversParentTypes['FieldEvidenceManureTest']> = ResolversObject<{
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  labReport?: Resolver<Maybe<ResolversTypes['EvidenceFiles']>, ParentType, ContextType>;
  nitrogenContent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FieldEvidenceManureTestsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceManureTests'] = ResolversParentTypes['FieldEvidenceManureTests']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceManureTest']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceNutritionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceNutrition'] = ResolversParentTypes['FieldEvidenceNutrition']> = ResolversObject<{
  nutritionPlan?: Resolver<Maybe<ResolversTypes['FieldEvidenceNutritionPlan']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceNutritionTask']>>>, ParentType, ContextType>;
  totalNitrogenApplied?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceNutritionPlanResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceNutritionPlan'] = ResolversParentTypes['FieldEvidenceNutritionPlan']> = ResolversObject<{
  basis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  expertCredentials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceFile']>>>, ParentType, ContextType>;
  planDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilTestUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceNutritionTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceNutritionTask'] = ResolversParentTypes['FieldEvidenceNutritionTask']> = ResolversObject<{
  applicationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  nitrogenApplied?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  receipts?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceReceipt']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceProgramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceProgram'] = ResolversParentTypes['FieldEvidenceProgram']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceRecordsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceRecords'] = ResolversParentTypes['FieldEvidenceRecords']> = ResolversObject<{
  coverCrop?: Resolver<Maybe<ResolversTypes['FieldEvidenceCoverCrop']>, ParentType, ContextType>;
  harvest?: Resolver<Maybe<ResolversTypes['FieldEvidenceHarvest']>, ParentType, ContextType>;
  nutrition?: Resolver<Maybe<ResolversTypes['FieldEvidenceNutrition']>, ParentType, ContextType>;
  seeding?: Resolver<Maybe<ResolversTypes['FieldEvidenceSeeding']>, ParentType, ContextType>;
  tillage?: Resolver<Maybe<ResolversTypes['FieldEvidenceTillage']>, ParentType, ContextType>;
}>;

export type FieldEvidenceSaleResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceSale'] = ResolversParentTypes['FieldEvidenceSale']> = ResolversObject<{
  averageMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ci?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receipts?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceReceipt']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  yieldDry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yieldWet?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldEvidenceSampleResultsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceSampleResults'] = ResolversParentTypes['FieldEvidenceSampleResults']> = ResolversObject<{
  pH?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldEvidenceSeedingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceSeeding'] = ResolversParentTypes['FieldEvidenceSeeding']> = ResolversObject<{
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceSeedingTask']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceSeedingTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceSeedingTask'] = ResolversParentTypes['FieldEvidenceSeedingTask']> = ResolversObject<{
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  receipts?: Resolver<Maybe<Array<Maybe<ResolversTypes['EvidenceReceipt']>>>, ParentType, ContextType>;
  seedingDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceSoilTestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceSoilTest'] = ResolversParentTypes['FieldEvidenceSoilTest']> = ResolversObject<{
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  labReport?: Resolver<Maybe<ResolversTypes['EvidenceFiles']>, ParentType, ContextType>;
  sampleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleResults?: Resolver<Maybe<ResolversTypes['FieldEvidenceSampleResults']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['EvidenceFileSource']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FieldEvidenceSoilTestsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceSoilTests'] = ResolversParentTypes['FieldEvidenceSoilTests']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceSoilTest']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceTDiscResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceTDisc'] = ResolversParentTypes['FieldEvidenceTDisc']> = ResolversObject<{
  mixingEfficiency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tillageDepth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldEvidenceTillageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceTillage'] = ResolversParentTypes['FieldEvidenceTillage']> = ResolversObject<{
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceTillageTask']>>>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceTillageTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceTillageTask'] = ResolversParentTypes['FieldEvidenceTillageTask']> = ResolversObject<{
  passes?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tDisc?: Resolver<Maybe<ResolversTypes['FieldEvidenceTDisc']>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldEvidenceYieldSalesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldEvidenceYieldSales'] = ResolversParentTypes['FieldEvidenceYieldSales']> = ResolversObject<{
  sales?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceSale']>>>, ParentType, ContextType>;
  totalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldFeature'] = ResolversParentTypes['FieldFeature']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['FeatureName']>>>, ParentType, ContextType>;
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isActivatedField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSponsoredField?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type FieldIdentifierScoreResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldIdentifierScore'] = ResolversParentTypes['FieldIdentifierScore']> = ResolversObject<{
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldIdentifierSavingScorePercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldInputPackagingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldInputPackaging'] = ResolversParentTypes['FieldInputPackaging']> = ResolversObject<{
  containerUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  fieldInputType?: Resolver<Maybe<ResolversTypes['FieldInputType']>, ParentType, ContextType>;
  fieldInputUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retracted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldNoteResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNote'] = ResolversParentTypes['FieldNote']> = ResolversObject<{
  attachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteAttachment']>>>, ParentType, ContextType>;
  audioAttachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteAudioAttachment']>>>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteCategory']>>>, ParentType, ContextType>;
  creationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  isAutoGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDeletionAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  locationType?: Resolver<Maybe<ResolversTypes['FieldNoteLocationType']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<ResolversTypes['FieldNoteObservation']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['FieldNotePriority']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  scoutingPoi?: Resolver<Maybe<ResolversTypes['ScoutingPoiV2']>, ParentType, ContextType>;
  scoutingTask?: Resolver<Maybe<ResolversTypes['ScoutingTask']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldNoteAggregationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteAggregation'] = ResolversParentTypes['FieldNoteAggregation']> = ResolversObject<{
  creators?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  cropAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteCropAggregation']>>>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  fieldNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldV2']>>>, ParentType, ContextType>;
}>;

export type FieldNoteAnswerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteAnswer'] = ResolversParentTypes['FieldNoteAnswer']> = ResolversObject<{
  assessmentTypeAnswerUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  importantGrowthStageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  numberOfFields?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numericalValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type FieldNoteAssessmentAggregationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteAssessmentAggregation'] = ResolversParentTypes['FieldNoteAssessmentAggregation']> = ResolversObject<{
  answers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteAnswer']>>>, ParentType, ContextType>;
  assessmentTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteImage']>>>, ParentType, ContextType>;
}>;

export type FieldNoteAttachmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteAttachment'] = ResolversParentTypes['FieldNoteAttachment']> = ResolversObject<{
  assessmentTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeletionAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldNoteAudioAttachmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteAudioAttachment'] = ResolversParentTypes['FieldNoteAudioAttachment']> = ResolversObject<{
  contentLength?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDeletionAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldNoteCropAggregationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteCropAggregation'] = ResolversParentTypes['FieldNoteCropAggregation']> = ResolversObject<{
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  maxImportantGrowthStage?: Resolver<Maybe<ResolversTypes['ImportantGrowthStage']>, ParentType, ContextType>;
  minImportantGrowthStage?: Resolver<Maybe<ResolversTypes['ImportantGrowthStage']>, ParentType, ContextType>;
  stressAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteStressAggregation']>>>, ParentType, ContextType>;
}>;

export type FieldNoteImageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteImage'] = ResolversParentTypes['FieldNoteImage']> = ResolversObject<{
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  imagePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type FieldNoteObservationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteObservation'] = ResolversParentTypes['FieldNoteObservation']> = ResolversObject<{
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  expert?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  importantStage?: Resolver<Maybe<ResolversTypes['ImportantGrowthStage']>, ParentType, ContextType>;
  leafCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  overriddenImportantGrowthStage?: Resolver<Maybe<ResolversTypes['ImportantGrowthStage']>, ParentType, ContextType>;
  plantDensity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stressAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressAnswer']>>>, ParentType, ContextType, Partial<FieldNoteObservationStressAnswersArgs>>;
  stressV2Answers?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingStressQuestion']>>>, ParentType, ContextType, Partial<FieldNoteObservationStressV2AnswersArgs>>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weather?: Resolver<Maybe<ResolversTypes['ObservationWeather']>, ParentType, ContextType>;
}>;

export type FieldNoteStressAggregationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldNoteStressAggregation'] = ResolversParentTypes['FieldNoteStressAggregation']> = ResolversObject<{
  assessmentAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteAssessmentAggregation']>>>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteImage']>>>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<FieldNoteStressAggregationStressArgs>>;
}>;

export type FieldPointLookupResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldPointLookup'] = ResolversParentTypes['FieldPointLookup']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
}>;

export type FieldSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldSummary'] = ResolversParentTypes['FieldSummary']> = ResolversObject<{
  activeCropSeasonCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalActiveCropSeasonArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldV2'] = ResolversParentTypes['FieldV2']> = ResolversObject<{
  abLines?: Resolver<Maybe<Array<Maybe<ResolversTypes['AbLine']>>>, ParentType, ContextType>;
  activations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldActivation']>>>, ParentType, ContextType>;
  agBalanceFieldInput?: Resolver<Maybe<ResolversTypes['AgBalanceFieldInput']>, ParentType, ContextType>;
  area?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  boundary?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  boundaryChecksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  boundarySvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carbonCredits?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonCredit']>>>, ParentType, ContextType>;
  carbonFarmingRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonFarmingRequest']>>>, ParentType, ContextType>;
  centreLatitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  centreLongitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  clayPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  cropSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeason']>>>, ParentType, ContextType, RequireFields<FieldV2CropSeasonsArgs, 'lifecycleState'>>;
  cropSeasonsV2?: Resolver<Maybe<Array<ResolversTypes['CropSeasonV2']>>, ParentType, ContextType, Partial<FieldV2CropSeasonsV2Args>>;
  currentWeedPredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CurrentWeedPrediction']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['Farm']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldFeature']>>>, ParentType, ContextType>;
  fieldDataLayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, ParentType, ContextType, RequireFields<FieldV2FieldDataLayersArgs, 'types'>>;
  fieldEntries?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEntry']>>>, ParentType, ContextType>;
  fieldNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, ParentType, ContextType, Partial<FieldV2FieldNotesArgs>>;
  fieldZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, ParentType, ContextType>;
  flik?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gravelPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  greenhouse?: Resolver<Maybe<ResolversTypes['Greenhouse']>, ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isInRedZone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  landUseTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  localSoilScale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localSoilTexture?: Resolver<Maybe<ResolversTypes['SoilTexture']>, ParentType, ContextType>;
  modifier?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  monitorPractices?: Resolver<Maybe<Array<Maybe<ResolversTypes['MonitorPractice']>>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  porosityLevel?: Resolver<Maybe<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  schlagnummer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoutingTasks?: Resolver<Maybe<Array<ResolversTypes['ScoutingTask']>>, ParentType, ContextType>;
  seedSelectorInputs?: Resolver<Maybe<Array<Maybe<ResolversTypes['SeedSelectorInput']>>>, ParentType, ContextType>;
  slopePercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilErosion?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilErosion']>>>, ParentType, ContextType>;
  soilOrganicMatterPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilSalinity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilSamplingResults?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingResult']>>>, ParentType, ContextType>;
  soilSamplings?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSampling']>>>, ParentType, ContextType>;
  soilTaxonomy?: Resolver<Maybe<ResolversTypes['SoilTaxonomy']>, ParentType, ContextType>;
  soilTexture?: Resolver<Maybe<ResolversTypes['SoilTexture']>, ParentType, ContextType>;
  sourceMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['SourceMap']>>>, ParentType, ContextType, Partial<FieldV2SourceMapsArgs>>;
  sprayWeather?: Resolver<Maybe<Array<Maybe<ResolversTypes['SprayWeather']>>>, ParentType, ContextType, RequireFields<FieldV2SprayWeatherArgs, 'fromDate' | 'toDate'>>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  tramlines?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tramline']>>>, ParentType, ContextType>;
  userDataVsValidationComparisons?: Resolver<Maybe<ResolversTypes['UserDataVsValidationComparison']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validityScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  varietyRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['VarietyRecommendation']>>>, ParentType, ContextType>;
  weather?: Resolver<Maybe<Array<Maybe<ResolversTypes['Weather']>>>, ParentType, ContextType, RequireFields<FieldV2WeatherArgs, 'fromDate' | 'tillDate'>>;
  weatherV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeatherV2']>>>, ParentType, ContextType, RequireFields<FieldV2WeatherV2Args, 'fromDate' | 'tillDate'>>;
  weedRecords?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeedRecord']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FieldVariabilityInSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldVariabilityInSeason'] = ResolversParentTypes['FieldVariabilityInSeason']> = ResolversObject<{
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldVariabilityIndexes?: Resolver<Array<ResolversTypes['FieldVariabilityInSeasonIndex']>, ParentType, ContextType>;
  seasonResolutionStatus?: Resolver<ResolversTypes['SeasonResolutionStatus'], ParentType, ContextType>;
  seasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FieldVariabilityInSeasonIndexResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldVariabilityInSeasonIndex'] = ResolversParentTypes['FieldVariabilityInSeasonIndex']> = ResolversObject<{
  coefficientOfVariation?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  index?: Resolver<ResolversTypes['AgronomicIndexType'], ParentType, ContextType>;
  quantileRange?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type FieldVariabilityIndexResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldVariabilityIndex'] = ResolversParentTypes['FieldVariabilityIndex']> = ResolversObject<{
  boundaryChecksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  indexStatus?: Resolver<Maybe<ResolversTypes['FieldVariabilityIndexStatus']>, ParentType, ContextType>;
  indexStatusDescriptionTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  indexStatusTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recommendedNumberOfZones?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  zones?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
}>;

export type FieldVariabilityInputResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldVariabilityInput'] = ResolversParentTypes['FieldVariabilityInput']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selectedYears?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedYear']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldVariabilityTimeSeriesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldVariabilityTimeSeries'] = ResolversParentTypes['FieldVariabilityTimeSeries']> = ResolversObject<{
  collection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldVariabilityIndexes?: Resolver<Array<ResolversTypes['FieldVariabilityTimeSeriesIndex']>, ParentType, ContextType>;
  observedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  seasonResolutionStatus?: Resolver<ResolversTypes['SeasonResolutionStatus'], ParentType, ContextType>;
  seasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stacItemUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FieldVariabilityTimeSeriesIndexResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldVariabilityTimeSeriesIndex'] = ResolversParentTypes['FieldVariabilityTimeSeriesIndex']> = ResolversObject<{
  coefficientOfVariation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['AgronomicIndexType']>, ParentType, ContextType>;
  quantileRange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type FieldZoneResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FieldZone'] = ResolversParentTypes['FieldZone']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfPolygons?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trials?: Resolver<Maybe<Array<Maybe<ResolversTypes['Trial']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FieldZoneType']>, ParentType, ContextType>;
  typeColor?: Resolver<Maybe<ResolversTypes['Color']>, ParentType, ContextType>;
  typeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FileResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = ResolversObject<{
  batchUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  deviceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  fieldUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  fileExtension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizeInBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['FileSource']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uploadDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type FmCarbonRelatedDataResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FmCarbonRelatedData'] = ResolversParentTypes['FmCarbonRelatedData']> = ResolversObject<{
  coverCropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  coverCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fieldBoundary?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  tillages?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonRelatedDataTillage']>>>, ParentType, ContextType>;
}>;

export type FootprintResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Footprint'] = ResolversParentTypes['Footprint']> = ResolversObject<{
  benchmarkTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorCropProtection?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorFertilizerProvision?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorFieldEmissions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorSeeds?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorTractorUse?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorWater?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ForeignCatchCropResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ForeignCatchCrop'] = ResolversParentTypes['ForeignCatchCrop']> = ResolversObject<{
  carryOverNitrogenPreviousYearCoverCrop?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  deDuevCropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ForeignCropResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ForeignCrop'] = ResolversParentTypes['ForeignCrop']> = ResolversObject<{
  allocationCoefficientCropResiduesFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  allocationCoefficientHarvestProductFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  allocationCoefficientRootsFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  allocationCoefficientStubbleFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  annualHumusCropResidue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  annualHumusDecayPerCrop?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  annualHumusRoots?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  carbonConcentrationCropResidueFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  crops?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropDictCode']>>>, ParentType, ContextType>;
  deDuevCropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultFreshMatterStateYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultStateCropNitrogenDemandRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultStateFreshMatterYieldDifference?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultStateMaximumNitrogenRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultStateNitrogenAdditionalValueMinus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultStateNitrogenAdditionalValuePlus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dryMatterConcentrationCropResidues?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nitrogenAllocationFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nitrogenConcentrationCropResidues?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nitrogenConcentrationHarvestProduct?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nitrogenDemandCalculation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recommendedNumberOfApplications?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recommendedTimingForApplications?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecommendedTimingForApplication']>>>, ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  yieldMultiplierFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ForeignPreCropResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ForeignPreCrop'] = ResolversParentTypes['ForeignPreCrop']> = ResolversObject<{
  carryOverNitrogenPreviousYearMainCrop?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  deDuevCropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FreshBiomassOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FreshBiomassOrder'] = ResolversParentTypes['FreshBiomassOrder']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FreshBiomassOrderStatus']>, ParentType, ContextType>;
  tillDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type FrostRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FrostRisk'] = ResolversParentTypes['FrostRisk']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isFrostRiskPresent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type FulfilledInterventionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['FulfilledIntervention'] = ResolversParentTypes['FulfilledIntervention']> = ResolversObject<{
  fulfilmentStatus?: Resolver<Maybe<ResolversTypes['FulfilmentStatus']>, ParentType, ContextType>;
  interventionType?: Resolver<Maybe<ResolversTypes['Intervention']>, ParentType, ContextType>;
}>;

export type GeneralTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GeneralTask'] = ResolversParentTypes['GeneralTask']> = ResolversObject<{
  assigneeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  creationFlowHint?: Resolver<Maybe<ResolversTypes['CreationFlowHint']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  generalStatus?: Resolver<ResolversTypes['GeneralTaskStatus'], ParentType, ContextType>;
  generalStatusDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  productCategoryCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductCategoryType']>>>, ParentType, ContextType>;
  taskDetails?: Resolver<ResolversTypes['GeneralTasksUnion'], ParentType, ContextType>;
  taskType?: Resolver<ResolversTypes['GeneralTaskType'], ParentType, ContextType>;
  taskUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type GeneralTasksUnionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GeneralTasksUnion'] = ResolversParentTypes['GeneralTasksUnion']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CropEstablishment' | 'CropResidueManagementTask' | 'DroneFlight' | 'GreenhouseWhiteningTask' | 'Harvest' | 'LandPreparation' | 'LeafPruningTask' | 'ProduceDeliveryTask' | 'ScoutingTask' | 'SeedBoxTreatment' | 'SeedTreatment' | 'SmartSprayingTaskV2' | 'SoilSamplingTask' | 'SprayingV2' | 'ToppingTask' | 'WaterManagementTask', ParentType, ContextType>;
}>;

export type GeoMapDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GeoMapDetail'] = ResolversParentTypes['GeoMapDetail']> = ResolversObject<{
  attribute?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  mapCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mapUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestDiseaseRegionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestDiseaseRegionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestDiseaseRegionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueOrig?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valueUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valueUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type GreenhouseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Greenhouse'] = ResolversParentTypes['Greenhouse']> = ResolversObject<{
  averageHeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  roofMaterialUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weatherV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeatherV2']>>>, ParentType, ContextType, RequireFields<GreenhouseWeatherV2Args, 'fromDate' | 'tillDate'>>;
}>;

export type GreenhouseWhiteningTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GreenhouseWhiteningTask'] = ResolversParentTypes['GreenhouseWhiteningTask']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GreetApplicationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GreetApplication'] = ResolversParentTypes['GreetApplication']> = ResolversObject<{
  applicationType?: Resolver<Maybe<ResolversTypes['GreetApplicationType']>, ParentType, ContextType>;
  avgRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  productUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sprayingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type GreetCarbonIntensityScoreResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GreetCarbonIntensityScore'] = ResolversParentTypes['GreetCarbonIntensityScore']> = ResolversObject<{
  appliedCropProtection?: Resolver<Maybe<Array<Maybe<ResolversTypes['GreetCropProtection']>>>, ParentType, ContextType>;
  appliedFertilizers?: Resolver<Maybe<Array<Maybe<ResolversTypes['GreetApplication']>>>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  carbonFarmingSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  coverCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  energyConsumptionRateDiesel?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateElectricity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateGasoline?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateLiquefiedPetroleumGas?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  energyConsumptionRateNaturalGas?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  harvestMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yieldExpectation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type GreetCropProtectionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GreetCropProtection'] = ResolversParentTypes['GreetCropProtection']> = ResolversObject<{
  avgRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  productUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sprayingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type GroupResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type GrowthStageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GrowthStage'] = ResolversParentTypes['GrowthStage']> = ResolversObject<{
  continuousIndex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  continuousLeafIndex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropGrowthStageV2?: Resolver<Maybe<ResolversTypes['CropGrowthStageV2']>, ParentType, ContextType, RequireFields<GrowthStageCropGrowthStageV2Args, 'languageCode'>>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  gsOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  leafCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['GrowthStageProvider']>, ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes['Scale']>, ParentType, ContextType>;
  scaleV2?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  simulationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type GrowthStagePredictionCalculatedPayloadResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GrowthStagePredictionCalculatedPayload'] = ResolversParentTypes['GrowthStagePredictionCalculatedPayload']> = ResolversObject<{
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type GrowthStagePredictionDailyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['GrowthStagePredictionDaily'] = ResolversParentTypes['GrowthStagePredictionDaily']> = ResolversObject<{
  accumulatedGrowingDegreeDays?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  berryDevelopmentPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  continuousIndex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  continuousLeafIndex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dailyGrowingDegreeDays?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  floweringPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gsOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inflorescenceEmissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  leafCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  leafEmissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['GrowthStageProvider']>, ParentType, ContextType>;
  ripeningPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type HfContractorEquipmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HFContractorEquipment'] = ResolversParentTypes['HFContractorEquipment']> = ResolversObject<{
  hasSectionControl?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasVRA?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  machineryLocation?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tankSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  terminal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  workingWidth2?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type HfContractorRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HFContractorRequest'] = ResolversParentTypes['HFContractorRequest']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  agreedPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  equipments?: Resolver<Maybe<Array<Maybe<ResolversTypes['HFContractorEquipment']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxCapacity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  onboardingAssigneeUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['HFContractorRequestStatus']>, ParentType, ContextType>;
  supportedConnectivityTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConnectionSource']>>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfServiceRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HFServiceRequest'] = ResolversParentTypes['HFServiceRequest']> = ResolversObject<{
  accessMode?: Resolver<Maybe<ResolversTypes['AccessMode']>, ParentType, ContextType>;
  appliedPriceCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  assignedAgScoutId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedAgronomicConsultantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedContractorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedCoordinatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['BillingAddress']>, ParentType, ContextType>;
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collaborator?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  connectivitySource?: Resolver<Maybe<ResolversTypes['ConnectivitySource']>, ParentType, ContextType>;
  contractorAgreementId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dateApproved?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  guidancePatternDistance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hfDiscounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfDiscount']>>>, ParentType, ContextType>;
  hfReferenceCode?: Resolver<Maybe<ResolversTypes['HfReferenceCode']>, ParentType, ContextType>;
  hfRiskClass?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfRiskClass']>>>, ParentType, ContextType>;
  historicalExtremeHeatDays?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isEyeSpotTreatmentRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFafRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPGRrequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRamulariaRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  magentoOrderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operationalReferenceCode?: Resolver<Maybe<ResolversTypes['HfReferenceCode']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['RateCategory']>>>, ParentType, ContextType>;
  orderReferenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preferredContractorComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pricePerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pricePerAreaUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  pricing?: Resolver<Maybe<ResolversTypes['Pricing']>, ParentType, ContextType>;
  programType?: Resolver<Maybe<ResolversTypes['ProgramType']>, ParentType, ContextType>;
  referenceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requesteeUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  secondaryApplicatorEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceTerm?: Resolver<Maybe<ResolversTypes['HfServiceTerm']>, ParentType, ContextType>;
  serviceType?: Resolver<Maybe<ResolversTypes['ServiceType']>, ParentType, ContextType>;
  shadowApplicatorEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Status']>, ParentType, ContextType>;
  totalBasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPgrPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HarvestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Harvest'] = ResolversParentTypes['Harvest']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clustersPerPlant?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  harvestMethodCode?: Resolver<Maybe<ResolversTypes['HarvestMethodCode']>, ParentType, ContextType>;
  harvestedProduceCode?: Resolver<Maybe<ResolversTypes['HarvestedProduceCode']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  yield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yieldProperties?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HfAddressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfAddress'] = ResolversParentTypes['HfAddress']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type HfAgRegionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfAgRegion'] = ResolversParentTypes['HfAgRegion']> = ResolversObject<{
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type HfAlertResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfAlert'] = ResolversParentTypes['HfAlert']> = ResolversObject<{
  alert?: Resolver<Maybe<ResolversTypes['Alert']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type HfClaimResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfClaim'] = ResolversParentTypes['HfClaim']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  assigneeUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['ClaimCategory']>>>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evaluation?: Resolver<Maybe<ResolversTypes['ClaimEvaluation']>, ParentType, ContextType>;
  fieldNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, ParentType, ContextType>;
  hfServiceRequest?: Resolver<Maybe<ResolversTypes['HFServiceRequest']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['HfClaimStatus'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfDiscountResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfDiscount'] = ResolversParentTypes['HfDiscount']> = ResolversObject<{
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  hfServiceRequest?: Resolver<Maybe<ResolversTypes['HFServiceRequest']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<ResolversTypes['HfDiscountUnit'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfDistributorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfDistributor'] = ResolversParentTypes['HfDistributor']> = ResolversObject<{
  address?: Resolver<ResolversTypes['HfAddress'], ParentType, ContextType>;
  distributorManagerId?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  distributorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  distributorPartner?: Resolver<ResolversTypes['DistributorPartner'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfFarmResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfFarm'] = ResolversParentTypes['HfFarm']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<ResolversTypes['FarmV2'], ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sapCreditor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sapDebtor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfInvoiceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfInvoice'] = ResolversParentTypes['HfInvoice']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hfServiceRequests?: Resolver<Array<ResolversTypes['HFServiceRequest']>, ParentType, ContextType>;
  invoiceReferenceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPaid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfMachineryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfMachinery'] = ResolversParentTypes['HfMachinery']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  depotLocation?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasSectionControl?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasVRA?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['Sprayer']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tankSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  terminal?: Resolver<Maybe<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  workingWidths?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
}>;

export type HfOfferResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfOffer'] = ResolversParentTypes['HfOffer']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hfServiceRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['HFServiceRequest']>>>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipientUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Status']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type HfOfferConditionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfOfferCondition'] = ResolversParentTypes['HfOfferCondition']> = ResolversObject<{
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  riskClass?: Resolver<Maybe<ResolversTypes['RiskClass']>, ParentType, ContextType>;
}>;

export type HfOperationalInstructionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfOperationalInstruction'] = ResolversParentTypes['HfOperationalInstruction']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  instruction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['HfLevel']>, ParentType, ContextType>;
  roleFeatureName?: Resolver<Maybe<ResolversTypes['RoleFeatureName']>, ParentType, ContextType>;
}>;

export type HfPreOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfPreOrder'] = ResolversParentTypes['HfPreOrder']> = ResolversObject<{
  cropQuotas?: Resolver<Maybe<Array<Maybe<ResolversTypes['PreOrderCropQuota']>>>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CommercialPartnerPreOrderStatus']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfPriceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfPrice'] = ResolversParentTypes['HfPrice']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  loyaltyDiscountAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  loyaltyDiscountEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  loyaltyDiscountPerArea?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  loyaltyDiscountPerAreaUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  pricePerArea?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pricePerAreaUnitUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  totalBasePrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalPgrPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type HfRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfRate'] = ResolversParentTypes['HfRate']> = ResolversObject<{
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rates?: Resolver<Maybe<Array<Maybe<ResolversTypes['RegionRate']>>>, ParentType, ContextType>;
}>;

export type HfReferenceCodeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfReferenceCode'] = ResolversParentTypes['HfReferenceCode']> = ResolversObject<{
  accessMode?: Resolver<Maybe<ResolversTypes['AccessMode']>, ParentType, ContextType>;
  assignedAgronomicConsultantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedCoordinatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  digitalServiceManager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  distributorUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  enabledCrops?: Resolver<Maybe<Array<ResolversTypes['Crop']>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hfDistributor?: Resolver<Maybe<ResolversTypes['HfDistributor']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  margins?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfReferenceCodeMargin']>>>, ParentType, ContextType>;
  offerModel?: Resolver<Maybe<ResolversTypes['OfferModel']>, ParentType, ContextType>;
  operationalReferenceCode?: Resolver<Maybe<ResolversTypes['HfReferenceCode']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['PublicOrganisation']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfReferenceCodeCategoryRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfReferenceCodeCategoryRate'] = ResolversParentTypes['HfReferenceCodeCategoryRate']> = ResolversObject<{
  category?: Resolver<Maybe<ResolversTypes['RateCategory']>, ParentType, ContextType>;
  rateInEuroPerHectare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type HfReferenceCodeMarginResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfReferenceCodeMargin'] = ResolversParentTypes['HfReferenceCodeMargin']> = ResolversObject<{
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  marginAbs?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type HfReferenceCodePublicResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfReferenceCodePublic'] = ResolversParentTypes['HfReferenceCodePublic']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabledCrops?: Resolver<Maybe<Array<ResolversTypes['Crop']>>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offerModel?: Resolver<Maybe<ResolversTypes['OfferModel']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['PublicOrganisation']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HfReferenceCodeRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfReferenceCodeRate'] = ResolversParentTypes['HfReferenceCodeRate']> = ResolversObject<{
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfReferenceCodeCategoryRate']>>>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  hfReferenceCodeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['PricingSeason']>, ParentType, ContextType>;
}>;

export type HfRequestFarmPackageAddOnResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfRequestFarmPackageAddOn'] = ResolversParentTypes['HfRequestFarmPackageAddOn']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  lastModifier?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  packageUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type HfRiskClassResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfRiskClass'] = ResolversParentTypes['HfRiskClass']> = ResolversObject<{
  riskClass?: Resolver<Maybe<ResolversTypes['HfServiceRequestAreaClassType']>, ParentType, ContextType>;
  varietyUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type HfSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfSeason'] = ResolversParentTypes['HfSeason']> = ResolversObject<{
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  seasonStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type HfWeatherDataResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HfWeatherData'] = ResolversParentTypes['HfWeatherData']> = ResolversObject<{
  actualExtremeHeatDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  currentGDD?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  floweringPeriodEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  floweringPeriodStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type HortaCropSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HortaCropSeason'] = ResolversParentTypes['HortaCropSeason']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fmCropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  hortaPreCropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HortaSprayingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HortaSpraying'] = ResolversParentTypes['HortaSpraying']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fmSpraying?: Resolver<Maybe<ResolversTypes['SprayingV2']>, ParentType, ContextType>;
  hortaCropProtectionDistributionModeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  hortaFertilizerDistributionModeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HortaStressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HortaStress'] = ResolversParentTypes['HortaStress']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatmentTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatmentTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treatmentTypeUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type HortaSustainabilityIndicatorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['HortaSustainabilityIndicator'] = ResolversParentTypes['HortaSustainabilityIndicator']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sustainabilityIndicators?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
}>;

export type ImageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageThumbnailPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  usage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ImportOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ImportOrder'] = ResolversParentTypes['ImportOrder']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  importedNumberOfFields?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ImportOrderStatus']>, ParentType, ContextType>;
  subjectId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ImportantGrowthStageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ImportantGrowthStage'] = ResolversParentTypes['ImportantGrowthStage']> = ResolversObject<{
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  cropGrowthStageV2?: Resolver<Maybe<ResolversTypes['CropGrowthStageV2']>, ParentType, ContextType, RequireFields<ImportantGrowthStageCropGrowthStageV2Args, 'languageCode'>>;
  cropGrowthStages?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropGrowthStage']>>>, ParentType, ContextType, RequireFields<ImportantGrowthStageCropGrowthStagesArgs, 'languageCode'>>;
  gsOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isMilestone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes['Scale']>, ParentType, ContextType>;
  scaleV2?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  shortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type IncubationLevelResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['IncubationLevel'] = ResolversParentTypes['IncubationLevel']> = ResolversObject<{
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  incubationLevel?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export interface IndexableObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['IndexableObject'], any> {
  name: 'IndexableObject';
}

export type IngredientResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Ingredient'] = ResolversParentTypes['Ingredient']> = ResolversObject<{
  averageApplicationRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productFormulationTypeGroup?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  productFormulationTypeGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalApplication?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type InviteCodeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['InviteCode'] = ResolversParentTypes['InviteCode']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  languageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type JdFieldSynchronizationOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['JdFieldSynchronizationOrder'] = ResolversParentTypes['JdFieldSynchronizationOrder']> = ResolversObject<{
  farmUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmUuid']>>>, ParentType, ContextType>;
  jdFieldSyncId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  jdOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['JdFieldSynchronizationOrderStatus']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type JdNotificationSubscriptionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['JdNotificationSubscription'] = ResolversParentTypes['JdNotificationSubscription']> = ResolversObject<{
  categories?: Resolver<Maybe<Array<ResolversTypes['JdNotificationSubscriptionCategory']>>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  jdOrganizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type KubotaApplicationMapDispatchOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['KubotaApplicationMapDispatchOrder'] = ResolversParentTypes['KubotaApplicationMapDispatchOrder']> = ResolversObject<{
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  errorReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['KubotaApplicationMapDispatchOrderStatus']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['KubotaApplicationMapDispatchOrderTaskType']>, ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type KubotaFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['KubotaField'] = ResolversParentTypes['KubotaField']> = ResolversObject<{
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type KwsConsentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['KwsConsent'] = ResolversParentTypes['KwsConsent']> = ResolversObject<{
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  proofOfPurchaseStatus?: Resolver<Maybe<ResolversTypes['ProofOfPurchaseStatus']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['KwsConsentStatus']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type KwsSupportedVarietyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['KwsSupportedVariety'] = ResolversParentTypes['KwsSupportedVariety']> = ResolversObject<{
  variety?: Resolver<Maybe<ResolversTypes['Variety']>, ParentType, ContextType, Partial<KwsSupportedVarietyVarietyArgs>>;
}>;

export type LandPreparationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['LandPreparation'] = ResolversParentTypes['LandPreparation']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  drainagePreparationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  tillageDepth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LeafDamageResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['LeafDamageResult'] = ResolversParentTypes['LeafDamageResult']> = ResolversObject<{
  highDamageAreaPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediumDamageAreaPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ScoutingPoiResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LeafPruningTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['LeafPruningTask'] = ResolversParentTypes['LeafPruningTask']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LegendEntryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['LegendEntry'] = ResolversParentTypes['LegendEntry']> = ResolversObject<{
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type LicenseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['License'] = ResolversParentTypes['License']> = ResolversObject<{
  activeSince?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  activeTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  associatedDevicePackages?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  associatedPackages?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  associatedUserPackages?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAvailableInAppStore?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentType?: Resolver<Maybe<ResolversTypes['PaymentType']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  requiredPackages?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['LicenseSellerType']>, ParentType, ContextType>;
  stockQty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type LicenseRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['LicenseRequest'] = ResolversParentTypes['LicenseRequest']> = ResolversObject<{
  approvedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<ResolversTypes['FarmV2'], ParentType, ContextType>;
  lastModifierUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  licenseUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  organisationMemberUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  seasonEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  seasonStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  shopFarmPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopFarmPackage']>>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LicenseRequestStatusType'], ParentType, ContextType>;
  statusColor?: Resolver<Maybe<ResolversTypes['ColorCx']>, ParentType, ContextType>;
  statusOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  statusTranslationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type LicenseRequestSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['LicenseRequestSeason'] = ResolversParentTypes['LicenseRequestSeason']> = ResolversObject<{
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type LinkedDeviceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['LinkedDevice'] = ResolversParentTypes['LinkedDevice']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devices?: Resolver<Maybe<Array<Maybe<ResolversTypes['VendorDeviceInfo']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type LocationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = ResolversObject<{
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type MagnitudeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Magnitude'] = ResolversParentTypes['Magnitude']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  classification?: Resolver<Maybe<ResolversTypes['FieldDataLayerClassification']>, ParentType, ContextType, Partial<MagnitudeClassificationArgs>>;
  dataReliability?: Resolver<Maybe<ResolversTypes['DataReliability']>, ParentType, ContextType>;
  elevation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldDataLayer?: Resolver<Maybe<ResolversTypes['FieldDataLayer']>, ParentType, ContextType>;
  geodataZipUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legend?: Resolver<Maybe<ResolversTypes['FieldDataLayerLegend']>, ParentType, ContextType, Partial<MagnitudeLegendArgs>>;
  magnitudeType?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  maxElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mbTilesUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processingType?: Resolver<Maybe<ResolversTypes['ProcessingType']>, ParentType, ContextType>;
  sourceInvalidReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['MagnitudeSourceInvalidReasonType']>>>, ParentType, ContextType>;
  statistics?: Resolver<Maybe<ResolversTypes['FieldDataLayerStatistics']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  typeDescriptionTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  typeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['MagnitudeUnit']>, ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  vectorTilesStyleUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorTilesUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wmsParameters?: Resolver<Maybe<ResolversTypes['WmsParameters']>, ParentType, ContextType>;
  wmsUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type MapItemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MapItem'] = ResolversParentTypes['MapItem']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fieldDataLayer?: Resolver<Maybe<ResolversTypes['FieldDataLayer']>, ParentType, ContextType>;
  fieldDataLayerType?: Resolver<Maybe<ResolversTypes['FieldDataLayerType']>, ParentType, ContextType>;
  mapType?: Resolver<Maybe<ResolversTypes['MapItemType']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['FieldDataLayerSourceType']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stacFieldDataLayerType?: Resolver<Maybe<ResolversTypes['StacFieldDataLayer']>, ParentType, ContextType>;
  stacItemUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['TaskType']>, ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type MappingFieldZoneResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MappingFieldZone'] = ResolversParentTypes['MappingFieldZone']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldZone?: Resolver<Maybe<ResolversTypes['FieldZone']>, ParentType, ContextType>;
  fixedRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FieldZoneType']>, ParentType, ContextType>;
}>;

export type Md2AggregatedProductusesByCropResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2AggregatedProductusesByCrop'] = ResolversParentTypes['Md2AggregatedProductusesByCrop']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type Md2ConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2Configuration'] = ResolversParentTypes['Md2Configuration']> = ResolversObject<{
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characteristicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  codes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stressCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type Md2CountryCropConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2CountryCropConfiguration'] = ResolversParentTypes['Md2CountryCropConfiguration']> = ResolversObject<{
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characteristicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type Md2DictionaryMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2DictionaryMapping'] = ResolversParentTypes['Md2DictionaryMapping']> = ResolversObject<{
  sourceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceDictName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceDictShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  targetCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetDictName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetDictShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type Md2ItemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2Item'] = ResolversParentTypes['Md2Item']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dictId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type Md2ProductFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2ProductFeature'] = ResolversParentTypes['Md2ProductFeature']> = ResolversObject<{
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characteristicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
  productCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valueCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
}>;

export type Md2TillageDepthResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2TillageDepth'] = ResolversParentTypes['Md2TillageDepth']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  tillageDepths?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tillages']>>>, ParentType, ContextType>;
}>;

export type Md2VraAdvisorConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2VraAdvisorConfiguration'] = ResolversParentTypes['Md2VraAdvisorConfiguration']> = ResolversObject<{
  applicationStrategyOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  dosageDistributionOptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
  doseRateStepPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fieldDataLayerConfigurations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2VraAdvisorFieldDataLayerConfiguration']>>>, ParentType, ContextType>;
  growthStageModelScale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minPolygonWidthInPixel?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minZoneSizeInM2?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  productCategoryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productCategoryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type Md2VraAdvisorFieldDataLayerConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Md2VraAdvisorFieldDataLayerConfiguration'] = ResolversParentTypes['Md2VraAdvisorFieldDataLayerConfiguration']> = ResolversObject<{
  applicationStrategyDefaultCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicationStrategyDefaultName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicationStrategyDefaultUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  dosageDistributionDefaultCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dosageDistributionDefaultName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dosageDistributionDefaultUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fdlTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fdlTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fdlTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  growthStageIntervalCodeFrom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growthStageIntervalCodeTill?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interval?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxMapPrimaryFdlAgeInDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  maxNumberOfZone?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfDaySeedingFdlFrom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfDaySeedingFdlTill?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offConcept?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  offLogic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type MdCoefficientOfVariationDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MdCoefficientOfVariationDetail'] = ResolversParentTypes['MdCoefficientOfVariationDetail']> = ResolversObject<{
  colourValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldVariabilityCategoryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldVariabilityCategoryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldVariabilityCategoryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  recommendedNumberOfZones?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valueMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type MdSoilNematodeRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MdSoilNematodeRisk'] = ResolversParentTypes['MdSoilNematodeRisk']> = ResolversObject<{
  assessmentObjectCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentObjectName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentObjectUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  numeratorUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numeratorUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numeratorUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  pestCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pestUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  riskCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  riskName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  riskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sampleSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valueMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  valueMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type MdUnitResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MdUnit'] = ResolversParentTypes['MdUnit']> = ResolversObject<{
  baseUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayUnitConversionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  displayUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitDenominatorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitDenominatorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitDenominatorUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  unitGroupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitGroupUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  unitNumeratorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitNumeratorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unitNumeratorUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validUnit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type MeasureSubmissionFieldOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionFieldOrder'] = ResolversParentTypes['MeasureSubmissionFieldOrder']> = ResolversObject<{
  carbonFarmingSeason?: Resolver<Maybe<ResolversTypes['CarbonFarmingSeason']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionFieldOrderError']>>>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeasureSubmissionStatus'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type MeasureSubmissionFieldOrderErrorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionFieldOrderError'] = ResolversParentTypes['MeasureSubmissionFieldOrderError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['MeasureSubmissionErrorCode'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type MeasureSubmissionFieldResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionFieldResult'] = ResolversParentTypes['MeasureSubmissionFieldResult']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ch4SoilPreliminaryCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  directN2OPreliminaryCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dsocPreliminaryCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  indirectN2OPreliminaryCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  postUncertaintyNonReversibleCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  postUncertaintyReversibleCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalNonReversiblePreliminaryCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPreliminaryCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReversiblePreliminaryCredit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weightedCreditShare?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type MeasureSubmissionOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionOrder'] = ResolversParentTypes['MeasureSubmissionOrder']> = ResolversObject<{
  baselineMethod?: Resolver<Maybe<ResolversTypes['BaselineMethod']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionFieldOrder']>>>, ParentType, ContextType>;
  finalizedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  projectName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statistics?: Resolver<ResolversTypes['MeasureSubmissionOrderStatistics'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MeasureSubmissionStatus'], ParentType, ContextType>;
  submissionMode?: Resolver<Maybe<ResolversTypes['MeasureSubmissionMode']>, ParentType, ContextType>;
  sustainabilityProgram?: Resolver<Maybe<ResolversTypes['SustainabilityProgram']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type MeasureSubmissionOrderStatisticsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionOrderStatistics'] = ResolversParentTypes['MeasureSubmissionOrderStatistics']> = ResolversObject<{
  numberOfFailedFields?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfFieldsToSubmit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numberOfSubmittedFields?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type MeasureSubmissionProjectLevelCropResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionProjectLevelCropResult'] = ResolversParentTypes['MeasureSubmissionProjectLevelCropResult']> = ResolversObject<{
  cropName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberOfFields?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCredits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalNonReversibleEmissionReductions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReversibleEmissionReductions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type MeasureSubmissionProjectLevelResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionProjectLevelResult'] = ResolversParentTypes['MeasureSubmissionProjectLevelResult']> = ResolversObject<{
  numberOfFields?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCredits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalNonReversibleEmissionReductions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReversibleEmissionReductions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalYield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type MeasureSubmissionResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MeasureSubmissionResult'] = ResolversParentTypes['MeasureSubmissionResult']> = ResolversObject<{
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionFieldResult']>>>, ParentType, ContextType>;
  measureSubmissionOrder?: Resolver<ResolversTypes['MeasureSubmissionOrder'], ParentType, ContextType>;
  projectLevelCropResults?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionProjectLevelCropResult']>>>, ParentType, ContextType>;
  projectLevelResult?: Resolver<Maybe<ResolversTypes['MeasureSubmissionProjectLevelResult']>, ParentType, ContextType>;
  projectLevelResultByCrop?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionProjectLevelCropResult']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type MeasurementResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Measurement'] = ResolversParentTypes['Measurement']> = ResolversObject<{
  assessmentObjectUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  displayUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  measurement?: Resolver<Maybe<ResolversTypes['SoilPropertyType']>, ParentType, ContextType>;
  siValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type MergedSmartSprayerExecutionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MergedSmartSprayerExecution'] = ResolversParentTypes['MergedSmartSprayerExecution']> = ResolversObject<{
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  executionDates?: Resolver<Maybe<Array<ResolversTypes['Date']>>, ParentType, ContextType>;
  externalTaskUuids?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  mergeOrigin?: Resolver<Maybe<ResolversTypes['MergeOrigin']>, ParentType, ContextType>;
  smartSprayerRegistrations?: Resolver<Array<ResolversTypes['SmartSprayerRegistration']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['MergedExecutionStatus']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type MissingInfoDataMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MissingInfoDataMapping'] = ResolversParentTypes['MissingInfoDataMapping']> = ResolversObject<{
  applicableColumns?: Resolver<Maybe<ResolversTypes['ApplicableColumn']>, ParentType, ContextType>;
  applicableUnits?: Resolver<Maybe<ResolversTypes['ApplicableUnit']>, ParentType, ContextType>;
  measurement?: Resolver<Maybe<ResolversTypes['FieldDataMeasurement']>, ParentType, ContextType>;
}>;

export type MissingInfoDateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MissingInfoDate'] = ResolversParentTypes['MissingInfoDate']> = ResolversObject<{
  bestGuess?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type MissingInfoExampleDataResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MissingInfoExampleData'] = ResolversParentTypes['MissingInfoExampleData']> = ResolversObject<{
  columnIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
}>;

export type MissingInfoUploadDatasetTypeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MissingInfoUploadDatasetType'] = ResolversParentTypes['MissingInfoUploadDatasetType']> = ResolversObject<{
  bestGuess?: Resolver<Maybe<ResolversTypes['UploadDatasetType']>, ParentType, ContextType>;
  possibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['UploadDatasetType']>>>, ParentType, ContextType>;
}>;

export type MonitorCoverCropResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MonitorCoverCrop'] = ResolversParentTypes['MonitorCoverCrop']> = ResolversObject<{
  coverCropConfidenceIndex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverCropDetected?: Resolver<Maybe<ResolversTypes['CoverCrop']>, ParentType, ContextType>;
}>;

export type MonitorPracticeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MonitorPractice'] = ResolversParentTypes['MonitorPractice']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  coverCrops?: Resolver<Maybe<Array<Maybe<ResolversTypes['MonitorCoverCrop']>>>, ParentType, ContextType>;
  cropUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  tillages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MonitorTillage']>>>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type MonitorTillageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MonitorTillage'] = ResolversParentTypes['MonitorTillage']> = ResolversObject<{
  confidenceIndex?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  tillageIntensity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type MultiFileResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MultiFile'] = ResolversParentTypes['MultiFile']> = ResolversObject<{
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  offsetInBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  partNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  s3UploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sizeInBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FileUploadStatus']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type MultiFileUploadOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MultiFileUploadOrder'] = ResolversParentTypes['MultiFileUploadOrder']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['MultiFile']>>>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['MultiFileSource']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FileUploadOrderStatus']>, ParentType, ContextType>;
  totalUploadSizeInBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uploadType?: Resolver<Maybe<ResolversTypes['MultiFileUploadType']>, ParentType, ContextType>;
  uploadedSizeInBytes?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type MultiWeedResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MultiWeedResult'] = ResolversParentTypes['MultiWeedResult']> = ResolversObject<{
  detectedWeeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['DetectedWeed']>>>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfWeeds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfWeedsPerSquareMeter?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ScoutingPoiResultStatus']>, ParentType, ContextType>;
  weedCoverage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  createCropSeasonStatusReportEmailSubscription?: Resolver<Maybe<ResolversTypes['CropSeasonStatusReportEmailSubscription']>, ParentType, ContextType, RequireFields<MutationCreateCropSeasonStatusReportEmailSubscriptionArgs, 'deliveryDays' | 'farmUuid' | 'locale'>>;
  createFarmReceipt?: Resolver<Maybe<ResolversTypes['FarmReceipt']>, ParentType, ContextType, RequireFields<MutationCreateFarmReceiptArgs, 'farmUuid' | 'fileBatchUuid' | 'receiptKind'>>;
  createFarmReceiptReference?: Resolver<Maybe<ResolversTypes['FarmReceiptReference']>, ParentType, ContextType, RequireFields<MutationCreateFarmReceiptReferenceArgs, 'objectType' | 'objectUuid' | 'receiptUuid'>>;
  createNodes?: Resolver<Array<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationCreateNodesArgs, 'payloads' | 'typename'>>;
  createPrecifieldCerealsMapSubscription?: Resolver<Maybe<ResolversTypes['PrecifieldCerealsMapSubscription']>, ParentType, ContextType, RequireFields<MutationCreatePrecifieldCerealsMapSubscriptionArgs, 'cropSeasonUuid' | 'nitrogenTargetRate' | 'productUuid' | 'yieldFiveYearOlympicAverage'>>;
  createRecommendationSnooze?: Resolver<Maybe<ResolversTypes['RecommendationSnooze']>, ParentType, ContextType, RequireFields<MutationCreateRecommendationSnoozeArgs, 'actionType' | 'cropSeasonUuid'>>;
  createSpraying?: Resolver<Maybe<ResolversTypes['Spraying']>, ParentType, ContextType, RequireFields<MutationCreateSprayingArgs, 'cropSeasonUuid' | 'plannedDate'>>;
  createSprayingV2?: Resolver<Maybe<ResolversTypes['SprayingV2']>, ParentType, ContextType, RequireFields<MutationCreateSprayingV2Args, 'cropSeasonUuid' | 'plannedDate'>>;
  deleteFarmReceipt?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType, RequireFields<MutationDeleteFarmReceiptArgs, 'uuid'>>;
  deleteFarmReceiptReference?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType, RequireFields<MutationDeleteFarmReceiptReferenceArgs, 'uuid'>>;
  deleteNodes?: Resolver<Array<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationDeleteNodesArgs, 'nodes'>>;
  replaceSmartSprayerWeedPressureExclusions?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureExclusionSet']>, ParentType, ContextType, RequireFields<MutationReplaceSmartSprayerWeedPressureExclusionsArgs, 'exclusions' | 'fieldUuid'>>;
  requestSmartSprayerWeedPressureRecalculation?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureRecalculation']>, ParentType, ContextType, RequireFields<MutationRequestSmartSprayerWeedPressureRecalculationArgs, 'reason'>>;
  updateFarmReceipt?: Resolver<Maybe<ResolversTypes['FarmReceipt']>, ParentType, ContextType, RequireFields<MutationUpdateFarmReceiptArgs, 'etag' | 'fileBatchUuid' | 'uuid'>>;
  updateNodes?: Resolver<Array<ResolversTypes['MutationResponse']>, ParentType, ContextType, RequireFields<MutationUpdateNodesArgs, 'nodes' | 'payloads'>>;
  updatePrecifieldCerealsMapSubscription?: Resolver<Maybe<ResolversTypes['PrecifieldCerealsMapSubscription']>, ParentType, ContextType, RequireFields<MutationUpdatePrecifieldCerealsMapSubscriptionArgs, 'cropSeasonUuid' | 'nitrogenTargetRate' | 'productUuid' | 'uuid' | 'yieldFiveYearOlympicAverage'>>;
}>;

export type MutationResponseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['MutationResponse'] = ResolversParentTypes['MutationResponse']> = ResolversObject<{
  context?: Resolver<Maybe<ResolversTypes['IndexableObject']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['ResponseStatus']>>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NodeWithTypename'], ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['IndexableObject']>, ParentType, ContextType>;
  restResponse?: Resolver<Maybe<ResolversTypes['IndexableObject']>, ParentType, ContextType>;
}>;

export type NamedCropMixResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NamedCropMix'] = ResolversParentTypes['NamedCropMix']> = ResolversObject<{
  crops?: Resolver<Array<ResolversTypes['CropMixDetail']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isCustom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRetracted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type NitrogenProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NitrogenProduct'] = ResolversParentTypes['NitrogenProduct']> = ResolversObject<{
  nutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientProduct']>>>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type NitrogenStatusResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NitrogenStatusResult'] = ResolversParentTypes['NitrogenStatusResult']> = ResolversObject<{
  detectedNitrogenStatus?: Resolver<Maybe<ResolversTypes['DetectedNitrogenStatus']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ScoutingPoiResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NitrogenTypeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NitrogenType'] = ResolversParentTypes['NitrogenType']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export interface NodeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Node'], any> {
  name: 'Node';
}

export interface NodeWithTypenameScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['NodeWithTypename'], any> {
  name: 'NodeWithTypename';
}

export type NotificationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['Farm']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  isRead?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  object?: Resolver<Maybe<ResolversTypes['NotificationObject']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['NotificationPayload']>, ParentType, ContextType>;
  scheduledDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NotificationType'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type NotificationConfigurationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NotificationConfiguration'] = ResolversParentTypes['NotificationConfiguration']> = ResolversObject<{
  notificationEnd?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  notificationStart?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  notificationType?: Resolver<Maybe<ResolversTypes['NotificationType']>, ParentType, ContextType>;
}>;

export type NotificationObjectResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NotificationObject'] = ResolversParentTypes['NotificationObject']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CropSeason' | 'DroneFlight' | 'FieldV2' | 'Permission' | 'Spraying', ParentType, ContextType>;
}>;

export type NotificationPayloadResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NotificationPayload'] = ResolversParentTypes['NotificationPayload']> = ResolversObject<{
  index?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes['Scale']>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['Stress']>, ParentType, ContextType>;
  stressV2?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType>;
  upcomingInDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type NotificationPreferenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NotificationPreference'] = ResolversParentTypes['NotificationPreference']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationPreferenceCropSeason']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type NotificationPreferenceCropSeasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NotificationPreferenceCropSeason'] = ResolversParentTypes['NotificationPreferenceCropSeason']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  notifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationConfiguration']>>>, ParentType, ContextType>;
}>;

export type NutrientResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Nutrient'] = ResolversParentTypes['Nutrient']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  concentrationPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type NutrientMethodMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutrientMethodMapping'] = ResolversParentTypes['NutrientMethodMapping']> = ResolversObject<{
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  distributorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distributorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distributorUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  nutrientCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrientMethodCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrientMethodName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrientMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  nutrientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nutrientUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type NutrientProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutrientProduct'] = ResolversParentTypes['NutrientProduct']> = ResolversObject<{
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type NutrientRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutrientRate'] = ResolversParentTypes['NutrientRate']> = ResolversObject<{
  nutrientUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type NutritionActionDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionActionDetail'] = ResolversParentTypes['NutritionActionDetail']> = ResolversObject<{
  applicationTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionApplicationType']>>>, ParentType, ContextType>;
  appliedNutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  nutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionActionNutrient']>>>, ParentType, ContextType>;
  nutrientsDemandDelta?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutritionActionProduct']>>>, ParentType, ContextType>;
  totalNutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['NutritionRecommendationActionType']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['NutritionActionValidity']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['NutritionActionValidity']>, ParentType, ContextType>;
}>;

export type NutritionActionNutrientResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionActionNutrient'] = ResolversParentTypes['NutritionActionNutrient']> = ResolversObject<{
  nutrientUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relativePowerOfTotalNeutralisation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  samplingAreaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type NutritionActionProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionActionProduct'] = ResolversParentTypes['NutritionActionProduct']> = ResolversObject<{
  nutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientRate']>>>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type NutritionActionValidityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionActionValidity'] = ResolversParentTypes['NutritionActionValidity']> = ResolversObject<{
  calendarDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  daysAfterSeeding?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  growthStageIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  growthStageIndexAsString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growthStageScale?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['NutritionActionValidityType']>, ParentType, ContextType>;
}>;

export type NutritionRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionRecommendation'] = ResolversParentTypes['NutritionRecommendation']> = ResolversObject<{
  actionType?: Resolver<Maybe<ResolversTypes['NutritionRecommendationActionType']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  confidenceLevel?: Resolver<Maybe<ResolversTypes['ConfidenceLevel']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['NutritionRecommendationStatus']>, ParentType, ContextType>;
}>;

export type NutritionStacItemVectorizationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionStacItemVectorization'] = ResolversParentTypes['NutritionStacItemVectorization']> = ResolversObject<{
  centerZoneId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  geometry?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  index?: Resolver<ResolversTypes['AgronomicIndexType'], ParentType, ContextType>;
  numberOfZones?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stacItemUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  zonePercentageDifferences?: Resolver<Array<ResolversTypes['ZonePercentageDifference']>, ParentType, ContextType>;
  zoneStatistics?: Resolver<Array<ResolversTypes['ZoneStatisticsItem']>, ParentType, ContextType>;
}>;

export type NutritionStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionStatus'] = ResolversParentTypes['NutritionStatus']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['NutritionStatusState']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NutritionStatusType'], ParentType, ContextType>;
}>;

export type NutritionTargetRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['NutritionTargetRate'] = ResolversParentTypes['NutritionTargetRate']> = ResolversObject<{
  cropRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nutrientUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ObservationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Observation'] = ResolversParentTypes['Observation']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  importantStage?: Resolver<Maybe<ResolversTypes['ImportantGrowthStage']>, ParentType, ContextType>;
  importantStageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leafCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stressAnswerUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  stressAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressAnswer']>>>, ParentType, ContextType, Partial<ObservationStressAnswersArgs>>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  yieldExpectation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ObservationWeatherResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ObservationWeather'] = ResolversParentTypes['ObservationWeather']> = ResolversObject<{
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  precipitationMmAcc?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type OfflineBasedSmartSprayingTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OfflineBasedSmartSprayingTask'] = ResolversParentTypes['OfflineBasedSmartSprayingTask']> = ResolversObject<{
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type OnOffStatisticsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OnOffStatistics'] = ResolversParentTypes['OnOffStatistics']> = ResolversObject<{
  areaOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  areaOn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fieldDataLayer?: Resolver<Maybe<ResolversTypes['FieldDataLayer']>, ParentType, ContextType>;
  regionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type OneSoilApplicationMapDispatchOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OneSoilApplicationMapDispatchOrder'] = ResolversParentTypes['OneSoilApplicationMapDispatchOrder']> = ResolversObject<{
  deviceManufacturerUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  dispatchDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['OneSoilApplicationMapDispatchOrderFormat']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OneSoilApplicationMapDispatchOrderStatus']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  terminalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userDeviceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OneSoilDeviceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OneSoilDevice'] = ResolversParentTypes['OneSoilDevice']> = ResolversObject<{
  batteryLevel?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  batteryLevelPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceLicense?: Resolver<Maybe<ResolversTypes['OneSoilDeviceLicense']>, ParentType, ContextType>;
  deviceVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firmwareVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastCellularProvider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastSeen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationLat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  locationLon?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  networkType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rssi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageSizeTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageSizeUsed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syncIntervalBatterySeconds?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syncIntervalPowerSeconds?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type OneSoilDeviceLicenseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OneSoilDeviceLicense'] = ResolversParentTypes['OneSoilDeviceLicense']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenseValidTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OneSoilFarmReceivedFileResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OneSoilFarmReceivedFile'] = ResolversParentTypes['OneSoilFarmReceivedFile']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  receivedFile?: Resolver<Maybe<ResolversTypes['OneSoilReceivedFile']>, ParentType, ContextType>;
  uploadDatasetUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OneSoilReceivedFileResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OneSoilReceivedFile'] = ResolversParentTypes['OneSoilReceivedFile']> = ResolversObject<{
  acquisitionDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmReceivedFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilFarmReceivedFile']>>>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceEvent?: Resolver<Maybe<ResolversTypes['OneSoilReceivedFileSourceEvent']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OneSoilUploadDatasetOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OneSoilUploadDatasetOrder'] = ResolversParentTypes['OneSoilUploadDatasetOrder']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  receivedFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilReceivedFile']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OnesoilUploadDatasetOrderStatus']>, ParentType, ContextType>;
  uploadDatasetResults?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilUploadDatasetResult']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OneSoilUploadDatasetResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OneSoilUploadDatasetResult'] = ResolversParentTypes['OneSoilUploadDatasetResult']> = ResolversObject<{
  receivedFile?: Resolver<Maybe<ResolversTypes['OneSoilReceivedFile']>, ParentType, ContextType>;
  uploadDatasetUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrderAffiliateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrderAffiliate'] = ResolversParentTypes['OrderAffiliate']> = ResolversObject<{
  affiliateCodeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['Farm']>, ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Organisation'] = ResolversParentTypes['Organisation']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  billingAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactInformation?: Resolver<Maybe<ResolversTypes['ContactInformation']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Group']>>>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationTagType']>>>, ParentType, ContextType>;
  organisationType?: Resolver<Maybe<ResolversTypes['OrganisationType']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  quotas?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationQuota']>>>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  trustedDomains?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationBranchResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationBranch'] = ResolversParentTypes['OrganisationBranch']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationFarmAssignmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationFarmAssignment'] = ResolversParentTypes['OrganisationFarmAssignment']> = ResolversObject<{
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<ResolversTypes['FarmV2'], ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['OrganisationFarmAssignmentRole']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type OrganisationFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationFeature'] = ResolversParentTypes['OrganisationFeature']> = ResolversObject<{
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feature?: Resolver<ResolversTypes['OrganisationFeatureType'], ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  organisation?: Resolver<ResolversTypes['Organisation'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationMemberResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationMember'] = ResolversParentTypes['OrganisationMember']> = ResolversObject<{
  branch?: Resolver<Maybe<ResolversTypes['OrganisationBranch']>, ParentType, ContextType>;
  coOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['OrganisationMember']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  privileges?: Resolver<Maybe<Array<ResolversTypes['OrganisationMemberPrivilege']>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationMembershipRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationMembershipRequest'] = ResolversParentTypes['OrganisationMembershipRequest']> = ResolversObject<{
  branch?: Resolver<Maybe<ResolversTypes['OrganisationBranch']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['OrganisationMember']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['PublicOrganisation']>, ParentType, ContextType>;
  requestee?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  requesteeEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requester?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OrganisationMembershipRequestStatus']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationMethodResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationMethod'] = ResolversParentTypes['OrganisationMethod']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  methodUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  organisation?: Resolver<ResolversTypes['Organisation'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationQuotaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationQuota'] = ResolversParentTypes['OrganisationQuota']> = ResolversObject<{
  consumedQuota?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isRetracted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  license?: Resolver<Maybe<ResolversTypes['License']>, ParentType, ContextType>;
  maxQuota?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['LicenseRequestSeason']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type OrganisationQuotaLedgerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationQuotaLedger'] = ResolversParentTypes['OrganisationQuotaLedger']> = ResolversObject<{
  correlationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  destinationQuotaCreditUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  destinationType?: Resolver<ResolversTypes['OrganisationQuotaPartyType'], ParentType, ContextType>;
  destinationUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  license?: Resolver<Maybe<ResolversTypes['License']>, ParentType, ContextType>;
  operationType?: Resolver<ResolversTypes['OrganisationQuotaOperationType'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quotaCreditUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sourceType?: Resolver<ResolversTypes['OrganisationQuotaPartyType'], ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type OrganisationTagResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['OrganisationTag'] = ResolversParentTypes['OrganisationTag']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['OrganisationTagType']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type OrganizationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Package'] = ResolversParentTypes['Package']> = ResolversObject<{
  activatesPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['Package']>>>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  dependsOnFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['FeatureName']>>>, ParentType, ContextType>;
  farmAssignable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<ResolversTypes['FeatureName']>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PackageType']>, ParentType, ContextType>;
  userAssignable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  validityInDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type PaginatedFarmEvidenceLinkResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedFarmEvidenceLink'] = ResolversParentTypes['PaginatedFarmEvidenceLink']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmEvidenceLink']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedFarmReceiptResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedFarmReceipt'] = ResolversParentTypes['PaginatedFarmReceipt']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmReceipt']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedFieldDataLayerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedFieldDataLayer'] = ResolversParentTypes['PaginatedFieldDataLayer']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedFieldEvidenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedFieldEvidence'] = ResolversParentTypes['PaginatedFieldEvidence']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidence']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedFieldEvidenceLinkResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedFieldEvidenceLink'] = ResolversParentTypes['PaginatedFieldEvidenceLink']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEvidenceLink']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedFieldNoteResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedFieldNote'] = ResolversParentTypes['PaginatedFieldNote']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedFileResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedFile'] = ResolversParentTypes['PaginatedFile']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['File']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedHfClaimResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedHfClaim'] = ResolversParentTypes['PaginatedHfClaim']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfClaim']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedHfContractorRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedHfContractorRequest'] = ResolversParentTypes['PaginatedHfContractorRequest']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HFContractorRequest']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedHfOperationalInstructionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedHfOperationalInstruction'] = ResolversParentTypes['PaginatedHfOperationalInstruction']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfOperationalInstruction']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedMapItemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedMapItem'] = ResolversParentTypes['PaginatedMapItem']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['MapItem']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedMd2DictionaryMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedMd2DictionaryMapping'] = ResolversParentTypes['PaginatedMd2DictionaryMapping']> = ResolversObject<{
  content?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2DictionaryMapping']>>>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfElements?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalElements?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type PaginatedOrganisationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedOrganisation'] = ResolversParentTypes['PaginatedOrganisation']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organisation']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedOrganisationQuotaLedgerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedOrganisationQuotaLedger'] = ResolversParentTypes['PaginatedOrganisationQuotaLedger']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationQuotaLedger']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedPreOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedPreOrder'] = ResolversParentTypes['PaginatedPreOrder']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['PreOrder']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScaleTicketResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScaleTicket'] = ResolversParentTypes['PaginatedScaleTicket']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicket']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScaleTicketBookingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScaleTicketBooking'] = ResolversParentTypes['PaginatedScaleTicketBooking']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketBooking']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScaleTicketBookingDisputeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScaleTicketBookingDispute'] = ResolversParentTypes['PaginatedScaleTicketBookingDispute']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketBookingDispute']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScaleTicketDataMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScaleTicketDataMapping'] = ResolversParentTypes['PaginatedScaleTicketDataMapping']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketDataMapping']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScaleTicketHistoryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScaleTicketHistory'] = ResolversParentTypes['PaginatedScaleTicketHistory']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketHistory']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScaleTicketSellerMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScaleTicketSellerMapping'] = ResolversParentTypes['PaginatedScaleTicketSellerMapping']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketSellerMapping']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScaleTicketUploadResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScaleTicketUpload'] = ResolversParentTypes['PaginatedScaleTicketUpload']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketUpload']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedScoutingTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedScoutingTask'] = ResolversParentTypes['PaginatedScoutingTask']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingTask']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSmartSprayerExecutionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSmartSprayerExecution'] = ResolversParentTypes['PaginatedSmartSprayerExecution']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerExecution']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSmartSprayerRegistrationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSmartSprayerRegistration'] = ResolversParentTypes['PaginatedSmartSprayerRegistration']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerRegistration']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSmartSprayerWeedPressureFieldsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSmartSprayerWeedPressureFields'] = ResolversParentTypes['PaginatedSmartSprayerWeedPressureFields']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerWeedPressureFieldListItem']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
  pendingFieldCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type PaginatedSustainabilityOrganisationCapabilityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSustainabilityOrganisationCapability'] = ResolversParentTypes['PaginatedSustainabilityOrganisationCapability']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityOrganisationCapability']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSustainabilityProgramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSustainabilityProgram'] = ResolversParentTypes['PaginatedSustainabilityProgram']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityProgram']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSustainabilityProgramBranchAssignmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSustainabilityProgramBranchAssignment'] = ResolversParentTypes['PaginatedSustainabilityProgramBranchAssignment']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramBranchAssignment']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSustainabilityProgramEnrolledFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSustainabilityProgramEnrolledField'] = ResolversParentTypes['PaginatedSustainabilityProgramEnrolledField']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramEnrolledField']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSustainabilityProgramInvitationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSustainabilityProgramInvitation'] = ResolversParentTypes['PaginatedSustainabilityProgramInvitation']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramInvitation']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedSustainabilityProgramOrganisationParticipationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedSustainabilityProgramOrganisationParticipation'] = ResolversParentTypes['PaginatedSustainabilityProgramOrganisationParticipation']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramOrganisationParticipation']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedTask'] = ResolversParentTypes['PaginatedTask']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeneralTask']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedTrialsV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedTrialsV2'] = ResolversParentTypes['PaginatedTrialsV2']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['TrialV2']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedUploadDatasetResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedUploadDataset'] = ResolversParentTypes['PaginatedUploadDataset']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataUploadDataset']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginatedVarietyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PaginatedVariety'] = ResolversParentTypes['PaginatedVariety']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Variety']>>>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['Pagination'], ParentType, ContextType>;
}>;

export type PaginationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Pagination'] = ResolversParentTypes['Pagination']> = ResolversObject<{
  pageNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalItems?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type PanoramaClientResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PanoramaClient'] = ResolversParentTypes['PanoramaClient']> = ResolversObject<{
  panoramaClientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panoramaOrganization?: Resolver<Maybe<ResolversTypes['PanoramaOrganization']>, ParentType, ContextType>;
}>;

export type PanoramaConnectionStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PanoramaConnectionStatus'] = ResolversParentTypes['PanoramaConnectionStatus']> = ResolversObject<{
  connectedOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['PanoramaOrganization']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ConnectionStatus']>, ParentType, ContextType>;
}>;

export type PanoramaFarmResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PanoramaFarm'] = ResolversParentTypes['PanoramaFarm']> = ResolversObject<{
  panoramaClientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panoramaFarmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panoramaOrganization?: Resolver<Maybe<ResolversTypes['PanoramaOrganization']>, ParentType, ContextType>;
}>;

export type PanoramaFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PanoramaField'] = ResolversParentTypes['PanoramaField']> = ResolversObject<{
  alreadyImported?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  hasValidBoundary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  panoramaAsAppliedUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  panoramaClientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panoramaFarmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panoramaFieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panoramaOrganization?: Resolver<Maybe<ResolversTypes['PanoramaOrganization']>, ParentType, ContextType>;
  panoramaPlanningUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PanoramaOrganizationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PanoramaOrganization'] = ResolversParentTypes['PanoramaOrganization']> = ResolversObject<{
  panoramaOrgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  panoramaOrgName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type PayloadDataResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PayloadData'] = ResolversParentTypes['PayloadData']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['AggregatedNotificationPayload']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type PermissionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Permission'] = ResolversParentTypes['Permission']> = ResolversObject<{
  access?: Resolver<Maybe<ResolversTypes['Access']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grantee?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  granter?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  isGranteeOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['PermissionTag']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PermissionRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PermissionRequest'] = ResolversParentTypes['PermissionRequest']> = ResolversObject<{
  requestee?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  requester?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PermissionRequestStatus']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type PestDevelopmentPredictionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PestDevelopmentPrediction'] = ResolversParentTypes['PestDevelopmentPrediction']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  cumulativePercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cumulativeWeightedPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currentPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currentWeightedPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  developmentStage?: Resolver<Maybe<ResolversTypes['DevelopmentStage']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  generation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PestDevelopmentStatus']>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<PestDevelopmentPredictionStressArgs>>;
}>;

export type PlausibilityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Plausibility'] = ResolversParentTypes['Plausibility']> = ResolversObject<{
  amber1Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amber1MaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amber1Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amber1MinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amber2Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amber2MaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amber2Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amber2MinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  green1Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  green1MaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  green1Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  green1MinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rateUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  red1Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red1MaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red1Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red1MinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red2Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red2MaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red2Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  red2MinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PreOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PreOrder'] = ResolversParentTypes['PreOrder']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<ResolversTypes['FarmV2'], ParentType, ContextType>;
  hfServiceDetails?: Resolver<Maybe<ResolversTypes['PreOrderHfServiceDetails']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderType?: Resolver<ResolversTypes['CommercialPartnerPreOrderType'], ParentType, ContextType>;
  shadowApplicatorEmailAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CommercialPartnerPreOrderStatus'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type PreOrderCropQuotaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PreOrderCropQuota'] = ResolversParentTypes['PreOrderCropQuota']> = ResolversObject<{
  consumed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  effectiveQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pricePerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pricePerAreaUnit?: Resolver<Maybe<ResolversTypes['MdUnit']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type PreOrderHfServiceDetailsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PreOrderHfServiceDetails'] = ResolversParentTypes['PreOrderHfServiceDetails']> = ResolversObject<{
  areaClasses?: Resolver<Maybe<Array<ResolversTypes['PreOrderHfServiceRequestAreaClass']>>, ParentType, ContextType>;
  assignedAgronomicConsultant?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  assignedContractor?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  assignedContractorIdOnLogisticPlatform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignedContractorShippingAddress?: Resolver<Maybe<ResolversTypes['PreOrderHfServiceRequestShippingAddress']>, ParentType, ContextType>;
  businessName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hfReferenceCode?: Resolver<Maybe<ResolversTypes['HfReferenceCode']>, ParentType, ContextType>;
  hfReferenceCodePublic?: Resolver<Maybe<ResolversTypes['HfReferenceCodePublic']>, ParentType, ContextType>;
  logisticPlatformCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logisticPlatformName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotas?: Resolver<Maybe<Array<Maybe<ResolversTypes['PreOrderQuota']>>>, ParentType, ContextType>;
  secondaryLogisticPlatformCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceType?: Resolver<ResolversTypes['ServiceType'], ParentType, ContextType>;
  soldAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  suggestedAgronomicConsultantEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suggestedAgronomicConsultantFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suggestedContractorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suggestedContractorFullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalFafArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type PreOrderHfServiceRequestAreaClassResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PreOrderHfServiceRequestAreaClass'] = ResolversParentTypes['PreOrderHfServiceRequestAreaClass']> = ResolversObject<{
  area?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  classType?: Resolver<ResolversTypes['HfServiceRequestAreaClassType'], ParentType, ContextType>;
  crop?: Resolver<ResolversTypes['Crop'], ParentType, ContextType, Partial<PreOrderHfServiceRequestAreaClassCropArgs>>;
}>;

export type PreOrderHfServiceRequestShippingAddressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PreOrderHfServiceRequestShippingAddress'] = ResolversParentTypes['PreOrderHfServiceRequestShippingAddress']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  provinceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type PreOrderQuotaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PreOrderQuota'] = ResolversParentTypes['PreOrderQuota']> = ResolversObject<{
  crop?: Resolver<ResolversTypes['Crop'], ParentType, ContextType, Partial<PreOrderQuotaCropArgs>>;
  pricePerArea?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pricePerAreaUnit?: Resolver<ResolversTypes['MdUnit'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type PrecifieldBiomassMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PrecifieldBiomassMap'] = ResolversParentTypes['PrecifieldBiomassMap']> = ResolversObject<{
  acquisitionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  averageBiomass?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PrecifieldCerealsMapSubscriptionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PrecifieldCerealsMapSubscription'] = ResolversParentTypes['PrecifieldCerealsMapSubscription']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  nitrogenTargetRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  productV2?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PrecifieldSubscriptionStatus']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  yieldFiveYearOlympicAverage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type PrecifieldNitrogenPrescriptionMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PrecifieldNitrogenPrescriptionMap'] = ResolversParentTypes['PrecifieldNitrogenPrescriptionMap']> = ResolversObject<{
  acquisitionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mapId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mapModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precifieldFieldId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['NitrogenProduct']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PrecifieldOsrMapSubscriptionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PrecifieldOsrMapSubscription'] = ResolversParentTypes['PrecifieldOsrMapSubscription']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  endWinterPrecifieldBiomassMapUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  historicOrganicProductUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isCropAssociatedWithLegumesCover?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  organicProductFrequencyUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  precifieldSoilTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  productV2?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  startWinterPrecifieldBiomassMapUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PrecifieldSubscriptionStatus']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PrecifieldYieldPotentialMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PrecifieldYieldPotentialMap'] = ResolversParentTypes['PrecifieldYieldPotentialMap']> = ResolversObject<{
  acquisitionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mapId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  mapModel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precifieldFieldId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PredictionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Prediction'] = ResolversParentTypes['Prediction']> = ResolversObject<{
  harvestDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  yieldScenario?: Resolver<Maybe<Array<Maybe<ResolversTypes['YieldScenario']>>>, ParentType, ContextType>;
}>;

export type PremiumBandResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PremiumBand'] = ResolversParentTypes['PremiumBand']> = ResolversObject<{
  maxCi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  premium?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ProduceDeliveryTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProduceDeliveryTask'] = ResolversParentTypes['ProduceDeliveryTask']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  distanceToStorage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  produceProperties?: Resolver<Maybe<ResolversTypes['ProduceDeliveryTaskProduceProperties']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  transportSystemUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProduceDeliveryTaskProducePropertiesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProduceDeliveryTaskProduceProperties'] = ResolversParentTypes['ProduceDeliveryTaskProduceProperties']> = ResolversObject<{
  brix?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moisturePercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']> = ResolversObject<{
  abstractProductType?: Resolver<Maybe<Array<Maybe<ResolversTypes['AbstractProductType']>>>, ParentType, ContextType>;
  actualFormulationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cdnImagePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cdnLogoPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  distributionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distributionTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  doseRateUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doseRateUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  formulation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formulationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formulationFormUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  formulationTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  highFlowRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  importCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isProductSynonym?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastCommercialDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastUseDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lowFlowRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  maxDoseRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minDoseRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  productExpiryDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  productFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductFeatureType']>>>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  productUseStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceProductUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  referenceRegistration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceSystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ProductApplicationRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductApplicationRate'] = ResolversParentTypes['ProductApplicationRate']> = ResolversObject<{
  averageApplicationRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  liquid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  ratesPerZone?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  totalApplication?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ProductFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductFeature'] = ResolversParentTypes['ProductFeature']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  vraMinMixRateSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vraMinRateSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ProductPackResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductPack'] = ResolversParentTypes['ProductPack']> = ResolversObject<{
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['Category']>>>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductV2']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ProductPermissibleRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductPermissibleRate'] = ResolversParentTypes['ProductPermissibleRate']> = ResolversObject<{
  amountWaterMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountWaterMaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountWaterMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountWaterMinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  appliedWithWater?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  dilutionRatioMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dilutionRatioMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  doseUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doseUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doseUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  maxRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateMaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateMinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskMethodCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskMethodName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  waterUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  waterUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ProductPermissibleRateV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductPermissibleRateV2'] = ResolversParentTypes['ProductPermissibleRateV2']> = ResolversObject<{
  amountWaterMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountWaterMaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountWaterMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amountWaterMinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  appliedWithWater?: Resolver<Maybe<ResolversTypes['AppliedWithWater']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  dilutionRatioMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dilutionRatioMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  doseUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doseUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  doseUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  maxRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateMaxSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateMinSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskMethodCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskMethodName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  waterUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ProductRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductRate'] = ResolversParentTypes['ProductRate']> = ResolversObject<{
  isMaster?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
}>;

export type ProductRecommendationTankMixResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductRecommendationTankMix'] = ResolversParentTypes['ProductRecommendationTankMix']> = ResolversObject<{
  crops?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropTankMixSummary']>>>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ProductV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProductV2'] = ResolversParentTypes['ProductV2']> = ResolversObject<{
  accountableNitrogenPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  activeDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeIngredients?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActiveIngredient']>>>, ParentType, ContextType>;
  actualFormulationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ammoniumStabilizer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['Category']>>>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conversionFactorToRateUnitSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  conversionFactorToWaterUnitSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  dateOfAnalysis?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  density?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  displayRateUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayRateUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayRateUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  displayWaterUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayWaterUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayWaterUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  distributionTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distributionTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distributionTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['Farm']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductFeature']>>>, ParentType, ContextType>;
  fertilizerTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  formulationBasedMixSequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  formulationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formulationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formulationTypeGroupCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formulationTypeGroupName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  formulationTypeGroupUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  formulationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isCustom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRetracted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUseRestricted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  labelLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUseDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  maxRateSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxWaterSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minRateSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minWaterSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minimumAccountableNitrogenPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nitrificationInhibitor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nitrogenTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['NitrogenType']>>>, ParentType, ContextType>;
  nutrients?: Resolver<Maybe<Array<Maybe<ResolversTypes['Nutrient']>>>, ParentType, ContextType>;
  organicFertilizerSubTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organicFertilizerSubTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  organizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organization']>>>, ParentType, ContextType>;
  productFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  productUseStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rateUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  referenceProductCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceProductName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceProductUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  registrationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sanitizedDensity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Site']>>>, ParentType, ContextType>;
  taskMethods?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskMethod']>>>, ParentType, ContextType>;
  ureaseInhibitor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  waterUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  waterUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ProjectedDailyIncidenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProjectedDailyIncidence'] = ResolversParentTypes['ProjectedDailyIncidence']> = ResolversObject<{
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  projectedIncidence?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type ProjectedIncidencesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProjectedIncidences'] = ResolversParentTypes['ProjectedIncidences']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  criticalPeriodEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  criticalPeriodIncidenceThresholdHigh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  criticalPeriodStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  inoculumPeriodStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  projectedDailyIncidences?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProjectedDailyIncidence']>>>, ParentType, ContextType>;
  projectingGrowthStageIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectingGrowthStageScale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<ProjectedIncidencesStressArgs>>;
}>;

export type ProtectionTimeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProtectionTime'] = ResolversParentTypes['ProtectionTime']> = ResolversObject<{
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stress?: Resolver<ResolversTypes['Stress'], ParentType, ContextType>;
  stressV2?: Resolver<ResolversTypes['StressV2'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ProtocolResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Protocol'] = ResolversParentTypes['Protocol']> = ResolversObject<{
  creationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factorLevels?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  factorUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxPlotArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minPlotArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  plannedNoOfTrials?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  plotLength?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  plotWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  protocolAttachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProtocolAttachment']>>>, ParentType, ContextType>;
  protocolName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  protocolNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  replicates?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  targetCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  typeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ProtocolAttachmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ProtocolAttachment'] = ResolversParentTypes['ProtocolAttachment']> = ResolversObject<{
  contentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  protocolUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uploadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type PublicOrganisationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PublicOrganisation'] = ResolversParentTypes['PublicOrganisation']> = ResolversObject<{
  billingAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contactInformation?: Resolver<Maybe<ResolversTypes['ContactInformation']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type PurchasedLicenseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['PurchasedLicense'] = ResolversParentTypes['PurchasedLicense']> = ResolversObject<{
  paymentType?: Resolver<Maybe<ResolversTypes['PaymentType']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  subscriptionActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  abLines?: Resolver<Maybe<Array<Maybe<ResolversTypes['AbLine']>>>, ParentType, ContextType, Partial<QueryAbLinesArgs>>;
  activeIngredients?: Resolver<Maybe<Array<ResolversTypes['ActiveIngredient']>>, ParentType, ContextType, Partial<QueryActiveIngredientsArgs>>;
  additionalInfectionRiskFactor?: Resolver<Maybe<ResolversTypes['AdditionalInfectionRiskFactor']>, ParentType, ContextType, RequireFields<QueryAdditionalInfectionRiskFactorArgs, 'uuid'>>;
  additionalInfectionRiskFactors?: Resolver<Maybe<Array<Maybe<ResolversTypes['AdditionalInfectionRiskFactor']>>>, ParentType, ContextType, Partial<QueryAdditionalInfectionRiskFactorsArgs>>;
  agBalanceFieldEmissionIndicators?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgBalanceFieldEmissionIndicator']>>>, ParentType, ContextType, Partial<QueryAgBalanceFieldEmissionIndicatorsArgs>>;
  agBalanceFieldInputs?: Resolver<Maybe<Array<Maybe<ResolversTypes['AgBalanceFieldInput']>>>, ParentType, ContextType, Partial<QueryAgBalanceFieldInputsArgs>>;
  aggregatedPestDevelopmentPredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AggregatedPestDevelopmentPrediction']>>>, ParentType, ContextType, RequireFields<QueryAggregatedPestDevelopmentPredictionsArgs, 'cropSeasonUuids'>>;
  aggregatedUserNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['AggregatedNotification']>>>, ParentType, ContextType, RequireFields<QueryAggregatedUserNotificationsArgs, 'fromDate' | 'languageCode'>>;
  analyticsCollection?: Resolver<Maybe<ResolversTypes['AnalyticsCollection']>, ParentType, ContextType, RequireFields<QueryAnalyticsCollectionArgs, 'uuid'>>;
  analyticsCollections?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnalyticsCollection']>>>, ParentType, ContextType, Partial<QueryAnalyticsCollectionsArgs>>;
  appConfigs?: Resolver<Maybe<Array<Maybe<ResolversTypes['AppConfig']>>>, ParentType, ContextType, Partial<QueryAppConfigsArgs>>;
  arableApiKey?: Resolver<Maybe<ResolversTypes['ArableApiKey']>, ParentType, ContextType, RequireFields<QueryArableApiKeyArgs, 'uuid'>>;
  arableApiKeys?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArableApiKey']>>>, ParentType, ContextType>;
  arableDeviceToLocations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArableDeviceToLocation']>>>, ParentType, ContextType, Partial<QueryArableDeviceToLocationsArgs>>;
  arableDevices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArableDevice']>>>, ParentType, ContextType, Partial<QueryArableDevicesArgs>>;
  arvalisCustomEfficacyInformations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArvalisCustomEfficacyInformation']>>>, ParentType, ContextType, RequireFields<QueryArvalisCustomEfficacyInformationsArgs, 'dosedMapUuids'>>;
  arvalisDeviceToCropSeasons?: Resolver<Maybe<Array<ResolversTypes['ArvalisDeviceToCropSeason']>>, ParentType, ContextType, Partial<QueryArvalisDeviceToCropSeasonsArgs>>;
  arvalisInformations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArvalisInformation']>>>, ParentType, ContextType, RequireFields<QueryArvalisInformationsArgs, 'cropSeasonUuids'>>;
  assessment?: Resolver<Maybe<ResolversTypes['Assessment']>, ParentType, ContextType, Partial<QueryAssessmentArgs>>;
  assessmentAttachment?: Resolver<Maybe<ResolversTypes['AssessmentAttachment']>, ParentType, ContextType, Partial<QueryAssessmentAttachmentArgs>>;
  assessmentAttachments?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssessmentAttachment']>>>, ParentType, ContextType, Partial<QueryAssessmentAttachmentsArgs>>;
  assessmentData?: Resolver<Maybe<ResolversTypes['AssessmentData']>, ParentType, ContextType, Partial<QueryAssessmentDataArgs>>;
  assessmentNote?: Resolver<Maybe<ResolversTypes['AssessmentNote']>, ParentType, ContextType, Partial<QueryAssessmentNoteArgs>>;
  assessmentNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssessmentNote']>>>, ParentType, ContextType, Partial<QueryAssessmentNotesArgs>>;
  assessmentTiming?: Resolver<Maybe<ResolversTypes['AssessmentTiming']>, ParentType, ContextType, Partial<QueryAssessmentTimingArgs>>;
  availablePackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailablePackage']>>>, ParentType, ContextType, RequireFields<QueryAvailablePackagesArgs, 'countryCode'>>;
  bagCounts?: Resolver<Maybe<Array<ResolversTypes['BagCount']>>, ParentType, ContextType, RequireFields<QueryBagCountsArgs, 'mdBagUuids' | 'totalApplication' | 'unit'>>;
  beforeSeasonRisks?: Resolver<Maybe<Array<ResolversTypes['BeforeSeasonRisk']>>, ParentType, ContextType, RequireFields<QueryBeforeSeasonRisksArgs, 'cropSeasonUuid'>>;
  biomassAnalysisNdvi?: Resolver<Maybe<Array<Maybe<ResolversTypes['BiomassAnalysisNdvi']>>>, ParentType, ContextType, RequireFields<QueryBiomassAnalysisNdviArgs, 'cropSeasonUuids' | 'fromDate' | 'tillDate'>>;
  businessLinePurchaseAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['BusinessLinePurchaseAggregation']>>>, ParentType, ContextType, RequireFields<QueryBusinessLinePurchaseAggregationsArgs, 'farmUuids'>>;
  carbonCredits?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonCredit']>>>, ParentType, ContextType, Partial<QueryCarbonCreditsArgs>>;
  carbonFarmingPlausibilities?: Resolver<Maybe<Array<Maybe<ResolversTypes['Plausibility']>>>, ParentType, ContextType, Partial<QueryCarbonFarmingPlausibilitiesArgs>>;
  carbonFarmingRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonFarmingRequest']>>>, ParentType, ContextType, Partial<QueryCarbonFarmingRequestsArgs>>;
  carbonFarmingSeason?: Resolver<Maybe<ResolversTypes['CarbonFarmingSeason']>, ParentType, ContextType, RequireFields<QueryCarbonFarmingSeasonArgs, 'uuid'>>;
  carbonFarmingSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonFarmingSeason']>>>, ParentType, ContextType, Partial<QueryCarbonFarmingSeasonsArgs>>;
  carbonIntensityIndicators?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonIntensityIndicator']>>>, ParentType, ContextType, Partial<QueryCarbonIntensityIndicatorsArgs>>;
  carbonPlausibilityComments?: Resolver<Maybe<Array<Maybe<ResolversTypes['CarbonPlausibilityComment']>>>, ParentType, ContextType, Partial<QueryCarbonPlausibilityCommentsArgs>>;
  claasConnectStatus?: Resolver<Maybe<ResolversTypes['ClaasConnectStatus']>, ParentType, ContextType>;
  claasFarms?: Resolver<Maybe<Array<Maybe<ResolversTypes['ClaasFarm']>>>, ParentType, ContextType, RequireFields<QueryClaasFarmsArgs, 'claasOrganizationId'>>;
  claasFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['ClaasField']>>>, ParentType, ContextType, RequireFields<QueryClaasFieldsArgs, 'claasFarmId' | 'claasOrganizationId'>>;
  claasOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ClaasOrganization']>>>, ParentType, ContextType>;
  cnhCompanies?: Resolver<Maybe<Array<Maybe<ResolversTypes['CnhCompany']>>>, ParentType, ContextType>;
  cnhFarms?: Resolver<Maybe<Array<Maybe<ResolversTypes['CnhFarm']>>>, ParentType, ContextType, RequireFields<QueryCnhFarmsArgs, 'cnhCompanyId' | 'cnhGrowerUuid'>>;
  cnhFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['CnhField']>>>, ParentType, ContextType, RequireFields<QueryCnhFieldsArgs, 'cnhCompanyId' | 'cnhFarmUuid'>>;
  cnhGrowers?: Resolver<Maybe<Array<Maybe<ResolversTypes['CnhGrower']>>>, ParentType, ContextType, RequireFields<QueryCnhGrowersArgs, 'cnhCompanyId'>>;
  cnhTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['CnhTask']>>>, ParentType, ContextType, Partial<QueryCnhTasksArgs>>;
  coefficientOfVariationDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['MdCoefficientOfVariationDetail']>>>, ParentType, ContextType, Partial<QueryCoefficientOfVariationDetailsArgs>>;
  collaborators?: Resolver<Maybe<Array<Maybe<ResolversTypes['Collaborator']>>>, ParentType, ContextType, Partial<QueryCollaboratorsArgs>>;
  containers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Container']>>>, ParentType, ContextType, Partial<QueryContainersArgs>>;
  countryCropGrowthStagePredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryCropGrowthStagePrediction']>>>, ParentType, ContextType, RequireFields<QueryCountryCropGrowthStagePredictionsArgs, 'cropSeasonUuids'>>;
  countryCropStressSettings?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryCropStressSetting']>>>, ParentType, ContextType, RequireFields<QueryCountryCropStressSettingsArgs, 'countryCode' | 'cropUuids'>>;
  countryWeeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['CountryWeed']>>>, ParentType, ContextType, Partial<QueryCountryWeedsArgs>>;
  criticalCropStageRiskInfos?: Resolver<Maybe<Array<Maybe<ResolversTypes['CriticalCropStageRiskInfo']>>>, ParentType, ContextType, RequireFields<QueryCriticalCropStageRiskInfosArgs, 'cropSeasonUuids'>>;
  criticalCropStageRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['CriticalCropStageRisk']>>>, ParentType, ContextType, RequireFields<QueryCriticalCropStageRisksArgs, 'cropSeasonUuids'>>;
  criticalGrowthStagePeriodRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['CriticalGrowthStagePeriodRisk']>>>, ParentType, ContextType, RequireFields<QueryCriticalGrowthStagePeriodRisksArgs, 'cropSeasonUuids'>>;
  cropEstablishment?: Resolver<Maybe<ResolversTypes['CropEstablishment']>, ParentType, ContextType, RequireFields<QueryCropEstablishmentArgs, 'uuid'>>;
  cropEstablishmentDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropEstablishmentDetails']>>>, ParentType, ContextType, Partial<QueryCropEstablishmentDetailsArgs>>;
  cropEstablishments?: Resolver<Maybe<Array<ResolversTypes['CropEstablishment']>>, ParentType, ContextType, Partial<QueryCropEstablishmentsArgs>>;
  cropResidueManagementTask?: Resolver<Maybe<ResolversTypes['CropResidueManagementTask']>, ParentType, ContextType, RequireFields<QueryCropResidueManagementTaskArgs, 'uuid'>>;
  cropResidueManagementTasks?: Resolver<Maybe<Array<ResolversTypes['CropResidueManagementTask']>>, ParentType, ContextType, Partial<QueryCropResidueManagementTasksArgs>>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType, RequireFields<QueryCropSeasonArgs, 'uuid'>>;
  cropSeasonNutritionProgramExecutionStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonNutritionProgramExecutionStatus']>>>, ParentType, ContextType, Partial<QueryCropSeasonNutritionProgramExecutionStatusesArgs>>;
  cropSeasonNutritionPrograms?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonNutritionProgram']>>>, ParentType, ContextType, Partial<QueryCropSeasonNutritionProgramsArgs>>;
  cropSeasonNutritionRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonNutritionRecommendation']>>>, ParentType, ContextType, RequireFields<QueryCropSeasonNutritionRecommendationsArgs, 'cropSeasonUuid' | 'nitrogenMin' | 'provider'>>;
  cropSeasonTreatmentProgramV3?: Resolver<Maybe<ResolversTypes['CropSeasonTreatmentProgramV3']>, ParentType, ContextType, RequireFields<QueryCropSeasonTreatmentProgramV3Args, 'uuid'>>;
  cropSeasonTreatmentPrograms?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonTreatmentProgram']>>>, ParentType, ContextType, Partial<QueryCropSeasonTreatmentProgramsArgs>>;
  cropSeasonTreatmentProgramsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonTreatmentProgramV2']>>>, ParentType, ContextType, Partial<QueryCropSeasonTreatmentProgramsV2Args>>;
  cropSeasonTreatmentProgramsV3?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonTreatmentProgramV3']>>>, ParentType, ContextType, Partial<QueryCropSeasonTreatmentProgramsV3Args>>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType, RequireFields<QueryCropSeasonV2Args, 'uuid'>>;
  cropSeasonsV2?: Resolver<Maybe<Array<ResolversTypes['CropSeasonV2']>>, ParentType, ContextType, Partial<QueryCropSeasonsV2Args>>;
  cropSystemRecommendation?: Resolver<Maybe<ResolversTypes['CropSystemRecommendation']>, ParentType, ContextType, RequireFields<QueryCropSystemRecommendationArgs, 'uuid'>>;
  cropSystemRecommendationV2?: Resolver<Maybe<ResolversTypes['CropSystemRecommendationV2']>, ParentType, ContextType, RequireFields<QueryCropSystemRecommendationV2Args, 'uuid'>>;
  cropSystemRecommendationsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSystemRecommendationV2']>>>, ParentType, ContextType, Partial<QueryCropSystemRecommendationsV2Args>>;
  cropUsages?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropUsage']>>>, ParentType, ContextType, Partial<QueryCropUsagesArgs>>;
  cropWaterAvailabilities?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropWaterAvailability']>>>, ParentType, ContextType, RequireFields<QueryCropWaterAvailabilitiesArgs, 'cropSeasonUuids'>>;
  crops?: Resolver<Maybe<Array<Maybe<ResolversTypes['Crop']>>>, ParentType, ContextType, Partial<QueryCropsArgs>>;
  currentWeedPredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CurrentWeedPrediction']>>>, ParentType, ContextType, Partial<QueryCurrentWeedPredictionsArgs>>;
  customPowerzoneOrder?: Resolver<Maybe<ResolversTypes['CustomPowerzoneOrder']>, ParentType, ContextType, RequireFields<QueryCustomPowerzoneOrderArgs, 'uuid'>>;
  customPowerzoneOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomPowerzoneOrder']>>>, ParentType, ContextType, RequireFields<QueryCustomPowerzoneOrdersArgs, 'cropSeasonUuids'>>;
  dailyFungusDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyFungusDetails']>>>, ParentType, ContextType, RequireFields<QueryDailyFungusDetailsArgs, 'cropSeasonUuids'>>;
  dailyStressCharacteristics?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyStressCharacteristics']>>>, ParentType, ContextType, RequireFields<QueryDailyStressCharacteristicsArgs, 'cropSeasonUuids'>>;
  dailyStressEventProbabilities?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyStressEventProbability']>>>, ParentType, ContextType, RequireFields<QueryDailyStressEventProbabilitiesArgs, 'cropSeasonUuids'>>;
  dailyWeedRiskDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['DailyWeedRiskDetails']>>>, ParentType, ContextType, RequireFields<QueryDailyWeedRiskDetailsArgs, 'cropSeasonUuids'>>;
  demandEquationRecommendation?: Resolver<Maybe<ResolversTypes['DemandEquationRecommendation']>, ParentType, ContextType, RequireFields<QueryDemandEquationRecommendationArgs, 'uuid'>>;
  demandEquationRecommendationV2?: Resolver<Maybe<ResolversTypes['DemandEquationRecommendationV2']>, ParentType, ContextType, RequireFields<QueryDemandEquationRecommendationV2Args, 'uuid'>>;
  demandEquationRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['DemandEquationRecommendation']>>>, ParentType, ContextType, Partial<QueryDemandEquationRecommendationsArgs>>;
  demandEquationRecommendationsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['DemandEquationRecommendationV2']>>>, ParentType, ContextType, Partial<QueryDemandEquationRecommendationsV2Args>>;
  devicePackage?: Resolver<Maybe<ResolversTypes['DevicePackage']>, ParentType, ContextType, RequireFields<QueryDevicePackageArgs, 'uuid'>>;
  devicePackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['DevicePackage']>>>, ParentType, ContextType, RequireFields<QueryDevicePackagesArgs, 'deviceUuids'>>;
  dictcodeFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['DictcodeFeature']>>>, ParentType, ContextType, RequireFields<QueryDictcodeFeaturesArgs, 'characteristicIds'>>;
  dictcodeHierarchies?: Resolver<Maybe<Array<Maybe<ResolversTypes['DictcodeHierarchy']>>>, ParentType, ContextType, Partial<QueryDictcodeHierarchiesArgs>>;
  dictionaries?: Resolver<Maybe<Array<Maybe<ResolversTypes['Dictionary']>>>, ParentType, ContextType, RequireFields<QueryDictionariesArgs, 'dict'>>;
  dosedMapLegends?: Resolver<Maybe<Array<Maybe<ResolversTypes['DosedMapLegend']>>>, ParentType, ContextType, RequireFields<QueryDosedMapLegendsArgs, 'dosedMapUuid'>>;
  dosedMapProductSummaries?: Resolver<Maybe<Array<Maybe<ResolversTypes['DosedMapProductSummary']>>>, ParentType, ContextType, RequireFields<QueryDosedMapProductSummariesArgs, 'cropSeasonUuids'>>;
  dosedMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['DosedMap']>>>, ParentType, ContextType, Partial<QueryDosedMapsArgs>>;
  droneFlightQuotaTransfers?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightQuotaTransfer']>>>, ParentType, ContextType, Partial<QueryDroneFlightQuotaTransfersArgs>>;
  droneFlightQuotas?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneFlightQuota']>>>, ParentType, ContextType, Partial<QueryDroneFlightQuotasArgs>>;
  droneFlightSummary?: Resolver<Maybe<Array<ResolversTypes['DroneFlightSummary']>>, ParentType, ContextType, Partial<QueryDroneFlightSummaryArgs>>;
  droneFlights?: Resolver<Maybe<Array<ResolversTypes['DroneFlight']>>, ParentType, ContextType, Partial<QueryDroneFlightsArgs>>;
  dronePlantingFailureMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['DronePlantingFailureMap']>>>, ParentType, ContextType, Partial<QueryDronePlantingFailureMapsArgs>>;
  droneSprayerWeedMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['DroneSprayerWeedMap']>>>, ParentType, ContextType, Partial<QueryDroneSprayerWeedMapsArgs>>;
  dtnVendorDeviceActivation?: Resolver<Maybe<ResolversTypes['DtnVendorDeviceActivation']>, ParentType, ContextType, RequireFields<QueryDtnVendorDeviceActivationArgs, 'uuid'>>;
  dtnVendorDeviceActivations?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorDeviceActivation']>>>, ParentType, ContextType, Partial<QueryDtnVendorDeviceActivationsArgs>>;
  dtnVendorDeviceToLocations?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorDeviceToLocation']>>>, ParentType, ContextType, RequireFields<QueryDtnVendorDeviceToLocationsArgs, 'vendor'>>;
  dtnVendorDeviceToLocationsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorDeviceToLocationV2']>>>, ParentType, ContextType, Partial<QueryDtnVendorDeviceToLocationsV2Args>>;
  dtnVendorDevices?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorDevice']>>>, ParentType, ContextType, Partial<QueryDtnVendorDevicesArgs>>;
  dtnVendorKey?: Resolver<Maybe<ResolversTypes['DtnVendorKey']>, ParentType, ContextType, RequireFields<QueryDtnVendorKeyArgs, 'uuid'>>;
  dtnVendorKeys?: Resolver<Maybe<Array<Maybe<ResolversTypes['DtnVendorKey']>>>, ParentType, ContextType>;
  exatrekApplicationMapDispatchOrders?: Resolver<Maybe<Array<ResolversTypes['ExatrekApplicationMapDispatchOrder']>>, ParentType, ContextType, Partial<QueryExatrekApplicationMapDispatchOrdersArgs>>;
  exatrekDeviceStates?: Resolver<Maybe<Array<ResolversTypes['ExatrekDeviceState']>>, ParentType, ContextType, RequireFields<QueryExatrekDeviceStatesArgs, 'uuids'>>;
  exatrekUserDevices?: Resolver<Maybe<Array<ResolversTypes['ExatrekUserDevice']>>, ParentType, ContextType, Partial<QueryExatrekUserDevicesArgs>>;
  exatrekUserMachines?: Resolver<Maybe<Array<ResolversTypes['ExatrekUserMachine']>>, ParentType, ContextType, Partial<QueryExatrekUserMachinesArgs>>;
  existingOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExistingOrder']>>>, ParentType, ContextType, RequireFields<QueryExistingOrdersArgs, 'farmUuids'>>;
  exportOrder?: Resolver<Maybe<ResolversTypes['ExportOrder']>, ParentType, ContextType, RequireFields<QueryExportOrderArgs, 'uuid'>>;
  exportOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExportOrder']>>>, ParentType, ContextType, RequireFields<QueryExportOrdersArgs, 'taskUuids'>>;
  farm?: Resolver<Maybe<ResolversTypes['Farm']>, ParentType, ContextType, RequireFields<QueryFarmArgs, 'uuid'>>;
  farmCarbonIntensityIndicators?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmCarbonIntensityIndicator']>>>, ParentType, ContextType, RequireFields<QueryFarmCarbonIntensityIndicatorsArgs, 'cropUuid' | 'sustainabilityProgramUuid' | 'year'>>;
  farmCropMetrics?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmCropMetrics']>>>, ParentType, ContextType, RequireFields<QueryFarmCropMetricsArgs, 'farmUuids'>>;
  farmDataLayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmDataLayer']>>>, ParentType, ContextType, RequireFields<QueryFarmDataLayersArgs, 'magnitude' | 'type'>>;
  farmEvidence?: Resolver<Maybe<ResolversTypes['FarmEvidence']>, ParentType, ContextType, RequireFields<QueryFarmEvidenceArgs, 'farmUuid' | 'sustainabilityProgramUuid'>>;
  farmFeaturesSummary?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmFeaturesSummary']>>>, ParentType, ContextType, RequireFields<QueryFarmFeaturesSummaryArgs, 'farmUuids'>>;
  farmGreetCarbonIntensityScores?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmGreetCarbonIntensityScore']>>>, ParentType, ContextType, RequireFields<QueryFarmGreetCarbonIntensityScoresArgs, 'cropUuid' | 'sustainabilityProgramUuid' | 'year'>>;
  farmLayerSummaryCount?: Resolver<Maybe<Array<Maybe<ResolversTypes['FarmLayerSummaryCount']>>>, ParentType, ContextType, RequireFields<QueryFarmLayerSummaryCountArgs, 'farmUuid'>>;
  farmPackages?: Resolver<Maybe<Array<ResolversTypes['FarmPackage']>>, ParentType, ContextType, RequireFields<QueryFarmPackagesArgs, 'farmUuids'>>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType, RequireFields<QueryFarmV2Args, 'uuid'>>;
  farmsV2?: Resolver<Maybe<Array<ResolversTypes['FarmV2']>>, ParentType, ContextType, RequireFields<QueryFarmsV2Args, 'uuids'>>;
  field?: Resolver<Maybe<ResolversTypes['Field']>, ParentType, ContextType, RequireFields<QueryFieldArgs, 'uuid'>>;
  fieldActivations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldActivation']>>>, ParentType, ContextType, Partial<QueryFieldActivationsArgs>>;
  fieldBoundaryLookupScore?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldBoundaryLookupScore']>>>, ParentType, ContextType, Partial<QueryFieldBoundaryLookupScoreArgs>>;
  fieldDataLayerClassifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayerClassification']>>>, ParentType, ContextType, RequireFields<QueryFieldDataLayerClassificationsArgs, 'fieldDataLayerUuid' | 'locale' | 'magnitudes'>>;
  fieldDataLayerLegends?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayerLegend']>>>, ParentType, ContextType, RequireFields<QueryFieldDataLayerLegendsArgs, 'fieldDataLayerUuids'>>;
  fieldDataLayerStatistics?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayerStatistics']>>>, ParentType, ContextType, RequireFields<QueryFieldDataLayerStatisticsArgs, 'magnitudeType' | 'uuid'>>;
  fieldDataLayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayer']>>>, ParentType, ContextType, Partial<QueryFieldDataLayersArgs>>;
  fieldDataLayersStatistics?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataLayerStatistics']>>>, ParentType, ContextType, RequireFields<QueryFieldDataLayersStatisticsArgs, 'magnitudeTypes' | 'uuids'>>;
  fieldDataUploadDatasets?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataUploadDataset']>>>, ParentType, ContextType, Partial<QueryFieldDataUploadDatasetsArgs>>;
  fieldEntries?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldEntry']>>>, ParentType, ContextType, Partial<QueryFieldEntriesArgs>>;
  fieldFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldFeature']>>>, ParentType, ContextType, Partial<QueryFieldFeaturesArgs>>;
  fieldInputPackagings?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldInputPackaging']>>>, ParentType, ContextType, Partial<QueryFieldInputPackagingsArgs>>;
  fieldNotesAggregation?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNoteAggregation']>>>, ParentType, ContextType, Partial<QueryFieldNotesAggregationArgs>>;
  fieldPointLookup?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldPointLookup']>>>, ParentType, ContextType, Partial<QueryFieldPointLookupArgs>>;
  fieldV2?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType, RequireFields<QueryFieldV2Args, 'uuid'>>;
  fieldVariabilityIndexes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldVariabilityIndex']>>>, ParentType, ContextType, Partial<QueryFieldVariabilityIndexesArgs>>;
  fieldVariabilityInputs?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldVariabilityInput']>>>, ParentType, ContextType, Partial<QueryFieldVariabilityInputsArgs>>;
  fieldZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, ParentType, ContextType, Partial<QueryFieldZonesArgs>>;
  fieldsV2?: Resolver<Maybe<Array<ResolversTypes['FieldV2']>>, ParentType, ContextType, Partial<QueryFieldsV2Args>>;
  fmCarbonRelatedData?: Resolver<Array<ResolversTypes['FmCarbonRelatedData']>, ParentType, ContextType, RequireFields<QueryFmCarbonRelatedDataArgs, 'fieldUuids'>>;
  foreignCatchCrops?: Resolver<Maybe<Array<Maybe<ResolversTypes['ForeignCatchCrop']>>>, ParentType, ContextType, Partial<QueryForeignCatchCropsArgs>>;
  foreignCrops?: Resolver<Maybe<Array<Maybe<ResolversTypes['ForeignCrop']>>>, ParentType, ContextType, Partial<QueryForeignCropsArgs>>;
  foreignPreCrops?: Resolver<Maybe<Array<Maybe<ResolversTypes['ForeignPreCrop']>>>, ParentType, ContextType, Partial<QueryForeignPreCropsArgs>>;
  freshBiomassOrder?: Resolver<Maybe<ResolversTypes['FreshBiomassOrder']>, ParentType, ContextType, RequireFields<QueryFreshBiomassOrderArgs, 'uuid'>>;
  frostRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['FrostRisk']>>>, ParentType, ContextType, RequireFields<QueryFrostRisksArgs, 'cropSeasonUuids'>>;
  geoMapDetails?: Resolver<Maybe<Array<Maybe<ResolversTypes['GeoMapDetail']>>>, ParentType, ContextType, RequireFields<QueryGeoMapDetailsArgs, 'latitude' | 'longitude'>>;
  getAllSupportedGreenOnGreenCrops?: Resolver<Maybe<Array<ResolversTypes['UUID']>>, ParentType, ContextType>;
  greenhouseWhiteningTask?: Resolver<Maybe<ResolversTypes['GreenhouseWhiteningTask']>, ParentType, ContextType, RequireFields<QueryGreenhouseWhiteningTaskArgs, 'uuid'>>;
  greenhouseWhiteningTasks?: Resolver<Maybe<Array<ResolversTypes['GreenhouseWhiteningTask']>>, ParentType, ContextType, Partial<QueryGreenhouseWhiteningTasksArgs>>;
  greenhouses?: Resolver<Maybe<Array<ResolversTypes['Greenhouse']>>, ParentType, ContextType, Partial<QueryGreenhousesArgs>>;
  greetCarbonIntensityScores?: Resolver<Maybe<Array<Maybe<ResolversTypes['GreetCarbonIntensityScore']>>>, ParentType, ContextType, RequireFields<QueryGreetCarbonIntensityScoresArgs, 'carbonFarmingSeasonUuids' | 'cropSeasonUuids'>>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  growthStagePredictionDaily?: Resolver<Maybe<Array<Maybe<ResolversTypes['GrowthStagePredictionDaily']>>>, ParentType, ContextType, RequireFields<QueryGrowthStagePredictionDailyArgs, 'cropSeasonUuid'>>;
  growthStages?: Resolver<Maybe<Array<Maybe<ResolversTypes['GrowthStage']>>>, ParentType, ContextType, RequireFields<QueryGrowthStagesArgs, 'cropSeasonUuid'>>;
  harvest?: Resolver<Maybe<ResolversTypes['Harvest']>, ParentType, ContextType, RequireFields<QueryHarvestArgs, 'uuid'>>;
  harvests?: Resolver<Maybe<Array<ResolversTypes['Harvest']>>, ParentType, ContextType, Partial<QueryHarvestsArgs>>;
  hfAgRegions?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfAgRegion']>>>, ParentType, ContextType, Partial<QueryHfAgRegionsArgs>>;
  hfAlerts?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfAlert']>>>, ParentType, ContextType, RequireFields<QueryHfAlertsArgs, 'farmUuids'>>;
  hfClaims?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfClaim']>>>, ParentType, ContextType, Partial<QueryHfClaimsArgs>>;
  hfContractorRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['HFContractorRequest']>>>, ParentType, ContextType, Partial<QueryHfContractorRequestsArgs>>;
  hfDiscounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfDiscount']>>>, ParentType, ContextType, Partial<QueryHfDiscountsArgs>>;
  hfDistributors?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfDistributor']>>>, ParentType, ContextType, Partial<QueryHfDistributorsArgs>>;
  hfFarms?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfFarm']>>>, ParentType, ContextType, Partial<QueryHfFarmsArgs>>;
  hfInvoices?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfInvoice']>>>, ParentType, ContextType, Partial<QueryHfInvoicesArgs>>;
  hfMachineries?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfMachinery']>>>, ParentType, ContextType, Partial<QueryHfMachineriesArgs>>;
  hfOfferConditions?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfOfferCondition']>>>, ParentType, ContextType, RequireFields<QueryHfOfferConditionsArgs, 'cropSeasonUuid'>>;
  hfOffers?: Resolver<Maybe<Array<ResolversTypes['HfOffer']>>, ParentType, ContextType, RequireFields<QueryHfOffersArgs, 'uuids'>>;
  hfPreOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfPreOrder']>>>, ParentType, ContextType, Partial<QueryHfPreOrdersArgs>>;
  hfPrices?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfPrice']>>>, ParentType, ContextType, RequireFields<QueryHfPricesArgs, 'cropSeasonUuids'>>;
  hfRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfRate']>>>, ParentType, ContextType, Partial<QueryHfRatesArgs>>;
  hfReferenceCodeRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfReferenceCodeRate']>>>, ParentType, ContextType, Partial<QueryHfReferenceCodeRatesArgs>>;
  hfReferenceCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfReferenceCode']>>>, ParentType, ContextType, Partial<QueryHfReferenceCodesArgs>>;
  hfReferenceCodesPublic?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfReferenceCodePublic']>>>, ParentType, ContextType, Partial<QueryHfReferenceCodesPublicArgs>>;
  hfRequestFarmPackageAddOns?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfRequestFarmPackageAddOn']>>>, ParentType, ContextType, Partial<QueryHfRequestFarmPackageAddOnsArgs>>;
  hfRiskClasses?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfRiskClass']>>>, ParentType, ContextType, Partial<QueryHfRiskClassesArgs>>;
  hfSeason?: Resolver<Maybe<ResolversTypes['HfSeason']>, ParentType, ContextType, RequireFields<QueryHfSeasonArgs, 'countryCode'>>;
  hfServiceRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['HFServiceRequest']>>>, ParentType, ContextType, Partial<QueryHfServiceRequestsArgs>>;
  hfServiceRequestsHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['EntityHistory']>>>, ParentType, ContextType, RequireFields<QueryHfServiceRequestsHistoryArgs, 'uuids'>>;
  hfWeatherData?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfWeatherData']>>>, ParentType, ContextType, Partial<QueryHfWeatherDataArgs>>;
  hortaCropSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['HortaCropSeason']>>>, ParentType, ContextType, Partial<QueryHortaCropSeasonsArgs>>;
  hortaSprayings?: Resolver<Maybe<Array<Maybe<ResolversTypes['HortaSpraying']>>>, ParentType, ContextType, Partial<QueryHortaSprayingsArgs>>;
  hortaStresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['HortaStress']>>>, ParentType, ContextType, Partial<QueryHortaStressesArgs>>;
  hortaSustainabilityIndicators?: Resolver<Maybe<Array<Maybe<ResolversTypes['HortaSustainabilityIndicator']>>>, ParentType, ContextType, Partial<QueryHortaSustainabilityIndicatorsArgs>>;
  importOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ImportOrder']>>>, ParentType, ContextType, Partial<QueryImportOrdersArgs>>;
  importantGrowthStages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ImportantGrowthStage']>>>, ParentType, ContextType, RequireFields<QueryImportantGrowthStagesArgs, 'countryCode'>>;
  inviteCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['InviteCode']>>>, ParentType, ContextType>;
  jdFieldSynchronizationOrder?: Resolver<Maybe<ResolversTypes['JdFieldSynchronizationOrder']>, ParentType, ContextType, RequireFields<QueryJdFieldSynchronizationOrderArgs, 'uuid'>>;
  jdFieldSynchronizationOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['JdFieldSynchronizationOrder']>>>, ParentType, ContextType, Partial<QueryJdFieldSynchronizationOrdersArgs>>;
  jdNotificationSubscriptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['JdNotificationSubscription']>>>, ParentType, ContextType, Partial<QueryJdNotificationSubscriptionsArgs>>;
  kubotaApplicationMapDispatchOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['KubotaApplicationMapDispatchOrder']>>>, ParentType, ContextType, Partial<QueryKubotaApplicationMapDispatchOrdersArgs>>;
  kwsConsent?: Resolver<Maybe<ResolversTypes['KwsConsent']>, ParentType, ContextType, RequireFields<QueryKwsConsentArgs, 'uuid'>>;
  kwsSupportedVarieties?: Resolver<Maybe<Array<Maybe<ResolversTypes['KwsSupportedVariety']>>>, ParentType, ContextType>;
  landPreparation?: Resolver<Maybe<Array<Maybe<ResolversTypes['LandPreparation']>>>, ParentType, ContextType, Partial<QueryLandPreparationArgs>>;
  landPreparations?: Resolver<Maybe<Array<ResolversTypes['LandPreparation']>>, ParentType, ContextType, Partial<QueryLandPreparationsArgs>>;
  leafPruningTask?: Resolver<Maybe<ResolversTypes['LeafPruningTask']>, ParentType, ContextType, RequireFields<QueryLeafPruningTaskArgs, 'uuid'>>;
  leafPruningTasks?: Resolver<Maybe<Array<ResolversTypes['LeafPruningTask']>>, ParentType, ContextType, Partial<QueryLeafPruningTasksArgs>>;
  licenseRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['LicenseRequest']>>>, ParentType, ContextType, Partial<QueryLicenseRequestsArgs>>;
  licenses?: Resolver<Maybe<Array<ResolversTypes['License']>>, ParentType, ContextType, Partial<QueryLicensesArgs>>;
  linkedDevices?: Resolver<Maybe<Array<Maybe<ResolversTypes['LinkedDevice']>>>, ParentType, ContextType, Partial<QueryLinkedDevicesArgs>>;
  md2AggregatedProductusesByCrops?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2AggregatedProductusesByCrop']>>>, ParentType, ContextType, Partial<QueryMd2AggregatedProductusesByCropsArgs>>;
  md2Configurations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Configuration']>>>, ParentType, ContextType, Partial<QueryMd2ConfigurationsArgs>>;
  md2CountryCropConfigurations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2CountryCropConfiguration']>>>, ParentType, ContextType, Partial<QueryMd2CountryCropConfigurationsArgs>>;
  md2CropGrowthStageV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropGrowthStageV2']>>>, ParentType, ContextType, Partial<QueryMd2CropGrowthStageV2Args>>;
  md2ProductFeatures?: Resolver<Maybe<Array<ResolversTypes['Md2ProductFeature']>>, ParentType, ContextType, Partial<QueryMd2ProductFeaturesArgs>>;
  md2TillageDepths?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2TillageDepth']>>>, ParentType, ContextType, Partial<QueryMd2TillageDepthsArgs>>;
  md2VraAdvisorConfigurations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2VraAdvisorConfiguration']>>>, ParentType, ContextType, Partial<QueryMd2VraAdvisorConfigurationsArgs>>;
  mdUnits?: Resolver<Maybe<Array<Maybe<ResolversTypes['MdUnit']>>>, ParentType, ContextType, Partial<QueryMdUnitsArgs>>;
  measureSubmissionOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionOrder']>>>, ParentType, ContextType, Partial<QueryMeasureSubmissionOrdersArgs>>;
  measureSubmissionResults?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionResult']>>>, ParentType, ContextType, Partial<QueryMeasureSubmissionResultsArgs>>;
  mergedSmartSprayerExecution?: Resolver<Maybe<ResolversTypes['MergedSmartSprayerExecution']>, ParentType, ContextType, RequireFields<QueryMergedSmartSprayerExecutionArgs, 'uuid'>>;
  minObservationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType, RequireFields<QueryMinObservationDateArgs, 'cropSeasonUuid'>>;
  monitorPractices?: Resolver<Maybe<Array<Maybe<ResolversTypes['MonitorPractice']>>>, ParentType, ContextType, RequireFields<QueryMonitorPracticesArgs, 'fieldUuids'>>;
  multiFileUploadOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['MultiFileUploadOrder']>>>, ParentType, ContextType, Partial<QueryMultiFileUploadOrdersArgs>>;
  namedCropMixes?: Resolver<Maybe<Array<Maybe<ResolversTypes['NamedCropMix']>>>, ParentType, ContextType, RequireFields<QueryNamedCropMixesArgs, 'countryCode'>>;
  notificationPreferences?: Resolver<Maybe<Array<Maybe<ResolversTypes['NotificationPreference']>>>, ParentType, ContextType, Partial<QueryNotificationPreferencesArgs>>;
  nutrientMethodMappings?: Resolver<Maybe<Array<Maybe<ResolversTypes['NutrientMethodMapping']>>>, ParentType, ContextType, Partial<QueryNutrientMethodMappingsArgs>>;
  nutritionVraAdvisorGeometries?: Resolver<Maybe<ResolversTypes['NutritionStacItemVectorization']>, ParentType, ContextType, RequireFields<QueryNutritionVraAdvisorGeometriesArgs, 'index' | 'stacItemUuid'>>;
  observation?: Resolver<Maybe<ResolversTypes['Observation']>, ParentType, ContextType, RequireFields<QueryObservationArgs, 'uuid'>>;
  observations?: Resolver<Maybe<Array<ResolversTypes['Observation']>>, ParentType, ContextType, Partial<QueryObservationsArgs>>;
  onOffStatistics?: Resolver<Maybe<Array<Maybe<ResolversTypes['OnOffStatistics']>>>, ParentType, ContextType, Partial<QueryOnOffStatisticsArgs>>;
  onesoilApplicationMapDispatchOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilApplicationMapDispatchOrder']>>>, ParentType, ContextType, Partial<QueryOnesoilApplicationMapDispatchOrdersArgs>>;
  onesoilDevices?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilDevice']>>>, ParentType, ContextType, Partial<QueryOnesoilDevicesArgs>>;
  onesoilFarmReceivedFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilFarmReceivedFile']>>>, ParentType, ContextType, RequireFields<QueryOnesoilFarmReceivedFilesArgs, 'farmUuids'>>;
  onesoilReceivedFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilReceivedFile']>>>, ParentType, ContextType, Partial<QueryOnesoilReceivedFilesArgs>>;
  onesoilUploadDatasetOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['OneSoilUploadDatasetOrder']>>>, ParentType, ContextType, Partial<QueryOnesoilUploadDatasetOrdersArgs>>;
  operationalInstructions?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfOperationalInstruction']>>>, ParentType, ContextType, RequireFields<QueryOperationalInstructionsArgs, 'cropSeasonUuids' | 'roleFeatureName'>>;
  orderAffiliates?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderAffiliate']>>>, ParentType, ContextType, Partial<QueryOrderAffiliatesArgs>>;
  organisationBranches?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationBranch']>>>, ParentType, ContextType, Partial<QueryOrganisationBranchesArgs>>;
  organisationFarmAssignments?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationFarmAssignment']>>>, ParentType, ContextType, Partial<QueryOrganisationFarmAssignmentsArgs>>;
  organisationFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationFeature']>>>, ParentType, ContextType, Partial<QueryOrganisationFeaturesArgs>>;
  organisationMembers?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationMember']>>>, ParentType, ContextType, Partial<QueryOrganisationMembersArgs>>;
  organisationMembershipRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationMembershipRequest']>>>, ParentType, ContextType, Partial<QueryOrganisationMembershipRequestsArgs>>;
  organisationMethods?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationMethod']>>>, ParentType, ContextType, Partial<QueryOrganisationMethodsArgs>>;
  organisationTags?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganisationTag']>>>, ParentType, ContextType>;
  organisations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Organisation']>>>, ParentType, ContextType, Partial<QueryOrganisationsArgs>>;
  packages?: Resolver<Maybe<Array<ResolversTypes['Package']>>, ParentType, ContextType, Partial<QueryPackagesArgs>>;
  paginatedFarmEvidenceLinks?: Resolver<Maybe<ResolversTypes['PaginatedFarmEvidenceLink']>, ParentType, ContextType, RequireFields<QueryPaginatedFarmEvidenceLinksArgs, 'farmUuid' | 'sustainabilityProgramUuid'>>;
  paginatedFarmReceipts?: Resolver<Maybe<ResolversTypes['PaginatedFarmReceipt']>, ParentType, ContextType, Partial<QueryPaginatedFarmReceiptsArgs>>;
  paginatedFieldDataLayers?: Resolver<Maybe<ResolversTypes['PaginatedFieldDataLayer']>, ParentType, ContextType, RequireFields<QueryPaginatedFieldDataLayersArgs, 'pageSize'>>;
  paginatedFieldDataUploadDatasets?: Resolver<Maybe<ResolversTypes['PaginatedUploadDataset']>, ParentType, ContextType, RequireFields<QueryPaginatedFieldDataUploadDatasetsArgs, 'pageSize'>>;
  paginatedFieldEvidence?: Resolver<Maybe<ResolversTypes['PaginatedFieldEvidence']>, ParentType, ContextType, RequireFields<QueryPaginatedFieldEvidenceArgs, 'farmUuid' | 'sustainabilityProgramUuid'>>;
  paginatedFieldEvidenceLinks?: Resolver<Maybe<ResolversTypes['PaginatedFieldEvidenceLink']>, ParentType, ContextType, RequireFields<QueryPaginatedFieldEvidenceLinksArgs, 'farmUuid' | 'sustainabilityProgramUuid'>>;
  paginatedFieldNotes?: Resolver<Maybe<ResolversTypes['PaginatedFieldNote']>, ParentType, ContextType, RequireFields<QueryPaginatedFieldNotesArgs, 'pageSize'>>;
  paginatedFiles?: Resolver<Maybe<ResolversTypes['PaginatedFile']>, ParentType, ContextType, RequireFields<QueryPaginatedFilesArgs, 'pageSize'>>;
  paginatedHfClaims?: Resolver<Maybe<ResolversTypes['PaginatedHfClaim']>, ParentType, ContextType, RequireFields<QueryPaginatedHfClaimsArgs, 'pageSize'>>;
  paginatedHfContractorRequests?: Resolver<Maybe<ResolversTypes['PaginatedHfContractorRequest']>, ParentType, ContextType, RequireFields<QueryPaginatedHfContractorRequestsArgs, 'pageSize'>>;
  paginatedHfOperationalInstructions?: Resolver<Maybe<ResolversTypes['PaginatedHfOperationalInstruction']>, ParentType, ContextType, RequireFields<QueryPaginatedHfOperationalInstructionsArgs, 'cropSeasonUuids' | 'roleFeatureName'>>;
  paginatedMapItems?: Resolver<Maybe<ResolversTypes['PaginatedMapItem']>, ParentType, ContextType, RequireFields<QueryPaginatedMapItemsArgs, 'locale' | 'pageSize'>>;
  paginatedMd2DictionaryMappings?: Resolver<Maybe<ResolversTypes['PaginatedMd2DictionaryMapping']>, ParentType, ContextType, RequireFields<QueryPaginatedMd2DictionaryMappingsArgs, 'sourceDictShort' | 'targetDictShort'>>;
  paginatedOrganisationQuotaLedgers?: Resolver<Maybe<ResolversTypes['PaginatedOrganisationQuotaLedger']>, ParentType, ContextType, RequireFields<QueryPaginatedOrganisationQuotaLedgersArgs, 'fromDate' | 'organisationUuids' | 'pageSize' | 'tillDate'>>;
  paginatedOrganisations?: Resolver<Maybe<ResolversTypes['PaginatedOrganisation']>, ParentType, ContextType, RequireFields<QueryPaginatedOrganisationsArgs, 'pageSize'>>;
  paginatedPreOrders?: Resolver<Maybe<ResolversTypes['PaginatedPreOrder']>, ParentType, ContextType, RequireFields<QueryPaginatedPreOrdersArgs, 'pageSize'>>;
  paginatedScaleTicketBookingDisputes?: Resolver<Maybe<ResolversTypes['PaginatedScaleTicketBookingDispute']>, ParentType, ContextType, Partial<QueryPaginatedScaleTicketBookingDisputesArgs>>;
  paginatedScaleTicketBookings?: Resolver<Maybe<ResolversTypes['PaginatedScaleTicketBooking']>, ParentType, ContextType, Partial<QueryPaginatedScaleTicketBookingsArgs>>;
  paginatedScaleTicketDataMappings?: Resolver<Maybe<ResolversTypes['PaginatedScaleTicketDataMapping']>, ParentType, ContextType, Partial<QueryPaginatedScaleTicketDataMappingsArgs>>;
  paginatedScaleTicketHistory?: Resolver<Maybe<ResolversTypes['PaginatedScaleTicketHistory']>, ParentType, ContextType, RequireFields<QueryPaginatedScaleTicketHistoryArgs, 'branchUuid' | 'organisationUuid'>>;
  paginatedScaleTicketSellerMappings?: Resolver<Maybe<ResolversTypes['PaginatedScaleTicketSellerMapping']>, ParentType, ContextType, Partial<QueryPaginatedScaleTicketSellerMappingsArgs>>;
  paginatedScaleTicketUploads?: Resolver<Maybe<ResolversTypes['PaginatedScaleTicketUpload']>, ParentType, ContextType, Partial<QueryPaginatedScaleTicketUploadsArgs>>;
  paginatedScaleTickets?: Resolver<Maybe<ResolversTypes['PaginatedScaleTicket']>, ParentType, ContextType, Partial<QueryPaginatedScaleTicketsArgs>>;
  paginatedScoutingTasks?: Resolver<Maybe<ResolversTypes['PaginatedScoutingTask']>, ParentType, ContextType, RequireFields<QueryPaginatedScoutingTasksArgs, 'pageSize'>>;
  paginatedSmartSprayerExecutions?: Resolver<Maybe<ResolversTypes['PaginatedSmartSprayerExecution']>, ParentType, ContextType, RequireFields<QueryPaginatedSmartSprayerExecutionsArgs, 'pageSize'>>;
  paginatedSmartSprayerRegistrations?: Resolver<Maybe<ResolversTypes['PaginatedSmartSprayerRegistration']>, ParentType, ContextType, RequireFields<QueryPaginatedSmartSprayerRegistrationsArgs, 'pageSize'>>;
  paginatedSustainabilityOrganisationCapabilities?: Resolver<Maybe<ResolversTypes['PaginatedSustainabilityOrganisationCapability']>, ParentType, ContextType, Partial<QueryPaginatedSustainabilityOrganisationCapabilitiesArgs>>;
  paginatedSustainabilityProgramBranchAssignments?: Resolver<Maybe<ResolversTypes['PaginatedSustainabilityProgramBranchAssignment']>, ParentType, ContextType, RequireFields<QueryPaginatedSustainabilityProgramBranchAssignmentsArgs, 'sustainabilityProgramUuids'>>;
  paginatedSustainabilityProgramEnrolledFields?: Resolver<Maybe<ResolversTypes['PaginatedSustainabilityProgramEnrolledField']>, ParentType, ContextType, RequireFields<QueryPaginatedSustainabilityProgramEnrolledFieldsArgs, 'sustainabilityProgramUuid'>>;
  paginatedSustainabilityProgramInvitations?: Resolver<Maybe<ResolversTypes['PaginatedSustainabilityProgramInvitation']>, ParentType, ContextType, Partial<QueryPaginatedSustainabilityProgramInvitationsArgs>>;
  paginatedSustainabilityProgramOrganisationParticipations?: Resolver<Maybe<ResolversTypes['PaginatedSustainabilityProgramOrganisationParticipation']>, ParentType, ContextType, Partial<QueryPaginatedSustainabilityProgramOrganisationParticipationsArgs>>;
  paginatedSustainabilityPrograms?: Resolver<Maybe<ResolversTypes['PaginatedSustainabilityProgram']>, ParentType, ContextType, Partial<QueryPaginatedSustainabilityProgramsArgs>>;
  paginatedTasks?: Resolver<Maybe<ResolversTypes['PaginatedTask']>, ParentType, ContextType, RequireFields<QueryPaginatedTasksArgs, 'pageSize'>>;
  paginatedTrialsV2?: Resolver<Maybe<ResolversTypes['PaginatedTrialsV2']>, ParentType, ContextType, RequireFields<QueryPaginatedTrialsV2Args, 'pageSize'>>;
  paginatedVarieties?: Resolver<Maybe<ResolversTypes['PaginatedVariety']>, ParentType, ContextType, RequireFields<QueryPaginatedVarietiesArgs, 'pageSize'>>;
  panoramaClients?: Resolver<Maybe<Array<Maybe<ResolversTypes['PanoramaClient']>>>, ParentType, ContextType, RequireFields<QueryPanoramaClientsArgs, 'panoramaOrgCode'>>;
  panoramaConnectionStatus?: Resolver<Maybe<ResolversTypes['PanoramaConnectionStatus']>, ParentType, ContextType>;
  panoramaFarms?: Resolver<Maybe<Array<Maybe<ResolversTypes['PanoramaFarm']>>>, ParentType, ContextType, RequireFields<QueryPanoramaFarmsArgs, 'panoramaClientName' | 'panoramaOrgCode'>>;
  panoramaFields?: Resolver<Maybe<Array<Maybe<ResolversTypes['PanoramaField']>>>, ParentType, ContextType, Partial<QueryPanoramaFieldsArgs>>;
  panoramaOrganizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['PanoramaOrganization']>>>, ParentType, ContextType>;
  permissionRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['PermissionRequest']>>>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Permission']>>>, ParentType, ContextType, Partial<QueryPermissionsArgs>>;
  pestDevelopmentPredictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PestDevelopmentPrediction']>>>, ParentType, ContextType, RequireFields<QueryPestDevelopmentPredictionsArgs, 'cropSeasonUuids'>>;
  preOrder?: Resolver<Maybe<ResolversTypes['PreOrder']>, ParentType, ContextType, RequireFields<QueryPreOrderArgs, 'uuid'>>;
  preOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['PreOrder']>>>, ParentType, ContextType, Partial<QueryPreOrdersArgs>>;
  precifieldBiomassMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['PrecifieldBiomassMap']>>>, ParentType, ContextType, Partial<QueryPrecifieldBiomassMapsArgs>>;
  precifieldCerealsMapSubscription?: Resolver<Maybe<Array<Maybe<ResolversTypes['PrecifieldCerealsMapSubscription']>>>, ParentType, ContextType, Partial<QueryPrecifieldCerealsMapSubscriptionArgs>>;
  precifieldNitrogenPrescriptionMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['PrecifieldNitrogenPrescriptionMap']>>>, ParentType, ContextType, Partial<QueryPrecifieldNitrogenPrescriptionMapsArgs>>;
  precifieldOsrMapSubscriptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['PrecifieldOsrMapSubscription']>>>, ParentType, ContextType, Partial<QueryPrecifieldOsrMapSubscriptionsArgs>>;
  precifieldYieldPotentialMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['PrecifieldYieldPotentialMap']>>>, ParentType, ContextType, Partial<QueryPrecifieldYieldPotentialMapsArgs>>;
  produceDeliveryTask?: Resolver<Maybe<ResolversTypes['ProduceDeliveryTask']>, ParentType, ContextType, RequireFields<QueryProduceDeliveryTaskArgs, 'uuid'>>;
  produceDeliveryTasks?: Resolver<Maybe<Array<ResolversTypes['ProduceDeliveryTask']>>, ParentType, ContextType, Partial<QueryProduceDeliveryTasksArgs>>;
  productPacks?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductPack']>>>, ParentType, ContextType, Partial<QueryProductPacksArgs>>;
  productPermissibleRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductPermissibleRate']>>>, ParentType, ContextType, Partial<QueryProductPermissibleRatesArgs>>;
  productPermissibleRatesV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductPermissibleRateV2']>>>, ParentType, ContextType, Partial<QueryProductPermissibleRatesV2Args>>;
  productRecommendationTankMixes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductRecommendationTankMix']>>>, ParentType, ContextType, Partial<QueryProductRecommendationTankMixesArgs>>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['Product']>>>, ParentType, ContextType, RequireFields<QueryProductsArgs, 'cropUuid'>>;
  productsV2?: Resolver<Maybe<Array<ResolversTypes['ProductV2']>>, ParentType, ContextType, Partial<QueryProductsV2Args>>;
  projectedIncidences?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProjectedIncidences']>>>, ParentType, ContextType, RequireFields<QueryProjectedIncidencesArgs, 'cropSeasonUuids'>>;
  protocol?: Resolver<Maybe<ResolversTypes['Protocol']>, ParentType, ContextType, Partial<QueryProtocolArgs>>;
  protocolAttachments?: Resolver<Array<Maybe<ResolversTypes['ProtocolAttachment']>>, ParentType, ContextType, Partial<QueryProtocolAttachmentsArgs>>;
  protocols?: Resolver<Maybe<Array<Maybe<ResolversTypes['Protocol']>>>, ParentType, ContextType, Partial<QueryProtocolsArgs>>;
  publicOrganisations?: Resolver<Maybe<Array<Maybe<ResolversTypes['PublicOrganisation']>>>, ParentType, ContextType, Partial<QueryPublicOrganisationsArgs>>;
  quotaLimits?: Resolver<Maybe<Array<Maybe<ResolversTypes['QuotaLimit']>>>, ParentType, ContextType, Partial<QueryQuotaLimitsArgs>>;
  quotaTransfers?: Resolver<Maybe<Array<Maybe<ResolversTypes['QuotaTransfer']>>>, ParentType, ContextType, Partial<QueryQuotaTransfersArgs>>;
  recentlyUsedProducts?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecentlyUsedProduct']>>>, ParentType, ContextType, RequireFields<QueryRecentlyUsedProductsArgs, 'farmUuids'>>;
  risks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Risk']>>>, ParentType, ContextType, RequireFields<QueryRisksArgs, 'cropSeasonUuids'>>;
  risksV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['RiskV2']>>>, ParentType, ContextType, RequireFields<QueryRisksV2Args, 'cropSeasonUuids'>>;
  scaleTicket?: Resolver<Maybe<ResolversTypes['ScaleTicket']>, ParentType, ContextType, RequireFields<QueryScaleTicketArgs, 'uuid'>>;
  scaleTicketBooking?: Resolver<Maybe<ResolversTypes['ScaleTicketBooking']>, ParentType, ContextType, RequireFields<QueryScaleTicketBookingArgs, 'uuid'>>;
  scaleTicketBookingDispute?: Resolver<Maybe<ResolversTypes['ScaleTicketBookingDispute']>, ParentType, ContextType, RequireFields<QueryScaleTicketBookingDisputeArgs, 'uuid'>>;
  scaleTicketSummary?: Resolver<Maybe<ResolversTypes['ScaleTicketSummary']>, ParentType, ContextType, RequireFields<QueryScaleTicketSummaryArgs, 'organisationUuid'>>;
  scaleTicketUpload?: Resolver<Maybe<ResolversTypes['ScaleTicketUpload']>, ParentType, ContextType, RequireFields<QueryScaleTicketUploadArgs, 'uuid'>>;
  scoutingPois?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingPoi']>>>, ParentType, ContextType, Partial<QueryScoutingPoisArgs>>;
  scoutingPoisV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingPoiV2']>>>, ParentType, ContextType, Partial<QueryScoutingPoisV2Args>>;
  scoutingProtocols?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingProtocol']>>>, ParentType, ContextType, Partial<QueryScoutingProtocolsArgs>>;
  scoutingReportDispatchOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingReportDispatchOrder']>>>, ParentType, ContextType, Partial<QueryScoutingReportDispatchOrdersArgs>>;
  scoutingReports?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingReport']>>>, ParentType, ContextType, Partial<QueryScoutingReportsArgs>>;
  scoutingStressQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingStressQuestion']>>>, ParentType, ContextType, Partial<QueryScoutingStressQuestionsArgs>>;
  scoutingStressQuestionsByWeedAssessmentType?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingStressQuestion']>>>, ParentType, ContextType, Partial<QueryScoutingStressQuestionsByWeedAssessmentTypeArgs>>;
  scoutingTasks?: Resolver<Maybe<Array<ResolversTypes['ScoutingTask']>>, ParentType, ContextType, Partial<QueryScoutingTasksArgs>>;
  searchFieldIdentifierScores?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldIdentifierScore']>>>, ParentType, ContextType, Partial<QuerySearchFieldIdentifierScoresArgs>>;
  searchFieldVariabilityInSeason?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldVariabilityInSeason']>>>, ParentType, ContextType, RequireFields<QuerySearchFieldVariabilityInSeasonArgs, 'farmUuids'>>;
  searchFieldVariabilityTimeSeries?: Resolver<Maybe<Array<ResolversTypes['FieldVariabilityTimeSeries']>>, ParentType, ContextType, RequireFields<QuerySearchFieldVariabilityTimeSeriesArgs, 'cropSeasonUuids' | 'fromDate' | 'tillDate'>>;
  searchTreatmentPrograms?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonTreatmentProgramV3']>>>, ParentType, ContextType, RequireFields<QuerySearchTreatmentProgramsArgs, 'farmUuid' | 'type'>>;
  searchTreatmentScenarios?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentScenario']>>>, ParentType, ContextType, RequireFields<QuerySearchTreatmentScenariosArgs, 'cropUuid' | 'equipmentType' | 'farmUuid' | 'type'>>;
  seasonTimelines?: Resolver<Maybe<Array<Maybe<ResolversTypes['SeasonTimeline']>>>, ParentType, ContextType, Partial<QuerySeasonTimelinesArgs>>;
  seedBoxTreatments?: Resolver<Maybe<Array<ResolversTypes['SeedBoxTreatment']>>, ParentType, ContextType, Partial<QuerySeedBoxTreatmentsArgs>>;
  seedSelectorInput?: Resolver<Maybe<ResolversTypes['SeedSelectorInput']>, ParentType, ContextType, RequireFields<QuerySeedSelectorInputArgs, 'uuid'>>;
  seedSelectorInputs?: Resolver<Maybe<Array<Maybe<ResolversTypes['SeedSelectorInput']>>>, ParentType, ContextType, Partial<QuerySeedSelectorInputsArgs>>;
  seedTreatments?: Resolver<Maybe<Array<ResolversTypes['SeedTreatment']>>, ParentType, ContextType, Partial<QuerySeedTreatmentsArgs>>;
  sharingMandates?: Resolver<Maybe<Array<Maybe<ResolversTypes['SharingMandate']>>>, ParentType, ContextType, Partial<QuerySharingMandatesArgs>>;
  shopDevicePackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopDevicePackage']>>>, ParentType, ContextType, Partial<QueryShopDevicePackagesArgs>>;
  shopFarmPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopFarmPackage']>>>, ParentType, ContextType, Partial<QueryShopFarmPackagesArgs>>;
  shopGiftCard?: Resolver<Maybe<ResolversTypes['ShopGiftCard']>, ParentType, ContextType, RequireFields<QueryShopGiftCardArgs, 'giftCardCode'>>;
  shopSubscriptionItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopSubscriptionItem']>>>, ParentType, ContextType, Partial<QueryShopSubscriptionItemsArgs>>;
  shopSubscriptionPeriod?: Resolver<Maybe<ResolversTypes['ShopSubscriptionPeriod']>, ParentType, ContextType, RequireFields<QueryShopSubscriptionPeriodArgs, 'uuid'>>;
  shopSubscriptionPeriods?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopSubscriptionPeriod']>>>, ParentType, ContextType, Partial<QueryShopSubscriptionPeriodsArgs>>;
  shopSubscriptions?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopSubscription']>>>, ParentType, ContextType, Partial<QueryShopSubscriptionsArgs>>;
  shopUserPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopUserPackage']>>>, ParentType, ContextType, Partial<QueryShopUserPackagesArgs>>;
  smagConnectionStatus?: Resolver<Maybe<ResolversTypes['SmagConnectionStatus']>, ParentType, ContextType>;
  smartSprayerExecution?: Resolver<Maybe<ResolversTypes['SmartSprayerExecution']>, ParentType, ContextType, RequireFields<QuerySmartSprayerExecutionArgs, 'uuid'>>;
  smartSprayerExecutionStatistics?: Resolver<Maybe<ResolversTypes['SmartSprayerExecutionStatistics']>, ParentType, ContextType, Partial<QuerySmartSprayerExecutionStatisticsArgs>>;
  smartSprayerExecutions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerExecution']>>>, ParentType, ContextType, Partial<QuerySmartSprayerExecutionsArgs>>;
  smartSprayerLicenses?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerLicense']>>>, ParentType, ContextType, Partial<QuerySmartSprayerLicensesArgs>>;
  smartSprayerRegistration?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistration']>, ParentType, ContextType, RequireFields<QuerySmartSprayerRegistrationArgs, 'uuid'>>;
  smartSprayerRegistrationStatus?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistrationStatus']>, ParentType, ContextType, RequireFields<QuerySmartSprayerRegistrationStatusArgs, 'uuid'>>;
  smartSprayerRegistrations?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerRegistration']>>>, ParentType, ContextType, Partial<QuerySmartSprayerRegistrationsArgs>>;
  smartSprayerWeedPressureExclusions?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureExclusionSet']>, ParentType, ContextType, RequireFields<QuerySmartSprayerWeedPressureExclusionsArgs, 'fieldUuid'>>;
  smartSprayerWeedPressureField?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureField']>, ParentType, ContextType, RequireFields<QuerySmartSprayerWeedPressureFieldArgs, 'fieldUuid'>>;
  smartSprayerWeedPressureFields?: Resolver<Maybe<ResolversTypes['PaginatedSmartSprayerWeedPressureFields']>, ParentType, ContextType, RequireFields<QuerySmartSprayerWeedPressureFieldsArgs, 'pageSize'>>;
  smartSprayerWeedPressureStatistics?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureStatistics']>, ParentType, ContextType, Partial<QuerySmartSprayerWeedPressureStatisticsArgs>>;
  smartSprayingOfflineTask?: Resolver<Maybe<ResolversTypes['SmartSprayingOfflineTask']>, ParentType, ContextType, RequireFields<QuerySmartSprayingOfflineTaskArgs, 'uuid'>>;
  smartSprayingOfflineTasks?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingOfflineTask']>>, ParentType, ContextType, Partial<QuerySmartSprayingOfflineTasksArgs>>;
  smartSprayingOfflineTasksV2?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingOfflineTask']>>, ParentType, ContextType, Partial<QuerySmartSprayingOfflineTasksV2Args>>;
  smartSprayingTask?: Resolver<ResolversTypes['SmartSprayingTask'], ParentType, ContextType, RequireFields<QuerySmartSprayingTaskArgs, 'uuid'>>;
  smartSprayingTaskDevicePayloads?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingTaskDevicePayload']>>, ParentType, ContextType, Partial<QuerySmartSprayingTaskDevicePayloadsArgs>>;
  smartSprayingTaskV2?: Resolver<ResolversTypes['SmartSprayingTaskV2'], ParentType, ContextType, RequireFields<QuerySmartSprayingTaskV2Args, 'uuid'>>;
  smartSprayingTasks?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingTask']>>, ParentType, ContextType, Partial<QuerySmartSprayingTasksArgs>>;
  smartSprayingTasksV2?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingTaskV2']>>, ParentType, ContextType, Partial<QuerySmartSprayingTasksV2Args>>;
  smartSprayingTerminalStrategyMappings?: Resolver<Maybe<ResolversTypes['SmartSprayingTerminalStrategyMappings']>, ParentType, ContextType>;
  smartSprayingTerminalTask?: Resolver<Maybe<ResolversTypes['SmartSprayingTerminalTask']>, ParentType, ContextType, RequireFields<QuerySmartSprayingTerminalTaskArgs, 'uuid'>>;
  smartSprayingTerminalTasks?: Resolver<Maybe<Array<ResolversTypes['SmartSprayingTerminalTask']>>, ParentType, ContextType, Partial<QuerySmartSprayingTerminalTasksArgs>>;
  soilNematodeRisks?: Resolver<Maybe<Array<Maybe<ResolversTypes['MdSoilNematodeRisk']>>>, ParentType, ContextType, Partial<QuerySoilNematodeRisksArgs>>;
  soilSampling?: Resolver<Maybe<ResolversTypes['SoilSampling']>, ParentType, ContextType, RequireFields<QuerySoilSamplingArgs, 'uuid'>>;
  soilSamplingMeasurements?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingMeasurement']>>>, ParentType, ContextType>;
  soilSamplingResult?: Resolver<Maybe<ResolversTypes['SoilSamplingResult']>, ParentType, ContextType, RequireFields<QuerySoilSamplingResultArgs, 'uuid'>>;
  soilSamplingResults?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingResult']>>>, ParentType, ContextType, Partial<QuerySoilSamplingResultsArgs>>;
  soilSamplingStressAnalyses?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingStressAnalysis']>>>, ParentType, ContextType, Partial<QuerySoilSamplingStressAnalysesArgs>>;
  soilSamplingStressAnalysis?: Resolver<Maybe<ResolversTypes['SoilSamplingStressAnalysis']>, ParentType, ContextType, RequireFields<QuerySoilSamplingStressAnalysisArgs, 'uuid'>>;
  soilSamplingTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingTask']>>>, ParentType, ContextType, Partial<QuerySoilSamplingTasksArgs>>;
  soilSamplings?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSampling']>>>, ParentType, ContextType, Partial<QuerySoilSamplingsArgs>>;
  soilTaxonomies?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilTaxonomy']>>>, ParentType, ContextType, Partial<QuerySoilTaxonomiesArgs>>;
  soilTextures?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilTexture']>>>, ParentType, ContextType, Partial<QuerySoilTexturesArgs>>;
  sourceMapStyle?: Resolver<Maybe<ResolversTypes['SourceMapStyle']>, ParentType, ContextType, RequireFields<QuerySourceMapStyleArgs, 'type'>>;
  sourceMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['SourceMap']>>>, ParentType, ContextType, Partial<QuerySourceMapsArgs>>;
  sprayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Sprayer']>>>, ParentType, ContextType, Partial<QuerySprayersArgs>>;
  spraying?: Resolver<Maybe<Array<Maybe<ResolversTypes['Spraying']>>>, ParentType, ContextType, RequireFields<QuerySprayingArgs, 'uuid'>>;
  sprayingV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['SprayingV2']>>>, ParentType, ContextType, RequireFields<QuerySprayingV2Args, 'uuid'>>;
  sprayingsV2?: Resolver<Maybe<Array<ResolversTypes['SprayingV2']>>, ParentType, ContextType, Partial<QuerySprayingsV2Args>>;
  stacFarmStatistics?: Resolver<Maybe<Array<Maybe<ResolversTypes['StacFarmStatistics']>>>, ParentType, ContextType, RequireFields<QueryStacFarmStatisticsArgs, 'farmUuids'>>;
  stacItemRenders?: Resolver<Maybe<Array<Maybe<ResolversTypes['StacItemRender']>>>, ParentType, ContextType, Partial<QueryStacItemRendersArgs>>;
  stacItemVectorizeGeometries?: Resolver<Maybe<ResolversTypes['StacItemVectorizeGeometry']>, ParentType, ContextType, RequireFields<QueryStacItemVectorizeGeometriesArgs, 'creationFlowHint' | 'index' | 'stacItemUuid'>>;
  stacMosaicRender?: Resolver<Maybe<ResolversTypes['StacMosaicRender']>, ParentType, ContextType, RequireFields<QueryStacMosaicRenderArgs, 'magnitudeType'>>;
  stirObjects?: Resolver<Array<ResolversTypes['StirObject']>, ParentType, ContextType, Partial<QueryStirObjectsArgs>>;
  stirOperations?: Resolver<Array<ResolversTypes['StirOperation']>, ParentType, ContextType, RequireFields<QueryStirOperationsArgs, 'taskType'>>;
  stressEfficacyCharacteristics?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressEfficacyCharacteristics']>>>, ParentType, ContextType, RequireFields<QueryStressEfficacyCharacteristicsArgs, 'cropSeasonUuids'>>;
  stressQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressQuestion']>>>, ParentType, ContextType, Partial<QueryStressQuestionsArgs>>;
  stressSettings?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressSettings']>>>, ParentType, ContextType, Partial<QueryStressSettingsArgs>>;
  stressSettingsByUuid?: Resolver<Maybe<ResolversTypes['StressSettings']>, ParentType, ContextType, RequireFields<QueryStressSettingsByUuidArgs, 'uuid'>>;
  stresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['Stress']>>>, ParentType, ContextType, Partial<QueryStressesArgs>>;
  stressesV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressV2']>>>, ParentType, ContextType, Partial<QueryStressesV2Args>>;
  subscriptionPreference?: Resolver<Maybe<ResolversTypes['SubscriptionPreference']>, ParentType, ContextType>;
  sustainabilityInput?: Resolver<Maybe<ResolversTypes['SustainabilityInput']>, ParentType, ContextType, RequireFields<QuerySustainabilityInputArgs, 'uuid'>>;
  sustainabilityInputs?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityInput']>>>, ParentType, ContextType, Partial<QuerySustainabilityInputsArgs>>;
  sustainabilityProgram?: Resolver<Maybe<ResolversTypes['SustainabilityProgram']>, ParentType, ContextType, RequireFields<QuerySustainabilityProgramArgs, 'uuid'>>;
  sustainabilityProgramInvitation?: Resolver<Maybe<ResolversTypes['SustainabilityProgramInvitation']>, ParentType, ContextType, RequireFields<QuerySustainabilityProgramInvitationArgs, 'uuid'>>;
  sustainabilityProgramStaffMembers?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityProgramStaffMember']>>>, ParentType, ContextType, Partial<QuerySustainabilityProgramStaffMembersArgs>>;
  sustainabilityPrograms?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainabilityProgram']>>>, ParentType, ContextType, Partial<QuerySustainabilityProgramsArgs>>;
  tDiskAssignments?: Resolver<Array<ResolversTypes['TDiskAssignment']>, ParentType, ContextType, Partial<QueryTDiskAssignmentsArgs>>;
  tDiskOperations?: Resolver<Array<ResolversTypes['TDiskOperation']>, ParentType, ContextType, Partial<QueryTDiskOperationsArgs>>;
  taskAggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskAggregation']>>>, ParentType, ContextType, Partial<QueryTaskAggregationsArgs>>;
  tasksHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['EntityHistory']>>>, ParentType, ContextType, RequireFields<QueryTasksHistoryArgs, 'taskTypes' | 'uuids'>>;
  tasksSummary?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskSummary']>>>, ParentType, ContextType, RequireFields<QueryTasksSummaryArgs, 'creationFlowHint' | 'cropUuids' | 'farmUuids' | 'taskType'>>;
  tenants?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tenant']>>>, ParentType, ContextType>;
  tillageSystems?: Resolver<Maybe<Array<Maybe<ResolversTypes['TillageSystem']>>>, ParentType, ContextType, Partial<QueryTillageSystemsArgs>>;
  timingCalculationStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingCalculationStatus']>>>, ParentType, ContextType, RequireFields<QueryTimingCalculationStatusesArgs, 'cropSeasonUuids'>>;
  timingLimitationsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingLimitationV2']>>>, ParentType, ContextType, RequireFields<QueryTimingLimitationsV2Args, 'cropSeasonUuids'>>;
  timingLimitationsV2List?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingLimitationV2']>>>, ParentType, ContextType, RequireFields<QueryTimingLimitationsV2ListArgs, 'inputs'>>;
  timingProductRecommendations?: Resolver<Maybe<Array<ResolversTypes['TimingProductRecommendation']>>, ParentType, ContextType, RequireFields<QueryTimingProductRecommendationsArgs, 'cropSeasonUuids'>>;
  timingProductRecommendationsGroups?: Resolver<Maybe<Array<ResolversTypes['TimingProductRecommendationsGroup']>>, ParentType, ContextType, RequireFields<QueryTimingProductRecommendationsGroupsArgs, 'cropSeasonUuids' | 'includeDoseRateCompatibility'>>;
  toppingTask?: Resolver<Maybe<ResolversTypes['ToppingTask']>, ParentType, ContextType, RequireFields<QueryToppingTaskArgs, 'uuid'>>;
  toppingTasks?: Resolver<Maybe<Array<ResolversTypes['ToppingTask']>>, ParentType, ContextType, Partial<QueryToppingTasksArgs>>;
  tramlines?: Resolver<Maybe<Array<Maybe<ResolversTypes['Tramline']>>>, ParentType, ContextType, Partial<QueryTramlinesArgs>>;
  treatmentScenario?: Resolver<Maybe<ResolversTypes['TreatmentScenario']>, ParentType, ContextType, RequireFields<QueryTreatmentScenarioArgs, 'uuid'>>;
  treatmentScenarios?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentScenario']>>>, ParentType, ContextType, Partial<QueryTreatmentScenariosArgs>>;
  trials?: Resolver<Array<Maybe<ResolversTypes['Trial']>>, ParentType, ContextType, Partial<QueryTrialsArgs>>;
  uploadDatasetSourceValueMappings?: Resolver<Maybe<Array<Maybe<ResolversTypes['SourceValueMapping']>>>, ParentType, ContextType, RequireFields<QueryUploadDatasetSourceValueMappingsArgs, 'measurement' | 'uploadDatasetUuid'>>;
  uploadDatasetSummaries?: Resolver<Array<ResolversTypes['UploadDatasetSummary']>, ParentType, ContextType, Partial<QueryUploadDatasetSummariesArgs>>;
  userDataVsValidationComparisons?: Resolver<Array<ResolversTypes['UserDataVsValidationComparison']>, ParentType, ContextType, RequireFields<QueryUserDataVsValidationComparisonsArgs, 'fieldUuids'>>;
  userDevices?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserDevice']>>>, ParentType, ContextType, Partial<QueryUserDevicesArgs>>;
  userFarmPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserFarmPackage']>>>, ParentType, ContextType, Partial<QueryUserFarmPackagesArgs>>;
  userFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserFeature']>>>, ParentType, ContextType>;
  userGroups?: Resolver<Maybe<Array<ResolversTypes['UserGroup']>>, ParentType, ContextType, Partial<QueryUserGroupsArgs>>;
  userLicenseRequests?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserLicenseRequest']>>>, ParentType, ContextType, Partial<QueryUserLicenseRequestsArgs>>;
  userNotifications?: Resolver<Maybe<Array<Maybe<ResolversTypes['Notification']>>>, ParentType, ContextType, RequireFields<QueryUserNotificationsArgs, 'fromDate' | 'tillDate'>>;
  userNotificationsV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserNotification']>>>, ParentType, ContextType, RequireFields<QueryUserNotificationsV2Args, 'fromDate' | 'languageCode'>>;
  userPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserPackage']>>>, ParentType, ContextType, Partial<QueryUserPackagesArgs>>;
  userSettings?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserSetting']>>>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType, Partial<QueryUsersArgs>>;
  varieties?: Resolver<Maybe<Array<Maybe<ResolversTypes['Variety']>>>, ParentType, ContextType, Partial<QueryVarietiesArgs>>;
  varietyCharacteristics?: Resolver<Maybe<Array<Maybe<ResolversTypes['VarietyCharacteristic']>>>, ParentType, ContextType, RequireFields<QueryVarietyCharacteristicsArgs, 'characteristicIds'>>;
  varietyRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['VarietyRecommendation']>>>, ParentType, ContextType, RequireFields<QueryVarietyRecommendationsArgs, 'fieldUuids'>>;
  vendorDeviceBlacklistEntries?: Resolver<Maybe<Array<Maybe<ResolversTypes['VendorDeviceBlacklistEntry']>>>, ParentType, ContextType, Partial<QueryVendorDeviceBlacklistEntriesArgs>>;
  vendorDeviceDataAnomalies?: Resolver<Maybe<Array<Maybe<ResolversTypes['VendorDeviceDataAnomaly']>>>, ParentType, ContextType, RequireFields<QueryVendorDeviceDataAnomaliesArgs, 'fromDate' | 'tillDate' | 'timeFormat'>>;
  vendorDeviceDataMissing?: Resolver<Maybe<Array<Maybe<ResolversTypes['VendorDeviceDataMissing']>>>, ParentType, ContextType, RequireFields<QueryVendorDeviceDataMissingArgs, 'fromDate' | 'tillDate' | 'timeFormat'>>;
  vendorDeviceSensorStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['VendorDeviceSensorStatus']>>>, ParentType, ContextType, Partial<QueryVendorDeviceSensorStatusesArgs>>;
  vendorDeviceStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['VendorDeviceStatus']>>>, ParentType, ContextType, Partial<QueryVendorDeviceStatusArgs>>;
  waterBalances?: Resolver<Maybe<Array<Maybe<ResolversTypes['WaterBalance']>>>, ParentType, ContextType, RequireFields<QueryWaterBalancesArgs, 'cropSeasonUuids'>>;
  waterManagementScenarios?: Resolver<Maybe<Array<Maybe<ResolversTypes['WaterManagementScenario']>>>, ParentType, ContextType, Partial<QueryWaterManagementScenariosArgs>>;
  waterManagementTask?: Resolver<Maybe<ResolversTypes['WaterManagementTask']>, ParentType, ContextType, RequireFields<QueryWaterManagementTaskArgs, 'uuid'>>;
  waterManagementTasks?: Resolver<Maybe<Array<ResolversTypes['WaterManagementTask']>>, ParentType, ContextType, Partial<QueryWaterManagementTasksArgs>>;
  weather?: Resolver<Maybe<Array<Maybe<ResolversTypes['Weather']>>>, ParentType, ContextType, RequireFields<QueryWeatherArgs, 'foreignUuid' | 'fromDate' | 'tillDate'>>;
  weatherUserData?: Resolver<Maybe<ResolversTypes['WeatherUserData']>, ParentType, ContextType, RequireFields<QueryWeatherUserDataArgs, 'uuid'>>;
  weatherUserDataList?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeatherUserData']>>>, ParentType, ContextType, Partial<QueryWeatherUserDataListArgs>>;
  weedRecord?: Resolver<ResolversTypes['WeedRecord'], ParentType, ContextType, RequireFields<QueryWeedRecordArgs, 'uuid'>>;
  weedRecords?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeedRecord']>>>, ParentType, ContextType, Partial<QueryWeedRecordsArgs>>;
  weeklySeedingRecommendations?: Resolver<Maybe<Array<Maybe<ResolversTypes['WeeklySeedingRecommendation']>>>, ParentType, ContextType, RequireFields<QueryWeeklySeedingRecommendationsArgs, 'cropSeasonUuid'>>;
  wiuzConnectionStatus?: Resolver<Maybe<ResolversTypes['WiuzConnectionStatus']>, ParentType, ContextType>;
  wiuzUserFarms?: Resolver<Maybe<Array<Maybe<ResolversTypes['WiuzUserFarm']>>>, ParentType, ContextType>;
  wiuzUserfarmImportOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['WiuzUserfarmImportOrder']>>>, ParentType, ContextType, Partial<QueryWiuzUserfarmImportOrdersArgs>>;
}>;

export type QuotaLimitResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['QuotaLimit'] = ResolversParentTypes['QuotaLimit']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  license?: Resolver<ResolversTypes['License'], ParentType, ContextType>;
  maxQuota?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisation?: Resolver<ResolversTypes['Organisation'], ParentType, ContextType>;
  retracted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type QuotaTransferResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['QuotaTransfer'] = ResolversParentTypes['QuotaTransfer']> = ResolversObject<{
  createdDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  license?: Resolver<ResolversTypes['License'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceOrganisation?: Resolver<ResolversTypes['PublicOrganisation'], ParentType, ContextType>;
  targetOrganisation?: Resolver<ResolversTypes['PublicOrganisation'], ParentType, ContextType>;
  targetOrganisationCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type RateByZoneResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RateByZone'] = ResolversParentTypes['RateByZone']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type RatesCalculationRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RatesCalculationRequest'] = ResolversParentTypes['RatesCalculationRequest']> = ResolversObject<{
  allowLimitationViolations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  applicationFieldZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationFieldZone']>>>, ParentType, ContextType>;
  applicationMapZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicationMapZone']>>>, ParentType, ContextType>;
  applicationStrategy?: Resolver<Maybe<ResolversTypes['ApplicationStrategy']>, ParentType, ContextType>;
  applicationType?: Resolver<Maybe<ResolversTypes['ApplicationType']>, ParentType, ContextType>;
  baseFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lowestZoneExcluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  referenceProductRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReferenceProductRate']>>>, ParentType, ContextType>;
  referenceTotalMixtureRate?: Resolver<Maybe<ResolversTypes['ReferenceTotalMixtureRate']>, ParentType, ContextType>;
  referenceZoneId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zoneFactors?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  zoneIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  zonePercentageDifferences?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZonePercentageDifference']>>>, ParentType, ContextType>;
}>;

export type RecentlyUsedProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RecentlyUsedProduct'] = ResolversParentTypes['RecentlyUsedProduct']> = ResolversObject<{
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  productCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['Md2Item']>>>, ParentType, ContextType>;
  productCategoryUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  productUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['TaskType']>, ParentType, ContextType>;
  usedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type RecommendationActionValidityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RecommendationActionValidity'] = ResolversParentTypes['RecommendationActionValidity']> = ResolversObject<{
  calendarDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  daysAfterSeeding?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  growthStageIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growthStageScale?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['NutritionActionValidityType']>, ParentType, ContextType>;
}>;

export type RecommendationSnoozeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RecommendationSnooze'] = ResolversParentTypes['RecommendationSnooze']> = ResolversObject<{
  actionType?: Resolver<Maybe<ResolversTypes['RecommendationSnoozeType']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type RecommendedRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RecommendedRate'] = ResolversParentTypes['RecommendedRate']> = ResolversObject<{
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  rateUnit?: Resolver<ResolversTypes['RateUnit'], ParentType, ContextType>;
  zoneId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type RecommendedTimingForApplicationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RecommendedTimingForApplication'] = ResolversParentTypes['RecommendedTimingForApplication']> = ResolversObject<{
  applicationOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['BBCHScale']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['BBCHScale']>, ParentType, ContextType>;
}>;

export type ReferenceProductRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ReferenceProductRate'] = ResolversParentTypes['ReferenceProductRate']> = ResolversObject<{
  formulationType?: Resolver<Maybe<ResolversTypes['ProductFormulationTypeGroup']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  productUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  referenceRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ReferenceTotalMixtureRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ReferenceTotalMixtureRate'] = ResolversParentTypes['ReferenceTotalMixtureRate']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referenceRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type RegionRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RegionRate'] = ResolversParentTypes['RegionRate']> = ResolversObject<{
  basePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type RelativeMaturityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RelativeMaturity'] = ResolversParentTypes['RelativeMaturity']> = ResolversObject<{
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ResidualActivationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ResidualActivation'] = ResolversParentTypes['ResidualActivation']> = ResolversObject<{
  activationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  activationDeadline?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scoutingReminderDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sprayingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ResidualActivationStatus']>, ParentType, ContextType>;
}>;

export type ResponseStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ResponseStatus'] = ResolversParentTypes['ResponseStatus']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCodeTranslation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorCodeTranslationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type RiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Risk'] = ResolversParentTypes['Risk']> = ResolversObject<{
  basedOn?: Resolver<Maybe<ResolversTypes['CalculationBase']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CropSeasonStatusState']>, ParentType, ContextType>;
  statusPrecision?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stressV2?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<RiskStressV2Args>>;
  type?: Resolver<Maybe<ResolversTypes['RiskType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type RiskClassificationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RiskClassification'] = ResolversParentTypes['RiskClassification']> = ResolversObject<{
  maxValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  riskLevel?: Resolver<Maybe<ResolversTypes['RiskLevel']>, ParentType, ContextType>;
  thresholdUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zoneId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type RiskMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RiskMap'] = ResolversParentTypes['RiskMap']> = ResolversObject<{
  aggregatedRiskLevel?: Resolver<Maybe<ResolversTypes['RiskLevel']>, ParentType, ContextType>;
  assessmentObjectUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  classification?: Resolver<Maybe<Array<Maybe<ResolversTypes['RiskClassification']>>>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type RiskV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['RiskV2'] = ResolversParentTypes['RiskV2']> = ResolversObject<{
  basedOn?: Resolver<Maybe<ResolversTypes['CalculationBase']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CropSeasonStatusState']>, ParentType, ContextType>;
  statusPrecision?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressV2']>>>, ParentType, ContextType, Partial<RiskV2StressesArgs>>;
  type?: Resolver<Maybe<ResolversTypes['RiskType']>, ParentType, ContextType>;
}>;

export type SampledPointResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SampledPoint'] = ResolversParentTypes['SampledPoint']> = ResolversObject<{
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
}>;

export type SamplingAreaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SamplingArea'] = ResolversParentTypes['SamplingArea']> = ResolversObject<{
  area?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  classId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCores?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type SamplingDepthResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SamplingDepth'] = ResolversParentTypes['SamplingDepth']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type SamplingIdResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SamplingId'] = ResolversParentTypes['SamplingId']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samplingAreaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samplingDepthId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type SamplingPointResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SamplingPoint'] = ResolversParentTypes['SamplingPoint']> = ResolversObject<{
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
}>;

export type ScaleTicketResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicket'] = ResolversParentTypes['ScaleTicket']> = ResolversObject<{
  bookings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketBooking']>>>, ParentType, ContextType>;
  branchUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  dataMappingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  grossWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sampleMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerIsAnElevator?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sellerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['ScaleTicketState']>, ParentType, ContextType>;
  tareWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ticketNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weighedInAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weighedOutAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketBookingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketBooking'] = ResolversParentTypes['ScaleTicketBooking']> = ResolversObject<{
  booking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bookingNote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carbonFarmingSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldCiScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fieldCiScoreUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldHarvestCap?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fieldHarvestDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['ScaleTicketBookingState']>, ParentType, ContextType>;
  sustainabilityProgramAllocationOrder?: Resolver<Maybe<ResolversTypes['SustainabilityProgramAllocationOrder']>, ParentType, ContextType>;
  sustainabilityProgramName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sustainabilityProgramUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  ticketUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketBookingDisputeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketBookingDispute'] = ResolversParentTypes['ScaleTicketBookingDispute']> = ResolversObject<{
  bookingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  correctedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  correctedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  correctionReason?: Resolver<Maybe<ResolversTypes['ScaleTicketBookingDisputeCorrectionReason']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputeNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldNotEnrolled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  heldNetWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketBookingDisputeReason']>>>, ParentType, ContextType>;
  rejectedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectedReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketBookingDisputeReason']>>>, ParentType, ContextType>;
  resolution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  splits?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScaleTicketBookingDisputeSplit']>>>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['ScaleTicketBookingDisputeState']>, ParentType, ContextType>;
  suggestedCarbonFarmingSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  ticketNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalLoad?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weighedInAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withdrawnAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  withdrawnBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketBookingDisputeSplitResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketBookingDisputeSplit'] = ResolversParentTypes['ScaleTicketBookingDisputeSplit']> = ResolversObject<{
  booking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bookingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netWeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ScaleTicketDataMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketDataMapping'] = ResolversParentTypes['ScaleTicketDataMapping']> = ResolversObject<{
  branchColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropMappings?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUsed?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  moistureColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  organisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sellerColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tareColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tareUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketNumberColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weighInDateColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weighInDateTimeColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weighInTimeColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weighOutDateColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weighOutDateTimeColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weighOutTimeColumn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketDuplicateNumberSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketDuplicateNumberSummary'] = ResolversParentTypes['ScaleTicketDuplicateNumberSummary']> = ResolversObject<{
  netWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  seller?: Resolver<ResolversTypes['ScaleTicketSellerRef'], ParentType, ContextType>;
  ticketNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tickets?: Resolver<Maybe<Array<ResolversTypes['ScaleTicketDuplicateTicket']>>, ParentType, ContextType>;
}>;

export type ScaleTicketDuplicateTicketResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketDuplicateTicket'] = ResolversParentTypes['ScaleTicketDuplicateTicket']> = ResolversObject<{
  netWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sampleMoisture?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  weighedInAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
}>;

export type ScaleTicketHarvestCapSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketHarvestCapSummary'] = ResolversParentTypes['ScaleTicketHarvestCapSummary']> = ResolversObject<{
  booked?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  field?: Resolver<ResolversTypes['ScaleTicketNamedRef'], ParentType, ContextType>;
  harvestCap?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  harvestChangedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  harvestSales?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  harvestUsed?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  harvested?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalTickets?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ScaleTicketHistoryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketHistory'] = ResolversParentTypes['ScaleTicketHistory']> = ResolversObject<{
  bookingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disputeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['ScaleTicketHistoryField']>, ParentType, ContextType>;
  kind?: Resolver<Maybe<ResolversTypes['ScaleTicketHistoryKind']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valueAfter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueAfterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueBefore?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueBeforeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketMissingHarvestSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketMissingHarvestSummary'] = ResolversParentTypes['ScaleTicketMissingHarvestSummary']> = ResolversObject<{
  allHarvestedFieldsFull?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  farm?: Resolver<ResolversTypes['ScaleTicketNamedRef'], ParentType, ContextType>;
  fields?: Resolver<Maybe<Array<ResolversTypes['ScaleTicketNamedRef']>>, ParentType, ContextType>;
  netWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  programs?: Resolver<Maybe<Array<ResolversTypes['SustainabilityProgramNamedRef']>>, ParentType, ContextType>;
}>;

export type ScaleTicketMissingMoistureSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketMissingMoistureSummary'] = ResolversParentTypes['ScaleTicketMissingMoistureSummary']> = ResolversObject<{
  netWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['ScaleTicketSellerRef']>, ParentType, ContextType>;
  ticketNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ScaleTicketNamedRefResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketNamedRef'] = ResolversParentTypes['ScaleTicketNamedRef']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ScaleTicketSellerMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketSellerMapping'] = ResolversParentTypes['ScaleTicketSellerMapping']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  organisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sellerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketSellerNotMatchedResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketSellerNotMatched'] = ResolversParentTypes['ScaleTicketSellerNotMatched']> = ResolversObject<{
  firstSeen?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  netWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['ScaleTicketSellerRef']>, ParentType, ContextType>;
  suggestedFarm?: Resolver<Maybe<ResolversTypes['ScaleTicketNamedRef']>, ParentType, ContextType>;
  tickets?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type ScaleTicketSellerRefResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketSellerRef'] = ResolversParentTypes['ScaleTicketSellerRef']> = ResolversObject<{
  sellerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ScaleTicketStateSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketStateSummary'] = ResolversParentTypes['ScaleTicketStateSummary']> = ResolversObject<{
  netWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netWeightAtStandardMoisture?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tickets?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ScaleTicketStatesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketStates'] = ResolversParentTypes['ScaleTicketStates']> = ResolversObject<{
  BOOKED?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
  DISPUTED?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
  DUPLICATE_TICKET_NUMBER?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
  HARVEST_CAP_REACHED?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
  MISSING_HARVEST?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
  MISSING_MOISTURE?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
  SELLER_NOT_MATCHED?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
  UNBOOKED?: Resolver<ResolversTypes['ScaleTicketStateSummary'], ParentType, ContextType>;
}>;

export type ScaleTicketSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketSummary'] = ResolversParentTypes['ScaleTicketSummary']> = ResolversObject<{
  duplicateTicketNumbers?: Resolver<Maybe<Array<ResolversTypes['ScaleTicketDuplicateNumberSummary']>>, ParentType, ContextType>;
  harvestCapExceeded?: Resolver<Maybe<Array<ResolversTypes['ScaleTicketHarvestCapSummary']>>, ParentType, ContextType>;
  missingHarvest?: Resolver<Maybe<Array<ResolversTypes['ScaleTicketMissingHarvestSummary']>>, ParentType, ContextType>;
  missingMoisture?: Resolver<Maybe<Array<ResolversTypes['ScaleTicketMissingMoistureSummary']>>, ParentType, ContextType>;
  sellerNotMatched?: Resolver<Maybe<Array<ResolversTypes['ScaleTicketSellerNotMatched']>>, ParentType, ContextType>;
  ticketStates?: Resolver<ResolversTypes['ScaleTicketStates'], ParentType, ContextType>;
  totalTickets?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUploads?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ScaleTicketUploadResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketUpload'] = ResolversParentTypes['ScaleTicketUpload']> = ResolversObject<{
  branchUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dataMappingName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dataMappingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  errorCode?: Resolver<Maybe<ResolversTypes['ScaleTicketUploadError']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['ScaleTicketUploadState']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['ScaleTicketUploadSummary']>, ParentType, ContextType>;
  ticketStates?: Resolver<Maybe<ResolversTypes['ScaleTicketUploadTicketStates']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketUploadSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketUploadSummary'] = ResolversParentTypes['ScaleTicketUploadSummary']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaleTicketUploadUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalDuplicate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalImported?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalOtherCrop?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalRows?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalVoid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScaleTicketUploadTicketStatesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScaleTicketUploadTicketStates'] = ResolversParentTypes['ScaleTicketUploadTicketStates']> = ResolversObject<{
  BOOKED?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  DISPUTED?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  DUPLICATE_TICKET_NUMBER?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  HARVEST_CAP_REACHED?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MISSING_HARVEST?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  MISSING_MOISTURE?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  SELLER_NOT_MATCHED?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  UNBOOKED?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type ScoutingGrowthStageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingGrowthStage'] = ResolversParentTypes['ScoutingGrowthStage']> = ResolversObject<{
  endIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scale?: Resolver<Maybe<ResolversTypes['ScaleV2']>, ParentType, ContextType>;
  startIndex?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ScoutingPoiResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingPoi'] = ResolversParentTypes['ScoutingPoi']> = ResolversObject<{
  algorithmType?: Resolver<Maybe<ResolversTypes['ScoutingPoiAlgorithmType']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingPoiImage']>>>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['LeafDamageResult']>, ParentType, ContextType>;
  tripName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ScoutingPoiImageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingPoiImage'] = ResolversParentTypes['ScoutingPoiImage']> = ResolversObject<{
  appVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  captureDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  imageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ScoutingPoiResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingPoiResult'] = ResolversParentTypes['ScoutingPoiResult']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DiseaseIdentificationResult' | 'EmergenceAnalysisResult' | 'LeafDamageResult' | 'MultiWeedResult' | 'NitrogenStatusResult' | 'YellowTrapResult', ParentType, ContextType>;
}>;

export type ScoutingPoiV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingPoiV2'] = ResolversParentTypes['ScoutingPoiV2']> = ResolversObject<{
  algorithmType?: Resolver<Maybe<ResolversTypes['ScoutingPoiAlgorithmType']>, ParentType, ContextType>;
  algorithmTypeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  cropEppoCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingPoiImage']>>>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ScoutingPoiResult']>, ParentType, ContextType>;
  tripName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ScoutingProtocolResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingProtocol'] = ResolversParentTypes['ScoutingProtocol']> = ResolversObject<{
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  growthStage?: Resolver<Maybe<ResolversTypes['ScoutingGrowthStage']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  stressQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingStressQuestion']>>>, ParentType, ContextType, Partial<ScoutingProtocolStressQuestionsArgs>>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ScoutingReportResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingReport'] = ResolversParentTypes['ScoutingReport']> = ResolversObject<{
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  fieldNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldNote']>>>, ParentType, ContextType>;
  isIncludeImages?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pdfPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ScoutingReportDispatchOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingReportDispatchOrder'] = ResolversParentTypes['ScoutingReportDispatchOrder']> = ResolversObject<{
  copyToSelf?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recipients?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  scoutingReport?: Resolver<Maybe<ResolversTypes['ScoutingReport']>, ParentType, ContextType>;
  shareType?: Resolver<ResolversTypes['ScoutingReportShareType'], ParentType, ContextType>;
  sharedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ScoutingReportDispatchOrderStatus'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ScoutingStressAnswerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingStressAnswer'] = ResolversParentTypes['ScoutingStressAnswer']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['Image']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ScoutingStressQuestionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingStressQuestion'] = ResolversParentTypes['ScoutingStressQuestion']> = ResolversObject<{
  answerValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  assessmentTypeAnswerDictName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentTypeAnswerDictShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentTypeAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingStressAnswer']>>>, ParentType, ContextType>;
  assessmentTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentTypeDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assessmentTypeUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  crop?: Resolver<ResolversTypes['Crop'], ParentType, ContextType>;
  dataType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expertQuestion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  expertScoutingTripQuestion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  images?: Resolver<Maybe<Array<Maybe<ResolversTypes['Image']>>>, ParentType, ContextType>;
  isPhotoRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mdUnit?: Resolver<Maybe<ResolversTypes['MdUnit']>, ParentType, ContextType>;
  regularQuestion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sampleUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  scoutingProblemCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoutingProblemName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoutingProblemUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stressV2?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType>;
}>;

export type ScoutingTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ScoutingTask'] = ResolversParentTypes['ScoutingTask']> = ResolversObject<{
  assessmentTiming?: Resolver<Maybe<ResolversTypes['AssessmentTiming']>, ParentType, ContextType>;
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  scoutingPois?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingPoi']>>>, ParentType, ContextType>;
  scoutingPoisV2?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingPoiV2']>>>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  stressQuestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingStressQuestion']>>>, ParentType, ContextType, Partial<ScoutingTaskStressQuestionsArgs>>;
  trial?: Resolver<Maybe<ResolversTypes['Trial']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeasonTimelineResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SeasonTimeline'] = ResolversParentTypes['SeasonTimeline']> = ResolversObject<{
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['SeasonTimelineFeatures']>>>, ParentType, ContextType>;
}>;

export type SeasonTimelineFeaturesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SeasonTimelineFeatures'] = ResolversParentTypes['SeasonTimelineFeatures']> = ResolversObject<{
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characteristicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endWeekOfMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  endYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startWeekOfMonth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SectionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Section'] = ResolversParentTypes['Section']> = ResolversObject<{
  abiotics?: Resolver<Maybe<ResolversTypes['SectionSummary']>, ParentType, ContextType>;
  diseases?: Resolver<Maybe<ResolversTypes['SectionSummary']>, ParentType, ContextType>;
  growthstages?: Resolver<Maybe<ResolversTypes['SectionSummary']>, ParentType, ContextType>;
  insects?: Resolver<Maybe<ResolversTypes['SectionSummary']>, ParentType, ContextType>;
  lodgings?: Resolver<Maybe<ResolversTypes['SectionSummary']>, ParentType, ContextType>;
}>;

export type SectionSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SectionSummary'] = ResolversParentTypes['SectionSummary']> = ResolversObject<{
  details?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type SeedBoxTreatmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SeedBoxTreatment'] = ResolversParentTypes['SeedBoxTreatment']> = ResolversObject<{
  applicationSpotUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProduct']>>>, ParentType, ContextType>;
  recipe?: Resolver<Maybe<Array<Maybe<ResolversTypes['Ingredient']>>>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  taskMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalLiquidLocalUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  waterLocalUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeedSelectorInputResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SeedSelectorInput'] = ResolversParentTypes['SeedSelectorInput']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relativeMaturity?: Resolver<Maybe<ResolversTypes['RelativeMaturity']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  variety?: Resolver<Maybe<ResolversTypes['Variety']>, ParentType, ContextType>;
}>;

export type SeedTreatmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SeedTreatment'] = ResolversParentTypes['SeedTreatment']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProduct']>>>, ParentType, ContextType>;
  recipe?: Resolver<Maybe<Array<Maybe<ResolversTypes['Ingredient']>>>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  taskMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  totalLiquidRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SeedTreatmentTypeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SeedTreatmentType'] = ResolversParentTypes['SeedTreatmentType']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SelectedYearResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SelectedYear'] = ResolversParentTypes['SelectedYear']> = ResolversObject<{
  included?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type SensorStatusVariableDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SensorStatusVariableDetail'] = ResolversParentTypes['SensorStatusVariableDetail']> = ResolversObject<{
  disabledHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['DisabledHistory']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wasEverDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type SharingMandateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SharingMandate'] = ResolversParentTypes['SharingMandate']> = ResolversObject<{
  accessCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SharingMandatePermission']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SharingMandatePermissionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SharingMandatePermission'] = ResolversParentTypes['SharingMandatePermission']> = ResolversObject<{
  access?: Resolver<Maybe<ResolversTypes['Access']>, ParentType, ContextType>;
  isGranteeOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  objectType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ShopDevicePackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopDevicePackage'] = ResolversParentTypes['ShopDevicePackage']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validityInDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type ShopFarmPackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopFarmPackage'] = ResolversParentTypes['ShopFarmPackage']> = ResolversObject<{
  accumulatedOrderIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validityInDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type ShopGiftCardResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopGiftCard'] = ResolversParentTypes['ShopGiftCard']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  giftCardCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ShopSubscriptionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopSubscription'] = ResolversParentTypes['ShopSubscription']> = ResolversObject<{
  addressInformation?: Resolver<Maybe<ResolversTypes['ShopSubscriptionAddressInformation']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  paymentDetails?: Resolver<Maybe<ResolversTypes['ShopSubscriptionPaymentDetails']>, ParentType, ContextType>;
  renewalDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ShopSubscriptionStatus']>, ParentType, ContextType>;
  subscriptionItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopSubscriptionItem']>>>, ParentType, ContextType>;
  subscriptionPeriods?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShopSubscriptionPeriod']>>>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ShopSubscriptionAddressInformationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopSubscriptionAddressInformation'] = ResolversParentTypes['ShopSubscriptionAddressInformation']> = ResolversObject<{
  billingAddress?: Resolver<Maybe<ResolversTypes['ShopSubscriptionBillingAddress']>, ParentType, ContextType>;
  shippingAddress?: Resolver<Maybe<ResolversTypes['ShopSubscriptionShippingAddress']>, ParentType, ContextType>;
}>;

export type ShopSubscriptionBillingAddressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopSubscriptionBillingAddress'] = ResolversParentTypes['ShopSubscriptionBillingAddress']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  telephone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type ShopSubscriptionItemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopSubscriptionItem'] = ResolversParentTypes['ShopSubscriptionItem']> = ResolversObject<{
  cancellationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['ShopSubscription']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type ShopSubscriptionPaymentDetailsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopSubscriptionPaymentDetails'] = ResolversParentTypes['ShopSubscriptionPaymentDetails']> = ResolversObject<{
  cardExpiration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerFirstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerLastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maskedDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tokenExpirationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['ShopPaymentVendor'], ParentType, ContextType>;
}>;

export type ShopSubscriptionPeriodResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopSubscriptionPeriod'] = ResolversParentTypes['ShopSubscriptionPeriod']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTrial?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['ShopSubscription']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ShopSubscriptionShippingAddressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopSubscriptionShippingAddress'] = ResolversParentTypes['ShopSubscriptionShippingAddress']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sameAsBilling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  street?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  telephone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ShopUserPackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ShopUserPackage'] = ResolversParentTypes['ShopUserPackage']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validityInDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SiteResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Site'] = ResolversParentTypes['Site']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type SmagConnectionStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmagConnectionStatus'] = ResolversParentTypes['SmagConnectionStatus']> = ResolversObject<{
  status?: Resolver<Maybe<ResolversTypes['ConnectionStatus']>, ParentType, ContextType>;
}>;

export type SmartSprayerExecutionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerExecution'] = ResolversParentTypes['SmartSprayerExecution']> = ResolversObject<{
  adeMode?: Resolver<Maybe<ResolversTypes['AdeMode']>, ParentType, ContextType>;
  adeSavings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adeSprayedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adeTotalArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  archivedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fieldAssignmentUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  isMinRateApplicationEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  machineName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mergedSmartSprayingExecution?: Resolver<Maybe<ResolversTypes['MergedSmartSprayerExecution']>, ParentType, ContextType>;
  mergedSmartSprayingExecutionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  missingInfo?: Resolver<Maybe<ResolversTypes['SmartSprayerExecutionMissingInfo']>, ParentType, ContextType>;
  offlineTask?: Resolver<Maybe<ResolversTypes['SmartSprayingOfflineTask']>, ParentType, ContextType>;
  operationMode?: Resolver<Maybe<ResolversTypes['OperationMode']>, ParentType, ContextType>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  smartSprayerRegistration?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistration']>, ParentType, ContextType>;
  smartSprayingTaskV2?: Resolver<Maybe<ResolversTypes['SmartSprayingTaskV2']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['Strategy']>, ParentType, ContextType>;
  terminalTask?: Resolver<Maybe<ResolversTypes['SmartSprayingTerminalTask']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  zoneStrategies?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExecutionZoneStrategy']>>>, ParentType, ContextType>;
}>;

export type SmartSprayerExecutionFieldInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerExecutionFieldInfo'] = ResolversParentTypes['SmartSprayerExecutionFieldInfo']> = ResolversObject<{
  bestGuess?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  possibleValues?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
}>;

export type SmartSprayerExecutionMissingInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerExecutionMissingInfo'] = ResolversParentTypes['SmartSprayerExecutionMissingInfo']> = ResolversObject<{
  fieldUuid?: Resolver<Maybe<ResolversTypes['SmartSprayerExecutionFieldInfo']>, ParentType, ContextType>;
}>;

export type SmartSprayerExecutionStatisticsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerExecutionStatistics'] = ResolversParentTypes['SmartSprayerExecutionStatistics']> = ResolversObject<{
  executionCropUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  executionFieldUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  executionStrategies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Strategy']>>>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['SmartSprayerExecutionSummary'], ParentType, ContextType>;
}>;

export type SmartSprayerExecutionSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerExecutionSummary'] = ResolversParentTypes['SmartSprayerExecutionSummary']> = ResolversObject<{
  adeSavings?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adeSprayedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  adeTotalArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type SmartSprayerLicenseResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerLicense'] = ResolversParentTypes['SmartSprayerLicense']> = ResolversObject<{
  licenseCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oem?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistrationOem']>, ParentType, ContextType>;
  smartSprayerRegistrations?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerRegistration']>>>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SmartSprayerRegistrationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerRegistration'] = ResolversParentTypes['SmartSprayerRegistration']> = ResolversObject<{
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deviceFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerDeviceFeature']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isTwoTankSupported?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  licenseStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  machineIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oem?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistrationOem']>, ParentType, ContextType>;
  registeredAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  registrationType?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistrationType']>, ParentType, ContextType>;
  smartSprayerExecutions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerExecution']>>>, ParentType, ContextType>;
  smartSprayerLicense?: Resolver<Maybe<ResolversTypes['SmartSprayerLicense']>, ParentType, ContextType>;
  smartSprayerStatus?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistrationStatus']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SmartSprayerRegistrationStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerRegistrationStatus'] = ResolversParentTypes['SmartSprayerRegistrationStatus']> = ResolversObject<{
  lastSeen?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  packages?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerStatusPackage']>>>, ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type SmartSprayerStatusPackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerStatusPackage'] = ResolversParentTypes['SmartSprayerStatusPackage']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureApplicationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureApplication'] = ResolversParentTypes['SmartSprayerWeedPressureApplication']> = ResolversObject<{
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fieldCoveragePercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  included?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  seasonKind?: Resolver<ResolversTypes['SmartSprayerWeedPressureSeasonKind'], ParentType, ContextType>;
  seasonLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureApplicationSelectionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureApplicationSelection'] = ResolversParentTypes['SmartSprayerWeedPressureApplicationSelection']> = ResolversObject<{
  applicationsAnalyzed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currentExclusionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  eligibleApplicationsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  filtered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureExclusionSetResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureExclusionSet'] = ResolversParentTypes['SmartSprayerWeedPressureExclusionSet']> = ResolversObject<{
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  exclusionRevision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  exclusions?: Resolver<Array<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureField'] = ResolversParentTypes['SmartSprayerWeedPressureField']> = ResolversObject<{
  applicationSelection?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureApplicationSelection']>, ParentType, ContextType>;
  applications?: Resolver<Maybe<Array<ResolversTypes['SmartSprayerWeedPressureApplication']>>, ParentType, ContextType>;
  averageCoveragePercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  averageDensity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  boundaryAreaHa?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  calculationState?: Resolver<ResolversTypes['SmartSprayerWeedPressureCalculationState'], ParentType, ContextType>;
  dominantWeedSize?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureWeedSize']>, ParentType, ContextType>;
  emergingZones?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fieldCoverageWarning?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fieldDataState?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureFieldDataState']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldVariability?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  highPressureAreaPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hotSpotHistory?: Resolver<Maybe<Array<ResolversTypes['SmartSprayerWeedPressureHotSpotHistoryPoint']>>, ParentType, ContextType>;
  hotSpotStabilityPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pressureTrendDirection?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureTrendDirection']>, ParentType, ContextType>;
  pressureTrendSlope?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  retryAfterSeconds?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  settingsApplied?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureSettingsApplied']>, ParentType, ContextType>;
  stacItemId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weedPressureScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureFieldListItemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureFieldListItem'] = ResolversParentTypes['SmartSprayerWeedPressureFieldListItem']> = ResolversObject<{
  applicationsAnalyzed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  averageCoveragePercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  averageDensity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  boundaryAreaHa?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  calculationState?: Resolver<ResolversTypes['SmartSprayerWeedPressureCalculationState'], ParentType, ContextType>;
  dominantWeedSize?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureWeedSize']>, ParentType, ContextType>;
  eligibleApplicationsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  emergingZones?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fieldCoverageWarning?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fieldDataState?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureFieldDataState']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldVariability?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  highPressureAreaPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hotSpotStabilityPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pressureTrendDirection?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureTrendDirection']>, ParentType, ContextType>;
  pressureTrendSlope?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weedPressureScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureHotSpotHistoryPointResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureHotSpotHistoryPoint'] = ResolversParentTypes['SmartSprayerWeedPressureHotSpotHistoryPoint']> = ResolversObject<{
  applicationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  applicationsAnalyzed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  averageCoveragePercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  averageDensity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  dominantWeedSize?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureWeedSize']>, ParentType, ContextType>;
  emergingZones?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fieldDataState?: Resolver<ResolversTypes['SmartSprayerWeedPressureFieldDataState'], ParentType, ContextType>;
  fieldVariability?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  highPressureAreaPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hotSpotStabilityPercent?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['SmartSprayerWeedPressureHistoryKind'], ParentType, ContextType>;
  pressureTrendDirection?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureTrendDirection']>, ParentType, ContextType>;
  pressureTrendSlope?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceApplicationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stacItemId?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weedPressureScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureRecalculationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureRecalculation'] = ResolversParentTypes['SmartSprayerWeedPressureRecalculation']> = ResolversObject<{
  reason?: Resolver<ResolversTypes['SmartSprayerWeedPressureRecalculationReason'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SmartSprayerWeedPressureRecalculationStatus'], ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureSettingsAppliedResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureSettingsApplied'] = ResolversParentTypes['SmartSprayerWeedPressureSettingsApplied']> = ResolversObject<{
  gridSizeM?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeWeighting?: Resolver<ResolversTypes['SmartSprayerWeedPressureTimeWeighting'], ParentType, ContextType>;
  weightingMode?: Resolver<ResolversTypes['SmartSprayerWeedPressureWeightingMode'], ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureStatisticsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureStatistics'] = ResolversParentTypes['SmartSprayerWeedPressureStatistics']> = ResolversObject<{
  calculationComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pendingFieldCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['SmartSprayerWeedPressureStatisticsSummary'], ParentType, ContextType>;
  weedPressureFieldUuids?: Resolver<Array<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type SmartSprayerWeedPressureStatisticsSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayerWeedPressureStatisticsSummary'] = ResolversParentTypes['SmartSprayerWeedPressureStatisticsSummary']> = ResolversObject<{
  summaryPressureTrendDirection?: Resolver<Maybe<ResolversTypes['SmartSprayerWeedPressureTrendDirection']>, ParentType, ContextType>;
  summaryPressureTrendSlope?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  summaryWeedPressureScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SmartSprayingOfflineTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayingOfflineTask'] = ResolversParentTypes['SmartSprayingOfflineTask']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  machineIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operationMode?: Resolver<Maybe<ResolversTypes['OperationMode']>, ParentType, ContextType>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  smartSprayingExecution?: Resolver<Maybe<ResolversTypes['SmartSprayerExecution']>, ParentType, ContextType>;
  smartSprayingTask?: Resolver<Maybe<ResolversTypes['SmartSprayingTask']>, ParentType, ContextType>;
  smartSprayingTaskV2?: Resolver<Maybe<ResolversTypes['SmartSprayingTaskV2']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['Strategy']>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SmartSprayingTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayingTask'] = ResolversParentTypes['SmartSprayingTask']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dosedMap?: Resolver<Maybe<ResolversTypes['DosedMap']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operationMode?: Resolver<Maybe<ResolversTypes['OperationMode']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  recommendationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  smartSprayingExecution?: Resolver<Maybe<ResolversTypes['SmartSprayerExecution']>, ParentType, ContextType>;
  smartSprayingTaskDevicePayloads?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayingTaskDevicePayload']>>>, ParentType, ContextType>;
  soilTextureUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['Strategy']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weedRecord?: Resolver<Maybe<ResolversTypes['WeedRecord']>, ParentType, ContextType>;
  zoneStrategies?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZoneStrategy']>>>, ParentType, ContextType>;
}>;

export type SmartSprayingTaskDevicePayloadResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayingTaskDevicePayload'] = ResolversParentTypes['SmartSprayingTaskDevicePayload']> = ResolversObject<{
  calculatedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  devicePayload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['SmartSprayingTaskDevicePayloadError']>, ParentType, ContextType>;
  smartSprayingTask?: Resolver<Maybe<ResolversTypes['SmartSprayingTask']>, ParentType, ContextType>;
  smartSprayingTaskV2?: Resolver<Maybe<ResolversTypes['SmartSprayingTaskV2']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['SmartSprayingTaskDevicePayloadStatus']>, ParentType, ContextType>;
  warning?: Resolver<Maybe<ResolversTypes['SmartSprayingTaskDevicePayloadWarning']>, ParentType, ContextType>;
}>;

export type SmartSprayingTaskDosedMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayingTaskDosedMap'] = ResolversParentTypes['SmartSprayingTaskDosedMap']> = ResolversObject<{
  dosedMap?: Resolver<Maybe<ResolversTypes['DosedMap']>, ParentType, ContextType>;
  tankNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SmartSprayingTaskV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayingTaskV2'] = ResolversParentTypes['SmartSprayingTaskV2']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  customAdjacentThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dosedMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayingTaskDosedMap']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isCropRowAngleDetectionEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMinRateApplicationEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operationMode?: Resolver<Maybe<ResolversTypes['OperationMode']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  recommendationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  smartSprayingExecution?: Resolver<Maybe<ResolversTypes['SmartSprayerExecution']>, ParentType, ContextType>;
  smartSprayingTaskDevicePayloads?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayingTaskDevicePayload']>>>, ParentType, ContextType>;
  soilTextureUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['Strategy']>, ParentType, ContextType>;
  thresholdAnswerUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weedRecord?: Resolver<Maybe<ResolversTypes['WeedRecord']>, ParentType, ContextType>;
  zoneStrategies?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZoneStrategy']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SmartSprayingTerminalStrategyMappingsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayingTerminalStrategyMappings'] = ResolversParentTypes['SmartSprayingTerminalStrategyMappings']> = ResolversObject<{
  burndown?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  smartsprayer?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
}>;

export type SmartSprayingTerminalTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SmartSprayingTerminalTask'] = ResolversParentTypes['SmartSprayingTerminalTask']> = ResolversObject<{
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  externalTaskUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  operationMode?: Resolver<Maybe<ResolversTypes['OperationMode']>, ParentType, ContextType>;
  rowWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  smartSprayerRegistration?: Resolver<Maybe<ResolversTypes['SmartSprayerRegistration']>, ParentType, ContextType>;
  smartSprayingExecution?: Resolver<Maybe<ResolversTypes['SmartSprayerExecution']>, ParentType, ContextType>;
  smartSprayingTask?: Resolver<Maybe<ResolversTypes['SmartSprayingTask']>, ParentType, ContextType>;
  smartSprayingTaskV2?: Resolver<Maybe<ResolversTypes['SmartSprayingTaskV2']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SoilErosionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilErosion'] = ResolversParentTypes['SoilErosion']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldV2?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  totalErosion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type SoilSampleResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSample'] = ResolversParentTypes['SoilSample']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  measurements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Measurement']>>>, ParentType, ContextType>;
  samplingArea?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samplingDepth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type SoilSamplingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSampling'] = ResolversParentTypes['SoilSampling']> = ResolversObject<{
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  flowHint?: Resolver<Maybe<ResolversTypes['FlowHint']>, ParentType, ContextType>;
  gridAngle?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gridCellSize?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  headlandWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  internalBuffer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numCores?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfPointsPerReferenceArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pattern?: Resolver<Maybe<ResolversTypes['SoilSamplingPattern']>, ParentType, ContextType>;
  radius?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referenceArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  samplingAreas?: Resolver<Maybe<Array<Maybe<ResolversTypes['SamplingArea']>>>, ParentType, ContextType>;
  samplingDepths?: Resolver<Maybe<Array<Maybe<ResolversTypes['SamplingDepth']>>>, ParentType, ContextType>;
  samplingIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['SamplingId']>>>, ParentType, ContextType>;
  samplingPoints?: Resolver<Maybe<Array<Maybe<ResolversTypes['SamplingPoint']>>>, ParentType, ContextType>;
  soilSamplingTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingTask']>>>, ParentType, ContextType>;
  sourceMapUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SoilSamplingType']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['SoilSamplingUnit']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SoilSamplingMeasurementResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSamplingMeasurement'] = ResolversParentTypes['SoilSamplingMeasurement']> = ResolversObject<{
  applicableStresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['ApplicableStress']>>>, ParentType, ContextType>;
  applicableUnits?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  measurement?: Resolver<ResolversTypes['SoilPropertyType'], ParentType, ContextType>;
}>;

export type SoilSamplingResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSamplingResult'] = ResolversParentTypes['SoilSamplingResult']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fileBatchUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['File']>>>, ParentType, ContextType>;
  laboratory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSample']>>>, ParentType, ContextType>;
  samplingAreas?: Resolver<Maybe<Array<Maybe<ResolversTypes['SoilSamplingResultArea']>>>, ParentType, ContextType>;
  samplingDepths?: Resolver<Maybe<Array<Maybe<ResolversTypes['SamplingDepth']>>>, ParentType, ContextType>;
  soilSampling?: Resolver<Maybe<ResolversTypes['SoilSampling']>, ParentType, ContextType>;
  sourceMap?: Resolver<Maybe<ResolversTypes['SoilSamplingResultSourceMap']>, ParentType, ContextType>;
  sourceSoilSamplingResult?: Resolver<Maybe<ResolversTypes['SoilSamplingResult']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['SoilSamplingResultStatus']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SoilSamplingResultAreaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSamplingResultArea'] = ResolversParentTypes['SoilSamplingResultArea']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type SoilSamplingResultSourceMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSamplingResultSourceMap'] = ResolversParentTypes['SoilSamplingResultSourceMap']> = ResolversObject<{
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  zonesToSamplingAreaMappings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZonesToSamplingAreaMapping']>>>, ParentType, ContextType>;
}>;

export type SoilSamplingStressAnalysisResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSamplingStressAnalysis'] = ResolversParentTypes['SoilSamplingStressAnalysis']> = ResolversObject<{
  aggregatedRiskLevel?: Resolver<Maybe<ResolversTypes['RiskLevel']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  riskMaps?: Resolver<Maybe<Array<Maybe<ResolversTypes['RiskMap']>>>, ParentType, ContextType>;
  soilSamplingResult?: Resolver<Maybe<ResolversTypes['SoilSamplingResult']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SoilSamplingTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilSamplingTask'] = ResolversParentTypes['SoilSamplingTask']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sampledPoints?: Resolver<Maybe<Array<Maybe<ResolversTypes['SampledPoint']>>>, ParentType, ContextType>;
  soilSamplingSet?: Resolver<Maybe<ResolversTypes['SoilSampling']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SoilTaxonomyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilTaxonomy'] = ResolversParentTypes['SoilTaxonomy']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SoilTextureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SoilTexture'] = ResolversParentTypes['SoilTexture']> = ResolversObject<{
  clayAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  clayMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  clayMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dict?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sandAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sandMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sandMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  siltAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  siltMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  siltMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilTaxonomyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilTaxonomyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilTaxonomyUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  soilTextureUSDACode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilTextureUSDADescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilTextureUSDAName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilTextureUSDAShortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  soilTextureUSDAUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SourceMapResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SourceMap'] = ResolversParentTypes['SourceMap']> = ResolversObject<{
  acceptableThresholds?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  boundaryOutdatedSince?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  droneCustomMapParameters?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fieldDataLayerMagnitude?: Resolver<Maybe<ResolversTypes['Magnitude']>, ParentType, ContextType, Partial<SourceMapFieldDataLayerMagnitudeArgs>>;
  fieldDataLayerMagnitudeType?: Resolver<Maybe<ResolversTypes['MagnitudeType']>, ParentType, ContextType>;
  fieldDataLayerProcessingType?: Resolver<Maybe<ResolversTypes['ProcessingType']>, ParentType, ContextType, Partial<SourceMapFieldDataLayerProcessingTypeArgs>>;
  fieldDataLayerUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  groupTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  labelTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  maxElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minElevation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendedThreshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sourceCardinality?: Resolver<Maybe<ResolversTypes['SourceCardinality']>, ParentType, ContextType>;
  sourceDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['SourceType']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stacFieldDataLayer?: Resolver<Maybe<ResolversTypes['StacFieldDataLayer']>, ParentType, ContextType>;
  stacIndex?: Resolver<Maybe<ResolversTypes['AgronomicIndexType']>, ParentType, ContextType>;
  stacMagnitude?: Resolver<Maybe<ResolversTypes['StacMagnitudeType']>, ParentType, ContextType>;
  thresholdIndex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SourceMapType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  vectorizationParameters?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  weeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['Weed']>>>, ParentType, ContextType>;
  zoneCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  zoneIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SourceMapStyleResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SourceMapStyle'] = ResolversParentTypes['SourceMapStyle']> = ResolversObject<{
  applicationType?: Resolver<Maybe<ResolversTypes['ApplicationType']>, ParentType, ContextType>;
  entries?: Resolver<Maybe<Array<ResolversTypes['SourceMapStyleEntry']>>, ParentType, ContextType>;
  sourceMapType?: Resolver<Maybe<ResolversTypes['SourceMapType']>, ParentType, ContextType>;
}>;

export type SourceMapStyleEntryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SourceMapStyleEntry'] = ResolversParentTypes['SourceMapStyleEntry']> = ResolversObject<{
  category?: Resolver<Maybe<ResolversTypes['ApplicationCategory']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zoneId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type SourceValueMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SourceValueMapping'] = ResolversParentTypes['SourceValueMapping']> = ResolversObject<{
  foreignValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SprayWeatherResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SprayWeather'] = ResolversParentTypes['SprayWeather']> = ResolversObject<{
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  factors?: Resolver<Maybe<Array<Maybe<ResolversTypes['SprayWeatherFactor']>>>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['Field']>, ParentType, ContextType>;
  fieldV2?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fromDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  modelUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SprayWeatherResult']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  toDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type SprayWeatherFactorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SprayWeatherFactor'] = ResolversParentTypes['SprayWeatherFactor']> = ResolversObject<{
  factor?: Resolver<Maybe<ResolversTypes['SprayWeatherFactorFactor']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SprayWeatherResult']>, ParentType, ContextType>;
}>;

export type SprayerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Sprayer'] = ResolversParentTypes['Sprayer']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['SprayerManufacturer']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SprayerType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SprayerManufacturerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SprayerManufacturer'] = ResolversParentTypes['SprayerManufacturer']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type SprayerTypeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SprayerType'] = ResolversParentTypes['SprayerType']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type SprayingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Spraying'] = ResolversParentTypes['Spraying']> = ResolversObject<{
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  dosedMap?: Resolver<Maybe<ResolversTypes['DosedMap']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fieldInputPackagingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldInputPackagingUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recommendationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SprayingNutrientResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SprayingNutrient'] = ResolversParentTypes['SprayingNutrient']> = ResolversObject<{
  accountableAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  accountableRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fertilizerTypeUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  nutrientUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  sprayingUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SprayingV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SprayingV2'] = ResolversParentTypes['SprayingV2']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assigneeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  availableDosedMaps?: Resolver<Maybe<Array<ResolversTypes['AvailableDosedMap']>>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dosedMap?: Resolver<Maybe<ResolversTypes['DosedMap']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  executionStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fieldInputPackagingUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldInputPackagingUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  hortaSpraying?: Resolver<Maybe<ResolversTypes['HortaSpraying']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAutoGenerated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recommendationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  residualActivation?: Resolver<Maybe<ResolversTypes['ResidualActivation']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weedRecordUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SprayingWindowResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SprayingWindow'] = ResolversParentTypes['SprayingWindow']> = ResolversObject<{
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SprayingWindowStatus'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type StacFarmStatisticsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacFarmStatistics'] = ResolversParentTypes['StacFarmStatistics']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  stacFieldDataLayerType?: Resolver<Maybe<ResolversTypes['StacFieldDataLayer']>, ParentType, ContextType>;
}>;

export type StacHistogramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacHistogram'] = ResolversParentTypes['StacHistogram']> = ResolversObject<{
  buckets?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  classBoundaries?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type StacItemRenderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacItemRender'] = ResolversParentTypes['StacItemRender']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  datetime?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  field?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  fieldDataLayerType?: Resolver<ResolversTypes['StacFieldDataLayer'], ParentType, ContextType>;
  fullUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groupTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['AgronomicIndexType']>, ParentType, ContextType>;
  labelTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  legends?: Resolver<Array<ResolversTypes['StacLegend']>, ParentType, ContextType>;
  magnitudeType?: Resolver<ResolversTypes['StacMagnitudeType'], ParentType, ContextType>;
  md2Configuration?: Resolver<Maybe<ResolversTypes['Md2VraAdvisorConfiguration']>, ParentType, ContextType>;
  selectionReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['StacItemSelectionReason']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['StacItemRenderSource']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  statistics?: Resolver<Maybe<ResolversTypes['StacStatistics']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  visUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type StacItemRenderSourceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacItemRenderSource'] = ResolversParentTypes['StacItemRenderSource']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DroneFlight', ParentType, ContextType>;
}>;

export type StacItemVectorizeGeometryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacItemVectorizeGeometry'] = ResolversParentTypes['StacItemVectorizeGeometry']> = ResolversObject<{
  acquisitionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  centerZoneId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customBreaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  geometry?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  index?: Resolver<ResolversTypes['AgronomicIndexType'], ParentType, ContextType>;
  medianZoneId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfZones?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recommendedRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['RecommendedRate']>>>, ParentType, ContextType>;
  stacItemUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  zonePercentageDifferences?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZonePercentageDifference']>>>, ParentType, ContextType>;
  zoneStatistics?: Resolver<Maybe<Array<Maybe<ResolversTypes['ZoneStatisticsItem']>>>, ParentType, ContextType>;
}>;

export type StacLegendResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacLegend'] = ResolversParentTypes['StacLegend']> = ResolversObject<{
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  translationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type StacMosaicRenderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacMosaicRender'] = ResolversParentTypes['StacMosaicRender']> = ResolversObject<{
  availableRenderingTypes?: Resolver<Array<Maybe<ResolversTypes['RenderingType']>>, ParentType, ContextType>;
  fieldDataLayerType?: Resolver<ResolversTypes['StacFieldDataLayer'], ParentType, ContextType>;
  fromDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  legends?: Resolver<Array<ResolversTypes['StacLegend']>, ParentType, ContextType>;
  magnitudeType?: Resolver<ResolversTypes['StacMagnitudeType'], ParentType, ContextType>;
  renderingType?: Resolver<ResolversTypes['RenderingType'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tillDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  unitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type StacStatisticsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StacStatistics'] = ResolversParentTypes['StacStatistics']> = ResolversObject<{
  histogram?: Resolver<Maybe<ResolversTypes['StacHistogram']>, ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mean?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  stddev?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type StatisticResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Statistic'] = ResolversParentTypes['Statistic']> = ResolversObject<{
  totalFailureLength?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalFailureRatio?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalRowLength?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type StirObjectResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StirObject'] = ResolversParentTypes['StirObject']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fmObjectType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fmObjectUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stirOperation?: Resolver<Maybe<ResolversTypes['StirOperation']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type StirOperationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StirOperation'] = ResolversParentTypes['StirOperation']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stirValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type StressResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Stress'] = ResolversParentTypes['Stress']> = ResolversObject<{
  eppocode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scientificName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taxonomyUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type StressAnswerResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StressAnswer'] = ResolversParentTypes['StressAnswer']> = ResolversObject<{
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stressQuestion?: Resolver<ResolversTypes['StressQuestion'], ParentType, ContextType, Partial<StressAnswerStressQuestionArgs>>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type StressEfficacyCharacteristicsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StressEfficacyCharacteristics'] = ResolversParentTypes['StressEfficacyCharacteristics']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  calculationMode?: Resolver<Maybe<ResolversTypes['CalculationMode']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  endDateTransplant?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['TimeFormat']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStressDeclared?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  protectionEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  protectionLevel?: Resolver<Maybe<ResolversTypes['ProtectionLevel']>, ParentType, ContextType>;
  protectionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  protectionStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  protectionType?: Resolver<Maybe<ResolversTypes['ProtectionType']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDateTransplant?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  stresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressV2']>>>, ParentType, ContextType, Partial<StressEfficacyCharacteristicsStressesArgs>>;
  taskUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taskUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
}>;

export type StressQuestionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StressQuestion'] = ResolversParentTypes['StressQuestion']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  expertQuestion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  question?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stress?: Resolver<ResolversTypes['Stress'], ParentType, ContextType, Partial<StressQuestionStressArgs>>;
  stressAnswers?: Resolver<Maybe<Array<Maybe<ResolversTypes['StressAnswer']>>>, ParentType, ContextType, Partial<StressQuestionStressAnswersArgs>>;
  stressV2?: Resolver<ResolversTypes['StressV2'], ParentType, ContextType, Partial<StressQuestionStressV2Args>>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type StressRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StressRisk'] = ResolversParentTypes['StressRisk']> = ResolversObject<{
  beforeSeasonRisk?: Resolver<Maybe<ResolversTypes['StressRiskValue']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type StressSettingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StressSetting'] = ResolversParentTypes['StressSetting']> = ResolversObject<{
  cautionLevel?: Resolver<Maybe<ResolversTypes['CautionLevel']>, ParentType, ContextType>;
  isPresent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stressUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type StressSettingsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StressSettings'] = ResolversParentTypes['StressSettings']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<Array<Maybe<ResolversTypes['StressSetting']>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type StressV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['StressV2'] = ResolversParentTypes['StressV2']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cotyledonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cotyledonName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cotyledonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  descriptionAndSymptoms?: Resolver<Maybe<Array<Maybe<ResolversTypes['DescriptionAndSymptom']>>>, ParentType, ContextType, Partial<StressV2DescriptionAndSymptomsArgs>>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentStressCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentStressName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentStressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  scientificName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressTypeCodeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  stressTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  taxonomyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxonomyCodeTranslationId?: Resolver<Maybe<ResolversTypes['TranslationId']>, ParentType, ContextType>;
  taxonomyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxonomyUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SubscriptionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  growthStagePredictionCalculated?: SubscriptionResolver<ResolversTypes['GrowthStagePredictionCalculatedPayload'], "growthStagePredictionCalculated", ParentType, ContextType, RequireFields<SubscriptionGrowthStagePredictionCalculatedArgs, 'cropSeasonUuids'>>;
}>;

export type SubscriptionPreferenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SubscriptionPreference'] = ResolversParentTypes['SubscriptionPreference']> = ResolversObject<{
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farms?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubscriptionPreferenceFarm']>>>, ParentType, ContextType>;
  globalCategories?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubscriptionPreferenceCategory']>>>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type SubscriptionPreferenceFarmResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SubscriptionPreferenceFarm'] = ResolversParentTypes['SubscriptionPreferenceFarm']> = ResolversObject<{
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubscriptionPreferenceCategory']>>>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type SubstanceApplicationRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SubstanceApplicationRate'] = ResolversParentTypes['SubstanceApplicationRate']> = ResolversObject<{
  averageApplicationRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dilutionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  formulation?: Resolver<Maybe<ResolversTypes['Formulation']>, ParentType, ContextType>;
  liquid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratesByZone?: Resolver<Maybe<Array<Maybe<ResolversTypes['RateByZone']>>>, ParentType, ContextType>;
  ratesPerZone?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  totalApplication?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SubstanceType']>, ParentType, ContextType>;
  typeIconName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['RateUnit']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  volumeBasisLocalUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  volumeBasisRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type SubstanceRateV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SubstanceRateV2'] = ResolversParentTypes['SubstanceRateV2']> = ResolversObject<{
  dilutionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  substanceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SubstanceType']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['RateUnit']>, ParentType, ContextType>;
  volumeBasisLocalUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  volumeBasisRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type SupportedTaskTypeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SupportedTaskType'] = ResolversParentTypes['SupportedTaskType']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['TaskTypeCode']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type SustainabilityIndicatorResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityIndicator'] = ResolversParentTypes['SustainabilityIndicator']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  co2EquivalentFootprint?: Resolver<Maybe<ResolversTypes['Footprint']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nitrogenFootprint?: Resolver<Maybe<ResolversTypes['Footprint']>, ParentType, ContextType>;
  waterFootprint?: Resolver<Maybe<ResolversTypes['Footprint']>, ParentType, ContextType>;
}>;

export type SustainabilityInputResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityInput'] = ResolversParentTypes['SustainabilityInput']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fuelConsumptionPerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  harvestPriceMain?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  harvestPriceOther?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hasCoverCrops?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasFlowerStrips?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasGrassBufferStrips?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasOrganicFertilizers?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasReducedCropInputs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasReducedTillage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasStrawBeenRemoved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasStubblesLeft?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasUncultivatedMargins?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasUndersownCereals?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasUndrilledMargins?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasUndrilledPatches?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasUnsprayedHeadlands?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  irrigationEnergySource?: Resolver<Maybe<ResolversTypes['IrrigationEnergySource']>, ParentType, ContextType>;
  irrigationEnergySourceTranslationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isBiofuelUsageAboveCutoff?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDrainageSystemUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isNitrificationInhibitorUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUreaseInhibitorUsed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mineralNitrogenPerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organicFertilizersTotalNitrogenPerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organicFertilizersTotalPhosphorPerArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilPH?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SustainabilityOrganisationCapabilityResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityOrganisationCapability'] = ResolversParentTypes['SustainabilityOrganisationCapability']> = ResolversObject<{
  adjudicator?: Resolver<Maybe<ResolversTypes['SustainabilityAdjudicator']>, ParentType, ContextType>;
  approvedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  approvedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  capability?: Resolver<Maybe<ResolversTypes['SustainabilityOrganisationCapabilityType']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declinedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  declinedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declinedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastModifiedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  organisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SustainabilityProgramResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityProgram'] = ResolversParentTypes['SustainabilityProgram']> = ResolversObject<{
  allocationOrder?: Resolver<Maybe<ResolversTypes['SustainabilityProgramAllocationOrder']>, ParentType, ContextType>;
  annualDataEntryClosesAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicableFirstInterventionYears?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  certificationScheme?: Resolver<Maybe<ResolversTypes['SustainabilityProgramCertificationScheme']>, ParentType, ContextType>;
  ciLimit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  claimTarget45z?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  claimTargetLcfs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crops?: Resolver<Maybe<Array<Maybe<ResolversTypes['Crop']>>>, ParentType, ContextType>;
  deliveryWindowEnd?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deliveryWindowStart?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentationDueDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  endYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  enrolmentEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  enrolmentStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  escalationContact?: Resolver<Maybe<ResolversTypes['EscalationContact']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  joinCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  measureSubmissionOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['MeasureSubmissionOrder']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  premiumBands?: Resolver<Maybe<Array<Maybe<ResolversTypes['PremiumBand']>>>, ParentType, ContextType>;
  protocol?: Resolver<Maybe<ResolversTypes['SustainabilityProgramProtocol']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  startYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['SustainabilityProgramStatus']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['SustainabilityProgramStrategy']>, ParentType, ContextType>;
  supplyChainPartnerUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  targetWeightedCi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['SustainabilityProgramType']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  visibilityMode?: Resolver<Maybe<ResolversTypes['SustainabilityProgramVisibilityMode']>, ParentType, ContextType>;
  volumeCap?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  volumeTarget?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SustainabilityProgramBranchAssignmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityProgramBranchAssignment'] = ResolversParentTypes['SustainabilityProgramBranchAssignment']> = ResolversObject<{
  branchAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  branchName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isFPA?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPlant?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  organisationBranch?: Resolver<Maybe<ResolversTypes['OrganisationBranch']>, ParentType, ContextType>;
  organisationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sustainabilityProgram?: Resolver<Maybe<ResolversTypes['SustainabilityProgram']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SustainabilityProgramEnrolledFieldResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityProgramEnrolledField'] = ResolversParentTypes['SustainabilityProgramEnrolledField']> = ResolversObject<{
  carbonFarmingSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  farmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SustainabilityProgramInvitationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityProgramInvitation'] = ResolversParentTypes['SustainabilityProgramInvitation']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviteeEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  joinedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sustainabilityProgram?: Resolver<Maybe<ResolversTypes['SustainabilityProgram']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SustainabilityProgramNamedRefResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityProgramNamedRef'] = ResolversParentTypes['SustainabilityProgramNamedRef']> = ResolversObject<{
  claimTarget45z?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  claimTargetLcfs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organisationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type SustainabilityProgramOrganisationParticipationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityProgramOrganisationParticipation'] = ResolversParentTypes['SustainabilityProgramOrganisationParticipation']> = ResolversObject<{
  approvedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  approvedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  branchName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  branchUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  capability?: Resolver<Maybe<ResolversTypes['SustainabilityOrganisationCapabilityType']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  declinedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  declinedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organisationAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  organisationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  partnerOrganisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  programOrganisationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['SustainabilityProgramOrganisationParticipationStatus']>, ParentType, ContextType>;
  sustainabilityProgramUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  withdrawnAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  withdrawnBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SustainabilityProgramStaffMemberResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['SustainabilityProgramStaffMember'] = ResolversParentTypes['SustainabilityProgramStaffMember']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['SustainabilityProgramStaffMemberRole'], ParentType, ContextType>;
  sustainabilityProgram?: Resolver<Maybe<ResolversTypes['SustainabilityProgram']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TDiskAssignmentResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TDiskAssignment'] = ResolversParentTypes['TDiskAssignment']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tDiskOperation?: Resolver<Maybe<ResolversTypes['TDiskOperation']>, ParentType, ContextType>;
  taskType?: Resolver<ResolversTypes['TDiskTaskType'], ParentType, ContextType>;
  taskUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TDiskOperationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TDiskOperation'] = ResolversParentTypes['TDiskOperation']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TargetWeedResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TargetWeed'] = ResolversParentTypes['TargetWeed']> = ResolversObject<{
  resistanceUuids?: Resolver<Maybe<Array<Maybe<ResolversTypes['UUID']>>>, ParentType, ContextType>;
  resistances?: Resolver<Maybe<Array<Maybe<ResolversTypes['TargetWeedResistance']>>>, ParentType, ContextType>;
  taxonomicRank?: Resolver<Maybe<ResolversTypes['TaxonomicRank']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['TargetWeedWeight']>, ParentType, ContextType>;
}>;

export type TaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Task'] = ResolversParentTypes['Task']> = ResolversObject<{
  type?: Resolver<Maybe<ResolversTypes['TaskAggregationType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TaskAggregationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TaskAggregation'] = ResolversParentTypes['TaskAggregation']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['Task']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TaskMethodResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TaskMethod'] = ResolversParentTypes['TaskMethod']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taskTypeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type TaskSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TaskSummary'] = ResolversParentTypes['TaskSummary']> = ResolversObject<{
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaskSummaryDetail']>>>, ParentType, ContextType>;
}>;

export type TaskSummaryDetailResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TaskSummaryDetail'] = ResolversParentTypes['TaskSummaryDetail']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creationFlowHint?: Resolver<Maybe<ResolversTypes['CreationFlowHint']>, ParentType, ContextType>;
  cropUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  generalTaskStatus?: Resolver<Maybe<ResolversTypes['GeneralTaskStatus']>, ParentType, ContextType>;
  taskType?: Resolver<Maybe<ResolversTypes['GeneralTaskType']>, ParentType, ContextType>;
}>;

export type TenantResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Tenant'] = ResolversParentTypes['Tenant']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TillageSystemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TillageSystem'] = ResolversParentTypes['TillageSystem']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TillagesResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Tillages'] = ResolversParentTypes['Tillages']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTillageDepth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultTillageDepthSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultTillageDepthSiUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTillageDepthSiUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTillageDepthSiUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  defaultTillageDepthUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTillageDepthUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTillageDepthUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxTillageDepth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxTillageDepthSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  maxTillageDepthSiUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxTillageDepthSiUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxTillageDepthSiUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  maxTillageDepthUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxTillageDepthUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maxTillageDepthUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  minTillageDepth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minTillageDepthSi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minTillageDepthSiUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minTillageDepthSiUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minTillageDepthSiUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  minTillageDepthUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minTillageDepthUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minTillageDepthUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TimingCalculationStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingCalculationStatus'] = ResolversParentTypes['TimingCalculationStatus']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['CalculationStatusCode']>, ParentType, ContextType>;
}>;

export type TimingLimitationV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingLimitationV2'] = ResolversParentTypes['TimingLimitationV2']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVraUnrestricted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  limitationReasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['LimitationReason']>>>, ParentType, ContextType>;
  productCategoryType?: Resolver<Maybe<ResolversTypes['ProductCategoryType']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type TimingProductRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingProductRecommendation'] = ResolversParentTypes['TimingProductRecommendation']> = ResolversObject<{
  basfChoiceRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  characteristics?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationCharacteristic']>>>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  efficacyRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  efficacyScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pricePerformanceRatioRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  protectionPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipe?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationRecipe']>>>, ParentType, ContextType>;
  recommendationEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sortValueRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  stressEfficacy?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationStressEfficacy']>>>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  sustainabilityRank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TimingProductRecommendationType']>, ParentType, ContextType>;
  vraCapability?: Resolver<Maybe<ResolversTypes['TimingProductRecommendationVraCapability']>, ParentType, ContextType>;
}>;

export type TimingProductRecommendationGroupDoseRateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingProductRecommendationGroupDoseRate'] = ResolversParentTypes['TimingProductRecommendationGroupDoseRate']> = ResolversObject<{
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  doseRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recommendationReferenceDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type TimingProductRecommendationGroupRecipeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingProductRecommendationGroupRecipe'] = ResolversParentTypes['TimingProductRecommendationGroupRecipe']> = ResolversObject<{
  doseRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationGroupDoseRate']>>>, ParentType, ContextType>;
  productV2?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
}>;

export type TimingProductRecommendationRecipeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingProductRecommendationRecipe'] = ResolversParentTypes['TimingProductRecommendationRecipe']> = ResolversObject<{
  doseRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  productV2?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
}>;

export type TimingProductRecommendationStressEfficacyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingProductRecommendationStressEfficacy'] = ResolversParentTypes['TimingProductRecommendationStressEfficacy']> = ResolversObject<{
  efficacyScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stressV2?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<TimingProductRecommendationStressEfficacyStressV2Args>>;
}>;

export type TimingProductRecommendationsGroupResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingProductRecommendationsGroup'] = ResolversParentTypes['TimingProductRecommendationsGroup']> = ResolversObject<{
  characteristics?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationCharacteristic']>>>, ParentType, ContextType>;
  cropSeasons?: Resolver<Maybe<Array<Maybe<ResolversTypes['CropSeasonV2']>>>, ParentType, ContextType>;
  recipe?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimingProductRecommendationGroupRecipe']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TimingProductRecommendationsGroupType']>, ParentType, ContextType>;
  vraCapability?: Resolver<Maybe<ResolversTypes['TimingProductRecommendationVraCapability']>, ParentType, ContextType>;
}>;

export type TimingStressInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TimingStressInfo'] = ResolversParentTypes['TimingStressInfo']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  isEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  stress?: Resolver<Maybe<ResolversTypes['Stress']>, ParentType, ContextType>;
  stressV2?: Resolver<Maybe<ResolversTypes['StressV2']>, ParentType, ContextType, Partial<TimingStressInfoStressV2Args>>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type ToppingTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ToppingTask'] = ResolversParentTypes['ToppingTask']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TotalNutrientsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TotalNutrients'] = ResolversParentTypes['TotalNutrients']> = ResolversObject<{
  accountableAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  accountableRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fertilizerTypeUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  nutrientUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  targetAmountDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetContributionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetContributionRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetRateDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TotalNutrientsDeltaResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TotalNutrientsDelta'] = ResolversParentTypes['TotalNutrientsDelta']> = ResolversObject<{
  nutrientUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  targetAmountDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetRateDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type TotalProductsResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TotalProducts'] = ResolversParentTypes['TotalProducts']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductV2']>, ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  targetAmountDelta?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  targetRateDelta?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type TramlineResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Tramline'] = ResolversParentTypes['Tramline']> = ResolversObject<{
  abLine?: Resolver<Maybe<ResolversTypes['AbLine']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldV2?: Resolver<ResolversTypes['FieldV2'], ParentType, ContextType>;
  geometry?: Resolver<ResolversTypes['JSONObject'], ParentType, ContextType>;
  headlandWidth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  workingWidth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export interface TranslationIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TranslationId'], any> {
  name: 'TranslationId';
}

export type TreatmentProductResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TreatmentProduct'] = ResolversParentTypes['TreatmentProduct']> = ResolversObject<{
  applicationRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dilutionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['TreatmentProductUnit']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TreatmentProgramActionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TreatmentProgramAction'] = ResolversParentTypes['TreatmentProgramAction']> = ResolversObject<{
  additionalNoticeKeys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['ActionCode']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  labelKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendedApplicationTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProgramApplicationType']>>>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['ActionDate']>, ParentType, ContextType>;
  tankMixes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ActionDetailTankMix']>>>, ParentType, ContextType>;
  tillageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionDetailType']>, ParentType, ContextType>;
}>;

export type TreatmentProgramActionWindowResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TreatmentProgramActionWindow'] = ResolversParentTypes['TreatmentProgramActionWindow']> = ResolversObject<{
  action?: Resolver<Maybe<ResolversTypes['Action']>, ParentType, ContextType>;
  actionV3?: Resolver<Maybe<ResolversTypes['TreatmentProgramAction']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['ActionCode']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  executionStatus?: Resolver<Maybe<ResolversTypes['ActionWindowExecutionStatus']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  tasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['TreatmentProgramActionWindowTask']>>>, ParentType, ContextType>;
}>;

export type TreatmentProgramActionWindowTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TreatmentProgramActionWindowTask'] = ResolversParentTypes['TreatmentProgramActionWindowTask']> = ResolversObject<{
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ActionDetailType']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type TreatmentReasonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TreatmentReason'] = ResolversParentTypes['TreatmentReason']> = ResolversObject<{
  reasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  stressUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TreatmentScenarioResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TreatmentScenario'] = ResolversParentTypes['TreatmentScenario']> = ResolversObject<{
  actions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Action']>>>, ParentType, ContextType>;
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  equipmentType?: Resolver<Maybe<ResolversTypes['TreatmentEquipmentType']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  isDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nameTranslationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  season?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TrialResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Trial'] = ResolversParentTypes['Trial']> = ResolversObject<{
  assessmentTimings?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssessmentTiming']>>>, ParentType, ContextType>;
  assessments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Assessment']>>>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  disabledReplicates?: Resolver<Maybe<Array<Maybe<ResolversTypes['TrialDisabledReplicate']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factorLevelFieldZoneMappings?: Resolver<Array<ResolversTypes['FactorLevelFieldZoneMapping']>, ParentType, ContextType>;
  factorLevels?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  factorUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, ParentType, ContextType>;
  fieldZonesWithoutOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lockedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  maxPlotArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minPlotArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  plotLength?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  plotWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  protocol?: Resolver<Maybe<ResolversTypes['Protocol']>, ParentType, ContextType>;
  replicates?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scoutingTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingTask']>>>, ParentType, ContextType>;
  trialNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type TrialDisabledReplicateResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TrialDisabledReplicate'] = ResolversParentTypes['TrialDisabledReplicate']> = ResolversObject<{
  factorLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  replicate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type TrialV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['TrialV2'] = ResolversParentTypes['TrialV2']> = ResolversObject<{
  assessmentTimings?: Resolver<Maybe<Array<Maybe<ResolversTypes['AssessmentTiming']>>>, ParentType, ContextType>;
  assessments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Assessment']>>>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  disabledReplicates?: Resolver<Maybe<Array<Maybe<ResolversTypes['TrialDisabledReplicate']>>>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factorLevelFieldZoneMappings?: Resolver<Array<ResolversTypes['FactorLevelFieldZoneMapping']>, ParentType, ContextType>;
  factorLevels?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  factorUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  farmName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, ParentType, ContextType>;
  fieldZonesWithoutOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldZone']>>>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lockedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  maxPlotArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minPlotArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  plotLength?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  plotWidth?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  protocol?: Resolver<Maybe<ResolversTypes['Protocol']>, ParentType, ContextType>;
  protocolId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  protocolName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replicates?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scoutingTasks?: Resolver<Maybe<Array<Maybe<ResolversTypes['ScoutingTask']>>>, ParentType, ContextType>;
  scoutingTasksCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  trialNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UploadDatasetSummaryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UploadDatasetSummary'] = ResolversParentTypes['UploadDatasetSummary']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UploadDatasetStatus'], ParentType, ContextType>;
}>;

export type UploadDatasetTotalResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UploadDatasetTotal'] = ResolversParentTypes['UploadDatasetTotal']> = ResolversObject<{
  actualCulturalPractice?: Resolver<Maybe<ResolversTypes['ActualCulturalPractice']>, ParentType, ContextType>;
  deviceElementDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['UploadDatasetTotalSourceType']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type UserResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hfMachineries?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfMachinery']>>>, ParentType, ContextType>;
  hfOffers?: Resolver<Maybe<Array<Maybe<ResolversTypes['HfOffer']>>>, ParentType, ContextType>;
  initials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviteCodeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isEmailVerificationNeeded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEmailVerified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sharingMandates?: Resolver<Maybe<Array<Maybe<ResolversTypes['SharingMandate']>>>, ParentType, ContextType>;
  smartSprayerRegistrations?: Resolver<Maybe<Array<Maybe<ResolversTypes['SmartSprayerRegistration']>>>, ParentType, ContextType>;
  tenantUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  userFarmPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserFarmPackage']>>>, ParentType, ContextType>;
  userFeatures?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserFeature']>>>, ParentType, ContextType>;
  userPackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserPackage']>>>, ParentType, ContextType, Partial<UserUserPackagesArgs>>;
  uuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type UserDataVsValidationComparisonResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserDataVsValidationComparison'] = ResolversParentTypes['UserDataVsValidationComparison']> = ResolversObject<{
  coverCropMatch?: Resolver<Maybe<ResolversTypes['Comparison']>, ParentType, ContextType>;
  coverCropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  cropMatch?: Resolver<Maybe<ResolversTypes['Comparison']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  detectedPractices?: Resolver<Maybe<ResolversTypes['MonitorPractice']>, ParentType, ContextType>;
  fieldUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  fmCarbonRelatedData?: Resolver<Maybe<ResolversTypes['FmCarbonRelatedData']>, ParentType, ContextType>;
  monitorResultAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  regrowCropName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tillages?: Resolver<Maybe<Array<Maybe<ResolversTypes['MonitorTillage']>>>, ParentType, ContextType>;
}>;

export type UserDeviceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserDevice'] = ResolversParentTypes['UserDevice']> = ResolversObject<{
  device?: Resolver<Maybe<ResolversTypes['OneSoilDevice']>, ParentType, ContextType>;
  devicePackages?: Resolver<Maybe<Array<Maybe<ResolversTypes['DevicePackage']>>>, ParentType, ContextType, Partial<UserDeviceDevicePackagesArgs>>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  features?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeviceFeature']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type UserFarmPackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserFarmPackage'] = ResolversParentTypes['UserFarmPackage']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userPackageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type UserFeatureResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserFeature'] = ResolversParentTypes['UserFeature']> = ResolversObject<{
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['FeatureName']>, ParentType, ContextType>;
  needsActivation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  packageType?: Resolver<Maybe<ResolversTypes['PackageType']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type UserGroupResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserGroup'] = ResolversParentTypes['UserGroup']> = ResolversObject<{
  group?: Resolver<ResolversTypes['Group'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
}>;

export type UserLicenseRequestResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserLicenseRequest'] = ResolversParentTypes['UserLicenseRequest']> = ResolversObject<{
  approvedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  license?: Resolver<ResolversTypes['License'], ParentType, ContextType>;
  organisation?: Resolver<Maybe<ResolversTypes['Organisation']>, ParentType, ContextType>;
  organisationMemberUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LicenseRequestStatusType'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  validFrom?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type UserNotificationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserNotification'] = ResolversParentTypes['UserNotification']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  isRead?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  objectUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  payloadData?: Resolver<Maybe<ResolversTypes['PayloadData']>, ParentType, ContextType>;
  scheduledDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['NotificationType']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type UserPackageResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserPackage'] = ResolversParentTypes['UserPackage']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmAssignable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityType?: Resolver<Maybe<ResolversTypes['FarmPackageQuantityType']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PackageType']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  validTill?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type UserSettingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['UserSetting'] = ResolversParentTypes['UserSetting']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ValueCodeResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ValueCode'] = ResolversParentTypes['ValueCode']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sortOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type VarietyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Variety'] = ResolversParentTypes['Variety']> = ResolversObject<{
  breeder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  breederReferenceNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  breederUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  crop?: Resolver<Maybe<ResolversTypes['Crop']>, ParentType, ContextType, Partial<VarietyCropArgs>>;
  dictCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dictCodeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  farm?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  isCustom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationApplicationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationCountry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationCountryUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  registrationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationStatusUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type VarietyCharacteristicResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VarietyCharacteristic'] = ResolversParentTypes['VarietyCharacteristic']> = ResolversObject<{
  altitudeMax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  altitudeMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  characteristicId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characteristicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isIrrigated?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  scaleCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaleUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  seasonCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  sowingDateMax?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sowingDateMin?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  stressCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stressUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valueCodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValueCode']>>>, ParentType, ContextType>;
  valueOrig?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  valueUnitCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valueUnitSiUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  valueUnitUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  varietyCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  varietyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  varietyUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type VarietyRankingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VarietyRanking'] = ResolversParentTypes['VarietyRanking']> = ResolversObject<{
  rank?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recommendedFlatRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recommendedRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  variety?: Resolver<Maybe<ResolversTypes['Variety']>, ParentType, ContextType>;
  vpi?: Resolver<Maybe<ResolversTypes['VarietyRatingVpi']>, ParentType, ContextType>;
}>;

export type VarietyRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VarietyRecommendation'] = ResolversParentTypes['VarietyRecommendation']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['ErrorCode']>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['FieldV2']>, ParentType, ContextType>;
  fieldVpiClassification?: Resolver<Maybe<ResolversTypes['FieldVpiClassification']>, ParentType, ContextType>;
  percentageHighVpi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percentageLowVpi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percentageMidVpi?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['VarietyRecommendationStatus']>, ParentType, ContextType>;
  varietyRankings?: Resolver<Maybe<Array<Maybe<ResolversTypes['VarietyRanking']>>>, ParentType, ContextType>;
}>;

export type VendorDeviceBlacklistEntryResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VendorDeviceBlacklistEntry'] = ResolversParentTypes['VendorDeviceBlacklistEntry']> = ResolversObject<{
  device?: Resolver<Maybe<ResolversTypes['DtnVendorDevice']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  intersectingOngoingCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  variables?: Resolver<Maybe<Array<Maybe<ResolversTypes['BlacklistVariableInfo']>>>, ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['DtnVendor'], ParentType, ContextType>;
  wasAnySensorDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type VendorDeviceDataAnomalyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VendorDeviceDataAnomaly'] = ResolversParentTypes['VendorDeviceDataAnomaly']> = ResolversObject<{
  anomalyTimestepCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['DtnVendorDevice']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  timeFormat?: Resolver<Maybe<ResolversTypes['WeatherFormat']>, ParentType, ContextType>;
  variables?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnomalyVariableInfo']>>>, ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['DtnVendor'], ParentType, ContextType>;
  wasEverAnomaly?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type VendorDeviceDataMissingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VendorDeviceDataMissing'] = ResolversParentTypes['VendorDeviceDataMissing']> = ResolversObject<{
  device?: Resolver<Maybe<ResolversTypes['DtnVendorDevice']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isReportingNow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  missingCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notReportingHistory?: Resolver<Maybe<Array<Maybe<ResolversTypes['Date']>>>, ParentType, ContextType>;
  timeFormat?: Resolver<Maybe<ResolversTypes['WeatherFormat']>, ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['DtnVendor'], ParentType, ContextType>;
  wasEverNotReporting?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type VendorDeviceInfoResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VendorDeviceInfo'] = ResolversParentTypes['VendorDeviceInfo']> = ResolversObject<{
  variables?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['DtnVendor']>, ParentType, ContextType>;
  vendorDevice?: Resolver<Maybe<ResolversTypes['DtnVendorDevice']>, ParentType, ContextType>;
  vendorDeviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type VendorDeviceSensorStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VendorDeviceSensorStatus'] = ResolversParentTypes['VendorDeviceSensorStatus']> = ResolversObject<{
  device?: Resolver<Maybe<ResolversTypes['DtnVendorDevice']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  intersectingOngoingCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  variables?: Resolver<Maybe<Array<Maybe<ResolversTypes['SensorStatusVariableDetail']>>>, ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['DtnVendor'], ParentType, ContextType>;
  wasAnySensorDisabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
}>;

export type VendorDeviceStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['VendorDeviceStatus'] = ResolversParentTypes['VendorDeviceStatus']> = ResolversObject<{
  device?: Resolver<Maybe<ResolversTypes['DtnVendorDevice']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vendor?: Resolver<ResolversTypes['DtnVendor'], ParentType, ContextType>;
}>;

export type WaterBalanceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WaterBalance'] = ResolversParentTypes['WaterBalance']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  plantAvailableWaterCapacity0_100cm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  transpirationReductionFactor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type WaterManagementScenarioResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WaterManagementScenario'] = ResolversParentTypes['WaterManagementScenario']> = ResolversObject<{
  cropEstablishmentMethod?: Resolver<Maybe<ResolversTypes['EstablishmentMethod']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['WaterManagementAction']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type WaterManagementTaskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WaterManagementTask'] = ResolversParentTypes['WaterManagementTask']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['Collaborator']>, ParentType, ContextType>;
  assignmentState?: Resolver<Maybe<ResolversTypes['TaskAssignmentState']>, ParentType, ContextType>;
  autoExecutedOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  executionStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fieldCoveragePercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  irrigationSystemUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  isAutoExecutable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plannedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  processedArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['TaskExecutionState']>, ParentType, ContextType>;
  taskMethodUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['WaterManagementTaskType']>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  waterHeight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  waterHeightDifference?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WaterRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WaterRecommendation'] = ResolversParentTypes['WaterRecommendation']> = ResolversObject<{
  actionType?: Resolver<Maybe<ResolversTypes['WaterManagementActionType']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  confidenceLevel?: Resolver<Maybe<ResolversTypes['ConfidenceLevel']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['WaterRecommendationStatus']>, ParentType, ContextType>;
}>;

export type WaterStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WaterStatus'] = ResolversParentTypes['WaterStatus']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['WaterStatusState']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WaterStatusType'], ParentType, ContextType>;
}>;

export type WeatherResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Weather'] = ResolversParentTypes['Weather']> = ResolversObject<{
  airTempCAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airTempCMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  airTempCMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorCodeAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorCodeMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorCodeMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorIconAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorIconMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorIconMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorIdAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorIdMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorIdMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorTextAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorTextMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorTextMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorUrlAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorUrlMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverDescriptorUrlMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverPctAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverPctMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cloudCoverPctMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  correctedPrecipitationMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deltaTCAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDatetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  globalRadiationKjM2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalRadiationKjM2Avg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalRadiationKjM2Max?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalRadiationKjM2Min?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  globalRadiationKjM2Stddev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leafWetnessDurationH?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationAdjustedMm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationBestMm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationDescriptorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationDescriptorIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationDescriptorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationDescriptorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationDescriptorUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationDurationH?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationMm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationMmAcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  precipitationProbabilityPct?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relativeHumidityPctAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relativeHumidityPctMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relativeHumidityPctMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDatetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sunshineDurationH?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuidForeign?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  uuidLocation?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  weatherDescriptorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weatherDescriptorIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weatherDescriptorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weatherDescriptorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weatherDescriptorUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDeg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDegPlus180?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDescriptorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDescriptorIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDescriptorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDescriptorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDescriptorUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windSpeedMSAvg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windSpeedMSMax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windSpeedMSMin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type WeatherUserDataResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeatherUserData'] = ResolversParentTypes['WeatherUserData']> = ResolversObject<{
  correctedPrecipitationMm?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDatetime?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationType?: Resolver<ResolversTypes['LocationType'], ParentType, ContextType>;
  locationUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  startDatetime?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type WeatherV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeatherV2'] = ResolversParentTypes['WeatherV2']> = ResolversObject<{
  airTemp5cmCAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  airTemp5cmCMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  airTempCAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  airTempCMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  airTempCMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  airTempCStddev?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  belowDeviceTempCAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cloudCoverPctAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  correctedPrecipitationMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  datetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deltaTCAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dewPointCAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dewPointCMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dewPointCMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  endDatetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  globalRadiationKjM2?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  globalRadiationKjM2Avg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  globalRadiationKjM2Max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  globalRadiationKjM2Min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  globalRadiationKjM2Stddev?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  leafWetnessBool?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  leafWetnessDurationH?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  liquidMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  locationUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  longWaveRadiationWM2Avg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  petMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  precipitationBestMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  precipitationDurationH?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  precipitationHourlyMaxMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  precipitationMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  precipitationMmAcc?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  precipitationProbabilityPct?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relativeHumidityDurationOver80pctH?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relativeHumidityDurationOver90pctH?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relativeHumidityPctAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relativeHumidityPctMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relativeHumidityPctMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shortWaveRadiationWM2Avg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  snowMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilMoisture0to10cmAbsScaled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilMoisture0to10cmAbsScaledPaw?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilTemp0to10cmC?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  soilTemp0to10cmCMin?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDatetime?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  sunshineDurationH?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  visibilityKmAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  waterBalanceMm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  weatherDescriptorImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDeg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  windDirectionDegPlus180?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  windDirectionDescriptorCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  windDirectionDescriptorIcon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windDirectionDescriptorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  windSpeed2mMSAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  windSpeedMSAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  windSpeedMSMax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type WeedResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['Weed'] = ResolversParentTypes['Weed']> = ResolversObject<{
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type WeedManagementProgramRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeedManagementProgramRecommendation'] = ResolversParentTypes['WeedManagementProgramRecommendation']> = ResolversObject<{
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type WeedManagementProgramRecommendationV3Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeedManagementProgramRecommendationV3'] = ResolversParentTypes['WeedManagementProgramRecommendationV3']> = ResolversObject<{
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type WeedManagementRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeedManagementRecommendation'] = ResolversParentTypes['WeedManagementRecommendation']> = ResolversObject<{
  actionType?: Resolver<Maybe<ResolversTypes['WeedManagementRecommendationType']>, ParentType, ContextType>;
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  confidenceLevel?: Resolver<Maybe<ResolversTypes['ConfidenceLevel']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeason'], ParentType, ContextType>;
  cropSeasonTreatmentProgramActionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonTreatmentProgramV3Index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['WeedManagementRecommendationStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['WeedManagementRecommendationType']>, ParentType, ContextType>;
}>;

export type WeedRecordResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeedRecord'] = ResolversParentTypes['WeedRecord']> = ResolversObject<{
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  etag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  farmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  fieldUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  retracted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  targetWeeds?: Resolver<Maybe<Array<Maybe<ResolversTypes['TargetWeed']>>>, ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
}>;

export type WeedRiskResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeedRisk'] = ResolversParentTypes['WeedRisk']> = ResolversObject<{
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeason']>, ParentType, ContextType>;
  cropSeasonV2?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['WeedRiskStatus']>, ParentType, ContextType>;
}>;

export type WeedStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeedStatus'] = ResolversParentTypes['WeedStatus']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<ResolversTypes['CropSeasonV2'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['WeedStatusStatus']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['WeedStatusType']>, ParentType, ContextType>;
}>;

export type WeeklySeedingRecommendationResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WeeklySeedingRecommendation'] = ResolversParentTypes['WeeklySeedingRecommendation']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeasonUuid?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isLocked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seedingDensity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  seedingRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
}>;

export type WfsParametersResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WfsParameters'] = ResolversParentTypes['WfsParameters']> = ResolversObject<{
  cql_filter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outputFormat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  typeNames?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewParams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type WiuzConnectionStatusResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WiuzConnectionStatus'] = ResolversParentTypes['WiuzConnectionStatus']> = ResolversObject<{
  accessTokenExpiry?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  needsUpgrade?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ConnectionStatus']>, ParentType, ContextType>;
}>;

export type WiuzUserFarmResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WiuzUserFarm'] = ResolversParentTypes['WiuzUserFarm']> = ResolversObject<{
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  lastImportedOnDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  legalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userFamilyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userGivenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type WiuzUserfarmImportOrderResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WiuzUserfarmImportOrder'] = ResolversParentTypes['WiuzUserfarmImportOrder']> = ResolversObject<{
  createdDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  creatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedImportNumberOfCropSeasons?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  failedImportNumberOfFields?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  farmV2?: Resolver<Maybe<ResolversTypes['FarmV2']>, ParentType, ContextType>;
  importedNumberOfFields?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastModifierId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noBoundaryNumberOfFields?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['WiuzImportOrderStatus']>, ParentType, ContextType>;
  totalNumberOfFields?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unsupportedCropNumberOfFields?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  uuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  wiuzUserfarmUuid?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
}>;

export type WmsParametersResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['WmsParameters'] = ResolversParentTypes['WmsParameters']> = ResolversObject<{
  cql_filter?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  elevation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  env?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  style?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  styles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewparams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type YellowTrapResultResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['YellowTrapResult'] = ResolversParentTypes['YellowTrapResult']> = ResolversObject<{
  detectedPests?: Resolver<Maybe<Array<Maybe<ResolversTypes['DetectedPest']>>>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ScoutingPoiResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type YieldPredictionResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['YieldPrediction'] = ResolversParentTypes['YieldPrediction']> = ResolversObject<{
  calculationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  cropSeason?: Resolver<Maybe<ResolversTypes['CropSeasonV2']>, ParentType, ContextType>;
  eTag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isStale?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  predictions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Prediction']>>>, ParentType, ContextType>;
}>;

export type YieldScenarioResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['YieldScenario'] = ResolversParentTypes['YieldScenario']> = ResolversObject<{
  weatherType?: Resolver<Maybe<ResolversTypes['YieldScenarioWeatherType']>, ParentType, ContextType>;
  yield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type ZonePercentageDifferenceResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ZonePercentageDifference'] = ResolversParentTypes['ZonePercentageDifference']> = ResolversObject<{
  applicationStrategy?: Resolver<ResolversTypes['ApplicationStrategy'], ParentType, ContextType>;
  rateFactor?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  zoneId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ZoneRateV2Resolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ZoneRateV2'] = ResolversParentTypes['ZoneRateV2']> = ResolversObject<{
  substanceRates?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubstanceRateV2']>>>, ParentType, ContextType>;
  zoneId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type ZoneStatisticsItemResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ZoneStatisticsItem'] = ResolversParentTypes['ZoneStatisticsItem']> = ResolversObject<{
  area?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  zoneId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
}>;

export type ZoneStrategyResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ZoneStrategy'] = ResolversParentTypes['ZoneStrategy']> = ResolversObject<{
  checksum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customAdjacentThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customThreshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  geometry?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  strategy?: Resolver<Maybe<ResolversTypes['ZoneSpecificStrategy']>, ParentType, ContextType>;
}>;

export type ZonesToSamplingAreaMappingResolvers<ContextType = GraphqlContext, ParentType extends ResolversParentTypes['ZonesToSamplingAreaMapping'] = ResolversParentTypes['ZonesToSamplingAreaMapping']> = ResolversObject<{
  samplingAreaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zoneArea?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  zoneId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type Resolvers<ContextType = GraphqlContext> = ResolversObject<{
  AbLine?: AbLineResolvers<ContextType>;
  Action?: ActionResolvers<ContextType>;
  ActionDate?: ActionDateResolvers<ContextType>;
  ActionDetail?: ActionDetailResolvers<ContextType>;
  ActionDetailAdditive?: ActionDetailAdditiveResolvers<ContextType>;
  ActionDetailProduct?: ActionDetailProductResolvers<ContextType>;
  ActionDetailTankMix?: ActionDetailTankMixResolvers<ContextType>;
  ActionDetailV2?: ActionDetailV2Resolvers<ContextType>;
  ActionRecommendation?: ActionRecommendationResolvers<ContextType>;
  ActionRecommendationAggregation?: ActionRecommendationAggregationResolvers<ContextType>;
  ActionRecommendationAggregationAction?: ActionRecommendationAggregationActionResolvers<ContextType>;
  ActionWindow?: ActionWindowResolvers<ContextType>;
  ActiveIngredient?: ActiveIngredientResolvers<ContextType>;
  AdditionalInfectionRiskFactor?: AdditionalInfectionRiskFactorResolvers<ContextType>;
  AdditiveRate?: AdditiveRateResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  AgBalanceFieldEmissionIndicator?: AgBalanceFieldEmissionIndicatorResolvers<ContextType>;
  AgBalanceFieldEmissionIndicatorIssue?: AgBalanceFieldEmissionIndicatorIssueResolvers<ContextType>;
  AgBalanceFieldInput?: AgBalanceFieldInputResolvers<ContextType>;
  AggregatedNotification?: AggregatedNotificationResolvers<ContextType>;
  AggregatedNotificationPayload?: AggregatedNotificationPayloadResolvers<ContextType>;
  AggregatedPestDevelopmentPrediction?: AggregatedPestDevelopmentPredictionResolvers<ContextType>;
  AggregatedRisk?: AggregatedRiskResolvers<ContextType>;
  AnalyticsCollection?: AnalyticsCollectionResolvers<ContextType>;
  AnalyticsCollectionFieldDataLayer?: AnalyticsCollectionFieldDataLayerResolvers<ContextType>;
  AnalyticsCollectionMapItemMagnitude?: AnalyticsCollectionMapItemMagnitudeResolvers<ContextType>;
  AnalyticsCollectionStacItem?: AnalyticsCollectionStacItemResolvers<ContextType>;
  AnomalyHistory?: AnomalyHistoryResolvers<ContextType>;
  AnomalyVariableInfo?: AnomalyVariableInfoResolvers<ContextType>;
  AppConfig?: AppConfigResolvers<ContextType>;
  AppConfigValue?: GraphQLScalarType;
  ApplicableColumn?: ApplicableColumnResolvers<ContextType>;
  ApplicableStress?: ApplicableStressResolvers<ContextType>;
  ApplicableUnit?: ApplicableUnitResolvers<ContextType>;
  ApplicationFieldZone?: ApplicationFieldZoneResolvers<ContextType>;
  ApplicationMapZone?: ApplicationMapZoneResolvers<ContextType>;
  ApplicationRecommendation?: ApplicationRecommendationResolvers<ContextType>;
  ApplicationSpot?: ApplicationSpotResolvers<ContextType>;
  ApplicationWindow?: ApplicationWindowResolvers<ContextType>;
  ApplicationZone?: ApplicationZoneResolvers<ContextType>;
  ArableApiKey?: ArableApiKeyResolvers<ContextType>;
  ArableDevice?: ArableDeviceResolvers<ContextType>;
  ArableDeviceLatestMeasurement?: ArableDeviceLatestMeasurementResolvers<ContextType>;
  ArableDeviceToLocation?: ArableDeviceToLocationResolvers<ContextType>;
  ArvalisCalculationBasis?: ArvalisCalculationBasisResolvers<ContextType>;
  ArvalisCustomEfficacyInformation?: ArvalisCustomEfficacyInformationResolvers<ContextType>;
  ArvalisDeviceToCropSeason?: ArvalisDeviceToCropSeasonResolvers<ContextType>;
  ArvalisInformation?: ArvalisInformationResolvers<ContextType>;
  Assessment?: AssessmentResolvers<ContextType>;
  AssessmentAttachment?: AssessmentAttachmentResolvers<ContextType>;
  AssessmentData?: AssessmentDataResolvers<ContextType>;
  AssessmentNote?: AssessmentNoteResolvers<ContextType>;
  AssessmentTiming?: AssessmentTimingResolvers<ContextType>;
  AvailableDosedMap?: AvailableDosedMapResolvers<ContextType>;
  AvailablePackage?: AvailablePackageResolvers<ContextType>;
  BBCHScale?: BbchScaleResolvers<ContextType>;
  BagCount?: BagCountResolvers<ContextType>;
  BaseEntityAuditingType?: BaseEntityAuditingTypeResolvers<ContextType>;
  BeforeSeasonRisk?: BeforeSeasonRiskResolvers<ContextType>;
  BillingAddress?: BillingAddressResolvers<ContextType>;
  BiodiversityIndicator?: BiodiversityIndicatorResolvers<ContextType>;
  BiomassAnalysisNdvi?: BiomassAnalysisNdviResolvers<ContextType>;
  BlacklistVariableInfo?: BlacklistVariableInfoResolvers<ContextType>;
  BufferZones?: BufferZonesResolvers<ContextType>;
  BusinessLineLicense?: BusinessLineLicenseResolvers<ContextType>;
  BusinessLineLicensePackageQuota?: BusinessLineLicensePackageQuotaResolvers<ContextType>;
  BusinessLinePurchaseAggregation?: BusinessLinePurchaseAggregationResolvers<ContextType>;
  CarbonCredit?: CarbonCreditResolvers<ContextType>;
  CarbonFarmingRequest?: CarbonFarmingRequestResolvers<ContextType>;
  CarbonFarmingSeason?: CarbonFarmingSeasonResolvers<ContextType>;
  CarbonIntensityIndicator?: CarbonIntensityIndicatorResolvers<ContextType>;
  CarbonIntensityIndicatorIssue?: CarbonIntensityIndicatorIssueResolvers<ContextType>;
  CarbonPlausibilityComment?: CarbonPlausibilityCommentResolvers<ContextType>;
  CarbonRelatedDataTillage?: CarbonRelatedDataTillageResolvers<ContextType>;
  Category?: CategoryResolvers<ContextType>;
  ClaasConnectStatus?: ClaasConnectStatusResolvers<ContextType>;
  ClaasFarm?: ClaasFarmResolvers<ContextType>;
  ClaasField?: ClaasFieldResolvers<ContextType>;
  ClaasOrganization?: ClaasOrganizationResolvers<ContextType>;
  ClaimAttachment?: ClaimAttachmentResolvers<ContextType>;
  ClaimCategory?: ClaimCategoryResolvers<ContextType>;
  ClaimEvaluation?: ClaimEvaluationResolvers<ContextType>;
  CnhCompany?: CnhCompanyResolvers<ContextType>;
  CnhFarm?: CnhFarmResolvers<ContextType>;
  CnhField?: CnhFieldResolvers<ContextType>;
  CnhGrower?: CnhGrowerResolvers<ContextType>;
  CnhTask?: CnhTaskResolvers<ContextType>;
  Collaborator?: CollaboratorResolvers<ContextType>;
  Color?: GraphQLScalarType;
  ColorCx?: GraphQLScalarType;
  ConnectivitySource?: ConnectivitySourceResolvers<ContextType>;
  ContactInformation?: ContactInformationResolvers<ContextType>;
  Container?: ContainerResolvers<ContextType>;
  CountryCropGrowthStagePrediction?: CountryCropGrowthStagePredictionResolvers<ContextType>;
  CountryCropStressSetting?: CountryCropStressSettingResolvers<ContextType>;
  CountryWeed?: CountryWeedResolvers<ContextType>;
  CreditEligibility?: CreditEligibilityResolvers<ContextType>;
  CriticalCropStageRisk?: CriticalCropStageRiskResolvers<ContextType>;
  CriticalCropStageRiskInfo?: CriticalCropStageRiskInfoResolvers<ContextType>;
  CriticalGrowthStagePeriodRisk?: CriticalGrowthStagePeriodRiskResolvers<ContextType>;
  Crop?: CropResolvers<ContextType>;
  CropDictCode?: CropDictCodeResolvers<ContextType>;
  CropEstablishment?: CropEstablishmentResolvers<ContextType>;
  CropEstablishmentDetails?: CropEstablishmentDetailsResolvers<ContextType>;
  CropGrowthStage?: CropGrowthStageResolvers<ContextType>;
  CropGrowthStageImage?: CropGrowthStageImageResolvers<ContextType>;
  CropGrowthStageV2?: CropGrowthStageV2Resolvers<ContextType>;
  CropMix?: CropMixResolvers<ContextType>;
  CropMixDetail?: CropMixDetailResolvers<ContextType>;
  CropNutritionReportConfiguration?: CropNutritionReportConfigurationResolvers<ContextType>;
  CropNutritionReportCoverConfiguration?: CropNutritionReportCoverConfigurationResolvers<ContextType>;
  CropNutritionReportFarmSummaryConfiguration?: CropNutritionReportFarmSummaryConfigurationResolvers<ContextType>;
  CropNutritionReportFieldDetailsConfiguration?: CropNutritionReportFieldDetailsConfigurationResolvers<ContextType>;
  CropResidueManagementTask?: CropResidueManagementTaskResolvers<ContextType>;
  CropSeason?: CropSeasonResolvers<ContextType>;
  CropSeasonData?: CropSeasonDataResolvers<ContextType>;
  CropSeasonNutritionProgram?: CropSeasonNutritionProgramResolvers<ContextType>;
  CropSeasonNutritionProgramExecutionStatus?: CropSeasonNutritionProgramExecutionStatusResolvers<ContextType>;
  CropSeasonNutritionRecommendation?: CropSeasonNutritionRecommendationResolvers<ContextType>;
  CropSeasonStatus?: CropSeasonStatusResolvers<ContextType>;
  CropSeasonStatusReportEmailSubscription?: CropSeasonStatusReportEmailSubscriptionResolvers<ContextType>;
  CropSeasonTreatmentProgram?: CropSeasonTreatmentProgramResolvers<ContextType>;
  CropSeasonTreatmentProgramExecutionStatus?: CropSeasonTreatmentProgramExecutionStatusResolvers<ContextType>;
  CropSeasonTreatmentProgramV2?: CropSeasonTreatmentProgramV2Resolvers<ContextType>;
  CropSeasonTreatmentProgramV3?: CropSeasonTreatmentProgramV3Resolvers<ContextType>;
  CropSeasonV2?: CropSeasonV2Resolvers<ContextType>;
  CropSeasonWaterManagementProgram?: CropSeasonWaterManagementProgramResolvers<ContextType>;
  CropSystemRecommendation?: CropSystemRecommendationResolvers<ContextType>;
  CropSystemRecommendationActionDetail?: CropSystemRecommendationActionDetailResolvers<ContextType>;
  CropSystemRecommendationRequest?: CropSystemRecommendationRequestResolvers<ContextType>;
  CropSystemRecommendationV2?: CropSystemRecommendationV2Resolvers<ContextType>;
  CropTankMixSummary?: CropTankMixSummaryResolvers<ContextType>;
  CropUsage?: CropUsageResolvers<ContextType>;
  CropWaterAvailability?: CropWaterAvailabilityResolvers<ContextType>;
  CurrentWeedPrediction?: CurrentWeedPredictionResolvers<ContextType>;
  CustomPowerzoneOrder?: CustomPowerzoneOrderResolvers<ContextType>;
  CustomPowerzoneTimeWindow?: CustomPowerzoneTimeWindowResolvers<ContextType>;
  DailyFungusDetails?: DailyFungusDetailsResolvers<ContextType>;
  DailyStressCharacteristics?: DailyStressCharacteristicsResolvers<ContextType>;
  DailyStressEventProbability?: DailyStressEventProbabilityResolvers<ContextType>;
  DailyWeedRiskDetails?: DailyWeedRiskDetailsResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DemandEquationProduct?: DemandEquationProductResolvers<ContextType>;
  DemandEquationRecommendation?: DemandEquationRecommendationResolvers<ContextType>;
  DemandEquationRecommendationV2?: DemandEquationRecommendationV2Resolvers<ContextType>;
  DemandEquationSamplingArea?: DemandEquationSamplingAreaResolvers<ContextType>;
  DemandEquationSamplingAreaProduct?: DemandEquationSamplingAreaProductResolvers<ContextType>;
  DemandEquationZone?: DemandEquationZoneResolvers<ContextType>;
  DescriptionAndSymptom?: DescriptionAndSymptomResolvers<ContextType>;
  DetectedDisease?: DetectedDiseaseResolvers<ContextType>;
  DetectedNitrogenStatus?: DetectedNitrogenStatusResolvers<ContextType>;
  DetectedPest?: DetectedPestResolvers<ContextType>;
  DetectedWeed?: DetectedWeedResolvers<ContextType>;
  DeviceFeature?: DeviceFeatureResolvers<ContextType>;
  DevicePackage?: DevicePackageResolvers<ContextType>;
  DictcodeFeature?: DictcodeFeatureResolvers<ContextType>;
  DictcodeHierarchy?: DictcodeHierarchyResolvers<ContextType>;
  Dictionary?: DictionaryResolvers<ContextType>;
  DisabledHistory?: DisabledHistoryResolvers<ContextType>;
  DiseaseIdentificationResult?: DiseaseIdentificationResultResolvers<ContextType>;
  DosedMap?: DosedMapResolvers<ContextType>;
  DosedMapLegend?: DosedMapLegendResolvers<ContextType>;
  DosedMapLegendEntry?: DosedMapLegendEntryResolvers<ContextType>;
  DosedMapProductSummary?: DosedMapProductSummaryResolvers<ContextType>;
  DroneFlight?: DroneFlightResolvers<ContextType>;
  DroneFlightError?: DroneFlightErrorResolvers<ContextType>;
  DroneFlightOrthomosaic?: DroneFlightOrthomosaicResolvers<ContextType>;
  DroneFlightQuota?: DroneFlightQuotaResolvers<ContextType>;
  DroneFlightQuotaTransfer?: DroneFlightQuotaTransferResolvers<ContextType>;
  DroneFlightSummary?: DroneFlightSummaryResolvers<ContextType>;
  DronePlantingFailureMap?: DronePlantingFailureMapResolvers<ContextType>;
  DroneSprayerWeedMap?: DroneSprayerWeedMapResolvers<ContextType>;
  DryMatterAnalysis?: DryMatterAnalysisResolvers<ContextType>;
  DtnVendorDevice?: DtnVendorDeviceResolvers<ContextType>;
  DtnVendorDeviceActivation?: DtnVendorDeviceActivationResolvers<ContextType>;
  DtnVendorDeviceLatestMeasurement?: DtnVendorDeviceLatestMeasurementResolvers<ContextType>;
  DtnVendorDeviceToLocation?: DtnVendorDeviceToLocationResolvers<ContextType>;
  DtnVendorDeviceToLocationV2?: DtnVendorDeviceToLocationV2Resolvers<ContextType>;
  DtnVendorKey?: DtnVendorKeyResolvers<ContextType>;
  DtnVendorKeyDevice?: DtnVendorKeyDeviceResolvers<ContextType>;
  EmergenceAnalysisImageResult?: EmergenceAnalysisImageResultResolvers<ContextType>;
  EmergenceAnalysisResult?: EmergenceAnalysisResultResolvers<ContextType>;
  EntityHistory?: EntityHistoryResolvers<ContextType>;
  EntityModification?: EntityModificationResolvers<ContextType>;
  EscalationContact?: EscalationContactResolvers<ContextType>;
  EvidenceFile?: EvidenceFileResolvers<ContextType>;
  EvidenceFiles?: EvidenceFilesResolvers<ContextType>;
  EvidenceReceipt?: EvidenceReceiptResolvers<ContextType>;
  ExatrekApplicationMapDispatchOrder?: ExatrekApplicationMapDispatchOrderResolvers<ContextType>;
  ExatrekDeviceState?: ExatrekDeviceStateResolvers<ContextType>;
  ExatrekDeviceStatePosition?: ExatrekDeviceStatePositionResolvers<ContextType>;
  ExatrekUserDevice?: ExatrekUserDeviceResolvers<ContextType>;
  ExatrekUserMachine?: ExatrekUserMachineResolvers<ContextType>;
  ExecutionZoneStrategy?: ExecutionZoneStrategyResolvers<ContextType>;
  ExistingOrder?: ExistingOrderResolvers<ContextType>;
  ExportOrder?: ExportOrderResolvers<ContextType>;
  FDLSourceUnion?: FdlSourceUnionResolvers<ContextType>;
  FactorLevelFieldZoneMapping?: FactorLevelFieldZoneMappingResolvers<ContextType>;
  FailureMap?: FailureMapResolvers<ContextType>;
  Farm?: FarmResolvers<ContextType>;
  FarmCarbonIntensityIndicator?: FarmCarbonIntensityIndicatorResolvers<ContextType>;
  FarmCountryCropGrowthStagePredictions?: FarmCountryCropGrowthStagePredictionsResolvers<ContextType>;
  FarmCropMetrics?: FarmCropMetricsResolvers<ContextType>;
  FarmDataLayer?: FarmDataLayerResolvers<ContextType>;
  FarmDataLayerLegend?: FarmDataLayerLegendResolvers<ContextType>;
  FarmEvidence?: FarmEvidenceResolvers<ContextType>;
  FarmEvidenceAcceptedTerm?: FarmEvidenceAcceptedTermResolvers<ContextType>;
  FarmEvidenceAcceptedTerms?: FarmEvidenceAcceptedTermsResolvers<ContextType>;
  FarmEvidenceAgExpertStatement?: FarmEvidenceAgExpertStatementResolvers<ContextType>;
  FarmEvidenceAgExpertStatements?: FarmEvidenceAgExpertStatementsResolvers<ContextType>;
  FarmEvidenceAudit?: FarmEvidenceAuditResolvers<ContextType>;
  FarmEvidenceAudits?: FarmEvidenceAuditsResolvers<ContextType>;
  FarmEvidenceAverageCiScore?: FarmEvidenceAverageCiScoreResolvers<ContextType>;
  FarmEvidenceCertification?: FarmEvidenceCertificationResolvers<ContextType>;
  FarmEvidenceCertifications?: FarmEvidenceCertificationsResolvers<ContextType>;
  FarmEvidenceCropScore?: FarmEvidenceCropScoreResolvers<ContextType>;
  FarmEvidenceFieldBuckets?: FarmEvidenceFieldBucketsResolvers<ContextType>;
  FarmEvidenceFieldCount?: FarmEvidenceFieldCountResolvers<ContextType>;
  FarmEvidenceLink?: FarmEvidenceLinkResolvers<ContextType>;
  FarmEvidenceLinks?: FarmEvidenceLinksResolvers<ContextType>;
  FarmEvidenceManureSource?: FarmEvidenceManureSourceResolvers<ContextType>;
  FarmEvidenceManureSources?: FarmEvidenceManureSourcesResolvers<ContextType>;
  FarmEvidenceProgram?: FarmEvidenceProgramResolvers<ContextType>;
  FarmEvidenceRecords?: FarmEvidenceRecordsResolvers<ContextType>;
  FarmFeature?: FarmFeatureResolvers<ContextType>;
  FarmFeatures?: FarmFeaturesResolvers<ContextType>;
  FarmFeaturesSummary?: FarmFeaturesSummaryResolvers<ContextType>;
  FarmGreetCarbonIntensityScore?: FarmGreetCarbonIntensityScoreResolvers<ContextType>;
  FarmLayerSummaryCount?: FarmLayerSummaryCountResolvers<ContextType>;
  FarmPackage?: FarmPackageResolvers<ContextType>;
  FarmPackageConsumption?: FarmPackageConsumptionResolvers<ContextType>;
  FarmReceipt?: FarmReceiptResolvers<ContextType>;
  FarmReceiptReference?: FarmReceiptReferenceResolvers<ContextType>;
  FarmUuid?: FarmUuidResolvers<ContextType>;
  FarmV2?: FarmV2Resolvers<ContextType>;
  Field?: FieldResolvers<ContextType>;
  FieldActivation?: FieldActivationResolvers<ContextType>;
  FieldBoundaryLookupScore?: FieldBoundaryLookupScoreResolvers<ContextType>;
  FieldDataDataMapping?: FieldDataDataMappingResolvers<ContextType>;
  FieldDataLayer?: FieldDataLayerResolvers<ContextType>;
  FieldDataLayerClassification?: FieldDataLayerClassificationResolvers<ContextType>;
  FieldDataLayerClassificationEntry?: FieldDataLayerClassificationEntryResolvers<ContextType>;
  FieldDataLayerLegend?: FieldDataLayerLegendResolvers<ContextType>;
  FieldDataLayerSourceProperty?: FieldDataLayerSourcePropertyResolvers<ContextType>;
  FieldDataLayerStatistics?: FieldDataLayerStatisticsResolvers<ContextType>;
  FieldDataUploadDataset?: FieldDataUploadDatasetResolvers<ContextType>;
  FieldDataUploadDatasetMissingInfo?: FieldDataUploadDatasetMissingInfoResolvers<ContextType>;
  FieldDataUploadDatasetMissingInfoCropSeason?: FieldDataUploadDatasetMissingInfoCropSeasonResolvers<ContextType>;
  FieldDataUploadDatasetMissingInfoField?: FieldDataUploadDatasetMissingInfoFieldResolvers<ContextType>;
  FieldEntry?: FieldEntryResolvers<ContextType>;
  FieldEvidence?: FieldEvidenceResolvers<ContextType>;
  FieldEvidenceAph?: FieldEvidenceAphResolvers<ContextType>;
  FieldEvidenceCiScore?: FieldEvidenceCiScoreResolvers<ContextType>;
  FieldEvidenceCoverCrop?: FieldEvidenceCoverCropResolvers<ContextType>;
  FieldEvidenceCoverCropSeason?: FieldEvidenceCoverCropSeasonResolvers<ContextType>;
  FieldEvidenceCropSeason?: FieldEvidenceCropSeasonResolvers<ContextType>;
  FieldEvidenceExpectedYieldProof?: FieldEvidenceExpectedYieldProofResolvers<ContextType>;
  FieldEvidenceField?: FieldEvidenceFieldResolvers<ContextType>;
  FieldEvidenceHarvest?: FieldEvidenceHarvestResolvers<ContextType>;
  FieldEvidenceHarvestTask?: FieldEvidenceHarvestTaskResolvers<ContextType>;
  FieldEvidenceLandLease?: FieldEvidenceLandLeaseResolvers<ContextType>;
  FieldEvidenceLandLeases?: FieldEvidenceLandLeasesResolvers<ContextType>;
  FieldEvidenceLandUse?: FieldEvidenceLandUseResolvers<ContextType>;
  FieldEvidenceLandUses?: FieldEvidenceLandUsesResolvers<ContextType>;
  FieldEvidenceLandownerRelease?: FieldEvidenceLandownerReleaseResolvers<ContextType>;
  FieldEvidenceLandownerReleases?: FieldEvidenceLandownerReleasesResolvers<ContextType>;
  FieldEvidenceLink?: FieldEvidenceLinkResolvers<ContextType>;
  FieldEvidenceLinks?: FieldEvidenceLinksResolvers<ContextType>;
  FieldEvidenceManureTest?: FieldEvidenceManureTestResolvers<ContextType>;
  FieldEvidenceManureTests?: FieldEvidenceManureTestsResolvers<ContextType>;
  FieldEvidenceNutrition?: FieldEvidenceNutritionResolvers<ContextType>;
  FieldEvidenceNutritionPlan?: FieldEvidenceNutritionPlanResolvers<ContextType>;
  FieldEvidenceNutritionTask?: FieldEvidenceNutritionTaskResolvers<ContextType>;
  FieldEvidenceProgram?: FieldEvidenceProgramResolvers<ContextType>;
  FieldEvidenceRecords?: FieldEvidenceRecordsResolvers<ContextType>;
  FieldEvidenceSale?: FieldEvidenceSaleResolvers<ContextType>;
  FieldEvidenceSampleResults?: FieldEvidenceSampleResultsResolvers<ContextType>;
  FieldEvidenceSeeding?: FieldEvidenceSeedingResolvers<ContextType>;
  FieldEvidenceSeedingTask?: FieldEvidenceSeedingTaskResolvers<ContextType>;
  FieldEvidenceSoilTest?: FieldEvidenceSoilTestResolvers<ContextType>;
  FieldEvidenceSoilTests?: FieldEvidenceSoilTestsResolvers<ContextType>;
  FieldEvidenceTDisc?: FieldEvidenceTDiscResolvers<ContextType>;
  FieldEvidenceTillage?: FieldEvidenceTillageResolvers<ContextType>;
  FieldEvidenceTillageTask?: FieldEvidenceTillageTaskResolvers<ContextType>;
  FieldEvidenceYieldSales?: FieldEvidenceYieldSalesResolvers<ContextType>;
  FieldFeature?: FieldFeatureResolvers<ContextType>;
  FieldIdentifierScore?: FieldIdentifierScoreResolvers<ContextType>;
  FieldInputPackaging?: FieldInputPackagingResolvers<ContextType>;
  FieldNote?: FieldNoteResolvers<ContextType>;
  FieldNoteAggregation?: FieldNoteAggregationResolvers<ContextType>;
  FieldNoteAnswer?: FieldNoteAnswerResolvers<ContextType>;
  FieldNoteAssessmentAggregation?: FieldNoteAssessmentAggregationResolvers<ContextType>;
  FieldNoteAttachment?: FieldNoteAttachmentResolvers<ContextType>;
  FieldNoteAudioAttachment?: FieldNoteAudioAttachmentResolvers<ContextType>;
  FieldNoteCropAggregation?: FieldNoteCropAggregationResolvers<ContextType>;
  FieldNoteImage?: FieldNoteImageResolvers<ContextType>;
  FieldNoteObservation?: FieldNoteObservationResolvers<ContextType>;
  FieldNoteStressAggregation?: FieldNoteStressAggregationResolvers<ContextType>;
  FieldPointLookup?: FieldPointLookupResolvers<ContextType>;
  FieldSummary?: FieldSummaryResolvers<ContextType>;
  FieldV2?: FieldV2Resolvers<ContextType>;
  FieldVariabilityInSeason?: FieldVariabilityInSeasonResolvers<ContextType>;
  FieldVariabilityInSeasonIndex?: FieldVariabilityInSeasonIndexResolvers<ContextType>;
  FieldVariabilityIndex?: FieldVariabilityIndexResolvers<ContextType>;
  FieldVariabilityInput?: FieldVariabilityInputResolvers<ContextType>;
  FieldVariabilityTimeSeries?: FieldVariabilityTimeSeriesResolvers<ContextType>;
  FieldVariabilityTimeSeriesIndex?: FieldVariabilityTimeSeriesIndexResolvers<ContextType>;
  FieldZone?: FieldZoneResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  FmCarbonRelatedData?: FmCarbonRelatedDataResolvers<ContextType>;
  Footprint?: FootprintResolvers<ContextType>;
  ForeignCatchCrop?: ForeignCatchCropResolvers<ContextType>;
  ForeignCrop?: ForeignCropResolvers<ContextType>;
  ForeignPreCrop?: ForeignPreCropResolvers<ContextType>;
  FreshBiomassOrder?: FreshBiomassOrderResolvers<ContextType>;
  FrostRisk?: FrostRiskResolvers<ContextType>;
  FulfilledIntervention?: FulfilledInterventionResolvers<ContextType>;
  GeneralTask?: GeneralTaskResolvers<ContextType>;
  GeneralTasksUnion?: GeneralTasksUnionResolvers<ContextType>;
  GeoMapDetail?: GeoMapDetailResolvers<ContextType>;
  Greenhouse?: GreenhouseResolvers<ContextType>;
  GreenhouseWhiteningTask?: GreenhouseWhiteningTaskResolvers<ContextType>;
  GreetApplication?: GreetApplicationResolvers<ContextType>;
  GreetCarbonIntensityScore?: GreetCarbonIntensityScoreResolvers<ContextType>;
  GreetCropProtection?: GreetCropProtectionResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  GrowthStage?: GrowthStageResolvers<ContextType>;
  GrowthStagePredictionCalculatedPayload?: GrowthStagePredictionCalculatedPayloadResolvers<ContextType>;
  GrowthStagePredictionDaily?: GrowthStagePredictionDailyResolvers<ContextType>;
  HFContractorEquipment?: HfContractorEquipmentResolvers<ContextType>;
  HFContractorRequest?: HfContractorRequestResolvers<ContextType>;
  HFServiceRequest?: HfServiceRequestResolvers<ContextType>;
  Harvest?: HarvestResolvers<ContextType>;
  HfAddress?: HfAddressResolvers<ContextType>;
  HfAgRegion?: HfAgRegionResolvers<ContextType>;
  HfAlert?: HfAlertResolvers<ContextType>;
  HfClaim?: HfClaimResolvers<ContextType>;
  HfDiscount?: HfDiscountResolvers<ContextType>;
  HfDistributor?: HfDistributorResolvers<ContextType>;
  HfFarm?: HfFarmResolvers<ContextType>;
  HfInvoice?: HfInvoiceResolvers<ContextType>;
  HfMachinery?: HfMachineryResolvers<ContextType>;
  HfOffer?: HfOfferResolvers<ContextType>;
  HfOfferCondition?: HfOfferConditionResolvers<ContextType>;
  HfOperationalInstruction?: HfOperationalInstructionResolvers<ContextType>;
  HfPreOrder?: HfPreOrderResolvers<ContextType>;
  HfPrice?: HfPriceResolvers<ContextType>;
  HfRate?: HfRateResolvers<ContextType>;
  HfReferenceCode?: HfReferenceCodeResolvers<ContextType>;
  HfReferenceCodeCategoryRate?: HfReferenceCodeCategoryRateResolvers<ContextType>;
  HfReferenceCodeMargin?: HfReferenceCodeMarginResolvers<ContextType>;
  HfReferenceCodePublic?: HfReferenceCodePublicResolvers<ContextType>;
  HfReferenceCodeRate?: HfReferenceCodeRateResolvers<ContextType>;
  HfRequestFarmPackageAddOn?: HfRequestFarmPackageAddOnResolvers<ContextType>;
  HfRiskClass?: HfRiskClassResolvers<ContextType>;
  HfSeason?: HfSeasonResolvers<ContextType>;
  HfWeatherData?: HfWeatherDataResolvers<ContextType>;
  HortaCropSeason?: HortaCropSeasonResolvers<ContextType>;
  HortaSpraying?: HortaSprayingResolvers<ContextType>;
  HortaStress?: HortaStressResolvers<ContextType>;
  HortaSustainabilityIndicator?: HortaSustainabilityIndicatorResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  ImportOrder?: ImportOrderResolvers<ContextType>;
  ImportantGrowthStage?: ImportantGrowthStageResolvers<ContextType>;
  IncubationLevel?: IncubationLevelResolvers<ContextType>;
  IndexableObject?: GraphQLScalarType;
  Ingredient?: IngredientResolvers<ContextType>;
  InviteCode?: InviteCodeResolvers<ContextType>;
  JSONObject?: GraphQLScalarType;
  JdFieldSynchronizationOrder?: JdFieldSynchronizationOrderResolvers<ContextType>;
  JdNotificationSubscription?: JdNotificationSubscriptionResolvers<ContextType>;
  KubotaApplicationMapDispatchOrder?: KubotaApplicationMapDispatchOrderResolvers<ContextType>;
  KubotaField?: KubotaFieldResolvers<ContextType>;
  KwsConsent?: KwsConsentResolvers<ContextType>;
  KwsSupportedVariety?: KwsSupportedVarietyResolvers<ContextType>;
  LandPreparation?: LandPreparationResolvers<ContextType>;
  LeafDamageResult?: LeafDamageResultResolvers<ContextType>;
  LeafPruningTask?: LeafPruningTaskResolvers<ContextType>;
  LegendEntry?: LegendEntryResolvers<ContextType>;
  License?: LicenseResolvers<ContextType>;
  LicenseRequest?: LicenseRequestResolvers<ContextType>;
  LicenseRequestSeason?: LicenseRequestSeasonResolvers<ContextType>;
  LinkedDevice?: LinkedDeviceResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  Magnitude?: MagnitudeResolvers<ContextType>;
  MapItem?: MapItemResolvers<ContextType>;
  MappingFieldZone?: MappingFieldZoneResolvers<ContextType>;
  Md2AggregatedProductusesByCrop?: Md2AggregatedProductusesByCropResolvers<ContextType>;
  Md2Configuration?: Md2ConfigurationResolvers<ContextType>;
  Md2CountryCropConfiguration?: Md2CountryCropConfigurationResolvers<ContextType>;
  Md2DictionaryMapping?: Md2DictionaryMappingResolvers<ContextType>;
  Md2Item?: Md2ItemResolvers<ContextType>;
  Md2ProductFeature?: Md2ProductFeatureResolvers<ContextType>;
  Md2TillageDepth?: Md2TillageDepthResolvers<ContextType>;
  Md2VraAdvisorConfiguration?: Md2VraAdvisorConfigurationResolvers<ContextType>;
  Md2VraAdvisorFieldDataLayerConfiguration?: Md2VraAdvisorFieldDataLayerConfigurationResolvers<ContextType>;
  MdCoefficientOfVariationDetail?: MdCoefficientOfVariationDetailResolvers<ContextType>;
  MdSoilNematodeRisk?: MdSoilNematodeRiskResolvers<ContextType>;
  MdUnit?: MdUnitResolvers<ContextType>;
  MeasureSubmissionFieldOrder?: MeasureSubmissionFieldOrderResolvers<ContextType>;
  MeasureSubmissionFieldOrderError?: MeasureSubmissionFieldOrderErrorResolvers<ContextType>;
  MeasureSubmissionFieldResult?: MeasureSubmissionFieldResultResolvers<ContextType>;
  MeasureSubmissionOrder?: MeasureSubmissionOrderResolvers<ContextType>;
  MeasureSubmissionOrderStatistics?: MeasureSubmissionOrderStatisticsResolvers<ContextType>;
  MeasureSubmissionProjectLevelCropResult?: MeasureSubmissionProjectLevelCropResultResolvers<ContextType>;
  MeasureSubmissionProjectLevelResult?: MeasureSubmissionProjectLevelResultResolvers<ContextType>;
  MeasureSubmissionResult?: MeasureSubmissionResultResolvers<ContextType>;
  Measurement?: MeasurementResolvers<ContextType>;
  MergedSmartSprayerExecution?: MergedSmartSprayerExecutionResolvers<ContextType>;
  MissingInfoDataMapping?: MissingInfoDataMappingResolvers<ContextType>;
  MissingInfoDate?: MissingInfoDateResolvers<ContextType>;
  MissingInfoExampleData?: MissingInfoExampleDataResolvers<ContextType>;
  MissingInfoUploadDatasetType?: MissingInfoUploadDatasetTypeResolvers<ContextType>;
  MonitorCoverCrop?: MonitorCoverCropResolvers<ContextType>;
  MonitorPractice?: MonitorPracticeResolvers<ContextType>;
  MonitorTillage?: MonitorTillageResolvers<ContextType>;
  MultiFile?: MultiFileResolvers<ContextType>;
  MultiFileUploadOrder?: MultiFileUploadOrderResolvers<ContextType>;
  MultiWeedResult?: MultiWeedResultResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MutationResponse?: MutationResponseResolvers<ContextType>;
  NamedCropMix?: NamedCropMixResolvers<ContextType>;
  NitrogenProduct?: NitrogenProductResolvers<ContextType>;
  NitrogenStatusResult?: NitrogenStatusResultResolvers<ContextType>;
  NitrogenType?: NitrogenTypeResolvers<ContextType>;
  Node?: GraphQLScalarType;
  NodeWithTypename?: GraphQLScalarType;
  Notification?: NotificationResolvers<ContextType>;
  NotificationConfiguration?: NotificationConfigurationResolvers<ContextType>;
  NotificationObject?: NotificationObjectResolvers<ContextType>;
  NotificationPayload?: NotificationPayloadResolvers<ContextType>;
  NotificationPreference?: NotificationPreferenceResolvers<ContextType>;
  NotificationPreferenceCropSeason?: NotificationPreferenceCropSeasonResolvers<ContextType>;
  Nutrient?: NutrientResolvers<ContextType>;
  NutrientMethodMapping?: NutrientMethodMappingResolvers<ContextType>;
  NutrientProduct?: NutrientProductResolvers<ContextType>;
  NutrientRate?: NutrientRateResolvers<ContextType>;
  NutritionActionDetail?: NutritionActionDetailResolvers<ContextType>;
  NutritionActionNutrient?: NutritionActionNutrientResolvers<ContextType>;
  NutritionActionProduct?: NutritionActionProductResolvers<ContextType>;
  NutritionActionValidity?: NutritionActionValidityResolvers<ContextType>;
  NutritionRecommendation?: NutritionRecommendationResolvers<ContextType>;
  NutritionStacItemVectorization?: NutritionStacItemVectorizationResolvers<ContextType>;
  NutritionStatus?: NutritionStatusResolvers<ContextType>;
  NutritionTargetRate?: NutritionTargetRateResolvers<ContextType>;
  Observation?: ObservationResolvers<ContextType>;
  ObservationWeather?: ObservationWeatherResolvers<ContextType>;
  OfflineBasedSmartSprayingTask?: OfflineBasedSmartSprayingTaskResolvers<ContextType>;
  OnOffStatistics?: OnOffStatisticsResolvers<ContextType>;
  OneSoilApplicationMapDispatchOrder?: OneSoilApplicationMapDispatchOrderResolvers<ContextType>;
  OneSoilDevice?: OneSoilDeviceResolvers<ContextType>;
  OneSoilDeviceLicense?: OneSoilDeviceLicenseResolvers<ContextType>;
  OneSoilFarmReceivedFile?: OneSoilFarmReceivedFileResolvers<ContextType>;
  OneSoilReceivedFile?: OneSoilReceivedFileResolvers<ContextType>;
  OneSoilUploadDatasetOrder?: OneSoilUploadDatasetOrderResolvers<ContextType>;
  OneSoilUploadDatasetResult?: OneSoilUploadDatasetResultResolvers<ContextType>;
  OrderAffiliate?: OrderAffiliateResolvers<ContextType>;
  Organisation?: OrganisationResolvers<ContextType>;
  OrganisationBranch?: OrganisationBranchResolvers<ContextType>;
  OrganisationFarmAssignment?: OrganisationFarmAssignmentResolvers<ContextType>;
  OrganisationFeature?: OrganisationFeatureResolvers<ContextType>;
  OrganisationMember?: OrganisationMemberResolvers<ContextType>;
  OrganisationMembershipRequest?: OrganisationMembershipRequestResolvers<ContextType>;
  OrganisationMethod?: OrganisationMethodResolvers<ContextType>;
  OrganisationQuota?: OrganisationQuotaResolvers<ContextType>;
  OrganisationQuotaLedger?: OrganisationQuotaLedgerResolvers<ContextType>;
  OrganisationTag?: OrganisationTagResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  Package?: PackageResolvers<ContextType>;
  PaginatedFarmEvidenceLink?: PaginatedFarmEvidenceLinkResolvers<ContextType>;
  PaginatedFarmReceipt?: PaginatedFarmReceiptResolvers<ContextType>;
  PaginatedFieldDataLayer?: PaginatedFieldDataLayerResolvers<ContextType>;
  PaginatedFieldEvidence?: PaginatedFieldEvidenceResolvers<ContextType>;
  PaginatedFieldEvidenceLink?: PaginatedFieldEvidenceLinkResolvers<ContextType>;
  PaginatedFieldNote?: PaginatedFieldNoteResolvers<ContextType>;
  PaginatedFile?: PaginatedFileResolvers<ContextType>;
  PaginatedHfClaim?: PaginatedHfClaimResolvers<ContextType>;
  PaginatedHfContractorRequest?: PaginatedHfContractorRequestResolvers<ContextType>;
  PaginatedHfOperationalInstruction?: PaginatedHfOperationalInstructionResolvers<ContextType>;
  PaginatedMapItem?: PaginatedMapItemResolvers<ContextType>;
  PaginatedMd2DictionaryMapping?: PaginatedMd2DictionaryMappingResolvers<ContextType>;
  PaginatedOrganisation?: PaginatedOrganisationResolvers<ContextType>;
  PaginatedOrganisationQuotaLedger?: PaginatedOrganisationQuotaLedgerResolvers<ContextType>;
  PaginatedPreOrder?: PaginatedPreOrderResolvers<ContextType>;
  PaginatedScaleTicket?: PaginatedScaleTicketResolvers<ContextType>;
  PaginatedScaleTicketBooking?: PaginatedScaleTicketBookingResolvers<ContextType>;
  PaginatedScaleTicketBookingDispute?: PaginatedScaleTicketBookingDisputeResolvers<ContextType>;
  PaginatedScaleTicketDataMapping?: PaginatedScaleTicketDataMappingResolvers<ContextType>;
  PaginatedScaleTicketHistory?: PaginatedScaleTicketHistoryResolvers<ContextType>;
  PaginatedScaleTicketSellerMapping?: PaginatedScaleTicketSellerMappingResolvers<ContextType>;
  PaginatedScaleTicketUpload?: PaginatedScaleTicketUploadResolvers<ContextType>;
  PaginatedScoutingTask?: PaginatedScoutingTaskResolvers<ContextType>;
  PaginatedSmartSprayerExecution?: PaginatedSmartSprayerExecutionResolvers<ContextType>;
  PaginatedSmartSprayerRegistration?: PaginatedSmartSprayerRegistrationResolvers<ContextType>;
  PaginatedSmartSprayerWeedPressureFields?: PaginatedSmartSprayerWeedPressureFieldsResolvers<ContextType>;
  PaginatedSustainabilityOrganisationCapability?: PaginatedSustainabilityOrganisationCapabilityResolvers<ContextType>;
  PaginatedSustainabilityProgram?: PaginatedSustainabilityProgramResolvers<ContextType>;
  PaginatedSustainabilityProgramBranchAssignment?: PaginatedSustainabilityProgramBranchAssignmentResolvers<ContextType>;
  PaginatedSustainabilityProgramEnrolledField?: PaginatedSustainabilityProgramEnrolledFieldResolvers<ContextType>;
  PaginatedSustainabilityProgramInvitation?: PaginatedSustainabilityProgramInvitationResolvers<ContextType>;
  PaginatedSustainabilityProgramOrganisationParticipation?: PaginatedSustainabilityProgramOrganisationParticipationResolvers<ContextType>;
  PaginatedTask?: PaginatedTaskResolvers<ContextType>;
  PaginatedTrialsV2?: PaginatedTrialsV2Resolvers<ContextType>;
  PaginatedUploadDataset?: PaginatedUploadDatasetResolvers<ContextType>;
  PaginatedVariety?: PaginatedVarietyResolvers<ContextType>;
  Pagination?: PaginationResolvers<ContextType>;
  PanoramaClient?: PanoramaClientResolvers<ContextType>;
  PanoramaConnectionStatus?: PanoramaConnectionStatusResolvers<ContextType>;
  PanoramaFarm?: PanoramaFarmResolvers<ContextType>;
  PanoramaField?: PanoramaFieldResolvers<ContextType>;
  PanoramaOrganization?: PanoramaOrganizationResolvers<ContextType>;
  PayloadData?: PayloadDataResolvers<ContextType>;
  Permission?: PermissionResolvers<ContextType>;
  PermissionRequest?: PermissionRequestResolvers<ContextType>;
  PestDevelopmentPrediction?: PestDevelopmentPredictionResolvers<ContextType>;
  Plausibility?: PlausibilityResolvers<ContextType>;
  PreOrder?: PreOrderResolvers<ContextType>;
  PreOrderCropQuota?: PreOrderCropQuotaResolvers<ContextType>;
  PreOrderHfServiceDetails?: PreOrderHfServiceDetailsResolvers<ContextType>;
  PreOrderHfServiceRequestAreaClass?: PreOrderHfServiceRequestAreaClassResolvers<ContextType>;
  PreOrderHfServiceRequestShippingAddress?: PreOrderHfServiceRequestShippingAddressResolvers<ContextType>;
  PreOrderQuota?: PreOrderQuotaResolvers<ContextType>;
  PrecifieldBiomassMap?: PrecifieldBiomassMapResolvers<ContextType>;
  PrecifieldCerealsMapSubscription?: PrecifieldCerealsMapSubscriptionResolvers<ContextType>;
  PrecifieldNitrogenPrescriptionMap?: PrecifieldNitrogenPrescriptionMapResolvers<ContextType>;
  PrecifieldOsrMapSubscription?: PrecifieldOsrMapSubscriptionResolvers<ContextType>;
  PrecifieldYieldPotentialMap?: PrecifieldYieldPotentialMapResolvers<ContextType>;
  Prediction?: PredictionResolvers<ContextType>;
  PremiumBand?: PremiumBandResolvers<ContextType>;
  ProduceDeliveryTask?: ProduceDeliveryTaskResolvers<ContextType>;
  ProduceDeliveryTaskProduceProperties?: ProduceDeliveryTaskProducePropertiesResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  ProductApplicationRate?: ProductApplicationRateResolvers<ContextType>;
  ProductFeature?: ProductFeatureResolvers<ContextType>;
  ProductPack?: ProductPackResolvers<ContextType>;
  ProductPermissibleRate?: ProductPermissibleRateResolvers<ContextType>;
  ProductPermissibleRateV2?: ProductPermissibleRateV2Resolvers<ContextType>;
  ProductRate?: ProductRateResolvers<ContextType>;
  ProductRecommendationTankMix?: ProductRecommendationTankMixResolvers<ContextType>;
  ProductV2?: ProductV2Resolvers<ContextType>;
  ProjectedDailyIncidence?: ProjectedDailyIncidenceResolvers<ContextType>;
  ProjectedIncidences?: ProjectedIncidencesResolvers<ContextType>;
  ProtectionTime?: ProtectionTimeResolvers<ContextType>;
  Protocol?: ProtocolResolvers<ContextType>;
  ProtocolAttachment?: ProtocolAttachmentResolvers<ContextType>;
  PublicOrganisation?: PublicOrganisationResolvers<ContextType>;
  PurchasedLicense?: PurchasedLicenseResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QuotaLimit?: QuotaLimitResolvers<ContextType>;
  QuotaTransfer?: QuotaTransferResolvers<ContextType>;
  RateByZone?: RateByZoneResolvers<ContextType>;
  RatesCalculationRequest?: RatesCalculationRequestResolvers<ContextType>;
  RecentlyUsedProduct?: RecentlyUsedProductResolvers<ContextType>;
  RecommendationActionValidity?: RecommendationActionValidityResolvers<ContextType>;
  RecommendationSnooze?: RecommendationSnoozeResolvers<ContextType>;
  RecommendedRate?: RecommendedRateResolvers<ContextType>;
  RecommendedTimingForApplication?: RecommendedTimingForApplicationResolvers<ContextType>;
  ReferenceProductRate?: ReferenceProductRateResolvers<ContextType>;
  ReferenceTotalMixtureRate?: ReferenceTotalMixtureRateResolvers<ContextType>;
  RegionRate?: RegionRateResolvers<ContextType>;
  RelativeMaturity?: RelativeMaturityResolvers<ContextType>;
  ResidualActivation?: ResidualActivationResolvers<ContextType>;
  ResponseStatus?: ResponseStatusResolvers<ContextType>;
  Risk?: RiskResolvers<ContextType>;
  RiskClassification?: RiskClassificationResolvers<ContextType>;
  RiskMap?: RiskMapResolvers<ContextType>;
  RiskV2?: RiskV2Resolvers<ContextType>;
  SampledPoint?: SampledPointResolvers<ContextType>;
  SamplingArea?: SamplingAreaResolvers<ContextType>;
  SamplingDepth?: SamplingDepthResolvers<ContextType>;
  SamplingId?: SamplingIdResolvers<ContextType>;
  SamplingPoint?: SamplingPointResolvers<ContextType>;
  ScaleTicket?: ScaleTicketResolvers<ContextType>;
  ScaleTicketBooking?: ScaleTicketBookingResolvers<ContextType>;
  ScaleTicketBookingDispute?: ScaleTicketBookingDisputeResolvers<ContextType>;
  ScaleTicketBookingDisputeSplit?: ScaleTicketBookingDisputeSplitResolvers<ContextType>;
  ScaleTicketDataMapping?: ScaleTicketDataMappingResolvers<ContextType>;
  ScaleTicketDuplicateNumberSummary?: ScaleTicketDuplicateNumberSummaryResolvers<ContextType>;
  ScaleTicketDuplicateTicket?: ScaleTicketDuplicateTicketResolvers<ContextType>;
  ScaleTicketHarvestCapSummary?: ScaleTicketHarvestCapSummaryResolvers<ContextType>;
  ScaleTicketHistory?: ScaleTicketHistoryResolvers<ContextType>;
  ScaleTicketMissingHarvestSummary?: ScaleTicketMissingHarvestSummaryResolvers<ContextType>;
  ScaleTicketMissingMoistureSummary?: ScaleTicketMissingMoistureSummaryResolvers<ContextType>;
  ScaleTicketNamedRef?: ScaleTicketNamedRefResolvers<ContextType>;
  ScaleTicketSellerMapping?: ScaleTicketSellerMappingResolvers<ContextType>;
  ScaleTicketSellerNotMatched?: ScaleTicketSellerNotMatchedResolvers<ContextType>;
  ScaleTicketSellerRef?: ScaleTicketSellerRefResolvers<ContextType>;
  ScaleTicketStateSummary?: ScaleTicketStateSummaryResolvers<ContextType>;
  ScaleTicketStates?: ScaleTicketStatesResolvers<ContextType>;
  ScaleTicketSummary?: ScaleTicketSummaryResolvers<ContextType>;
  ScaleTicketUpload?: ScaleTicketUploadResolvers<ContextType>;
  ScaleTicketUploadSummary?: ScaleTicketUploadSummaryResolvers<ContextType>;
  ScaleTicketUploadTicketStates?: ScaleTicketUploadTicketStatesResolvers<ContextType>;
  ScoutingGrowthStage?: ScoutingGrowthStageResolvers<ContextType>;
  ScoutingPoi?: ScoutingPoiResolvers<ContextType>;
  ScoutingPoiImage?: ScoutingPoiImageResolvers<ContextType>;
  ScoutingPoiResult?: ScoutingPoiResultResolvers<ContextType>;
  ScoutingPoiV2?: ScoutingPoiV2Resolvers<ContextType>;
  ScoutingProtocol?: ScoutingProtocolResolvers<ContextType>;
  ScoutingReport?: ScoutingReportResolvers<ContextType>;
  ScoutingReportDispatchOrder?: ScoutingReportDispatchOrderResolvers<ContextType>;
  ScoutingStressAnswer?: ScoutingStressAnswerResolvers<ContextType>;
  ScoutingStressQuestion?: ScoutingStressQuestionResolvers<ContextType>;
  ScoutingTask?: ScoutingTaskResolvers<ContextType>;
  SeasonTimeline?: SeasonTimelineResolvers<ContextType>;
  SeasonTimelineFeatures?: SeasonTimelineFeaturesResolvers<ContextType>;
  Section?: SectionResolvers<ContextType>;
  SectionSummary?: SectionSummaryResolvers<ContextType>;
  SeedBoxTreatment?: SeedBoxTreatmentResolvers<ContextType>;
  SeedSelectorInput?: SeedSelectorInputResolvers<ContextType>;
  SeedTreatment?: SeedTreatmentResolvers<ContextType>;
  SeedTreatmentType?: SeedTreatmentTypeResolvers<ContextType>;
  SelectedYear?: SelectedYearResolvers<ContextType>;
  SensorStatusVariableDetail?: SensorStatusVariableDetailResolvers<ContextType>;
  SharingMandate?: SharingMandateResolvers<ContextType>;
  SharingMandatePermission?: SharingMandatePermissionResolvers<ContextType>;
  ShopDevicePackage?: ShopDevicePackageResolvers<ContextType>;
  ShopFarmPackage?: ShopFarmPackageResolvers<ContextType>;
  ShopGiftCard?: ShopGiftCardResolvers<ContextType>;
  ShopSubscription?: ShopSubscriptionResolvers<ContextType>;
  ShopSubscriptionAddressInformation?: ShopSubscriptionAddressInformationResolvers<ContextType>;
  ShopSubscriptionBillingAddress?: ShopSubscriptionBillingAddressResolvers<ContextType>;
  ShopSubscriptionItem?: ShopSubscriptionItemResolvers<ContextType>;
  ShopSubscriptionPaymentDetails?: ShopSubscriptionPaymentDetailsResolvers<ContextType>;
  ShopSubscriptionPeriod?: ShopSubscriptionPeriodResolvers<ContextType>;
  ShopSubscriptionShippingAddress?: ShopSubscriptionShippingAddressResolvers<ContextType>;
  ShopUserPackage?: ShopUserPackageResolvers<ContextType>;
  Site?: SiteResolvers<ContextType>;
  SmagConnectionStatus?: SmagConnectionStatusResolvers<ContextType>;
  SmartSprayerExecution?: SmartSprayerExecutionResolvers<ContextType>;
  SmartSprayerExecutionFieldInfo?: SmartSprayerExecutionFieldInfoResolvers<ContextType>;
  SmartSprayerExecutionMissingInfo?: SmartSprayerExecutionMissingInfoResolvers<ContextType>;
  SmartSprayerExecutionStatistics?: SmartSprayerExecutionStatisticsResolvers<ContextType>;
  SmartSprayerExecutionSummary?: SmartSprayerExecutionSummaryResolvers<ContextType>;
  SmartSprayerLicense?: SmartSprayerLicenseResolvers<ContextType>;
  SmartSprayerRegistration?: SmartSprayerRegistrationResolvers<ContextType>;
  SmartSprayerRegistrationStatus?: SmartSprayerRegistrationStatusResolvers<ContextType>;
  SmartSprayerStatusPackage?: SmartSprayerStatusPackageResolvers<ContextType>;
  SmartSprayerWeedPressureApplication?: SmartSprayerWeedPressureApplicationResolvers<ContextType>;
  SmartSprayerWeedPressureApplicationSelection?: SmartSprayerWeedPressureApplicationSelectionResolvers<ContextType>;
  SmartSprayerWeedPressureExclusionSet?: SmartSprayerWeedPressureExclusionSetResolvers<ContextType>;
  SmartSprayerWeedPressureField?: SmartSprayerWeedPressureFieldResolvers<ContextType>;
  SmartSprayerWeedPressureFieldListItem?: SmartSprayerWeedPressureFieldListItemResolvers<ContextType>;
  SmartSprayerWeedPressureHotSpotHistoryPoint?: SmartSprayerWeedPressureHotSpotHistoryPointResolvers<ContextType>;
  SmartSprayerWeedPressureRecalculation?: SmartSprayerWeedPressureRecalculationResolvers<ContextType>;
  SmartSprayerWeedPressureSettingsApplied?: SmartSprayerWeedPressureSettingsAppliedResolvers<ContextType>;
  SmartSprayerWeedPressureStatistics?: SmartSprayerWeedPressureStatisticsResolvers<ContextType>;
  SmartSprayerWeedPressureStatisticsSummary?: SmartSprayerWeedPressureStatisticsSummaryResolvers<ContextType>;
  SmartSprayingOfflineTask?: SmartSprayingOfflineTaskResolvers<ContextType>;
  SmartSprayingTask?: SmartSprayingTaskResolvers<ContextType>;
  SmartSprayingTaskDevicePayload?: SmartSprayingTaskDevicePayloadResolvers<ContextType>;
  SmartSprayingTaskDosedMap?: SmartSprayingTaskDosedMapResolvers<ContextType>;
  SmartSprayingTaskV2?: SmartSprayingTaskV2Resolvers<ContextType>;
  SmartSprayingTerminalStrategyMappings?: SmartSprayingTerminalStrategyMappingsResolvers<ContextType>;
  SmartSprayingTerminalTask?: SmartSprayingTerminalTaskResolvers<ContextType>;
  SoilErosion?: SoilErosionResolvers<ContextType>;
  SoilSample?: SoilSampleResolvers<ContextType>;
  SoilSampling?: SoilSamplingResolvers<ContextType>;
  SoilSamplingMeasurement?: SoilSamplingMeasurementResolvers<ContextType>;
  SoilSamplingResult?: SoilSamplingResultResolvers<ContextType>;
  SoilSamplingResultArea?: SoilSamplingResultAreaResolvers<ContextType>;
  SoilSamplingResultSourceMap?: SoilSamplingResultSourceMapResolvers<ContextType>;
  SoilSamplingStressAnalysis?: SoilSamplingStressAnalysisResolvers<ContextType>;
  SoilSamplingTask?: SoilSamplingTaskResolvers<ContextType>;
  SoilTaxonomy?: SoilTaxonomyResolvers<ContextType>;
  SoilTexture?: SoilTextureResolvers<ContextType>;
  SourceMap?: SourceMapResolvers<ContextType>;
  SourceMapStyle?: SourceMapStyleResolvers<ContextType>;
  SourceMapStyleEntry?: SourceMapStyleEntryResolvers<ContextType>;
  SourceValueMapping?: SourceValueMappingResolvers<ContextType>;
  SprayWeather?: SprayWeatherResolvers<ContextType>;
  SprayWeatherFactor?: SprayWeatherFactorResolvers<ContextType>;
  Sprayer?: SprayerResolvers<ContextType>;
  SprayerManufacturer?: SprayerManufacturerResolvers<ContextType>;
  SprayerType?: SprayerTypeResolvers<ContextType>;
  Spraying?: SprayingResolvers<ContextType>;
  SprayingNutrient?: SprayingNutrientResolvers<ContextType>;
  SprayingV2?: SprayingV2Resolvers<ContextType>;
  SprayingWindow?: SprayingWindowResolvers<ContextType>;
  StacFarmStatistics?: StacFarmStatisticsResolvers<ContextType>;
  StacHistogram?: StacHistogramResolvers<ContextType>;
  StacItemRender?: StacItemRenderResolvers<ContextType>;
  StacItemRenderSource?: StacItemRenderSourceResolvers<ContextType>;
  StacItemVectorizeGeometry?: StacItemVectorizeGeometryResolvers<ContextType>;
  StacLegend?: StacLegendResolvers<ContextType>;
  StacMosaicRender?: StacMosaicRenderResolvers<ContextType>;
  StacStatistics?: StacStatisticsResolvers<ContextType>;
  Statistic?: StatisticResolvers<ContextType>;
  StirObject?: StirObjectResolvers<ContextType>;
  StirOperation?: StirOperationResolvers<ContextType>;
  Stress?: StressResolvers<ContextType>;
  StressAnswer?: StressAnswerResolvers<ContextType>;
  StressEfficacyCharacteristics?: StressEfficacyCharacteristicsResolvers<ContextType>;
  StressQuestion?: StressQuestionResolvers<ContextType>;
  StressRisk?: StressRiskResolvers<ContextType>;
  StressSetting?: StressSettingResolvers<ContextType>;
  StressSettings?: StressSettingsResolvers<ContextType>;
  StressV2?: StressV2Resolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionPreference?: SubscriptionPreferenceResolvers<ContextType>;
  SubscriptionPreferenceFarm?: SubscriptionPreferenceFarmResolvers<ContextType>;
  SubstanceApplicationRate?: SubstanceApplicationRateResolvers<ContextType>;
  SubstanceRateV2?: SubstanceRateV2Resolvers<ContextType>;
  SupportedTaskType?: SupportedTaskTypeResolvers<ContextType>;
  SustainabilityIndicator?: SustainabilityIndicatorResolvers<ContextType>;
  SustainabilityInput?: SustainabilityInputResolvers<ContextType>;
  SustainabilityOrganisationCapability?: SustainabilityOrganisationCapabilityResolvers<ContextType>;
  SustainabilityProgram?: SustainabilityProgramResolvers<ContextType>;
  SustainabilityProgramBranchAssignment?: SustainabilityProgramBranchAssignmentResolvers<ContextType>;
  SustainabilityProgramEnrolledField?: SustainabilityProgramEnrolledFieldResolvers<ContextType>;
  SustainabilityProgramInvitation?: SustainabilityProgramInvitationResolvers<ContextType>;
  SustainabilityProgramNamedRef?: SustainabilityProgramNamedRefResolvers<ContextType>;
  SustainabilityProgramOrganisationParticipation?: SustainabilityProgramOrganisationParticipationResolvers<ContextType>;
  SustainabilityProgramStaffMember?: SustainabilityProgramStaffMemberResolvers<ContextType>;
  TDiskAssignment?: TDiskAssignmentResolvers<ContextType>;
  TDiskOperation?: TDiskOperationResolvers<ContextType>;
  TargetWeed?: TargetWeedResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TaskAggregation?: TaskAggregationResolvers<ContextType>;
  TaskMethod?: TaskMethodResolvers<ContextType>;
  TaskSummary?: TaskSummaryResolvers<ContextType>;
  TaskSummaryDetail?: TaskSummaryDetailResolvers<ContextType>;
  Tenant?: TenantResolvers<ContextType>;
  TillageSystem?: TillageSystemResolvers<ContextType>;
  Tillages?: TillagesResolvers<ContextType>;
  TimingCalculationStatus?: TimingCalculationStatusResolvers<ContextType>;
  TimingLimitationV2?: TimingLimitationV2Resolvers<ContextType>;
  TimingProductRecommendation?: TimingProductRecommendationResolvers<ContextType>;
  TimingProductRecommendationGroupDoseRate?: TimingProductRecommendationGroupDoseRateResolvers<ContextType>;
  TimingProductRecommendationGroupRecipe?: TimingProductRecommendationGroupRecipeResolvers<ContextType>;
  TimingProductRecommendationRecipe?: TimingProductRecommendationRecipeResolvers<ContextType>;
  TimingProductRecommendationStressEfficacy?: TimingProductRecommendationStressEfficacyResolvers<ContextType>;
  TimingProductRecommendationsGroup?: TimingProductRecommendationsGroupResolvers<ContextType>;
  TimingStressInfo?: TimingStressInfoResolvers<ContextType>;
  ToppingTask?: ToppingTaskResolvers<ContextType>;
  TotalNutrients?: TotalNutrientsResolvers<ContextType>;
  TotalNutrientsDelta?: TotalNutrientsDeltaResolvers<ContextType>;
  TotalProducts?: TotalProductsResolvers<ContextType>;
  Tramline?: TramlineResolvers<ContextType>;
  TranslationId?: GraphQLScalarType;
  TreatmentProduct?: TreatmentProductResolvers<ContextType>;
  TreatmentProgramAction?: TreatmentProgramActionResolvers<ContextType>;
  TreatmentProgramActionWindow?: TreatmentProgramActionWindowResolvers<ContextType>;
  TreatmentProgramActionWindowTask?: TreatmentProgramActionWindowTaskResolvers<ContextType>;
  TreatmentReason?: TreatmentReasonResolvers<ContextType>;
  TreatmentScenario?: TreatmentScenarioResolvers<ContextType>;
  Trial?: TrialResolvers<ContextType>;
  TrialDisabledReplicate?: TrialDisabledReplicateResolvers<ContextType>;
  TrialV2?: TrialV2Resolvers<ContextType>;
  UUID?: GraphQLScalarType;
  UploadDatasetSummary?: UploadDatasetSummaryResolvers<ContextType>;
  UploadDatasetTotal?: UploadDatasetTotalResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserDataVsValidationComparison?: UserDataVsValidationComparisonResolvers<ContextType>;
  UserDevice?: UserDeviceResolvers<ContextType>;
  UserFarmPackage?: UserFarmPackageResolvers<ContextType>;
  UserFeature?: UserFeatureResolvers<ContextType>;
  UserGroup?: UserGroupResolvers<ContextType>;
  UserLicenseRequest?: UserLicenseRequestResolvers<ContextType>;
  UserNotification?: UserNotificationResolvers<ContextType>;
  UserPackage?: UserPackageResolvers<ContextType>;
  UserSetting?: UserSettingResolvers<ContextType>;
  ValueCode?: ValueCodeResolvers<ContextType>;
  Variety?: VarietyResolvers<ContextType>;
  VarietyCharacteristic?: VarietyCharacteristicResolvers<ContextType>;
  VarietyRanking?: VarietyRankingResolvers<ContextType>;
  VarietyRecommendation?: VarietyRecommendationResolvers<ContextType>;
  VendorDeviceBlacklistEntry?: VendorDeviceBlacklistEntryResolvers<ContextType>;
  VendorDeviceDataAnomaly?: VendorDeviceDataAnomalyResolvers<ContextType>;
  VendorDeviceDataMissing?: VendorDeviceDataMissingResolvers<ContextType>;
  VendorDeviceInfo?: VendorDeviceInfoResolvers<ContextType>;
  VendorDeviceSensorStatus?: VendorDeviceSensorStatusResolvers<ContextType>;
  VendorDeviceStatus?: VendorDeviceStatusResolvers<ContextType>;
  WaterBalance?: WaterBalanceResolvers<ContextType>;
  WaterManagementScenario?: WaterManagementScenarioResolvers<ContextType>;
  WaterManagementTask?: WaterManagementTaskResolvers<ContextType>;
  WaterRecommendation?: WaterRecommendationResolvers<ContextType>;
  WaterStatus?: WaterStatusResolvers<ContextType>;
  Weather?: WeatherResolvers<ContextType>;
  WeatherUserData?: WeatherUserDataResolvers<ContextType>;
  WeatherV2?: WeatherV2Resolvers<ContextType>;
  Weed?: WeedResolvers<ContextType>;
  WeedManagementProgramRecommendation?: WeedManagementProgramRecommendationResolvers<ContextType>;
  WeedManagementProgramRecommendationV3?: WeedManagementProgramRecommendationV3Resolvers<ContextType>;
  WeedManagementRecommendation?: WeedManagementRecommendationResolvers<ContextType>;
  WeedRecord?: WeedRecordResolvers<ContextType>;
  WeedRisk?: WeedRiskResolvers<ContextType>;
  WeedStatus?: WeedStatusResolvers<ContextType>;
  WeeklySeedingRecommendation?: WeeklySeedingRecommendationResolvers<ContextType>;
  WfsParameters?: WfsParametersResolvers<ContextType>;
  WiuzConnectionStatus?: WiuzConnectionStatusResolvers<ContextType>;
  WiuzUserFarm?: WiuzUserFarmResolvers<ContextType>;
  WiuzUserfarmImportOrder?: WiuzUserfarmImportOrderResolvers<ContextType>;
  WmsParameters?: WmsParametersResolvers<ContextType>;
  YellowTrapResult?: YellowTrapResultResolvers<ContextType>;
  YieldPrediction?: YieldPredictionResolvers<ContextType>;
  YieldScenario?: YieldScenarioResolvers<ContextType>;
  ZonePercentageDifference?: ZonePercentageDifferenceResolvers<ContextType>;
  ZoneRateV2?: ZoneRateV2Resolvers<ContextType>;
  ZoneStatisticsItem?: ZoneStatisticsItemResolvers<ContextType>;
  ZoneStrategy?: ZoneStrategyResolvers<ContextType>;
  ZonesToSamplingAreaMapping?: ZonesToSamplingAreaMappingResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = GraphqlContext> = ResolversObject<{
  CalculatedThing?: CalculatedThingDirectiveResolver<any, any, ContextType>;
  defer?: DeferDirectiveResolver<any, any, ContextType>;
  experimental_disableErrorPropagation?: Experimental_DisableErrorPropagationDirectiveResolver<any, any, ContextType>;
}>;
